var pE = Object.defineProperty;
var gE = (e, A, t) => A in e ? pE(e, A, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[A] = t;
var ce = (e, A, t) => (gE(e, typeof A != "symbol" ? A + "" : A, t), t);
import { j as F } from "./jsx-runtime-721af1ab.js";
import { useQuery as C0, QueryClient as E0, useMutation as BE, QueryClientProvider as vE } from "@tanstack/react-query";
import * as Zc from "react";
import Rr, { Children as F0, isValidElement as mE, useMemo as xn, cloneElement as wE, Fragment as yE, useCallback as _e, useState as Ue, useEffect as Re, useContext as Pt, createContext as Kt, Suspense as xE, useRef as Ut, forwardRef as CE, createElement as ln, useImperativeHandle as EE, useLayoutEffect as FE } from "react";
import { BrowserRouter as bE } from "react-router-dom";
import { CheckIcon as SE, CloseIcon as $v, ChevronRightIcon as Eh, Icon as UE, ArrowBackIcon as _E, ArrowForwardIcon as jv } from "@chakra-ui/icons";
import { Box as ye, Stack as Gv, Text as EA, Spinner as b0, createMultiStyleConfigHelpers as QE, extendTheme as Vv, ChakraProvider as IE, Center as Wv, useEditableControls as DE, ButtonGroup as TE, IconButton as co, useToast as OE, Tooltip as cl, Editable as HE, EditablePreview as LE, useColorModeValue as Yv, HStack as Cn, Input as zo, EditableInput as ME, Skeleton as zv, Button as Sn, Show as Xv, VStack as pn, Link as Gs, Spacer as ef, Circle as Vs, Flex as _t, Image as Xo, keyframes as RE, InputGroup as S0, InputRightElement as qv, Heading as Jv, UnorderedList as Fh, ListItem as Rn, chakra as NE, FormControl as fl, FormErrorMessage as dl } from "@chakra-ui/react";
import { r as U0, o as Nr, b as kE, p as PE, k as KE, a as _0, w as $E, u as Q0, e as jE, d as GE, c as VE, l as WE, x as YE, y as Ta, z as zE, s as XE, A as qE, g as hl, m as JE, n as bh, h as ZE } from "./useAccount-5ddee56a.js";
import "./myasurion-shared.mixpanel.es.js";
import { a as Zv, F as eF } from "./features-e6661c21.js";
import { a as qo, g as NA } from "./domains-5b6d38aa.js";
import { getCountryByCarrier as gn, getDefaultLanguageByCarrier as AF } from "./myasurion-shared.carrier.es.js";
import { g as wt, c as te } from "./lodash-3345fe65.js";
import { n as tF, a as em, f as Am, c as rF, F as nF, B as ta, p as aF, q as iF } from "./cleave-react-node-3145b543.js";
import { C as sF } from "./providers-a757499d.js";
import { motion as oF } from "framer-motion";
import "@react-oauth/google";
import { Button as Af } from "./myasurion-shared.widgets.es.js";
import { getContentfulImage as uF } from "./myasurion-shared.utils.es.js";
import "@emotion/react";
import { P as lF } from "./ProfileIcon-ce0111a3.js";
import { AvatarInitials as cF } from "./myasurion-shared.profile.es.js";
import { getChakraColorScale as Sh } from "./myasurion-shared.colors.es.js";
function Oe(e, A = {}) {
  let t = !1;
  function r() {
    if (!t) {
      t = !0;
      return;
    }
    throw new Error(
      "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
    );
  }
  function n(...l) {
    r();
    for (const c of l)
      A[c] = o(c);
    return Oe(e, A);
  }
  function a(...l) {
    for (const c of l)
      c in A || (A[c] = o(c));
    return Oe(e, A);
  }
  function i() {
    return Object.fromEntries(
      Object.entries(A).map(([c, f]) => [c, f.selector])
    );
  }
  function s() {
    return Object.fromEntries(
      Object.entries(A).map(([c, f]) => [c, f.className])
    );
  }
  function o(l) {
    const d = `chakra-${(["container", "root"].includes(l ?? "") ? [e] : [e, l]).filter(Boolean).join("__")}`;
    return {
      className: d,
      selector: `.${d}`,
      toString: () => l
    };
  }
  return {
    parts: n,
    toPart: o,
    extend: a,
    selectors: i,
    classnames: s,
    get keys() {
      return Object.keys(A);
    },
    __type: {}
  };
}
Oe("accordion").parts("root", "container", "button", "panel").extend("icon");
Oe("alert").parts("title", "description", "container").extend("icon", "spinner");
Oe("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
Oe("breadcrumb").parts("link", "item", "container").extend("separator");
Oe("button").parts();
Oe("checkbox").parts("control", "icon", "container").extend("label");
Oe("progress").parts("track", "filledTrack").extend("label");
Oe("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Oe("editable").parts(
  "preview",
  "input",
  "textarea"
);
Oe("form").parts(
  "container",
  "requiredIndicator",
  "helperText"
);
Oe("formError").parts("text", "icon");
var fF = Oe("input").parts(
  "addon",
  "field",
  "element",
  "group"
);
Oe("list").parts("container", "item", "icon");
Oe("menu").parts("button", "list", "item").extend("groupTitle", "icon", "command", "divider");
Oe("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Oe("numberinput").parts(
  "root",
  "field",
  "stepperGroup",
  "stepper"
);
Oe("pininput").parts("field");
Oe("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
Oe("progress").parts(
  "label",
  "filledTrack",
  "track"
);
Oe("radio").parts(
  "container",
  "control",
  "label"
);
Oe("select").parts("field", "icon");
Oe("slider").parts(
  "container",
  "track",
  "thumb",
  "filledTrack",
  "mark"
);
Oe("stat").parts(
  "container",
  "label",
  "helpText",
  "number",
  "icon"
);
Oe("switch").parts(
  "container",
  "track",
  "thumb",
  "label"
);
Oe("table").parts(
  "table",
  "thead",
  "tbody",
  "tr",
  "th",
  "td",
  "tfoot",
  "caption"
);
Oe("tabs").parts(
  "root",
  "tab",
  "tablist",
  "tabpanel",
  "tabpanels",
  "indicator"
);
Oe("tag").parts(
  "container",
  "label",
  "closeButton"
);
Oe("card").parts(
  "container",
  "header",
  "body",
  "footer"
);
Oe("stepper").parts(
  "stepper",
  "step",
  "title",
  "description",
  "indicator",
  "separator",
  "icon",
  "number"
);
function dF(e) {
  return F0.toArray(e).filter(
    (A) => mE(A)
  );
}
function hF(e, A) {
  return Array.isArray(e) ? e.map((t) => t === null ? null : A(t)) : tF(e) ? Object.keys(e).reduce((t, r) => (t[r] = A(e[r]), t), {}) : e != null ? A(e) : null;
}
var tm = (e) => /* @__PURE__ */ F.jsx(
  em.div,
  {
    className: "chakra-stack__item",
    ...e,
    __css: {
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0,
      ...e.__css
    }
  }
);
tm.displayName = "StackItem";
function pF(e) {
  const { spacing: A, direction: t } = e, r = {
    column: {
      my: A,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: A,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: A,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: A,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": hF(
      t,
      (n) => r[n]
    )
  };
}
var rm = Am((e, A) => {
  const {
    isInline: t,
    direction: r,
    align: n,
    justify: a,
    spacing: i = "0.5rem",
    wrap: s,
    children: o,
    divider: u,
    className: l,
    shouldWrapChildren: c,
    ...f
  } = e, d = t ? "row" : r ?? "column", h = xn(
    () => pF({ spacing: i, direction: d }),
    [i, d]
  ), p = !!u, v = !c && !p, y = xn(() => {
    const B = dF(o);
    return v ? B : B.map((w, m) => {
      const x = typeof w.key < "u" ? w.key : m, C = m + 1 === B.length, T = c ? /* @__PURE__ */ F.jsx(tm, { children: w }, x) : w;
      if (!p)
        return T;
      const S = wE(
        u,
        {
          __css: h
        }
      ), b = C ? null : S;
      return /* @__PURE__ */ F.jsxs(yE, { children: [
        T,
        b
      ] }, x);
    });
  }, [
    u,
    h,
    p,
    v,
    c,
    o
  ]), g = rF("chakra-stack", l);
  return /* @__PURE__ */ F.jsx(
    em.div,
    {
      ref: A,
      display: "flex",
      alignItems: n,
      justifyContent: a,
      flexDirection: d,
      flexWrap: s,
      gap: p ? void 0 : i,
      className: g,
      ...f,
      children: y
    }
  );
});
rm.displayName = "Stack";
var nm = Am((e, A) => /* @__PURE__ */ F.jsx(rm, { align: "center", ...e, direction: "row", ref: A }));
nm.displayName = "HStack";
function Uh(e, A) {
  const t = _e(() => {
    if (typeof window > "u")
      return A;
    try {
      const s = window.localStorage.getItem(e);
      return s ? gF(s) : A;
    } catch (s) {
      return console.warn(`Error reading localStorage key “${e}”:`, s), A;
    }
  }, [A, e]), [r, n] = Ue(t), a = U0((s) => {
    typeof window > "u" && console.warn(`Tried setting localStorage key “${e}” even though environment is not a client`);
    try {
      const o = s instanceof Function ? s(r) : s;
      window.localStorage.setItem(e, JSON.stringify(o)), n(o), window.dispatchEvent(new Event("local-storage"));
    } catch (o) {
      console.warn(`Error setting localStorage key “${e}”:`, o);
    }
  });
  Re(() => {
    n(t());
  }, []);
  const i = _e((s) => {
    s != null && s.key && s.key !== e || n(t());
  }, [e, t]);
  return Nr("storage", i), Nr("local-storage", i), [r, a];
}
function gF(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e ?? "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
function am(e, A) {
  const t = _e(() => {
    if (typeof window > "u")
      return A;
    try {
      const s = window.sessionStorage.getItem(e);
      return s ? BF(s) : A;
    } catch (s) {
      return console.warn(`Error reading sessionStorage key “${e}”:`, s), A;
    }
  }, [A, e]), [r, n] = Ue(t), a = U0((s) => {
    typeof window > "u" && console.warn(`Tried setting sessionStorage key “${e}” even though environment is not a client`);
    try {
      const o = s instanceof Function ? s(r) : s;
      window.sessionStorage.setItem(e, JSON.stringify(o)), n(o), window.dispatchEvent(new Event("session-storage"));
    } catch (o) {
      console.warn(`Error setting sessionStorage key “${e}”:`, o);
    }
  });
  Re(() => {
    n(t());
  }, []);
  const i = _e((s) => {
    s != null && s.key && s.key !== e || n(t());
  }, [e, t]);
  return Nr("storage", i), Nr("session-storage", i), [r, a];
}
function BF(e) {
  try {
    return e === "undefined" ? void 0 : JSON.parse(e ?? "");
  } catch {
    console.log("parsing error on", { value: e });
    return;
  }
}
const vF = (e) => {
  var a, i;
  const A = Pt(Zv);
  if (A === void 0)
    throw new Error("useFeatureIsOn must be used within a Feature Provider");
  const t = qo(), { features: r } = A, n = (i = (a = r == null ? void 0 : r.featureList) == null ? void 0 : a[t ?? "device_protection"]) == null ? void 0 : i.findIndex(
    (s) => (s == null ? void 0 : s.key) === e
  );
  return n ? n > -1 : !1;
}, im = Kt({
  isOpen: !1,
  setIsOpen: () => {
  },
  isNotifsOpen: !1,
  setIsNotifsOpen: () => {
  },
  config: void 0
}), mF = ({
  children: e,
  config: A
}) => {
  const [t, r] = Ue(!1), [n, a] = Ue(!1);
  return /* @__PURE__ */ F.jsx(
    im.Provider,
    {
      value: {
        isOpen: t,
        setIsOpen: r,
        isNotifsOpen: n,
        setIsNotifsOpen: a,
        config: A
      },
      children: e
    }
  );
}, sm = () => {
  const e = Pt(im);
  if (e === void 0)
    throw new Error("useHeader must be used within a HeaderProvider");
  const { isOpen: A, setIsOpen: t, isNotifsOpen: r, setIsNotifsOpen: n, config: a } = e;
  return {
    headerIsOpen: A,
    updateHeaderIsOpen: t,
    notificationsIsOpen: r,
    updateNoficationsIsOpen: n,
    config: a
  };
}, wF = (e, A) => {
  var i, s, o;
  const t = Pt(Zv);
  if (t === void 0)
    throw new Error("useDisabledFeature must be used within a Feature Provider");
  const r = qo(), { features: n } = t, a = (s = (i = n == null ? void 0 : n.featureList) == null ? void 0 : i[r ?? "device_protection"]) == null ? void 0 : s.find(
    (u) => (u == null ? void 0 : u.key) === e
  );
  return (o = a == null ? void 0 : a.disabledFeatures) == null ? void 0 : o.includes(A);
};
function om(e, A) {
  return function() {
    return e.apply(A, arguments);
  };
}
const { toString: yF } = Object.prototype, { getPrototypeOf: I0 } = Object, Jo = ((e) => (A) => {
  const t = yF.call(A);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), $t = (e) => (e = e.toLowerCase(), (A) => Jo(A) === e), Zo = (e) => (A) => typeof A === e, { isArray: Ba } = Array, vi = Zo("undefined");
function xF(e) {
  return e !== null && !vi(e) && e.constructor !== null && !vi(e.constructor) && st(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const um = $t("ArrayBuffer");
function CF(e) {
  let A;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? A = ArrayBuffer.isView(e) : A = e && e.buffer && um(e.buffer), A;
}
const EF = Zo("string"), st = Zo("function"), lm = Zo("number"), eu = (e) => e !== null && typeof e == "object", FF = (e) => e === !0 || e === !1, Ws = (e) => {
  if (Jo(e) !== "object")
    return !1;
  const A = I0(e);
  return (A === null || A === Object.prototype || Object.getPrototypeOf(A) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, bF = $t("Date"), SF = $t("File"), UF = $t("Blob"), _F = $t("FileList"), QF = (e) => eu(e) && st(e.pipe), IF = (e) => {
  let A;
  return e && (typeof FormData == "function" && e instanceof FormData || st(e.append) && ((A = Jo(e)) === "formdata" || // detect form-data instance
  A === "object" && st(e.toString) && e.toString() === "[object FormData]"));
}, DF = $t("URLSearchParams"), TF = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Oi(e, A, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, n;
  if (typeof e != "object" && (e = [e]), Ba(e))
    for (r = 0, n = e.length; r < n; r++)
      A.call(null, e[r], r, e);
  else {
    const a = t ? Object.getOwnPropertyNames(e) : Object.keys(e), i = a.length;
    let s;
    for (r = 0; r < i; r++)
      s = a[r], A.call(null, e[s], s, e);
  }
}
function cm(e, A) {
  A = A.toLowerCase();
  const t = Object.keys(e);
  let r = t.length, n;
  for (; r-- > 0; )
    if (n = t[r], A === n.toLowerCase())
      return n;
  return null;
}
const fm = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), dm = (e) => !vi(e) && e !== fm;
function tf() {
  const { caseless: e } = dm(this) && this || {}, A = {}, t = (r, n) => {
    const a = e && cm(A, n) || n;
    Ws(A[a]) && Ws(r) ? A[a] = tf(A[a], r) : Ws(r) ? A[a] = tf({}, r) : Ba(r) ? A[a] = r.slice() : A[a] = r;
  };
  for (let r = 0, n = arguments.length; r < n; r++)
    arguments[r] && Oi(arguments[r], t);
  return A;
}
const OF = (e, A, t, { allOwnKeys: r } = {}) => (Oi(A, (n, a) => {
  t && st(n) ? e[a] = om(n, t) : e[a] = n;
}, { allOwnKeys: r }), e), HF = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), LF = (e, A, t, r) => {
  e.prototype = Object.create(A.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: A.prototype
  }), t && Object.assign(e.prototype, t);
}, MF = (e, A, t, r) => {
  let n, a, i;
  const s = {};
  if (A = A || {}, e == null)
    return A;
  do {
    for (n = Object.getOwnPropertyNames(e), a = n.length; a-- > 0; )
      i = n[a], (!r || r(i, e, A)) && !s[i] && (A[i] = e[i], s[i] = !0);
    e = t !== !1 && I0(e);
  } while (e && (!t || t(e, A)) && e !== Object.prototype);
  return A;
}, RF = (e, A, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= A.length;
  const r = e.indexOf(A, t);
  return r !== -1 && r === t;
}, NF = (e) => {
  if (!e)
    return null;
  if (Ba(e))
    return e;
  let A = e.length;
  if (!lm(A))
    return null;
  const t = new Array(A);
  for (; A-- > 0; )
    t[A] = e[A];
  return t;
}, kF = ((e) => (A) => e && A instanceof e)(typeof Uint8Array < "u" && I0(Uint8Array)), PF = (e, A) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let n;
  for (; (n = r.next()) && !n.done; ) {
    const a = n.value;
    A.call(e, a[0], a[1]);
  }
}, KF = (e, A) => {
  let t;
  const r = [];
  for (; (t = e.exec(A)) !== null; )
    r.push(t);
  return r;
}, $F = $t("HTMLFormElement"), jF = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, r, n) {
    return r.toUpperCase() + n;
  }
), _h = (({ hasOwnProperty: e }) => (A, t) => e.call(A, t))(Object.prototype), GF = $t("RegExp"), hm = (e, A) => {
  const t = Object.getOwnPropertyDescriptors(e), r = {};
  Oi(t, (n, a) => {
    let i;
    (i = A(n, a, e)) !== !1 && (r[a] = i || n);
  }), Object.defineProperties(e, r);
}, VF = (e) => {
  hm(e, (A, t) => {
    if (st(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const r = e[t];
    if (st(r)) {
      if (A.enumerable = !1, "writable" in A) {
        A.writable = !1;
        return;
      }
      A.set || (A.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, WF = (e, A) => {
  const t = {}, r = (n) => {
    n.forEach((a) => {
      t[a] = !0;
    });
  };
  return Ba(e) ? r(e) : r(String(e).split(A)), t;
}, YF = () => {
}, zF = (e, A) => (e = +e, Number.isFinite(e) ? e : A), pl = "abcdefghijklmnopqrstuvwxyz", Qh = "0123456789", pm = {
  DIGIT: Qh,
  ALPHA: pl,
  ALPHA_DIGIT: pl + pl.toUpperCase() + Qh
}, XF = (e = 16, A = pm.ALPHA_DIGIT) => {
  let t = "";
  const { length: r } = A;
  for (; e--; )
    t += A[Math.random() * r | 0];
  return t;
};
function qF(e) {
  return !!(e && st(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const JF = (e) => {
  const A = new Array(10), t = (r, n) => {
    if (eu(r)) {
      if (A.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        A[n] = r;
        const a = Ba(r) ? [] : {};
        return Oi(r, (i, s) => {
          const o = t(i, n + 1);
          !vi(o) && (a[s] = o);
        }), A[n] = void 0, a;
      }
    }
    return r;
  };
  return t(e, 0);
}, ZF = $t("AsyncFunction"), e1 = (e) => e && (eu(e) || st(e)) && st(e.then) && st(e.catch), G = {
  isArray: Ba,
  isArrayBuffer: um,
  isBuffer: xF,
  isFormData: IF,
  isArrayBufferView: CF,
  isString: EF,
  isNumber: lm,
  isBoolean: FF,
  isObject: eu,
  isPlainObject: Ws,
  isUndefined: vi,
  isDate: bF,
  isFile: SF,
  isBlob: UF,
  isRegExp: GF,
  isFunction: st,
  isStream: QF,
  isURLSearchParams: DF,
  isTypedArray: kF,
  isFileList: _F,
  forEach: Oi,
  merge: tf,
  extend: OF,
  trim: TF,
  stripBOM: HF,
  inherits: LF,
  toFlatObject: MF,
  kindOf: Jo,
  kindOfTest: $t,
  endsWith: RF,
  toArray: NF,
  forEachEntry: PF,
  matchAll: KF,
  isHTMLForm: $F,
  hasOwnProperty: _h,
  hasOwnProp: _h,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: hm,
  freezeMethods: VF,
  toObjectSet: WF,
  toCamelCase: jF,
  noop: YF,
  toFiniteNumber: zF,
  findKey: cm,
  global: fm,
  isContextDefined: dm,
  ALPHABET: pm,
  generateString: XF,
  isSpecCompliantForm: qF,
  toJSONObject: JF,
  isAsyncFn: ZF,
  isThenable: e1
};
function be(e, A, t, r, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", A && (this.code = A), t && (this.config = t), r && (this.request = r), n && (this.response = n);
}
G.inherits(be, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: G.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const gm = be.prototype, Bm = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Bm[e] = { value: e };
});
Object.defineProperties(be, Bm);
Object.defineProperty(gm, "isAxiosError", { value: !0 });
be.from = (e, A, t, r, n, a) => {
  const i = Object.create(gm);
  return G.toFlatObject(e, i, function(o) {
    return o !== Error.prototype;
  }, (s) => s !== "isAxiosError"), be.call(i, e.message, A, t, r, n), i.cause = e, i.name = e.name, a && Object.assign(i, a), i;
};
const A1 = null;
function rf(e) {
  return G.isPlainObject(e) || G.isArray(e);
}
function vm(e) {
  return G.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ih(e, A, t) {
  return e ? e.concat(A).map(function(n, a) {
    return n = vm(n), !t && a ? "[" + n + "]" : n;
  }).join(t ? "." : "") : A;
}
function t1(e) {
  return G.isArray(e) && !e.some(rf);
}
const r1 = G.toFlatObject(G, {}, null, function(A) {
  return /^is[A-Z]/.test(A);
});
function Au(e, A, t) {
  if (!G.isObject(e))
    throw new TypeError("target must be an object");
  A = A || new FormData(), t = G.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, v) {
    return !G.isUndefined(v[p]);
  });
  const r = t.metaTokens, n = t.visitor || l, a = t.dots, i = t.indexes, o = (t.Blob || typeof Blob < "u" && Blob) && G.isSpecCompliantForm(A);
  if (!G.isFunction(n))
    throw new TypeError("visitor must be a function");
  function u(h) {
    if (h === null)
      return "";
    if (G.isDate(h))
      return h.toISOString();
    if (!o && G.isBlob(h))
      throw new be("Blob is not supported. Use a Buffer instead.");
    return G.isArrayBuffer(h) || G.isTypedArray(h) ? o && typeof Blob == "function" ? new Blob([h]) : Buffer.from(h) : h;
  }
  function l(h, p, v) {
    let y = h;
    if (h && !v && typeof h == "object") {
      if (G.endsWith(p, "{}"))
        p = r ? p : p.slice(0, -2), h = JSON.stringify(h);
      else if (G.isArray(h) && t1(h) || (G.isFileList(h) || G.endsWith(p, "[]")) && (y = G.toArray(h)))
        return p = vm(p), y.forEach(function(B, w) {
          !(G.isUndefined(B) || B === null) && A.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Ih([p], w, a) : i === null ? p : p + "[]",
            u(B)
          );
        }), !1;
    }
    return rf(h) ? !0 : (A.append(Ih(v, p, a), u(h)), !1);
  }
  const c = [], f = Object.assign(r1, {
    defaultVisitor: l,
    convertValue: u,
    isVisitable: rf
  });
  function d(h, p) {
    if (!G.isUndefined(h)) {
      if (c.indexOf(h) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      c.push(h), G.forEach(h, function(y, g) {
        (!(G.isUndefined(y) || y === null) && n.call(
          A,
          y,
          G.isString(g) ? g.trim() : g,
          p,
          f
        )) === !0 && d(y, p ? p.concat(g) : [g]);
      }), c.pop();
    }
  }
  if (!G.isObject(e))
    throw new TypeError("data must be an object");
  return d(e), A;
}
function Dh(e) {
  const A = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return A[r];
  });
}
function D0(e, A) {
  this._pairs = [], e && Au(e, this, A);
}
const mm = D0.prototype;
mm.append = function(A, t) {
  this._pairs.push([A, t]);
};
mm.toString = function(A) {
  const t = A ? function(r) {
    return A.call(this, r, Dh);
  } : Dh;
  return this._pairs.map(function(n) {
    return t(n[0]) + "=" + t(n[1]);
  }, "").join("&");
};
function n1(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function wm(e, A, t) {
  if (!A)
    return e;
  const r = t && t.encode || n1, n = t && t.serialize;
  let a;
  if (n ? a = n(A, t) : a = G.isURLSearchParams(A) ? A.toString() : new D0(A, t).toString(r), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class a1 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(A, t, r) {
    return this.handlers.push({
      fulfilled: A,
      rejected: t,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(A) {
    this.handlers[A] && (this.handlers[A] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(A) {
    G.forEach(this.handlers, function(r) {
      r !== null && A(r);
    });
  }
}
const Th = a1, ym = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, i1 = typeof URLSearchParams < "u" ? URLSearchParams : D0, s1 = typeof FormData < "u" ? FormData : null, o1 = typeof Blob < "u" ? Blob : null, u1 = {
  isBrowser: !0,
  classes: {
    URLSearchParams: i1,
    FormData: s1,
    Blob: o1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, xm = typeof window < "u" && typeof document < "u", l1 = ((e) => xm && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator < "u" && navigator.product), c1 = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), f1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: xm,
  hasStandardBrowserEnv: l1,
  hasStandardBrowserWebWorkerEnv: c1
}, Symbol.toStringTag, { value: "Module" })), Ht = {
  ...f1,
  ...u1
};
function d1(e, A) {
  return Au(e, new Ht.classes.URLSearchParams(), Object.assign({
    visitor: function(t, r, n, a) {
      return Ht.isNode && G.isBuffer(t) ? (this.append(r, t.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, A));
}
function h1(e) {
  return G.matchAll(/\w+|\[(\w*)]/g, e).map((A) => A[0] === "[]" ? "" : A[1] || A[0]);
}
function p1(e) {
  const A = {}, t = Object.keys(e);
  let r;
  const n = t.length;
  let a;
  for (r = 0; r < n; r++)
    a = t[r], A[a] = e[a];
  return A;
}
function Cm(e) {
  function A(t, r, n, a) {
    let i = t[a++];
    const s = Number.isFinite(+i), o = a >= t.length;
    return i = !i && G.isArray(n) ? n.length : i, o ? (G.hasOwnProp(n, i) ? n[i] = [n[i], r] : n[i] = r, !s) : ((!n[i] || !G.isObject(n[i])) && (n[i] = []), A(t, r, n[i], a) && G.isArray(n[i]) && (n[i] = p1(n[i])), !s);
  }
  if (G.isFormData(e) && G.isFunction(e.entries)) {
    const t = {};
    return G.forEachEntry(e, (r, n) => {
      A(h1(r), n, t, 0);
    }), t;
  }
  return null;
}
function g1(e, A, t) {
  if (G.isString(e))
    try {
      return (A || JSON.parse)(e), G.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (t || JSON.stringify)(e);
}
const T0 = {
  transitional: ym,
  adapter: ["xhr", "http"],
  transformRequest: [function(A, t) {
    const r = t.getContentType() || "", n = r.indexOf("application/json") > -1, a = G.isObject(A);
    if (a && G.isHTMLForm(A) && (A = new FormData(A)), G.isFormData(A))
      return n && n ? JSON.stringify(Cm(A)) : A;
    if (G.isArrayBuffer(A) || G.isBuffer(A) || G.isStream(A) || G.isFile(A) || G.isBlob(A))
      return A;
    if (G.isArrayBufferView(A))
      return A.buffer;
    if (G.isURLSearchParams(A))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), A.toString();
    let s;
    if (a) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return d1(A, this.formSerializer).toString();
      if ((s = G.isFileList(A)) || r.indexOf("multipart/form-data") > -1) {
        const o = this.env && this.env.FormData;
        return Au(
          s ? { "files[]": A } : A,
          o && new o(),
          this.formSerializer
        );
      }
    }
    return a || n ? (t.setContentType("application/json", !1), g1(A)) : A;
  }],
  transformResponse: [function(A) {
    const t = this.transitional || T0.transitional, r = t && t.forcedJSONParsing, n = this.responseType === "json";
    if (A && G.isString(A) && (r && !this.responseType || n)) {
      const i = !(t && t.silentJSONParsing) && n;
      try {
        return JSON.parse(A);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? be.from(s, be.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return A;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ht.classes.FormData,
    Blob: Ht.classes.Blob
  },
  validateStatus: function(A) {
    return A >= 200 && A < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
G.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  T0.headers[e] = {};
});
const O0 = T0, B1 = G.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), v1 = (e) => {
  const A = {};
  let t, r, n;
  return e && e.split(`
`).forEach(function(i) {
    n = i.indexOf(":"), t = i.substring(0, n).trim().toLowerCase(), r = i.substring(n + 1).trim(), !(!t || A[t] && B1[t]) && (t === "set-cookie" ? A[t] ? A[t].push(r) : A[t] = [r] : A[t] = A[t] ? A[t] + ", " + r : r);
  }), A;
}, Oh = Symbol("internals");
function Oa(e) {
  return e && String(e).trim().toLowerCase();
}
function Ys(e) {
  return e === !1 || e == null ? e : G.isArray(e) ? e.map(Ys) : String(e);
}
function m1(e) {
  const A = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = t.exec(e); )
    A[r[1]] = r[2];
  return A;
}
const w1 = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function gl(e, A, t, r, n) {
  if (G.isFunction(r))
    return r.call(this, A, t);
  if (n && (A = t), !!G.isString(A)) {
    if (G.isString(r))
      return A.indexOf(r) !== -1;
    if (G.isRegExp(r))
      return r.test(A);
  }
}
function y1(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (A, t, r) => t.toUpperCase() + r);
}
function x1(e, A) {
  const t = G.toCamelCase(" " + A);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + t, {
      value: function(n, a, i) {
        return this[r].call(this, A, n, a, i);
      },
      configurable: !0
    });
  });
}
class tu {
  constructor(A) {
    A && this.set(A);
  }
  set(A, t, r) {
    const n = this;
    function a(s, o, u) {
      const l = Oa(o);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const c = G.findKey(n, l);
      (!c || n[c] === void 0 || u === !0 || u === void 0 && n[c] !== !1) && (n[c || o] = Ys(s));
    }
    const i = (s, o) => G.forEach(s, (u, l) => a(u, l, o));
    return G.isPlainObject(A) || A instanceof this.constructor ? i(A, t) : G.isString(A) && (A = A.trim()) && !w1(A) ? i(v1(A), t) : A != null && a(t, A, r), this;
  }
  get(A, t) {
    if (A = Oa(A), A) {
      const r = G.findKey(this, A);
      if (r) {
        const n = this[r];
        if (!t)
          return n;
        if (t === !0)
          return m1(n);
        if (G.isFunction(t))
          return t.call(this, n, r);
        if (G.isRegExp(t))
          return t.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(A, t) {
    if (A = Oa(A), A) {
      const r = G.findKey(this, A);
      return !!(r && this[r] !== void 0 && (!t || gl(this, this[r], r, t)));
    }
    return !1;
  }
  delete(A, t) {
    const r = this;
    let n = !1;
    function a(i) {
      if (i = Oa(i), i) {
        const s = G.findKey(r, i);
        s && (!t || gl(r, r[s], s, t)) && (delete r[s], n = !0);
      }
    }
    return G.isArray(A) ? A.forEach(a) : a(A), n;
  }
  clear(A) {
    const t = Object.keys(this);
    let r = t.length, n = !1;
    for (; r--; ) {
      const a = t[r];
      (!A || gl(this, this[a], a, A, !0)) && (delete this[a], n = !0);
    }
    return n;
  }
  normalize(A) {
    const t = this, r = {};
    return G.forEach(this, (n, a) => {
      const i = G.findKey(r, a);
      if (i) {
        t[i] = Ys(n), delete t[a];
        return;
      }
      const s = A ? y1(a) : String(a).trim();
      s !== a && delete t[a], t[s] = Ys(n), r[s] = !0;
    }), this;
  }
  concat(...A) {
    return this.constructor.concat(this, ...A);
  }
  toJSON(A) {
    const t = /* @__PURE__ */ Object.create(null);
    return G.forEach(this, (r, n) => {
      r != null && r !== !1 && (t[n] = A && G.isArray(r) ? r.join(", ") : r);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([A, t]) => A + ": " + t).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(A) {
    return A instanceof this ? A : new this(A);
  }
  static concat(A, ...t) {
    const r = new this(A);
    return t.forEach((n) => r.set(n)), r;
  }
  static accessor(A) {
    const r = (this[Oh] = this[Oh] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function a(i) {
      const s = Oa(i);
      r[s] || (x1(n, i), r[s] = !0);
    }
    return G.isArray(A) ? A.forEach(a) : a(A), this;
  }
}
tu.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
G.reduceDescriptors(tu.prototype, ({ value: e }, A) => {
  let t = A[0].toUpperCase() + A.slice(1);
  return {
    get: () => e,
    set(r) {
      this[t] = r;
    }
  };
});
G.freezeMethods(tu);
const sr = tu;
function Bl(e, A) {
  const t = this || O0, r = A || t, n = sr.from(r.headers);
  let a = r.data;
  return G.forEach(e, function(s) {
    a = s.call(t, a, n.normalize(), A ? A.status : void 0);
  }), n.normalize(), a;
}
function Em(e) {
  return !!(e && e.__CANCEL__);
}
function Hi(e, A, t) {
  be.call(this, e ?? "canceled", be.ERR_CANCELED, A, t), this.name = "CanceledError";
}
G.inherits(Hi, be, {
  __CANCEL__: !0
});
function C1(e, A, t) {
  const r = t.config.validateStatus;
  !t.status || !r || r(t.status) ? e(t) : A(new be(
    "Request failed with status code " + t.status,
    [be.ERR_BAD_REQUEST, be.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
const E1 = Ht.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, A, t, r, n, a) {
      const i = [e + "=" + encodeURIComponent(A)];
      G.isNumber(t) && i.push("expires=" + new Date(t).toGMTString()), G.isString(r) && i.push("path=" + r), G.isString(n) && i.push("domain=" + n), a === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const A = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return A ? decodeURIComponent(A[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function F1(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function b1(e, A) {
  return A ? e.replace(/\/+$/, "") + "/" + A.replace(/^\/+/, "") : e;
}
function Fm(e, A) {
  return e && !F1(A) ? b1(e, A) : A;
}
const S1 = Ht.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const A = /(msie|trident)/i.test(navigator.userAgent), t = document.createElement("a");
    let r;
    function n(a) {
      let i = a;
      return A && (t.setAttribute("href", i), i = t.href), t.setAttribute("href", i), {
        href: t.href,
        protocol: t.protocol ? t.protocol.replace(/:$/, "") : "",
        host: t.host,
        search: t.search ? t.search.replace(/^\?/, "") : "",
        hash: t.hash ? t.hash.replace(/^#/, "") : "",
        hostname: t.hostname,
        port: t.port,
        pathname: t.pathname.charAt(0) === "/" ? t.pathname : "/" + t.pathname
      };
    }
    return r = n(window.location.href), function(i) {
      const s = G.isString(i) ? n(i) : i;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function U1(e) {
  const A = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return A && A[1] || "";
}
function _1(e, A) {
  e = e || 10;
  const t = new Array(e), r = new Array(e);
  let n = 0, a = 0, i;
  return A = A !== void 0 ? A : 1e3, function(o) {
    const u = Date.now(), l = r[a];
    i || (i = u), t[n] = o, r[n] = u;
    let c = a, f = 0;
    for (; c !== n; )
      f += t[c++], c = c % e;
    if (n = (n + 1) % e, n === a && (a = (a + 1) % e), u - i < A)
      return;
    const d = l && u - l;
    return d ? Math.round(f * 1e3 / d) : void 0;
  };
}
function Hh(e, A) {
  let t = 0;
  const r = _1(50, 250);
  return (n) => {
    const a = n.loaded, i = n.lengthComputable ? n.total : void 0, s = a - t, o = r(s), u = a <= i;
    t = a;
    const l = {
      loaded: a,
      total: i,
      progress: i ? a / i : void 0,
      bytes: s,
      rate: o || void 0,
      estimated: o && i && u ? (i - a) / o : void 0,
      event: n
    };
    l[A ? "download" : "upload"] = !0, e(l);
  };
}
const Q1 = typeof XMLHttpRequest < "u", I1 = Q1 && function(e) {
  return new Promise(function(t, r) {
    let n = e.data;
    const a = sr.from(e.headers).normalize();
    let { responseType: i, withXSRFToken: s } = e, o;
    function u() {
      e.cancelToken && e.cancelToken.unsubscribe(o), e.signal && e.signal.removeEventListener("abort", o);
    }
    let l;
    if (G.isFormData(n)) {
      if (Ht.hasStandardBrowserEnv || Ht.hasStandardBrowserWebWorkerEnv)
        a.setContentType(!1);
      else if ((l = a.getContentType()) !== !1) {
        const [p, ...v] = l ? l.split(";").map((y) => y.trim()).filter(Boolean) : [];
        a.setContentType([p || "multipart/form-data", ...v].join("; "));
      }
    }
    let c = new XMLHttpRequest();
    if (e.auth) {
      const p = e.auth.username || "", v = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      a.set("Authorization", "Basic " + btoa(p + ":" + v));
    }
    const f = Fm(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), wm(f, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function d() {
      if (!c)
        return;
      const p = sr.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), y = {
        data: !i || i === "text" || i === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: p,
        config: e,
        request: c
      };
      C1(function(B) {
        t(B), u();
      }, function(B) {
        r(B), u();
      }, y), c = null;
    }
    if ("onloadend" in c ? c.onloadend = d : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(d);
    }, c.onabort = function() {
      c && (r(new be("Request aborted", be.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      r(new be("Network Error", be.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let v = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const y = e.transitional || ym;
      e.timeoutErrorMessage && (v = e.timeoutErrorMessage), r(new be(
        v,
        y.clarifyTimeoutError ? be.ETIMEDOUT : be.ECONNABORTED,
        e,
        c
      )), c = null;
    }, Ht.hasStandardBrowserEnv && (s && G.isFunction(s) && (s = s(e)), s || s !== !1 && S1(f))) {
      const p = e.xsrfHeaderName && e.xsrfCookieName && E1.read(e.xsrfCookieName);
      p && a.set(e.xsrfHeaderName, p);
    }
    n === void 0 && a.setContentType(null), "setRequestHeader" in c && G.forEach(a.toJSON(), function(v, y) {
      c.setRequestHeader(y, v);
    }), G.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), i && i !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", Hh(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", Hh(e.onUploadProgress)), (e.cancelToken || e.signal) && (o = (p) => {
      c && (r(!p || p.type ? new Hi(null, e, c) : p), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(o), e.signal && (e.signal.aborted ? o() : e.signal.addEventListener("abort", o)));
    const h = U1(f);
    if (h && Ht.protocols.indexOf(h) === -1) {
      r(new be("Unsupported protocol " + h + ":", be.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(n || null);
  });
}, nf = {
  http: A1,
  xhr: I1
};
G.forEach(nf, (e, A) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: A });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: A });
  }
});
const Lh = (e) => `- ${e}`, D1 = (e) => G.isFunction(e) || e === null || e === !1, bm = {
  getAdapter: (e) => {
    e = G.isArray(e) ? e : [e];
    const { length: A } = e;
    let t, r;
    const n = {};
    for (let a = 0; a < A; a++) {
      t = e[a];
      let i;
      if (r = t, !D1(t) && (r = nf[(i = String(t)).toLowerCase()], r === void 0))
        throw new be(`Unknown adapter '${i}'`);
      if (r)
        break;
      n[i || "#" + a] = r;
    }
    if (!r) {
      const a = Object.entries(n).map(
        ([s, o]) => `adapter ${s} ` + (o === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = A ? a.length > 1 ? `since :
` + a.map(Lh).join(`
`) : " " + Lh(a[0]) : "as no adapter specified";
      throw new be(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: nf
};
function vl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Hi(null, e);
}
function Mh(e) {
  return vl(e), e.headers = sr.from(e.headers), e.data = Bl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), bm.getAdapter(e.adapter || O0.adapter)(e).then(function(r) {
    return vl(e), r.data = Bl.call(
      e,
      e.transformResponse,
      r
    ), r.headers = sr.from(r.headers), r;
  }, function(r) {
    return Em(r) || (vl(e), r && r.response && (r.response.data = Bl.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = sr.from(r.response.headers))), Promise.reject(r);
  });
}
const Rh = (e) => e instanceof sr ? e.toJSON() : e;
function da(e, A) {
  A = A || {};
  const t = {};
  function r(u, l, c) {
    return G.isPlainObject(u) && G.isPlainObject(l) ? G.merge.call({ caseless: c }, u, l) : G.isPlainObject(l) ? G.merge({}, l) : G.isArray(l) ? l.slice() : l;
  }
  function n(u, l, c) {
    if (G.isUndefined(l)) {
      if (!G.isUndefined(u))
        return r(void 0, u, c);
    } else
      return r(u, l, c);
  }
  function a(u, l) {
    if (!G.isUndefined(l))
      return r(void 0, l);
  }
  function i(u, l) {
    if (G.isUndefined(l)) {
      if (!G.isUndefined(u))
        return r(void 0, u);
    } else
      return r(void 0, l);
  }
  function s(u, l, c) {
    if (c in A)
      return r(u, l);
    if (c in e)
      return r(void 0, u);
  }
  const o = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (u, l) => n(Rh(u), Rh(l), !0)
  };
  return G.forEach(Object.keys(Object.assign({}, e, A)), function(l) {
    const c = o[l] || n, f = c(e[l], A[l], l);
    G.isUndefined(f) && c !== s || (t[l] = f);
  }), t;
}
const Sm = "1.6.2", H0 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, A) => {
  H0[e] = function(r) {
    return typeof r === e || "a" + (A < 1 ? "n " : " ") + e;
  };
});
const Nh = {};
H0.transitional = function(A, t, r) {
  function n(a, i) {
    return "[Axios v" + Sm + "] Transitional option '" + a + "'" + i + (r ? ". " + r : "");
  }
  return (a, i, s) => {
    if (A === !1)
      throw new be(
        n(i, " has been removed" + (t ? " in " + t : "")),
        be.ERR_DEPRECATED
      );
    return t && !Nh[i] && (Nh[i] = !0, console.warn(
      n(
        i,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), A ? A(a, i, s) : !0;
  };
};
function T1(e, A, t) {
  if (typeof e != "object")
    throw new be("options must be an object", be.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let n = r.length;
  for (; n-- > 0; ) {
    const a = r[n], i = A[a];
    if (i) {
      const s = e[a], o = s === void 0 || i(s, a, e);
      if (o !== !0)
        throw new be("option " + a + " must be " + o, be.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new be("Unknown option " + a, be.ERR_BAD_OPTION);
  }
}
const af = {
  assertOptions: T1,
  validators: H0
}, vr = af.validators;
class fo {
  constructor(A) {
    this.defaults = A, this.interceptors = {
      request: new Th(),
      response: new Th()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(A, t) {
    typeof A == "string" ? (t = t || {}, t.url = A) : t = A || {}, t = da(this.defaults, t);
    const { transitional: r, paramsSerializer: n, headers: a } = t;
    r !== void 0 && af.assertOptions(r, {
      silentJSONParsing: vr.transitional(vr.boolean),
      forcedJSONParsing: vr.transitional(vr.boolean),
      clarifyTimeoutError: vr.transitional(vr.boolean)
    }, !1), n != null && (G.isFunction(n) ? t.paramsSerializer = {
      serialize: n
    } : af.assertOptions(n, {
      encode: vr.function,
      serialize: vr.function
    }, !0)), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let i = a && G.merge(
      a.common,
      a[t.method]
    );
    a && G.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (h) => {
        delete a[h];
      }
    ), t.headers = sr.concat(i, a);
    const s = [];
    let o = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(t) === !1 || (o = o && p.synchronous, s.unshift(p.fulfilled, p.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(p) {
      u.push(p.fulfilled, p.rejected);
    });
    let l, c = 0, f;
    if (!o) {
      const h = [Mh.bind(this), void 0];
      for (h.unshift.apply(h, s), h.push.apply(h, u), f = h.length, l = Promise.resolve(t); c < f; )
        l = l.then(h[c++], h[c++]);
      return l;
    }
    f = s.length;
    let d = t;
    for (c = 0; c < f; ) {
      const h = s[c++], p = s[c++];
      try {
        d = h(d);
      } catch (v) {
        p.call(this, v);
        break;
      }
    }
    try {
      l = Mh.call(this, d);
    } catch (h) {
      return Promise.reject(h);
    }
    for (c = 0, f = u.length; c < f; )
      l = l.then(u[c++], u[c++]);
    return l;
  }
  getUri(A) {
    A = da(this.defaults, A);
    const t = Fm(A.baseURL, A.url);
    return wm(t, A.params, A.paramsSerializer);
  }
}
G.forEach(["delete", "get", "head", "options"], function(A) {
  fo.prototype[A] = function(t, r) {
    return this.request(da(r || {}, {
      method: A,
      url: t,
      data: (r || {}).data
    }));
  };
});
G.forEach(["post", "put", "patch"], function(A) {
  function t(r) {
    return function(a, i, s) {
      return this.request(da(s || {}, {
        method: A,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  fo.prototype[A] = t(), fo.prototype[A + "Form"] = t(!0);
});
const zs = fo;
class L0 {
  constructor(A) {
    if (typeof A != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(a) {
      t = a;
    });
    const r = this;
    this.promise.then((n) => {
      if (!r._listeners)
        return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](n);
      r._listeners = null;
    }), this.promise.then = (n) => {
      let a;
      const i = new Promise((s) => {
        r.subscribe(s), a = s;
      }).then(n);
      return i.cancel = function() {
        r.unsubscribe(a);
      }, i;
    }, A(function(a, i, s) {
      r.reason || (r.reason = new Hi(a, i, s), t(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(A) {
    if (this.reason) {
      A(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(A) : this._listeners = [A];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(A) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(A);
    t !== -1 && this._listeners.splice(t, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let A;
    return {
      token: new L0(function(n) {
        A = n;
      }),
      cancel: A
    };
  }
}
const O1 = L0;
function H1(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function L1(e) {
  return G.isObject(e) && e.isAxiosError === !0;
}
const sf = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(sf).forEach(([e, A]) => {
  sf[A] = e;
});
const M1 = sf;
function Um(e) {
  const A = new zs(e), t = om(zs.prototype.request, A);
  return G.extend(t, zs.prototype, A, { allOwnKeys: !0 }), G.extend(t, A, null, { allOwnKeys: !0 }), t.create = function(n) {
    return Um(da(e, n));
  }, t;
}
const pA = Um(O0);
pA.Axios = zs;
pA.CanceledError = Hi;
pA.CancelToken = O1;
pA.isCancel = Em;
pA.VERSION = Sm;
pA.toFormData = Au;
pA.AxiosError = be;
pA.Cancel = pA.CanceledError;
pA.all = function(A) {
  return Promise.all(A);
};
pA.spread = H1;
pA.isAxiosError = L1;
pA.mergeConfig = da;
pA.AxiosHeaders = sr;
pA.formToJSON = (e) => Cm(G.isHTMLForm(e) ? new FormData(e) : e);
pA.getAdapter = bm.getAdapter;
pA.HttpStatusCode = M1;
pA.default = pA;
const ii = pA, _m = Kt({
  refetch: async () => {
  },
  notifications: [],
  setNotifications: () => {
  },
  updateClients: () => {
  },
  isNotificationsLoading: !1,
  promptCount: 0
}), Qm = NA(), R1 = gn(Qm), N1 = (e) => {
  const A = kE();
  return {
    token: A.token,
    "x-api-key": e,
    "x-asurion-client": Qm,
    "x-asurion-cc": R1.code,
    authorization: A.authorization,
    id: A.userId
  };
}, k1 = async (e, A, t, r, n) => {
  const a = N1(n == null ? void 0 : n.apiKey);
  return (await ii.get(
    `${n == null ? void 0 : n.apiBaseUrl}/online/notifications?cid=${e}&aid=${A}&agreementId=${t}`,
    {
      headers: {
        ...a,
        data: r
      }
    }
  )).data.body;
}, P1 = ({
  children: e,
  apiKey: A,
  apiBaseUrl: t
}) => {
  const [r, n] = Ue([]), [a, i] = Ue(""), [s, o] = Ue(""), [u, l] = Ue(""), [c, f] = Ue(""), [d, h] = Ue(0), [p] = am("data", ""), {
    data: v,
    isLoading: y,
    refetch: g
  } = C0({
    queryKey: ["notificationsData", a, s, u],
    queryFn: () => a === "" || s === "" || u === "" || c === "" ? [] : k1(
      a,
      s,
      u,
      c,
      { apiKey: A, apiBaseUrl: t }
    ).then((m) => m).catch(() => [])
  }), B = _e(
    (m) => {
      m != null && m.cid && i(m == null ? void 0 : m.cid), m != null && m.aid && o(m == null ? void 0 : m.aid), m != null && m.agreementId && l(m == null ? void 0 : m.agreementId);
    },
    []
  ), w = async (m, x, C) => {
    if (a === "" || s === "" || u === "") {
      B({ cid: m, aid: x, agreementId: C });
      return;
    } else {
      g();
      return;
    }
  };
  return Re(() => {
    p && p !== "" && f(p);
  }, [p]), Re(() => {
    if (v) {
      n(v);
      let m = 0;
      Array.isArray(v) && v.length > 0 && (m = v == null ? void 0 : v.reduce((x, C) => (C == null ? void 0 : C.IsResolved) === "N" ? x + 1 : x, 0)), h(m);
    }
  }, [v]), /* @__PURE__ */ F.jsx(
    _m.Provider,
    {
      value: {
        refetch: w,
        promptCount: d,
        notifications: r,
        setNotifications: n,
        updateClients: B,
        isNotificationsLoading: y
      },
      children: e
    }
  );
}, K1 = () => {
  const e = Pt(_m);
  if (e === void 0)
    throw new Error("useNotifications must be used within a Notifications Provider");
  const {
    notifications: A,
    setNotifications: t,
    isNotificationsLoading: r,
    updateClients: n,
    refetch: a,
    promptCount: i
  } = e;
  return {
    notifications: A,
    updateNotifications: t,
    isNotificationsLoading: r,
    updateClients: n,
    fetchNotifications: a,
    promptCount: i
  };
}, Im = (e, A) => {
  const t = _e(() => {
    if (typeof window > "u")
      return A;
    try {
      const s = window.sessionStorage.getItem(e);
      return s ? PE(s) : A;
    } catch (s) {
      return console.warn(`Error reading sessionStorage key “${e}”:`, s), A;
    }
  }, [A, e]), [r, n] = Ue(t), a = U0((s) => {
    typeof window > "u" && console.warn(
      `Tried setting sessionStorage key “${e}” even though environment is not a client`
    );
    try {
      const o = s instanceof Function ? s(r) : s;
      window.sessionStorage.setItem(e, JSON.stringify(o)), n(o), window.dispatchEvent(new Event("session-storage"));
    } catch (o) {
      console.warn(`Error setting sessionStorage key “${e}”:`, o);
    }
  });
  Re(() => {
    n(t());
  }, []);
  const i = _e(
    (s) => {
      s != null && s.key && s.key !== e || n(t());
    },
    [e, t]
  );
  return Nr("storage", i), Nr("session-storage", i), [r, a];
};
function $1() {
}
var j1 = $1;
const M0 = /* @__PURE__ */ wt(j1), G1 = M0;
function Dm(e, A) {
  const t = V1(A, () => {
  }), r = [], n = Object.keys(A), a = Object.values(A);
  return Zc.Children.forEach(e, (i) => {
    if (!Zc.isValidElement(i)) {
      r.push(i);
      return;
    }
    const s = a.findIndex((u) => i.type === u);
    if (s === -1) {
      r.push(i);
      return;
    }
    const o = n[s];
    if (t[o]) {
      G1(
        !0,
        `Found duplicate "${String(o)}" slot. Only the first will be rendered.`
      );
      return;
    }
    t[o] = i;
  }), [t, r];
}
function V1(e, A) {
  return Object.keys(e).reduce((t, r) => (t[r] = A(e[r]), t), {});
}
const W1 = () => /* @__PURE__ */ F.jsx(ye, { h: "full", id: "myasurion-portal-suspense", children: /* @__PURE__ */ F.jsxs(
  Gv,
  {
    h: "100vh",
    w: "full",
    justifyContent: "center",
    alignItems: "center",
    px: 4,
    textAlign: "center",
    children: [
      /* @__PURE__ */ F.jsx(
        J5,
        {
          top: 0,
          signOutProps: { styleProps: { margin: "0 auto" } },
          zIndex: "999999",
          account: { profileId: "", userId: "" }
        }
      ),
      /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
        /* @__PURE__ */ F.jsx(EA, { children: "Please wait..." }),
        /* @__PURE__ */ F.jsx(b0, { my: 2 })
      ] })
    ]
  }
) }), Tm = Kt({
  chatConfig: {
    appSyncGraphQL: {
      endpoint: "",
      region: "",
      authType: ""
    },
    amplifyConfig: {
      cognitoIdentityPoolId: "",
      cognitoRegion: "",
      cognitoUserPoolId: "",
      cognitoUserPoolWebClientId: ""
    },
    chat: {
      baseEndpoint: "",
      apiKey: "",
      environment: "",
      clientName: "",
      program: "",
      productName: ""
    },
    contentful: {
      space: "",
      token: "",
      env: ""
    }
  },
  firebaseConfig: null,
  baseApiConfig: {
    baseEndpoint: "",
    apiKey: ""
  }
}), Y1 = ({ config: e, baseApiConfig: A, children: t }) => {
  const r = NA(), { data: n, refetch: a } = C0({
    queryKey: ["chatConfigData"],
    queryFn: () => {
      var i;
      return KE(e, `chat_config_${r}_${(i = e == null ? void 0 : e.env) == null ? void 0 : i.toLowerCase()}`).then((s) => s ? JSON.parse(s) : null).catch((s) => (console.error("Failed to fetch config ", s), null));
    },
    enabled: !1
  });
  return Re(() => {
    e && a();
  }, [e]), /* @__PURE__ */ F.jsx(
    Tm.Provider,
    {
      value: {
        chatConfig: n,
        firebaseConfig: e,
        baseApiConfig: A
      },
      children: t
    }
  );
};
var z1 = function() {
  var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = A.wnd, r = t === void 0 ? window : t;
  (function(n, a, i, s, o, u, l, c) {
    if (i in n) {
      n.console && n.console.log && n.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
      return;
    }
    l = n[i] = function(f, d, h) {
      l.q ? l.q.push([f, d, h]) : l._api(f, d, h);
    }, l.q = [], u = a.createElement(s), u.async = 1, u.crossOrigin = "anonymous", u.src = "https://" + _fs_script, c = a.getElementsByTagName(s)[0], c.parentNode.insertBefore(u, c), l.identify = function(f, d, h) {
      l(o, {
        uid: f
      }, h), d && l(o, d, h);
    }, l.setUserVars = function(f, d) {
      l(o, f, d);
    }, l.event = function(f, d, h) {
      l("event", {
        n: f,
        p: d
      }, h);
    }, l.anonymize = function() {
      l.identify(!1);
    }, l.shutdown = function() {
      l("rec", !1);
    }, l.restart = function() {
      l("rec", !0);
    }, l.log = function(f, d) {
      l("log", [f, d]);
    }, l.consent = function(f) {
      l("consent", !arguments.length || f);
    }, l.identifyAccount = function(f, d) {
      u = "account", d = d || {}, d.acctId = f, l(u, d);
    }, l.clearUserCookie = function() {
    }, l.setVars = function(f, d) {
      l("setVars", [f, d]);
    }, l._w = {}, c = "XMLHttpRequest", l._w[c] = n[c], c = "fetch", l._w[c] = n[c], n[c] && (n[c] = function() {
      return l._w[c].apply(this, arguments);
    }), l._v = "1.3.0";
  })(r, r.document, r._fs_namespace, "script", "user");
}, X1 = function(A) {
  return A === "window" ? "document" : "".concat(A, ".document");
}, q1 = function() {
  var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = A.shouldInsertScript, r = t === void 0 ? !0 : t, n = A.globalVar, a = n === void 0 ? "window" : n, i = A.apiVersion, s = i === void 0 ? "1.3.0" : i;
  return `(function(m,n,e,t,l,o,g,y){
    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];`.concat(r ? `
    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);` : "", `
    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
    g.anonymize=function(){g.identify(!!0)};
    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
    g.log = function(a,b){g("log",[a,b])};
    g.consent=function(a){g("consent",!arguments.length||a)};
    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
    g.clearUserCookie=function(){};
    g.setVars=function(n, p){g('setVars',[n,p]);};
    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
    g._v="`).concat(s, `";
})(`).concat(a, ",").concat(X1(a), ",").concat(a, "['_fs_namespace'],'script','user');");
}, J1 = function(A) {
  var t = A.orgId, r = A.namespace, n = r === void 0 ? "FS" : r, a = A.debug, i = a === void 0 ? !1 : a, s = A.host, o = s === void 0 ? "fullstory.com" : s, u = A.script, l = u === void 0 ? "edge.fullstory.com/s/fs.js" : u;
  if (!t)
    throw new Error("FullStory orgId is a required parameter");
  window._fs_debug = i, window._fs_host = o, window._fs_script = l, window._fs_org = t, window._fs_namespace = n, z1();
};
q1();
function kh(e, A) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    A && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Z1(e) {
  for (var A = 1; A < arguments.length; A++) {
    var t = arguments[A] != null ? arguments[A] : {};
    A % 2 ? kh(Object(t), !0).forEach(function(r) {
      eb(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : kh(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function eb(e, A, t) {
  return A in e ? Object.defineProperty(e, A, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[A] = t, e;
}
var mi = function() {
  return window[window._fs_namespace];
}, Ab = function() {
  var A = !!mi();
  if (!A)
    throw Error("FullStory is not loaded, please ensure the init function is invoked before calling FullStory API functions");
}, tb = function() {
  Ab();
  for (var A = arguments.length, t = new Array(A), r = 0; r < A; r++)
    t[r] = arguments[r];
  return t.every(function(n) {
    return mi()[n];
  });
}, ru = function(A) {
  return function() {
    if (window._fs_dev_mode) {
      var t = "FullStory is in dev mode and is not recording: ".concat(A, " method not executed");
      return console.warn(t), t;
    }
    if (tb(A)) {
      var r;
      return (r = mi())[A].apply(r, arguments);
    }
    return console.warn("FS.".concat(A, " not ready")), null;
  };
}, rb = ru("event"), nb = ru("getCurrentSessionURL"), ab = ru("identify"), ib = ru("shutdown"), sb = function(A, t) {
  var r = Z1({}, A);
  if (mi()) {
    console.warn("The FullStory snippet has already been defined elsewhere (likely in the <head> element)");
    return;
  }
  if (r.recordCrossDomainIFrames && (window._fs_run_in_iframe = !0), r.recordOnlyThisIFrame && (window._fs_is_outer_script = !0), r.cookieDomain && (window._fs_cookie_domain = r.cookieDomain), r.debug === !0 && (r.script ? console.warn("Ignoring `debug = true` because `script` is set") : r.script = "edge.fullstory.com/s/fs-debug.js"), J1(r), t && mi()("observe", {
    type: "start",
    callback: t
  }), r.devMode === !0) {
    var n = "FullStory was initialized in devMode and will stop recording";
    rb("FullStory Dev Mode", {
      message_str: n
    }), ib(), window._fs_dev_mode = !0, console.warn(n);
  }
}, ob = function(A, t) {
  return function() {
    if (window._fs_initialized) {
      t && console.warn(t);
      return;
    }
    A.apply(void 0, arguments), window._fs_initialized = !0;
  };
}, Ph = ob(sb, "FullStory init has already been called once, additional invocations are ignored"), ub = function() {
  return !!window._fs_initialized;
};
const lb = Kt({
  fullStoryInit: () => {
  },
  isInitialized: () => !1,
  identify: () => {
  },
  getCurrentSessionURL: () => ""
}), cb = ({ children: e }) => {
  const [A] = _0({
    profileId: "",
    userId: ""
  }), { enrolledMdn: t, email: r, userId: n } = A, { data: a } = yt(), { fullstory: i } = a, s = (c, f, d) => {
    Ph({
      orgId: c,
      devMode: f,
      debug: d
    });
  }, o = () => ub(), u = (c, f) => ab(c, f), l = (c) => o() ? nb(c) : "FullStory not yet initialized";
  return Re(() => {
    const c = t ?? r ?? n;
    i && c && (Ph(
      {
        orgId: i == null ? void 0 : i.orgId,
        devMode: i == null ? void 0 : i.devMode,
        debug: i == null ? void 0 : i.debug
      },
      ({ sessionUrl: f }) => {
        i != null && i.debug && console.log(`Started session: ${f}`);
      }
    ), o() && u(c, {
      timestamp: Date.now().toString(),
      dateUTC: (/* @__PURE__ */ new Date()).toUTCString()
    }));
  }, [A]), /* @__PURE__ */ F.jsx(
    lb.Provider,
    {
      value: { fullStoryInit: s, isInitialized: o, identify: u, getCurrentSessionURL: l },
      children: e
    }
  );
};
var Om = { exports: {} };
function fb(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var ml = { exports: {} }, Kh;
function Fe() {
  return Kh || (Kh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r();
    })(te, function() {
      var t = t || function(r, n) {
        var a;
        if (typeof window < "u" && window.crypto && (a = window.crypto), typeof self < "u" && self.crypto && (a = self.crypto), typeof globalThis < "u" && globalThis.crypto && (a = globalThis.crypto), !a && typeof window < "u" && window.msCrypto && (a = window.msCrypto), !a && typeof te < "u" && te.crypto && (a = te.crypto), !a && typeof fb == "function")
          try {
            a = $E;
          } catch {
          }
        var i = function() {
          if (a) {
            if (typeof a.getRandomValues == "function")
              try {
                return a.getRandomValues(new Uint32Array(1))[0];
              } catch {
              }
            if (typeof a.randomBytes == "function")
              try {
                return a.randomBytes(4).readInt32LE();
              } catch {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, s = Object.create || function() {
          function g() {
          }
          return function(B) {
            var w;
            return g.prototype = B, w = new g(), g.prototype = null, w;
          };
        }(), o = {}, u = o.lib = {}, l = u.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(g) {
              var B = s(this);
              return g && B.mixIn(g), (!B.hasOwnProperty("init") || this.init === B.init) && (B.init = function() {
                B.$super.init.apply(this, arguments);
              }), B.init.prototype = B, B.$super = this, B;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var g = this.extend();
              return g.init.apply(g, arguments), g;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(g) {
              for (var B in g)
                g.hasOwnProperty(B) && (this[B] = g[B]);
              g.hasOwnProperty("toString") && (this.toString = g.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), c = u.WordArray = l.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(g, B) {
            g = this.words = g || [], B != n ? this.sigBytes = B : this.sigBytes = g.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(g) {
            return (g || d).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(g) {
            var B = this.words, w = g.words, m = this.sigBytes, x = g.sigBytes;
            if (this.clamp(), m % 4)
              for (var C = 0; C < x; C++) {
                var E = w[C >>> 2] >>> 24 - C % 4 * 8 & 255;
                B[m + C >>> 2] |= E << 24 - (m + C) % 4 * 8;
              }
            else
              for (var T = 0; T < x; T += 4)
                B[m + T >>> 2] = w[T >>> 2];
            return this.sigBytes += x, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var g = this.words, B = this.sigBytes;
            g[B >>> 2] &= 4294967295 << 32 - B % 4 * 8, g.length = r.ceil(B / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var g = l.clone.call(this);
            return g.words = this.words.slice(0), g;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(g) {
            for (var B = [], w = 0; w < g; w += 4)
              B.push(i());
            return new c.init(B, g);
          }
        }), f = o.enc = {}, d = f.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(g) {
            for (var B = g.words, w = g.sigBytes, m = [], x = 0; x < w; x++) {
              var C = B[x >>> 2] >>> 24 - x % 4 * 8 & 255;
              m.push((C >>> 4).toString(16)), m.push((C & 15).toString(16));
            }
            return m.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(g) {
            for (var B = g.length, w = [], m = 0; m < B; m += 2)
              w[m >>> 3] |= parseInt(g.substr(m, 2), 16) << 24 - m % 8 * 4;
            return new c.init(w, B / 2);
          }
        }, h = f.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(g) {
            for (var B = g.words, w = g.sigBytes, m = [], x = 0; x < w; x++) {
              var C = B[x >>> 2] >>> 24 - x % 4 * 8 & 255;
              m.push(String.fromCharCode(C));
            }
            return m.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(g) {
            for (var B = g.length, w = [], m = 0; m < B; m++)
              w[m >>> 2] |= (g.charCodeAt(m) & 255) << 24 - m % 4 * 8;
            return new c.init(w, B);
          }
        }, p = f.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(g) {
            try {
              return decodeURIComponent(escape(h.stringify(g)));
            } catch {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(g) {
            return h.parse(unescape(encodeURIComponent(g)));
          }
        }, v = u.BufferedBlockAlgorithm = l.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new c.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(g) {
            typeof g == "string" && (g = p.parse(g)), this._data.concat(g), this._nDataBytes += g.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(g) {
            var B, w = this._data, m = w.words, x = w.sigBytes, C = this.blockSize, E = C * 4, T = x / E;
            g ? T = r.ceil(T) : T = r.max((T | 0) - this._minBufferSize, 0);
            var S = T * C, b = r.min(S * 4, x);
            if (S) {
              for (var N = 0; N < S; N += C)
                this._doProcessBlock(m, N);
              B = m.splice(0, S), w.sigBytes -= b;
            }
            return new c.init(B, b);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var g = l.clone.call(this);
            return g._data = this._data.clone(), g;
          },
          _minBufferSize: 0
        });
        u.Hasher = v.extend({
          /**
           * Configuration options.
           */
          cfg: l.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(g) {
            this.cfg = this.cfg.extend(g), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            v.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(g) {
            return this._append(g), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(g) {
            g && this._append(g);
            var B = this._doFinalize();
            return B;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(g) {
            return function(B, w) {
              return new g.init(w).finalize(B);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(g) {
            return function(B, w) {
              return new y.HMAC.init(g, w).finalize(B);
            };
          }
        });
        var y = o.algo = {};
        return o;
      }(Math);
      return t;
    });
  }(ml)), ml.exports;
}
var wl = { exports: {} }, $h;
function nu() {
  return $h || ($h = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function(r) {
        var n = t, a = n.lib, i = a.Base, s = a.WordArray, o = n.x64 = {};
        o.Word = i.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(u, l) {
            this.high = u, this.low = l;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), o.WordArray = i.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(u, l) {
            u = this.words = u || [], l != r ? this.sigBytes = l : this.sigBytes = u.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var u = this.words, l = u.length, c = [], f = 0; f < l; f++) {
              var d = u[f];
              c.push(d.high), c.push(d.low);
            }
            return s.create(c, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var u = i.clone.call(this), l = u.words = this.words.slice(0), c = l.length, f = 0; f < c; f++)
              l[f] = l[f].clone();
            return u;
          }
        });
      }(), t;
    });
  }(wl)), wl.exports;
}
var yl = { exports: {} }, jh;
function db() {
  return jh || (jh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var r = t, n = r.lib, a = n.WordArray, i = a.init, s = a.init = function(o) {
            if (o instanceof ArrayBuffer && (o = new Uint8Array(o)), (o instanceof Int8Array || typeof Uint8ClampedArray < "u" && o instanceof Uint8ClampedArray || o instanceof Int16Array || o instanceof Uint16Array || o instanceof Int32Array || o instanceof Uint32Array || o instanceof Float32Array || o instanceof Float64Array) && (o = new Uint8Array(o.buffer, o.byteOffset, o.byteLength)), o instanceof Uint8Array) {
              for (var u = o.byteLength, l = [], c = 0; c < u; c++)
                l[c >>> 2] |= o[c] << 24 - c % 4 * 8;
              i.call(this, l, u);
            } else
              i.apply(this, arguments);
          };
          s.prototype = a;
        }
      }(), t.lib.WordArray;
    });
  }(yl)), yl.exports;
}
var xl = { exports: {} }, Gh;
function hb() {
  return Gh || (Gh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.WordArray, i = r.enc;
        i.Utf16 = i.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(o) {
            for (var u = o.words, l = o.sigBytes, c = [], f = 0; f < l; f += 2) {
              var d = u[f >>> 2] >>> 16 - f % 4 * 8 & 65535;
              c.push(String.fromCharCode(d));
            }
            return c.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(o) {
            for (var u = o.length, l = [], c = 0; c < u; c++)
              l[c >>> 1] |= o.charCodeAt(c) << 16 - c % 2 * 16;
            return a.create(l, u * 2);
          }
        }, i.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(o) {
            for (var u = o.words, l = o.sigBytes, c = [], f = 0; f < l; f += 2) {
              var d = s(u[f >>> 2] >>> 16 - f % 4 * 8 & 65535);
              c.push(String.fromCharCode(d));
            }
            return c.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(o) {
            for (var u = o.length, l = [], c = 0; c < u; c++)
              l[c >>> 1] |= s(o.charCodeAt(c) << 16 - c % 2 * 16);
            return a.create(l, u * 2);
          }
        };
        function s(o) {
          return o << 8 & 4278255360 | o >>> 8 & 16711935;
        }
      }(), t.enc.Utf16;
    });
  }(xl)), xl.exports;
}
var Cl = { exports: {} }, Vh;
function Un() {
  return Vh || (Vh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.WordArray, i = r.enc;
        i.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(o) {
            var u = o.words, l = o.sigBytes, c = this._map;
            o.clamp();
            for (var f = [], d = 0; d < l; d += 3)
              for (var h = u[d >>> 2] >>> 24 - d % 4 * 8 & 255, p = u[d + 1 >>> 2] >>> 24 - (d + 1) % 4 * 8 & 255, v = u[d + 2 >>> 2] >>> 24 - (d + 2) % 4 * 8 & 255, y = h << 16 | p << 8 | v, g = 0; g < 4 && d + g * 0.75 < l; g++)
                f.push(c.charAt(y >>> 6 * (3 - g) & 63));
            var B = c.charAt(64);
            if (B)
              for (; f.length % 4; )
                f.push(B);
            return f.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(o) {
            var u = o.length, l = this._map, c = this._reverseMap;
            if (!c) {
              c = this._reverseMap = [];
              for (var f = 0; f < l.length; f++)
                c[l.charCodeAt(f)] = f;
            }
            var d = l.charAt(64);
            if (d) {
              var h = o.indexOf(d);
              h !== -1 && (u = h);
            }
            return s(o, u, c);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function s(o, u, l) {
          for (var c = [], f = 0, d = 0; d < u; d++)
            if (d % 4) {
              var h = l[o.charCodeAt(d - 1)] << d % 4 * 2, p = l[o.charCodeAt(d)] >>> 6 - d % 4 * 2, v = h | p;
              c[f >>> 2] |= v << 24 - f % 4 * 8, f++;
            }
          return a.create(c, f);
        }
      }(), t.enc.Base64;
    });
  }(Cl)), Cl.exports;
}
var El = { exports: {} }, Wh;
function pb() {
  return Wh || (Wh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.WordArray, i = r.enc;
        i.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(o, u) {
            u === void 0 && (u = !0);
            var l = o.words, c = o.sigBytes, f = u ? this._safe_map : this._map;
            o.clamp();
            for (var d = [], h = 0; h < c; h += 3)
              for (var p = l[h >>> 2] >>> 24 - h % 4 * 8 & 255, v = l[h + 1 >>> 2] >>> 24 - (h + 1) % 4 * 8 & 255, y = l[h + 2 >>> 2] >>> 24 - (h + 2) % 4 * 8 & 255, g = p << 16 | v << 8 | y, B = 0; B < 4 && h + B * 0.75 < c; B++)
                d.push(f.charAt(g >>> 6 * (3 - B) & 63));
            var w = f.charAt(64);
            if (w)
              for (; d.length % 4; )
                d.push(w);
            return d.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(o, u) {
            u === void 0 && (u = !0);
            var l = o.length, c = u ? this._safe_map : this._map, f = this._reverseMap;
            if (!f) {
              f = this._reverseMap = [];
              for (var d = 0; d < c.length; d++)
                f[c.charCodeAt(d)] = d;
            }
            var h = c.charAt(64);
            if (h) {
              var p = o.indexOf(h);
              p !== -1 && (l = p);
            }
            return s(o, l, f);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function s(o, u, l) {
          for (var c = [], f = 0, d = 0; d < u; d++)
            if (d % 4) {
              var h = l[o.charCodeAt(d - 1)] << d % 4 * 2, p = l[o.charCodeAt(d)] >>> 6 - d % 4 * 2, v = h | p;
              c[f >>> 2] |= v << 24 - f % 4 * 8, f++;
            }
          return a.create(c, f);
        }
      }(), t.enc.Base64url;
    });
  }(El)), El.exports;
}
var Fl = { exports: {} }, Yh;
function _n() {
  return Yh || (Yh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function(r) {
        var n = t, a = n.lib, i = a.WordArray, s = a.Hasher, o = n.algo, u = [];
        (function() {
          for (var p = 0; p < 64; p++)
            u[p] = r.abs(r.sin(p + 1)) * 4294967296 | 0;
        })();
        var l = o.MD5 = s.extend({
          _doReset: function() {
            this._hash = new i.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(p, v) {
            for (var y = 0; y < 16; y++) {
              var g = v + y, B = p[g];
              p[g] = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360;
            }
            var w = this._hash.words, m = p[v + 0], x = p[v + 1], C = p[v + 2], E = p[v + 3], T = p[v + 4], S = p[v + 5], b = p[v + 6], N = p[v + 7], O = p[v + 8], V = p[v + 9], I = p[v + 10], _ = p[v + 11], K = p[v + 12], Y = p[v + 13], X = p[v + 14], R = p[v + 15], U = w[0], H = w[1], D = w[2], Q = w[3];
            U = c(U, H, D, Q, m, 7, u[0]), Q = c(Q, U, H, D, x, 12, u[1]), D = c(D, Q, U, H, C, 17, u[2]), H = c(H, D, Q, U, E, 22, u[3]), U = c(U, H, D, Q, T, 7, u[4]), Q = c(Q, U, H, D, S, 12, u[5]), D = c(D, Q, U, H, b, 17, u[6]), H = c(H, D, Q, U, N, 22, u[7]), U = c(U, H, D, Q, O, 7, u[8]), Q = c(Q, U, H, D, V, 12, u[9]), D = c(D, Q, U, H, I, 17, u[10]), H = c(H, D, Q, U, _, 22, u[11]), U = c(U, H, D, Q, K, 7, u[12]), Q = c(Q, U, H, D, Y, 12, u[13]), D = c(D, Q, U, H, X, 17, u[14]), H = c(H, D, Q, U, R, 22, u[15]), U = f(U, H, D, Q, x, 5, u[16]), Q = f(Q, U, H, D, b, 9, u[17]), D = f(D, Q, U, H, _, 14, u[18]), H = f(H, D, Q, U, m, 20, u[19]), U = f(U, H, D, Q, S, 5, u[20]), Q = f(Q, U, H, D, I, 9, u[21]), D = f(D, Q, U, H, R, 14, u[22]), H = f(H, D, Q, U, T, 20, u[23]), U = f(U, H, D, Q, V, 5, u[24]), Q = f(Q, U, H, D, X, 9, u[25]), D = f(D, Q, U, H, E, 14, u[26]), H = f(H, D, Q, U, O, 20, u[27]), U = f(U, H, D, Q, Y, 5, u[28]), Q = f(Q, U, H, D, C, 9, u[29]), D = f(D, Q, U, H, N, 14, u[30]), H = f(H, D, Q, U, K, 20, u[31]), U = d(U, H, D, Q, S, 4, u[32]), Q = d(Q, U, H, D, O, 11, u[33]), D = d(D, Q, U, H, _, 16, u[34]), H = d(H, D, Q, U, X, 23, u[35]), U = d(U, H, D, Q, x, 4, u[36]), Q = d(Q, U, H, D, T, 11, u[37]), D = d(D, Q, U, H, N, 16, u[38]), H = d(H, D, Q, U, I, 23, u[39]), U = d(U, H, D, Q, Y, 4, u[40]), Q = d(Q, U, H, D, m, 11, u[41]), D = d(D, Q, U, H, E, 16, u[42]), H = d(H, D, Q, U, b, 23, u[43]), U = d(U, H, D, Q, V, 4, u[44]), Q = d(Q, U, H, D, K, 11, u[45]), D = d(D, Q, U, H, R, 16, u[46]), H = d(H, D, Q, U, C, 23, u[47]), U = h(U, H, D, Q, m, 6, u[48]), Q = h(Q, U, H, D, N, 10, u[49]), D = h(D, Q, U, H, X, 15, u[50]), H = h(H, D, Q, U, S, 21, u[51]), U = h(U, H, D, Q, K, 6, u[52]), Q = h(Q, U, H, D, E, 10, u[53]), D = h(D, Q, U, H, I, 15, u[54]), H = h(H, D, Q, U, x, 21, u[55]), U = h(U, H, D, Q, O, 6, u[56]), Q = h(Q, U, H, D, R, 10, u[57]), D = h(D, Q, U, H, b, 15, u[58]), H = h(H, D, Q, U, Y, 21, u[59]), U = h(U, H, D, Q, T, 6, u[60]), Q = h(Q, U, H, D, _, 10, u[61]), D = h(D, Q, U, H, C, 15, u[62]), H = h(H, D, Q, U, V, 21, u[63]), w[0] = w[0] + U | 0, w[1] = w[1] + H | 0, w[2] = w[2] + D | 0, w[3] = w[3] + Q | 0;
          },
          _doFinalize: function() {
            var p = this._data, v = p.words, y = this._nDataBytes * 8, g = p.sigBytes * 8;
            v[g >>> 5] |= 128 << 24 - g % 32;
            var B = r.floor(y / 4294967296), w = y;
            v[(g + 64 >>> 9 << 4) + 15] = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360, v[(g + 64 >>> 9 << 4) + 14] = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360, p.sigBytes = (v.length + 1) * 4, this._process();
            for (var m = this._hash, x = m.words, C = 0; C < 4; C++) {
              var E = x[C];
              x[C] = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360;
            }
            return m;
          },
          clone: function() {
            var p = s.clone.call(this);
            return p._hash = this._hash.clone(), p;
          }
        });
        function c(p, v, y, g, B, w, m) {
          var x = p + (v & y | ~v & g) + B + m;
          return (x << w | x >>> 32 - w) + v;
        }
        function f(p, v, y, g, B, w, m) {
          var x = p + (v & g | y & ~g) + B + m;
          return (x << w | x >>> 32 - w) + v;
        }
        function d(p, v, y, g, B, w, m) {
          var x = p + (v ^ y ^ g) + B + m;
          return (x << w | x >>> 32 - w) + v;
        }
        function h(p, v, y, g, B, w, m) {
          var x = p + (y ^ (v | ~g)) + B + m;
          return (x << w | x >>> 32 - w) + v;
        }
        n.MD5 = s._createHelper(l), n.HmacMD5 = s._createHmacHelper(l);
      }(Math), t.MD5;
    });
  }(Fl)), Fl.exports;
}
var bl = { exports: {} }, zh;
function Hm() {
  return zh || (zh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.WordArray, i = n.Hasher, s = r.algo, o = [], u = s.SHA1 = i.extend({
          _doReset: function() {
            this._hash = new a.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(l, c) {
            for (var f = this._hash.words, d = f[0], h = f[1], p = f[2], v = f[3], y = f[4], g = 0; g < 80; g++) {
              if (g < 16)
                o[g] = l[c + g] | 0;
              else {
                var B = o[g - 3] ^ o[g - 8] ^ o[g - 14] ^ o[g - 16];
                o[g] = B << 1 | B >>> 31;
              }
              var w = (d << 5 | d >>> 27) + y + o[g];
              g < 20 ? w += (h & p | ~h & v) + 1518500249 : g < 40 ? w += (h ^ p ^ v) + 1859775393 : g < 60 ? w += (h & p | h & v | p & v) - 1894007588 : w += (h ^ p ^ v) - 899497514, y = v, v = p, p = h << 30 | h >>> 2, h = d, d = w;
            }
            f[0] = f[0] + d | 0, f[1] = f[1] + h | 0, f[2] = f[2] + p | 0, f[3] = f[3] + v | 0, f[4] = f[4] + y | 0;
          },
          _doFinalize: function() {
            var l = this._data, c = l.words, f = this._nDataBytes * 8, d = l.sigBytes * 8;
            return c[d >>> 5] |= 128 << 24 - d % 32, c[(d + 64 >>> 9 << 4) + 14] = Math.floor(f / 4294967296), c[(d + 64 >>> 9 << 4) + 15] = f, l.sigBytes = c.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var l = i.clone.call(this);
            return l._hash = this._hash.clone(), l;
          }
        });
        r.SHA1 = i._createHelper(u), r.HmacSHA1 = i._createHmacHelper(u);
      }(), t.SHA1;
    });
  }(bl)), bl.exports;
}
var Sl = { exports: {} }, Xh;
function R0() {
  return Xh || (Xh = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      return function(r) {
        var n = t, a = n.lib, i = a.WordArray, s = a.Hasher, o = n.algo, u = [], l = [];
        (function() {
          function d(y) {
            for (var g = r.sqrt(y), B = 2; B <= g; B++)
              if (!(y % B))
                return !1;
            return !0;
          }
          function h(y) {
            return (y - (y | 0)) * 4294967296 | 0;
          }
          for (var p = 2, v = 0; v < 64; )
            d(p) && (v < 8 && (u[v] = h(r.pow(p, 1 / 2))), l[v] = h(r.pow(p, 1 / 3)), v++), p++;
        })();
        var c = [], f = o.SHA256 = s.extend({
          _doReset: function() {
            this._hash = new i.init(u.slice(0));
          },
          _doProcessBlock: function(d, h) {
            for (var p = this._hash.words, v = p[0], y = p[1], g = p[2], B = p[3], w = p[4], m = p[5], x = p[6], C = p[7], E = 0; E < 64; E++) {
              if (E < 16)
                c[E] = d[h + E] | 0;
              else {
                var T = c[E - 15], S = (T << 25 | T >>> 7) ^ (T << 14 | T >>> 18) ^ T >>> 3, b = c[E - 2], N = (b << 15 | b >>> 17) ^ (b << 13 | b >>> 19) ^ b >>> 10;
                c[E] = S + c[E - 7] + N + c[E - 16];
              }
              var O = w & m ^ ~w & x, V = v & y ^ v & g ^ y & g, I = (v << 30 | v >>> 2) ^ (v << 19 | v >>> 13) ^ (v << 10 | v >>> 22), _ = (w << 26 | w >>> 6) ^ (w << 21 | w >>> 11) ^ (w << 7 | w >>> 25), K = C + _ + O + l[E] + c[E], Y = I + V;
              C = x, x = m, m = w, w = B + K | 0, B = g, g = y, y = v, v = K + Y | 0;
            }
            p[0] = p[0] + v | 0, p[1] = p[1] + y | 0, p[2] = p[2] + g | 0, p[3] = p[3] + B | 0, p[4] = p[4] + w | 0, p[5] = p[5] + m | 0, p[6] = p[6] + x | 0, p[7] = p[7] + C | 0;
          },
          _doFinalize: function() {
            var d = this._data, h = d.words, p = this._nDataBytes * 8, v = d.sigBytes * 8;
            return h[v >>> 5] |= 128 << 24 - v % 32, h[(v + 64 >>> 9 << 4) + 14] = r.floor(p / 4294967296), h[(v + 64 >>> 9 << 4) + 15] = p, d.sigBytes = h.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var d = s.clone.call(this);
            return d._hash = this._hash.clone(), d;
          }
        });
        n.SHA256 = s._createHelper(f), n.HmacSHA256 = s._createHmacHelper(f);
      }(Math), t.SHA256;
    });
  }(Sl)), Sl.exports;
}
var Ul = { exports: {} }, qh;
function gb() {
  return qh || (qh = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), R0());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.WordArray, i = r.algo, s = i.SHA256, o = i.SHA224 = s.extend({
          _doReset: function() {
            this._hash = new a.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var u = s._doFinalize.call(this);
            return u.sigBytes -= 4, u;
          }
        });
        r.SHA224 = s._createHelper(o), r.HmacSHA224 = s._createHmacHelper(o);
      }(), t.SHA224;
    });
  }(Ul)), Ul.exports;
}
var _l = { exports: {} }, Jh;
function Lm() {
  return Jh || (Jh = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), nu());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.Hasher, i = r.x64, s = i.Word, o = i.WordArray, u = r.algo;
        function l() {
          return s.create.apply(s, arguments);
        }
        var c = [
          l(1116352408, 3609767458),
          l(1899447441, 602891725),
          l(3049323471, 3964484399),
          l(3921009573, 2173295548),
          l(961987163, 4081628472),
          l(1508970993, 3053834265),
          l(2453635748, 2937671579),
          l(2870763221, 3664609560),
          l(3624381080, 2734883394),
          l(310598401, 1164996542),
          l(607225278, 1323610764),
          l(1426881987, 3590304994),
          l(1925078388, 4068182383),
          l(2162078206, 991336113),
          l(2614888103, 633803317),
          l(3248222580, 3479774868),
          l(3835390401, 2666613458),
          l(4022224774, 944711139),
          l(264347078, 2341262773),
          l(604807628, 2007800933),
          l(770255983, 1495990901),
          l(1249150122, 1856431235),
          l(1555081692, 3175218132),
          l(1996064986, 2198950837),
          l(2554220882, 3999719339),
          l(2821834349, 766784016),
          l(2952996808, 2566594879),
          l(3210313671, 3203337956),
          l(3336571891, 1034457026),
          l(3584528711, 2466948901),
          l(113926993, 3758326383),
          l(338241895, 168717936),
          l(666307205, 1188179964),
          l(773529912, 1546045734),
          l(1294757372, 1522805485),
          l(1396182291, 2643833823),
          l(1695183700, 2343527390),
          l(1986661051, 1014477480),
          l(2177026350, 1206759142),
          l(2456956037, 344077627),
          l(2730485921, 1290863460),
          l(2820302411, 3158454273),
          l(3259730800, 3505952657),
          l(3345764771, 106217008),
          l(3516065817, 3606008344),
          l(3600352804, 1432725776),
          l(4094571909, 1467031594),
          l(275423344, 851169720),
          l(430227734, 3100823752),
          l(506948616, 1363258195),
          l(659060556, 3750685593),
          l(883997877, 3785050280),
          l(958139571, 3318307427),
          l(1322822218, 3812723403),
          l(1537002063, 2003034995),
          l(1747873779, 3602036899),
          l(1955562222, 1575990012),
          l(2024104815, 1125592928),
          l(2227730452, 2716904306),
          l(2361852424, 442776044),
          l(2428436474, 593698344),
          l(2756734187, 3733110249),
          l(3204031479, 2999351573),
          l(3329325298, 3815920427),
          l(3391569614, 3928383900),
          l(3515267271, 566280711),
          l(3940187606, 3454069534),
          l(4118630271, 4000239992),
          l(116418474, 1914138554),
          l(174292421, 2731055270),
          l(289380356, 3203993006),
          l(460393269, 320620315),
          l(685471733, 587496836),
          l(852142971, 1086792851),
          l(1017036298, 365543100),
          l(1126000580, 2618297676),
          l(1288033470, 3409855158),
          l(1501505948, 4234509866),
          l(1607167915, 987167468),
          l(1816402316, 1246189591)
        ], f = [];
        (function() {
          for (var h = 0; h < 80; h++)
            f[h] = l();
        })();
        var d = u.SHA512 = a.extend({
          _doReset: function() {
            this._hash = new o.init([
              new s.init(1779033703, 4089235720),
              new s.init(3144134277, 2227873595),
              new s.init(1013904242, 4271175723),
              new s.init(2773480762, 1595750129),
              new s.init(1359893119, 2917565137),
              new s.init(2600822924, 725511199),
              new s.init(528734635, 4215389547),
              new s.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(h, p) {
            for (var v = this._hash.words, y = v[0], g = v[1], B = v[2], w = v[3], m = v[4], x = v[5], C = v[6], E = v[7], T = y.high, S = y.low, b = g.high, N = g.low, O = B.high, V = B.low, I = w.high, _ = w.low, K = m.high, Y = m.low, X = x.high, R = x.low, U = C.high, H = C.low, D = E.high, Q = E.low, j = T, z = S, re = b, Z = N, ve = O, L = V, M = I, k = _, $ = K, ee = Y, he = X, pe = R, fe = U, Ge = H, gA = D, JA = Q, rA = 0; rA < 80; rA++) {
              var P, J, ne = f[rA];
              if (rA < 16)
                J = ne.high = h[p + rA * 2] | 0, P = ne.low = h[p + rA * 2 + 1] | 0;
              else {
                var ue = f[rA - 15], ge = ue.high, Ce = ue.low, fA = (ge >>> 1 | Ce << 31) ^ (ge >>> 8 | Ce << 24) ^ ge >>> 7, jA = (Ce >>> 1 | ge << 31) ^ (Ce >>> 8 | ge << 24) ^ (Ce >>> 7 | ge << 25), Mn = f[rA - 2], Et = Mn.high, zr = Mn.low, ll = (Et >>> 19 | zr << 13) ^ (Et << 3 | zr >>> 29) ^ Et >>> 6, Da = (zr >>> 19 | Et << 13) ^ (zr << 3 | Et >>> 29) ^ (zr >>> 6 | Et << 26), ns = f[rA - 7], nE = ns.high, aE = ns.low, Bh = f[rA - 16], iE = Bh.high, vh = Bh.low;
                P = jA + aE, J = fA + nE + (P >>> 0 < jA >>> 0 ? 1 : 0), P = P + Da, J = J + ll + (P >>> 0 < Da >>> 0 ? 1 : 0), P = P + vh, J = J + iE + (P >>> 0 < vh >>> 0 ? 1 : 0), ne.high = J, ne.low = P;
              }
              var sE = $ & he ^ ~$ & fe, mh = ee & pe ^ ~ee & Ge, oE = j & re ^ j & ve ^ re & ve, uE = z & Z ^ z & L ^ Z & L, lE = (j >>> 28 | z << 4) ^ (j << 30 | z >>> 2) ^ (j << 25 | z >>> 7), wh = (z >>> 28 | j << 4) ^ (z << 30 | j >>> 2) ^ (z << 25 | j >>> 7), cE = ($ >>> 14 | ee << 18) ^ ($ >>> 18 | ee << 14) ^ ($ << 23 | ee >>> 9), fE = (ee >>> 14 | $ << 18) ^ (ee >>> 18 | $ << 14) ^ (ee << 23 | $ >>> 9), yh = c[rA], dE = yh.high, xh = yh.low, GA = JA + fE, Br = gA + cE + (GA >>> 0 < JA >>> 0 ? 1 : 0), GA = GA + mh, Br = Br + sE + (GA >>> 0 < mh >>> 0 ? 1 : 0), GA = GA + xh, Br = Br + dE + (GA >>> 0 < xh >>> 0 ? 1 : 0), GA = GA + P, Br = Br + J + (GA >>> 0 < P >>> 0 ? 1 : 0), Ch = wh + uE, hE = lE + oE + (Ch >>> 0 < wh >>> 0 ? 1 : 0);
              gA = fe, JA = Ge, fe = he, Ge = pe, he = $, pe = ee, ee = k + GA | 0, $ = M + Br + (ee >>> 0 < k >>> 0 ? 1 : 0) | 0, M = ve, k = L, ve = re, L = Z, re = j, Z = z, z = GA + Ch | 0, j = Br + hE + (z >>> 0 < GA >>> 0 ? 1 : 0) | 0;
            }
            S = y.low = S + z, y.high = T + j + (S >>> 0 < z >>> 0 ? 1 : 0), N = g.low = N + Z, g.high = b + re + (N >>> 0 < Z >>> 0 ? 1 : 0), V = B.low = V + L, B.high = O + ve + (V >>> 0 < L >>> 0 ? 1 : 0), _ = w.low = _ + k, w.high = I + M + (_ >>> 0 < k >>> 0 ? 1 : 0), Y = m.low = Y + ee, m.high = K + $ + (Y >>> 0 < ee >>> 0 ? 1 : 0), R = x.low = R + pe, x.high = X + he + (R >>> 0 < pe >>> 0 ? 1 : 0), H = C.low = H + Ge, C.high = U + fe + (H >>> 0 < Ge >>> 0 ? 1 : 0), Q = E.low = Q + JA, E.high = D + gA + (Q >>> 0 < JA >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var h = this._data, p = h.words, v = this._nDataBytes * 8, y = h.sigBytes * 8;
            p[y >>> 5] |= 128 << 24 - y % 32, p[(y + 128 >>> 10 << 5) + 30] = Math.floor(v / 4294967296), p[(y + 128 >>> 10 << 5) + 31] = v, h.sigBytes = p.length * 4, this._process();
            var g = this._hash.toX32();
            return g;
          },
          clone: function() {
            var h = a.clone.call(this);
            return h._hash = this._hash.clone(), h;
          },
          blockSize: 1024 / 32
        });
        r.SHA512 = a._createHelper(d), r.HmacSHA512 = a._createHmacHelper(d);
      }(), t.SHA512;
    });
  }(_l)), _l.exports;
}
var Ql = { exports: {} }, Zh;
function Bb() {
  return Zh || (Zh = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), nu(), Lm());
    })(te, function(t) {
      return function() {
        var r = t, n = r.x64, a = n.Word, i = n.WordArray, s = r.algo, o = s.SHA512, u = s.SHA384 = o.extend({
          _doReset: function() {
            this._hash = new i.init([
              new a.init(3418070365, 3238371032),
              new a.init(1654270250, 914150663),
              new a.init(2438529370, 812702999),
              new a.init(355462360, 4144912697),
              new a.init(1731405415, 4290775857),
              new a.init(2394180231, 1750603025),
              new a.init(3675008525, 1694076839),
              new a.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var l = o._doFinalize.call(this);
            return l.sigBytes -= 16, l;
          }
        });
        r.SHA384 = o._createHelper(u), r.HmacSHA384 = o._createHmacHelper(u);
      }(), t.SHA384;
    });
  }(Ql)), Ql.exports;
}
var Il = { exports: {} }, ep;
function vb() {
  return ep || (ep = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), nu());
    })(te, function(t) {
      return function(r) {
        var n = t, a = n.lib, i = a.WordArray, s = a.Hasher, o = n.x64, u = o.Word, l = n.algo, c = [], f = [], d = [];
        (function() {
          for (var v = 1, y = 0, g = 0; g < 24; g++) {
            c[v + 5 * y] = (g + 1) * (g + 2) / 2 % 64;
            var B = y % 5, w = (2 * v + 3 * y) % 5;
            v = B, y = w;
          }
          for (var v = 0; v < 5; v++)
            for (var y = 0; y < 5; y++)
              f[v + 5 * y] = y + (2 * v + 3 * y) % 5 * 5;
          for (var m = 1, x = 0; x < 24; x++) {
            for (var C = 0, E = 0, T = 0; T < 7; T++) {
              if (m & 1) {
                var S = (1 << T) - 1;
                S < 32 ? E ^= 1 << S : C ^= 1 << S - 32;
              }
              m & 128 ? m = m << 1 ^ 113 : m <<= 1;
            }
            d[x] = u.create(C, E);
          }
        })();
        var h = [];
        (function() {
          for (var v = 0; v < 25; v++)
            h[v] = u.create();
        })();
        var p = l.SHA3 = s.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: s.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var v = this._state = [], y = 0; y < 25; y++)
              v[y] = new u.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(v, y) {
            for (var g = this._state, B = this.blockSize / 2, w = 0; w < B; w++) {
              var m = v[y + 2 * w], x = v[y + 2 * w + 1];
              m = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360, x = (x << 8 | x >>> 24) & 16711935 | (x << 24 | x >>> 8) & 4278255360;
              var C = g[w];
              C.high ^= x, C.low ^= m;
            }
            for (var E = 0; E < 24; E++) {
              for (var T = 0; T < 5; T++) {
                for (var S = 0, b = 0, N = 0; N < 5; N++) {
                  var C = g[T + 5 * N];
                  S ^= C.high, b ^= C.low;
                }
                var O = h[T];
                O.high = S, O.low = b;
              }
              for (var T = 0; T < 5; T++)
                for (var V = h[(T + 4) % 5], I = h[(T + 1) % 5], _ = I.high, K = I.low, S = V.high ^ (_ << 1 | K >>> 31), b = V.low ^ (K << 1 | _ >>> 31), N = 0; N < 5; N++) {
                  var C = g[T + 5 * N];
                  C.high ^= S, C.low ^= b;
                }
              for (var Y = 1; Y < 25; Y++) {
                var S, b, C = g[Y], X = C.high, R = C.low, U = c[Y];
                U < 32 ? (S = X << U | R >>> 32 - U, b = R << U | X >>> 32 - U) : (S = R << U - 32 | X >>> 64 - U, b = X << U - 32 | R >>> 64 - U);
                var H = h[f[Y]];
                H.high = S, H.low = b;
              }
              var D = h[0], Q = g[0];
              D.high = Q.high, D.low = Q.low;
              for (var T = 0; T < 5; T++)
                for (var N = 0; N < 5; N++) {
                  var Y = T + 5 * N, C = g[Y], j = h[Y], z = h[(T + 1) % 5 + 5 * N], re = h[(T + 2) % 5 + 5 * N];
                  C.high = j.high ^ ~z.high & re.high, C.low = j.low ^ ~z.low & re.low;
                }
              var C = g[0], Z = d[E];
              C.high ^= Z.high, C.low ^= Z.low;
            }
          },
          _doFinalize: function() {
            var v = this._data, y = v.words;
            this._nDataBytes * 8;
            var g = v.sigBytes * 8, B = this.blockSize * 32;
            y[g >>> 5] |= 1 << 24 - g % 32, y[(r.ceil((g + 1) / B) * B >>> 5) - 1] |= 128, v.sigBytes = y.length * 4, this._process();
            for (var w = this._state, m = this.cfg.outputLength / 8, x = m / 8, C = [], E = 0; E < x; E++) {
              var T = w[E], S = T.high, b = T.low;
              S = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, b = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, C.push(b), C.push(S);
            }
            return new i.init(C, m);
          },
          clone: function() {
            for (var v = s.clone.call(this), y = v._state = this._state.slice(0), g = 0; g < 25; g++)
              y[g] = y[g].clone();
            return v;
          }
        });
        n.SHA3 = s._createHelper(p), n.HmacSHA3 = s._createHmacHelper(p);
      }(Math), t.SHA3;
    });
  }(Il)), Il.exports;
}
var Dl = { exports: {} }, Ap;
function mb() {
  return Ap || (Ap = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(r) {
        var n = t, a = n.lib, i = a.WordArray, s = a.Hasher, o = n.algo, u = i.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), l = i.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), c = i.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), f = i.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), d = i.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), h = i.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), p = o.RIPEMD160 = s.extend({
          _doReset: function() {
            this._hash = i.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(x, C) {
            for (var E = 0; E < 16; E++) {
              var T = C + E, S = x[T];
              x[T] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360;
            }
            var b = this._hash.words, N = d.words, O = h.words, V = u.words, I = l.words, _ = c.words, K = f.words, Y, X, R, U, H, D, Q, j, z, re;
            D = Y = b[0], Q = X = b[1], j = R = b[2], z = U = b[3], re = H = b[4];
            for (var Z, E = 0; E < 80; E += 1)
              Z = Y + x[C + V[E]] | 0, E < 16 ? Z += v(X, R, U) + N[0] : E < 32 ? Z += y(X, R, U) + N[1] : E < 48 ? Z += g(X, R, U) + N[2] : E < 64 ? Z += B(X, R, U) + N[3] : Z += w(X, R, U) + N[4], Z = Z | 0, Z = m(Z, _[E]), Z = Z + H | 0, Y = H, H = U, U = m(R, 10), R = X, X = Z, Z = D + x[C + I[E]] | 0, E < 16 ? Z += w(Q, j, z) + O[0] : E < 32 ? Z += B(Q, j, z) + O[1] : E < 48 ? Z += g(Q, j, z) + O[2] : E < 64 ? Z += y(Q, j, z) + O[3] : Z += v(Q, j, z) + O[4], Z = Z | 0, Z = m(Z, K[E]), Z = Z + re | 0, D = re, re = z, z = m(j, 10), j = Q, Q = Z;
            Z = b[1] + R + z | 0, b[1] = b[2] + U + re | 0, b[2] = b[3] + H + D | 0, b[3] = b[4] + Y + Q | 0, b[4] = b[0] + X + j | 0, b[0] = Z;
          },
          _doFinalize: function() {
            var x = this._data, C = x.words, E = this._nDataBytes * 8, T = x.sigBytes * 8;
            C[T >>> 5] |= 128 << 24 - T % 32, C[(T + 64 >>> 9 << 4) + 14] = (E << 8 | E >>> 24) & 16711935 | (E << 24 | E >>> 8) & 4278255360, x.sigBytes = (C.length + 1) * 4, this._process();
            for (var S = this._hash, b = S.words, N = 0; N < 5; N++) {
              var O = b[N];
              b[N] = (O << 8 | O >>> 24) & 16711935 | (O << 24 | O >>> 8) & 4278255360;
            }
            return S;
          },
          clone: function() {
            var x = s.clone.call(this);
            return x._hash = this._hash.clone(), x;
          }
        });
        function v(x, C, E) {
          return x ^ C ^ E;
        }
        function y(x, C, E) {
          return x & C | ~x & E;
        }
        function g(x, C, E) {
          return (x | ~C) ^ E;
        }
        function B(x, C, E) {
          return x & E | C & ~E;
        }
        function w(x, C, E) {
          return x ^ (C | ~E);
        }
        function m(x, C) {
          return x << C | x >>> 32 - C;
        }
        n.RIPEMD160 = s._createHelper(p), n.HmacRIPEMD160 = s._createHmacHelper(p);
      }(), t.RIPEMD160;
    });
  }(Dl)), Dl.exports;
}
var Tl = { exports: {} }, tp;
function N0() {
  return tp || (tp = 1, function(e, A) {
    (function(t, r) {
      e.exports = r(Fe());
    })(te, function(t) {
      (function() {
        var r = t, n = r.lib, a = n.Base, i = r.enc, s = i.Utf8, o = r.algo;
        o.HMAC = a.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(u, l) {
            u = this._hasher = new u.init(), typeof l == "string" && (l = s.parse(l));
            var c = u.blockSize, f = c * 4;
            l.sigBytes > f && (l = u.finalize(l)), l.clamp();
            for (var d = this._oKey = l.clone(), h = this._iKey = l.clone(), p = d.words, v = h.words, y = 0; y < c; y++)
              p[y] ^= 1549556828, v[y] ^= 909522486;
            d.sigBytes = h.sigBytes = f, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var u = this._hasher;
            u.reset(), u.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(u) {
            return this._hasher.update(u), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(u) {
            var l = this._hasher, c = l.finalize(u);
            l.reset();
            var f = l.finalize(this._oKey.clone().concat(c));
            return f;
          }
        });
      })();
    });
  }(Tl)), Tl.exports;
}
var Ol = { exports: {} }, rp;
function wb() {
  return rp || (rp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), R0(), N0());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.Base, i = n.WordArray, s = r.algo, o = s.SHA256, u = s.HMAC, l = s.PBKDF2 = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: o,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(c) {
            this.cfg = this.cfg.extend(c);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(c, f) {
            for (var d = this.cfg, h = u.create(d.hasher, c), p = i.create(), v = i.create([1]), y = p.words, g = v.words, B = d.keySize, w = d.iterations; y.length < B; ) {
              var m = h.update(f).finalize(v);
              h.reset();
              for (var x = m.words, C = x.length, E = m, T = 1; T < w; T++) {
                E = h.finalize(E), h.reset();
                for (var S = E.words, b = 0; b < C; b++)
                  x[b] ^= S[b];
              }
              p.concat(m), g[0]++;
            }
            return p.sigBytes = B * 4, p;
          }
        });
        r.PBKDF2 = function(c, f, d) {
          return l.create(d).compute(c, f);
        };
      }(), t.PBKDF2;
    });
  }(Ol)), Ol.exports;
}
var Hl = { exports: {} }, np;
function Kr() {
  return np || (np = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Hm(), N0());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.Base, i = n.WordArray, s = r.algo, o = s.MD5, u = s.EvpKDF = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: a.extend({
            keySize: 128 / 32,
            hasher: o,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(l) {
            this.cfg = this.cfg.extend(l);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(l, c) {
            for (var f, d = this.cfg, h = d.hasher.create(), p = i.create(), v = p.words, y = d.keySize, g = d.iterations; v.length < y; ) {
              f && h.update(f), f = h.update(l).finalize(c), h.reset();
              for (var B = 1; B < g; B++)
                f = h.finalize(f), h.reset();
              p.concat(f);
            }
            return p.sigBytes = y * 4, p;
          }
        });
        r.EvpKDF = function(l, c, f) {
          return u.create(f).compute(l, c);
        };
      }(), t.EvpKDF;
    });
  }(Hl)), Hl.exports;
}
var Ll = { exports: {} }, ap;
function yA() {
  return ap || (ap = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Kr());
    })(te, function(t) {
      t.lib.Cipher || function(r) {
        var n = t, a = n.lib, i = a.Base, s = a.WordArray, o = a.BufferedBlockAlgorithm, u = n.enc;
        u.Utf8;
        var l = u.Base64, c = n.algo, f = c.EvpKDF, d = a.Cipher = o.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: i.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(S, b) {
            return this.create(this._ENC_XFORM_MODE, S, b);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(S, b) {
            return this.create(this._DEC_XFORM_MODE, S, b);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(S, b, N) {
            this.cfg = this.cfg.extend(N), this._xformMode = S, this._key = b, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            o.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(S) {
            return this._append(S), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(S) {
            S && this._append(S);
            var b = this._doFinalize();
            return b;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: function() {
            function S(b) {
              return typeof b == "string" ? T : x;
            }
            return function(b) {
              return {
                encrypt: function(N, O, V) {
                  return S(O).encrypt(b, N, O, V);
                },
                decrypt: function(N, O, V) {
                  return S(O).decrypt(b, N, O, V);
                }
              };
            };
          }()
        });
        a.StreamCipher = d.extend({
          _doFinalize: function() {
            var S = this._process(!0);
            return S;
          },
          blockSize: 1
        });
        var h = n.mode = {}, p = a.BlockCipherMode = i.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(S, b) {
            return this.Encryptor.create(S, b);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(S, b) {
            return this.Decryptor.create(S, b);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(S, b) {
            this._cipher = S, this._iv = b;
          }
        }), v = h.CBC = function() {
          var S = p.extend();
          S.Encryptor = S.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(N, O) {
              var V = this._cipher, I = V.blockSize;
              b.call(this, N, O, I), V.encryptBlock(N, O), this._prevBlock = N.slice(O, O + I);
            }
          }), S.Decryptor = S.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(N, O) {
              var V = this._cipher, I = V.blockSize, _ = N.slice(O, O + I);
              V.decryptBlock(N, O), b.call(this, N, O, I), this._prevBlock = _;
            }
          });
          function b(N, O, V) {
            var I, _ = this._iv;
            _ ? (I = _, this._iv = r) : I = this._prevBlock;
            for (var K = 0; K < V; K++)
              N[O + K] ^= I[K];
          }
          return S;
        }(), y = n.pad = {}, g = y.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(S, b) {
            for (var N = b * 4, O = N - S.sigBytes % N, V = O << 24 | O << 16 | O << 8 | O, I = [], _ = 0; _ < O; _ += 4)
              I.push(V);
            var K = s.create(I, O);
            S.concat(K);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(S) {
            var b = S.words[S.sigBytes - 1 >>> 2] & 255;
            S.sigBytes -= b;
          }
        };
        a.BlockCipher = d.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: d.cfg.extend({
            mode: v,
            padding: g
          }),
          reset: function() {
            var S;
            d.reset.call(this);
            var b = this.cfg, N = b.iv, O = b.mode;
            this._xformMode == this._ENC_XFORM_MODE ? S = O.createEncryptor : (S = O.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == S ? this._mode.init(this, N && N.words) : (this._mode = S.call(O, this, N && N.words), this._mode.__creator = S);
          },
          _doProcessBlock: function(S, b) {
            this._mode.processBlock(S, b);
          },
          _doFinalize: function() {
            var S, b = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (b.pad(this._data, this.blockSize), S = this._process(!0)) : (S = this._process(!0), b.unpad(S)), S;
          },
          blockSize: 128 / 32
        });
        var B = a.CipherParams = i.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(S) {
            this.mixIn(S);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(S) {
            return (S || this.formatter).stringify(this);
          }
        }), w = n.format = {}, m = w.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(S) {
            var b, N = S.ciphertext, O = S.salt;
            return O ? b = s.create([1398893684, 1701076831]).concat(O).concat(N) : b = N, b.toString(l);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(S) {
            var b, N = l.parse(S), O = N.words;
            return O[0] == 1398893684 && O[1] == 1701076831 && (b = s.create(O.slice(2, 4)), O.splice(0, 4), N.sigBytes -= 16), B.create({ ciphertext: N, salt: b });
          }
        }, x = a.SerializableCipher = i.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: i.extend({
            format: m
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(S, b, N, O) {
            O = this.cfg.extend(O);
            var V = S.createEncryptor(N, O), I = V.finalize(b), _ = V.cfg;
            return B.create({
              ciphertext: I,
              key: N,
              iv: _.iv,
              algorithm: S,
              mode: _.mode,
              padding: _.padding,
              blockSize: S.blockSize,
              formatter: O.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(S, b, N, O) {
            O = this.cfg.extend(O), b = this._parse(b, O.format);
            var V = S.createDecryptor(N, O).finalize(b.ciphertext);
            return V;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(S, b) {
            return typeof S == "string" ? b.parse(S, this) : S;
          }
        }), C = n.kdf = {}, E = C.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(S, b, N, O, V) {
            if (O || (O = s.random(64 / 8)), V)
              var I = f.create({ keySize: b + N, hasher: V }).compute(S, O);
            else
              var I = f.create({ keySize: b + N }).compute(S, O);
            var _ = s.create(I.words.slice(b), N * 4);
            return I.sigBytes = b * 4, B.create({ key: I, iv: _, salt: O });
          }
        }, T = a.PasswordBasedCipher = x.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: x.cfg.extend({
            kdf: E
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(S, b, N, O) {
            O = this.cfg.extend(O);
            var V = O.kdf.execute(N, S.keySize, S.ivSize, O.salt, O.hasher);
            O.iv = V.iv;
            var I = x.encrypt.call(this, S, b, V.key, O);
            return I.mixIn(V), I;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(S, b, N, O) {
            O = this.cfg.extend(O), b = this._parse(b, O.format);
            var V = O.kdf.execute(N, S.keySize, S.ivSize, b.salt, O.hasher);
            O.iv = V.iv;
            var I = x.decrypt.call(this, S, b, V.key, O);
            return I;
          }
        });
      }();
    });
  }(Ll)), Ll.exports;
}
var Ml = { exports: {} }, ip;
function yb() {
  return ip || (ip = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.mode.CFB = function() {
        var r = t.lib.BlockCipherMode.extend();
        r.Encryptor = r.extend({
          processBlock: function(a, i) {
            var s = this._cipher, o = s.blockSize;
            n.call(this, a, i, o, s), this._prevBlock = a.slice(i, i + o);
          }
        }), r.Decryptor = r.extend({
          processBlock: function(a, i) {
            var s = this._cipher, o = s.blockSize, u = a.slice(i, i + o);
            n.call(this, a, i, o, s), this._prevBlock = u;
          }
        });
        function n(a, i, s, o) {
          var u, l = this._iv;
          l ? (u = l.slice(0), this._iv = void 0) : u = this._prevBlock, o.encryptBlock(u, 0);
          for (var c = 0; c < s; c++)
            a[i + c] ^= u[c];
        }
        return r;
      }(), t.mode.CFB;
    });
  }(Ml)), Ml.exports;
}
var Rl = { exports: {} }, sp;
function xb() {
  return sp || (sp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.mode.CTR = function() {
        var r = t.lib.BlockCipherMode.extend(), n = r.Encryptor = r.extend({
          processBlock: function(a, i) {
            var s = this._cipher, o = s.blockSize, u = this._iv, l = this._counter;
            u && (l = this._counter = u.slice(0), this._iv = void 0);
            var c = l.slice(0);
            s.encryptBlock(c, 0), l[o - 1] = l[o - 1] + 1 | 0;
            for (var f = 0; f < o; f++)
              a[i + f] ^= c[f];
          }
        });
        return r.Decryptor = n, r;
      }(), t.mode.CTR;
    });
  }(Rl)), Rl.exports;
}
var Nl = { exports: {} }, op;
function Cb() {
  return op || (op = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return t.mode.CTRGladman = function() {
        var r = t.lib.BlockCipherMode.extend();
        function n(s) {
          if ((s >> 24 & 255) === 255) {
            var o = s >> 16 & 255, u = s >> 8 & 255, l = s & 255;
            o === 255 ? (o = 0, u === 255 ? (u = 0, l === 255 ? l = 0 : ++l) : ++u) : ++o, s = 0, s += o << 16, s += u << 8, s += l;
          } else
            s += 1 << 24;
          return s;
        }
        function a(s) {
          return (s[0] = n(s[0])) === 0 && (s[1] = n(s[1])), s;
        }
        var i = r.Encryptor = r.extend({
          processBlock: function(s, o) {
            var u = this._cipher, l = u.blockSize, c = this._iv, f = this._counter;
            c && (f = this._counter = c.slice(0), this._iv = void 0), a(f);
            var d = f.slice(0);
            u.encryptBlock(d, 0);
            for (var h = 0; h < l; h++)
              s[o + h] ^= d[h];
          }
        });
        return r.Decryptor = i, r;
      }(), t.mode.CTRGladman;
    });
  }(Nl)), Nl.exports;
}
var kl = { exports: {} }, up;
function Eb() {
  return up || (up = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.mode.OFB = function() {
        var r = t.lib.BlockCipherMode.extend(), n = r.Encryptor = r.extend({
          processBlock: function(a, i) {
            var s = this._cipher, o = s.blockSize, u = this._iv, l = this._keystream;
            u && (l = this._keystream = u.slice(0), this._iv = void 0), s.encryptBlock(l, 0);
            for (var c = 0; c < o; c++)
              a[i + c] ^= l[c];
          }
        });
        return r.Decryptor = n, r;
      }(), t.mode.OFB;
    });
  }(kl)), kl.exports;
}
var Pl = { exports: {} }, lp;
function Fb() {
  return lp || (lp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.mode.ECB = function() {
        var r = t.lib.BlockCipherMode.extend();
        return r.Encryptor = r.extend({
          processBlock: function(n, a) {
            this._cipher.encryptBlock(n, a);
          }
        }), r.Decryptor = r.extend({
          processBlock: function(n, a) {
            this._cipher.decryptBlock(n, a);
          }
        }), r;
      }(), t.mode.ECB;
    });
  }(Pl)), Pl.exports;
}
var Kl = { exports: {} }, cp;
function bb() {
  return cp || (cp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.pad.AnsiX923 = {
        pad: function(r, n) {
          var a = r.sigBytes, i = n * 4, s = i - a % i, o = a + s - 1;
          r.clamp(), r.words[o >>> 2] |= s << 24 - o % 4 * 8, r.sigBytes += s;
        },
        unpad: function(r) {
          var n = r.words[r.sigBytes - 1 >>> 2] & 255;
          r.sigBytes -= n;
        }
      }, t.pad.Ansix923;
    });
  }(Kl)), Kl.exports;
}
var $l = { exports: {} }, fp;
function Sb() {
  return fp || (fp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.pad.Iso10126 = {
        pad: function(r, n) {
          var a = n * 4, i = a - r.sigBytes % a;
          r.concat(t.lib.WordArray.random(i - 1)).concat(t.lib.WordArray.create([i << 24], 1));
        },
        unpad: function(r) {
          var n = r.words[r.sigBytes - 1 >>> 2] & 255;
          r.sigBytes -= n;
        }
      }, t.pad.Iso10126;
    });
  }($l)), $l.exports;
}
var jl = { exports: {} }, dp;
function Ub() {
  return dp || (dp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.pad.Iso97971 = {
        pad: function(r, n) {
          r.concat(t.lib.WordArray.create([2147483648], 1)), t.pad.ZeroPadding.pad(r, n);
        },
        unpad: function(r) {
          t.pad.ZeroPadding.unpad(r), r.sigBytes--;
        }
      }, t.pad.Iso97971;
    });
  }(jl)), jl.exports;
}
var Gl = { exports: {} }, hp;
function _b() {
  return hp || (hp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.pad.ZeroPadding = {
        pad: function(r, n) {
          var a = n * 4;
          r.clamp(), r.sigBytes += a - (r.sigBytes % a || a);
        },
        unpad: function(r) {
          for (var n = r.words, a = r.sigBytes - 1, a = r.sigBytes - 1; a >= 0; a--)
            if (n[a >>> 2] >>> 24 - a % 4 * 8 & 255) {
              r.sigBytes = a + 1;
              break;
            }
        }
      }, t.pad.ZeroPadding;
    });
  }(Gl)), Gl.exports;
}
var Vl = { exports: {} }, pp;
function Qb() {
  return pp || (pp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return t.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, t.pad.NoPadding;
    });
  }(Vl)), Vl.exports;
}
var Wl = { exports: {} }, gp;
function Ib() {
  return gp || (gp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), yA());
    })(te, function(t) {
      return function(r) {
        var n = t, a = n.lib, i = a.CipherParams, s = n.enc, o = s.Hex, u = n.format;
        u.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(l) {
            return l.ciphertext.toString(o);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(l) {
            var c = o.parse(l);
            return i.create({ ciphertext: c });
          }
        };
      }(), t.format.Hex;
    });
  }(Wl)), Wl.exports;
}
var Yl = { exports: {} }, Bp;
function Db() {
  return Bp || (Bp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Un(), _n(), Kr(), yA());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.BlockCipher, i = r.algo, s = [], o = [], u = [], l = [], c = [], f = [], d = [], h = [], p = [], v = [];
        (function() {
          for (var B = [], w = 0; w < 256; w++)
            w < 128 ? B[w] = w << 1 : B[w] = w << 1 ^ 283;
          for (var m = 0, x = 0, w = 0; w < 256; w++) {
            var C = x ^ x << 1 ^ x << 2 ^ x << 3 ^ x << 4;
            C = C >>> 8 ^ C & 255 ^ 99, s[m] = C, o[C] = m;
            var E = B[m], T = B[E], S = B[T], b = B[C] * 257 ^ C * 16843008;
            u[m] = b << 24 | b >>> 8, l[m] = b << 16 | b >>> 16, c[m] = b << 8 | b >>> 24, f[m] = b;
            var b = S * 16843009 ^ T * 65537 ^ E * 257 ^ m * 16843008;
            d[C] = b << 24 | b >>> 8, h[C] = b << 16 | b >>> 16, p[C] = b << 8 | b >>> 24, v[C] = b, m ? (m = E ^ B[B[B[S ^ E]]], x ^= B[B[x]]) : m = x = 1;
          }
        })();
        var y = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], g = i.AES = a.extend({
          _doReset: function() {
            var B;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var w = this._keyPriorReset = this._key, m = w.words, x = w.sigBytes / 4, C = this._nRounds = x + 6, E = (C + 1) * 4, T = this._keySchedule = [], S = 0; S < E; S++)
                S < x ? T[S] = m[S] : (B = T[S - 1], S % x ? x > 6 && S % x == 4 && (B = s[B >>> 24] << 24 | s[B >>> 16 & 255] << 16 | s[B >>> 8 & 255] << 8 | s[B & 255]) : (B = B << 8 | B >>> 24, B = s[B >>> 24] << 24 | s[B >>> 16 & 255] << 16 | s[B >>> 8 & 255] << 8 | s[B & 255], B ^= y[S / x | 0] << 24), T[S] = T[S - x] ^ B);
              for (var b = this._invKeySchedule = [], N = 0; N < E; N++) {
                var S = E - N;
                if (N % 4)
                  var B = T[S];
                else
                  var B = T[S - 4];
                N < 4 || S <= 4 ? b[N] = B : b[N] = d[s[B >>> 24]] ^ h[s[B >>> 16 & 255]] ^ p[s[B >>> 8 & 255]] ^ v[s[B & 255]];
              }
            }
          },
          encryptBlock: function(B, w) {
            this._doCryptBlock(B, w, this._keySchedule, u, l, c, f, s);
          },
          decryptBlock: function(B, w) {
            var m = B[w + 1];
            B[w + 1] = B[w + 3], B[w + 3] = m, this._doCryptBlock(B, w, this._invKeySchedule, d, h, p, v, o);
            var m = B[w + 1];
            B[w + 1] = B[w + 3], B[w + 3] = m;
          },
          _doCryptBlock: function(B, w, m, x, C, E, T, S) {
            for (var b = this._nRounds, N = B[w] ^ m[0], O = B[w + 1] ^ m[1], V = B[w + 2] ^ m[2], I = B[w + 3] ^ m[3], _ = 4, K = 1; K < b; K++) {
              var Y = x[N >>> 24] ^ C[O >>> 16 & 255] ^ E[V >>> 8 & 255] ^ T[I & 255] ^ m[_++], X = x[O >>> 24] ^ C[V >>> 16 & 255] ^ E[I >>> 8 & 255] ^ T[N & 255] ^ m[_++], R = x[V >>> 24] ^ C[I >>> 16 & 255] ^ E[N >>> 8 & 255] ^ T[O & 255] ^ m[_++], U = x[I >>> 24] ^ C[N >>> 16 & 255] ^ E[O >>> 8 & 255] ^ T[V & 255] ^ m[_++];
              N = Y, O = X, V = R, I = U;
            }
            var Y = (S[N >>> 24] << 24 | S[O >>> 16 & 255] << 16 | S[V >>> 8 & 255] << 8 | S[I & 255]) ^ m[_++], X = (S[O >>> 24] << 24 | S[V >>> 16 & 255] << 16 | S[I >>> 8 & 255] << 8 | S[N & 255]) ^ m[_++], R = (S[V >>> 24] << 24 | S[I >>> 16 & 255] << 16 | S[N >>> 8 & 255] << 8 | S[O & 255]) ^ m[_++], U = (S[I >>> 24] << 24 | S[N >>> 16 & 255] << 16 | S[O >>> 8 & 255] << 8 | S[V & 255]) ^ m[_++];
            B[w] = Y, B[w + 1] = X, B[w + 2] = R, B[w + 3] = U;
          },
          keySize: 256 / 32
        });
        r.AES = a._createHelper(g);
      }(), t.AES;
    });
  }(Yl)), Yl.exports;
}
var zl = { exports: {} }, vp;
function Tb() {
  return vp || (vp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Un(), _n(), Kr(), yA());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.WordArray, i = n.BlockCipher, s = r.algo, o = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], u = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], l = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], c = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], f = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], d = s.DES = i.extend({
          _doReset: function() {
            for (var y = this._key, g = y.words, B = [], w = 0; w < 56; w++) {
              var m = o[w] - 1;
              B[w] = g[m >>> 5] >>> 31 - m % 32 & 1;
            }
            for (var x = this._subKeys = [], C = 0; C < 16; C++) {
              for (var E = x[C] = [], T = l[C], w = 0; w < 24; w++)
                E[w / 6 | 0] |= B[(u[w] - 1 + T) % 28] << 31 - w % 6, E[4 + (w / 6 | 0)] |= B[28 + (u[w + 24] - 1 + T) % 28] << 31 - w % 6;
              E[0] = E[0] << 1 | E[0] >>> 31;
              for (var w = 1; w < 7; w++)
                E[w] = E[w] >>> (w - 1) * 4 + 3;
              E[7] = E[7] << 5 | E[7] >>> 27;
            }
            for (var S = this._invSubKeys = [], w = 0; w < 16; w++)
              S[w] = x[15 - w];
          },
          encryptBlock: function(y, g) {
            this._doCryptBlock(y, g, this._subKeys);
          },
          decryptBlock: function(y, g) {
            this._doCryptBlock(y, g, this._invSubKeys);
          },
          _doCryptBlock: function(y, g, B) {
            this._lBlock = y[g], this._rBlock = y[g + 1], h.call(this, 4, 252645135), h.call(this, 16, 65535), p.call(this, 2, 858993459), p.call(this, 8, 16711935), h.call(this, 1, 1431655765);
            for (var w = 0; w < 16; w++) {
              for (var m = B[w], x = this._lBlock, C = this._rBlock, E = 0, T = 0; T < 8; T++)
                E |= c[T][((C ^ m[T]) & f[T]) >>> 0];
              this._lBlock = C, this._rBlock = x ^ E;
            }
            var S = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = S, h.call(this, 1, 1431655765), p.call(this, 8, 16711935), p.call(this, 2, 858993459), h.call(this, 16, 65535), h.call(this, 4, 252645135), y[g] = this._lBlock, y[g + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function h(y, g) {
          var B = (this._lBlock >>> y ^ this._rBlock) & g;
          this._rBlock ^= B, this._lBlock ^= B << y;
        }
        function p(y, g) {
          var B = (this._rBlock >>> y ^ this._lBlock) & g;
          this._lBlock ^= B, this._rBlock ^= B << y;
        }
        r.DES = i._createHelper(d);
        var v = s.TripleDES = i.extend({
          _doReset: function() {
            var y = this._key, g = y.words;
            if (g.length !== 2 && g.length !== 4 && g.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var B = g.slice(0, 2), w = g.length < 4 ? g.slice(0, 2) : g.slice(2, 4), m = g.length < 6 ? g.slice(0, 2) : g.slice(4, 6);
            this._des1 = d.createEncryptor(a.create(B)), this._des2 = d.createEncryptor(a.create(w)), this._des3 = d.createEncryptor(a.create(m));
          },
          encryptBlock: function(y, g) {
            this._des1.encryptBlock(y, g), this._des2.decryptBlock(y, g), this._des3.encryptBlock(y, g);
          },
          decryptBlock: function(y, g) {
            this._des3.decryptBlock(y, g), this._des2.encryptBlock(y, g), this._des1.decryptBlock(y, g);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        r.TripleDES = i._createHelper(v);
      }(), t.TripleDES;
    });
  }(zl)), zl.exports;
}
var Xl = { exports: {} }, mp;
function Ob() {
  return mp || (mp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Un(), _n(), Kr(), yA());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.StreamCipher, i = r.algo, s = i.RC4 = a.extend({
          _doReset: function() {
            for (var l = this._key, c = l.words, f = l.sigBytes, d = this._S = [], h = 0; h < 256; h++)
              d[h] = h;
            for (var h = 0, p = 0; h < 256; h++) {
              var v = h % f, y = c[v >>> 2] >>> 24 - v % 4 * 8 & 255;
              p = (p + d[h] + y) % 256;
              var g = d[h];
              d[h] = d[p], d[p] = g;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(l, c) {
            l[c] ^= o.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function o() {
          for (var l = this._S, c = this._i, f = this._j, d = 0, h = 0; h < 4; h++) {
            c = (c + 1) % 256, f = (f + l[c]) % 256;
            var p = l[c];
            l[c] = l[f], l[f] = p, d |= l[(l[c] + l[f]) % 256] << 24 - h * 8;
          }
          return this._i = c, this._j = f, d;
        }
        r.RC4 = a._createHelper(s);
        var u = i.RC4Drop = s.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: s.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            s._doReset.call(this);
            for (var l = this.cfg.drop; l > 0; l--)
              o.call(this);
          }
        });
        r.RC4Drop = a._createHelper(u);
      }(), t.RC4;
    });
  }(Xl)), Xl.exports;
}
var ql = { exports: {} }, wp;
function Hb() {
  return wp || (wp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Un(), _n(), Kr(), yA());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.StreamCipher, i = r.algo, s = [], o = [], u = [], l = i.Rabbit = a.extend({
          _doReset: function() {
            for (var f = this._key.words, d = this.cfg.iv, h = 0; h < 4; h++)
              f[h] = (f[h] << 8 | f[h] >>> 24) & 16711935 | (f[h] << 24 | f[h] >>> 8) & 4278255360;
            var p = this._X = [
              f[0],
              f[3] << 16 | f[2] >>> 16,
              f[1],
              f[0] << 16 | f[3] >>> 16,
              f[2],
              f[1] << 16 | f[0] >>> 16,
              f[3],
              f[2] << 16 | f[1] >>> 16
            ], v = this._C = [
              f[2] << 16 | f[2] >>> 16,
              f[0] & 4294901760 | f[1] & 65535,
              f[3] << 16 | f[3] >>> 16,
              f[1] & 4294901760 | f[2] & 65535,
              f[0] << 16 | f[0] >>> 16,
              f[2] & 4294901760 | f[3] & 65535,
              f[1] << 16 | f[1] >>> 16,
              f[3] & 4294901760 | f[0] & 65535
            ];
            this._b = 0;
            for (var h = 0; h < 4; h++)
              c.call(this);
            for (var h = 0; h < 8; h++)
              v[h] ^= p[h + 4 & 7];
            if (d) {
              var y = d.words, g = y[0], B = y[1], w = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, m = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360, x = w >>> 16 | m & 4294901760, C = m << 16 | w & 65535;
              v[0] ^= w, v[1] ^= x, v[2] ^= m, v[3] ^= C, v[4] ^= w, v[5] ^= x, v[6] ^= m, v[7] ^= C;
              for (var h = 0; h < 4; h++)
                c.call(this);
            }
          },
          _doProcessBlock: function(f, d) {
            var h = this._X;
            c.call(this), s[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, s[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, s[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, s[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var p = 0; p < 4; p++)
              s[p] = (s[p] << 8 | s[p] >>> 24) & 16711935 | (s[p] << 24 | s[p] >>> 8) & 4278255360, f[d + p] ^= s[p];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function c() {
          for (var f = this._X, d = this._C, h = 0; h < 8; h++)
            o[h] = d[h];
          d[0] = d[0] + 1295307597 + this._b | 0, d[1] = d[1] + 3545052371 + (d[0] >>> 0 < o[0] >>> 0 ? 1 : 0) | 0, d[2] = d[2] + 886263092 + (d[1] >>> 0 < o[1] >>> 0 ? 1 : 0) | 0, d[3] = d[3] + 1295307597 + (d[2] >>> 0 < o[2] >>> 0 ? 1 : 0) | 0, d[4] = d[4] + 3545052371 + (d[3] >>> 0 < o[3] >>> 0 ? 1 : 0) | 0, d[5] = d[5] + 886263092 + (d[4] >>> 0 < o[4] >>> 0 ? 1 : 0) | 0, d[6] = d[6] + 1295307597 + (d[5] >>> 0 < o[5] >>> 0 ? 1 : 0) | 0, d[7] = d[7] + 3545052371 + (d[6] >>> 0 < o[6] >>> 0 ? 1 : 0) | 0, this._b = d[7] >>> 0 < o[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var p = f[h] + d[h], v = p & 65535, y = p >>> 16, g = ((v * v >>> 17) + v * y >>> 15) + y * y, B = ((p & 4294901760) * p | 0) + ((p & 65535) * p | 0);
            u[h] = g ^ B;
          }
          f[0] = u[0] + (u[7] << 16 | u[7] >>> 16) + (u[6] << 16 | u[6] >>> 16) | 0, f[1] = u[1] + (u[0] << 8 | u[0] >>> 24) + u[7] | 0, f[2] = u[2] + (u[1] << 16 | u[1] >>> 16) + (u[0] << 16 | u[0] >>> 16) | 0, f[3] = u[3] + (u[2] << 8 | u[2] >>> 24) + u[1] | 0, f[4] = u[4] + (u[3] << 16 | u[3] >>> 16) + (u[2] << 16 | u[2] >>> 16) | 0, f[5] = u[5] + (u[4] << 8 | u[4] >>> 24) + u[3] | 0, f[6] = u[6] + (u[5] << 16 | u[5] >>> 16) + (u[4] << 16 | u[4] >>> 16) | 0, f[7] = u[7] + (u[6] << 8 | u[6] >>> 24) + u[5] | 0;
        }
        r.Rabbit = a._createHelper(l);
      }(), t.Rabbit;
    });
  }(ql)), ql.exports;
}
var Jl = { exports: {} }, yp;
function Lb() {
  return yp || (yp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Un(), _n(), Kr(), yA());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.StreamCipher, i = r.algo, s = [], o = [], u = [], l = i.RabbitLegacy = a.extend({
          _doReset: function() {
            var f = this._key.words, d = this.cfg.iv, h = this._X = [
              f[0],
              f[3] << 16 | f[2] >>> 16,
              f[1],
              f[0] << 16 | f[3] >>> 16,
              f[2],
              f[1] << 16 | f[0] >>> 16,
              f[3],
              f[2] << 16 | f[1] >>> 16
            ], p = this._C = [
              f[2] << 16 | f[2] >>> 16,
              f[0] & 4294901760 | f[1] & 65535,
              f[3] << 16 | f[3] >>> 16,
              f[1] & 4294901760 | f[2] & 65535,
              f[0] << 16 | f[0] >>> 16,
              f[2] & 4294901760 | f[3] & 65535,
              f[1] << 16 | f[1] >>> 16,
              f[3] & 4294901760 | f[0] & 65535
            ];
            this._b = 0;
            for (var v = 0; v < 4; v++)
              c.call(this);
            for (var v = 0; v < 8; v++)
              p[v] ^= h[v + 4 & 7];
            if (d) {
              var y = d.words, g = y[0], B = y[1], w = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, m = (B << 8 | B >>> 24) & 16711935 | (B << 24 | B >>> 8) & 4278255360, x = w >>> 16 | m & 4294901760, C = m << 16 | w & 65535;
              p[0] ^= w, p[1] ^= x, p[2] ^= m, p[3] ^= C, p[4] ^= w, p[5] ^= x, p[6] ^= m, p[7] ^= C;
              for (var v = 0; v < 4; v++)
                c.call(this);
            }
          },
          _doProcessBlock: function(f, d) {
            var h = this._X;
            c.call(this), s[0] = h[0] ^ h[5] >>> 16 ^ h[3] << 16, s[1] = h[2] ^ h[7] >>> 16 ^ h[5] << 16, s[2] = h[4] ^ h[1] >>> 16 ^ h[7] << 16, s[3] = h[6] ^ h[3] >>> 16 ^ h[1] << 16;
            for (var p = 0; p < 4; p++)
              s[p] = (s[p] << 8 | s[p] >>> 24) & 16711935 | (s[p] << 24 | s[p] >>> 8) & 4278255360, f[d + p] ^= s[p];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function c() {
          for (var f = this._X, d = this._C, h = 0; h < 8; h++)
            o[h] = d[h];
          d[0] = d[0] + 1295307597 + this._b | 0, d[1] = d[1] + 3545052371 + (d[0] >>> 0 < o[0] >>> 0 ? 1 : 0) | 0, d[2] = d[2] + 886263092 + (d[1] >>> 0 < o[1] >>> 0 ? 1 : 0) | 0, d[3] = d[3] + 1295307597 + (d[2] >>> 0 < o[2] >>> 0 ? 1 : 0) | 0, d[4] = d[4] + 3545052371 + (d[3] >>> 0 < o[3] >>> 0 ? 1 : 0) | 0, d[5] = d[5] + 886263092 + (d[4] >>> 0 < o[4] >>> 0 ? 1 : 0) | 0, d[6] = d[6] + 1295307597 + (d[5] >>> 0 < o[5] >>> 0 ? 1 : 0) | 0, d[7] = d[7] + 3545052371 + (d[6] >>> 0 < o[6] >>> 0 ? 1 : 0) | 0, this._b = d[7] >>> 0 < o[7] >>> 0 ? 1 : 0;
          for (var h = 0; h < 8; h++) {
            var p = f[h] + d[h], v = p & 65535, y = p >>> 16, g = ((v * v >>> 17) + v * y >>> 15) + y * y, B = ((p & 4294901760) * p | 0) + ((p & 65535) * p | 0);
            u[h] = g ^ B;
          }
          f[0] = u[0] + (u[7] << 16 | u[7] >>> 16) + (u[6] << 16 | u[6] >>> 16) | 0, f[1] = u[1] + (u[0] << 8 | u[0] >>> 24) + u[7] | 0, f[2] = u[2] + (u[1] << 16 | u[1] >>> 16) + (u[0] << 16 | u[0] >>> 16) | 0, f[3] = u[3] + (u[2] << 8 | u[2] >>> 24) + u[1] | 0, f[4] = u[4] + (u[3] << 16 | u[3] >>> 16) + (u[2] << 16 | u[2] >>> 16) | 0, f[5] = u[5] + (u[4] << 8 | u[4] >>> 24) + u[3] | 0, f[6] = u[6] + (u[5] << 16 | u[5] >>> 16) + (u[4] << 16 | u[4] >>> 16) | 0, f[7] = u[7] + (u[6] << 8 | u[6] >>> 24) + u[5] | 0;
        }
        r.RabbitLegacy = a._createHelper(l);
      }(), t.RabbitLegacy;
    });
  }(Jl)), Jl.exports;
}
var Zl = { exports: {} }, xp;
function Mb() {
  return xp || (xp = 1, function(e, A) {
    (function(t, r, n) {
      e.exports = r(Fe(), Un(), _n(), Kr(), yA());
    })(te, function(t) {
      return function() {
        var r = t, n = r.lib, a = n.BlockCipher, i = r.algo;
        const s = 16, o = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], u = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var l = {
          pbox: [],
          sbox: []
        };
        function c(v, y) {
          let g = y >> 24 & 255, B = y >> 16 & 255, w = y >> 8 & 255, m = y & 255, x = v.sbox[0][g] + v.sbox[1][B];
          return x = x ^ v.sbox[2][w], x = x + v.sbox[3][m], x;
        }
        function f(v, y, g) {
          let B = y, w = g, m;
          for (let x = 0; x < s; ++x)
            B = B ^ v.pbox[x], w = c(v, B) ^ w, m = B, B = w, w = m;
          return m = B, B = w, w = m, w = w ^ v.pbox[s], B = B ^ v.pbox[s + 1], { left: B, right: w };
        }
        function d(v, y, g) {
          let B = y, w = g, m;
          for (let x = s + 1; x > 1; --x)
            B = B ^ v.pbox[x], w = c(v, B) ^ w, m = B, B = w, w = m;
          return m = B, B = w, w = m, w = w ^ v.pbox[1], B = B ^ v.pbox[0], { left: B, right: w };
        }
        function h(v, y, g) {
          for (let C = 0; C < 4; C++) {
            v.sbox[C] = [];
            for (let E = 0; E < 256; E++)
              v.sbox[C][E] = u[C][E];
          }
          let B = 0;
          for (let C = 0; C < s + 2; C++)
            v.pbox[C] = o[C] ^ y[B], B++, B >= g && (B = 0);
          let w = 0, m = 0, x = 0;
          for (let C = 0; C < s + 2; C += 2)
            x = f(v, w, m), w = x.left, m = x.right, v.pbox[C] = w, v.pbox[C + 1] = m;
          for (let C = 0; C < 4; C++)
            for (let E = 0; E < 256; E += 2)
              x = f(v, w, m), w = x.left, m = x.right, v.sbox[C][E] = w, v.sbox[C][E + 1] = m;
          return !0;
        }
        var p = i.Blowfish = a.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var v = this._keyPriorReset = this._key, y = v.words, g = v.sigBytes / 4;
              h(l, y, g);
            }
          },
          encryptBlock: function(v, y) {
            var g = f(l, v[y], v[y + 1]);
            v[y] = g.left, v[y + 1] = g.right;
          },
          decryptBlock: function(v, y) {
            var g = d(l, v[y], v[y + 1]);
            v[y] = g.left, v[y + 1] = g.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        r.Blowfish = a._createHelper(p);
      }(), t.Blowfish;
    });
  }(Zl)), Zl.exports;
}
(function(e, A) {
  (function(t, r, n) {
    e.exports = r(Fe(), nu(), db(), hb(), Un(), pb(), _n(), Hm(), R0(), gb(), Lm(), Bb(), vb(), mb(), N0(), wb(), Kr(), yA(), yb(), xb(), Cb(), Eb(), Fb(), bb(), Sb(), Ub(), _b(), Qb(), Ib(), Db(), Tb(), Ob(), Hb(), Lb(), Mb());
  })(te, function(t) {
    return t;
  });
})(Om);
var au = Om.exports;
const SAe = /* @__PURE__ */ wt(au);
var xA = {}, DA = {}, XA = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var A = Object.prototype.hasOwnProperty;
  e.has = function(c, f) {
    return A.call(c, f);
  };
  function t(c, f) {
    return c < f ? -1 : c === f ? 0 : 1;
  }
  e.defaultCompare = t;
  function r(c, f) {
    return c === f;
  }
  e.defaultEquals = r;
  function n(c) {
    return c === null ? "COLLECTION_NULL" : s(c) ? "COLLECTION_UNDEFINED" : o(c) ? "$s" + c : "$o" + c.toString();
  }
  e.defaultToString = n;
  function a(c, f) {
    if (f === void 0 && (f = ","), c === null)
      return "COLLECTION_NULL";
    if (s(c))
      return "COLLECTION_UNDEFINED";
    if (o(c))
      return c.toString();
    var d = "{", h = !0;
    for (var p in c)
      e.has(c, p) && (h ? h = !1 : d = d + f, d = d + p + ":" + c[p]);
    return d + "}";
  }
  e.makeString = a;
  function i(c) {
    return typeof c == "function";
  }
  e.isFunction = i;
  function s(c) {
    return typeof c > "u";
  }
  e.isUndefined = s;
  function o(c) {
    return Object.prototype.toString.call(c) === "[object String]";
  }
  e.isString = o;
  function u(c) {
    return s(c) || !i(c) ? function(f, d) {
      return f < d ? 1 : f === d ? 0 : -1;
    } : function(f, d) {
      return c(f, d) * -1;
    };
  }
  e.reverseCompareFunction = u;
  function l(c) {
    return function(f, d) {
      return c(f, d) === 0;
    };
  }
  e.compareToEquals = l;
})(XA);
Object.defineProperty(DA, "__esModule", { value: !0 });
var iu = XA;
function k0(e, A, t) {
  for (var r = t || iu.defaultEquals, n = e.length, a = 0; a < n; a++)
    if (r(e[a], A))
      return a;
  return -1;
}
DA.indexOf = k0;
function Rb(e, A, t) {
  for (var r = t || iu.defaultEquals, n = e.length, a = n - 1; a >= 0; a--)
    if (r(e[a], A))
      return a;
  return -1;
}
DA.lastIndexOf = Rb;
function Nb(e, A, t) {
  return k0(e, A, t) >= 0;
}
DA.contains = Nb;
function kb(e, A, t) {
  var r = k0(e, A, t);
  return r < 0 ? !1 : (e.splice(r, 1), !0);
}
DA.remove = kb;
function Pb(e, A, t) {
  for (var r = t || iu.defaultEquals, n = e.length, a = 0, i = 0; i < n; i++)
    r(e[i], A) && a++;
  return a;
}
DA.frequency = Pb;
function Kb(e, A, t) {
  var r = t || iu.defaultEquals;
  if (e.length !== A.length)
    return !1;
  for (var n = e.length, a = 0; a < n; a++)
    if (!r(e[a], A[a]))
      return !1;
  return !0;
}
DA.equals = Kb;
function $b(e) {
  return e.concat();
}
DA.copy = $b;
function jb(e, A, t) {
  if (A < 0 || A >= e.length || t < 0 || t >= e.length)
    return !1;
  var r = e[A];
  return e[A] = e[t], e[t] = r, !0;
}
DA.swap = jb;
function Gb(e) {
  return "[" + e.toString() + "]";
}
DA.toString = Gb;
function Vb(e, A) {
  for (var t = 0, r = e; t < r.length; t++) {
    var n = r[t];
    if (A(n) === !1)
      return;
  }
}
DA.forEach = Vb;
var P0 = {}, $r = {};
Object.defineProperty($r, "__esModule", { value: !0 });
var Ft = XA, Wb = (
  /** @class */
  function() {
    function e(A) {
      this.table = {}, this.nElements = 0, this.toStr = A || Ft.defaultToString;
    }
    return e.prototype.getValue = function(A) {
      var t = this.table["$" + this.toStr(A)];
      if (!Ft.isUndefined(t))
        return t.value;
    }, e.prototype.setValue = function(A, t) {
      if (!(Ft.isUndefined(A) || Ft.isUndefined(t))) {
        var r, n = "$" + this.toStr(A), a = this.table[n];
        return Ft.isUndefined(a) ? (this.nElements++, r = void 0) : r = a.value, this.table[n] = {
          key: A,
          value: t
        }, r;
      }
    }, e.prototype.remove = function(A) {
      var t = "$" + this.toStr(A), r = this.table[t];
      if (!Ft.isUndefined(r))
        return delete this.table[t], this.nElements--, r.value;
    }, e.prototype.keys = function() {
      var A = [];
      for (var t in this.table)
        if (Ft.has(this.table, t)) {
          var r = this.table[t];
          A.push(r.key);
        }
      return A;
    }, e.prototype.values = function() {
      var A = [];
      for (var t in this.table)
        if (Ft.has(this.table, t)) {
          var r = this.table[t];
          A.push(r.value);
        }
      return A;
    }, e.prototype.forEach = function(A) {
      for (var t in this.table)
        if (Ft.has(this.table, t)) {
          var r = this.table[t], n = A(r.key, r.value);
          if (n === !1)
            return;
        }
    }, e.prototype.containsKey = function(A) {
      return !Ft.isUndefined(this.getValue(A));
    }, e.prototype.clear = function() {
      this.table = {}, this.nElements = 0;
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.isEmpty = function() {
      return this.nElements <= 0;
    }, e.prototype.toString = function() {
      var A = "{";
      return this.forEach(function(t, r) {
        A += `
	` + t + " : " + r;
      }), A + `
}`;
    }, e;
  }()
);
$r.default = Wb;
var su = {};
Object.defineProperty(su, "__esModule", { value: !0 });
var Yb = XA, zb = DA, Xb = $r, qb = (
  /** @class */
  function() {
    function e(A) {
      this.dictionary = new Xb.default(A);
    }
    return e.prototype.contains = function(A) {
      return this.dictionary.containsKey(A);
    }, e.prototype.add = function(A) {
      return this.contains(A) || Yb.isUndefined(A) ? !1 : (this.dictionary.setValue(A, A), !0);
    }, e.prototype.intersection = function(A) {
      var t = this;
      this.forEach(function(r) {
        return A.contains(r) || t.remove(r), !0;
      });
    }, e.prototype.union = function(A) {
      var t = this;
      A.forEach(function(r) {
        return t.add(r), !0;
      });
    }, e.prototype.difference = function(A) {
      var t = this;
      A.forEach(function(r) {
        return t.remove(r), !0;
      });
    }, e.prototype.isSubsetOf = function(A) {
      if (this.size() > A.size())
        return !1;
      var t = !0;
      return this.forEach(function(r) {
        return A.contains(r) ? !0 : (t = !1, !1);
      }), t;
    }, e.prototype.remove = function(A) {
      return this.contains(A) ? (this.dictionary.remove(A), !0) : !1;
    }, e.prototype.forEach = function(A) {
      this.dictionary.forEach(function(t, r) {
        return A(r);
      });
    }, e.prototype.toArray = function() {
      return this.dictionary.values();
    }, e.prototype.isEmpty = function() {
      return this.dictionary.isEmpty();
    }, e.prototype.size = function() {
      return this.dictionary.size();
    }, e.prototype.clear = function() {
      this.dictionary.clear();
    }, e.prototype.toString = function() {
      return zb.toString(this.toArray());
    }, e;
  }()
);
su.default = qb;
Object.defineProperty(P0, "__esModule", { value: !0 });
var ec = XA, Jb = $r, Zb = su, eS = (
  /** @class */
  function() {
    function e(A) {
      this.toStrF = A || ec.defaultToString, this.dictionary = new Jb.default(this.toStrF), this.nElements = 0;
    }
    return e.prototype.add = function(A, t) {
      if (t === void 0 && (t = 1), ec.isUndefined(A) || t <= 0)
        return !1;
      if (this.contains(A))
        this.dictionary.getValue(A).copies += t;
      else {
        var r = {
          value: A,
          copies: t
        };
        this.dictionary.setValue(A, r);
      }
      return this.nElements += t, !0;
    }, e.prototype.count = function(A) {
      return this.contains(A) ? this.dictionary.getValue(A).copies : 0;
    }, e.prototype.contains = function(A) {
      return this.dictionary.containsKey(A);
    }, e.prototype.remove = function(A, t) {
      if (t === void 0 && (t = 1), ec.isUndefined(A) || t <= 0)
        return !1;
      if (this.contains(A)) {
        var r = this.dictionary.getValue(A);
        return t > r.copies ? this.nElements -= r.copies : this.nElements -= t, r.copies -= t, r.copies <= 0 && this.dictionary.remove(A), !0;
      } else
        return !1;
    }, e.prototype.toArray = function() {
      for (var A = [], t = this.dictionary.values(), r = 0, n = t; r < n.length; r++)
        for (var a = n[r], i = a.value, s = a.copies, o = 0; o < s; o++)
          A.push(i);
      return A;
    }, e.prototype.toSet = function() {
      for (var A = new Zb.default(this.toStrF), t = this.dictionary.values(), r = 0, n = t; r < n.length; r++) {
        var a = n[r], i = a.value;
        A.add(i);
      }
      return A;
    }, e.prototype.forEach = function(A) {
      this.dictionary.forEach(function(t, r) {
        for (var n = r.value, a = r.copies, i = 0; i < a; i++)
          if (A(n) === !1)
            return !1;
        return !0;
      });
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.isEmpty = function() {
      return this.nElements === 0;
    }, e.prototype.clear = function() {
      this.nElements = 0, this.dictionary.clear();
    }, e;
  }()
);
P0.default = eS;
var K0 = {}, ou = {}, uu = {}, Li = {};
Object.defineProperty(Li, "__esModule", { value: !0 });
var Xr = XA, AS = DA, tS = (
  /** @class */
  function() {
    function e() {
      this.firstNode = null, this.lastNode = null, this.nElements = 0;
    }
    return e.prototype.add = function(A, t) {
      if (Xr.isUndefined(t) && (t = this.nElements), t < 0 || t > this.nElements || Xr.isUndefined(A))
        return !1;
      var r = this.createNode(A);
      if (this.nElements === 0 || this.lastNode === null)
        this.firstNode = r, this.lastNode = r;
      else if (t === this.nElements)
        this.lastNode.next = r, this.lastNode = r;
      else if (t === 0)
        r.next = this.firstNode, this.firstNode = r;
      else {
        var n = this.nodeAtIndex(t - 1);
        if (n === null)
          return !1;
        r.next = n.next, n.next = r;
      }
      return this.nElements++, !0;
    }, e.prototype.first = function() {
      if (this.firstNode !== null)
        return this.firstNode.element;
    }, e.prototype.last = function() {
      if (this.lastNode !== null)
        return this.lastNode.element;
    }, e.prototype.elementAtIndex = function(A) {
      var t = this.nodeAtIndex(A);
      if (t !== null)
        return t.element;
    }, e.prototype.indexOf = function(A, t) {
      var r = t || Xr.defaultEquals;
      if (Xr.isUndefined(A))
        return -1;
      for (var n = this.firstNode, a = 0; n !== null; ) {
        if (r(n.element, A))
          return a;
        a++, n = n.next;
      }
      return -1;
    }, e.prototype.contains = function(A, t) {
      return this.indexOf(A, t) >= 0;
    }, e.prototype.remove = function(A, t) {
      var r = t || Xr.defaultEquals;
      if (this.nElements < 1 || Xr.isUndefined(A))
        return !1;
      for (var n = null, a = this.firstNode; a !== null; ) {
        if (r(a.element, A))
          return n === null ? (this.firstNode = a.next, a === this.lastNode && (this.lastNode = null)) : a === this.lastNode ? (this.lastNode = n, n.next = a.next, a.next = null) : (n.next = a.next, a.next = null), this.nElements--, !0;
        n = a, a = a.next;
      }
      return !1;
    }, e.prototype.clear = function() {
      this.firstNode = null, this.lastNode = null, this.nElements = 0;
    }, e.prototype.equals = function(A, t) {
      var r = t || Xr.defaultEquals;
      return !(A instanceof e) || this.size() !== A.size() ? !1 : this.equalsAux(this.firstNode, A.firstNode, r);
    }, e.prototype.equalsAux = function(A, t, r) {
      for (; A !== null && t !== null; ) {
        if (!r(A.element, t.element))
          return !1;
        A = A.next, t = t.next;
      }
      return !0;
    }, e.prototype.removeElementAtIndex = function(A) {
      if (!(A < 0 || A >= this.nElements || this.firstNode === null || this.lastNode === null)) {
        var t;
        if (this.nElements === 1)
          t = this.firstNode.element, this.firstNode = null, this.lastNode = null;
        else {
          var r = this.nodeAtIndex(A - 1);
          r === null ? (t = this.firstNode.element, this.firstNode = this.firstNode.next) : r.next === this.lastNode && (t = this.lastNode.element, this.lastNode = r), r !== null && r.next !== null && (t = r.next.element, r.next = r.next.next);
        }
        return this.nElements--, t;
      }
    }, e.prototype.forEach = function(A) {
      for (var t = this.firstNode; t !== null && A(t.element) !== !1; )
        t = t.next;
    }, e.prototype.reverse = function() {
      for (var A = null, t = this.firstNode, r = null; t !== null; )
        r = t.next, t.next = A, A = t, t = r;
      r = this.firstNode, this.firstNode = this.lastNode, this.lastNode = r;
    }, e.prototype.toArray = function() {
      for (var A = [], t = this.firstNode; t !== null; )
        A.push(t.element), t = t.next;
      return A;
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.isEmpty = function() {
      return this.nElements <= 0;
    }, e.prototype.toString = function() {
      return AS.toString(this.toArray());
    }, e.prototype.nodeAtIndex = function(A) {
      if (A < 0 || A >= this.nElements)
        return null;
      if (A === this.nElements - 1)
        return this.lastNode;
      for (var t = this.firstNode, r = 0; r < A && t !== null; r++)
        t = t.next;
      return t;
    }, e.prototype.createNode = function(A) {
      return {
        element: A,
        next: null
      };
    }, e;
  }()
);
Li.default = tS;
Object.defineProperty(uu, "__esModule", { value: !0 });
var rS = Li, nS = (
  /** @class */
  function() {
    function e() {
      this.list = new rS.default();
    }
    return e.prototype.enqueue = function(A) {
      return this.list.add(A);
    }, e.prototype.add = function(A) {
      return this.list.add(A);
    }, e.prototype.dequeue = function() {
      if (this.list.size() !== 0) {
        var A = this.list.first();
        return this.list.removeElementAtIndex(0), A;
      }
    }, e.prototype.peek = function() {
      if (this.list.size() !== 0)
        return this.list.first();
    }, e.prototype.size = function() {
      return this.list.size();
    }, e.prototype.contains = function(A, t) {
      return this.list.contains(A, t);
    }, e.prototype.isEmpty = function() {
      return this.list.size() <= 0;
    }, e.prototype.clear = function() {
      this.list.clear();
    }, e.prototype.forEach = function(A) {
      this.list.forEach(A);
    }, e;
  }()
);
uu.default = nS;
Object.defineProperty(ou, "__esModule", { value: !0 });
var Ac = XA, aS = uu, iS = (
  /** @class */
  function() {
    function e(A) {
      this.root = null, this.compare = A || Ac.defaultCompare, this.nElements = 0;
    }
    return e.prototype.add = function(A) {
      return Ac.isUndefined(A) ? !1 : this.insertNode(this.createNode(A)) !== null ? (this.nElements++, !0) : !1;
    }, e.prototype.clear = function() {
      this.root = null, this.nElements = 0;
    }, e.prototype.isEmpty = function() {
      return this.nElements === 0;
    }, e.prototype.size = function() {
      return this.nElements;
    }, e.prototype.contains = function(A) {
      return Ac.isUndefined(A) ? !1 : this.searchNode(this.root, A) !== null;
    }, e.prototype.search = function(A) {
      var t = this.searchNode(this.root, A);
      if (t !== null)
        return t.element;
    }, e.prototype.remove = function(A) {
      var t = this.searchNode(this.root, A);
      return t === null ? !1 : (this.removeNode(t), this.nElements--, !0);
    }, e.prototype.inorderTraversal = function(A) {
      this.inorderTraversalAux(this.root, A, {
        stop: !1
      });
    }, e.prototype.preorderTraversal = function(A) {
      this.preorderTraversalAux(this.root, A, {
        stop: !1
      });
    }, e.prototype.postorderTraversal = function(A) {
      this.postorderTraversalAux(this.root, A, {
        stop: !1
      });
    }, e.prototype.levelTraversal = function(A) {
      this.levelTraversalAux(this.root, A);
    }, e.prototype.minimum = function() {
      if (!(this.isEmpty() || this.root === null))
        return this.minimumAux(this.root).element;
    }, e.prototype.maximum = function() {
      if (!(this.isEmpty() || this.root === null))
        return this.maximumAux(this.root).element;
    }, e.prototype.forEach = function(A) {
      this.inorderTraversal(A);
    }, e.prototype.toArray = function() {
      var A = [];
      return this.inorderTraversal(function(t) {
        return A.push(t), !0;
      }), A;
    }, e.prototype.height = function() {
      return this.heightAux(this.root);
    }, e.prototype.searchNode = function(A, t) {
      for (var r = 1; A !== null && r !== 0; )
        r = this.compare(t, A.element), r < 0 ? A = A.leftCh : r > 0 && (A = A.rightCh);
      return A;
    }, e.prototype.transplant = function(A, t) {
      A.parent === null ? this.root = t : A === A.parent.leftCh ? A.parent.leftCh = t : A.parent.rightCh = t, t !== null && (t.parent = A.parent);
    }, e.prototype.removeNode = function(A) {
      if (A.leftCh === null)
        this.transplant(A, A.rightCh);
      else if (A.rightCh === null)
        this.transplant(A, A.leftCh);
      else {
        var t = this.minimumAux(A.rightCh);
        t.parent !== A && (this.transplant(t, t.rightCh), t.rightCh = A.rightCh, t.rightCh.parent = t), this.transplant(A, t), t.leftCh = A.leftCh, t.leftCh.parent = t;
      }
    }, e.prototype.inorderTraversalAux = function(A, t, r) {
      A === null || r.stop || (this.inorderTraversalAux(A.leftCh, t, r), !r.stop && (r.stop = t(A.element) === !1, !r.stop && this.inorderTraversalAux(A.rightCh, t, r)));
    }, e.prototype.levelTraversalAux = function(A, t) {
      var r = new aS.default();
      for (A !== null && r.enqueue(A), A = r.dequeue() || null; A != null; ) {
        if (t(A.element) === !1)
          return;
        A.leftCh !== null && r.enqueue(A.leftCh), A.rightCh !== null && r.enqueue(A.rightCh), A = r.dequeue() || null;
      }
    }, e.prototype.preorderTraversalAux = function(A, t, r) {
      A === null || r.stop || (r.stop = t(A.element) === !1, !r.stop && (this.preorderTraversalAux(A.leftCh, t, r), !r.stop && this.preorderTraversalAux(A.rightCh, t, r)));
    }, e.prototype.postorderTraversalAux = function(A, t, r) {
      A === null || r.stop || (this.postorderTraversalAux(A.leftCh, t, r), !r.stop && (this.postorderTraversalAux(A.rightCh, t, r), !r.stop && (r.stop = t(A.element) === !1)));
    }, e.prototype.minimumAux = function(A) {
      for (; A != null && A.leftCh !== null; )
        A = A.leftCh;
      return A;
    }, e.prototype.maximumAux = function(A) {
      for (; A != null && A.rightCh !== null; )
        A = A.rightCh;
      return A;
    }, e.prototype.heightAux = function(A) {
      return A === null ? -1 : Math.max(this.heightAux(A.leftCh), this.heightAux(A.rightCh)) + 1;
    }, e.prototype.insertNode = function(A) {
      for (var t = null, r = this.root; r !== null; ) {
        var n = this.compare(A.element, r.element);
        if (n === 0)
          return null;
        n < 0 ? (t = r, r = r.leftCh) : (t = r, r = r.rightCh);
      }
      return A.parent = t, t === null ? this.root = A : this.compare(A.element, t.element) < 0 ? t.leftCh = A : t.rightCh = A, A;
    }, e.prototype.createNode = function(A) {
      return {
        element: A,
        leftCh: null,
        rightCh: null,
        parent: null
      };
    }, e;
  }()
);
ou.default = iS;
var sS = te && te.__extends || function() {
  var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, t) {
    A.__proto__ = t;
  } || function(A, t) {
    for (var r in t)
      t.hasOwnProperty(r) && (A[r] = t[r]);
  };
  return function(A, t) {
    e(A, t);
    function r() {
      this.constructor = A;
    }
    A.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
  };
}();
Object.defineProperty(K0, "__esModule", { value: !0 });
var oS = ou, uS = (
  /** @class */
  function(e) {
    sS(A, e);
    function A() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return A;
  }(oS.default)
);
K0.default = uS;
var lu = {};
Object.defineProperty(lu, "__esModule", { value: !0 });
var tc = XA, as = DA, lS = (
  /** @class */
  function() {
    function e(A) {
      this.data = [], this.compare = A || tc.defaultCompare;
    }
    return e.prototype.leftChildIndex = function(A) {
      return 2 * A + 1;
    }, e.prototype.rightChildIndex = function(A) {
      return 2 * A + 2;
    }, e.prototype.parentIndex = function(A) {
      return Math.floor((A - 1) / 2);
    }, e.prototype.minIndex = function(A, t) {
      return t >= this.data.length ? A >= this.data.length ? -1 : A : this.compare(this.data[A], this.data[t]) <= 0 ? A : t;
    }, e.prototype.siftUp = function(A) {
      for (var t = this.parentIndex(A); A > 0 && this.compare(this.data[t], this.data[A]) > 0; )
        as.swap(this.data, t, A), A = t, t = this.parentIndex(A);
    }, e.prototype.siftDown = function(A) {
      for (var t = this.minIndex(this.leftChildIndex(A), this.rightChildIndex(A)); t >= 0 && this.compare(this.data[A], this.data[t]) > 0; )
        as.swap(this.data, t, A), A = t, t = this.minIndex(this.leftChildIndex(A), this.rightChildIndex(A));
    }, e.prototype.peek = function() {
      if (this.data.length > 0)
        return this.data[0];
    }, e.prototype.add = function(A) {
      return tc.isUndefined(A) ? !1 : (this.data.push(A), this.siftUp(this.data.length - 1), !0);
    }, e.prototype.removeRoot = function() {
      if (this.data.length > 0) {
        var A = this.data[0];
        return this.data[0] = this.data[this.data.length - 1], this.data.splice(this.data.length - 1, 1), this.data.length > 0 && this.siftDown(0), A;
      }
    }, e.prototype.contains = function(A) {
      var t = tc.compareToEquals(this.compare);
      return as.contains(this.data, A, t);
    }, e.prototype.size = function() {
      return this.data.length;
    }, e.prototype.isEmpty = function() {
      return this.data.length <= 0;
    }, e.prototype.clear = function() {
      this.data.length = 0;
    }, e.prototype.forEach = function(A) {
      as.forEach(this.data, A);
    }, e;
  }()
);
lu.default = lS;
var $0 = {}, cS = te && te.__extends || function() {
  var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, t) {
    A.__proto__ = t;
  } || function(A, t) {
    for (var r in t)
      t.hasOwnProperty(r) && (A[r] = t[r]);
  };
  return function(A, t) {
    e(A, t);
    function r() {
      this.constructor = A;
    }
    A.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
  };
}();
Object.defineProperty($0, "__esModule", { value: !0 });
var fS = $r, Nn = XA, dS = (
  /** @class */
  function() {
    function e(A, t) {
      this.key = A, this.value = t;
    }
    return e.prototype.unlink = function() {
      this.prev.next = this.next, this.next.prev = this.prev;
    }, e;
  }()
), Cp = (
  /** @class */
  function() {
    function e() {
      this.key = null, this.value = null;
    }
    return e.prototype.unlink = function() {
      this.prev.next = this.next, this.next.prev = this.prev;
    }, e;
  }()
);
function hS(e) {
  return !e.next;
}
var pS = (
  /** @class */
  function(e) {
    cS(A, e);
    function A(t) {
      var r = e.call(this, t) || this;
      return r.head = new Cp(), r.tail = new Cp(), r.head.next = r.tail, r.tail.prev = r.head, r;
    }
    return A.prototype.appendToTail = function(t) {
      var r = this.tail.prev;
      r.next = t, t.prev = r, t.next = this.tail, this.tail.prev = t;
    }, A.prototype.getLinkedDictionaryPair = function(t) {
      if (!Nn.isUndefined(t)) {
        var r = "$" + this.toStr(t), n = this.table[r];
        return n;
      }
    }, A.prototype.getValue = function(t) {
      var r = this.getLinkedDictionaryPair(t);
      if (!Nn.isUndefined(r))
        return r.value;
    }, A.prototype.remove = function(t) {
      var r = this.getLinkedDictionaryPair(t);
      if (!Nn.isUndefined(r))
        return e.prototype.remove.call(this, t), r.unlink(), r.value;
    }, A.prototype.clear = function() {
      e.prototype.clear.call(this), this.head.next = this.tail, this.tail.prev = this.head;
    }, A.prototype.replace = function(t, r) {
      var n = "$" + this.toStr(r.key);
      r.next = t.next, r.prev = t.prev, this.remove(t.key), r.prev.next = r, r.next.prev = r, this.table[n] = r, ++this.nElements;
    }, A.prototype.setValue = function(t, r) {
      if (!(Nn.isUndefined(t) || Nn.isUndefined(r))) {
        var n = this.getLinkedDictionaryPair(t), a = new dS(t, r), i = "$" + this.toStr(t);
        if (Nn.isUndefined(n)) {
          this.appendToTail(a), this.table[i] = a, ++this.nElements;
          return;
        } else
          return this.replace(n, a), n.value;
      }
    }, A.prototype.keys = function() {
      var t = [];
      return this.forEach(function(r, n) {
        t.push(r);
      }), t;
    }, A.prototype.values = function() {
      var t = [];
      return this.forEach(function(r, n) {
        t.push(n);
      }), t;
    }, A.prototype.forEach = function(t) {
      for (var r = this.head.next; !hS(r); ) {
        var n = t(r.key, r.value);
        if (n === !1)
          return;
        r = r.next;
      }
    }, A;
  }(fS.default)
);
$0.default = pS;
var j0 = {};
Object.defineProperty(j0, "__esModule", { value: !0 });
var mr = XA, gS = $r, rc = DA, BS = (
  /** @class */
  function() {
    function e(A, t, r) {
      r === void 0 && (r = !1), this.dict = new gS.default(A), this.equalsF = t || mr.defaultEquals, this.allowDuplicate = r;
    }
    return e.prototype.getValue = function(A) {
      var t = this.dict.getValue(A);
      return mr.isUndefined(t) ? [] : rc.copy(t);
    }, e.prototype.setValue = function(A, t) {
      if (mr.isUndefined(A) || mr.isUndefined(t))
        return !1;
      var r = this.dict.getValue(A);
      return mr.isUndefined(r) ? (this.dict.setValue(A, [t]), !0) : !this.allowDuplicate && rc.contains(r, t, this.equalsF) ? !1 : (r.push(t), !0);
    }, e.prototype.remove = function(A, t) {
      if (mr.isUndefined(t)) {
        var r = this.dict.remove(A);
        return !mr.isUndefined(r);
      }
      var n = this.dict.getValue(A);
      return !mr.isUndefined(n) && rc.remove(n, t, this.equalsF) ? (n.length === 0 && this.dict.remove(A), !0) : !1;
    }, e.prototype.keys = function() {
      return this.dict.keys();
    }, e.prototype.values = function() {
      for (var A = this.dict.values(), t = [], r = 0, n = A; r < n.length; r++)
        for (var a = n[r], i = 0, s = a; i < s.length; i++) {
          var o = s[i];
          t.push(o);
        }
      return t;
    }, e.prototype.containsKey = function(A) {
      return this.dict.containsKey(A);
    }, e.prototype.clear = function() {
      this.dict.clear();
    }, e.prototype.size = function() {
      return this.dict.size();
    }, e.prototype.isEmpty = function() {
      return this.dict.isEmpty();
    }, e;
  }()
);
j0.default = BS;
var cu = {}, vS = te && te.__extends || function() {
  var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(A, t) {
    A.__proto__ = t;
  } || function(A, t) {
    for (var r in t)
      t.hasOwnProperty(r) && (A[r] = t[r]);
  };
  return function(A, t) {
    e(A, t);
    function r() {
      this.constructor = A;
    }
    A.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
  };
}();
Object.defineProperty(cu, "__esModule", { value: !0 });
var mS = $r, wS = XA, yS = (
  /** @class */
  function(e) {
    vS(A, e);
    function A(t, r) {
      var n = e.call(this, r) || this;
      return n.defaultFactoryFunction = t, n;
    }
    return A.prototype.setDefault = function(t, r) {
      var n = e.prototype.getValue.call(this, t);
      return wS.isUndefined(n) ? (this.setValue(t, r), r) : n;
    }, A.prototype.getValue = function(t) {
      return this.setDefault(t, this.defaultFactoryFunction());
    }, A;
  }(mS.default)
);
cu.default = yS;
var G0 = {};
Object.defineProperty(G0, "__esModule", { value: !0 });
var xS = XA, CS = lu, ES = (
  /** @class */
  function() {
    function e(A) {
      this.heap = new CS.default(xS.reverseCompareFunction(A));
    }
    return e.prototype.enqueue = function(A) {
      return this.heap.add(A);
    }, e.prototype.add = function(A) {
      return this.heap.add(A);
    }, e.prototype.dequeue = function() {
      if (this.heap.size() !== 0) {
        var A = this.heap.peek();
        return this.heap.removeRoot(), A;
      }
    }, e.prototype.peek = function() {
      return this.heap.peek();
    }, e.prototype.contains = function(A) {
      return this.heap.contains(A);
    }, e.prototype.isEmpty = function() {
      return this.heap.isEmpty();
    }, e.prototype.size = function() {
      return this.heap.size();
    }, e.prototype.clear = function() {
      this.heap.clear();
    }, e.prototype.forEach = function(A) {
      this.heap.forEach(A);
    }, e;
  }()
);
G0.default = ES;
var V0 = {};
Object.defineProperty(V0, "__esModule", { value: !0 });
var FS = Li, bS = (
  /** @class */
  function() {
    function e() {
      this.list = new FS.default();
    }
    return e.prototype.push = function(A) {
      return this.list.add(A, 0);
    }, e.prototype.add = function(A) {
      return this.list.add(A, 0);
    }, e.prototype.pop = function() {
      return this.list.removeElementAtIndex(0);
    }, e.prototype.peek = function() {
      return this.list.first();
    }, e.prototype.size = function() {
      return this.list.size();
    }, e.prototype.contains = function(A, t) {
      return this.list.contains(A, t);
    }, e.prototype.isEmpty = function() {
      return this.list.isEmpty();
    }, e.prototype.clear = function() {
      this.list.clear();
    }, e.prototype.forEach = function(A) {
      this.list.forEach(A);
    }, e;
  }()
);
V0.default = bS;
var W0 = {};
Object.defineProperty(W0, "__esModule", { value: !0 });
var iA;
(function(e) {
  e[e.BEFORE = 0] = "BEFORE", e[e.AFTER = 1] = "AFTER", e[e.INSIDE_AT_END = 2] = "INSIDE_AT_END", e[e.INSIDE_AT_START = 3] = "INSIDE_AT_START";
})(iA || (iA = {}));
var SS = (
  /** @class */
  function() {
    function e(A, t) {
      A === void 0 && (A = []), t === void 0 && (t = {}), this.rootIds = A, this.nodes = t, this.initRootIds(), this.initNodes();
    }
    return e.prototype.initRootIds = function() {
      for (var A = 0, t = this.rootIds; A < t.length; A++) {
        var r = t[A];
        this.createEmptyNodeIfNotExist(r);
      }
    }, e.prototype.initNodes = function() {
      for (var A in this.nodes)
        if (this.nodes.hasOwnProperty(A))
          for (var t = 0, r = this.nodes[A]; t < r.length; t++) {
            var n = r[t];
            this.createEmptyNodeIfNotExist(n);
          }
    }, e.prototype.createEmptyNodeIfNotExist = function(A) {
      this.nodes[A] || (this.nodes[A] = []);
    }, e.prototype.getRootIds = function() {
      var A = this.rootIds.slice();
      return A;
    }, e.prototype.getNodes = function() {
      var A = {};
      for (var t in this.nodes)
        this.nodes.hasOwnProperty(t) && (A[t] = this.nodes[t].slice());
      return A;
    }, e.prototype.getObject = function() {
      return {
        rootIds: this.getRootIds(),
        nodes: this.getNodes()
      };
    }, e.prototype.toObject = function() {
      return this.getObject();
    }, e.prototype.flatten = function() {
      for (var A = this, t = [], r = 0; r < this.rootIds.length; r++) {
        var n = this.rootIds[r];
        t.push({
          id: n,
          level: 0,
          hasParent: !1,
          childrenCount: 0
        }), u(n, this.nodes, t, 0);
      }
      for (var a = 0, i = t; a < i.length; a++) {
        var s = i[a];
        s.childrenCount = o(s.id);
      }
      return t;
      function o(l) {
        if (A.nodes[l]) {
          var c = A.nodes[l].length;
          return c;
        } else
          return 0;
      }
      function u(l, c, f, d) {
        if (d === void 0 && (d = 0), !(!l || !c || !f || !c[l])) {
          d++;
          for (var h = c[l], p = 0; p < h.length; p++) {
            var v = h[p];
            f.push({ id: v, level: d, hasParent: !0 }), u(v, c, f, d);
          }
          d--;
        }
      }
    }, e.prototype.moveIdBeforeId = function(A, t) {
      return this.moveId(A, t, iA.BEFORE);
    }, e.prototype.moveIdAfterId = function(A, t) {
      return this.moveId(A, t, iA.AFTER);
    }, e.prototype.moveIdIntoId = function(A, t, r) {
      return r === void 0 && (r = !0), r ? this.moveId(A, t, iA.INSIDE_AT_START) : this.moveId(A, t, iA.INSIDE_AT_END);
    }, e.prototype.swapRootIdWithRootId = function(A, t) {
      var r = this.findRootId(A), n = this.findRootId(t);
      this.swapRootPositionWithRootPosition(r, n);
    }, e.prototype.swapRootPositionWithRootPosition = function(A, t) {
      var r = this.rootIds[t];
      this.rootIds[t] = this.rootIds[A], this.rootIds[A] = r;
    }, e.prototype.deleteId = function(A) {
      this.rootDeleteId(A), this.nodeAndSubNodesDelete(A), this.nodeRefrencesDelete(A);
    }, e.prototype.insertIdBeforeId = function(A, t) {
      var r = this.findRootId(A);
      r > -1 && this.insertIdIntoRoot(t, r);
      for (var n in this.nodes)
        if (this.nodes.hasOwnProperty(n)) {
          var a = this.findNodeId(n, A);
          a > -1 && this.insertIdIntoNode(n, t, a);
        }
    }, e.prototype.insertIdAfterId = function(A, t) {
      var r = this.findRootId(A);
      r > -1 && this.insertIdIntoRoot(t, r + 1);
      for (var n in this.nodes)
        if (this.nodes.hasOwnProperty(n)) {
          var a = this.findNodeId(n, A);
          a > -1 && this.insertIdIntoNode(n, t, a + 1);
        }
    }, e.prototype.insertIdIntoId = function(A, t) {
      this.nodeInsertAtEnd(A, t), this.nodes[t] = [];
    }, e.prototype.insertIdIntoRoot = function(A, t) {
      if (t === void 0)
        this.rootInsertAtEnd(A);
      else if (t < 0) {
        var r = this.rootIds.length;
        this.rootIds.splice(t + r + 1, 0, A);
      } else
        this.rootIds.splice(t, 0, A);
      this.nodes[A] = this.nodes[A] || [];
    }, e.prototype.insertIdIntoNode = function(A, t, r) {
      if (this.nodes[A] = this.nodes[A] || [], this.nodes[t] = this.nodes[t] || [], r === void 0)
        this.nodeInsertAtEnd(A, t);
      else if (r < 0) {
        var n = this.nodes[A].length;
        this.nodes[A].splice(r + n + 1, 0, t);
      } else
        this.nodes[A].splice(r, 0, t);
    }, e.prototype.moveId = function(A, t, r) {
      var n = A, a = this.findRootId(n);
      this.nodes[t];
      for (var i in this.nodes)
        if (this.nodes.hasOwnProperty(i)) {
          this.findNodeId(i, t);
          break;
        }
      var s = t, o = this.findRootId(s);
      this.nodes[t];
      for (var i in this.nodes)
        if (this.nodes.hasOwnProperty(i)) {
          this.findNodeId(i, t);
          break;
        }
      if (a > -1)
        if (o > -1)
          switch (this.rootDelete(a), o > a && o--, r) {
            case iA.BEFORE:
              this.insertIdIntoRoot(n, o);
              break;
            case iA.AFTER:
              this.insertIdIntoRoot(n, o + 1);
              break;
            case iA.INSIDE_AT_START:
              this.nodeInsertAtStart(s, n);
              break;
            case iA.INSIDE_AT_END:
              this.nodeInsertAtEnd(s, n);
              break;
          }
        else {
          this.rootDelete(a);
          for (var i in this.nodes)
            if (this.nodes.hasOwnProperty(i)) {
              var u = this.findNodeId(i, s);
              if (u > -1) {
                switch (r) {
                  case iA.BEFORE:
                    this.insertIdIntoNode(i, n, u);
                    break;
                  case iA.AFTER:
                    this.insertIdIntoNode(i, n, u + 1);
                    break;
                  case iA.INSIDE_AT_START:
                    this.nodeInsertAtStart(s, n);
                    break;
                  case iA.INSIDE_AT_END:
                    this.nodeInsertAtEnd(s, n);
                    break;
                }
                break;
              }
            }
        }
      else if (o > -1) {
        for (var i in this.nodes)
          if (this.nodes.hasOwnProperty(i)) {
            var u = this.findNodeId(i, n);
            if (u > -1) {
              this.nodeDeleteAtIndex(i, u);
              break;
            }
          }
        switch (r) {
          case iA.BEFORE:
            this.insertIdIntoRoot(n, o);
            break;
          case iA.AFTER:
            this.insertIdIntoRoot(n, o + 1);
            break;
          case iA.INSIDE_AT_START:
            this.nodeInsertAtStart(s, n);
            break;
          case iA.INSIDE_AT_END:
            this.nodeInsertAtEnd(s, n);
            break;
        }
      } else {
        for (var i in this.nodes)
          if (this.nodes.hasOwnProperty(i)) {
            var u = this.findNodeId(i, n);
            if (u > -1) {
              this.nodeDeleteAtIndex(i, u);
              break;
            }
          }
        for (var i in this.nodes)
          if (this.nodes.hasOwnProperty(i)) {
            var u = this.findNodeId(i, s);
            if (u > -1) {
              switch (r) {
                case iA.BEFORE:
                  this.insertIdIntoNode(i, n, u);
                  break;
                case iA.AFTER:
                  this.insertIdIntoNode(i, n, u + 1);
                  break;
                case iA.INSIDE_AT_START:
                  this.nodeInsertAtStart(s, n);
                  break;
                case iA.INSIDE_AT_END:
                  this.nodeInsertAtEnd(s, n);
                  break;
              }
              break;
            }
          }
      }
    }, e.prototype.swapArrayElements = function(A, t, r) {
      var n = A[t];
      return A[t] = A[r], A[r] = n, A;
    }, e.prototype.rootDeleteId = function(A) {
      var t = this.findRootId(A);
      t > -1 && this.rootDelete(t);
    }, e.prototype.nodeAndSubNodesDelete = function(A) {
      for (var t = [], r = 0; r < this.nodes[A].length; r++) {
        var n = this.nodes[A][r];
        this.nodeAndSubNodesDelete(n), t.push(A);
      }
      this.nodeDelete(A);
      for (var r = 0; r < t.length; r++)
        this.nodeDelete(t[r]);
    }, e.prototype.nodeRefrencesDelete = function(A) {
      for (var t in this.nodes)
        if (this.nodes.hasOwnProperty(t))
          for (var r = 0; r < this.nodes[t].length; r++) {
            var n = this.nodes[t][r];
            n === A && this.nodeDeleteAtIndex(t, r);
          }
    }, e.prototype.nodeDelete = function(A) {
      delete this.nodes[A];
    }, e.prototype.findRootId = function(A) {
      return this.rootIds.indexOf(A);
    }, e.prototype.findNodeId = function(A, t) {
      return this.nodes[A].indexOf(t);
    }, e.prototype.findNode = function(A) {
      return this.nodes[A];
    }, e.prototype.nodeInsertAtStart = function(A, t) {
      this.nodes[A].unshift(t);
    }, e.prototype.nodeInsertAtEnd = function(A, t) {
      this.nodes[A].push(t);
    }, e.prototype.rootDelete = function(A) {
      this.rootIds.splice(A, 1);
    }, e.prototype.nodeDeleteAtIndex = function(A, t) {
      this.nodes[A].splice(t, 1);
    }, e.prototype.rootInsertAtStart = function(A) {
      this.rootIds.unshift(A);
    }, e.prototype.rootInsertAtEnd = function(A) {
      this.rootIds.push(A);
    }, e;
  }()
);
W0.default = SS;
Object.defineProperty(xA, "__esModule", { value: !0 });
var US = DA;
xA.arrays = US;
var _S = P0;
xA.Bag = _S.default;
var QS = K0;
xA.BSTree = QS.default;
var IS = ou;
xA.BSTreeKV = IS.default;
var DS = $r, is = xA.Dictionary = DS.default, TS = lu;
xA.Heap = TS.default;
var OS = $0;
xA.LinkedDictionary = OS.default;
var HS = Li;
xA.LinkedList = HS.default;
var LS = j0;
xA.MultiDictionary = LS.default;
var MS = cu;
xA.FactoryDictionary = MS.default;
var RS = cu;
xA.DefaultDictionary = RS.default;
var NS = uu;
xA.Queue = NS.default;
var kS = G0;
xA.PriorityQueue = kS.default;
var PS = su;
xA.Set = PS.default;
var KS = V0;
xA.Stack = KS.default;
var $S = W0;
xA.MultiRootTree = $S.default;
var jS = XA;
xA.util = jS;
const Mm = ({ method: e = "GET", httpPath: A = "/", token: t }, r) => au.HmacSHA512(`${e}_${A}_${t}`, r).toString();
function UAe(e, A) {
  const t = NA(), r = gn(t);
  return ii.create({
    baseURL: A ?? `${{}.VITE_MYASURION_API_BASE_URL}${{}.VITE_MYASURION_API_BASE_PATH}` ?? {}.VITE_API_BASE_URL,
    headers: {
      "x-asurion-client": t,
      "x-asurion-cc": r.code
    },
    ...e
  });
}
new E0({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
});
var Qe;
((e) => {
  class A {
    /**
     * Provide group/path id and module id. Name may be the same as the group/path id.
     * @param {string} id: Group/section id
     * @param {string} moduleId: Module Id
     * @param {string} name: Group/section name. Equivalent to group/section id
     * @param {StringManager} provider?: Internal StringManager dependency
     */
    constructor(M, k, $, ee) {
      /**
       * Group/Section Id
       */
      ce(this, "id");
      /**
       * Module Id
       */
      ce(this, "moduleId");
      /**
       * Group/section name. Equivalent to group/section id
       */
      ce(this, "name");
      /**
       * Internal StringManager
       */
      ce(this, "_provider");
      /**
       * Contains the map of strings for the specific group. Accepts string/path id with corresponding String
       */
      ce(this, "stringMap", new is());
      this.id = M, this.moduleId = k, this._provider = ee, this.name = $;
    }
    /**
     * Gets string from a given string/path id
     * @param {string} id: String/path id
     * @returns {String | undefined} String | undefined
     */
    getString(M) {
      return this.stringMap.getValue(M);
    }
    get provider() {
      return this._provider;
    }
    /**
     * Adds a String to the string map
     * @param {Localization.String} theString Adds the String to the string map.
     */
    addString(M) {
      this.stringMap.setValue(M.id, M);
    }
    replaceString(M) {
      this.stringMap.remove(M.id), this.stringMap.setValue(M.id, M);
    }
    get strings() {
      const M = [];
      return this.stringMap.forEach((k, $) => {
        M.push({ key: k, value: $ });
      }), M;
    }
  }
  e.Group = A;
  class t {
    /**
     * Provide the string/path id and internal id
     * @param {string} id String/path id
     * @param {string|null} internalId?: Unique internal id
     * @param {Group | null} parent?: Parent Group/Section of the String
     */
    constructor(M, k, $) {
      /**
       * Unique internal id for the string
       */
      ce(this, "_internalId");
      /**
       * The text content of the given String
       */
      ce(this, "_content");
      /**
       * String/path id
       */
      ce(this, "id");
      /**
       * The parent Group/Section of the String
       *
       */
      ce(this, "parent");
      /**
       * The usage for the string. Can be either static or dynamic
       */
      ce(this, "usage");
      ce(this, "inView");
      /**
       * The description for the string
       */
      ce(this, "description");
      /**
       * Internal update callbacks array
       */
      ce(this, "_callbacks", []);
      this.id = M, this.parent = $, this._internalId = k;
    }
    /**
     * Provides the group/section id of the string
     * @returns {string|undefined} Group/Section Id of the String
     */
    get sectionId() {
      var M;
      return (M = this.parent) == null ? void 0 : M.id;
    }
    get internalId() {
      return this._internalId;
    }
    set content(M) {
      this._content = M;
    }
    get content() {
      return this._content;
    }
    /**
     * Adds an update callback function to internal callbacks array
     * @param {UpdateCallback} callback: Update callback function
     */
    set onUpdateListener(M) {
      this._callbacks.push(M);
    }
  }
  e.String = t;
  class r {
    constructor(M, k, $, ee, he, pe, fe, Ge) {
      ce(this, "_initialDefaultLoadedText");
      ce(this, "_script");
      ce(this, "_id");
      ce(this, "_sectionId");
      ce(this, "_moduleId");
      ce(this, "_languageCode");
      ce(this, "_partnerId");
      ce(this, "_status");
      ce(this, "_dynamicValues");
      this._initialDefaultLoadedText = M, this._script = k, this._id = $, this._sectionId = ee, this._moduleId = he, this._languageCode = pe, this._partnerId = fe, this._status = "initial", this._dynamicValues = Ge;
    }
    replaceTextPlaceHolders(M, k) {
      return M.replace(
        /\{(\d+)\}/g,
        ($, ee) => typeof k[ee - 1] < "u" ? k[ee - 1] : `{${ee}}`
      );
    }
    get value() {
      return {
        defaultLoadedText: this._initialDefaultLoadedText,
        text: this.replaceTextPlaceHolders(this.script, this._dynamicValues ?? []),
        id: this._id,
        sectionId: this._sectionId,
        moduleId: this._moduleId,
        languageCode: this._languageCode,
        partnerId: this._partnerId
      };
    }
    set status(M) {
      this._status = M;
    }
    get status() {
      return this._status;
    }
    set script(M) {
      this._script = M;
    }
    get script() {
      return this._script;
    }
  }
  e.UserScript = r;
  class n {
    /**
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code. Should support en-US and zh-CN
     * @param {IDataLoader} loader: IDataLoader
     * @param {IDataPersister} persister: IDataPersister
     * @param {IDataCreator} creator: IDataCreator
     */
    constructor(M, k, $, ee, he, pe) {
      /**
       * Internal partner id
       */
      ce(this, "_partnerId");
      /**
       * Internal module id
       */
      ce(this, "_moduleId");
      /**
       * Internal language code. Should support en-US and zh-CN
       */
      ce(this, "_languageCode");
      ce(this, "loader");
      ce(this, "persister");
      ce(this, "manipulator");
      /**
       * Internal listeners array of update callback functions
       */
      ce(this, "listeners", []);
      /**
       * Contains the map of groups/sections for the specific module.
       *
       * Accepts group/section id with corresponding Group array
       */
      ce(this, "_groupMap");
      ce(this, "_id");
      ce(this, "_initFetch");
      ce(this, "_completeFetch");
      this.loader = ee, this.manipulator = pe, this.persister = he, this._groupMap = new is(), this._partnerId = M, this._moduleId = k, this._languageCode = $, this._id = (+/* @__PURE__ */ new Date()).toString(), this._initFetch = !1, this._completeFetch = !1;
    }
    /**
     * Adds an update callback function to internal listeners array
     * @param {UpdateCallback} callback: Update callback function
     */
    set onUpdateListener(M) {
      this.listeners.push(M);
    }
    async updateString(M) {
      return await this.persister.persistString(M);
    }
    async updateSection(M) {
      return await this.persister.persistStrings(M);
    }
    /**
     * Loads all sections.
     *
     * Creates a new group/section map. Loads sections from the data loader/store.
     * Checks the internal group map and assigns the sections to the created new section map.
     * Returns the new map with updates sections.
     *
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code
     * @returns {Dictionary<string, Group[]>} Dictionary<string, Group[]> - Group/Section Map
     */
    async loadAllSections(M, k, $) {
      let ee, he = new is();
      try {
        const pe = await this.loader.loadSections(
          M,
          k,
          $
        );
        let fe;
        for (const Ge of pe)
          fe = Ge.id, this._groupMap.containsKey(fe) || this._groupMap.setValue(fe, []), ee = this._groupMap.getValue(fe), ee && ee.findIndex((gA) => gA.id === fe) === -1 && ee.push(Ge);
        he = this._groupMap;
      } catch (pe) {
        console.log(pe);
      }
      return he;
    }
    /**
     * Gets Group/Section from given id
     * @param {any} sectionId: Section/Group Id
     * @returns {Promise<Group | null>} Promise<Group | null>
     */
    async getGroup(M) {
      let k = [], $ = null;
      const ee = M;
      if (this._initFetch || (this._initFetch = !0, this._groupMap = await this.loadAllSections(
        this._partnerId,
        this._moduleId,
        this._languageCode
      ), this._completeFetch = !0), this._initFetch && this._completeFetch) {
        if (k = this._groupMap.getValue(ee), k === void 0)
          return $;
        for (const he of k)
          if (he.id === M) {
            $ = he;
            break;
          }
        return $;
      } else
        return new Promise((he, pe) => {
          try {
            setTimeout(() => {
              if (k = this._groupMap.getValue(ee), k === void 0)
                return $;
              for (const fe of k)
                if (fe.id === M) {
                  $ = fe;
                  break;
                }
              he($);
            }, 3500);
          } catch {
            pe(null);
          }
        });
    }
    async createString(M, k, $, ee, he, pe, fe) {
      this.manipulator.createString(
        M,
        k,
        $,
        ee,
        he,
        pe.profileId,
        fe
      );
    }
    async updateStringEntry(M, k, $, ee, he) {
      const { isUpdated: pe, body: fe } = await this.manipulator.updateString(
        M,
        k,
        $,
        ee,
        he.profileId
      );
      return pe && fe && this._groupMap.forEach((Ge, gA) => {
        const JA = gA.map((rA) => (rA.strings.forEach(({ key: P, value: J }) => {
          const ne = fe.text.find(
            (ue) => ue.internalId === J.internalId
          );
          if (P && ne) {
            const ue = new t(
              ne.path,
              ne.internalId
            );
            ue.content = ne.text, ue.usage = ne.usage, ue.description = ne.description, rA.replaceString(ue);
          }
        }), rA));
        this._groupMap.setValue(Ge, JA);
      }), { isUpdated: pe, body: fe };
    }
  }
  e.StringManager = n;
  class a {
    constructor(M, k, $) {
      /**
       * Internal partner id
       */
      ce(this, "_partnerId");
      /**
       * Internal module id
       */
      ce(this, "_moduleId");
      /**
       * Internal language code. Should support en-US and zh-CN
       */
      ce(this, "_languageCode");
      ce(this, "_scripts");
      ce(this, "subscribers");
      this._scripts = [], this._partnerId = M, this._moduleId = k, this._languageCode = $, this.subscribers = [];
    }
    getScript(M, k) {
      return this._scripts.find(
        ($) => $.value.id === M && $.value.languageCode === k
      );
    }
    createScript(M, k, $, ee, he, pe, fe) {
      const Ge = new r(
        M,
        M,
        k,
        $,
        ee,
        he,
        pe,
        fe
      );
      return this._scripts.findIndex(
        (gA) => gA.value.id === k && gA.value.languageCode === he
      ) === -1 && this._scripts.push(Ge), Ge;
    }
    updateScript(M, k, $, ee, he) {
      const pe = this._scripts.findIndex(
        (fe) => fe.value.id === k && fe.value.sectionId === $ && fe.value.languageCode === he
      );
      pe > -1 && (this._scripts[pe].value.text = M, this._scripts[pe].script = M, this._scripts[pe].status = ee, this.subscribers.forEach((fe) => {
        fe(this._scripts);
      }));
    }
    get scripts() {
      return this._scripts;
    }
    subscribe(M) {
      return this.subscribers.push(M), () => {
        this.subscribers = this.subscribers.filter((k) => k !== M);
      };
    }
  }
  e.ScriptManager = a;
  class i {
    constructor() {
      ce(this, "_stringsMap");
      this._stringsMap = new is();
    }
    addStringManager(M, k) {
      this._stringsMap.containsKey(M) || this._stringsMap.setValue(M, k);
    }
  }
  e.LanguageManager = i;
  class s {
    /**
     * Provide module Id to the parser
     * @param {any} moduleId: Module Id
     */
    constructor(M) {
      /**
       * Internal module id
       */
      ce(this, "_moduleId");
      this._moduleId = M;
    }
    /**
     * Parses section from provided data
     * @param {any} data:any
     * @returns {Group[]} Group[]
     */
    parseSections(M) {
      const k = [];
      let $;
      const ee = JSON.parse(JSON.stringify(M));
      for (const he of ee) {
        $ = new A(he.id, this._moduleId, he.id);
        for (const pe of he.text) {
          const fe = new t(
            pe.path,
            pe.internalId,
            $
          );
          fe.content = pe.text, fe.usage = pe.usage, fe.description = pe.description, $.addString(fe);
        }
        k.push($);
      }
      return k;
    }
  }
  class o {
    /**
     * @param {any} baseUrl: Base URL of the Strings API. Should include the base path. e.g. {url}/api/v1
     * @param {any} hmacKey: HMAC Key used to generate headers
     */
    constructor(M, k, $, ee, he, pe, fe) {
      /**
       * Internal base url property
       */
      ce(this, "_baseUrl");
      /**
       * Internal hmac key property
       */
      ce(this, "_hmacKey");
      /**
       * Internal authorization property
       *
       * Used in string modification headers
       */
      ce(this, "_authorization");
      /**
       * Internal token property
       *
       * Used in string modification headers
       */
      ce(this, "_token");
      /**
       * Internal profileId property
       *
       * Used in string modification headers
       */
      ce(this, "_profileId");
      /**
       * Internal profileId property
       *
       * Used in string modification headers
       */
      ce(this, "_moduleId");
      ce(this, "_initializedCallback");
      ce(this, "_config", null);
      ce(this, "_isDevToolsEnabled");
      this._baseUrl = M, this._hmacKey = k, this._authorization = $, this._token = ee, this._profileId = he, this._moduleId = pe, this._isDevToolsEnabled = fe;
    }
    async initialize() {
      return !0;
    }
    get loader() {
      return this;
    }
    get persister() {
      return this;
    }
    /**
     * Generates GET Headers for getStrings API
     * @param {string} targetUrl: Target URL /api getStrings path
     * @param {string} hmacKey: HMAC Key
     */
    generateGetHeaders(M, k, $ = "GET") {
      const ee = NA(), he = gn(ee), pe = +/* @__PURE__ */ new Date(), fe = au.SHA256(pe.toString()).toString();
      return {
        Authorization: Mm(
          {
            httpPath: M,
            method: $,
            token: fe || ""
          },
          k
        ),
        token: fe,
        t: pe,
        "x-asurion-client": ee,
        "x-asurion-cc": he.code
      };
    }
    /**
     * Loads Sections from getStrings (GET) API. Implemented from IDataLoader
     * @param {string} partnerId: Partner Id
     * @param {string} moduleId: Module Id
     * @param {string} languageCode: Language Code. Should support en-US and zh-CN
     * @returns {Group[]} Group[] - Sections/Groups
     */
    async loadSections(M, k, $) {
      const ee = `${this._baseUrl}/content/strings?moduleId=${k}&language=${$}&partnerId=${M}&preview=true`, he = this.generateGetHeaders(
        "/api/v1/content/strings",
        this._hmacKey
      ), fe = await ii({
        method: "GET",
        url: ee,
        headers: he
      });
      return new s(k).parseSections(fe.data.body);
    }
    async createString(M, k, $, ee, he, pe) {
      ee = ($ == null ? void 0 : $.toLowerCase()) === "global" ? "global" : ee;
      const fe = +/* @__PURE__ */ new Date(), Ge = NA(), gA = gn(Ge), rA = {
        method: "POST",
        url: `${this._baseUrl}/content/strings?moduleId=${ee}`,
        headers: {
          authorization: he.authorization,
          token: he.token,
          t: fe,
          id: pe,
          "x-asurion-client": Ge,
          "x-asurion-cc": gA.code
        },
        data: JSON.stringify({
          moduleId: ee,
          sectionId: $,
          pathId: `${Ge}-${k}`,
          partnerId: Ge,
          value: M,
          usage: "static",
          autoPublish: "true"
        })
      };
      if (ee === "myAsurionAuth") {
        const P = this.generateGetHeaders(
          "/api/v1/content/strings",
          this._hmacKey,
          "POST"
        );
        rA.headers = P;
      }
      return await ii(rA), !0;
    }
    async updateString(M, k, $, ee, he) {
      var rA;
      const pe = +/* @__PURE__ */ new Date(), fe = NA(), Ge = gn(fe), JA = {
        method: "PUT",
        url: `${this._baseUrl}/content/strings`,
        headers: {
          authorization: ee.authorization,
          token: ee.token,
          t: pe,
          id: he,
          "x-asurion-client": fe,
          "x-asurion-cc": Ge.code
        },
        data: JSON.stringify({
          entryId: k,
          value: M,
          language: $,
          partnerId: fe
        })
      };
      try {
        const P = await ii(JA);
        if (P.data && ((rA = P.data) != null && rA.body))
          return {
            isUpdated: !0,
            body: P.data.body
          };
        throw "String update failed";
      } catch {
        return {
          isUpdated: !0,
          body: void 0
        };
      }
    }
    get config() {
      return this._config = {
        baseUrl: this._baseUrl,
        hmacKey: this._hmacKey,
        authorization: this._authorization,
        token: this._token,
        profileId: this._profileId,
        moduleId: this._moduleId
      }, this._config;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    persistString(M) {
      throw new Error("Method not implemented.");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    persistStrings(M) {
      throw new Error("Method not implemented.");
    }
    setInitCallback(M) {
      if (this._initializedCallback = M, this._moduleId === "myAsurionAuth") {
        if (this.config !== null && this.config.moduleId !== "")
          try {
            this._initializedCallback(this.config);
          } catch {
          }
      } else if (this.config !== null && this.config.moduleId !== "" && this.config.authorization !== "")
        try {
          this._initializedCallback(this.config);
        } catch {
        }
    }
    setConfig(M) {
      if (this._config = M, this._authorization === "" && (this._authorization = (M == null ? void 0 : M.authorization) || ""), this._baseUrl === "" && (this._baseUrl = (M == null ? void 0 : M.baseUrl) || ""), this._hmacKey === "" && (this._hmacKey = (M == null ? void 0 : M.hmacKey) || ""), this._moduleId === "" && (this._moduleId = (M == null ? void 0 : M.moduleId) || ""), this._profileId === "" && (this._profileId = (M == null ? void 0 : M.profileId) || ""), this._token === "" && (this._token = (M == null ? void 0 : M.token) || ""), this._isDevToolsEnabled = (M == null ? void 0 : M.isDevToolsEnabled) ?? !1, this._initializedCallback !== null)
        try {
          this._initializedCallback(this._config);
        } catch {
        }
    }
  }
  e.MyAsurionLocalizationStore = o;
  let u = null, l = null, c = null, f = null, d = null, h = null, p = null, v = null, y = null, g = null, B = null, w = null, m = null, x = null, C = null, E = null, T = null, S = null;
  function b(L, M, k, $) {
    return u === null && (u = new n(
      L,
      M,
      k,
      $,
      $,
      $
    )), u;
  }
  e.getStringManager = b;
  function N(L, M, k, $) {
    return l === null && (l = new n(
      L,
      M,
      "zh-Hant-TW",
      $,
      $,
      $
    )), l;
  }
  e.getZhStringManager = N;
  function O(L, M, k, $) {
    return c === null && (c = new n(
      L,
      M,
      "th-TH",
      $,
      $,
      $
    )), c;
  }
  e.getThStringManager = O;
  function V(L, M, k, $) {
    return f === null && (f = new n(
      L,
      M,
      "ko-KR",
      $,
      $,
      $
    )), f;
  }
  e.getKoStringManager = V;
  function I(L, M, k, $) {
    return d === null && (d = new n(
      L,
      M,
      "ms-MY",
      $,
      $,
      $
    )), d;
  }
  e.getMyStringManager = I;
  function _(L, M, k, $) {
    return h === null && (h = new n(
      L,
      M,
      k,
      $,
      $,
      $
    )), h;
  }
  e.getGlobalStringManager = _;
  function K(L, M, k, $) {
    return p === null && (p = new n(
      L,
      M,
      "zh-Hant-TW",
      $,
      $,
      $
    )), p;
  }
  e.getZhGlobalStringManager = K;
  function Y(L, M, k, $) {
    return v === null && (v = new n(
      L,
      M,
      "th-TH",
      $,
      $,
      $
    )), v;
  }
  e.getThGlobalStringManager = Y;
  function X(L, M, k, $) {
    return y === null && (y = new n(
      L,
      M,
      "ko-KR",
      $,
      $,
      $
    )), y;
  }
  e.getKoGlobalStringManager = X;
  function R(L, M, k, $) {
    return g === null && (g = new n(
      L,
      M,
      "ms-MY",
      $,
      $,
      $
    )), g;
  }
  e.getMyGlobalStringManager = R;
  function U(L, M, k) {
    return M === "global" ? (w === null && (w = new a(L, M, k)), w) : (B === null && (B = new a(L, M, k)), B);
  }
  e.getScriptManager = U;
  function H(L, M, k, $, ee) {
    return S === null && (S = new i(), S.addStringManager("en-US", L), S.addStringManager("zh-Hant-TW", M), S.addStringManager("th-TH", k), S.addStringManager("ko-KR", $), S.addStringManager("ms-MY", ee)), S;
  }
  e.getLanguageManager = H;
  function D(L, M, k, $, ee) {
    return m === null && (m = new o(
      L.apiUrl,
      L.hmacKey,
      M.authorization,
      M.token,
      k,
      $,
      ee
    )), m;
  }
  e.getDataStore = D;
  function Q(L, M, k, $, ee) {
    return x === null && (x = new o(
      L.apiUrl,
      L.hmacKey,
      M.authorization,
      M.token,
      k,
      $,
      ee
    )), x;
  }
  e.getZhDataStore = Q;
  function j(L, M, k, $, ee) {
    return C === null && (C = new o(
      L.apiUrl,
      L.hmacKey,
      M.authorization,
      M.token,
      k,
      $,
      ee
    )), C;
  }
  e.getThDataStore = j;
  function z(L, M, k, $, ee) {
    return E === null && (E = new o(
      L.apiUrl,
      L.hmacKey,
      M.authorization,
      M.token,
      k,
      $,
      ee
    )), E;
  }
  e.getKoDataStore = z;
  function re(L, M, k, $, ee) {
    return T === null && (T = new o(
      L.apiUrl,
      L.hmacKey,
      M.authorization,
      M.token,
      k,
      $,
      ee
    )), T;
  }
  e.getMyDataStore = re;
  function Z(L) {
    return L === "zh-Hant-TW" ? l : L === "th-TH" ? c : L === "ko-KR" ? f : L === "ms-MY" ? d : u;
  }
  e.getStringManagerInstance = Z;
  function ve(L) {
    m = D(
      L.apiEnv,
      L.authToken,
      L.profileId,
      L.moduleId,
      L.isDevToolsEnabled
    ), m.setConfig({
      baseUrl: L.apiEnv.apiUrl,
      hmacKey: L.apiEnv.hmacKey,
      authorization: L.authToken.authorization,
      token: L.authToken.token,
      profileId: L.profileId,
      moduleId: L.moduleId,
      partnerId: L.partnerId,
      isDevToolsEnabled: L.isDevToolsEnabled
    }), x = Q(
      L.apiEnv,
      L.authToken,
      L.profileId,
      L.moduleId,
      L.isDevToolsEnabled
    ), x.setConfig({
      baseUrl: L.apiEnv.apiUrl,
      hmacKey: L.apiEnv.hmacKey,
      authorization: L.authToken.authorization,
      token: L.authToken.token,
      profileId: L.profileId,
      moduleId: L.moduleId,
      partnerId: L.partnerId,
      isDevToolsEnabled: L.isDevToolsEnabled
    }), C = j(
      L.apiEnv,
      L.authToken,
      L.profileId,
      L.moduleId,
      L.isDevToolsEnabled
    ), C.setConfig({
      baseUrl: L.apiEnv.apiUrl,
      hmacKey: L.apiEnv.hmacKey,
      authorization: L.authToken.authorization,
      token: L.authToken.token,
      profileId: L.profileId,
      moduleId: L.moduleId,
      partnerId: L.partnerId,
      isDevToolsEnabled: L.isDevToolsEnabled
    }), E = z(
      L.apiEnv,
      L.authToken,
      L.profileId,
      L.moduleId,
      L.isDevToolsEnabled
    ), E.setConfig({
      baseUrl: L.apiEnv.apiUrl,
      hmacKey: L.apiEnv.hmacKey,
      authorization: L.authToken.authorization,
      token: L.authToken.token,
      profileId: L.profileId,
      moduleId: L.moduleId,
      partnerId: L.partnerId,
      isDevToolsEnabled: L.isDevToolsEnabled
    }), T = re(
      L.apiEnv,
      L.authToken,
      L.profileId,
      L.moduleId,
      L.isDevToolsEnabled
    ), T.setConfig({
      baseUrl: L.apiEnv.apiUrl,
      hmacKey: L.apiEnv.hmacKey,
      authorization: L.authToken.authorization,
      token: L.authToken.token,
      profileId: L.profileId,
      moduleId: L.moduleId,
      partnerId: L.partnerId,
      isDevToolsEnabled: L.isDevToolsEnabled
    }), u = b(
      L.partnerId,
      L.moduleId,
      "en-US",
      m
    ), l = N(
      L.partnerId,
      L.moduleId,
      "zh-Hant-TW",
      x
    ), c = O(
      L.partnerId,
      L.moduleId,
      "th-TH",
      C
    ), f = V(
      L.partnerId,
      L.moduleId,
      "ko-KR",
      C
    ), d = I(
      L.partnerId,
      L.moduleId,
      "ms-MY",
      T
    ), H(
      u,
      l,
      c,
      f,
      d
    );
  }
  e.initializeLocalization = ve;
})(Qe || (Qe = {}));
const Rm = Kt({
  language: "en-US",
  updateActiveLanguage: () => {
  },
  module: "myAsurionShared",
  isEnabled: !1,
  updateIsEnabled: () => {
  },
  apiEnv: { hmacKey: "", apiUrl: "" },
  isEditingMode: !1,
  updateIsEditingMode: () => {
  },
  isDevToolsOpen: !1,
  updateIsDevToolsOpen: () => {
  },
  isDevToolsEnabled: !1,
  updateIsDevToolsEnabled: () => {
  },
  isTranslationsLoading: !1,
  updateIsTranslationsLoading: () => {
  },
  isKeyShown: !1,
  setIsKeyShown: () => {
  }
}), GS = ({
  children: e,
  moduleId: A,
  isEnabled: t = !1,
  apiEnv: r
}) => {
  const [n, a] = Ue("en-US"), [i, s] = Ue(t), [o, u] = Ue(!1), [l, c] = Ue(!1), [f, d] = Ue(!1), [h, p] = Ue(!1), [v, y] = Ue(!1);
  if (!t)
    return /* @__PURE__ */ F.jsx(F.Fragment, { children: e });
  const [{ authorization: g, token: B, id: w }] = Q0({
    authorization: "",
    token: "",
    id: ""
  }), m = NA(), x = AF(m), [C, E] = Im(
    "al",
    x ?? "en-US"
    // NOTE: set defaultLanguage as activeLanguage if value is configured
  );
  return Re(() => {
    a(C ?? "en-US");
  }, []), Re(() => {
    E(n);
  }, [n]), Re(() => {
    x && !C && a(x);
  }, [x, C]), Re(() => {
    w && Qe.initializeLocalization({
      partnerId: m,
      moduleId: A,
      apiEnv: r,
      authToken: { authorization: g, token: B },
      profileId: w,
      isDevToolsEnabled: f
    });
  }, [g, B, w, f]), /* @__PURE__ */ F.jsx(
    Rm.Provider,
    {
      value: {
        language: n,
        updateActiveLanguage: a,
        module: A,
        isEnabled: i,
        updateIsEnabled: s,
        apiEnv: r,
        isEditingMode: o,
        updateIsEditingMode: u,
        isDevToolsOpen: l,
        updateIsDevToolsOpen: c,
        isDevToolsEnabled: f,
        updateIsDevToolsEnabled: d,
        isTranslationsLoading: h,
        updateIsTranslationsLoading: p,
        isKeyShown: v,
        setIsKeyShown: y
      },
      children: /* @__PURE__ */ F.jsx(nF, { flexFlow: "row nowrap", children: /* @__PURE__ */ F.jsx(ta, { as: "div", id: "translation-ctx", w: "full", flex: "1", children: e }) })
    }
  );
}, _Ae = new E0({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
}), VS = iF(({ colorScheme: e }) => e === "brand" ? {
  bg: "brand.black",
  border: "none",
  color: "white",
  px: 5,
  py: 3,
  borderRadius: "lg",
  fontWeight: "bold",
  lineHeight: "base",
  minH: 12,
  _hover: {
    bg: "brand.neutral.deeper",
    _disabled: {
      bg: "brand.neutral.bright"
    }
  },
  _disabled: {
    // bg: 'brand.neutral.bright',
    bg: "#E6E6EB",
    // color: 'brand.neutral.deep',
    color: "#A5AAAF",
    borderColor: "brand.neutral.deep",
    opacity: 1
  }
} : {}), WS = aF({
  variants: { solid: VS },
  defaultProps: {
    colorScheme: "brand"
  }
}), { definePartsStyle: Nm, defineMultiStyleConfig: YS } = QE(
  fF.keys
), zS = Nm({
  field: {
    paddingX: "12px",
    paddingY: "17.5px",
    height: {
      md: "56px"
    },
    _placeholder: {
      color(e) {
        return e.colors.brand.neutral.deeper;
      }
    }
  }
}), XS = Nm({
  field: {
    borderColor(e) {
      return e.colors.brand.neutral.deep;
    },
    _hover: {
      borderColor(e) {
        return e.colors.brand.neutral.deeper;
      }
    }
  }
}), qS = {
  ...YS({
    baseStyle: zS,
    variants: {
      outline: XS
    }
  }),
  defaultProps: {
    focusBorderColor: "brand.black"
  }
}, JS = {
  initialColorMode: "light",
  useSystemColorMode: !1
}, ZS = {
  global: {
    html: {
      // height: '100%',
      scrollBehavior: "smooth",
      colorScheme: "only light !important",
      overscrollBehavior: "none",
      WebkitTapHighlightColor: "rgba(255, 255, 255, 0)"
    },
    body: {
      bg: "#FFFFFF",
      overscrollBehavior: "none",
      color: "primaryText"
    },
    ":root": {
      colorScheme: "only light !important"
    }
  }
}, Ep = NA(), wr = Vv({
  config: JS,
  styles: ZS,
  fonts: {
    heading: Ep === "maxis" ? "Maxis, sans-serif" : "'Apercu Pro', ApercuPro, sans-serif",
    // TODO: EWWWWWW dont do this
    body: Ep === "maxis" ? "Maxis, sans-serif" : "'Apercu Pro', ApercuPro, sans-serif"
  },
  semanticTokens: {
    colors: {
      "chakra-body-text": {
        _light: "#000000"
      },
      brand: {
        valid: "#008662",
        invalid: "#DB1B1B"
      }
    }
  },
  colors: {
    primary: { 500: "#8223D2" },
    onPrimary: { 500: "#8223D2" },
    // Change to scale instead?
    brand: {
      border: "#D5D6DA",
      black: "#000000",
      tertiary: "#333333",
      secondary: "#6E767D",
      bg: "#F0F0F5",
      neutral: {
        deep: "#A5AAAF",
        deeper: "#6E767D",
        bright: "#E6E6EB",
        brightest: "#F0F0F5"
      }
    }
  },
  components: {
    Input: qS,
    Button: WS,
    Container: {
      baseStyle: {
        maxW: "container.sm"
      }
    },
    Code: {
      baseStyle: {
        padding: "16px",
        fontSize: "xs"
      }
    },
    Heading: {
      variants: {
        storyTitle: {
          color: "primary.500",
          fontSize: "3xl",
          fontWeight: 700
        }
      }
    },
    Text: {
      defaultProps: {
        color: "primaryText"
      },
      variants: {
        storyField: {
          fontSize: "large",
          color: "primary.500",
          textAlign: "left"
        }
      }
    }
  },
  breakpoints: {
    base: "0em",
    // 0px
    xsm: "23.4375em",
    // 375px
    sm: "30em",
    // ~480px. em is a relative unit and is dependant on the font-size.
    md: "48em",
    // ~768px
    lg: "62em",
    // ~992px
    xl: "80em",
    // ~1280px
    "2xl": "96em"
    // ~1536px
  }
}), eU = ({
  children: e,
  themeOverride: A = {}
}) => {
  const { data: t, isLoading: r } = yt(), n = xn(() => {
    var u, l;
    const { colors: a, baseComponents: i } = (t == null ? void 0 : t.theme) || {}, s = Object.fromEntries(
      Object.entries(i || {}).map(([c, f]) => {
        var d, h;
        return [
          c,
          {
            baseStyle: {
              ...((h = (d = wr == null ? void 0 : wr.components) == null ? void 0 : d[c]) == null ? void 0 : h.baseStyle) || {},
              ...f
            }
          }
        ];
      })
    ), o = {
      ...wr.components,
      ...s
    };
    return Vv({
      ...wr,
      colors: {
        ...wr.colors,
        primary: Sh(((u = A == null ? void 0 : A.color) == null ? void 0 : u.primary) || (a == null ? void 0 : a.primary)),
        onPrimary: Sh(
          ((l = A == null ? void 0 : A.color) == null ? void 0 : l.onPrimary) || (a == null ? void 0 : a.onPrimary)
        ),
        primaryText: a == null ? void 0 : a.bodyTextColor
      },
      semanticTokens: {
        ...wr.semanticTokens,
        colors: {
          ...wr.semanticTokens.colors,
          ...t.theme.colors.bodyTextColor ? {
            "chakra-body-text": {
              _light: t.theme.colors.bodyTextColor || "#000000"
            }
          } : {}
        }
      },
      components: o
    });
  }, [t]);
  return /* @__PURE__ */ F.jsx(IE, { theme: n, children: r && (t == null ? void 0 : t.local) === "true" ? /* @__PURE__ */ F.jsx(Wv, { h: "100vh", children: /* @__PURE__ */ F.jsx(b0, { size: "lg" }) }) : e });
}, AU = "configStart", tU = "configData", rU = 36e5, nU = [
  { code: "EN", locale: "en-US", name: "English" },
  { code: "CN", locale: "zh-Hant-TW", name: "Chinese" },
  { code: "TH", locale: "th-TH", name: "Thai" },
  { code: "KO", locale: "ko-KR", name: "Korean" },
  { code: "MY", locale: "ms-MY", name: "Bahasa" }
], an = {
  local: "true",
  partner: "myasurion",
  program: "myasurion",
  features: {},
  urls: {
    profile: "profile"
  },
  languagesAvailable: [{ code: "EN", locale: "en-US", name: "English" }],
  languages: [
    {
      code: "EN",
      name: "English"
    },
    {
      code: "CN",
      name: "Chinese"
    },
    {
      code: "TH",
      name: "Thai"
    },
    {
      code: "KO",
      name: "Korean"
    },
    {
      code: "MY",
      name: "Bahasa"
    }
  ],
  mainMenu: [
    {
      name: "Tech care preferences",
      code: "techcare",
      url: "profile/techcare"
    },
    {
      name: "Notifications",
      code: "notifications",
      url: "profile/notifications"
    },
    {
      name: "Share feedback",
      code: "feedback",
      url: "profile/feedback"
    }
  ],
  theme: {
    logo: "/images/carriers/asurion/asurion-logo.svg",
    header: {
      logo: "/images/carriers/asurion/asurion.svg",
      bg: "white"
    },
    notification: {
      discount: "/images/carriers/asurion/discount.svg",
      exclusives: "/images/carriers/asurion/exclusives.svg",
      newstuff: "/images/carriers/asurion/new-stuff.svg",
      order: "/images/carriers/asurion/order.svg"
    },
    colors: {
      primary: "#8223D2",
      onPrimary: "#8223D2",
      accent: "#8223D2",
      bannerGradient: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5"
    },
    components: {
      profileBanner: {
        bg: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5"
      },
      serviceRequestBtn: {
        w: "full",
        minW: "287px",
        p: "12px 20px",
        colorScheme: "primary",
        variant: "solid"
      },
      chat: {
        headerBg: "linear-gradient(225deg, #8223D2 33.33%, #6B8BFF 100%), #F0F0F5",
        headerColor: "white",
        btnTxtColor: "#09411D",
        chatIcon: "/images/carriers/asurion/expert-default-mid.png",
        sendIcon: "/images/carriers/asurion/chat-send.svg",
        agentIcon: "/images/carriers/asurion/agent-chat-icon.svg",
        thankYouIcon: "/images/carriers/asurion/chat-thankyou.svg"
      }
    }
  }
}, km = Kt({
  data: an,
  isLoading: !1,
  refetchConfig: async () => ({}),
  updateConfig: () => {
  },
  saveConfig: () => {
  },
  conf: { hmacKey: "", url: "", baseApi: "" },
  isInit: !1
});
Kt({
  config: an
});
const aU = async ({
  url: e,
  hmacKey: A = ""
}) => {
  const t = NA(), r = gn(t), n = +/* @__PURE__ */ new Date(), a = jE(n), i = GE(e), s = VE(
    {
      httpPath: i,
      token: a
    },
    A
  );
  return await (await fetch(e || `/configs/${t}.json`, {
    headers: {
      "x-api-key": "some-key",
      "x-asurion-client": t,
      "x-asurion-cc": r.code,
      token: a,
      t: n,
      // TODO: is it okay if this is a string to avoid type error?
      authorization: s
    }
  })).json();
}, iU = async ({
  url: e,
  authToken: A,
  dataConfig: t
}) => {
  const r = NA(), n = gn(r), a = +/* @__PURE__ */ new Date(), s = await (await fetch(e ? `${e}/config` : "/config", {
    method: "POST",
    headers: {
      "x-api-key": "some-key",
      "x-asurion-client": r,
      "x-asurion-cc": n.code,
      token: A.token,
      t: a,
      // TODO: is it okay if this is a string to avoid type error?
      authorization: A.authorization,
      id: A.id
    },
    body: JSON.stringify({
      configurationName: `config-${r}`,
      content: t
    })
  })).json();
  return console.log("Config is fetching from remote", s), s;
}, sU = ({
  queryClient: e,
  // TODO: no need to pass queryClient, we can use useQueryClient instead.
  url: A,
  headers: t,
  hmacKey: r,
  baseApi: n
}) => {
  const a = NA(), [i, s] = Uh(AU, 0), [o, u] = Uh(
    tU,
    void 0
  ), [l, c] = Ue(!1), f = xn(() => !o || (o == null ? void 0 : o.partner) !== a ? !0 : Date.now() - i > rU, [i]), { isFetching: d, refetch: h } = C0({
    queryKey: ["config", a],
    queryFn: () => aU({ url: A, headers: t, hmacKey: r }),
    enabled: !!a && f,
    onSuccess: (y) => {
      s(Date.now()), y != null && y.body ? u(y == null ? void 0 : y.body) : (e.setQueryData(["config", A], an), u(an));
    },
    onError: () => {
      console.error(
        `Cannot fetch config for carrier ${a}. Using default configuration instead.`
      ), e.setQueryData(["config", A], an), s(Date.now()), u(an);
    },
    onSettled: () => {
      c(!0);
    }
  }), p = _e(
    (y) => {
      u(y), s(Date.now());
    },
    [u]
  ), { mutate: v } = BE({
    mutationFn: iU,
    onSuccess: () => {
      console.log("saved config");
    }
  });
  return {
    data: o ?? an,
    isLoading: A && f ? d : !1,
    refetchConfig: h,
    updateConfig: p,
    saveConfig: v,
    conf: { hmacKey: r, url: A, baseApi: n },
    isInit: l
  };
}, oU = ({ env: e, children: A }) => {
  const t = e.apiBaseUrl, r = NA(), n = t ? `${t}/config?configurationName=config-${r}` : void 0, a = sU({
    url: n,
    queryClient: Pm,
    hmacKey: e.hmacKey || "",
    baseApi: t
  });
  return /* @__PURE__ */ F.jsx(km.Provider, { value: { module: e == null ? void 0 : e.moduleId, ...a }, children: /* @__PURE__ */ F.jsx(eU, { children: A }) });
}, Pm = new E0({
  defaultOptions: {
    queries: {
      retry: !1,
      refetchOnWindowFocus: !1
    }
  }
});
WE();
const QAe = ({ env: e, children: A, config: t }) => {
  const r = e == null ? void 0 : e.baseUrl;
  return /* @__PURE__ */ F.jsx(vE, { client: Pm, children: /* @__PURE__ */ F.jsx(bE, { basename: r, children: /* @__PURE__ */ F.jsx(oU, { env: e, children: /* @__PURE__ */ F.jsx(xE, { fallback: /* @__PURE__ */ F.jsx(W1, {}), children: /* @__PURE__ */ F.jsx(eF, { config: t, children: /* @__PURE__ */ F.jsx(mF, { config: t, children: /* @__PURE__ */ F.jsx(
    P1,
    {
      apiKey: e == null ? void 0 : e.apiKey,
      apiBaseUrl: e == null ? void 0 : e.apiBaseUrl,
      children: /* @__PURE__ */ F.jsx(cb, { children: /* @__PURE__ */ F.jsx(
        GS,
        {
          moduleId: (e == null ? void 0 : e.moduleId) || "myAsurionShared",
          isEnabled: (e == null ? void 0 : e.enableTranslations) ?? !1,
          apiEnv: {
            hmacKey: e.hmacKey,
            apiUrl: e.apiBaseUrl
          },
          children: /* @__PURE__ */ F.jsx(
            Y1,
            {
              config: t,
              baseApiConfig: {
                baseEndpoint: e.apiBaseUrl,
                apiKey: e == null ? void 0 : e.apiKey
              },
              children: /* @__PURE__ */ F.jsx(sF, { config: t, children: A })
            }
          )
        }
      ) })
    }
  ) }) }) }) }) }) });
}, va = /* @__PURE__ */ new Map();
va.set("myAsurionPortal", "/portal");
va.set("myAsurionSRSwap", "/swap");
va.set("myAsurionAuth", "/login");
va.set("myAsurionProfile", "/profile");
va.set("myAsurionArticle", "/articles");
const uU = (e) => va.get(e), yt = () => {
  const e = Pt(km);
  if (e === void 0)
    throw new Error("useConfig must be used within a ConfigProvider");
  const A = qo();
  function t(r) {
    var a;
    let n;
    try {
      n = Object.fromEntries(
        (a = Object.entries(r)) == null ? void 0 : a.map(([i, s]) => {
          const o = A === "repair" ? uU(e.module ?? "myAsurionPortal") : "";
          return typeof s == "object" && s !== null ? Array.isArray(s) ? [
            i,
            s.map((u) => (typeof u == "string" && u.startsWith("/images/") && o + u, u))
          ] : [i, t(s)] : typeof s == "string" && s.startsWith("/images/") ? [i, o + s] : [i, s];
        })
      );
    } catch {
      n = r;
    }
    return n;
  }
  return {
    ...e,
    data: t(e.data)
  };
};
var Fp;
((e) => {
  let A = null;
  class t {
    constructor(n) {
      ce(this, "_config");
      ce(this, "_app");
      ce(this, "_remoteConfig");
      ce(this, "_isActivated", !1);
      this._config = n, this._app = this._initialize(n), this._remoteConfig = YE(this._app), this._remoteConfig.settings.minimumFetchIntervalMillis = 3e3, this._remoteConfig.defaultConfig = {}, Ta(this._remoteConfig);
    }
    async fetchAndActivate(n) {
      await Ta(n), this._isActivated = !0;
    }
    _initialize(n) {
      return zE(n ?? this._config);
    }
    getValue(n) {
      return this._isActivated === !1 && Ta(this._remoteConfig), XE(this._remoteConfig, n);
    }
    async fetchValue(n) {
      return await Ta(this._remoteConfig), this.getValue(n);
    }
    async fetchAll() {
      return await Ta(this._remoteConfig), qE(this._remoteConfig);
    }
  }
  e.MARemoteConfig = t, e.initializeRemoteConfig = (r) => {
    A || (A = new t(r));
  }, e.getConfigValue = (r) => {
    if (A)
      return A.getValue(r);
  }, e.fetchValue = (r) => {
    if (A)
      return A.fetchValue(r);
  }, e.fetchAll = () => {
    if (A)
      return A.fetchAll();
  };
})(Fp || (Fp = {}));
const lU = "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZmlsbD0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjAiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGhlaWdodD0iMWVtIiB3aWR0aD0iMWVtIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0yNTcuNyA3NTJjMiAwIDQtLjIgNi0uNUw0MzEuOSA3MjJjMi0uNCAzLjktMS4zIDUuMy0yLjhsNDIzLjktNDIzLjlhOS45NiA5Ljk2IDAgMCAwIDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAgMCA5LjQgMjkuOGM2LjYgNi40IDE0LjkgOS45IDIzLjggOS45em02Ny40LTE3NC40TDY4Ny44IDIxNWw3My4zIDczLjMtMzYyLjcgMzYyLjYtODguOSAxNS43IDE1LjYtODl6TTg4MCA4MzZIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzNmMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtMzZjMC0xNy43LTE0LjMtMzItMzItMzJ6Ij48L3BhdGg+PC9zdmc+", cU = ({ handleSave: e, handleCancel: A }) => {
  const { isEditing: t, getSubmitButtonProps: r, getCancelButtonProps: n } = DE();
  return t ? /* @__PURE__ */ F.jsxs(
    TE,
    {
      justifyContent: "end",
      size: "xs",
      w: "max-content",
      spacing: "0.5",
      mt: 0,
      flex: "1",
      borderRadius: "5px",
      variant: "teal",
      py: "2",
      children: [
        /* @__PURE__ */ F.jsx(
          co,
          {
            "aria-label": "Check icon",
            icon: /* @__PURE__ */ F.jsx(SE, {}),
            size: "xs",
            variant: "outline",
            colorScheme: "teal",
            ...r({ onClick: e })
          }
        ),
        /* @__PURE__ */ F.jsx(
          co,
          {
            "aria-label": "Close icon",
            icon: /* @__PURE__ */ F.jsx($v, { boxSize: 2 }),
            size: "xs",
            variant: "outline",
            colorScheme: "teal",
            ...n({ onClick: A })
          }
        )
      ]
    }
  ) : null;
}, of = (e = null) => {
  if (e && e !== null) {
    const [A, t] = e.split("/");
    return [A, t];
  } else
    return [null, null];
}, Y0 = async (e, A, t, r, n, a, i, s, o, u, l) => {
  const [c, f] = of(A);
  let d = "";
  if (c !== null && f !== null) {
    if (l && l.length > 0)
      for (let h = 0; h < l.length; h++) {
        const p = await bp(
          e,
          A,
          c,
          t,
          // groupId?.toLowerCase() === 'global' ? 'global' : module,
          l[h],
          n,
          a,
          { ...i, profileId: a.id ?? i.profileId },
          s,
          o,
          u
        );
        l[h] === r && (d = p);
      }
    (!l || !(l != null && l.includes(r))) && (d = await bp(
      e,
      A,
      c,
      t,
      // groupId?.toLowerCase() === 'global' ? 'global' : module,
      r,
      n,
      a,
      { ...i, profileId: a.id ?? i.profileId },
      s,
      o,
      u
    ));
  }
  return et(d, u ?? []);
}, bp = async (e, A, t, r, n, a, i, s, o, u, l) => {
  let c, f, d;
  n === "zh-Hant-TW" ? d = Qe.getZhStringManager(
    o,
    r,
    n,
    Qe.getDataStore(
      a,
      i,
      s.profileId,
      r,
      u
    )
  ) : n === "th-TH" ? d = Qe.getThStringManager(
    o,
    r,
    n,
    Qe.getDataStore(
      a,
      i,
      s.profileId,
      r,
      u
    )
  ) : n === "ko-KR" ? d = Qe.getKoStringManager(
    o,
    r,
    n,
    Qe.getDataStore(
      a,
      i,
      s.profileId,
      r,
      u
    )
  ) : n === "ms-MY" ? d = Qe.getMyStringManager(
    o,
    r,
    n,
    Qe.getDataStore(
      a,
      i,
      s.profileId,
      r,
      u
    )
  ) : d = Qe.getStringManager(
    o,
    r,
    n,
    Qe.getDataStore(
      a,
      i,
      s.profileId,
      r,
      u
    )
  );
  const h = Qe.getScriptManager(
    o,
    (t == null ? void 0 : t.toLowerCase()) === "global" ? "global" : r,
    n
  );
  f = h.getScript(A, n), f || (f = h.createScript(
    e,
    A,
    t,
    (t == null ? void 0 : t.toLowerCase()) === "global" ? "global" : r,
    n,
    o,
    l
  ));
  const p = await d.getGroup(t);
  return p === null ? c = null : c = p.getString(`${o}-${A}`), (c === null || !c) && (n === "en-US" && await d.createString(
    e,
    A,
    t,
    r,
    i,
    s,
    o
  ), c = new Qe.String(A, null, p), c.content = e || "", c.onUpdateListener = fU, p && p.addString(c)), (c == null ? void 0 : c.content) || e;
}, fU = (e, A) => {
  let t;
  switch (e) {
    case "string.updated":
      t = A[0];
      break;
    default:
      t = "(loading)";
      break;
  }
  return t;
}, dU = (e) => {
  let A;
  switch (e) {
    case "initial":
      A = "#eaf3ff";
      break;
    case "modified":
      A = "#FEEBC8";
      break;
    case "changed":
      A = "#ceecff";
      break;
    case "failed":
      A = "#FFB6C1";
      break;
    default:
      A = Yv("gray.100", "gray.600");
      break;
  }
  return A;
}, et = (e, A) => !A || A.length === 0 ? e : e.replace(
  /\{(\d+)\}/g,
  (t, r) => typeof A[r - 1] < "u" ? A[r - 1] : `{${r}}`
), QA = ({
  text: e,
  translationKey: A,
  dynamicValues: t = [],
  isFull: r = !1,
  module: n
}) => {
  var K;
  const [a, i] = Ue(et(e, t)), [s, o] = Ue(""), [u, l] = Ue("initial"), [c, f] = Ue(e), d = OE(), { data: h } = yt(), { languagesAvailable: p } = h, [v] = Q0({
    authorization: "",
    token: "",
    id: ""
  }), [y] = _0({
    profileId: "",
    userId: ""
  }), {
    isEnabled: g,
    language: B,
    module: w,
    apiEnv: m,
    isEditingMode: x,
    isDevToolsOpen: C,
    isDevToolsEnabled: E,
    updateIsTranslationsLoading: T,
    isKeyShown: S
  } = fu(), b = NA(), N = (Y) => {
    Y.key == "Enter" && O();
  }, O = async () => {
    const [Y, X] = of(A);
    try {
      if (Y === null && X === null)
        throw "No section id or string id provided";
      let R;
      B === "zh-Hant-TW" ? R = Qe.getZhStringManager(
        b,
        n ?? w,
        B,
        Qe.getDataStore(
          m,
          v,
          v.id ?? y.profileId,
          n ?? w,
          E
        )
      ) : B === "th-TH" ? R = Qe.getThStringManager(
        b,
        n ?? w,
        B,
        Qe.getDataStore(
          m,
          v,
          v.id ?? y.profileId,
          n ?? w,
          E
        )
      ) : B === "ko-KR" ? R = Qe.getKoStringManager(
        b,
        n ?? w,
        B,
        Qe.getDataStore(
          m,
          v,
          v.id ?? y.profileId,
          n ?? w,
          E
        )
      ) : B === "ms-MY" ? R = Qe.getMyStringManager(
        b,
        n ?? w,
        B,
        Qe.getDataStore(
          m,
          v,
          v.id ?? y.profileId,
          n ?? w,
          E
        )
      ) : R = Qe.getStringManager(
        b,
        n ?? w,
        B,
        Qe.getDataStore(
          m,
          v,
          v.id ?? y.profileId,
          n ?? w,
          E
        )
      );
      const U = Qe.getScriptManager(
        b,
        n ?? w,
        B
      );
      if (R === null)
        throw "No manager instance";
      const H = await R.getGroup(Y), D = H == null ? void 0 : H.getString(`${b}-${A}`);
      if (D == null || !D.internalId)
        throw "No string instance";
      if (l("modified"), a !== s) {
        const { isUpdated: Q } = await R.updateStringEntry(
          a,
          D.internalId,
          B,
          v,
          { profileId: v.id }
        );
        if (Q)
          l("changed"), U.updateScript(
            a,
            A,
            Y,
            "changed",
            B
          ), f(a), d({
            title: "Text saved successfully!",
            description: `${a} is successfully requested for change to locale ${B}`,
            status: "success",
            duration: 1500,
            isClosable: !0
          });
        else
          throw U.updateScript(
            a,
            A,
            Y,
            "failed",
            B
          ), "Failed update";
      } else
        l("initial");
    } catch (R) {
      l("failed"), d({
        title: "Error in saving entry",
        description: "Something went wrong" + R,
        status: "error",
        duration: 2e3,
        isClosable: !0
      });
    }
  }, V = () => {
    l("initial"), i(et(s, t));
  }, I = xn(
    () => {
      var Y;
      return (Y = Qe.getScriptManager(b, n ?? w, B).getScript(
        A,
        B
      )) == null ? void 0 : Y.script;
    },
    [
      (K = Qe.getScriptManager(b, n ?? w, B).getScript(
        A,
        B
      )) == null ? void 0 : K.script
    ]
  );
  if (Re(() => {
    g && (i(et(e, t)), T(!0), (async () => {
      var D, Q;
      const X = await Y0(
        e,
        A,
        n ?? w,
        B,
        m,
        v,
        y,
        b,
        E,
        t,
        p.map((j) => j == null ? void 0 : j.locale)
      ), R = Qe.getScriptManager(
        b,
        n ?? w,
        B
      ), [U, H] = of(A);
      H !== null && U !== null && R.updateScript(
        X,
        A,
        U,
        "initial",
        B
      ), i(et(X, t)), o(et(X, t)), R.getScript(A, B) && (i(
        et(
          ((D = R.getScript(A, B)) == null ? void 0 : D.script) ?? et(X, t),
          t
        )
      ), o(
        et(
          ((Q = R.getScript(A, B)) == null ? void 0 : Q.script) ?? et(X, t),
          t
        )
      )), T(!1);
    })());
  }, [B, g, E, A, JSON.stringify(t)]), Re(() => {
    var X;
    const Y = ((X = Qe.getScriptManager(b, n ?? w, B).getScript(
      A,
      B
    )) == null ? void 0 : X.script) ?? a;
    i(et(Y, t)), f(Y);
  }, [I, c, C, B, JSON.stringify(t)]), !g)
    return /* @__PURE__ */ F.jsx(F.Fragment, { children: e });
  if (g && !x)
    return /* @__PURE__ */ F.jsx(
      cl,
      {
        "aria-description": A,
        label: A,
        isDisabled: !E,
        children: /* @__PURE__ */ F.jsx("span", { "aria-description": A, children: S ? A : a })
      }
    );
  const _ = (Y) => {
    i(Y);
  };
  return /* @__PURE__ */ F.jsxs(
    HE,
    {
      defaultValue: e,
      value: a,
      onChange: _,
      isPreviewFocusable: !0,
      selectAllOnFocus: !1,
      id: "editable",
      display: "flex",
      flexFlow: "row nowrap",
      "aria-description": `editable-${A}`,
      children: [
        /* @__PURE__ */ F.jsx(
          cl,
          {
            label: `Translation Key: ${A}. Click to edit`,
            shouldWrapChildren: !0,
            children: /* @__PURE__ */ F.jsx(
              LE,
              {
                px: 1,
                py: 2,
                position: "relative",
                paddingRight: "25px",
                cursor: "text",
                minHeight: "32px",
                background: dU(u),
                _hover: {
                  background: Yv("gray.200", "gray.700"),
                  color: "black"
                },
                _after: {
                  content: '""',
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  width: "13px",
                  height: "13px",
                  backgroundImage: `url("${lU}")`,
                  backgroundSize: "cover"
                },
                w: "full"
              }
            )
          }
        ),
        /* @__PURE__ */ F.jsx(cl, { label: "Input here your proposed translation changes", children: /* @__PURE__ */ F.jsxs(
          Cn,
          {
            justifyContent: "center",
            alignItems: "center",
            height: "max-content",
            w: r ? "full" : "unset",
            children: [
              /* @__PURE__ */ F.jsx(
                zo,
                {
                  py: 1,
                  px: 1,
                  as: ME,
                  value: a,
                  onKeyDown: N,
                  w: r ? "full" : "unset"
                }
              ),
              /* @__PURE__ */ F.jsx(cU, { handleSave: O, handleCancel: V })
            ]
          }
        ) })
      ]
    }
  );
}, IAe = (e, A, t = "en-US", r = []) => (console.log("Called getTextScript:", t), (async () => {
  const a = Qe.getDataStore(
    { hmacKey: "", apiUrl: "" },
    { authorization: "", token: "" },
    "",
    "",
    !1
  ), i = NA();
  return new Promise((o) => {
    a.setInitCallback(async (u) => {
      await ((m) => new Promise((x) => setTimeout(x, m)))(100);
      const c = sessionStorage.getItem("al"), {
        authorization: f,
        baseUrl: d,
        hmacKey: h,
        moduleId: p,
        profileId: v,
        token: y,
        isDevToolsEnabled: g
      } = u, B = typeof c == "string" && (JSON.parse(c) === "en-US" || JSON.parse(c) === "zh-Hant-TW" || JSON.parse(c) === "th-TH" || JSON.parse(c) === "ko-KR" || JSON.parse(c) === "ms-MY") ? JSON.parse(c) ?? t : t, w = await Y0(
        A,
        e,
        p,
        B,
        { hmacKey: h, baseUrl: d },
        { authorization: f, token: y },
        { profileId: v },
        i,
        // { hmacKey, baseUrl },
        // { authorization, token },
        // { profileId }
        g,
        r
      );
      o(et(w, r));
    });
  });
})()), hU = (e, A) => !A || A.length === 0 ? e : e.replace(
  /\{(\d+)\}/g,
  (t, r) => typeof A[r - 1] < "u" ? A[r - 1] : `{${r}}`
), fu = () => {
  const e = Pt(Rm);
  if (e === void 0)
    throw new Error("useTextScript must be used within a TextScriptProvider");
  const A = (g, B, w = "en-US", m = []) => (async () => {
    const C = Qe.getDataStore(
      { hmacKey: "", apiUrl: "" },
      { authorization: "", token: "" },
      "",
      "",
      !1
    ), E = NA();
    return new Promise((S) => {
      C.setInitCallback(async (b) => {
        const N = w, {
          authorization: O,
          baseUrl: V,
          hmacKey: I,
          moduleId: _,
          profileId: K,
          token: Y,
          isDevToolsEnabled: X
        } = b, U = await Y0(
          B,
          g,
          _,
          N,
          { hmacKey: I, baseUrl: V },
          { authorization: O, token: Y },
          { profileId: K },
          E,
          // { hmacKey, baseUrl },
          // { authorization, token },
          // { profileId }
          X,
          m
        );
        S(hU(U, m));
      });
    });
  })(), {
    language: t,
    updateActiveLanguage: r,
    module: n,
    isEnabled: a,
    updateIsEnabled: i,
    apiEnv: s,
    isEditingMode: o,
    updateIsEditingMode: u,
    isDevToolsOpen: l,
    updateIsDevToolsOpen: c,
    isDevToolsEnabled: f,
    updateIsDevToolsEnabled: d,
    isTranslationsLoading: h,
    updateIsTranslationsLoading: p,
    isKeyShown: v,
    setIsKeyShown: y
  } = e;
  return {
    language: t,
    updateActiveLanguage: r,
    module: n,
    isEnabled: a,
    updateIsEnabled: i,
    apiEnv: s,
    isEditingMode: o,
    updateIsEditingMode: u,
    isDevToolsOpen: l,
    updateIsDevToolsOpen: c,
    isDevToolsEnabled: f,
    updateIsDevToolsEnabled: d,
    isTranslationsLoading: h,
    updateIsTranslationsLoading: p,
    getTextScript: A,
    isKeyShown: v,
    setIsKeyShown: y
  };
}, pU = Kt({
  entries: [],
  updateEntry: async () => {
  },
  updateLocaleLanguage: () => {
  },
  localeLanguage: "en-US",
  getTextEntry: () => ({ textEntry: "", entryId: "" }),
  localModule: void 0,
  setLocalModule: () => {
  },
  isTranslationsActive: !1,
  setIsTranslationsActive: () => {
  },
  translationAPI: { api: null, authorization: "", token: "" }
}), nc = () => {
  const e = Pt(pU);
  if (e === void 0)
    throw new Error("useLocalization must be used within a TranslationProvider");
  const {
    entries: A,
    localeLanguage: t,
    updateLocaleLanguage: r,
    getTextEntry: n,
    updateEntry: a,
    setLocalModule: i,
    isTranslationsActive: s,
    setIsTranslationsActive: o,
    translationAPI: u
  } = e;
  return {
    entries: A,
    localeLanguage: t,
    updateLocaleLanguage: r,
    getTextEntry: n,
    updateEntry: a,
    setLocalModule: i,
    isTranslationsActive: s,
    setIsTranslationsActive: o,
    translationAPI: u
  };
}, gU = () => {
  const e = Ut(!1);
  return [() => {
    if (typeof document > "u")
      return;
    const r = document.documentElement, { body: n } = document;
    if (!n || !n.style || e.current)
      return;
    const a = window.innerWidth - r.clientWidth, i = parseInt(window.getComputedStyle(n).getPropertyValue("padding-right")) || 0;
    r.style.position = "relative", n.style.position = "relative", r.style.overflow = "hidden", n.style.overflow = "hidden", n.style.paddingRight = `${i + a}px`, e.current = !0;
  }, () => {
    if (typeof document > "u")
      return;
    const r = document.documentElement, { body: n } = document;
    !n || !n.style || !e.current || (r.style.position = "", r.style.overflow = "", n.style.position = "", n.style.overflow = "", n.style.paddingRight = "", e.current = !1);
  }];
}, BU = (e = "", A = "", t = "", r = "", n) => {
  const [a, i] = Ue(null), [s, o] = Ue(!0);
  return Re(() => {
    async function u() {
      try {
        if (e) {
          const l = await uF(
            e,
            A,
            t,
            r,
            n
          );
          l && i(l);
        } else {
          i(null);
          return;
        }
      } catch (l) {
        console.error("Error fetching Contentful image:", l);
      } finally {
        o(!1);
      }
    }
    u();
  }, [e, A, t, r]), { imageUrl: a, isLoading: s };
};
var ho = function() {
  return ho = Object.assign || function(A) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (A[a] = t[a]);
    }
    return A;
  }, ho.apply(this, arguments);
};
var vU = Object.prototype;
function mU(e) {
  var A = e && e.constructor, t = typeof A == "function" && A.prototype || vU;
  return e === t;
}
var z0 = mU;
function wU(e, A) {
  return function(t) {
    return e(A(t));
  };
}
var Km = wU, yU = Km, xU = yU(Object.keys, Object), CU = xU, EU = z0, FU = CU, bU = Object.prototype, SU = bU.hasOwnProperty;
function UU(e) {
  if (!EU(e))
    return FU(e);
  var A = [];
  for (var t in Object(e))
    SU.call(e, t) && t != "constructor" && A.push(t);
  return A;
}
var _U = UU, QU = typeof te == "object" && te && te.Object === Object && te, $m = QU, IU = $m, DU = typeof self == "object" && self && self.Object === Object && self, TU = IU || DU || Function("return this")(), jt = TU, OU = jt, HU = OU.Symbol, ma = HU, Sp = ma, jm = Object.prototype, LU = jm.hasOwnProperty, MU = jm.toString, Ha = Sp ? Sp.toStringTag : void 0;
function RU(e) {
  var A = LU.call(e, Ha), t = e[Ha];
  try {
    e[Ha] = void 0;
    var r = !0;
  } catch {
  }
  var n = MU.call(e);
  return r && (A ? e[Ha] = t : delete e[Ha]), n;
}
var NU = RU, kU = Object.prototype, PU = kU.toString;
function KU(e) {
  return PU.call(e);
}
var $U = KU, Up = ma, jU = NU, GU = $U, VU = "[object Null]", WU = "[object Undefined]", _p = Up ? Up.toStringTag : void 0;
function YU(e) {
  return e == null ? e === void 0 ? WU : VU : _p && _p in Object(e) ? jU(e) : GU(e);
}
var wa = YU;
function zU(e) {
  var A = typeof e;
  return e != null && (A == "object" || A == "function");
}
var jr = zU, XU = wa, qU = jr, JU = "[object AsyncFunction]", ZU = "[object Function]", e_ = "[object GeneratorFunction]", A_ = "[object Proxy]";
function t_(e) {
  if (!qU(e))
    return !1;
  var A = XU(e);
  return A == ZU || A == e_ || A == JU || A == A_;
}
var Gm = t_, r_ = jt, n_ = r_["__core-js_shared__"], a_ = n_, ac = a_, Qp = function() {
  var e = /[^.]+$/.exec(ac && ac.keys && ac.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function i_(e) {
  return !!Qp && Qp in e;
}
var s_ = i_, o_ = Function.prototype, u_ = o_.toString;
function l_(e) {
  if (e != null) {
    try {
      return u_.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Vm = l_, c_ = Gm, f_ = s_, d_ = jr, h_ = Vm, p_ = /[\\^$.*+?()[\]{}|]/g, g_ = /^\[object .+?Constructor\]$/, B_ = Function.prototype, v_ = Object.prototype, m_ = B_.toString, w_ = v_.hasOwnProperty, y_ = RegExp(
  "^" + m_.call(w_).replace(p_, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function x_(e) {
  if (!d_(e) || f_(e))
    return !1;
  var A = c_(e) ? y_ : g_;
  return A.test(h_(e));
}
var C_ = x_;
function E_(e, A) {
  return e == null ? void 0 : e[A];
}
var F_ = E_, b_ = C_, S_ = F_;
function U_(e, A) {
  var t = S_(e, A);
  return b_(t) ? t : void 0;
}
var Qn = U_, __ = Qn, Q_ = jt, I_ = __(Q_, "DataView"), D_ = I_, T_ = Qn, O_ = jt, H_ = T_(O_, "Map"), X0 = H_, L_ = Qn, M_ = jt, R_ = L_(M_, "Promise"), N_ = R_, k_ = Qn, P_ = jt, K_ = k_(P_, "Set"), $_ = K_, j_ = Qn, G_ = jt, V_ = j_(G_, "WeakMap"), W_ = V_, uf = D_, lf = X0, cf = N_, ff = $_, df = W_, Wm = wa, ya = Vm, Ip = "[object Map]", Y_ = "[object Object]", Dp = "[object Promise]", Tp = "[object Set]", Op = "[object WeakMap]", Hp = "[object DataView]", z_ = ya(uf), X_ = ya(lf), q_ = ya(cf), J_ = ya(ff), Z_ = ya(df), An = Wm;
(uf && An(new uf(new ArrayBuffer(1))) != Hp || lf && An(new lf()) != Ip || cf && An(cf.resolve()) != Dp || ff && An(new ff()) != Tp || df && An(new df()) != Op) && (An = function(e) {
  var A = Wm(e), t = A == Y_ ? e.constructor : void 0, r = t ? ya(t) : "";
  if (r)
    switch (r) {
      case z_:
        return Hp;
      case X_:
        return Ip;
      case q_:
        return Dp;
      case J_:
        return Tp;
      case Z_:
        return Op;
    }
  return A;
});
var du = An;
function eQ(e) {
  return e != null && typeof e == "object";
}
var Gr = eQ, AQ = wa, tQ = Gr, rQ = "[object Arguments]";
function nQ(e) {
  return tQ(e) && AQ(e) == rQ;
}
var aQ = nQ, Lp = aQ, iQ = Gr, Ym = Object.prototype, sQ = Ym.hasOwnProperty, oQ = Ym.propertyIsEnumerable, uQ = Lp(function() {
  return arguments;
}()) ? Lp : function(e) {
  return iQ(e) && sQ.call(e, "callee") && !oQ.call(e, "callee");
}, q0 = uQ, lQ = Array.isArray, ot = lQ, cQ = 9007199254740991;
function fQ(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= cQ;
}
var J0 = fQ, dQ = Gm, hQ = J0;
function pQ(e) {
  return e != null && hQ(e.length) && !dQ(e);
}
var Mi = pQ, po = { exports: {} };
function gQ() {
  return !1;
}
var BQ = gQ;
po.exports;
(function(e, A) {
  var t = jt, r = BQ, n = A && !A.nodeType && A, a = n && !0 && e && !e.nodeType && e, i = a && a.exports === n, s = i ? t.Buffer : void 0, o = s ? s.isBuffer : void 0, u = o || r;
  e.exports = u;
})(po, po.exports);
var Z0 = po.exports, vQ = wa, mQ = J0, wQ = Gr, yQ = "[object Arguments]", xQ = "[object Array]", CQ = "[object Boolean]", EQ = "[object Date]", FQ = "[object Error]", bQ = "[object Function]", SQ = "[object Map]", UQ = "[object Number]", _Q = "[object Object]", QQ = "[object RegExp]", IQ = "[object Set]", DQ = "[object String]", TQ = "[object WeakMap]", OQ = "[object ArrayBuffer]", HQ = "[object DataView]", LQ = "[object Float32Array]", MQ = "[object Float64Array]", RQ = "[object Int8Array]", NQ = "[object Int16Array]", kQ = "[object Int32Array]", PQ = "[object Uint8Array]", KQ = "[object Uint8ClampedArray]", $Q = "[object Uint16Array]", jQ = "[object Uint32Array]", ze = {};
ze[LQ] = ze[MQ] = ze[RQ] = ze[NQ] = ze[kQ] = ze[PQ] = ze[KQ] = ze[$Q] = ze[jQ] = !0;
ze[yQ] = ze[xQ] = ze[OQ] = ze[CQ] = ze[HQ] = ze[EQ] = ze[FQ] = ze[bQ] = ze[SQ] = ze[UQ] = ze[_Q] = ze[QQ] = ze[IQ] = ze[DQ] = ze[TQ] = !1;
function GQ(e) {
  return wQ(e) && mQ(e.length) && !!ze[vQ(e)];
}
var VQ = GQ;
function WQ(e) {
  return function(A) {
    return e(A);
  };
}
var hu = WQ, go = { exports: {} };
go.exports;
(function(e, A) {
  var t = $m, r = A && !A.nodeType && A, n = r && !0 && e && !e.nodeType && e, a = n && n.exports === r, i = a && t.process, s = function() {
    try {
      var o = n && n.require && n.require("util").types;
      return o || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(go, go.exports);
var ed = go.exports, YQ = VQ, zQ = hu, Mp = ed, Rp = Mp && Mp.isTypedArray, XQ = Rp ? zQ(Rp) : YQ, zm = XQ;
function qQ() {
  this.__data__ = [], this.size = 0;
}
var JQ = qQ;
function ZQ(e, A) {
  return e === A || e !== e && A !== A;
}
var pu = ZQ, eI = pu;
function AI(e, A) {
  for (var t = e.length; t--; )
    if (eI(e[t][0], A))
      return t;
  return -1;
}
var gu = AI, tI = gu, rI = Array.prototype, nI = rI.splice;
function aI(e) {
  var A = this.__data__, t = tI(A, e);
  if (t < 0)
    return !1;
  var r = A.length - 1;
  return t == r ? A.pop() : nI.call(A, t, 1), --this.size, !0;
}
var iI = aI, sI = gu;
function oI(e) {
  var A = this.__data__, t = sI(A, e);
  return t < 0 ? void 0 : A[t][1];
}
var uI = oI, lI = gu;
function cI(e) {
  return lI(this.__data__, e) > -1;
}
var fI = cI, dI = gu;
function hI(e, A) {
  var t = this.__data__, r = dI(t, e);
  return r < 0 ? (++this.size, t.push([e, A])) : t[r][1] = A, this;
}
var pI = hI, gI = JQ, BI = iI, vI = uI, mI = fI, wI = pI;
function xa(e) {
  var A = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++A < t; ) {
    var r = e[A];
    this.set(r[0], r[1]);
  }
}
xa.prototype.clear = gI;
xa.prototype.delete = BI;
xa.prototype.get = vI;
xa.prototype.has = mI;
xa.prototype.set = wI;
var Bu = xa, yI = Bu;
function xI() {
  this.__data__ = new yI(), this.size = 0;
}
var CI = xI;
function EI(e) {
  var A = this.__data__, t = A.delete(e);
  return this.size = A.size, t;
}
var FI = EI;
function bI(e) {
  return this.__data__.get(e);
}
var SI = bI;
function UI(e) {
  return this.__data__.has(e);
}
var _I = UI, QI = Qn, II = QI(Object, "create"), vu = II, Np = vu;
function DI() {
  this.__data__ = Np ? Np(null) : {}, this.size = 0;
}
var TI = DI;
function OI(e) {
  var A = this.has(e) && delete this.__data__[e];
  return this.size -= A ? 1 : 0, A;
}
var HI = OI, LI = vu, MI = "__lodash_hash_undefined__", RI = Object.prototype, NI = RI.hasOwnProperty;
function kI(e) {
  var A = this.__data__;
  if (LI) {
    var t = A[e];
    return t === MI ? void 0 : t;
  }
  return NI.call(A, e) ? A[e] : void 0;
}
var PI = kI, KI = vu, $I = Object.prototype, jI = $I.hasOwnProperty;
function GI(e) {
  var A = this.__data__;
  return KI ? A[e] !== void 0 : jI.call(A, e);
}
var VI = GI, WI = vu, YI = "__lodash_hash_undefined__";
function zI(e, A) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = WI && A === void 0 ? YI : A, this;
}
var XI = zI, qI = TI, JI = HI, ZI = PI, eD = VI, AD = XI;
function Ca(e) {
  var A = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++A < t; ) {
    var r = e[A];
    this.set(r[0], r[1]);
  }
}
Ca.prototype.clear = qI;
Ca.prototype.delete = JI;
Ca.prototype.get = ZI;
Ca.prototype.has = eD;
Ca.prototype.set = AD;
var tD = Ca, kp = tD, rD = Bu, nD = X0;
function aD() {
  this.size = 0, this.__data__ = {
    hash: new kp(),
    map: new (nD || rD)(),
    string: new kp()
  };
}
var iD = aD;
function sD(e) {
  var A = typeof e;
  return A == "string" || A == "number" || A == "symbol" || A == "boolean" ? e !== "__proto__" : e === null;
}
var oD = sD, uD = oD;
function lD(e, A) {
  var t = e.__data__;
  return uD(A) ? t[typeof A == "string" ? "string" : "hash"] : t.map;
}
var mu = lD, cD = mu;
function fD(e) {
  var A = cD(this, e).delete(e);
  return this.size -= A ? 1 : 0, A;
}
var dD = fD, hD = mu;
function pD(e) {
  return hD(this, e).get(e);
}
var gD = pD, BD = mu;
function vD(e) {
  return BD(this, e).has(e);
}
var mD = vD, wD = mu;
function yD(e, A) {
  var t = wD(this, e), r = t.size;
  return t.set(e, A), this.size += t.size == r ? 0 : 1, this;
}
var xD = yD, CD = iD, ED = dD, FD = gD, bD = mD, SD = xD;
function Ea(e) {
  var A = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++A < t; ) {
    var r = e[A];
    this.set(r[0], r[1]);
  }
}
Ea.prototype.clear = CD;
Ea.prototype.delete = ED;
Ea.prototype.get = FD;
Ea.prototype.has = bD;
Ea.prototype.set = SD;
var Ad = Ea, UD = Bu, _D = X0, QD = Ad, ID = 200;
function DD(e, A) {
  var t = this.__data__;
  if (t instanceof UD) {
    var r = t.__data__;
    if (!_D || r.length < ID - 1)
      return r.push([e, A]), this.size = ++t.size, this;
    t = this.__data__ = new QD(r);
  }
  return t.set(e, A), this.size = t.size, this;
}
var TD = DD, OD = Bu, HD = CI, LD = FI, MD = SI, RD = _I, ND = TD;
function Fa(e) {
  var A = this.__data__ = new OD(e);
  this.size = A.size;
}
Fa.prototype.clear = HD;
Fa.prototype.delete = LD;
Fa.prototype.get = MD;
Fa.prototype.has = RD;
Fa.prototype.set = ND;
var td = Fa, kD = "__lodash_hash_undefined__";
function PD(e) {
  return this.__data__.set(e, kD), this;
}
var KD = PD;
function $D(e) {
  return this.__data__.has(e);
}
var jD = $D, GD = Ad, VD = KD, WD = jD;
function Bo(e) {
  var A = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new GD(); ++A < t; )
    this.add(e[A]);
}
Bo.prototype.add = Bo.prototype.push = VD;
Bo.prototype.has = WD;
var YD = Bo;
function zD(e, A) {
  for (var t = -1, r = e == null ? 0 : e.length; ++t < r; )
    if (A(e[t], t, e))
      return !0;
  return !1;
}
var XD = zD;
function qD(e, A) {
  return e.has(A);
}
var JD = qD, ZD = YD, e2 = XD, A2 = JD, t2 = 1, r2 = 2;
function n2(e, A, t, r, n, a) {
  var i = t & t2, s = e.length, o = A.length;
  if (s != o && !(i && o > s))
    return !1;
  var u = a.get(e), l = a.get(A);
  if (u && l)
    return u == A && l == e;
  var c = -1, f = !0, d = t & r2 ? new ZD() : void 0;
  for (a.set(e, A), a.set(A, e); ++c < s; ) {
    var h = e[c], p = A[c];
    if (r)
      var v = i ? r(p, h, c, A, e, a) : r(h, p, c, e, A, a);
    if (v !== void 0) {
      if (v)
        continue;
      f = !1;
      break;
    }
    if (d) {
      if (!e2(A, function(y, g) {
        if (!A2(d, g) && (h === y || n(h, y, t, r, a)))
          return d.push(g);
      })) {
        f = !1;
        break;
      }
    } else if (!(h === p || n(h, p, t, r, a))) {
      f = !1;
      break;
    }
  }
  return a.delete(e), a.delete(A), f;
}
var Xm = n2, a2 = jt, i2 = a2.Uint8Array, qm = i2;
function s2(e) {
  var A = -1, t = Array(e.size);
  return e.forEach(function(r, n) {
    t[++A] = [n, r];
  }), t;
}
var o2 = s2;
function u2(e) {
  var A = -1, t = Array(e.size);
  return e.forEach(function(r) {
    t[++A] = r;
  }), t;
}
var l2 = u2, Pp = ma, Kp = qm, c2 = pu, f2 = Xm, d2 = o2, h2 = l2, p2 = 1, g2 = 2, B2 = "[object Boolean]", v2 = "[object Date]", m2 = "[object Error]", w2 = "[object Map]", y2 = "[object Number]", x2 = "[object RegExp]", C2 = "[object Set]", E2 = "[object String]", F2 = "[object Symbol]", b2 = "[object ArrayBuffer]", S2 = "[object DataView]", $p = Pp ? Pp.prototype : void 0, ic = $p ? $p.valueOf : void 0;
function U2(e, A, t, r, n, a, i) {
  switch (t) {
    case S2:
      if (e.byteLength != A.byteLength || e.byteOffset != A.byteOffset)
        return !1;
      e = e.buffer, A = A.buffer;
    case b2:
      return !(e.byteLength != A.byteLength || !a(new Kp(e), new Kp(A)));
    case B2:
    case v2:
    case y2:
      return c2(+e, +A);
    case m2:
      return e.name == A.name && e.message == A.message;
    case x2:
    case E2:
      return e == A + "";
    case w2:
      var s = d2;
    case C2:
      var o = r & p2;
      if (s || (s = h2), e.size != A.size && !o)
        return !1;
      var u = i.get(e);
      if (u)
        return u == A;
      r |= g2, i.set(e, A);
      var l = f2(s(e), s(A), r, n, a, i);
      return i.delete(e), l;
    case F2:
      if (ic)
        return ic.call(e) == ic.call(A);
  }
  return !1;
}
var _2 = U2;
function Q2(e, A) {
  for (var t = -1, r = A.length, n = e.length; ++t < r; )
    e[n + t] = A[t];
  return e;
}
var rd = Q2, I2 = rd, D2 = ot;
function T2(e, A, t) {
  var r = A(e);
  return D2(e) ? r : I2(r, t(e));
}
var Jm = T2;
function O2(e, A) {
  for (var t = -1, r = e == null ? 0 : e.length, n = 0, a = []; ++t < r; ) {
    var i = e[t];
    A(i, t, e) && (a[n++] = i);
  }
  return a;
}
var H2 = O2;
function L2() {
  return [];
}
var Zm = L2, M2 = H2, R2 = Zm, N2 = Object.prototype, k2 = N2.propertyIsEnumerable, jp = Object.getOwnPropertySymbols, P2 = jp ? function(e) {
  return e == null ? [] : (e = Object(e), M2(jp(e), function(A) {
    return k2.call(e, A);
  }));
} : R2, nd = P2;
function K2(e, A) {
  for (var t = -1, r = Array(e); ++t < e; )
    r[t] = A(t);
  return r;
}
var $2 = K2, j2 = 9007199254740991, G2 = /^(?:0|[1-9]\d*)$/;
function V2(e, A) {
  var t = typeof e;
  return A = A ?? j2, !!A && (t == "number" || t != "symbol" && G2.test(e)) && e > -1 && e % 1 == 0 && e < A;
}
var ad = V2, W2 = $2, Y2 = q0, z2 = ot, X2 = Z0, q2 = ad, J2 = zm, Z2 = Object.prototype, e4 = Z2.hasOwnProperty;
function A4(e, A) {
  var t = z2(e), r = !t && Y2(e), n = !t && !r && X2(e), a = !t && !r && !n && J2(e), i = t || r || n || a, s = i ? W2(e.length, String) : [], o = s.length;
  for (var u in e)
    (A || e4.call(e, u)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    q2(u, o))) && s.push(u);
  return s;
}
var ew = A4, t4 = ew, r4 = _U, n4 = Mi;
function a4(e) {
  return n4(e) ? t4(e) : r4(e);
}
var Ri = a4, i4 = Jm, s4 = nd, o4 = Ri;
function u4(e) {
  return i4(e, o4, s4);
}
var Aw = u4, Gp = Aw, l4 = 1, c4 = Object.prototype, f4 = c4.hasOwnProperty;
function d4(e, A, t, r, n, a) {
  var i = t & l4, s = Gp(e), o = s.length, u = Gp(A), l = u.length;
  if (o != l && !i)
    return !1;
  for (var c = o; c--; ) {
    var f = s[c];
    if (!(i ? f in A : f4.call(A, f)))
      return !1;
  }
  var d = a.get(e), h = a.get(A);
  if (d && h)
    return d == A && h == e;
  var p = !0;
  a.set(e, A), a.set(A, e);
  for (var v = i; ++c < o; ) {
    f = s[c];
    var y = e[f], g = A[f];
    if (r)
      var B = i ? r(g, y, f, A, e, a) : r(y, g, f, e, A, a);
    if (!(B === void 0 ? y === g || n(y, g, t, r, a) : B)) {
      p = !1;
      break;
    }
    v || (v = f == "constructor");
  }
  if (p && !v) {
    var w = e.constructor, m = A.constructor;
    w != m && "constructor" in e && "constructor" in A && !(typeof w == "function" && w instanceof w && typeof m == "function" && m instanceof m) && (p = !1);
  }
  return a.delete(e), a.delete(A), p;
}
var h4 = d4, sc = td, p4 = Xm, g4 = _2, B4 = h4, Vp = du, Wp = ot, Yp = Z0, v4 = zm, m4 = 1, zp = "[object Arguments]", Xp = "[object Array]", ss = "[object Object]", w4 = Object.prototype, qp = w4.hasOwnProperty;
function y4(e, A, t, r, n, a) {
  var i = Wp(e), s = Wp(A), o = i ? Xp : Vp(e), u = s ? Xp : Vp(A);
  o = o == zp ? ss : o, u = u == zp ? ss : u;
  var l = o == ss, c = u == ss, f = o == u;
  if (f && Yp(e)) {
    if (!Yp(A))
      return !1;
    i = !0, l = !1;
  }
  if (f && !l)
    return a || (a = new sc()), i || v4(e) ? p4(e, A, t, r, n, a) : g4(e, A, o, t, r, n, a);
  if (!(t & m4)) {
    var d = l && qp.call(e, "__wrapped__"), h = c && qp.call(A, "__wrapped__");
    if (d || h) {
      var p = d ? e.value() : e, v = h ? A.value() : A;
      return a || (a = new sc()), n(p, v, t, r, a);
    }
  }
  return f ? (a || (a = new sc()), B4(e, A, t, r, n, a)) : !1;
}
var x4 = y4, C4 = x4, Jp = Gr;
function tw(e, A, t, r, n) {
  return e === A ? !0 : e == null || A == null || !Jp(e) && !Jp(A) ? e !== e && A !== A : C4(e, A, t, r, tw, n);
}
var rw = tw, E4 = wa, F4 = Gr, b4 = "[object Symbol]";
function S4(e) {
  return typeof e == "symbol" || F4(e) && E4(e) == b4;
}
var Ni = S4, U4 = ot, _4 = Ni, Q4 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, I4 = /^\w*$/;
function D4(e, A) {
  if (U4(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || _4(e) ? !0 : I4.test(e) || !Q4.test(e) || A != null && e in Object(A);
}
var id = D4, nw = Ad, T4 = "Expected a function";
function sd(e, A) {
  if (typeof e != "function" || A != null && typeof A != "function")
    throw new TypeError(T4);
  var t = function() {
    var r = arguments, n = A ? A.apply(this, r) : r[0], a = t.cache;
    if (a.has(n))
      return a.get(n);
    var i = e.apply(this, r);
    return t.cache = a.set(n, i) || a, i;
  };
  return t.cache = new (sd.Cache || nw)(), t;
}
sd.Cache = nw;
var O4 = sd, H4 = O4, L4 = 500;
function M4(e) {
  var A = H4(e, function(r) {
    return t.size === L4 && t.clear(), r;
  }), t = A.cache;
  return A;
}
var R4 = M4, N4 = R4, k4 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, P4 = /\\(\\)?/g, K4 = N4(function(e) {
  var A = [];
  return e.charCodeAt(0) === 46 && A.push(""), e.replace(k4, function(t, r, n, a) {
    A.push(n ? a.replace(P4, "$1") : r || t);
  }), A;
}), $4 = K4;
function j4(e, A) {
  for (var t = -1, r = e == null ? 0 : e.length, n = Array(r); ++t < r; )
    n[t] = A(e[t], t, e);
  return n;
}
var wu = j4, Zp = ma, G4 = wu, V4 = ot, W4 = Ni, Y4 = 1 / 0, eg = Zp ? Zp.prototype : void 0, Ag = eg ? eg.toString : void 0;
function aw(e) {
  if (typeof e == "string")
    return e;
  if (V4(e))
    return G4(e, aw) + "";
  if (W4(e))
    return Ag ? Ag.call(e) : "";
  var A = e + "";
  return A == "0" && 1 / e == -Y4 ? "-0" : A;
}
var z4 = aw, X4 = z4;
function q4(e) {
  return e == null ? "" : X4(e);
}
var iw = q4, J4 = ot, Z4 = id, eT = $4, AT = iw;
function tT(e, A) {
  return J4(e) ? e : Z4(e, A) ? [e] : eT(AT(e));
}
var yu = tT, rT = Ni, nT = 1 / 0;
function aT(e) {
  if (typeof e == "string" || rT(e))
    return e;
  var A = e + "";
  return A == "0" && 1 / e == -nT ? "-0" : A;
}
var ki = aT, iT = yu, sT = ki;
function oT(e, A) {
  A = iT(A, e);
  for (var t = 0, r = A.length; e != null && t < r; )
    e = e[sT(A[t++])];
  return t && t == r ? e : void 0;
}
var xu = oT, uT = xu;
function lT(e, A, t) {
  var r = e == null ? void 0 : uT(e, A);
  return r === void 0 ? t : r;
}
var cT = lT, tg = ma, fT = q0, dT = ot, rg = tg ? tg.isConcatSpreadable : void 0;
function hT(e) {
  return dT(e) || fT(e) || !!(rg && e && e[rg]);
}
var pT = hT, gT = rd, BT = pT;
function sw(e, A, t, r, n) {
  var a = -1, i = e.length;
  for (t || (t = BT), n || (n = []); ++a < i; ) {
    var s = e[a];
    A > 0 && t(s) ? A > 1 ? sw(s, A - 1, t, r, n) : gT(n, s) : r || (n[n.length] = s);
  }
  return n;
}
var ow = sw, vT = ow;
function mT(e) {
  var A = e == null ? 0 : e.length;
  return A ? vT(e, 1) : [];
}
var wT = mT;
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var uw;
function ae() {
  return uw.apply(null, arguments);
}
function yT(e) {
  uw = e;
}
function vt(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function Bn(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Ie(e, A) {
  return Object.prototype.hasOwnProperty.call(e, A);
}
function od(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var A;
  for (A in e)
    if (Ie(e, A))
      return !1;
  return !0;
}
function PA(e) {
  return e === void 0;
}
function cr(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function Pi(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function lw(e, A) {
  var t = [], r, n = e.length;
  for (r = 0; r < n; ++r)
    t.push(A(e[r], r));
  return t;
}
function Sr(e, A) {
  for (var t in A)
    Ie(A, t) && (e[t] = A[t]);
  return Ie(A, "toString") && (e.toString = A.toString), Ie(A, "valueOf") && (e.valueOf = A.valueOf), e;
}
function Gt(e, A, t, r) {
  return Ow(e, A, t, r, !0).utc();
}
function xT() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Be(e) {
  return e._pf == null && (e._pf = xT()), e._pf;
}
var hf;
Array.prototype.some ? hf = Array.prototype.some : hf = function(e) {
  var A = Object(this), t = A.length >>> 0, r;
  for (r = 0; r < t; r++)
    if (r in A && e.call(this, A[r], r, A))
      return !0;
  return !1;
};
function ud(e) {
  if (e._isValid == null) {
    var A = Be(e), t = hf.call(A.parsedDateParts, function(n) {
      return n != null;
    }), r = !isNaN(e._d.getTime()) && A.overflow < 0 && !A.empty && !A.invalidEra && !A.invalidMonth && !A.invalidWeekday && !A.weekdayMismatch && !A.nullInput && !A.invalidFormat && !A.userInvalidated && (!A.meridiem || A.meridiem && t);
    if (e._strict && (r = r && A.charsLeftOver === 0 && A.unusedTokens.length === 0 && A.bigHour === void 0), Object.isFrozen == null || !Object.isFrozen(e))
      e._isValid = r;
    else
      return r;
  }
  return e._isValid;
}
function Cu(e) {
  var A = Gt(NaN);
  return e != null ? Sr(Be(A), e) : Be(A).userInvalidated = !0, A;
}
var ng = ae.momentProperties = [], oc = !1;
function ld(e, A) {
  var t, r, n, a = ng.length;
  if (PA(A._isAMomentObject) || (e._isAMomentObject = A._isAMomentObject), PA(A._i) || (e._i = A._i), PA(A._f) || (e._f = A._f), PA(A._l) || (e._l = A._l), PA(A._strict) || (e._strict = A._strict), PA(A._tzm) || (e._tzm = A._tzm), PA(A._isUTC) || (e._isUTC = A._isUTC), PA(A._offset) || (e._offset = A._offset), PA(A._pf) || (e._pf = Be(A)), PA(A._locale) || (e._locale = A._locale), a > 0)
    for (t = 0; t < a; t++)
      r = ng[t], n = A[r], PA(n) || (e[r] = n);
  return e;
}
function Ki(e) {
  ld(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), oc === !1 && (oc = !0, ae.updateOffset(this), oc = !1);
}
function mt(e) {
  return e instanceof Ki || e != null && e._isAMomentObject != null;
}
function cw(e) {
  ae.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function ut(e, A) {
  var t = !0;
  return Sr(function() {
    if (ae.deprecationHandler != null && ae.deprecationHandler(null, e), t) {
      var r = [], n, a, i, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (n = "", typeof arguments[a] == "object") {
          n += `
[` + a + "] ";
          for (i in arguments[0])
            Ie(arguments[0], i) && (n += i + ": " + arguments[0][i] + ", ");
          n = n.slice(0, -2);
        } else
          n = arguments[a];
        r.push(n);
      }
      cw(
        e + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), t = !1;
    }
    return A.apply(this, arguments);
  }, A);
}
var ag = {};
function fw(e, A) {
  ae.deprecationHandler != null && ae.deprecationHandler(e, A), ag[e] || (cw(A), ag[e] = !0);
}
ae.suppressDeprecationWarnings = !1;
ae.deprecationHandler = null;
function Vt(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function CT(e) {
  var A, t;
  for (t in e)
    Ie(e, t) && (A = e[t], Vt(A) ? this[t] = A : this["_" + t] = A);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function pf(e, A) {
  var t = Sr({}, e), r;
  for (r in A)
    Ie(A, r) && (Bn(e[r]) && Bn(A[r]) ? (t[r] = {}, Sr(t[r], e[r]), Sr(t[r], A[r])) : A[r] != null ? t[r] = A[r] : delete t[r]);
  for (r in e)
    Ie(e, r) && !Ie(A, r) && Bn(e[r]) && (t[r] = Sr({}, t[r]));
  return t;
}
function cd(e) {
  e != null && this.set(e);
}
var gf;
Object.keys ? gf = Object.keys : gf = function(e) {
  var A, t = [];
  for (A in e)
    Ie(e, A) && t.push(A);
  return t;
};
var ET = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function FT(e, A, t) {
  var r = this._calendar[e] || this._calendar.sameElse;
  return Vt(r) ? r.call(A, t) : r;
}
function Nt(e, A, t) {
  var r = "" + Math.abs(e), n = A - r.length, a = e >= 0;
  return (a ? t ? "+" : "" : "-") + Math.pow(10, Math.max(0, n)).toString().substr(1) + r;
}
var fd = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, os = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, uc = {}, oa = {};
function le(e, A, t, r) {
  var n = r;
  typeof r == "string" && (n = function() {
    return this[r]();
  }), e && (oa[e] = n), A && (oa[A[0]] = function() {
    return Nt(n.apply(this, arguments), A[1], A[2]);
  }), t && (oa[t] = function() {
    return this.localeData().ordinal(
      n.apply(this, arguments),
      e
    );
  });
}
function bT(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function ST(e) {
  var A = e.match(fd), t, r;
  for (t = 0, r = A.length; t < r; t++)
    oa[A[t]] ? A[t] = oa[A[t]] : A[t] = bT(A[t]);
  return function(n) {
    var a = "", i;
    for (i = 0; i < r; i++)
      a += Vt(A[i]) ? A[i].call(n, e) : A[i];
    return a;
  };
}
function Xs(e, A) {
  return e.isValid() ? (A = dw(A, e.localeData()), uc[A] = uc[A] || ST(A), uc[A](e)) : e.localeData().invalidDate();
}
function dw(e, A) {
  var t = 5;
  function r(n) {
    return A.longDateFormat(n) || n;
  }
  for (os.lastIndex = 0; t >= 0 && os.test(e); )
    e = e.replace(
      os,
      r
    ), os.lastIndex = 0, t -= 1;
  return e;
}
var UT = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function _T(e) {
  var A = this._longDateFormat[e], t = this._longDateFormat[e.toUpperCase()];
  return A || !t ? A : (this._longDateFormat[e] = t.match(fd).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[e]);
}
var QT = "Invalid date";
function IT() {
  return this._invalidDate;
}
var DT = "%d", TT = /\d{1,2}/;
function OT(e) {
  return this._ordinal.replace("%d", e);
}
var HT = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function LT(e, A, t, r) {
  var n = this._relativeTime[t];
  return Vt(n) ? n(e, A, t, r) : n.replace(/%d/i, e);
}
function MT(e, A) {
  var t = this._relativeTime[e > 0 ? "future" : "past"];
  return Vt(t) ? t(A) : t.replace(/%s/i, A);
}
var si = {};
function TA(e, A) {
  var t = e.toLowerCase();
  si[t] = si[t + "s"] = si[A] = e;
}
function lt(e) {
  return typeof e == "string" ? si[e] || si[e.toLowerCase()] : void 0;
}
function dd(e) {
  var A = {}, t, r;
  for (r in e)
    Ie(e, r) && (t = lt(r), t && (A[t] = e[r]));
  return A;
}
var hw = {};
function OA(e, A) {
  hw[e] = A;
}
function RT(e) {
  var A = [], t;
  for (t in e)
    Ie(e, t) && A.push({ unit: t, priority: hw[t] });
  return A.sort(function(r, n) {
    return r.priority - n.priority;
  }), A;
}
function Eu(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function tt(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function xe(e) {
  var A = +e, t = 0;
  return A !== 0 && isFinite(A) && (t = tt(A)), t;
}
function ba(e, A) {
  return function(t) {
    return t != null ? (pw(this, e, t), ae.updateOffset(this, A), this) : vo(this, e);
  };
}
function vo(e, A) {
  return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + A]() : NaN;
}
function pw(e, A, t) {
  e.isValid() && !isNaN(t) && (A === "FullYear" && Eu(e.year()) && e.month() === 1 && e.date() === 29 ? (t = xe(t), e._d["set" + (e._isUTC ? "UTC" : "") + A](
    t,
    e.month(),
    Qu(t, e.month())
  )) : e._d["set" + (e._isUTC ? "UTC" : "") + A](t));
}
function NT(e) {
  return e = lt(e), Vt(this[e]) ? this[e]() : this;
}
function kT(e, A) {
  if (typeof e == "object") {
    e = dd(e);
    var t = RT(e), r, n = t.length;
    for (r = 0; r < n; r++)
      this[t[r].unit](e[t[r].unit]);
  } else if (e = lt(e), Vt(this[e]))
    return this[e](A);
  return this;
}
var gw = /\d/, qA = /\d\d/, Bw = /\d{3}/, hd = /\d{4}/, Fu = /[+-]?\d{6}/, eA = /\d\d?/, vw = /\d\d\d\d?/, mw = /\d\d\d\d\d\d?/, bu = /\d{1,3}/, pd = /\d{1,4}/, Su = /[+-]?\d{1,6}/, Sa = /\d+/, Uu = /[+-]?\d+/, PT = /Z|[+-]\d\d:?\d\d/gi, _u = /Z|[+-]\d\d(?::?\d\d)?/gi, KT = /[+-]?\d+(\.\d{1,3})?/, $i = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, mo;
mo = {};
function se(e, A, t) {
  mo[e] = Vt(A) ? A : function(r, n) {
    return r && t ? t : A;
  };
}
function $T(e, A) {
  return Ie(mo, e) ? mo[e](A._strict, A._locale) : new RegExp(jT(e));
}
function jT(e) {
  return YA(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(A, t, r, n, a) {
        return t || r || n || a;
      }
    )
  );
}
function YA(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var Bf = {};
function $e(e, A) {
  var t, r = A, n;
  for (typeof e == "string" && (e = [e]), cr(A) && (r = function(a, i) {
    i[A] = xe(a);
  }), n = e.length, t = 0; t < n; t++)
    Bf[e[t]] = r;
}
function ji(e, A) {
  $e(e, function(t, r, n, a) {
    n._w = n._w || {}, A(t, n._w, n, a);
  });
}
function GT(e, A, t) {
  A != null && Ie(Bf, e) && Bf[e](A, t._a, t, e);
}
var IA = 0, rr = 1, Ot = 2, vA = 3, Bt = 4, nr = 5, cn = 6, VT = 7, WT = 8;
function YT(e, A) {
  return (e % A + A) % A;
}
var lA;
Array.prototype.indexOf ? lA = Array.prototype.indexOf : lA = function(e) {
  var A;
  for (A = 0; A < this.length; ++A)
    if (this[A] === e)
      return A;
  return -1;
};
function Qu(e, A) {
  if (isNaN(e) || isNaN(A))
    return NaN;
  var t = YT(A, 12);
  return e += (A - t) / 12, t === 1 ? Eu(e) ? 29 : 28 : 31 - t % 7 % 2;
}
le("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
le("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
le("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
TA("month", "M");
OA("month", 8);
se("M", eA);
se("MM", eA, qA);
se("MMM", function(e, A) {
  return A.monthsShortRegex(e);
});
se("MMMM", function(e, A) {
  return A.monthsRegex(e);
});
$e(["M", "MM"], function(e, A) {
  A[rr] = xe(e) - 1;
});
$e(["MMM", "MMMM"], function(e, A, t, r) {
  var n = t._locale.monthsParse(e, r, t._strict);
  n != null ? A[rr] = n : Be(t).invalidMonth = e;
});
var zT = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), ww = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), yw = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, XT = $i, qT = $i;
function JT(e, A) {
  return e ? vt(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || yw).test(A) ? "format" : "standalone"][e.month()] : vt(this._months) ? this._months : this._months.standalone;
}
function ZT(e, A) {
  return e ? vt(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[yw.test(A) ? "format" : "standalone"][e.month()] : vt(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function eO(e, A, t) {
  var r, n, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      a = Gt([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
  return t ? A === "MMM" ? (n = lA.call(this._shortMonthsParse, i), n !== -1 ? n : null) : (n = lA.call(this._longMonthsParse, i), n !== -1 ? n : null) : A === "MMM" ? (n = lA.call(this._shortMonthsParse, i), n !== -1 ? n : (n = lA.call(this._longMonthsParse, i), n !== -1 ? n : null)) : (n = lA.call(this._longMonthsParse, i), n !== -1 ? n : (n = lA.call(this._shortMonthsParse, i), n !== -1 ? n : null));
}
function AO(e, A, t) {
  var r, n, a;
  if (this._monthsParseExact)
    return eO.call(this, e, A, t);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++) {
    if (n = Gt([2e3, r]), t && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(n, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(n, "").replace(".", "") + "$",
      "i"
    )), !t && !this._monthsParse[r] && (a = "^" + this.months(n, "") + "|^" + this.monthsShort(n, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), t && A === "MMMM" && this._longMonthsParse[r].test(e))
      return r;
    if (t && A === "MMM" && this._shortMonthsParse[r].test(e))
      return r;
    if (!t && this._monthsParse[r].test(e))
      return r;
  }
}
function xw(e, A) {
  var t;
  if (!e.isValid())
    return e;
  if (typeof A == "string") {
    if (/^\d+$/.test(A))
      A = xe(A);
    else if (A = e.localeData().monthsParse(A), !cr(A))
      return e;
  }
  return t = Math.min(e.date(), Qu(e.year(), A)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](A, t), e;
}
function Cw(e) {
  return e != null ? (xw(this, e), ae.updateOffset(this, !0), this) : vo(this, "Month");
}
function tO() {
  return Qu(this.year(), this.month());
}
function rO(e) {
  return this._monthsParseExact ? (Ie(this, "_monthsRegex") || Ew.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Ie(this, "_monthsShortRegex") || (this._monthsShortRegex = XT), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function nO(e) {
  return this._monthsParseExact ? (Ie(this, "_monthsRegex") || Ew.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Ie(this, "_monthsRegex") || (this._monthsRegex = qT), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Ew() {
  function e(i, s) {
    return s.length - i.length;
  }
  var A = [], t = [], r = [], n, a;
  for (n = 0; n < 12; n++)
    a = Gt([2e3, n]), A.push(this.monthsShort(a, "")), t.push(this.months(a, "")), r.push(this.months(a, "")), r.push(this.monthsShort(a, ""));
  for (A.sort(e), t.sort(e), r.sort(e), n = 0; n < 12; n++)
    A[n] = YA(A[n]), t[n] = YA(t[n]);
  for (n = 0; n < 24; n++)
    r[n] = YA(r[n]);
  this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + A.join("|") + ")",
    "i"
  );
}
le("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Nt(e, 4) : "+" + e;
});
le(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
le(0, ["YYYY", 4], 0, "year");
le(0, ["YYYYY", 5], 0, "year");
le(0, ["YYYYYY", 6, !0], 0, "year");
TA("year", "y");
OA("year", 1);
se("Y", Uu);
se("YY", eA, qA);
se("YYYY", pd, hd);
se("YYYYY", Su, Fu);
se("YYYYYY", Su, Fu);
$e(["YYYYY", "YYYYYY"], IA);
$e("YYYY", function(e, A) {
  A[IA] = e.length === 2 ? ae.parseTwoDigitYear(e) : xe(e);
});
$e("YY", function(e, A) {
  A[IA] = ae.parseTwoDigitYear(e);
});
$e("Y", function(e, A) {
  A[IA] = parseInt(e, 10);
});
function oi(e) {
  return Eu(e) ? 366 : 365;
}
ae.parseTwoDigitYear = function(e) {
  return xe(e) + (xe(e) > 68 ? 1900 : 2e3);
};
var Fw = ba("FullYear", !0);
function aO() {
  return Eu(this.year());
}
function iO(e, A, t, r, n, a, i) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, A, t, r, n, a, i), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, A, t, r, n, a, i), s;
}
function wi(e) {
  var A, t;
  return e < 100 && e >= 0 ? (t = Array.prototype.slice.call(arguments), t[0] = e + 400, A = new Date(Date.UTC.apply(null, t)), isFinite(A.getUTCFullYear()) && A.setUTCFullYear(e)) : A = new Date(Date.UTC.apply(null, arguments)), A;
}
function wo(e, A, t) {
  var r = 7 + A - t, n = (7 + wi(e, 0, r).getUTCDay() - A) % 7;
  return -n + r - 1;
}
function bw(e, A, t, r, n) {
  var a = (7 + t - r) % 7, i = wo(e, r, n), s = 1 + 7 * (A - 1) + a + i, o, u;
  return s <= 0 ? (o = e - 1, u = oi(o) + s) : s > oi(e) ? (o = e + 1, u = s - oi(e)) : (o = e, u = s), {
    year: o,
    dayOfYear: u
  };
}
function yi(e, A, t) {
  var r = wo(e.year(), A, t), n = Math.floor((e.dayOfYear() - r - 1) / 7) + 1, a, i;
  return n < 1 ? (i = e.year() - 1, a = n + or(i, A, t)) : n > or(e.year(), A, t) ? (a = n - or(e.year(), A, t), i = e.year() + 1) : (i = e.year(), a = n), {
    week: a,
    year: i
  };
}
function or(e, A, t) {
  var r = wo(e, A, t), n = wo(e + 1, A, t);
  return (oi(e) - r + n) / 7;
}
le("w", ["ww", 2], "wo", "week");
le("W", ["WW", 2], "Wo", "isoWeek");
TA("week", "w");
TA("isoWeek", "W");
OA("week", 5);
OA("isoWeek", 5);
se("w", eA);
se("ww", eA, qA);
se("W", eA);
se("WW", eA, qA);
ji(
  ["w", "ww", "W", "WW"],
  function(e, A, t, r) {
    A[r.substr(0, 1)] = xe(e);
  }
);
function sO(e) {
  return yi(e, this._week.dow, this._week.doy).week;
}
var oO = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function uO() {
  return this._week.dow;
}
function lO() {
  return this._week.doy;
}
function cO(e) {
  var A = this.localeData().week(this);
  return e == null ? A : this.add((e - A) * 7, "d");
}
function fO(e) {
  var A = yi(this, 1, 4).week;
  return e == null ? A : this.add((e - A) * 7, "d");
}
le("d", 0, "do", "day");
le("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
le("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
le("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
le("e", 0, 0, "weekday");
le("E", 0, 0, "isoWeekday");
TA("day", "d");
TA("weekday", "e");
TA("isoWeekday", "E");
OA("day", 11);
OA("weekday", 11);
OA("isoWeekday", 11);
se("d", eA);
se("e", eA);
se("E", eA);
se("dd", function(e, A) {
  return A.weekdaysMinRegex(e);
});
se("ddd", function(e, A) {
  return A.weekdaysShortRegex(e);
});
se("dddd", function(e, A) {
  return A.weekdaysRegex(e);
});
ji(["dd", "ddd", "dddd"], function(e, A, t, r) {
  var n = t._locale.weekdaysParse(e, r, t._strict);
  n != null ? A.d = n : Be(t).invalidWeekday = e;
});
ji(["d", "e", "E"], function(e, A, t, r) {
  A[r] = xe(e);
});
function dO(e, A) {
  return typeof e != "string" ? e : isNaN(e) ? (e = A.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function hO(e, A) {
  return typeof e == "string" ? A.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function gd(e, A) {
  return e.slice(A, 7).concat(e.slice(0, A));
}
var pO = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Sw = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), gO = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), BO = $i, vO = $i, mO = $i;
function wO(e, A) {
  var t = vt(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(A) ? "format" : "standalone"];
  return e === !0 ? gd(t, this._week.dow) : e ? t[e.day()] : t;
}
function yO(e) {
  return e === !0 ? gd(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function xO(e) {
  return e === !0 ? gd(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function CO(e, A, t) {
  var r, n, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      a = Gt([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
  return t ? A === "dddd" ? (n = lA.call(this._weekdaysParse, i), n !== -1 ? n : null) : A === "ddd" ? (n = lA.call(this._shortWeekdaysParse, i), n !== -1 ? n : null) : (n = lA.call(this._minWeekdaysParse, i), n !== -1 ? n : null) : A === "dddd" ? (n = lA.call(this._weekdaysParse, i), n !== -1 || (n = lA.call(this._shortWeekdaysParse, i), n !== -1) ? n : (n = lA.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : A === "ddd" ? (n = lA.call(this._shortWeekdaysParse, i), n !== -1 || (n = lA.call(this._weekdaysParse, i), n !== -1) ? n : (n = lA.call(this._minWeekdaysParse, i), n !== -1 ? n : null)) : (n = lA.call(this._minWeekdaysParse, i), n !== -1 || (n = lA.call(this._weekdaysParse, i), n !== -1) ? n : (n = lA.call(this._shortWeekdaysParse, i), n !== -1 ? n : null));
}
function EO(e, A, t) {
  var r, n, a;
  if (this._weekdaysParseExact)
    return CO.call(this, e, A, t);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++) {
    if (n = Gt([2e3, 1]).day(r), t && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(n, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(n, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (a = "^" + this.weekdays(n, "") + "|^" + this.weekdaysShort(n, "") + "|^" + this.weekdaysMin(n, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), t && A === "dddd" && this._fullWeekdaysParse[r].test(e))
      return r;
    if (t && A === "ddd" && this._shortWeekdaysParse[r].test(e))
      return r;
    if (t && A === "dd" && this._minWeekdaysParse[r].test(e))
      return r;
    if (!t && this._weekdaysParse[r].test(e))
      return r;
  }
}
function FO(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var A = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
  return e != null ? (e = dO(e, this.localeData()), this.add(e - A, "d")) : A;
}
function bO(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var A = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? A : this.add(e - A, "d");
}
function SO(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var A = hO(e, this.localeData());
    return this.day(this.day() % 7 ? A : A - 7);
  } else
    return this.day() || 7;
}
function UO(e) {
  return this._weekdaysParseExact ? (Ie(this, "_weekdaysRegex") || Bd.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Ie(this, "_weekdaysRegex") || (this._weekdaysRegex = BO), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function _O(e) {
  return this._weekdaysParseExact ? (Ie(this, "_weekdaysRegex") || Bd.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Ie(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = vO), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function QO(e) {
  return this._weekdaysParseExact ? (Ie(this, "_weekdaysRegex") || Bd.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Ie(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = mO), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Bd() {
  function e(l, c) {
    return c.length - l.length;
  }
  var A = [], t = [], r = [], n = [], a, i, s, o, u;
  for (a = 0; a < 7; a++)
    i = Gt([2e3, 1]).day(a), s = YA(this.weekdaysMin(i, "")), o = YA(this.weekdaysShort(i, "")), u = YA(this.weekdays(i, "")), A.push(s), t.push(o), r.push(u), n.push(s), n.push(o), n.push(u);
  A.sort(e), t.sort(e), r.sort(e), n.sort(e), this._weekdaysRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + A.join("|") + ")",
    "i"
  );
}
function vd() {
  return this.hours() % 12 || 12;
}
function IO() {
  return this.hours() || 24;
}
le("H", ["HH", 2], 0, "hour");
le("h", ["hh", 2], 0, vd);
le("k", ["kk", 2], 0, IO);
le("hmm", 0, 0, function() {
  return "" + vd.apply(this) + Nt(this.minutes(), 2);
});
le("hmmss", 0, 0, function() {
  return "" + vd.apply(this) + Nt(this.minutes(), 2) + Nt(this.seconds(), 2);
});
le("Hmm", 0, 0, function() {
  return "" + this.hours() + Nt(this.minutes(), 2);
});
le("Hmmss", 0, 0, function() {
  return "" + this.hours() + Nt(this.minutes(), 2) + Nt(this.seconds(), 2);
});
function Uw(e, A) {
  le(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      A
    );
  });
}
Uw("a", !0);
Uw("A", !1);
TA("hour", "h");
OA("hour", 13);
function _w(e, A) {
  return A._meridiemParse;
}
se("a", _w);
se("A", _w);
se("H", eA);
se("h", eA);
se("k", eA);
se("HH", eA, qA);
se("hh", eA, qA);
se("kk", eA, qA);
se("hmm", vw);
se("hmmss", mw);
se("Hmm", vw);
se("Hmmss", mw);
$e(["H", "HH"], vA);
$e(["k", "kk"], function(e, A, t) {
  var r = xe(e);
  A[vA] = r === 24 ? 0 : r;
});
$e(["a", "A"], function(e, A, t) {
  t._isPm = t._locale.isPM(e), t._meridiem = e;
});
$e(["h", "hh"], function(e, A, t) {
  A[vA] = xe(e), Be(t).bigHour = !0;
});
$e("hmm", function(e, A, t) {
  var r = e.length - 2;
  A[vA] = xe(e.substr(0, r)), A[Bt] = xe(e.substr(r)), Be(t).bigHour = !0;
});
$e("hmmss", function(e, A, t) {
  var r = e.length - 4, n = e.length - 2;
  A[vA] = xe(e.substr(0, r)), A[Bt] = xe(e.substr(r, 2)), A[nr] = xe(e.substr(n)), Be(t).bigHour = !0;
});
$e("Hmm", function(e, A, t) {
  var r = e.length - 2;
  A[vA] = xe(e.substr(0, r)), A[Bt] = xe(e.substr(r));
});
$e("Hmmss", function(e, A, t) {
  var r = e.length - 4, n = e.length - 2;
  A[vA] = xe(e.substr(0, r)), A[Bt] = xe(e.substr(r, 2)), A[nr] = xe(e.substr(n));
});
function DO(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var TO = /[ap]\.?m?\.?/i, OO = ba("Hours", !0);
function HO(e, A, t) {
  return e > 11 ? t ? "pm" : "PM" : t ? "am" : "AM";
}
var Qw = {
  calendar: ET,
  longDateFormat: UT,
  invalidDate: QT,
  ordinal: DT,
  dayOfMonthOrdinalParse: TT,
  relativeTime: HT,
  months: zT,
  monthsShort: ww,
  week: oO,
  weekdays: pO,
  weekdaysMin: gO,
  weekdaysShort: Sw,
  meridiemParse: TO
}, tA = {}, La = {}, xi;
function LO(e, A) {
  var t, r = Math.min(e.length, A.length);
  for (t = 0; t < r; t += 1)
    if (e[t] !== A[t])
      return t;
  return r;
}
function ig(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function MO(e) {
  for (var A = 0, t, r, n, a; A < e.length; ) {
    for (a = ig(e[A]).split("-"), t = a.length, r = ig(e[A + 1]), r = r ? r.split("-") : null; t > 0; ) {
      if (n = Iu(a.slice(0, t).join("-")), n)
        return n;
      if (r && r.length >= t && LO(a, r) >= t - 1)
        break;
      t--;
    }
    A++;
  }
  return xi;
}
function RO(e) {
  return e.match("^[^/\\\\]*$") != null;
}
function Iu(e) {
  var A = null, t;
  if (tA[e] === void 0 && typeof module < "u" && module && module.exports && RO(e))
    try {
      A = xi._abbr, t = require, t("./locale/" + e), Tr(A);
    } catch {
      tA[e] = null;
    }
  return tA[e];
}
function Tr(e, A) {
  var t;
  return e && (PA(A) ? t = dr(e) : t = md(e, A), t ? xi = t : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), xi._abbr;
}
function md(e, A) {
  if (A !== null) {
    var t, r = Qw;
    if (A.abbr = e, tA[e] != null)
      fw(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = tA[e]._config;
    else if (A.parentLocale != null)
      if (tA[A.parentLocale] != null)
        r = tA[A.parentLocale]._config;
      else if (t = Iu(A.parentLocale), t != null)
        r = t._config;
      else
        return La[A.parentLocale] || (La[A.parentLocale] = []), La[A.parentLocale].push({
          name: e,
          config: A
        }), null;
    return tA[e] = new cd(pf(r, A)), La[e] && La[e].forEach(function(n) {
      md(n.name, n.config);
    }), Tr(e), tA[e];
  } else
    return delete tA[e], null;
}
function NO(e, A) {
  if (A != null) {
    var t, r, n = Qw;
    tA[e] != null && tA[e].parentLocale != null ? tA[e].set(pf(tA[e]._config, A)) : (r = Iu(e), r != null && (n = r._config), A = pf(n, A), r == null && (A.abbr = e), t = new cd(A), t.parentLocale = tA[e], tA[e] = t), Tr(e);
  } else
    tA[e] != null && (tA[e].parentLocale != null ? (tA[e] = tA[e].parentLocale, e === Tr() && Tr(e)) : tA[e] != null && delete tA[e]);
  return tA[e];
}
function dr(e) {
  var A;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return xi;
  if (!vt(e)) {
    if (A = Iu(e), A)
      return A;
    e = [e];
  }
  return MO(e);
}
function kO() {
  return gf(tA);
}
function wd(e) {
  var A, t = e._a;
  return t && Be(e).overflow === -2 && (A = t[rr] < 0 || t[rr] > 11 ? rr : t[Ot] < 1 || t[Ot] > Qu(t[IA], t[rr]) ? Ot : t[vA] < 0 || t[vA] > 24 || t[vA] === 24 && (t[Bt] !== 0 || t[nr] !== 0 || t[cn] !== 0) ? vA : t[Bt] < 0 || t[Bt] > 59 ? Bt : t[nr] < 0 || t[nr] > 59 ? nr : t[cn] < 0 || t[cn] > 999 ? cn : -1, Be(e)._overflowDayOfYear && (A < IA || A > Ot) && (A = Ot), Be(e)._overflowWeeks && A === -1 && (A = VT), Be(e)._overflowWeekday && A === -1 && (A = WT), Be(e).overflow = A), e;
}
var PO = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, KO = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, $O = /Z|[+-]\d\d(?::?\d\d)?/, us = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], lc = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], jO = /^\/?Date\((-?\d+)/i, GO = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, VO = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Iw(e) {
  var A, t, r = e._i, n = PO.exec(r) || KO.exec(r), a, i, s, o, u = us.length, l = lc.length;
  if (n) {
    for (Be(e).iso = !0, A = 0, t = u; A < t; A++)
      if (us[A][1].exec(n[1])) {
        i = us[A][0], a = us[A][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (n[3]) {
      for (A = 0, t = l; A < t; A++)
        if (lc[A][1].exec(n[3])) {
          s = (n[2] || " ") + lc[A][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (n[4])
      if ($O.exec(n[4]))
        o = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (s || "") + (o || ""), xd(e);
  } else
    e._isValid = !1;
}
function WO(e, A, t, r, n, a) {
  var i = [
    YO(e),
    ww.indexOf(A),
    parseInt(t, 10),
    parseInt(r, 10),
    parseInt(n, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function YO(e) {
  var A = parseInt(e, 10);
  return A <= 49 ? 2e3 + A : A <= 999 ? 1900 + A : A;
}
function zO(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function XO(e, A, t) {
  if (e) {
    var r = Sw.indexOf(e), n = new Date(
      A[0],
      A[1],
      A[2]
    ).getDay();
    if (r !== n)
      return Be(t).weekdayMismatch = !0, t._isValid = !1, !1;
  }
  return !0;
}
function qO(e, A, t) {
  if (e)
    return VO[e];
  if (A)
    return 0;
  var r = parseInt(t, 10), n = r % 100, a = (r - n) / 100;
  return a * 60 + n;
}
function Dw(e) {
  var A = GO.exec(zO(e._i)), t;
  if (A) {
    if (t = WO(
      A[4],
      A[3],
      A[2],
      A[5],
      A[6],
      A[7]
    ), !XO(A[1], t, e))
      return;
    e._a = t, e._tzm = qO(A[8], A[9], A[10]), e._d = wi.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Be(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function JO(e) {
  var A = jO.exec(e._i);
  if (A !== null) {
    e._d = /* @__PURE__ */ new Date(+A[1]);
    return;
  }
  if (Iw(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Dw(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : ae.createFromInputFallback(e);
}
ae.createFromInputFallback = ut(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Jn(e, A, t) {
  return e ?? A ?? t;
}
function ZO(e) {
  var A = new Date(ae.now());
  return e._useUTC ? [
    A.getUTCFullYear(),
    A.getUTCMonth(),
    A.getUTCDate()
  ] : [A.getFullYear(), A.getMonth(), A.getDate()];
}
function yd(e) {
  var A, t, r = [], n, a, i;
  if (!e._d) {
    for (n = ZO(e), e._w && e._a[Ot] == null && e._a[rr] == null && eH(e), e._dayOfYear != null && (i = Jn(e._a[IA], n[IA]), (e._dayOfYear > oi(i) || e._dayOfYear === 0) && (Be(e)._overflowDayOfYear = !0), t = wi(i, 0, e._dayOfYear), e._a[rr] = t.getUTCMonth(), e._a[Ot] = t.getUTCDate()), A = 0; A < 3 && e._a[A] == null; ++A)
      e._a[A] = r[A] = n[A];
    for (; A < 7; A++)
      e._a[A] = r[A] = e._a[A] == null ? A === 2 ? 1 : 0 : e._a[A];
    e._a[vA] === 24 && e._a[Bt] === 0 && e._a[nr] === 0 && e._a[cn] === 0 && (e._nextDay = !0, e._a[vA] = 0), e._d = (e._useUTC ? wi : iO).apply(
      null,
      r
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[vA] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (Be(e).weekdayMismatch = !0);
  }
}
function eH(e) {
  var A, t, r, n, a, i, s, o, u;
  A = e._w, A.GG != null || A.W != null || A.E != null ? (a = 1, i = 4, t = Jn(
    A.GG,
    e._a[IA],
    yi(Ze(), 1, 4).year
  ), r = Jn(A.W, 1), n = Jn(A.E, 1), (n < 1 || n > 7) && (o = !0)) : (a = e._locale._week.dow, i = e._locale._week.doy, u = yi(Ze(), a, i), t = Jn(A.gg, e._a[IA], u.year), r = Jn(A.w, u.week), A.d != null ? (n = A.d, (n < 0 || n > 6) && (o = !0)) : A.e != null ? (n = A.e + a, (A.e < 0 || A.e > 6) && (o = !0)) : n = a), r < 1 || r > or(t, a, i) ? Be(e)._overflowWeeks = !0 : o != null ? Be(e)._overflowWeekday = !0 : (s = bw(t, r, n, a, i), e._a[IA] = s.year, e._dayOfYear = s.dayOfYear);
}
ae.ISO_8601 = function() {
};
ae.RFC_2822 = function() {
};
function xd(e) {
  if (e._f === ae.ISO_8601) {
    Iw(e);
    return;
  }
  if (e._f === ae.RFC_2822) {
    Dw(e);
    return;
  }
  e._a = [], Be(e).empty = !0;
  var A = "" + e._i, t, r, n, a, i, s = A.length, o = 0, u, l;
  for (n = dw(e._f, e._locale).match(fd) || [], l = n.length, t = 0; t < l; t++)
    a = n[t], r = (A.match($T(a, e)) || [])[0], r && (i = A.substr(0, A.indexOf(r)), i.length > 0 && Be(e).unusedInput.push(i), A = A.slice(
      A.indexOf(r) + r.length
    ), o += r.length), oa[a] ? (r ? Be(e).empty = !1 : Be(e).unusedTokens.push(a), GT(a, r, e)) : e._strict && !r && Be(e).unusedTokens.push(a);
  Be(e).charsLeftOver = s - o, A.length > 0 && Be(e).unusedInput.push(A), e._a[vA] <= 12 && Be(e).bigHour === !0 && e._a[vA] > 0 && (Be(e).bigHour = void 0), Be(e).parsedDateParts = e._a.slice(0), Be(e).meridiem = e._meridiem, e._a[vA] = AH(
    e._locale,
    e._a[vA],
    e._meridiem
  ), u = Be(e).era, u !== null && (e._a[IA] = e._locale.erasConvertYear(u, e._a[IA])), yd(e), wd(e);
}
function AH(e, A, t) {
  var r;
  return t == null ? A : e.meridiemHour != null ? e.meridiemHour(A, t) : (e.isPM != null && (r = e.isPM(t), r && A < 12 && (A += 12), !r && A === 12 && (A = 0)), A);
}
function tH(e) {
  var A, t, r, n, a, i, s = !1, o = e._f.length;
  if (o === 0) {
    Be(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (n = 0; n < o; n++)
    a = 0, i = !1, A = ld({}, e), e._useUTC != null && (A._useUTC = e._useUTC), A._f = e._f[n], xd(A), ud(A) && (i = !0), a += Be(A).charsLeftOver, a += Be(A).unusedTokens.length * 10, Be(A).score = a, s ? a < r && (r = a, t = A) : (r == null || a < r || i) && (r = a, t = A, i && (s = !0));
  Sr(e, t || A);
}
function rH(e) {
  if (!e._d) {
    var A = dd(e._i), t = A.day === void 0 ? A.date : A.day;
    e._a = lw(
      [A.year, A.month, t, A.hour, A.minute, A.second, A.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), yd(e);
  }
}
function nH(e) {
  var A = new Ki(wd(Tw(e)));
  return A._nextDay && (A.add(1, "d"), A._nextDay = void 0), A;
}
function Tw(e) {
  var A = e._i, t = e._f;
  return e._locale = e._locale || dr(e._l), A === null || t === void 0 && A === "" ? Cu({ nullInput: !0 }) : (typeof A == "string" && (e._i = A = e._locale.preparse(A)), mt(A) ? new Ki(wd(A)) : (Pi(A) ? e._d = A : vt(t) ? tH(e) : t ? xd(e) : aH(e), ud(e) || (e._d = null), e));
}
function aH(e) {
  var A = e._i;
  PA(A) ? e._d = new Date(ae.now()) : Pi(A) ? e._d = new Date(A.valueOf()) : typeof A == "string" ? JO(e) : vt(A) ? (e._a = lw(A.slice(0), function(t) {
    return parseInt(t, 10);
  }), yd(e)) : Bn(A) ? rH(e) : cr(A) ? e._d = new Date(A) : ae.createFromInputFallback(e);
}
function Ow(e, A, t, r, n) {
  var a = {};
  return (A === !0 || A === !1) && (r = A, A = void 0), (t === !0 || t === !1) && (r = t, t = void 0), (Bn(e) && od(e) || vt(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = n, a._l = t, a._i = e, a._f = A, a._strict = r, nH(a);
}
function Ze(e, A, t, r) {
  return Ow(e, A, t, r, !1);
}
var iH = ut(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ze.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Cu();
  }
), sH = ut(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Ze.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Cu();
  }
);
function Hw(e, A) {
  var t, r;
  if (A.length === 1 && vt(A[0]) && (A = A[0]), !A.length)
    return Ze();
  for (t = A[0], r = 1; r < A.length; ++r)
    (!A[r].isValid() || A[r][e](t)) && (t = A[r]);
  return t;
}
function oH() {
  var e = [].slice.call(arguments, 0);
  return Hw("isBefore", e);
}
function uH() {
  var e = [].slice.call(arguments, 0);
  return Hw("isAfter", e);
}
var lH = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, Ma = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function cH(e) {
  var A, t = !1, r, n = Ma.length;
  for (A in e)
    if (Ie(e, A) && !(lA.call(Ma, A) !== -1 && (e[A] == null || !isNaN(e[A]))))
      return !1;
  for (r = 0; r < n; ++r)
    if (e[Ma[r]]) {
      if (t)
        return !1;
      parseFloat(e[Ma[r]]) !== xe(e[Ma[r]]) && (t = !0);
    }
  return !0;
}
function fH() {
  return this._isValid;
}
function dH() {
  return xt(NaN);
}
function Du(e) {
  var A = dd(e), t = A.year || 0, r = A.quarter || 0, n = A.month || 0, a = A.week || A.isoWeek || 0, i = A.day || 0, s = A.hour || 0, o = A.minute || 0, u = A.second || 0, l = A.millisecond || 0;
  this._isValid = cH(A), this._milliseconds = +l + u * 1e3 + // 1000
  o * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +n + r * 3 + t * 12, this._data = {}, this._locale = dr(), this._bubble();
}
function qs(e) {
  return e instanceof Du;
}
function vf(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function hH(e, A, t) {
  var r = Math.min(e.length, A.length), n = Math.abs(e.length - A.length), a = 0, i;
  for (i = 0; i < r; i++)
    (t && e[i] !== A[i] || !t && xe(e[i]) !== xe(A[i])) && a++;
  return a + n;
}
function Lw(e, A) {
  le(e, 0, 0, function() {
    var t = this.utcOffset(), r = "+";
    return t < 0 && (t = -t, r = "-"), r + Nt(~~(t / 60), 2) + A + Nt(~~t % 60, 2);
  });
}
Lw("Z", ":");
Lw("ZZ", "");
se("Z", _u);
se("ZZ", _u);
$e(["Z", "ZZ"], function(e, A, t) {
  t._useUTC = !0, t._tzm = Cd(_u, e);
});
var pH = /([\+\-]|\d\d)/gi;
function Cd(e, A) {
  var t = (A || "").match(e), r, n, a;
  return t === null ? null : (r = t[t.length - 1] || [], n = (r + "").match(pH) || ["-", 0, 0], a = +(n[1] * 60) + xe(n[2]), a === 0 ? 0 : n[0] === "+" ? a : -a);
}
function Ed(e, A) {
  var t, r;
  return A._isUTC ? (t = A.clone(), r = (mt(e) || Pi(e) ? e.valueOf() : Ze(e).valueOf()) - t.valueOf(), t._d.setTime(t._d.valueOf() + r), ae.updateOffset(t, !1), t) : Ze(e).local();
}
function mf(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
ae.updateOffset = function() {
};
function gH(e, A, t) {
  var r = this._offset || 0, n;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Cd(_u, e), e === null)
        return this;
    } else
      Math.abs(e) < 16 && !t && (e = e * 60);
    return !this._isUTC && A && (n = mf(this)), this._offset = e, this._isUTC = !0, n != null && this.add(n, "m"), r !== e && (!A || this._changeInProgress ? Nw(
      this,
      xt(e - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, ae.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : mf(this);
}
function BH(e, A) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, A), this) : -this.utcOffset();
}
function vH(e) {
  return this.utcOffset(0, e);
}
function mH(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(mf(this), "m")), this;
}
function wH() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Cd(PT, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function yH(e) {
  return this.isValid() ? (e = e ? Ze(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function xH() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function CH() {
  if (!PA(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, A;
  return ld(e, this), e = Tw(e), e._a ? (A = e._isUTC ? Gt(e._a) : Ze(e._a), this._isDSTShifted = this.isValid() && hH(e._a, A.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function EH() {
  return this.isValid() ? !this._isUTC : !1;
}
function FH() {
  return this.isValid() ? this._isUTC : !1;
}
function Mw() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var bH = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, SH = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function xt(e, A) {
  var t = e, r = null, n, a, i;
  return qs(e) ? t = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : cr(e) || !isNaN(+e) ? (t = {}, A ? t[A] = +e : t.milliseconds = +e) : (r = bH.exec(e)) ? (n = r[1] === "-" ? -1 : 1, t = {
    y: 0,
    d: xe(r[Ot]) * n,
    h: xe(r[vA]) * n,
    m: xe(r[Bt]) * n,
    s: xe(r[nr]) * n,
    ms: xe(vf(r[cn] * 1e3)) * n
    // the millisecond decimal point is included in the match
  }) : (r = SH.exec(e)) ? (n = r[1] === "-" ? -1 : 1, t = {
    y: qr(r[2], n),
    M: qr(r[3], n),
    w: qr(r[4], n),
    d: qr(r[5], n),
    h: qr(r[6], n),
    m: qr(r[7], n),
    s: qr(r[8], n)
  }) : t == null ? t = {} : typeof t == "object" && ("from" in t || "to" in t) && (i = UH(
    Ze(t.from),
    Ze(t.to)
  ), t = {}, t.ms = i.milliseconds, t.M = i.months), a = new Du(t), qs(e) && Ie(e, "_locale") && (a._locale = e._locale), qs(e) && Ie(e, "_isValid") && (a._isValid = e._isValid), a;
}
xt.fn = Du.prototype;
xt.invalid = dH;
function qr(e, A) {
  var t = e && parseFloat(e.replace(",", "."));
  return (isNaN(t) ? 0 : t) * A;
}
function sg(e, A) {
  var t = {};
  return t.months = A.month() - e.month() + (A.year() - e.year()) * 12, e.clone().add(t.months, "M").isAfter(A) && --t.months, t.milliseconds = +A - +e.clone().add(t.months, "M"), t;
}
function UH(e, A) {
  var t;
  return e.isValid() && A.isValid() ? (A = Ed(A, e), e.isBefore(A) ? t = sg(e, A) : (t = sg(A, e), t.milliseconds = -t.milliseconds, t.months = -t.months), t) : { milliseconds: 0, months: 0 };
}
function Rw(e, A) {
  return function(t, r) {
    var n, a;
    return r !== null && !isNaN(+r) && (fw(
      A,
      "moment()." + A + "(period, number) is deprecated. Please use moment()." + A + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = t, t = r, r = a), n = xt(t, r), Nw(this, n, e), this;
  };
}
function Nw(e, A, t, r) {
  var n = A._milliseconds, a = vf(A._days), i = vf(A._months);
  e.isValid() && (r = r ?? !0, i && xw(e, vo(e, "Month") + i * t), a && pw(e, "Date", vo(e, "Date") + a * t), n && e._d.setTime(e._d.valueOf() + n * t), r && ae.updateOffset(e, a || i));
}
var _H = Rw(1, "add"), QH = Rw(-1, "subtract");
function kw(e) {
  return typeof e == "string" || e instanceof String;
}
function IH(e) {
  return mt(e) || Pi(e) || kw(e) || cr(e) || TH(e) || DH(e) || e === null || e === void 0;
}
function DH(e) {
  var A = Bn(e) && !od(e), t = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], n, a, i = r.length;
  for (n = 0; n < i; n += 1)
    a = r[n], t = t || Ie(e, a);
  return A && t;
}
function TH(e) {
  var A = vt(e), t = !1;
  return A && (t = e.filter(function(r) {
    return !cr(r) && kw(e);
  }).length === 0), A && t;
}
function OH(e) {
  var A = Bn(e) && !od(e), t = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], n, a;
  for (n = 0; n < r.length; n += 1)
    a = r[n], t = t || Ie(e, a);
  return A && t;
}
function HH(e, A) {
  var t = e.diff(A, "days", !0);
  return t < -6 ? "sameElse" : t < -1 ? "lastWeek" : t < 0 ? "lastDay" : t < 1 ? "sameDay" : t < 2 ? "nextDay" : t < 7 ? "nextWeek" : "sameElse";
}
function LH(e, A) {
  arguments.length === 1 && (arguments[0] ? IH(arguments[0]) ? (e = arguments[0], A = void 0) : OH(arguments[0]) && (A = arguments[0], e = void 0) : (e = void 0, A = void 0));
  var t = e || Ze(), r = Ed(t, this).startOf("day"), n = ae.calendarFormat(this, r) || "sameElse", a = A && (Vt(A[n]) ? A[n].call(this, t) : A[n]);
  return this.format(
    a || this.localeData().calendar(n, this, Ze(t))
  );
}
function MH() {
  return new Ki(this);
}
function RH(e, A) {
  var t = mt(e) ? e : Ze(e);
  return this.isValid() && t.isValid() ? (A = lt(A) || "millisecond", A === "millisecond" ? this.valueOf() > t.valueOf() : t.valueOf() < this.clone().startOf(A).valueOf()) : !1;
}
function NH(e, A) {
  var t = mt(e) ? e : Ze(e);
  return this.isValid() && t.isValid() ? (A = lt(A) || "millisecond", A === "millisecond" ? this.valueOf() < t.valueOf() : this.clone().endOf(A).valueOf() < t.valueOf()) : !1;
}
function kH(e, A, t, r) {
  var n = mt(e) ? e : Ze(e), a = mt(A) ? A : Ze(A);
  return this.isValid() && n.isValid() && a.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(n, t) : !this.isBefore(n, t)) && (r[1] === ")" ? this.isBefore(a, t) : !this.isAfter(a, t))) : !1;
}
function PH(e, A) {
  var t = mt(e) ? e : Ze(e), r;
  return this.isValid() && t.isValid() ? (A = lt(A) || "millisecond", A === "millisecond" ? this.valueOf() === t.valueOf() : (r = t.valueOf(), this.clone().startOf(A).valueOf() <= r && r <= this.clone().endOf(A).valueOf())) : !1;
}
function KH(e, A) {
  return this.isSame(e, A) || this.isAfter(e, A);
}
function $H(e, A) {
  return this.isSame(e, A) || this.isBefore(e, A);
}
function jH(e, A, t) {
  var r, n, a;
  if (!this.isValid())
    return NaN;
  if (r = Ed(e, this), !r.isValid())
    return NaN;
  switch (n = (r.utcOffset() - this.utcOffset()) * 6e4, A = lt(A), A) {
    case "year":
      a = Js(this, r) / 12;
      break;
    case "month":
      a = Js(this, r);
      break;
    case "quarter":
      a = Js(this, r) / 3;
      break;
    case "second":
      a = (this - r) / 1e3;
      break;
    case "minute":
      a = (this - r) / 6e4;
      break;
    case "hour":
      a = (this - r) / 36e5;
      break;
    case "day":
      a = (this - r - n) / 864e5;
      break;
    case "week":
      a = (this - r - n) / 6048e5;
      break;
    default:
      a = this - r;
  }
  return t ? a : tt(a);
}
function Js(e, A) {
  if (e.date() < A.date())
    return -Js(A, e);
  var t = (A.year() - e.year()) * 12 + (A.month() - e.month()), r = e.clone().add(t, "months"), n, a;
  return A - r < 0 ? (n = e.clone().add(t - 1, "months"), a = (A - r) / (r - n)) : (n = e.clone().add(t + 1, "months"), a = (A - r) / (n - r)), -(t + a) || 0;
}
ae.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ae.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function GH() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function VH(e) {
  if (!this.isValid())
    return null;
  var A = e !== !0, t = A ? this.clone().utc() : this;
  return t.year() < 0 || t.year() > 9999 ? Xs(
    t,
    A ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Vt(Date.prototype.toISOString) ? A ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Xs(t, "Z")) : Xs(
    t,
    A ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function WH() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", A = "", t, r, n, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", A = "Z"), t = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = "-MM-DD[T]HH:mm:ss.SSS", a = A + '[")]', this.format(t + r + n + a);
}
function YH(e) {
  e || (e = this.isUtc() ? ae.defaultFormatUtc : ae.defaultFormat);
  var A = Xs(this, e);
  return this.localeData().postformat(A);
}
function zH(e, A) {
  return this.isValid() && (mt(e) && e.isValid() || Ze(e).isValid()) ? xt({ to: this, from: e }).locale(this.locale()).humanize(!A) : this.localeData().invalidDate();
}
function XH(e) {
  return this.from(Ze(), e);
}
function qH(e, A) {
  return this.isValid() && (mt(e) && e.isValid() || Ze(e).isValid()) ? xt({ from: this, to: e }).locale(this.locale()).humanize(!A) : this.localeData().invalidDate();
}
function JH(e) {
  return this.to(Ze(), e);
}
function Pw(e) {
  var A;
  return e === void 0 ? this._locale._abbr : (A = dr(e), A != null && (this._locale = A), this);
}
var Kw = ut(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function $w() {
  return this._locale;
}
var yo = 1e3, ua = 60 * yo, xo = 60 * ua, jw = (365 * 400 + 97) * 24 * xo;
function la(e, A) {
  return (e % A + A) % A;
}
function Gw(e, A, t) {
  return e < 100 && e >= 0 ? new Date(e + 400, A, t) - jw : new Date(e, A, t).valueOf();
}
function Vw(e, A, t) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, A, t) - jw : Date.UTC(e, A, t);
}
function ZH(e) {
  var A, t;
  if (e = lt(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? Vw : Gw, e) {
    case "year":
      A = t(this.year(), 0, 1);
      break;
    case "quarter":
      A = t(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      A = t(this.year(), this.month(), 1);
      break;
    case "week":
      A = t(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      A = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      A = t(this.year(), this.month(), this.date());
      break;
    case "hour":
      A = this._d.valueOf(), A -= la(
        A + (this._isUTC ? 0 : this.utcOffset() * ua),
        xo
      );
      break;
    case "minute":
      A = this._d.valueOf(), A -= la(A, ua);
      break;
    case "second":
      A = this._d.valueOf(), A -= la(A, yo);
      break;
  }
  return this._d.setTime(A), ae.updateOffset(this, !0), this;
}
function eL(e) {
  var A, t;
  if (e = lt(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? Vw : Gw, e) {
    case "year":
      A = t(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      A = t(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      A = t(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      A = t(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      A = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      A = t(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      A = this._d.valueOf(), A += xo - la(
        A + (this._isUTC ? 0 : this.utcOffset() * ua),
        xo
      ) - 1;
      break;
    case "minute":
      A = this._d.valueOf(), A += ua - la(A, ua) - 1;
      break;
    case "second":
      A = this._d.valueOf(), A += yo - la(A, yo) - 1;
      break;
  }
  return this._d.setTime(A), ae.updateOffset(this, !0), this;
}
function AL() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function tL() {
  return Math.floor(this.valueOf() / 1e3);
}
function rL() {
  return new Date(this.valueOf());
}
function nL() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function aL() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function iL() {
  return this.isValid() ? this.toISOString() : null;
}
function sL() {
  return ud(this);
}
function oL() {
  return Sr({}, Be(this));
}
function uL() {
  return Be(this).overflow;
}
function lL() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
le("N", 0, 0, "eraAbbr");
le("NN", 0, 0, "eraAbbr");
le("NNN", 0, 0, "eraAbbr");
le("NNNN", 0, 0, "eraName");
le("NNNNN", 0, 0, "eraNarrow");
le("y", ["y", 1], "yo", "eraYear");
le("y", ["yy", 2], 0, "eraYear");
le("y", ["yyy", 3], 0, "eraYear");
le("y", ["yyyy", 4], 0, "eraYear");
se("N", Fd);
se("NN", Fd);
se("NNN", Fd);
se("NNNN", yL);
se("NNNNN", xL);
$e(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, A, t, r) {
    var n = t._locale.erasParse(e, r, t._strict);
    n ? Be(t).era = n : Be(t).invalidEra = e;
  }
);
se("y", Sa);
se("yy", Sa);
se("yyy", Sa);
se("yyyy", Sa);
se("yo", CL);
$e(["y", "yy", "yyy", "yyyy"], IA);
$e(["yo"], function(e, A, t, r) {
  var n;
  t._locale._eraYearOrdinalRegex && (n = e.match(t._locale._eraYearOrdinalRegex)), t._locale.eraYearOrdinalParse ? A[IA] = t._locale.eraYearOrdinalParse(e, n) : A[IA] = parseInt(e, 10);
});
function cL(e, A) {
  var t, r, n, a = this._eras || dr("en")._eras;
  for (t = 0, r = a.length; t < r; ++t) {
    switch (typeof a[t].since) {
      case "string":
        n = ae(a[t].since).startOf("day"), a[t].since = n.valueOf();
        break;
    }
    switch (typeof a[t].until) {
      case "undefined":
        a[t].until = 1 / 0;
        break;
      case "string":
        n = ae(a[t].until).startOf("day").valueOf(), a[t].until = n.valueOf();
        break;
    }
  }
  return a;
}
function fL(e, A, t) {
  var r, n, a = this.eras(), i, s, o;
  for (e = e.toUpperCase(), r = 0, n = a.length; r < n; ++r)
    if (i = a[r].name.toUpperCase(), s = a[r].abbr.toUpperCase(), o = a[r].narrow.toUpperCase(), t)
      switch (A) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[r];
          break;
        case "NNNN":
          if (i === e)
            return a[r];
          break;
        case "NNNNN":
          if (o === e)
            return a[r];
          break;
      }
    else if ([i, s, o].indexOf(e) >= 0)
      return a[r];
}
function dL(e, A) {
  var t = e.since <= e.until ? 1 : -1;
  return A === void 0 ? ae(e.since).year() : ae(e.since).year() + (A - e.offset) * t;
}
function hL() {
  var e, A, t, r = this.localeData().eras();
  for (e = 0, A = r.length; e < A; ++e)
    if (t = this.clone().startOf("day").valueOf(), r[e].since <= t && t <= r[e].until || r[e].until <= t && t <= r[e].since)
      return r[e].name;
  return "";
}
function pL() {
  var e, A, t, r = this.localeData().eras();
  for (e = 0, A = r.length; e < A; ++e)
    if (t = this.clone().startOf("day").valueOf(), r[e].since <= t && t <= r[e].until || r[e].until <= t && t <= r[e].since)
      return r[e].narrow;
  return "";
}
function gL() {
  var e, A, t, r = this.localeData().eras();
  for (e = 0, A = r.length; e < A; ++e)
    if (t = this.clone().startOf("day").valueOf(), r[e].since <= t && t <= r[e].until || r[e].until <= t && t <= r[e].since)
      return r[e].abbr;
  return "";
}
function BL() {
  var e, A, t, r, n = this.localeData().eras();
  for (e = 0, A = n.length; e < A; ++e)
    if (t = n[e].since <= n[e].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return (this.year() - ae(n[e].since).year()) * t + n[e].offset;
  return this.year();
}
function vL(e) {
  return Ie(this, "_erasNameRegex") || bd.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function mL(e) {
  return Ie(this, "_erasAbbrRegex") || bd.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function wL(e) {
  return Ie(this, "_erasNarrowRegex") || bd.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Fd(e, A) {
  return A.erasAbbrRegex(e);
}
function yL(e, A) {
  return A.erasNameRegex(e);
}
function xL(e, A) {
  return A.erasNarrowRegex(e);
}
function CL(e, A) {
  return A._eraYearOrdinalRegex || Sa;
}
function bd() {
  var e = [], A = [], t = [], r = [], n, a, i = this.eras();
  for (n = 0, a = i.length; n < a; ++n)
    A.push(YA(i[n].name)), e.push(YA(i[n].abbr)), t.push(YA(i[n].narrow)), r.push(YA(i[n].name)), r.push(YA(i[n].abbr)), r.push(YA(i[n].narrow));
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + A.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
le(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
le(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Tu(e, A) {
  le(0, [e, e.length], 0, A);
}
Tu("gggg", "weekYear");
Tu("ggggg", "weekYear");
Tu("GGGG", "isoWeekYear");
Tu("GGGGG", "isoWeekYear");
TA("weekYear", "gg");
TA("isoWeekYear", "GG");
OA("weekYear", 1);
OA("isoWeekYear", 1);
se("G", Uu);
se("g", Uu);
se("GG", eA, qA);
se("gg", eA, qA);
se("GGGG", pd, hd);
se("gggg", pd, hd);
se("GGGGG", Su, Fu);
se("ggggg", Su, Fu);
ji(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, A, t, r) {
    A[r.substr(0, 2)] = xe(e);
  }
);
ji(["gg", "GG"], function(e, A, t, r) {
  A[r] = ae.parseTwoDigitYear(e);
});
function EL(e) {
  return Ww.call(
    this,
    e,
    this.week(),
    this.weekday(),
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function FL(e) {
  return Ww.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function bL() {
  return or(this.year(), 1, 4);
}
function SL() {
  return or(this.isoWeekYear(), 1, 4);
}
function UL() {
  var e = this.localeData()._week;
  return or(this.year(), e.dow, e.doy);
}
function _L() {
  var e = this.localeData()._week;
  return or(this.weekYear(), e.dow, e.doy);
}
function Ww(e, A, t, r, n) {
  var a;
  return e == null ? yi(this, r, n).year : (a = or(e, r, n), A > a && (A = a), QL.call(this, e, A, t, r, n));
}
function QL(e, A, t, r, n) {
  var a = bw(e, A, t, r, n), i = wi(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
le("Q", 0, "Qo", "quarter");
TA("quarter", "Q");
OA("quarter", 7);
se("Q", gw);
$e("Q", function(e, A) {
  A[rr] = (xe(e) - 1) * 3;
});
function IL(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
le("D", ["DD", 2], "Do", "date");
TA("date", "D");
OA("date", 9);
se("D", eA);
se("DD", eA, qA);
se("Do", function(e, A) {
  return e ? A._dayOfMonthOrdinalParse || A._ordinalParse : A._dayOfMonthOrdinalParseLenient;
});
$e(["D", "DD"], Ot);
$e("Do", function(e, A) {
  A[Ot] = xe(e.match(eA)[0]);
});
var Yw = ba("Date", !0);
le("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
TA("dayOfYear", "DDD");
OA("dayOfYear", 4);
se("DDD", bu);
se("DDDD", Bw);
$e(["DDD", "DDDD"], function(e, A, t) {
  t._dayOfYear = xe(e);
});
function DL(e) {
  var A = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? A : this.add(e - A, "d");
}
le("m", ["mm", 2], 0, "minute");
TA("minute", "m");
OA("minute", 14);
se("m", eA);
se("mm", eA, qA);
$e(["m", "mm"], Bt);
var TL = ba("Minutes", !1);
le("s", ["ss", 2], 0, "second");
TA("second", "s");
OA("second", 15);
se("s", eA);
se("ss", eA, qA);
$e(["s", "ss"], nr);
var OL = ba("Seconds", !1);
le("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
le(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
le(0, ["SSS", 3], 0, "millisecond");
le(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
le(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
le(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
le(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
le(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
le(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
TA("millisecond", "ms");
OA("millisecond", 16);
se("S", bu, gw);
se("SS", bu, qA);
se("SSS", bu, Bw);
var Ur, zw;
for (Ur = "SSSS"; Ur.length <= 9; Ur += "S")
  se(Ur, Sa);
function HL(e, A) {
  A[cn] = xe(("0." + e) * 1e3);
}
for (Ur = "S"; Ur.length <= 9; Ur += "S")
  $e(Ur, HL);
zw = ba("Milliseconds", !1);
le("z", 0, 0, "zoneAbbr");
le("zz", 0, 0, "zoneName");
function LL() {
  return this._isUTC ? "UTC" : "";
}
function ML() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var q = Ki.prototype;
q.add = _H;
q.calendar = LH;
q.clone = MH;
q.diff = jH;
q.endOf = eL;
q.format = YH;
q.from = zH;
q.fromNow = XH;
q.to = qH;
q.toNow = JH;
q.get = NT;
q.invalidAt = uL;
q.isAfter = RH;
q.isBefore = NH;
q.isBetween = kH;
q.isSame = PH;
q.isSameOrAfter = KH;
q.isSameOrBefore = $H;
q.isValid = sL;
q.lang = Kw;
q.locale = Pw;
q.localeData = $w;
q.max = sH;
q.min = iH;
q.parsingFlags = oL;
q.set = kT;
q.startOf = ZH;
q.subtract = QH;
q.toArray = nL;
q.toObject = aL;
q.toDate = rL;
q.toISOString = VH;
q.inspect = WH;
typeof Symbol < "u" && Symbol.for != null && (q[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
q.toJSON = iL;
q.toString = GH;
q.unix = tL;
q.valueOf = AL;
q.creationData = lL;
q.eraName = hL;
q.eraNarrow = pL;
q.eraAbbr = gL;
q.eraYear = BL;
q.year = Fw;
q.isLeapYear = aO;
q.weekYear = EL;
q.isoWeekYear = FL;
q.quarter = q.quarters = IL;
q.month = Cw;
q.daysInMonth = tO;
q.week = q.weeks = cO;
q.isoWeek = q.isoWeeks = fO;
q.weeksInYear = UL;
q.weeksInWeekYear = _L;
q.isoWeeksInYear = bL;
q.isoWeeksInISOWeekYear = SL;
q.date = Yw;
q.day = q.days = FO;
q.weekday = bO;
q.isoWeekday = SO;
q.dayOfYear = DL;
q.hour = q.hours = OO;
q.minute = q.minutes = TL;
q.second = q.seconds = OL;
q.millisecond = q.milliseconds = zw;
q.utcOffset = gH;
q.utc = vH;
q.local = mH;
q.parseZone = wH;
q.hasAlignedHourOffset = yH;
q.isDST = xH;
q.isLocal = EH;
q.isUtcOffset = FH;
q.isUtc = Mw;
q.isUTC = Mw;
q.zoneAbbr = LL;
q.zoneName = ML;
q.dates = ut(
  "dates accessor is deprecated. Use date instead.",
  Yw
);
q.months = ut(
  "months accessor is deprecated. Use month instead",
  Cw
);
q.years = ut(
  "years accessor is deprecated. Use year instead",
  Fw
);
q.zone = ut(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  BH
);
q.isDSTShifted = ut(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  CH
);
function RL(e) {
  return Ze(e * 1e3);
}
function NL() {
  return Ze.apply(null, arguments).parseZone();
}
function Xw(e) {
  return e;
}
var De = cd.prototype;
De.calendar = FT;
De.longDateFormat = _T;
De.invalidDate = IT;
De.ordinal = OT;
De.preparse = Xw;
De.postformat = Xw;
De.relativeTime = LT;
De.pastFuture = MT;
De.set = CT;
De.eras = cL;
De.erasParse = fL;
De.erasConvertYear = dL;
De.erasAbbrRegex = mL;
De.erasNameRegex = vL;
De.erasNarrowRegex = wL;
De.months = JT;
De.monthsShort = ZT;
De.monthsParse = AO;
De.monthsRegex = nO;
De.monthsShortRegex = rO;
De.week = sO;
De.firstDayOfYear = lO;
De.firstDayOfWeek = uO;
De.weekdays = wO;
De.weekdaysMin = xO;
De.weekdaysShort = yO;
De.weekdaysParse = EO;
De.weekdaysRegex = UO;
De.weekdaysShortRegex = _O;
De.weekdaysMinRegex = QO;
De.isPM = DO;
De.meridiem = HO;
function Co(e, A, t, r) {
  var n = dr(), a = Gt().set(r, A);
  return n[t](a, e);
}
function qw(e, A, t) {
  if (cr(e) && (A = e, e = void 0), e = e || "", A != null)
    return Co(e, A, t, "month");
  var r, n = [];
  for (r = 0; r < 12; r++)
    n[r] = Co(e, r, t, "month");
  return n;
}
function Sd(e, A, t, r) {
  typeof e == "boolean" ? (cr(A) && (t = A, A = void 0), A = A || "") : (A = e, t = A, e = !1, cr(A) && (t = A, A = void 0), A = A || "");
  var n = dr(), a = e ? n._week.dow : 0, i, s = [];
  if (t != null)
    return Co(A, (t + a) % 7, r, "day");
  for (i = 0; i < 7; i++)
    s[i] = Co(A, (i + a) % 7, r, "day");
  return s;
}
function kL(e, A) {
  return qw(e, A, "months");
}
function PL(e, A) {
  return qw(e, A, "monthsShort");
}
function KL(e, A, t) {
  return Sd(e, A, t, "weekdays");
}
function $L(e, A, t) {
  return Sd(e, A, t, "weekdaysShort");
}
function jL(e, A, t) {
  return Sd(e, A, t, "weekdaysMin");
}
Tr("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var A = e % 10, t = xe(e % 100 / 10) === 1 ? "th" : A === 1 ? "st" : A === 2 ? "nd" : A === 3 ? "rd" : "th";
    return e + t;
  }
});
ae.lang = ut(
  "moment.lang is deprecated. Use moment.locale instead.",
  Tr
);
ae.langData = ut(
  "moment.langData is deprecated. Use moment.localeData instead.",
  dr
);
var qt = Math.abs;
function GL() {
  var e = this._data;
  return this._milliseconds = qt(this._milliseconds), this._days = qt(this._days), this._months = qt(this._months), e.milliseconds = qt(e.milliseconds), e.seconds = qt(e.seconds), e.minutes = qt(e.minutes), e.hours = qt(e.hours), e.months = qt(e.months), e.years = qt(e.years), this;
}
function Jw(e, A, t, r) {
  var n = xt(A, t);
  return e._milliseconds += r * n._milliseconds, e._days += r * n._days, e._months += r * n._months, e._bubble();
}
function VL(e, A) {
  return Jw(this, e, A, 1);
}
function WL(e, A) {
  return Jw(this, e, A, -1);
}
function og(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function YL() {
  var e = this._milliseconds, A = this._days, t = this._months, r = this._data, n, a, i, s, o;
  return e >= 0 && A >= 0 && t >= 0 || e <= 0 && A <= 0 && t <= 0 || (e += og(wf(t) + A) * 864e5, A = 0, t = 0), r.milliseconds = e % 1e3, n = tt(e / 1e3), r.seconds = n % 60, a = tt(n / 60), r.minutes = a % 60, i = tt(a / 60), r.hours = i % 24, A += tt(i / 24), o = tt(Zw(A)), t += o, A -= og(wf(o)), s = tt(t / 12), t %= 12, r.days = A, r.months = t, r.years = s, this;
}
function Zw(e) {
  return e * 4800 / 146097;
}
function wf(e) {
  return e * 146097 / 4800;
}
function zL(e) {
  if (!this.isValid())
    return NaN;
  var A, t, r = this._milliseconds;
  if (e = lt(e), e === "month" || e === "quarter" || e === "year")
    switch (A = this._days + r / 864e5, t = this._months + Zw(A), e) {
      case "month":
        return t;
      case "quarter":
        return t / 3;
      case "year":
        return t / 12;
    }
  else
    switch (A = this._days + Math.round(wf(this._months)), e) {
      case "week":
        return A / 7 + r / 6048e5;
      case "day":
        return A + r / 864e5;
      case "hour":
        return A * 24 + r / 36e5;
      case "minute":
        return A * 1440 + r / 6e4;
      case "second":
        return A * 86400 + r / 1e3;
      case "millisecond":
        return Math.floor(A * 864e5) + r;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function XL() {
  return this.isValid() ? this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + xe(this._months / 12) * 31536e6 : NaN;
}
function hr(e) {
  return function() {
    return this.as(e);
  };
}
var qL = hr("ms"), JL = hr("s"), ZL = hr("m"), e8 = hr("h"), A8 = hr("d"), t8 = hr("w"), r8 = hr("M"), n8 = hr("Q"), a8 = hr("y");
function i8() {
  return xt(this);
}
function s8(e) {
  return e = lt(e), this.isValid() ? this[e + "s"]() : NaN;
}
function In(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var o8 = In("milliseconds"), u8 = In("seconds"), l8 = In("minutes"), c8 = In("hours"), f8 = In("days"), d8 = In("months"), h8 = In("years");
function p8() {
  return tt(this.days() / 7);
}
var Ar = Math.round, ra = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function g8(e, A, t, r, n) {
  return n.relativeTime(A || 1, !!t, e, r);
}
function B8(e, A, t, r) {
  var n = xt(e).abs(), a = Ar(n.as("s")), i = Ar(n.as("m")), s = Ar(n.as("h")), o = Ar(n.as("d")), u = Ar(n.as("M")), l = Ar(n.as("w")), c = Ar(n.as("y")), f = a <= t.ss && ["s", a] || a < t.s && ["ss", a] || i <= 1 && ["m"] || i < t.m && ["mm", i] || s <= 1 && ["h"] || s < t.h && ["hh", s] || o <= 1 && ["d"] || o < t.d && ["dd", o];
  return t.w != null && (f = f || l <= 1 && ["w"] || l < t.w && ["ww", l]), f = f || u <= 1 && ["M"] || u < t.M && ["MM", u] || c <= 1 && ["y"] || ["yy", c], f[2] = A, f[3] = +e > 0, f[4] = r, g8.apply(null, f);
}
function v8(e) {
  return e === void 0 ? Ar : typeof e == "function" ? (Ar = e, !0) : !1;
}
function m8(e, A) {
  return ra[e] === void 0 ? !1 : A === void 0 ? ra[e] : (ra[e] = A, e === "s" && (ra.ss = A - 1), !0);
}
function w8(e, A) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = !1, r = ra, n, a;
  return typeof e == "object" && (A = e, e = !1), typeof e == "boolean" && (t = e), typeof A == "object" && (r = Object.assign({}, ra, A), A.s != null && A.ss == null && (r.ss = A.s - 1)), n = this.localeData(), a = B8(this, !t, r, n), t && (a = n.pastFuture(+this, a)), n.postformat(a);
}
var cc = Math.abs;
function kn(e) {
  return (e > 0) - (e < 0) || +e;
}
function Ou() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = cc(this._milliseconds) / 1e3, A = cc(this._days), t = cc(this._months), r, n, a, i, s = this.asSeconds(), o, u, l, c;
  return s ? (r = tt(e / 60), n = tt(r / 60), e %= 60, r %= 60, a = tt(t / 12), t %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", o = s < 0 ? "-" : "", u = kn(this._months) !== kn(s) ? "-" : "", l = kn(this._days) !== kn(s) ? "-" : "", c = kn(this._milliseconds) !== kn(s) ? "-" : "", o + "P" + (a ? u + a + "Y" : "") + (t ? u + t + "M" : "") + (A ? l + A + "D" : "") + (n || r || e ? "T" : "") + (n ? c + n + "H" : "") + (r ? c + r + "M" : "") + (e ? c + i + "S" : "")) : "P0D";
}
var Se = Du.prototype;
Se.isValid = fH;
Se.abs = GL;
Se.add = VL;
Se.subtract = WL;
Se.as = zL;
Se.asMilliseconds = qL;
Se.asSeconds = JL;
Se.asMinutes = ZL;
Se.asHours = e8;
Se.asDays = A8;
Se.asWeeks = t8;
Se.asMonths = r8;
Se.asQuarters = n8;
Se.asYears = a8;
Se.valueOf = XL;
Se._bubble = YL;
Se.clone = i8;
Se.get = s8;
Se.milliseconds = o8;
Se.seconds = u8;
Se.minutes = l8;
Se.hours = c8;
Se.days = f8;
Se.weeks = p8;
Se.months = d8;
Se.years = h8;
Se.humanize = w8;
Se.toISOString = Ou;
Se.toString = Ou;
Se.toJSON = Ou;
Se.locale = Pw;
Se.localeData = $w;
Se.toIsoString = ut(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Ou
);
Se.lang = Kw;
le("X", 0, 0, "unix");
le("x", 0, 0, "valueOf");
se("x", Uu);
se("X", KT);
$e("X", function(e, A, t) {
  t._d = new Date(parseFloat(e) * 1e3);
});
$e("x", function(e, A, t) {
  t._d = new Date(xe(e));
});
//! moment.js
ae.version = "2.29.4";
yT(Ze);
ae.fn = q;
ae.min = oH;
ae.max = uH;
ae.now = lH;
ae.utc = Gt;
ae.unix = RL;
ae.months = kL;
ae.isDate = Pi;
ae.locale = Tr;
ae.invalid = Cu;
ae.duration = xt;
ae.isMoment = mt;
ae.weekdays = KL;
ae.parseZone = NL;
ae.localeData = dr;
ae.isDuration = qs;
ae.monthsShort = PL;
ae.weekdaysMin = jL;
ae.defineLocale = md;
ae.updateLocale = NO;
ae.locales = kO;
ae.weekdaysShort = $L;
ae.normalizeUnits = lt;
ae.relativeTimeRounding = v8;
ae.relativeTimeThreshold = m8;
ae.calendarFormat = HH;
ae.prototype = q;
ae.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var y8 = Object.assign || function(A) {
  for (var t, r = 1, n = arguments.length; r < n; r++) {
    t = arguments[r];
    for (var a in t)
      Object.prototype.hasOwnProperty.call(t, a) && (A[a] = t[a]);
  }
  return A;
}, x8 = [
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)$/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/]
], C8 = [
  "Windows Phone",
  "Android",
  "CentOS",
  { name: "Chrome OS", pattern: "CrOS" },
  "Debian",
  "Fedora",
  "FreeBSD",
  "Gentoo",
  "Haiku",
  "Kubuntu",
  "Linux Mint",
  "OpenBSD",
  "Red Hat",
  "SuSE",
  "Ubuntu",
  "Xubuntu",
  "Cygwin",
  "Symbian OS",
  "hpwOS",
  "webOS ",
  "webOS",
  "Tablet OS",
  "Tizen",
  "Linux",
  "Mac OS X",
  "Macintosh",
  "Mac",
  "Windows 98;",
  "Windows "
], E8 = {
  "10.0": "10",
  "6.4": "10 Technical Preview",
  "6.3": "8.1",
  "6.2": "8",
  "6.1": "Server 2008 R2 / 7",
  "6.0": "Server 2008 / Vista",
  "5.2": "Server 2003 / XP 64-bit",
  "5.1": "XP",
  "5.01": "2000 SP1",
  "5.0": "2000",
  "4.0": "NT",
  "4.90": "ME"
}, F8 = new RegExp([
  "(android|bb\\d+|meego).+mobile|avantgo|bada\\/|blackberry|blazer|",
  "compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|",
  "midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)",
  "\\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\\.(browser|link)|vodafone|",
  "wap|windows ce|xda|xiino"
].join(""), "i"), b8 = new RegExp([
  "1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|",
  "ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|",
  "avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|",
  "cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|",
  "ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|",
  "g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|",
  "hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|",
  "i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|",
  "kddi|keji|kgt( |\\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|\\-[a-w])",
  "|libw|lynx|m1\\-w|m3ga|m50\\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|",
  "mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|",
  "n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|",
  "op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|",
  "po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|",
  "raks|rim9|ro(ve|zo)|s55\\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\\/|",
  "se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|k\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|",
  "so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|",
  "tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|",
  "veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|",
  "w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-"
].join(""), "i"), S8 = (
  /** @class */
  function() {
    function e(A, t, r) {
      this.navigator = t, this.process = r, this.userAgent = A || (this.navigator ? t.userAgent || t.vendor : "");
    }
    return e.prototype.detect = function() {
      if (this.process && !this.userAgent) {
        var A = this.process.version.slice(1).split(".").slice(0, 3), t = Array.prototype.slice.call(A, 1).join("") || "0";
        return {
          name: "node",
          version: A.join("."),
          versionNumber: parseFloat(A[0] + "." + t),
          mobile: !1,
          os: this.process.platform
        };
      }
      return this.userAgent || this.handleMissingError(), y8({}, this.checkBrowser(), this.checkMobile(), this.checkOs());
    }, e.prototype.checkBrowser = function() {
      var A = this;
      return x8.filter(function(t) {
        return t[1].test(A.userAgent);
      }).map(function(t) {
        var r = t[1].exec(A.userAgent), n = r && r[1].split(/[._]/).slice(0, 3), a = Array.prototype.slice.call(n, 1).join("") || "0";
        return n && n.length < 3 && Array.prototype.push.apply(n, n.length === 1 ? [0, 0] : [0]), {
          name: String(t[0]),
          version: n.join("."),
          versionNumber: +(n[0] + "." + a)
        };
      }).shift();
    }, e.prototype.checkMobile = function() {
      var A = this.userAgent.substr(0, 4), t = F8.test(this.userAgent) || b8.test(A);
      return { mobile: t };
    }, e.prototype.checkOs = function() {
      var A = this;
      return C8.map(function(t) {
        var r = t.name || t, n = A.getOsPattern(t);
        return {
          name: r,
          pattern: n,
          value: RegExp("\\b" + n.replace(/([ -])(?!$)/g, "$1?") + "(?:x?[\\d._]+|[ \\w.]*)", "i").exec(A.userAgent)
        };
      }).filter(function(t) {
        return t.value;
      }).map(function(t) {
        var r = t.value[0] || "", n;
        return t.pattern && t.name && /^Win/i.test(r) && !/^Windows Phone /i.test(r) && (n = E8[r.replace(/[^\d.]/g, "")]) && (r = "Windows " + n), t.pattern && t.name && (r = r.replace(RegExp(t.pattern, "i"), t.name)), r = r.replace(/ ce$/i, " CE").replace(/\bhpw/i, "web").replace(/\bMacintosh\b/, "Mac OS").replace(/_PowerPC\b/i, " OS").replace(/\b(OS X) [^ \d]+/i, "$1").replace(/\bMac (OS X)\b/, "$1").replace(/\/(\d)/, " $1").replace(/_/g, ".").replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, "").replace(/\bx86\.64\b/gi, "x86_64").replace(/\b(Windows Phone) OS\b/, "$1").replace(/\b(Chrome OS \w+) [\d.]+\b/, "$1").split(" on ")[0].trim(), r = /^(?:webOS|i(?:OS|P))/.test(r) ? r : r.charAt(0).toUpperCase() + r.slice(1), { os: r };
      }).shift();
    }, e.prototype.getOsPattern = function(A) {
      var t = A;
      return (typeof A == "string" ? A : void 0) || t.pattern || t.name;
    }, e.prototype.handleMissingError = function() {
      throw new Error(`Please give user-agent.
> browser(navigator.userAgent or res.headers['user-agent']).`);
    }, e;
  }()
);
function Gi(e, A) {
  return A = { exports: {} }, e(A, A.exports), A.exports;
}
var gt = Gi(function(e) {
  var A = e.exports = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")();
  typeof __g == "number" && (__g = A);
}), Rt = Gi(function(e) {
  var A = e.exports = { version: "2.5.7" };
  typeof __e == "number" && (__e = A);
});
Rt.version;
var _r = function(e) {
  return typeof e == "object" ? e !== null : typeof e == "function";
}, ug = function(e) {
  if (!_r(e))
    throw TypeError(e + " is not an object!");
  return e;
}, Hu = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, Ud = !Hu(function() {
  return Object.defineProperty({}, "a", { get: function() {
    return 7;
  } }).a != 7;
}), yf = gt.document, U8 = _r(yf) && _r(yf.createElement), _8 = function(e) {
  return U8 ? yf.createElement(e) : {};
}, Q8 = !Ud && !Hu(function() {
  return Object.defineProperty(_8("div"), "a", { get: function() {
    return 7;
  } }).a != 7;
}), I8 = function(e, A) {
  if (!_r(e))
    return e;
  var t, r;
  if (A && typeof (t = e.toString) == "function" && !_r(r = t.call(e)) || typeof (t = e.valueOf) == "function" && !_r(r = t.call(e)) || !A && typeof (t = e.toString) == "function" && !_r(r = t.call(e)))
    return r;
  throw TypeError("Can't convert object to primitive value");
}, D8 = Object.defineProperty, T8 = Ud ? Object.defineProperty : function(A, t, r) {
  if (ug(A), t = I8(t, !0), ug(r), Q8)
    try {
      return D8(A, t, r);
    } catch {
    }
  if ("get" in r || "set" in r)
    throw TypeError("Accessors not supported!");
  return "value" in r && (A[t] = r.value), A;
}, O8 = {
  f: T8
}, H8 = function(e, A) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: A
  };
}, Wa = Ud ? function(e, A, t) {
  return O8.f(e, A, H8(1, t));
} : function(e, A, t) {
  return e[A] = t, e;
}, L8 = {}.hasOwnProperty, lg = function(e, A) {
  return L8.call(e, A);
}, M8 = 0, R8 = Math.random(), ey = function(e) {
  return "Symbol(".concat(e === void 0 ? "" : e, ")_", (++M8 + R8).toString(36));
}, N8 = Gi(function(e) {
  var A = ey("src"), t = "toString", r = Function[t], n = ("" + r).split(t);
  Rt.inspectSource = function(a) {
    return r.call(a);
  }, (e.exports = function(a, i, s, o) {
    var u = typeof s == "function";
    u && (lg(s, "name") || Wa(s, "name", i)), a[i] !== s && (u && (lg(s, A) || Wa(s, A, a[i] ? "" + a[i] : n.join(String(i)))), a === gt ? a[i] = s : o ? a[i] ? a[i] = s : Wa(a, i, s) : (delete a[i], Wa(a, i, s)));
  })(Function.prototype, t, function() {
    return typeof this == "function" && this[A] || r.call(this);
  });
}), k8 = function(e) {
  if (typeof e != "function")
    throw TypeError(e + " is not a function!");
  return e;
}, xf = function(e, A, t) {
  if (k8(e), A === void 0)
    return e;
  switch (t) {
    case 1:
      return function(r) {
        return e.call(A, r);
      };
    case 2:
      return function(r, n) {
        return e.call(A, r, n);
      };
    case 3:
      return function(r, n, a) {
        return e.call(A, r, n, a);
      };
  }
  return function() {
    return e.apply(A, arguments);
  };
}, fc = "prototype", RA = function(e, A, t) {
  var r = e & RA.F, n = e & RA.G, a = e & RA.S, i = e & RA.P, s = e & RA.B, o = n ? gt : a ? gt[A] || (gt[A] = {}) : (gt[A] || {})[fc], u = n ? Rt : Rt[A] || (Rt[A] = {}), l = u[fc] || (u[fc] = {}), c, f, d, h;
  n && (t = A);
  for (c in t)
    f = !r && o && o[c] !== void 0, d = (f ? o : t)[c], h = s && f ? xf(d, gt) : i && typeof d == "function" ? xf(Function.call, d) : d, o && N8(o, c, d, e & RA.U), u[c] != d && Wa(u, c, h), i && l[c] != d && (l[c] = d);
};
gt.core = Rt;
RA.F = 1;
RA.G = 2;
RA.S = 4;
RA.P = 8;
RA.B = 16;
RA.W = 32;
RA.U = 64;
RA.R = 128;
var ur = RA, P8 = {}.toString, Ay = function(e) {
  return P8.call(e).slice(8, -1);
}, K8 = Object("z").propertyIsEnumerable(0) ? Object : function(e) {
  return Ay(e) == "String" ? e.split("") : Object(e);
}, ty = function(e) {
  if (e == null)
    throw TypeError("Can't call method on  " + e);
  return e;
}, $8 = function(e) {
  return Object(ty(e));
}, j8 = Math.ceil, G8 = Math.floor, V8 = function(e) {
  return isNaN(e = +e) ? 0 : (e > 0 ? G8 : j8)(e);
}, W8 = Math.min, Y8 = function(e) {
  return e > 0 ? W8(V8(e), 9007199254740991) : 0;
}, cg = Array.isArray || function(A) {
  return Ay(A) == "Array";
}, z8 = Gi(function(e) {
  var A = "__core-js_shared__", t = gt[A] || (gt[A] = {});
  (e.exports = function(r, n) {
    return t[r] || (t[r] = n !== void 0 ? n : {});
  })("versions", []).push({
    version: Rt.version,
    mode: "global",
    copyright: "© 2018 Denis Pushkarev (zloirock.ru)"
  });
}), X8 = Gi(function(e) {
  var A = z8("wks"), t = gt.Symbol, r = typeof t == "function", n = e.exports = function(a) {
    return A[a] || (A[a] = r && t[a] || (r ? t : ey)("Symbol." + a));
  };
  n.store = A;
}), q8 = X8("species"), J8 = function(e) {
  var A;
  return cg(e) && (A = e.constructor, typeof A == "function" && (A === Array || cg(A.prototype)) && (A = void 0), _r(A) && (A = A[q8], A === null && (A = void 0))), A === void 0 ? Array : A;
}, Z8 = function(e, A) {
  return new (J8(e))(A);
}, ry = function(e, A) {
  var t = e == 1, r = e == 2, n = e == 3, a = e == 4, i = e == 6, s = e == 5 || i, o = A || Z8;
  return function(u, l, c) {
    for (var f = $8(u), d = K8(f), h = xf(l, c, 3), p = Y8(d.length), v = 0, y = t ? o(u, p) : r ? o(u, 0) : void 0, g, B; p > v; v++)
      if ((s || v in d) && (g = d[v], B = h(g, v, f), e)) {
        if (t)
          y[v] = B;
        else if (B)
          switch (e) {
            case 3:
              return !0;
            case 5:
              return g;
            case 6:
              return v;
            case 2:
              y.push(g);
          }
        else if (a)
          return !1;
      }
    return i ? -1 : n || a ? a : y;
  };
}, ny = function(e, A) {
  return !!e && Hu(function() {
    A ? e.call(null, function() {
    }, 1) : e.call(null);
  });
}, eM = ry(2);
ur(ur.P + ur.F * !ny([].filter, !0), "Array", {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function(A) {
    return eM(this, A, arguments[1]);
  }
});
Rt.Array.filter;
var AM = ry(1);
ur(ur.P + ur.F * !ny([].map, !0), "Array", {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function(A) {
    return AM(this, A, arguments[1]);
  }
});
Rt.Array.map;
var Cf = `	
\v\f\r   ᠎             　\u2028\u2029\uFEFF`, Eo = "[" + Cf + "]", fg = "​", tM = RegExp("^" + Eo + Eo + "*"), rM = RegExp(Eo + Eo + "*$"), ay = function(e, A, t) {
  var r = {}, n = Hu(function() {
    return !!Cf[e]() || fg[e]() != fg;
  }), a = r[e] = n ? A(nM) : Cf[e];
  t && (r[t] = a), ur(ur.P + ur.F * n, "String", r);
}, nM = ay.trim = function(e, A) {
  return e = String(ty(e)), A & 1 && (e = e.replace(tM, "")), A & 2 && (e = e.replace(rM, "")), e;
}, aM = ay;
aM("trim", function(e) {
  return function() {
    return e(this, 3);
  };
});
Rt.String.trim;
var iM = typeof window < "u" ? window.navigator : void 0, sM = typeof process < "u" ? process : void 0;
function DAe(e) {
  var A = new S8(e, iM, sM);
  return A.detect();
}
function dc(e, A) {
  if (!!!e)
    throw new Error(A);
}
function oM(e) {
  return typeof e == "object" && e !== null;
}
function uM(e, A) {
  if (!!!e)
    throw new Error(
      A ?? "Unexpected invariant triggered."
    );
}
const lM = /\r\n|[\n\r]/g;
function Ef(e, A) {
  let t = 0, r = 1;
  for (const n of e.body.matchAll(lM)) {
    if (typeof n.index == "number" || uM(!1), n.index >= A)
      break;
    t = n.index + n[0].length, r += 1;
  }
  return {
    line: r,
    column: A + 1 - t
  };
}
function cM(e) {
  return iy(
    e.source,
    Ef(e.source, e.start)
  );
}
function iy(e, A) {
  const t = e.locationOffset.column - 1, r = "".padStart(t) + e.body, n = A.line - 1, a = e.locationOffset.line - 1, i = A.line + a, s = A.line === 1 ? t : 0, o = A.column + s, u = `${e.name}:${i}:${o}
`, l = r.split(/\r\n|[\n\r]/g), c = l[n];
  if (c.length > 120) {
    const f = Math.floor(o / 80), d = o % 80, h = [];
    for (let p = 0; p < c.length; p += 80)
      h.push(c.slice(p, p + 80));
    return u + dg([
      [`${i} |`, h[0]],
      ...h.slice(1, f + 1).map((p) => ["|", p]),
      ["|", "^".padStart(d)],
      ["|", h[f + 1]]
    ]);
  }
  return u + dg([
    // Lines specified like this: ["prefix", "string"],
    [`${i - 1} |`, l[n - 1]],
    [`${i} |`, c],
    ["|", "^".padStart(o)],
    [`${i + 1} |`, l[n + 1]]
  ]);
}
function dg(e) {
  const A = e.filter(([r, n]) => n !== void 0), t = Math.max(...A.map(([r]) => r.length));
  return A.map(([r, n]) => r.padStart(t) + (n ? " " + n : "")).join(`
`);
}
function fM(e) {
  const A = e[0];
  return A == null || "kind" in A || "length" in A ? {
    nodes: A,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : A;
}
class _d extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(A, ...t) {
    var r, n, a;
    const { nodes: i, source: s, positions: o, path: u, originalError: l, extensions: c } = fM(t);
    super(A), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = l ?? void 0, this.nodes = hg(
      Array.isArray(i) ? i : i ? [i] : void 0
    );
    const f = hg(
      (r = this.nodes) === null || r === void 0 ? void 0 : r.map((h) => h.loc).filter((h) => h != null)
    );
    this.source = s ?? (f == null || (n = f[0]) === null || n === void 0 ? void 0 : n.source), this.positions = o ?? (f == null ? void 0 : f.map((h) => h.start)), this.locations = o && s ? o.map((h) => Ef(s, h)) : f == null ? void 0 : f.map((h) => Ef(h.source, h.start));
    const d = oM(
      l == null ? void 0 : l.extensions
    ) ? l == null ? void 0 : l.extensions : void 0;
    this.extensions = (a = c ?? d) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, _d) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let A = this.message;
    if (this.nodes)
      for (const t of this.nodes)
        t.loc && (A += `

` + cM(t.loc));
    else if (this.source && this.locations)
      for (const t of this.locations)
        A += `

` + iy(this.source, t);
    return A;
  }
  toJSON() {
    const A = {
      message: this.message
    };
    return this.locations != null && (A.locations = this.locations), this.path != null && (A.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (A.extensions = this.extensions), A;
  }
}
function hg(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function wA(e, A, t) {
  return new _d(`Syntax Error: ${t}`, {
    source: e,
    positions: [A]
  });
}
class dM {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(A, t, r) {
    this.start = A.start, this.end = t.end, this.startToken = A, this.endToken = t, this.source = r;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class sy {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(A, t, r, n, a, i) {
    this.kind = A, this.start = t, this.end = r, this.line = n, this.column = a, this.value = i, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const hM = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
};
new Set(Object.keys(hM));
var na;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(na || (na = {}));
var Ff;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Ff || (Ff = {}));
var de;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(de || (de = {}));
function pM(e) {
  return e === 9 || e === 32;
}
function Ci(e) {
  return e >= 48 && e <= 57;
}
function oy(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function uy(e) {
  return oy(e) || e === 95;
}
function gM(e) {
  return oy(e) || Ci(e) || e === 95;
}
function BM(e) {
  var A;
  let t = Number.MAX_SAFE_INTEGER, r = null, n = -1;
  for (let i = 0; i < e.length; ++i) {
    var a;
    const s = e[i], o = vM(s);
    o !== s.length && (r = (a = r) !== null && a !== void 0 ? a : i, n = i, i !== 0 && o < t && (t = o));
  }
  return e.map((i, s) => s === 0 ? i : i.slice(t)).slice(
    (A = r) !== null && A !== void 0 ? A : 0,
    n + 1
  );
}
function vM(e) {
  let A = 0;
  for (; A < e.length && pM(e.charCodeAt(A)); )
    ++A;
  return A;
}
var W;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(W || (W = {}));
class mM {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(A) {
    const t = new sy(W.SOF, 0, 0, 0, 0);
    this.source = A, this.lastToken = t, this.token = t, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let A = this.token;
    if (A.kind !== W.EOF)
      do
        if (A.next)
          A = A.next;
        else {
          const t = yM(this, A.end);
          A.next = t, t.prev = A, A = t;
        }
      while (A.kind === W.COMMENT);
    return A;
  }
}
function wM(e) {
  return e === W.BANG || e === W.DOLLAR || e === W.AMP || e === W.PAREN_L || e === W.PAREN_R || e === W.SPREAD || e === W.COLON || e === W.EQUALS || e === W.AT || e === W.BRACKET_L || e === W.BRACKET_R || e === W.BRACE_L || e === W.PIPE || e === W.BRACE_R;
}
function Ua(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Lu(e, A) {
  return ly(e.charCodeAt(A)) && cy(e.charCodeAt(A + 1));
}
function ly(e) {
  return e >= 55296 && e <= 56319;
}
function cy(e) {
  return e >= 56320 && e <= 57343;
}
function En(e, A) {
  const t = e.source.body.codePointAt(A);
  if (t === void 0)
    return W.EOF;
  if (t >= 32 && t <= 126) {
    const r = String.fromCodePoint(t);
    return r === '"' ? `'"'` : `"${r}"`;
  }
  return "U+" + t.toString(16).toUpperCase().padStart(4, "0");
}
function dA(e, A, t, r, n) {
  const a = e.line, i = 1 + t - e.lineStart;
  return new sy(A, t, r, a, i, n);
}
function yM(e, A) {
  const t = e.source.body, r = t.length;
  let n = A;
  for (; n < r; ) {
    const a = t.charCodeAt(n);
    switch (a) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++n;
        continue;
      case 10:
        ++n, ++e.line, e.lineStart = n;
        continue;
      case 13:
        t.charCodeAt(n + 1) === 10 ? n += 2 : ++n, ++e.line, e.lineStart = n;
        continue;
      case 35:
        return xM(e, n);
      case 33:
        return dA(e, W.BANG, n, n + 1);
      case 36:
        return dA(e, W.DOLLAR, n, n + 1);
      case 38:
        return dA(e, W.AMP, n, n + 1);
      case 40:
        return dA(e, W.PAREN_L, n, n + 1);
      case 41:
        return dA(e, W.PAREN_R, n, n + 1);
      case 46:
        if (t.charCodeAt(n + 1) === 46 && t.charCodeAt(n + 2) === 46)
          return dA(e, W.SPREAD, n, n + 3);
        break;
      case 58:
        return dA(e, W.COLON, n, n + 1);
      case 61:
        return dA(e, W.EQUALS, n, n + 1);
      case 64:
        return dA(e, W.AT, n, n + 1);
      case 91:
        return dA(e, W.BRACKET_L, n, n + 1);
      case 93:
        return dA(e, W.BRACKET_R, n, n + 1);
      case 123:
        return dA(e, W.BRACE_L, n, n + 1);
      case 124:
        return dA(e, W.PIPE, n, n + 1);
      case 125:
        return dA(e, W.BRACE_R, n, n + 1);
      case 34:
        return t.charCodeAt(n + 1) === 34 && t.charCodeAt(n + 2) === 34 ? UM(e, n) : EM(e, n);
    }
    if (Ci(a) || a === 45)
      return CM(e, n, a);
    if (uy(a))
      return _M(e, n);
    throw wA(
      e.source,
      n,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : Ua(a) || Lu(t, n) ? `Unexpected character: ${En(e, n)}.` : `Invalid character: ${En(e, n)}.`
    );
  }
  return dA(e, W.EOF, r, r);
}
function xM(e, A) {
  const t = e.source.body, r = t.length;
  let n = A + 1;
  for (; n < r; ) {
    const a = t.charCodeAt(n);
    if (a === 10 || a === 13)
      break;
    if (Ua(a))
      ++n;
    else if (Lu(t, n))
      n += 2;
    else
      break;
  }
  return dA(
    e,
    W.COMMENT,
    A,
    n,
    t.slice(A + 1, n)
  );
}
function CM(e, A, t) {
  const r = e.source.body;
  let n = A, a = t, i = !1;
  if (a === 45 && (a = r.charCodeAt(++n)), a === 48) {
    if (a = r.charCodeAt(++n), Ci(a))
      throw wA(
        e.source,
        n,
        `Invalid number, unexpected digit after 0: ${En(
          e,
          n
        )}.`
      );
  } else
    n = hc(e, n, a), a = r.charCodeAt(n);
  if (a === 46 && (i = !0, a = r.charCodeAt(++n), n = hc(e, n, a), a = r.charCodeAt(n)), (a === 69 || a === 101) && (i = !0, a = r.charCodeAt(++n), (a === 43 || a === 45) && (a = r.charCodeAt(++n)), n = hc(e, n, a), a = r.charCodeAt(n)), a === 46 || uy(a))
    throw wA(
      e.source,
      n,
      `Invalid number, expected digit but got: ${En(
        e,
        n
      )}.`
    );
  return dA(
    e,
    i ? W.FLOAT : W.INT,
    A,
    n,
    r.slice(A, n)
  );
}
function hc(e, A, t) {
  if (!Ci(t))
    throw wA(
      e.source,
      A,
      `Invalid number, expected digit but got: ${En(
        e,
        A
      )}.`
    );
  const r = e.source.body;
  let n = A + 1;
  for (; Ci(r.charCodeAt(n)); )
    ++n;
  return n;
}
function EM(e, A) {
  const t = e.source.body, r = t.length;
  let n = A + 1, a = n, i = "";
  for (; n < r; ) {
    const s = t.charCodeAt(n);
    if (s === 34)
      return i += t.slice(a, n), dA(e, W.STRING, A, n + 1, i);
    if (s === 92) {
      i += t.slice(a, n);
      const o = t.charCodeAt(n + 1) === 117 ? t.charCodeAt(n + 2) === 123 ? FM(e, n) : bM(e, n) : SM(e, n);
      i += o.value, n += o.size, a = n;
      continue;
    }
    if (s === 10 || s === 13)
      break;
    if (Ua(s))
      ++n;
    else if (Lu(t, n))
      n += 2;
    else
      throw wA(
        e.source,
        n,
        `Invalid character within String: ${En(
          e,
          n
        )}.`
      );
  }
  throw wA(e.source, n, "Unterminated string.");
}
function FM(e, A) {
  const t = e.source.body;
  let r = 0, n = 3;
  for (; n < 12; ) {
    const a = t.charCodeAt(A + n++);
    if (a === 125) {
      if (n < 5 || !Ua(r))
        break;
      return {
        value: String.fromCodePoint(r),
        size: n
      };
    }
    if (r = r << 4 | Ya(a), r < 0)
      break;
  }
  throw wA(
    e.source,
    A,
    `Invalid Unicode escape sequence: "${t.slice(
      A,
      A + n
    )}".`
  );
}
function bM(e, A) {
  const t = e.source.body, r = pg(t, A + 2);
  if (Ua(r))
    return {
      value: String.fromCodePoint(r),
      size: 6
    };
  if (ly(r) && t.charCodeAt(A + 6) === 92 && t.charCodeAt(A + 7) === 117) {
    const n = pg(t, A + 8);
    if (cy(n))
      return {
        value: String.fromCodePoint(r, n),
        size: 12
      };
  }
  throw wA(
    e.source,
    A,
    `Invalid Unicode escape sequence: "${t.slice(A, A + 6)}".`
  );
}
function pg(e, A) {
  return Ya(e.charCodeAt(A)) << 12 | Ya(e.charCodeAt(A + 1)) << 8 | Ya(e.charCodeAt(A + 2)) << 4 | Ya(e.charCodeAt(A + 3));
}
function Ya(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function SM(e, A) {
  const t = e.source.body;
  switch (t.charCodeAt(A + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw wA(
    e.source,
    A,
    `Invalid character escape sequence: "${t.slice(
      A,
      A + 2
    )}".`
  );
}
function UM(e, A) {
  const t = e.source.body, r = t.length;
  let n = e.lineStart, a = A + 3, i = a, s = "";
  const o = [];
  for (; a < r; ) {
    const u = t.charCodeAt(a);
    if (u === 34 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34) {
      s += t.slice(i, a), o.push(s);
      const l = dA(
        e,
        W.BLOCK_STRING,
        A,
        a + 3,
        // Return a string of the lines joined with U+000A.
        BM(o).join(`
`)
      );
      return e.line += o.length - 1, e.lineStart = n, l;
    }
    if (u === 92 && t.charCodeAt(a + 1) === 34 && t.charCodeAt(a + 2) === 34 && t.charCodeAt(a + 3) === 34) {
      s += t.slice(i, a), i = a + 1, a += 4;
      continue;
    }
    if (u === 10 || u === 13) {
      s += t.slice(i, a), o.push(s), u === 13 && t.charCodeAt(a + 1) === 10 ? a += 2 : ++a, s = "", i = a, n = a;
      continue;
    }
    if (Ua(u))
      ++a;
    else if (Lu(t, a))
      a += 2;
    else
      throw wA(
        e.source,
        a,
        `Invalid character within String: ${En(
          e,
          a
        )}.`
      );
  }
  throw wA(e.source, a, "Unterminated string.");
}
function _M(e, A) {
  const t = e.source.body, r = t.length;
  let n = A + 1;
  for (; n < r; ) {
    const a = t.charCodeAt(n);
    if (gM(a))
      ++n;
    else
      break;
  }
  return dA(
    e,
    W.NAME,
    A,
    n,
    t.slice(A, n)
  );
}
const QM = 10, fy = 2;
function dy(e) {
  return Mu(e, []);
}
function Mu(e, A) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return IM(e, A);
    default:
      return String(e);
  }
}
function IM(e, A) {
  if (e === null)
    return "null";
  if (A.includes(e))
    return "[Circular]";
  const t = [...A, e];
  if (DM(e)) {
    const r = e.toJSON();
    if (r !== e)
      return typeof r == "string" ? r : Mu(r, t);
  } else if (Array.isArray(e))
    return OM(e, t);
  return TM(e, t);
}
function DM(e) {
  return typeof e.toJSON == "function";
}
function TM(e, A) {
  const t = Object.entries(e);
  return t.length === 0 ? "{}" : A.length > fy ? "[" + HM(e) + "]" : "{ " + t.map(
    ([n, a]) => n + ": " + Mu(a, A)
  ).join(", ") + " }";
}
function OM(e, A) {
  if (e.length === 0)
    return "[]";
  if (A.length > fy)
    return "[Array]";
  const t = Math.min(QM, e.length), r = e.length - t, n = [];
  for (let a = 0; a < t; ++a)
    n.push(Mu(e[a], A));
  return r === 1 ? n.push("... 1 more item") : r > 1 && n.push(`... ${r} more items`), "[" + n.join(", ") + "]";
}
function HM(e) {
  const A = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (A === "Object" && typeof e.constructor == "function") {
    const t = e.constructor.name;
    if (typeof t == "string" && t !== "")
      return t;
  }
  return A;
}
const LM = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function(A, t) {
    return A instanceof t;
  } : function(A, t) {
    if (A instanceof t)
      return !0;
    if (typeof A == "object" && A !== null) {
      var r;
      const n = t.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in A ? A[Symbol.toStringTag] : (r = A.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (n === a) {
        const i = dy(A);
        throw new Error(`Cannot use ${n} "${i}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class hy {
  constructor(A, t = "GraphQL request", r = {
    line: 1,
    column: 1
  }) {
    typeof A == "string" || dc(!1, `Body must be a string. Received: ${dy(A)}.`), this.body = A, this.name = t, this.locationOffset = r, this.locationOffset.line > 0 || dc(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || dc(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function MM(e) {
  return LM(e, hy);
}
function RM(e, A) {
  return new NM(e, A).parseDocument();
}
let NM = class {
  constructor(A, t = {}) {
    const r = MM(A) ? A : new hy(A);
    this._lexer = new mM(r), this._options = t, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const A = this.expectToken(W.NAME);
    return this.node(A, {
      kind: de.NAME,
      value: A.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: de.DOCUMENT,
      definitions: this.many(
        W.SOF,
        this.parseDefinition,
        W.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(W.BRACE_L))
      return this.parseOperationDefinition();
    const A = this.peekDescription(), t = A ? this._lexer.lookahead() : this._lexer.token;
    if (t.kind === W.NAME) {
      switch (t.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (A)
        throw wA(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (t.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(t);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const A = this._lexer.token;
    if (this.peek(W.BRACE_L))
      return this.node(A, {
        kind: de.OPERATION_DEFINITION,
        operation: na.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const t = this.parseOperationType();
    let r;
    return this.peek(W.NAME) && (r = this.parseName()), this.node(A, {
      kind: de.OPERATION_DEFINITION,
      operation: t,
      name: r,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const A = this.expectToken(W.NAME);
    switch (A.value) {
      case "query":
        return na.QUERY;
      case "mutation":
        return na.MUTATION;
      case "subscription":
        return na.SUBSCRIPTION;
    }
    throw this.unexpected(A);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      W.PAREN_L,
      this.parseVariableDefinition,
      W.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: de.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(W.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(W.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const A = this._lexer.token;
    return this.expectToken(W.DOLLAR), this.node(A, {
      kind: de.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: de.SELECTION_SET,
      selections: this.many(
        W.BRACE_L,
        this.parseSelection,
        W.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(W.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const A = this._lexer.token, t = this.parseName();
    let r, n;
    return this.expectOptionalToken(W.COLON) ? (r = t, n = this.parseName()) : n = t, this.node(A, {
      kind: de.FIELD,
      alias: r,
      name: n,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(W.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(A) {
    const t = A ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(W.PAREN_L, t, W.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(A = !1) {
    const t = this._lexer.token, r = this.parseName();
    return this.expectToken(W.COLON), this.node(t, {
      kind: de.ARGUMENT,
      name: r,
      value: this.parseValueLiteral(A)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const A = this._lexer.token;
    this.expectToken(W.SPREAD);
    const t = this.expectOptionalKeyword("on");
    return !t && this.peek(W.NAME) ? this.node(A, {
      kind: de.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(A, {
      kind: de.INLINE_FRAGMENT,
      typeCondition: t ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const A = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(A, {
      kind: de.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(A, {
      kind: de.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(A) {
    const t = this._lexer.token;
    switch (t.kind) {
      case W.BRACKET_L:
        return this.parseList(A);
      case W.BRACE_L:
        return this.parseObject(A);
      case W.INT:
        return this.advanceLexer(), this.node(t, {
          kind: de.INT,
          value: t.value
        });
      case W.FLOAT:
        return this.advanceLexer(), this.node(t, {
          kind: de.FLOAT,
          value: t.value
        });
      case W.STRING:
      case W.BLOCK_STRING:
        return this.parseStringLiteral();
      case W.NAME:
        switch (this.advanceLexer(), t.value) {
          case "true":
            return this.node(t, {
              kind: de.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(t, {
              kind: de.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(t, {
              kind: de.NULL
            });
          default:
            return this.node(t, {
              kind: de.ENUM,
              value: t.value
            });
        }
      case W.DOLLAR:
        if (A)
          if (this.expectToken(W.DOLLAR), this._lexer.token.kind === W.NAME) {
            const r = this._lexer.token.value;
            throw wA(
              this._lexer.source,
              t.start,
              `Unexpected variable "$${r}" in constant value.`
            );
          } else
            throw this.unexpected(t);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const A = this._lexer.token;
    return this.advanceLexer(), this.node(A, {
      kind: de.STRING,
      value: A.value,
      block: A.kind === W.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(A) {
    const t = () => this.parseValueLiteral(A);
    return this.node(this._lexer.token, {
      kind: de.LIST,
      values: this.any(W.BRACKET_L, t, W.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(A) {
    const t = () => this.parseObjectField(A);
    return this.node(this._lexer.token, {
      kind: de.OBJECT,
      fields: this.any(W.BRACE_L, t, W.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(A) {
    const t = this._lexer.token, r = this.parseName();
    return this.expectToken(W.COLON), this.node(t, {
      kind: de.OBJECT_FIELD,
      name: r,
      value: this.parseValueLiteral(A)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(A) {
    const t = [];
    for (; this.peek(W.AT); )
      t.push(this.parseDirective(A));
    return t;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(A) {
    const t = this._lexer.token;
    return this.expectToken(W.AT), this.node(t, {
      kind: de.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(A)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const A = this._lexer.token;
    let t;
    if (this.expectOptionalToken(W.BRACKET_L)) {
      const r = this.parseTypeReference();
      this.expectToken(W.BRACKET_R), t = this.node(A, {
        kind: de.LIST_TYPE,
        type: r
      });
    } else
      t = this.parseNamedType();
    return this.expectOptionalToken(W.BANG) ? this.node(A, {
      kind: de.NON_NULL_TYPE,
      type: t
    }) : t;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: de.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(W.STRING) || this.peek(W.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.many(
      W.BRACE_L,
      this.parseOperationTypeDefinition,
      W.BRACE_R
    );
    return this.node(A, {
      kind: de.SCHEMA_DEFINITION,
      description: t,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const A = this._lexer.token, t = this.parseOperationType();
    this.expectToken(W.COLON);
    const r = this.parseNamedType();
    return this.node(A, {
      kind: de.OPERATION_TYPE_DEFINITION,
      operation: t,
      type: r
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    return this.node(A, {
      kind: de.SCALAR_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), i = this.parseFieldsDefinition();
    return this.node(A, {
      kind: de.OBJECT_TYPE_DEFINITION,
      description: t,
      name: r,
      interfaces: n,
      directives: a,
      fields: i
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(W.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      W.BRACE_L,
      this.parseFieldDefinition,
      W.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const A = this._lexer.token, t = this.parseDescription(), r = this.parseName(), n = this.parseArgumentDefs();
    this.expectToken(W.COLON);
    const a = this.parseTypeReference(), i = this.parseConstDirectives();
    return this.node(A, {
      kind: de.FIELD_DEFINITION,
      description: t,
      name: r,
      arguments: n,
      type: a,
      directives: i
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      W.PAREN_L,
      this.parseInputValueDef,
      W.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const A = this._lexer.token, t = this.parseDescription(), r = this.parseName();
    this.expectToken(W.COLON);
    const n = this.parseTypeReference();
    let a;
    this.expectOptionalToken(W.EQUALS) && (a = this.parseConstValueLiteral());
    const i = this.parseConstDirectives();
    return this.node(A, {
      kind: de.INPUT_VALUE_DEFINITION,
      description: t,
      name: r,
      type: n,
      defaultValue: a,
      directives: i
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), i = this.parseFieldsDefinition();
    return this.node(A, {
      kind: de.INTERFACE_TYPE_DEFINITION,
      description: t,
      name: r,
      interfaces: n,
      directives: a,
      fields: i
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(A, {
      kind: de.UNION_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: n,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(W.EQUALS) ? this.delimitedMany(W.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(A, {
      kind: de.ENUM_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: n,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      W.BRACE_L,
      this.parseEnumValueDefinition,
      W.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const A = this._lexer.token, t = this.parseDescription(), r = this.parseEnumValueName(), n = this.parseConstDirectives();
    return this.node(A, {
      kind: de.ENUM_VALUE_DEFINITION,
      description: t,
      name: r,
      directives: n
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw wA(
        this._lexer.source,
        this._lexer.token.start,
        `${ls(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(A, {
      kind: de.INPUT_OBJECT_TYPE_DEFINITION,
      description: t,
      name: r,
      directives: n,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      W.BRACE_L,
      this.parseInputValueDef,
      W.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const A = this._lexer.lookahead();
    if (A.kind === W.NAME)
      switch (A.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(A);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const A = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const t = this.parseConstDirectives(), r = this.optionalMany(
      W.BRACE_L,
      this.parseOperationTypeDefinition,
      W.BRACE_R
    );
    if (t.length === 0 && r.length === 0)
      throw this.unexpected();
    return this.node(A, {
      kind: de.SCHEMA_EXTENSION,
      directives: t,
      operationTypes: r
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const A = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const t = this.parseName(), r = this.parseConstDirectives();
    if (r.length === 0)
      throw this.unexpected();
    return this.node(A, {
      kind: de.SCALAR_TYPE_EXTENSION,
      name: t,
      directives: r
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const A = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const t = this.parseName(), r = this.parseImplementsInterfaces(), n = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (r.length === 0 && n.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(A, {
      kind: de.OBJECT_TYPE_EXTENSION,
      name: t,
      interfaces: r,
      directives: n,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const A = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const t = this.parseName(), r = this.parseImplementsInterfaces(), n = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (r.length === 0 && n.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(A, {
      kind: de.INTERFACE_TYPE_EXTENSION,
      name: t,
      interfaces: r,
      directives: n,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const A = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const t = this.parseName(), r = this.parseConstDirectives(), n = this.parseUnionMemberTypes();
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(A, {
      kind: de.UNION_TYPE_EXTENSION,
      name: t,
      directives: r,
      types: n
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const A = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const t = this.parseName(), r = this.parseConstDirectives(), n = this.parseEnumValuesDefinition();
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(A, {
      kind: de.ENUM_TYPE_EXTENSION,
      name: t,
      directives: r,
      values: n
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const A = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const t = this.parseName(), r = this.parseConstDirectives(), n = this.parseInputFieldsDefinition();
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(A, {
      kind: de.INPUT_OBJECT_TYPE_EXTENSION,
      name: t,
      directives: r,
      fields: n
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const A = this._lexer.token, t = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(W.AT);
    const r = this.parseName(), n = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const i = this.parseDirectiveLocations();
    return this.node(A, {
      kind: de.DIRECTIVE_DEFINITION,
      description: t,
      name: r,
      arguments: n,
      repeatable: a,
      locations: i
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(W.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const A = this._lexer.token, t = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Ff, t.value))
      return t;
    throw this.unexpected(A);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(A, t) {
    return this._options.noLocation !== !0 && (t.loc = new dM(
      A,
      this._lexer.lastToken,
      this._lexer.source
    )), t;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(A) {
    return this._lexer.token.kind === A;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(A) {
    const t = this._lexer.token;
    if (t.kind === A)
      return this.advanceLexer(), t;
    throw wA(
      this._lexer.source,
      t.start,
      `Expected ${py(A)}, found ${ls(t)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(A) {
    return this._lexer.token.kind === A ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(A) {
    const t = this._lexer.token;
    if (t.kind === W.NAME && t.value === A)
      this.advanceLexer();
    else
      throw wA(
        this._lexer.source,
        t.start,
        `Expected "${A}", found ${ls(t)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(A) {
    const t = this._lexer.token;
    return t.kind === W.NAME && t.value === A ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(A) {
    const t = A ?? this._lexer.token;
    return wA(
      this._lexer.source,
      t.start,
      `Unexpected ${ls(t)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(A, t, r) {
    this.expectToken(A);
    const n = [];
    for (; !this.expectOptionalToken(r); )
      n.push(t.call(this));
    return n;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(A, t, r) {
    if (this.expectOptionalToken(A)) {
      const n = [];
      do
        n.push(t.call(this));
      while (!this.expectOptionalToken(r));
      return n;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(A, t, r) {
    this.expectToken(A);
    const n = [];
    do
      n.push(t.call(this));
    while (!this.expectOptionalToken(r));
    return n;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(A, t) {
    this.expectOptionalToken(A);
    const r = [];
    do
      r.push(t.call(this));
    while (this.expectOptionalToken(A));
    return r;
  }
  advanceLexer() {
    const { maxTokens: A } = this._options, t = this._lexer.advance();
    if (A !== void 0 && t.kind !== W.EOF && (++this._tokenCounter, this._tokenCounter > A))
      throw wA(
        this._lexer.source,
        t.start,
        `Document contains more that ${A} tokens. Parsing aborted.`
      );
  }
};
function ls(e) {
  const A = e.value;
  return py(e.kind) + (A != null ? ` "${A}"` : "");
}
function py(e) {
  return wM(e) ? `"${e}"` : e;
}
var Zs = /* @__PURE__ */ new Map(), bf = /* @__PURE__ */ new Map(), gy = !0, Fo = !1;
function By(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function kM(e) {
  return By(e.source.body.substring(e.start, e.end));
}
function PM(e) {
  var A = /* @__PURE__ */ new Set(), t = [];
  return e.definitions.forEach(function(r) {
    if (r.kind === "FragmentDefinition") {
      var n = r.name.value, a = kM(r.loc), i = bf.get(n);
      i && !i.has(a) ? gy && console.warn("Warning: fragment with name " + n + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : i || bf.set(n, i = /* @__PURE__ */ new Set()), i.add(a), A.has(a) || (A.add(a), t.push(r));
    } else
      t.push(r);
  }), ho(ho({}, e), { definitions: t });
}
function KM(e) {
  var A = new Set(e.definitions);
  A.forEach(function(r) {
    r.loc && delete r.loc, Object.keys(r).forEach(function(n) {
      var a = r[n];
      a && typeof a == "object" && A.add(a);
    });
  });
  var t = e.loc;
  return t && (delete t.startToken, delete t.endToken), e;
}
function $M(e) {
  var A = By(e);
  if (!Zs.has(A)) {
    var t = RM(e, {
      experimentalFragmentVariables: Fo,
      allowLegacyFragmentVariables: Fo
    });
    if (!t || t.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Zs.set(A, KM(PM(t)));
  }
  return Zs.get(A);
}
function ha(e) {
  for (var A = [], t = 1; t < arguments.length; t++)
    A[t - 1] = arguments[t];
  typeof e == "string" && (e = [e]);
  var r = e[0];
  return A.forEach(function(n, a) {
    n && n.kind === "Document" ? r += n.loc.source.body : r += n, r += e[a + 1];
  }), $M(r);
}
function jM() {
  Zs.clear(), bf.clear();
}
function GM() {
  gy = !1;
}
function VM() {
  Fo = !0;
}
function WM() {
  Fo = !1;
}
var Ra = {
  gql: ha,
  resetCaches: jM,
  disableFragmentWarnings: GM,
  enableExperimentalFragmentVariables: VM,
  disableExperimentalFragmentVariables: WM
};
(function(e) {
  e.gql = Ra.gql, e.resetCaches = Ra.resetCaches, e.disableFragmentWarnings = Ra.disableFragmentWarnings, e.enableExperimentalFragmentVariables = Ra.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = Ra.disableExperimentalFragmentVariables;
})(ha || (ha = {}));
ha.default = ha;
const Vr = ha, OAe = Vr`
    subscription onCreateConversation($requestId: ID!) {
        onCreateConversation(requestId: $requestId) {
            conversationId
            agentCognitoId
            requestId
            visitorId
            createdAt
            endTimestamp
        }
    }
`, HAe = Vr`
    subscription onUpdateChatRequest($requestId: ID!) {
        onUpdateChatRequest(requestId: $requestId) {
            requestId
            requestStatus
            endTimestamp
            isTransferred
            transferredRequestId
            wrapUpCode
        }
    }
`, LAe = Vr`
    subscription onCreateMessage($conversationId: ID!) {
        onCreateMessage(conversationId: $conversationId) {
            messageId
            visitorId
            conversationId
            messageType
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
        }
    }
`, MAe = Vr`
    subscription onAgentTyping($conversationId: ID!) {
        onAgentTyping(conversationId: $conversationId) {
            conversationId
            agentTyping
        }
    }
`, RAe = Vr`
    mutation createMessage($input: CreateMessageInput!) {
        createMessage(input: $input) {
            messageId
            visitorId
            conversationId
            messageType
            messageStatus
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
            sourceMsgId
            translated
            sourceLang
            targetLang
        }
    }
`, NAe = Vr`
    mutation updateEncryptedChatRequest($input: UpdateChatRequestInput!) {
        updateEncryptedChatRequest(input: $input) {
            requestId
            requestStatus
            speedToAnswer
            wrapUpCode
            endTimestamp
            expertName
            userEmail
            isTransferred
            transferredRequestId
            averageResponseTime
            engagementDuration
            violationCount
            chatAcceptTimeStamp
            expertId
            averageUserResponseTime
        }
    }
`, kAe = Vr`
    mutation createChatAudit($input: CreateChatAudit!) {
        createChatAudit(input: $input) {
            visitorId
            createdAt
            auditLog
            chatAuditId
            expertName
            requestId
        }
    }
`;
Vr`
    query getMessages($conversationId: ID!, $visitorId: ID!) {
        getMessages(conversationId: $conversationId, visitorId: $visitorId) {
            messageId
            visitorId
            conversationId
            messageType
            messageStatus
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
            sourceMsgId
            translated
            sourceLang
            targetLang
            agentResponseTime
            userResponseTime
        }
    }
`;
const PAe = `
  query getMessages {
    getMessages(visitorId: "{visitorId}", conversationId: "{conversationId}") {
    messageId
    visitorId
    conversationId
    messageType
    messageStatus
    interactionType
    sender
    source
    content
    isSent
    recipient
    isActive
    createdAt
    sourceMsgId
    translated
    sourceLang
    targetLang
    agentResponseTime
    userResponseTime
    }
  }
`, KAe = `
    subscription onCreateConversation {
        onCreateConversation(requestId: "{1}") {
            conversationId
            agentCognitoId
            requestId
            visitorId
            createdAt
            endTimestamp
        }
    }`, $Ae = `
    subscription onUpdateChatRequest {
        onUpdateChatRequest(requestId: "{1}") {
            requestId
            requestStatus
            endTimestamp
            isTransferred
            transferredRequestId
            wrapUpCode
        }
    }
`, jAe = `
    subscription onCreateMessage {
        onCreateMessage(conversationId: "{1}") {
            messageId
            visitorId
            conversationId
            messageType
            messageStatus
            interactionType
            sender
            source
            content
            isSent
            recipient
            isActive
            createdAt
        }
    }
`, GAe = `
    subscription onAgentTyping {
        onAgentTyping(conversationId: "{1}") {
            conversationId
            agentTyping
        }
    }
`;
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Sf = function(e, A) {
  return Sf = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, r) {
    t.__proto__ = r;
  } || function(t, r) {
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
  }, Sf(e, A);
};
function Ct(e, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Class extends value " + String(A) + " is not a constructor or null");
  Sf(e, A);
  function t() {
    this.constructor = e;
  }
  e.prototype = A === null ? Object.create(A) : (t.prototype = A.prototype, new t());
}
var Uf = function() {
  return Uf = Object.assign || function(A) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (A[a] = t[a]);
    }
    return A;
  }, Uf.apply(this, arguments);
};
function LA(e, A, t, r) {
  function n(a) {
    return a instanceof t ? a : new t(function(i) {
      i(a);
    });
  }
  return new (t || (t = Promise))(function(a, i) {
    function s(l) {
      try {
        u(r.next(l));
      } catch (c) {
        i(c);
      }
    }
    function o(l) {
      try {
        u(r.throw(l));
      } catch (c) {
        i(c);
      }
    }
    function u(l) {
      l.done ? a(l.value) : n(l.value).then(s, o);
    }
    u((r = r.apply(e, A || [])).next());
  });
}
function SA(e, A) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, n, a, i;
  return i = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function s(u) {
    return function(l) {
      return o([u, l]);
    };
  }
  function o(u) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; t; )
      try {
        if (r = 1, n && (a = u[0] & 2 ? n.return : u[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, u[1])).done)
          return a;
        switch (n = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
          case 0:
          case 1:
            a = u;
            break;
          case 4:
            return t.label++, { value: u[1], done: !1 };
          case 5:
            t.label++, n = u[1], u = [0];
            continue;
          case 7:
            u = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              t = 0;
              continue;
            }
            if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
              t.label = u[1];
              break;
            }
            if (u[0] === 6 && t.label < a[1]) {
              t.label = a[1], a = u;
              break;
            }
            if (a && t.label < a[2]) {
              t.label = a[2], t.ops.push(u);
              break;
            }
            a[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        u = A.call(e, t);
      } catch (l) {
        u = [6, l], n = 0;
      } finally {
        r = a = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function cs(e, A, t) {
  if (t || arguments.length === 2)
    for (var r = 0, n = A.length, a; r < n; r++)
      (a || !(r in A)) && (a || (a = Array.prototype.slice.call(A, 0, r)), a[r] = A[r]);
  return e.concat(a || A);
}
var fr = (
  /** @class */
  function() {
    function e(A, t, r, n) {
      this.left = A, this.top = t, this.width = r, this.height = n;
    }
    return e.prototype.add = function(A, t, r, n) {
      return new e(this.left + A, this.top + t, this.width + r, this.height + n);
    }, e.fromClientRect = function(A, t) {
      return new e(t.left + A.windowBounds.left, t.top + A.windowBounds.top, t.width, t.height);
    }, e.fromDOMRectList = function(A, t) {
      var r = Array.from(t).find(function(n) {
        return n.width !== 0;
      });
      return r ? new e(r.left + A.windowBounds.left, r.top + A.windowBounds.top, r.width, r.height) : e.EMPTY;
    }, e.EMPTY = new e(0, 0, 0, 0), e;
  }()
), Ru = function(e, A) {
  return fr.fromClientRect(e, A.getBoundingClientRect());
}, YM = function(e) {
  var A = e.body, t = e.documentElement;
  if (!A || !t)
    throw new Error("Unable to get document size");
  var r = Math.max(Math.max(A.scrollWidth, t.scrollWidth), Math.max(A.offsetWidth, t.offsetWidth), Math.max(A.clientWidth, t.clientWidth)), n = Math.max(Math.max(A.scrollHeight, t.scrollHeight), Math.max(A.offsetHeight, t.offsetHeight), Math.max(A.clientHeight, t.clientHeight));
  return new fr(0, 0, r, n);
}, Nu = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var a = e.charCodeAt(t++);
      (a & 64512) === 56320 ? A.push(((n & 1023) << 10) + (a & 1023) + 65536) : (A.push(n), t--);
    } else
      A.push(n);
  }
  return A;
}, uA = function() {
  for (var e = [], A = 0; A < arguments.length; A++)
    e[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t)
    return "";
  for (var r = [], n = -1, a = ""; ++n < t; ) {
    var i = e[n];
    i <= 65535 ? r.push(i) : (i -= 65536, r.push((i >> 10) + 55296, i % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (a += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return a;
}, gg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", zM = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var fs = 0; fs < gg.length; fs++)
  zM[gg.charCodeAt(fs)] = fs;
var Bg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", za = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var ds = 0; ds < Bg.length; ds++)
  za[Bg.charCodeAt(ds)] = ds;
var XM = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, a, i, s, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var u = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), l = Array.isArray(u) ? u : new Uint8Array(u);
  for (r = 0; r < t; r += 4)
    a = za[e.charCodeAt(r)], i = za[e.charCodeAt(r + 1)], s = za[e.charCodeAt(r + 2)], o = za[e.charCodeAt(r + 3)], l[n++] = a << 2 | i >> 4, l[n++] = (i & 15) << 4 | s >> 2, l[n++] = (s & 3) << 6 | o & 63;
  return u;
}, qM = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2)
    t.push(e[r + 1] << 8 | e[r]);
  return t;
}, JM = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4)
    t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, vn = 5, Qd = 6 + 5, pc = 2, ZM = Qd - vn, vy = 65536 >> vn, e3 = 1 << vn, gc = e3 - 1, A3 = 1024 >> vn, t3 = vy + A3, r3 = t3, n3 = 32, a3 = r3 + n3, i3 = 65536 >> Qd, s3 = 1 << ZM, o3 = s3 - 1, vg = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, u3 = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, l3 = function(e, A) {
  var t = XM(e), r = Array.isArray(t) ? JM(t) : new Uint32Array(t), n = Array.isArray(t) ? qM(t) : new Uint16Array(t), a = 24, i = vg(n, a / 2, r[4] / 2), s = r[5] === 2 ? vg(n, (a + r[4]) / 2) : u3(r, Math.ceil((a + r[4]) / 4));
  return new c3(r[0], r[1], r[2], r[3], i, s);
}, c3 = (
  /** @class */
  function() {
    function e(A, t, r, n, a, i) {
      this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = a, this.data = i;
    }
    return e.prototype.get = function(A) {
      var t;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return t = this.index[A >> vn], t = (t << pc) + (A & gc), this.data[t];
        if (A <= 65535)
          return t = this.index[vy + (A - 55296 >> vn)], t = (t << pc) + (A & gc), this.data[t];
        if (A < this.highStart)
          return t = a3 - i3 + (A >> Qd), t = this.index[t], t += A >> vn & o3, t = this.index[t], t = (t << pc) + (A & gc), this.data[t];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, e;
  }()
), mg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", f3 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var hs = 0; hs < mg.length; hs++)
  f3[mg.charCodeAt(hs)] = hs;
var d3 = "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", wg = 50, h3 = 1, my = 2, wy = 3, p3 = 4, g3 = 5, yg = 7, yy = 8, xg = 9, Qr = 10, _f = 11, Cg = 12, Qf = 13, B3 = 14, Xa = 15, If = 16, ps = 17, Na = 18, v3 = 19, Eg = 20, Df = 21, ka = 22, Bc = 23, Pn = 24, VA = 25, qa = 26, Ja = 27, Kn = 28, m3 = 29, sn = 30, w3 = 31, gs = 32, Bs = 33, Tf = 34, Of = 35, Hf = 36, Ei = 37, Lf = 38, eo = 39, Ao = 40, vc = 41, xy = 42, y3 = 43, x3 = [9001, 65288], Cy = "!", Ee = "×", vs = "÷", Mf = l3(d3), Jt = [sn, Hf], Rf = [h3, my, wy, g3], Ey = [Qr, yy], Fg = [Ja, qa], C3 = Rf.concat(Ey), bg = [Lf, eo, Ao, Tf, Of], E3 = [Xa, Qf], F3 = function(e, A) {
  A === void 0 && (A = "strict");
  var t = [], r = [], n = [];
  return e.forEach(function(a, i) {
    var s = Mf.get(a);
    if (s > wg ? (n.push(!0), s -= wg) : n.push(!1), ["normal", "auto", "loose"].indexOf(A) !== -1 && [8208, 8211, 12316, 12448].indexOf(a) !== -1)
      return r.push(i), t.push(If);
    if (s === p3 || s === _f) {
      if (i === 0)
        return r.push(i), t.push(sn);
      var o = t[i - 1];
      return C3.indexOf(o) === -1 ? (r.push(r[i - 1]), t.push(o)) : (r.push(i), t.push(sn));
    }
    if (r.push(i), s === w3)
      return t.push(A === "strict" ? Df : Ei);
    if (s === xy || s === m3)
      return t.push(sn);
    if (s === y3)
      return a >= 131072 && a <= 196605 || a >= 196608 && a <= 262141 ? t.push(Ei) : t.push(sn);
    t.push(s);
  }), [r, t, n];
}, mc = function(e, A, t, r) {
  var n = r[t];
  if (Array.isArray(e) ? e.indexOf(n) !== -1 : e === n)
    for (var a = t; a <= r.length; ) {
      a++;
      var i = r[a];
      if (i === A)
        return !0;
      if (i !== Qr)
        break;
    }
  if (n === Qr)
    for (var a = t; a > 0; ) {
      a--;
      var s = r[a];
      if (Array.isArray(e) ? e.indexOf(s) !== -1 : e === s)
        for (var o = t; o <= r.length; ) {
          o++;
          var i = r[o];
          if (i === A)
            return !0;
          if (i !== Qr)
            break;
        }
      if (s !== Qr)
        break;
    }
  return !1;
}, Sg = function(e, A) {
  for (var t = e; t >= 0; ) {
    var r = A[t];
    if (r === Qr)
      t--;
    else
      return r;
  }
  return 0;
}, b3 = function(e, A, t, r, n) {
  if (t[r] === 0)
    return Ee;
  var a = r - 1;
  if (Array.isArray(n) && n[a] === !0)
    return Ee;
  var i = a - 1, s = a + 1, o = A[a], u = i >= 0 ? A[i] : 0, l = A[s];
  if (o === my && l === wy)
    return Ee;
  if (Rf.indexOf(o) !== -1)
    return Cy;
  if (Rf.indexOf(l) !== -1 || Ey.indexOf(l) !== -1)
    return Ee;
  if (Sg(a, A) === yy)
    return vs;
  if (Mf.get(e[a]) === _f || (o === gs || o === Bs) && Mf.get(e[s]) === _f || o === yg || l === yg || o === xg || [Qr, Qf, Xa].indexOf(o) === -1 && l === xg || [ps, Na, v3, Pn, Kn].indexOf(l) !== -1 || Sg(a, A) === ka || mc(Bc, ka, a, A) || mc([ps, Na], Df, a, A) || mc(Cg, Cg, a, A))
    return Ee;
  if (o === Qr)
    return vs;
  if (o === Bc || l === Bc)
    return Ee;
  if (l === If || o === If)
    return vs;
  if ([Qf, Xa, Df].indexOf(l) !== -1 || o === B3 || u === Hf && E3.indexOf(o) !== -1 || o === Kn && l === Hf || l === Eg || Jt.indexOf(l) !== -1 && o === VA || Jt.indexOf(o) !== -1 && l === VA || o === Ja && [Ei, gs, Bs].indexOf(l) !== -1 || [Ei, gs, Bs].indexOf(o) !== -1 && l === qa || Jt.indexOf(o) !== -1 && Fg.indexOf(l) !== -1 || Fg.indexOf(o) !== -1 && Jt.indexOf(l) !== -1 || // (PR | PO) × ( OP | HY )? NU
  [Ja, qa].indexOf(o) !== -1 && (l === VA || [ka, Xa].indexOf(l) !== -1 && A[s + 1] === VA) || // ( OP | HY ) × NU
  [ka, Xa].indexOf(o) !== -1 && l === VA || // NU ×	(NU | SY | IS)
  o === VA && [VA, Kn, Pn].indexOf(l) !== -1)
    return Ee;
  if ([VA, Kn, Pn, ps, Na].indexOf(l) !== -1)
    for (var c = a; c >= 0; ) {
      var f = A[c];
      if (f === VA)
        return Ee;
      if ([Kn, Pn].indexOf(f) !== -1)
        c--;
      else
        break;
    }
  if ([Ja, qa].indexOf(l) !== -1)
    for (var c = [ps, Na].indexOf(o) !== -1 ? i : a; c >= 0; ) {
      var f = A[c];
      if (f === VA)
        return Ee;
      if ([Kn, Pn].indexOf(f) !== -1)
        c--;
      else
        break;
    }
  if (Lf === o && [Lf, eo, Tf, Of].indexOf(l) !== -1 || [eo, Tf].indexOf(o) !== -1 && [eo, Ao].indexOf(l) !== -1 || [Ao, Of].indexOf(o) !== -1 && l === Ao || bg.indexOf(o) !== -1 && [Eg, qa].indexOf(l) !== -1 || bg.indexOf(l) !== -1 && o === Ja || Jt.indexOf(o) !== -1 && Jt.indexOf(l) !== -1 || o === Pn && Jt.indexOf(l) !== -1 || Jt.concat(VA).indexOf(o) !== -1 && l === ka && x3.indexOf(e[s]) === -1 || Jt.concat(VA).indexOf(l) !== -1 && o === Na)
    return Ee;
  if (o === vc && l === vc) {
    for (var d = t[a], h = 1; d > 0 && (d--, A[d] === vc); )
      h++;
    if (h % 2 !== 0)
      return Ee;
  }
  return o === gs && l === Bs ? Ee : vs;
}, S3 = function(e, A) {
  A || (A = { lineBreak: "normal", wordBreak: "normal" });
  var t = F3(e, A.lineBreak), r = t[0], n = t[1], a = t[2];
  (A.wordBreak === "break-all" || A.wordBreak === "break-word") && (n = n.map(function(s) {
    return [VA, sn, xy].indexOf(s) !== -1 ? Ei : s;
  }));
  var i = A.wordBreak === "keep-all" ? a.map(function(s, o) {
    return s && e[o] >= 19968 && e[o] <= 40959;
  }) : void 0;
  return [r, n, i];
}, U3 = (
  /** @class */
  function() {
    function e(A, t, r, n) {
      this.codePoints = A, this.required = t === Cy, this.start = r, this.end = n;
    }
    return e.prototype.slice = function() {
      return uA.apply(void 0, this.codePoints.slice(this.start, this.end));
    }, e;
  }()
), _3 = function(e, A) {
  var t = Nu(e), r = S3(t, A), n = r[0], a = r[1], i = r[2], s = t.length, o = 0, u = 0;
  return {
    next: function() {
      if (u >= s)
        return { done: !0, value: null };
      for (var l = Ee; u < s && (l = b3(t, a, n, ++u, i)) === Ee; )
        ;
      if (l !== Ee || u === s) {
        var c = new U3(t, l, o, u);
        return o = u, { value: c, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, Q3 = 1, I3 = 2, Vi = 4, Ug = 8, bo = 10, _g = 47, ui = 92, D3 = 9, T3 = 32, ms = 34, Pa = 61, O3 = 35, H3 = 36, L3 = 37, ws = 39, ys = 40, Ka = 41, M3 = 95, KA = 45, R3 = 33, N3 = 60, k3 = 62, P3 = 64, K3 = 91, $3 = 93, j3 = 61, G3 = 123, xs = 63, V3 = 125, Qg = 124, W3 = 126, Y3 = 128, Ig = 65533, wc = 42, fn = 43, z3 = 44, X3 = 58, q3 = 59, Fi = 46, J3 = 0, Z3 = 8, eR = 11, AR = 14, tR = 31, rR = 127, bt = -1, Fy = 48, by = 97, Sy = 101, nR = 102, aR = 117, iR = 122, Uy = 65, _y = 69, Qy = 70, sR = 85, oR = 90, _A = function(e) {
  return e >= Fy && e <= 57;
}, uR = function(e) {
  return e >= 55296 && e <= 57343;
}, $n = function(e) {
  return _A(e) || e >= Uy && e <= Qy || e >= by && e <= nR;
}, lR = function(e) {
  return e >= by && e <= iR;
}, cR = function(e) {
  return e >= Uy && e <= oR;
}, fR = function(e) {
  return lR(e) || cR(e);
}, dR = function(e) {
  return e >= Y3;
}, Cs = function(e) {
  return e === bo || e === D3 || e === T3;
}, So = function(e) {
  return fR(e) || dR(e) || e === M3;
}, Dg = function(e) {
  return So(e) || _A(e) || e === KA;
}, hR = function(e) {
  return e >= J3 && e <= Z3 || e === eR || e >= AR && e <= tR || e === rR;
}, br = function(e, A) {
  return e !== ui ? !1 : A !== bo;
}, Es = function(e, A, t) {
  return e === KA ? So(A) || br(A, t) : So(e) ? !0 : !!(e === ui && br(e, A));
}, yc = function(e, A, t) {
  return e === fn || e === KA ? _A(A) ? !0 : A === Fi && _A(t) : _A(e === Fi ? A : e);
}, pR = function(e) {
  var A = 0, t = 1;
  (e[A] === fn || e[A] === KA) && (e[A] === KA && (t = -1), A++);
  for (var r = []; _A(e[A]); )
    r.push(e[A++]);
  var n = r.length ? parseInt(uA.apply(void 0, r), 10) : 0;
  e[A] === Fi && A++;
  for (var a = []; _A(e[A]); )
    a.push(e[A++]);
  var i = a.length, s = i ? parseInt(uA.apply(void 0, a), 10) : 0;
  (e[A] === _y || e[A] === Sy) && A++;
  var o = 1;
  (e[A] === fn || e[A] === KA) && (e[A] === KA && (o = -1), A++);
  for (var u = []; _A(e[A]); )
    u.push(e[A++]);
  var l = u.length ? parseInt(uA.apply(void 0, u), 10) : 0;
  return t * (n + s * Math.pow(10, -i)) * Math.pow(10, o * l);
}, gR = {
  type: 2
  /* LEFT_PARENTHESIS_TOKEN */
}, BR = {
  type: 3
  /* RIGHT_PARENTHESIS_TOKEN */
}, vR = {
  type: 4
  /* COMMA_TOKEN */
}, mR = {
  type: 13
  /* SUFFIX_MATCH_TOKEN */
}, wR = {
  type: 8
  /* PREFIX_MATCH_TOKEN */
}, yR = {
  type: 21
  /* COLUMN_TOKEN */
}, xR = {
  type: 9
  /* DASH_MATCH_TOKEN */
}, CR = {
  type: 10
  /* INCLUDE_MATCH_TOKEN */
}, ER = {
  type: 11
  /* LEFT_CURLY_BRACKET_TOKEN */
}, FR = {
  type: 12
  /* RIGHT_CURLY_BRACKET_TOKEN */
}, bR = {
  type: 14
  /* SUBSTRING_MATCH_TOKEN */
}, Fs = {
  type: 23
  /* BAD_URL_TOKEN */
}, SR = {
  type: 1
  /* BAD_STRING_TOKEN */
}, UR = {
  type: 25
  /* CDO_TOKEN */
}, _R = {
  type: 24
  /* CDC_TOKEN */
}, QR = {
  type: 26
  /* COLON_TOKEN */
}, IR = {
  type: 27
  /* SEMICOLON_TOKEN */
}, DR = {
  type: 28
  /* LEFT_SQUARE_BRACKET_TOKEN */
}, TR = {
  type: 29
  /* RIGHT_SQUARE_BRACKET_TOKEN */
}, OR = {
  type: 31
  /* WHITESPACE_TOKEN */
}, Nf = {
  type: 32
  /* EOF_TOKEN */
}, Iy = (
  /** @class */
  function() {
    function e() {
      this._value = [];
    }
    return e.prototype.write = function(A) {
      this._value = this._value.concat(Nu(A));
    }, e.prototype.read = function() {
      for (var A = [], t = this.consumeToken(); t !== Nf; )
        A.push(t), t = this.consumeToken();
      return A;
    }, e.prototype.consumeToken = function() {
      var A = this.consumeCodePoint();
      switch (A) {
        case ms:
          return this.consumeStringToken(ms);
        case O3:
          var t = this.peekCodePoint(0), r = this.peekCodePoint(1), n = this.peekCodePoint(2);
          if (Dg(t) || br(r, n)) {
            var a = Es(t, r, n) ? I3 : Q3, i = this.consumeName();
            return { type: 5, value: i, flags: a };
          }
          break;
        case H3:
          if (this.peekCodePoint(0) === Pa)
            return this.consumeCodePoint(), mR;
          break;
        case ws:
          return this.consumeStringToken(ws);
        case ys:
          return gR;
        case Ka:
          return BR;
        case wc:
          if (this.peekCodePoint(0) === Pa)
            return this.consumeCodePoint(), bR;
          break;
        case fn:
          if (yc(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case z3:
          return vR;
        case KA:
          var s = A, o = this.peekCodePoint(0), u = this.peekCodePoint(1);
          if (yc(s, o, u))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          if (Es(s, o, u))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          if (o === KA && u === k3)
            return this.consumeCodePoint(), this.consumeCodePoint(), _R;
          break;
        case Fi:
          if (yc(A, this.peekCodePoint(0), this.peekCodePoint(1)))
            return this.reconsumeCodePoint(A), this.consumeNumericToken();
          break;
        case _g:
          if (this.peekCodePoint(0) === wc)
            for (this.consumeCodePoint(); ; ) {
              var l = this.consumeCodePoint();
              if (l === wc && (l = this.consumeCodePoint(), l === _g))
                return this.consumeToken();
              if (l === bt)
                return this.consumeToken();
            }
          break;
        case X3:
          return QR;
        case q3:
          return IR;
        case N3:
          if (this.peekCodePoint(0) === R3 && this.peekCodePoint(1) === KA && this.peekCodePoint(2) === KA)
            return this.consumeCodePoint(), this.consumeCodePoint(), UR;
          break;
        case P3:
          var c = this.peekCodePoint(0), f = this.peekCodePoint(1), d = this.peekCodePoint(2);
          if (Es(c, f, d)) {
            var i = this.consumeName();
            return { type: 7, value: i };
          }
          break;
        case K3:
          return DR;
        case ui:
          if (br(A, this.peekCodePoint(0)))
            return this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
          break;
        case $3:
          return TR;
        case j3:
          if (this.peekCodePoint(0) === Pa)
            return this.consumeCodePoint(), wR;
          break;
        case G3:
          return ER;
        case V3:
          return FR;
        case aR:
        case sR:
          var h = this.peekCodePoint(0), p = this.peekCodePoint(1);
          return h === fn && ($n(p) || p === xs) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(A), this.consumeIdentLikeToken();
        case Qg:
          if (this.peekCodePoint(0) === Pa)
            return this.consumeCodePoint(), xR;
          if (this.peekCodePoint(0) === Qg)
            return this.consumeCodePoint(), yR;
          break;
        case W3:
          if (this.peekCodePoint(0) === Pa)
            return this.consumeCodePoint(), CR;
          break;
        case bt:
          return Nf;
      }
      return Cs(A) ? (this.consumeWhiteSpace(), OR) : _A(A) ? (this.reconsumeCodePoint(A), this.consumeNumericToken()) : So(A) ? (this.reconsumeCodePoint(A), this.consumeIdentLikeToken()) : { type: 6, value: uA(A) };
    }, e.prototype.consumeCodePoint = function() {
      var A = this._value.shift();
      return typeof A > "u" ? -1 : A;
    }, e.prototype.reconsumeCodePoint = function(A) {
      this._value.unshift(A);
    }, e.prototype.peekCodePoint = function(A) {
      return A >= this._value.length ? -1 : this._value[A];
    }, e.prototype.consumeUnicodeRangeToken = function() {
      for (var A = [], t = this.consumeCodePoint(); $n(t) && A.length < 6; )
        A.push(t), t = this.consumeCodePoint();
      for (var r = !1; t === xs && A.length < 6; )
        A.push(t), t = this.consumeCodePoint(), r = !0;
      if (r) {
        var n = parseInt(uA.apply(void 0, A.map(function(o) {
          return o === xs ? Fy : o;
        })), 16), a = parseInt(uA.apply(void 0, A.map(function(o) {
          return o === xs ? Qy : o;
        })), 16);
        return { type: 30, start: n, end: a };
      }
      var i = parseInt(uA.apply(void 0, A), 16);
      if (this.peekCodePoint(0) === KA && $n(this.peekCodePoint(1))) {
        this.consumeCodePoint(), t = this.consumeCodePoint();
        for (var s = []; $n(t) && s.length < 6; )
          s.push(t), t = this.consumeCodePoint();
        var a = parseInt(uA.apply(void 0, s), 16);
        return { type: 30, start: i, end: a };
      } else
        return { type: 30, start: i, end: i };
    }, e.prototype.consumeIdentLikeToken = function() {
      var A = this.consumeName();
      return A.toLowerCase() === "url" && this.peekCodePoint(0) === ys ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === ys ? (this.consumeCodePoint(), { type: 19, value: A }) : { type: 20, value: A };
    }, e.prototype.consumeUrlToken = function() {
      var A = [];
      if (this.consumeWhiteSpace(), this.peekCodePoint(0) === bt)
        return { type: 22, value: "" };
      var t = this.peekCodePoint(0);
      if (t === ws || t === ms) {
        var r = this.consumeStringToken(this.consumeCodePoint());
        return r.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === bt || this.peekCodePoint(0) === Ka) ? (this.consumeCodePoint(), { type: 22, value: r.value }) : (this.consumeBadUrlRemnants(), Fs);
      }
      for (; ; ) {
        var n = this.consumeCodePoint();
        if (n === bt || n === Ka)
          return { type: 22, value: uA.apply(void 0, A) };
        if (Cs(n))
          return this.consumeWhiteSpace(), this.peekCodePoint(0) === bt || this.peekCodePoint(0) === Ka ? (this.consumeCodePoint(), { type: 22, value: uA.apply(void 0, A) }) : (this.consumeBadUrlRemnants(), Fs);
        if (n === ms || n === ws || n === ys || hR(n))
          return this.consumeBadUrlRemnants(), Fs;
        if (n === ui)
          if (br(n, this.peekCodePoint(0)))
            A.push(this.consumeEscapedCodePoint());
          else
            return this.consumeBadUrlRemnants(), Fs;
        else
          A.push(n);
      }
    }, e.prototype.consumeWhiteSpace = function() {
      for (; Cs(this.peekCodePoint(0)); )
        this.consumeCodePoint();
    }, e.prototype.consumeBadUrlRemnants = function() {
      for (; ; ) {
        var A = this.consumeCodePoint();
        if (A === Ka || A === bt)
          return;
        br(A, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
      }
    }, e.prototype.consumeStringSlice = function(A) {
      for (var t = 5e4, r = ""; A > 0; ) {
        var n = Math.min(t, A);
        r += uA.apply(void 0, this._value.splice(0, n)), A -= n;
      }
      return this._value.shift(), r;
    }, e.prototype.consumeStringToken = function(A) {
      var t = "", r = 0;
      do {
        var n = this._value[r];
        if (n === bt || n === void 0 || n === A)
          return t += this.consumeStringSlice(r), { type: 0, value: t };
        if (n === bo)
          return this._value.splice(0, r), SR;
        if (n === ui) {
          var a = this._value[r + 1];
          a !== bt && a !== void 0 && (a === bo ? (t += this.consumeStringSlice(r), r = -1, this._value.shift()) : br(n, a) && (t += this.consumeStringSlice(r), t += uA(this.consumeEscapedCodePoint()), r = -1));
        }
        r++;
      } while (!0);
    }, e.prototype.consumeNumber = function() {
      var A = [], t = Vi, r = this.peekCodePoint(0);
      for ((r === fn || r === KA) && A.push(this.consumeCodePoint()); _A(this.peekCodePoint(0)); )
        A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0);
      var n = this.peekCodePoint(1);
      if (r === Fi && _A(n))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Ug; _A(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      r = this.peekCodePoint(0), n = this.peekCodePoint(1);
      var a = this.peekCodePoint(2);
      if ((r === _y || r === Sy) && ((n === fn || n === KA) && _A(a) || _A(n)))
        for (A.push(this.consumeCodePoint(), this.consumeCodePoint()), t = Ug; _A(this.peekCodePoint(0)); )
          A.push(this.consumeCodePoint());
      return [pR(A), t];
    }, e.prototype.consumeNumericToken = function() {
      var A = this.consumeNumber(), t = A[0], r = A[1], n = this.peekCodePoint(0), a = this.peekCodePoint(1), i = this.peekCodePoint(2);
      if (Es(n, a, i)) {
        var s = this.consumeName();
        return { type: 15, number: t, flags: r, unit: s };
      }
      return n === L3 ? (this.consumeCodePoint(), { type: 16, number: t, flags: r }) : { type: 17, number: t, flags: r };
    }, e.prototype.consumeEscapedCodePoint = function() {
      var A = this.consumeCodePoint();
      if ($n(A)) {
        for (var t = uA(A); $n(this.peekCodePoint(0)) && t.length < 6; )
          t += uA(this.consumeCodePoint());
        Cs(this.peekCodePoint(0)) && this.consumeCodePoint();
        var r = parseInt(t, 16);
        return r === 0 || uR(r) || r > 1114111 ? Ig : r;
      }
      return A === bt ? Ig : A;
    }, e.prototype.consumeName = function() {
      for (var A = ""; ; ) {
        var t = this.consumeCodePoint();
        if (Dg(t))
          A += uA(t);
        else if (br(t, this.peekCodePoint(0)))
          A += uA(this.consumeEscapedCodePoint());
        else
          return this.reconsumeCodePoint(t), A;
      }
    }, e;
  }()
), Dy = (
  /** @class */
  function() {
    function e(A) {
      this._tokens = A;
    }
    return e.create = function(A) {
      var t = new Iy();
      return t.write(A), new e(t.read());
    }, e.parseValue = function(A) {
      return e.create(A).parseComponentValue();
    }, e.parseValues = function(A) {
      return e.create(A).parseComponentValues();
    }, e.prototype.parseComponentValue = function() {
      for (var A = this.consumeToken(); A.type === 31; )
        A = this.consumeToken();
      if (A.type === 32)
        throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
      this.reconsumeToken(A);
      var t = this.consumeComponentValue();
      do
        A = this.consumeToken();
      while (A.type === 31);
      if (A.type === 32)
        return t;
      throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
    }, e.prototype.parseComponentValues = function() {
      for (var A = []; ; ) {
        var t = this.consumeComponentValue();
        if (t.type === 32)
          return A;
        A.push(t), A.push();
      }
    }, e.prototype.consumeComponentValue = function() {
      var A = this.consumeToken();
      switch (A.type) {
        case 11:
        case 28:
        case 2:
          return this.consumeSimpleBlock(A.type);
        case 19:
          return this.consumeFunction(A);
      }
      return A;
    }, e.prototype.consumeSimpleBlock = function(A) {
      for (var t = { type: A, values: [] }, r = this.consumeToken(); ; ) {
        if (r.type === 32 || LR(r, A))
          return t;
        this.reconsumeToken(r), t.values.push(this.consumeComponentValue()), r = this.consumeToken();
      }
    }, e.prototype.consumeFunction = function(A) {
      for (var t = {
        name: A.value,
        values: [],
        type: 18
        /* FUNCTION */
      }; ; ) {
        var r = this.consumeToken();
        if (r.type === 32 || r.type === 3)
          return t;
        this.reconsumeToken(r), t.values.push(this.consumeComponentValue());
      }
    }, e.prototype.consumeToken = function() {
      var A = this._tokens.shift();
      return typeof A > "u" ? Nf : A;
    }, e.prototype.reconsumeToken = function(A) {
      this._tokens.unshift(A);
    }, e;
  }()
), Wi = function(e) {
  return e.type === 15;
}, _a = function(e) {
  return e.type === 17;
}, Ke = function(e) {
  return e.type === 20;
}, HR = function(e) {
  return e.type === 0;
}, kf = function(e, A) {
  return Ke(e) && e.value === A;
}, Ty = function(e) {
  return e.type !== 31;
}, pa = function(e) {
  return e.type !== 31 && e.type !== 4;
}, Wt = function(e) {
  var A = [], t = [];
  return e.forEach(function(r) {
    if (r.type === 4) {
      if (t.length === 0)
        throw new Error("Error parsing function args, zero tokens for arg");
      A.push(t), t = [];
      return;
    }
    r.type !== 31 && t.push(r);
  }), t.length && A.push(t), A;
}, LR = function(e, A) {
  return A === 11 && e.type === 12 || A === 28 && e.type === 29 ? !0 : A === 2 && e.type === 3;
}, kr = function(e) {
  return e.type === 17 || e.type === 15;
}, hA = function(e) {
  return e.type === 16 || kr(e);
}, Oy = function(e) {
  return e.length > 1 ? [e[0], e[1]] : [e[0]];
}, FA = {
  type: 17,
  number: 0,
  flags: Vi
}, Id = {
  type: 16,
  number: 50,
  flags: Vi
}, Ir = {
  type: 16,
  number: 100,
  flags: Vi
}, Za = function(e, A, t) {
  var r = e[0], n = e[1];
  return [Ye(r, A), Ye(typeof n < "u" ? n : r, t)];
}, Ye = function(e, A) {
  if (e.type === 16)
    return e.number / 100 * A;
  if (Wi(e))
    switch (e.unit) {
      case "rem":
      case "em":
        return 16 * e.number;
      case "px":
      default:
        return e.number;
    }
  return e.number;
}, Hy = "deg", Ly = "grad", My = "rad", Ry = "turn", ku = {
  name: "angle",
  parse: function(e, A) {
    if (A.type === 15)
      switch (A.unit) {
        case Hy:
          return Math.PI * A.number / 180;
        case Ly:
          return Math.PI / 200 * A.number;
        case My:
          return A.number;
        case Ry:
          return Math.PI * 2 * A.number;
      }
    throw new Error("Unsupported angle type");
  }
}, Ny = function(e) {
  return e.type === 15 && (e.unit === Hy || e.unit === Ly || e.unit === My || e.unit === Ry);
}, ky = function(e) {
  var A = e.filter(Ke).map(function(t) {
    return t.value;
  }).join(" ");
  switch (A) {
    case "to bottom right":
    case "to right bottom":
    case "left top":
    case "top left":
      return [FA, FA];
    case "to top":
    case "bottom":
      return at(0);
    case "to bottom left":
    case "to left bottom":
    case "right top":
    case "top right":
      return [FA, Ir];
    case "to right":
    case "left":
      return at(90);
    case "to top left":
    case "to left top":
    case "right bottom":
    case "bottom right":
      return [Ir, Ir];
    case "to bottom":
    case "top":
      return at(180);
    case "to top right":
    case "to right top":
    case "left bottom":
    case "bottom left":
      return [Ir, FA];
    case "to left":
    case "right":
      return at(270);
  }
  return 0;
}, at = function(e) {
  return Math.PI * e / 180;
}, Or = {
  name: "color",
  parse: function(e, A) {
    if (A.type === 18) {
      var t = MR[A.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported color function "' + A.name + '"');
      return t(e, A.values);
    }
    if (A.type === 5) {
      if (A.value.length === 3) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), a = A.value.substring(2, 3);
        return Dr(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(a + a, 16), 1);
      }
      if (A.value.length === 4) {
        var r = A.value.substring(0, 1), n = A.value.substring(1, 2), a = A.value.substring(2, 3), i = A.value.substring(3, 4);
        return Dr(parseInt(r + r, 16), parseInt(n + n, 16), parseInt(a + a, 16), parseInt(i + i, 16) / 255);
      }
      if (A.value.length === 6) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), a = A.value.substring(4, 6);
        return Dr(parseInt(r, 16), parseInt(n, 16), parseInt(a, 16), 1);
      }
      if (A.value.length === 8) {
        var r = A.value.substring(0, 2), n = A.value.substring(2, 4), a = A.value.substring(4, 6), i = A.value.substring(6, 8);
        return Dr(parseInt(r, 16), parseInt(n, 16), parseInt(a, 16), parseInt(i, 16) / 255);
      }
    }
    if (A.type === 20) {
      var s = lr[A.value.toUpperCase()];
      if (typeof s < "u")
        return s;
    }
    return lr.TRANSPARENT;
  }
}, Hr = function(e) {
  return (255 & e) === 0;
}, mA = function(e) {
  var A = 255 & e, t = 255 & e >> 8, r = 255 & e >> 16, n = 255 & e >> 24;
  return A < 255 ? "rgba(" + n + "," + r + "," + t + "," + A / 255 + ")" : "rgb(" + n + "," + r + "," + t + ")";
}, Dr = function(e, A, t, r) {
  return (e << 24 | A << 16 | t << 8 | Math.round(r * 255) << 0) >>> 0;
}, Tg = function(e, A) {
  if (e.type === 17)
    return e.number;
  if (e.type === 16) {
    var t = A === 3 ? 1 : 255;
    return A === 3 ? e.number / 100 * t : Math.round(e.number / 100 * t);
  }
  return 0;
}, Og = function(e, A) {
  var t = A.filter(pa);
  if (t.length === 3) {
    var r = t.map(Tg), n = r[0], a = r[1], i = r[2];
    return Dr(n, a, i, 1);
  }
  if (t.length === 4) {
    var s = t.map(Tg), n = s[0], a = s[1], i = s[2], o = s[3];
    return Dr(n, a, i, o);
  }
  return 0;
};
function xc(e, A, t) {
  return t < 0 && (t += 1), t >= 1 && (t -= 1), t < 1 / 6 ? (A - e) * t * 6 + e : t < 1 / 2 ? A : t < 2 / 3 ? (A - e) * 6 * (2 / 3 - t) + e : e;
}
var Hg = function(e, A) {
  var t = A.filter(pa), r = t[0], n = t[1], a = t[2], i = t[3], s = (r.type === 17 ? at(r.number) : ku.parse(e, r)) / (Math.PI * 2), o = hA(n) ? n.number / 100 : 0, u = hA(a) ? a.number / 100 : 0, l = typeof i < "u" && hA(i) ? Ye(i, 1) : 1;
  if (o === 0)
    return Dr(u * 255, u * 255, u * 255, 1);
  var c = u <= 0.5 ? u * (o + 1) : u + o - u * o, f = u * 2 - c, d = xc(f, c, s + 1 / 3), h = xc(f, c, s), p = xc(f, c, s - 1 / 3);
  return Dr(d * 255, h * 255, p * 255, l);
}, MR = {
  hsl: Hg,
  hsla: Hg,
  rgb: Og,
  rgba: Og
}, li = function(e, A) {
  return Or.parse(e, Dy.create(A).parseComponentValue());
}, lr = {
  ALICEBLUE: 4042850303,
  ANTIQUEWHITE: 4209760255,
  AQUA: 16777215,
  AQUAMARINE: 2147472639,
  AZURE: 4043309055,
  BEIGE: 4126530815,
  BISQUE: 4293182719,
  BLACK: 255,
  BLANCHEDALMOND: 4293643775,
  BLUE: 65535,
  BLUEVIOLET: 2318131967,
  BROWN: 2771004159,
  BURLYWOOD: 3736635391,
  CADETBLUE: 1604231423,
  CHARTREUSE: 2147418367,
  CHOCOLATE: 3530104575,
  CORAL: 4286533887,
  CORNFLOWERBLUE: 1687547391,
  CORNSILK: 4294499583,
  CRIMSON: 3692313855,
  CYAN: 16777215,
  DARKBLUE: 35839,
  DARKCYAN: 9145343,
  DARKGOLDENROD: 3095837695,
  DARKGRAY: 2846468607,
  DARKGREEN: 6553855,
  DARKGREY: 2846468607,
  DARKKHAKI: 3182914559,
  DARKMAGENTA: 2332068863,
  DARKOLIVEGREEN: 1433087999,
  DARKORANGE: 4287365375,
  DARKORCHID: 2570243327,
  DARKRED: 2332033279,
  DARKSALMON: 3918953215,
  DARKSEAGREEN: 2411499519,
  DARKSLATEBLUE: 1211993087,
  DARKSLATEGRAY: 793726975,
  DARKSLATEGREY: 793726975,
  DARKTURQUOISE: 13554175,
  DARKVIOLET: 2483082239,
  DEEPPINK: 4279538687,
  DEEPSKYBLUE: 12582911,
  DIMGRAY: 1768516095,
  DIMGREY: 1768516095,
  DODGERBLUE: 512819199,
  FIREBRICK: 2988581631,
  FLORALWHITE: 4294635775,
  FORESTGREEN: 579543807,
  FUCHSIA: 4278255615,
  GAINSBORO: 3705462015,
  GHOSTWHITE: 4177068031,
  GOLD: 4292280575,
  GOLDENROD: 3668254975,
  GRAY: 2155905279,
  GREEN: 8388863,
  GREENYELLOW: 2919182335,
  GREY: 2155905279,
  HONEYDEW: 4043305215,
  HOTPINK: 4285117695,
  INDIANRED: 3445382399,
  INDIGO: 1258324735,
  IVORY: 4294963455,
  KHAKI: 4041641215,
  LAVENDER: 3873897215,
  LAVENDERBLUSH: 4293981695,
  LAWNGREEN: 2096890111,
  LEMONCHIFFON: 4294626815,
  LIGHTBLUE: 2916673279,
  LIGHTCORAL: 4034953471,
  LIGHTCYAN: 3774873599,
  LIGHTGOLDENRODYELLOW: 4210742015,
  LIGHTGRAY: 3553874943,
  LIGHTGREEN: 2431553791,
  LIGHTGREY: 3553874943,
  LIGHTPINK: 4290167295,
  LIGHTSALMON: 4288707327,
  LIGHTSEAGREEN: 548580095,
  LIGHTSKYBLUE: 2278488831,
  LIGHTSLATEGRAY: 2005441023,
  LIGHTSLATEGREY: 2005441023,
  LIGHTSTEELBLUE: 2965692159,
  LIGHTYELLOW: 4294959359,
  LIME: 16711935,
  LIMEGREEN: 852308735,
  LINEN: 4210091775,
  MAGENTA: 4278255615,
  MAROON: 2147483903,
  MEDIUMAQUAMARINE: 1724754687,
  MEDIUMBLUE: 52735,
  MEDIUMORCHID: 3126187007,
  MEDIUMPURPLE: 2473647103,
  MEDIUMSEAGREEN: 1018393087,
  MEDIUMSLATEBLUE: 2070474495,
  MEDIUMSPRINGGREEN: 16423679,
  MEDIUMTURQUOISE: 1221709055,
  MEDIUMVIOLETRED: 3340076543,
  MIDNIGHTBLUE: 421097727,
  MINTCREAM: 4127193855,
  MISTYROSE: 4293190143,
  MOCCASIN: 4293178879,
  NAVAJOWHITE: 4292783615,
  NAVY: 33023,
  OLDLACE: 4260751103,
  OLIVE: 2155872511,
  OLIVEDRAB: 1804477439,
  ORANGE: 4289003775,
  ORANGERED: 4282712319,
  ORCHID: 3664828159,
  PALEGOLDENROD: 4008225535,
  PALEGREEN: 2566625535,
  PALETURQUOISE: 2951671551,
  PALEVIOLETRED: 3681588223,
  PAPAYAWHIP: 4293907967,
  PEACHPUFF: 4292524543,
  PERU: 3448061951,
  PINK: 4290825215,
  PLUM: 3718307327,
  POWDERBLUE: 2967529215,
  PURPLE: 2147516671,
  REBECCAPURPLE: 1714657791,
  RED: 4278190335,
  ROSYBROWN: 3163525119,
  ROYALBLUE: 1097458175,
  SADDLEBROWN: 2336560127,
  SALMON: 4202722047,
  SANDYBROWN: 4104413439,
  SEAGREEN: 780883967,
  SEASHELL: 4294307583,
  SIENNA: 2689740287,
  SILVER: 3233857791,
  SKYBLUE: 2278484991,
  SLATEBLUE: 1784335871,
  SLATEGRAY: 1887473919,
  SLATEGREY: 1887473919,
  SNOW: 4294638335,
  SPRINGGREEN: 16744447,
  STEELBLUE: 1182971135,
  TAN: 3535047935,
  TEAL: 8421631,
  THISTLE: 3636451583,
  TOMATO: 4284696575,
  TRANSPARENT: 0,
  TURQUOISE: 1088475391,
  VIOLET: 4001558271,
  WHEAT: 4125012991,
  WHITE: 4294967295,
  WHITESMOKE: 4126537215,
  YELLOW: 4294902015,
  YELLOWGREEN: 2597139199
}, RR = {
  name: "background-clip",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.map(function(t) {
      if (Ke(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, NR = {
  name: "background-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, Pu = function(e, A) {
  var t = Or.parse(e, A[0]), r = A[1];
  return r && hA(r) ? { color: t, stop: r } : { color: t, stop: null };
}, Lg = function(e, A) {
  var t = e[0], r = e[e.length - 1];
  t.stop === null && (t.stop = FA), r.stop === null && (r.stop = Ir);
  for (var n = [], a = 0, i = 0; i < e.length; i++) {
    var s = e[i].stop;
    if (s !== null) {
      var o = Ye(s, A);
      o > a ? n.push(o) : n.push(a), a = o;
    } else
      n.push(null);
  }
  for (var u = null, i = 0; i < n.length; i++) {
    var l = n[i];
    if (l === null)
      u === null && (u = i);
    else if (u !== null) {
      for (var c = i - u, f = n[u - 1], d = (l - f) / (c + 1), h = 1; h <= c; h++)
        n[u + h - 1] = d * h;
      u = null;
    }
  }
  return e.map(function(p, v) {
    var y = p.color;
    return { color: y, stop: Math.max(Math.min(1, n[v] / A), 0) };
  });
}, kR = function(e, A, t) {
  var r = A / 2, n = t / 2, a = Ye(e[0], A) - r, i = n - Ye(e[1], t);
  return (Math.atan2(i, a) + Math.PI * 2) % (Math.PI * 2);
}, PR = function(e, A, t) {
  var r = typeof e == "number" ? e : kR(e, A, t), n = Math.abs(A * Math.sin(r)) + Math.abs(t * Math.cos(r)), a = A / 2, i = t / 2, s = n / 2, o = Math.sin(r - Math.PI / 2) * s, u = Math.cos(r - Math.PI / 2) * s;
  return [n, a - u, a + u, i - o, i + o];
}, dt = function(e, A) {
  return Math.sqrt(e * e + A * A);
}, Mg = function(e, A, t, r, n) {
  var a = [
    [0, 0],
    [0, A],
    [e, 0],
    [e, A]
  ];
  return a.reduce(function(i, s) {
    var o = s[0], u = s[1], l = dt(t - o, r - u);
    return (n ? l < i.optimumDistance : l > i.optimumDistance) ? {
      optimumCorner: s,
      optimumDistance: l
    } : i;
  }, {
    optimumDistance: n ? 1 / 0 : -1 / 0,
    optimumCorner: null
  }).optimumCorner;
}, KR = function(e, A, t, r, n) {
  var a = 0, i = 0;
  switch (e.size) {
    case 0:
      e.shape === 0 ? a = i = Math.min(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (a = Math.min(Math.abs(A), Math.abs(A - r)), i = Math.min(Math.abs(t), Math.abs(t - n)));
      break;
    case 2:
      if (e.shape === 0)
        a = i = Math.min(dt(A, t), dt(A, t - n), dt(A - r, t), dt(A - r, t - n));
      else if (e.shape === 1) {
        var s = Math.min(Math.abs(t), Math.abs(t - n)) / Math.min(Math.abs(A), Math.abs(A - r)), o = Mg(r, n, A, t, !0), u = o[0], l = o[1];
        a = dt(u - A, (l - t) / s), i = s * a;
      }
      break;
    case 1:
      e.shape === 0 ? a = i = Math.max(Math.abs(A), Math.abs(A - r), Math.abs(t), Math.abs(t - n)) : e.shape === 1 && (a = Math.max(Math.abs(A), Math.abs(A - r)), i = Math.max(Math.abs(t), Math.abs(t - n)));
      break;
    case 3:
      if (e.shape === 0)
        a = i = Math.max(dt(A, t), dt(A, t - n), dt(A - r, t), dt(A - r, t - n));
      else if (e.shape === 1) {
        var s = Math.max(Math.abs(t), Math.abs(t - n)) / Math.max(Math.abs(A), Math.abs(A - r)), c = Mg(r, n, A, t, !1), u = c[0], l = c[1];
        a = dt(u - A, (l - t) / s), i = s * a;
      }
      break;
  }
  return Array.isArray(e.size) && (a = Ye(e.size[0], r), i = e.size.length === 2 ? Ye(e.size[1], n) : a), [a, i];
}, $R = function(e, A) {
  var t = at(180), r = [];
  return Wt(A).forEach(function(n, a) {
    if (a === 0) {
      var i = n[0];
      if (i.type === 20 && i.value === "to") {
        t = ky(n);
        return;
      } else if (Ny(i)) {
        t = ku.parse(e, i);
        return;
      }
    }
    var s = Pu(e, n);
    r.push(s);
  }), {
    angle: t,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, bs = function(e, A) {
  var t = at(180), r = [];
  return Wt(A).forEach(function(n, a) {
    if (a === 0) {
      var i = n[0];
      if (i.type === 20 && ["top", "left", "right", "bottom"].indexOf(i.value) !== -1) {
        t = ky(n);
        return;
      } else if (Ny(i)) {
        t = (ku.parse(e, i) + at(270)) % at(360);
        return;
      }
    }
    var s = Pu(e, n);
    r.push(s);
  }), {
    angle: t,
    stops: r,
    type: 1
    /* LINEAR_GRADIENT */
  };
}, jR = function(e, A) {
  var t = at(180), r = [], n = 1, a = 0, i = 3, s = [];
  return Wt(A).forEach(function(o, u) {
    var l = o[0];
    if (u === 0) {
      if (Ke(l) && l.value === "linear") {
        n = 1;
        return;
      } else if (Ke(l) && l.value === "radial") {
        n = 2;
        return;
      }
    }
    if (l.type === 18) {
      if (l.name === "from") {
        var c = Or.parse(e, l.values[0]);
        r.push({ stop: FA, color: c });
      } else if (l.name === "to") {
        var c = Or.parse(e, l.values[0]);
        r.push({ stop: Ir, color: c });
      } else if (l.name === "color-stop") {
        var f = l.values.filter(pa);
        if (f.length === 2) {
          var c = Or.parse(e, f[1]), d = f[0];
          _a(d) && r.push({
            stop: { type: 16, number: d.number * 100, flags: d.flags },
            color: c
          });
        }
      }
    }
  }), n === 1 ? {
    angle: (t + at(180)) % at(360),
    stops: r,
    type: n
  } : { size: i, shape: a, stops: r, position: s, type: n };
}, Py = "closest-side", Ky = "farthest-side", $y = "closest-corner", jy = "farthest-corner", Gy = "circle", Vy = "ellipse", Wy = "cover", Yy = "contain", GR = function(e, A) {
  var t = 0, r = 3, n = [], a = [];
  return Wt(A).forEach(function(i, s) {
    var o = !0;
    if (s === 0) {
      var u = !1;
      o = i.reduce(function(c, f) {
        if (u)
          if (Ke(f))
            switch (f.value) {
              case "center":
                return a.push(Id), c;
              case "top":
              case "left":
                return a.push(FA), c;
              case "right":
              case "bottom":
                return a.push(Ir), c;
            }
          else
            (hA(f) || kr(f)) && a.push(f);
        else if (Ke(f))
          switch (f.value) {
            case Gy:
              return t = 0, !1;
            case Vy:
              return t = 1, !1;
            case "at":
              return u = !0, !1;
            case Py:
              return r = 0, !1;
            case Wy:
            case Ky:
              return r = 1, !1;
            case Yy:
            case $y:
              return r = 2, !1;
            case jy:
              return r = 3, !1;
          }
        else if (kr(f) || hA(f))
          return Array.isArray(r) || (r = []), r.push(f), !1;
        return c;
      }, o);
    }
    if (o) {
      var l = Pu(e, i);
      n.push(l);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: a,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, Ss = function(e, A) {
  var t = 0, r = 3, n = [], a = [];
  return Wt(A).forEach(function(i, s) {
    var o = !0;
    if (s === 0 ? o = i.reduce(function(l, c) {
      if (Ke(c))
        switch (c.value) {
          case "center":
            return a.push(Id), !1;
          case "top":
          case "left":
            return a.push(FA), !1;
          case "right":
          case "bottom":
            return a.push(Ir), !1;
        }
      else if (hA(c) || kr(c))
        return a.push(c), !1;
      return l;
    }, o) : s === 1 && (o = i.reduce(function(l, c) {
      if (Ke(c))
        switch (c.value) {
          case Gy:
            return t = 0, !1;
          case Vy:
            return t = 1, !1;
          case Yy:
          case Py:
            return r = 0, !1;
          case Ky:
            return r = 1, !1;
          case $y:
            return r = 2, !1;
          case Wy:
          case jy:
            return r = 3, !1;
        }
      else if (kr(c) || hA(c))
        return Array.isArray(r) || (r = []), r.push(c), !1;
      return l;
    }, o)), o) {
      var u = Pu(e, i);
      n.push(u);
    }
  }), {
    size: r,
    shape: t,
    stops: n,
    position: a,
    type: 2
    /* RADIAL_GRADIENT */
  };
}, VR = function(e) {
  return e.type === 1;
}, WR = function(e) {
  return e.type === 2;
}, Dd = {
  name: "image",
  parse: function(e, A) {
    if (A.type === 22) {
      var t = {
        url: A.value,
        type: 0
        /* URL */
      };
      return e.cache.addImage(A.value), t;
    }
    if (A.type === 18) {
      var r = zy[A.name];
      if (typeof r > "u")
        throw new Error('Attempting to parse an unsupported image function "' + A.name + '"');
      return r(e, A.values);
    }
    throw new Error("Unsupported image type " + A.type);
  }
};
function YR(e) {
  return !(e.type === 20 && e.value === "none") && (e.type !== 18 || !!zy[e.name]);
}
var zy = {
  "linear-gradient": $R,
  "-moz-linear-gradient": bs,
  "-ms-linear-gradient": bs,
  "-o-linear-gradient": bs,
  "-webkit-linear-gradient": bs,
  "radial-gradient": GR,
  "-moz-radial-gradient": Ss,
  "-ms-radial-gradient": Ss,
  "-o-radial-gradient": Ss,
  "-webkit-radial-gradient": Ss,
  "-webkit-gradient": jR
}, zR = {
  name: "background-image",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    var t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A.filter(function(r) {
      return pa(r) && YR(r);
    }).map(function(r) {
      return Dd.parse(e, r);
    });
  }
}, XR = {
  name: "background-origin",
  initialValue: "border-box",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.map(function(t) {
      if (Ke(t))
        switch (t.value) {
          case "padding-box":
            return 1;
          case "content-box":
            return 2;
        }
      return 0;
    });
  }
}, qR = {
  name: "background-position",
  initialValue: "0% 0%",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return Wt(A).map(function(t) {
      return t.filter(hA);
    }).map(Oy);
  }
}, JR = {
  name: "background-repeat",
  initialValue: "repeat",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return Wt(A).map(function(t) {
      return t.filter(Ke).map(function(r) {
        return r.value;
      }).join(" ");
    }).map(ZR);
  }
}, ZR = function(e) {
  switch (e) {
    case "no-repeat":
      return 1;
    case "repeat-x":
    case "repeat no-repeat":
      return 2;
    case "repeat-y":
    case "no-repeat repeat":
      return 3;
    case "repeat":
    default:
      return 0;
  }
}, ca;
(function(e) {
  e.AUTO = "auto", e.CONTAIN = "contain", e.COVER = "cover";
})(ca || (ca = {}));
var eN = {
  name: "background-size",
  initialValue: "0",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return Wt(A).map(function(t) {
      return t.filter(AN);
    });
  }
}, AN = function(e) {
  return Ke(e) || hA(e);
}, Ku = function(e) {
  return {
    name: "border-" + e + "-color",
    initialValue: "transparent",
    prefix: !1,
    type: 3,
    format: "color"
  };
}, tN = Ku("top"), rN = Ku("right"), nN = Ku("bottom"), aN = Ku("left"), $u = function(e) {
  return {
    name: "border-radius-" + e,
    initialValue: "0 0",
    prefix: !1,
    type: 1,
    parse: function(A, t) {
      return Oy(t.filter(hA));
    }
  };
}, iN = $u("top-left"), sN = $u("top-right"), oN = $u("bottom-right"), uN = $u("bottom-left"), ju = function(e) {
  return {
    name: "border-" + e + "-style",
    initialValue: "solid",
    prefix: !1,
    type: 2,
    parse: function(A, t) {
      switch (t) {
        case "none":
          return 0;
        case "dashed":
          return 2;
        case "dotted":
          return 3;
        case "double":
          return 4;
      }
      return 1;
    }
  };
}, lN = ju("top"), cN = ju("right"), fN = ju("bottom"), dN = ju("left"), Gu = function(e) {
  return {
    name: "border-" + e + "-width",
    initialValue: "0",
    type: 0,
    prefix: !1,
    parse: function(A, t) {
      return Wi(t) ? t.number : 0;
    }
  };
}, hN = Gu("top"), pN = Gu("right"), gN = Gu("bottom"), BN = Gu("left"), vN = {
  name: "color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, mN = {
  name: "direction",
  initialValue: "ltr",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "rtl":
        return 1;
      case "ltr":
      default:
        return 0;
    }
  }
}, wN = {
  name: "display",
  initialValue: "inline-block",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(Ke).reduce(
      function(t, r) {
        return t | yN(r.value);
      },
      0
      /* NONE */
    );
  }
}, yN = function(e) {
  switch (e) {
    case "block":
    case "-webkit-box":
      return 2;
    case "inline":
      return 4;
    case "run-in":
      return 8;
    case "flow":
      return 16;
    case "flow-root":
      return 32;
    case "table":
      return 64;
    case "flex":
    case "-webkit-flex":
      return 128;
    case "grid":
    case "-ms-grid":
      return 256;
    case "ruby":
      return 512;
    case "subgrid":
      return 1024;
    case "list-item":
      return 2048;
    case "table-row-group":
      return 4096;
    case "table-header-group":
      return 8192;
    case "table-footer-group":
      return 16384;
    case "table-row":
      return 32768;
    case "table-cell":
      return 65536;
    case "table-column-group":
      return 131072;
    case "table-column":
      return 262144;
    case "table-caption":
      return 524288;
    case "ruby-base":
      return 1048576;
    case "ruby-text":
      return 2097152;
    case "ruby-base-container":
      return 4194304;
    case "ruby-text-container":
      return 8388608;
    case "contents":
      return 16777216;
    case "inline-block":
      return 33554432;
    case "inline-list-item":
      return 67108864;
    case "inline-table":
      return 134217728;
    case "inline-flex":
      return 268435456;
    case "inline-grid":
      return 536870912;
  }
  return 0;
}, xN = {
  name: "float",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "left":
        return 1;
      case "right":
        return 2;
      case "inline-start":
        return 3;
      case "inline-end":
        return 4;
    }
    return 0;
  }
}, CN = {
  name: "letter-spacing",
  initialValue: "0",
  prefix: !1,
  type: 0,
  parse: function(e, A) {
    return A.type === 20 && A.value === "normal" ? 0 : A.type === 17 || A.type === 15 ? A.number : 0;
  }
}, Uo;
(function(e) {
  e.NORMAL = "normal", e.STRICT = "strict";
})(Uo || (Uo = {}));
var EN = {
  name: "line-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "strict":
        return Uo.STRICT;
      case "normal":
      default:
        return Uo.NORMAL;
    }
  }
}, FN = {
  name: "line-height",
  initialValue: "normal",
  prefix: !1,
  type: 4
  /* TOKEN_VALUE */
}, Rg = function(e, A) {
  return Ke(e) && e.value === "normal" ? 1.2 * A : e.type === 17 ? A * e.number : hA(e) ? Ye(e, A) : A;
}, bN = {
  name: "list-style-image",
  initialValue: "none",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return A.type === 20 && A.value === "none" ? null : Dd.parse(e, A);
  }
}, SN = {
  name: "list-style-position",
  initialValue: "outside",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "inside":
        return 0;
      case "outside":
      default:
        return 1;
    }
  }
}, Pf = {
  name: "list-style-type",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "disc":
        return 0;
      case "circle":
        return 1;
      case "square":
        return 2;
      case "decimal":
        return 3;
      case "cjk-decimal":
        return 4;
      case "decimal-leading-zero":
        return 5;
      case "lower-roman":
        return 6;
      case "upper-roman":
        return 7;
      case "lower-greek":
        return 8;
      case "lower-alpha":
        return 9;
      case "upper-alpha":
        return 10;
      case "arabic-indic":
        return 11;
      case "armenian":
        return 12;
      case "bengali":
        return 13;
      case "cambodian":
        return 14;
      case "cjk-earthly-branch":
        return 15;
      case "cjk-heavenly-stem":
        return 16;
      case "cjk-ideographic":
        return 17;
      case "devanagari":
        return 18;
      case "ethiopic-numeric":
        return 19;
      case "georgian":
        return 20;
      case "gujarati":
        return 21;
      case "gurmukhi":
        return 22;
      case "hebrew":
        return 22;
      case "hiragana":
        return 23;
      case "hiragana-iroha":
        return 24;
      case "japanese-formal":
        return 25;
      case "japanese-informal":
        return 26;
      case "kannada":
        return 27;
      case "katakana":
        return 28;
      case "katakana-iroha":
        return 29;
      case "khmer":
        return 30;
      case "korean-hangul-formal":
        return 31;
      case "korean-hanja-formal":
        return 32;
      case "korean-hanja-informal":
        return 33;
      case "lao":
        return 34;
      case "lower-armenian":
        return 35;
      case "malayalam":
        return 36;
      case "mongolian":
        return 37;
      case "myanmar":
        return 38;
      case "oriya":
        return 39;
      case "persian":
        return 40;
      case "simp-chinese-formal":
        return 41;
      case "simp-chinese-informal":
        return 42;
      case "tamil":
        return 43;
      case "telugu":
        return 44;
      case "thai":
        return 45;
      case "tibetan":
        return 46;
      case "trad-chinese-formal":
        return 47;
      case "trad-chinese-informal":
        return 48;
      case "upper-armenian":
        return 49;
      case "disclosure-open":
        return 50;
      case "disclosure-closed":
        return 51;
      case "none":
      default:
        return -1;
    }
  }
}, Vu = function(e) {
  return {
    name: "margin-" + e,
    initialValue: "0",
    prefix: !1,
    type: 4
    /* TOKEN_VALUE */
  };
}, UN = Vu("top"), _N = Vu("right"), QN = Vu("bottom"), IN = Vu("left"), DN = {
  name: "overflow",
  initialValue: "visible",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(Ke).map(function(t) {
      switch (t.value) {
        case "hidden":
          return 1;
        case "scroll":
          return 2;
        case "clip":
          return 3;
        case "auto":
          return 4;
        case "visible":
        default:
          return 0;
      }
    });
  }
}, TN = {
  name: "overflow-wrap",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "break-word":
        return "break-word";
      case "normal":
      default:
        return "normal";
    }
  }
}, Wu = function(e) {
  return {
    name: "padding-" + e,
    initialValue: "0",
    prefix: !1,
    type: 3,
    format: "length-percentage"
  };
}, ON = Wu("top"), HN = Wu("right"), LN = Wu("bottom"), MN = Wu("left"), RN = {
  name: "text-align",
  initialValue: "left",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "right":
        return 2;
      case "center":
      case "justify":
        return 1;
      case "left":
      default:
        return 0;
    }
  }
}, NN = {
  name: "position",
  initialValue: "static",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "relative":
        return 1;
      case "absolute":
        return 2;
      case "fixed":
        return 3;
      case "sticky":
        return 4;
    }
    return 0;
  }
}, kN = {
  name: "text-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.length === 1 && kf(A[0], "none") ? [] : Wt(A).map(function(t) {
      for (var r = {
        color: lr.TRANSPARENT,
        offsetX: FA,
        offsetY: FA,
        blur: FA
      }, n = 0, a = 0; a < t.length; a++) {
        var i = t[a];
        kr(i) ? (n === 0 ? r.offsetX = i : n === 1 ? r.offsetY = i : r.blur = i, n++) : r.color = Or.parse(e, i);
      }
      return r;
    });
  }
}, PN = {
  name: "text-transform",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "uppercase":
        return 2;
      case "lowercase":
        return 1;
      case "capitalize":
        return 3;
    }
    return 0;
  }
}, KN = {
  name: "transform",
  initialValue: "none",
  prefix: !0,
  type: 0,
  parse: function(e, A) {
    if (A.type === 20 && A.value === "none")
      return null;
    if (A.type === 18) {
      var t = GN[A.name];
      if (typeof t > "u")
        throw new Error('Attempting to parse an unsupported transform function "' + A.name + '"');
      return t(A.values);
    }
    return null;
  }
}, $N = function(e) {
  var A = e.filter(function(t) {
    return t.type === 17;
  }).map(function(t) {
    return t.number;
  });
  return A.length === 6 ? A : null;
}, jN = function(e) {
  var A = e.filter(function(o) {
    return o.type === 17;
  }).map(function(o) {
    return o.number;
  }), t = A[0], r = A[1];
  A[2], A[3];
  var n = A[4], a = A[5];
  A[6], A[7], A[8], A[9], A[10], A[11];
  var i = A[12], s = A[13];
  return A[14], A[15], A.length === 16 ? [t, r, n, a, i, s] : null;
}, GN = {
  matrix: $N,
  matrix3d: jN
}, Ng = {
  type: 16,
  number: 50,
  flags: Vi
}, VN = [Ng, Ng], WN = {
  name: "transform-origin",
  initialValue: "50% 50%",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    var t = A.filter(hA);
    return t.length !== 2 ? VN : [t[0], t[1]];
  }
}, YN = {
  name: "visible",
  initialValue: "none",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "hidden":
        return 1;
      case "collapse":
        return 2;
      case "visible":
      default:
        return 0;
    }
  }
}, ci;
(function(e) {
  e.NORMAL = "normal", e.BREAK_ALL = "break-all", e.KEEP_ALL = "keep-all";
})(ci || (ci = {}));
var zN = {
  name: "word-break",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "break-all":
        return ci.BREAK_ALL;
      case "keep-all":
        return ci.KEEP_ALL;
      case "normal":
      default:
        return ci.NORMAL;
    }
  }
}, XN = {
  name: "z-index",
  initialValue: "auto",
  prefix: !1,
  type: 0,
  parse: function(e, A) {
    if (A.type === 20)
      return { auto: !0, order: 0 };
    if (_a(A))
      return { auto: !1, order: A.number };
    throw new Error("Invalid z-index number parsed");
  }
}, Xy = {
  name: "time",
  parse: function(e, A) {
    if (A.type === 15)
      switch (A.unit.toLowerCase()) {
        case "s":
          return 1e3 * A.number;
        case "ms":
          return A.number;
      }
    throw new Error("Unsupported time type");
  }
}, qN = {
  name: "opacity",
  initialValue: "1",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return _a(A) ? A.number : 1;
  }
}, JN = {
  name: "text-decoration-color",
  initialValue: "transparent",
  prefix: !1,
  type: 3,
  format: "color"
}, ZN = {
  name: "text-decoration-line",
  initialValue: "none",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(Ke).map(function(t) {
      switch (t.value) {
        case "underline":
          return 1;
        case "overline":
          return 2;
        case "line-through":
          return 3;
        case "none":
          return 4;
      }
      return 0;
    }).filter(function(t) {
      return t !== 0;
    });
  }
}, e6 = {
  name: "font-family",
  initialValue: "",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    var t = [], r = [];
    return A.forEach(function(n) {
      switch (n.type) {
        case 20:
        case 0:
          t.push(n.value);
          break;
        case 17:
          t.push(n.number.toString());
          break;
        case 4:
          r.push(t.join(" ")), t.length = 0;
          break;
      }
    }), t.length && r.push(t.join(" ")), r.map(function(n) {
      return n.indexOf(" ") === -1 ? n : "'" + n + "'";
    });
  }
}, A6 = {
  name: "font-size",
  initialValue: "0",
  prefix: !1,
  type: 3,
  format: "length"
}, t6 = {
  name: "font-weight",
  initialValue: "normal",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    if (_a(A))
      return A.number;
    if (Ke(A))
      switch (A.value) {
        case "bold":
          return 700;
        case "normal":
        default:
          return 400;
      }
    return 400;
  }
}, r6 = {
  name: "font-variant",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.filter(Ke).map(function(t) {
      return t.value;
    });
  }
}, n6 = {
  name: "font-style",
  initialValue: "normal",
  prefix: !1,
  type: 2,
  parse: function(e, A) {
    switch (A) {
      case "oblique":
        return "oblique";
      case "italic":
        return "italic";
      case "normal":
      default:
        return "normal";
    }
  }
}, BA = function(e, A) {
  return (e & A) !== 0;
}, a6 = {
  name: "content",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    var t = A[0];
    return t.type === 20 && t.value === "none" ? [] : A;
  }
}, i6 = {
  name: "counter-increment",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return null;
    var t = A[0];
    if (t.type === 20 && t.value === "none")
      return null;
    for (var r = [], n = A.filter(Ty), a = 0; a < n.length; a++) {
      var i = n[a], s = n[a + 1];
      if (i.type === 20) {
        var o = s && _a(s) ? s.number : 1;
        r.push({ counter: i.value, increment: o });
      }
    }
    return r;
  }
}, s6 = {
  name: "counter-reset",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return [];
    for (var t = [], r = A.filter(Ty), n = 0; n < r.length; n++) {
      var a = r[n], i = r[n + 1];
      if (Ke(a) && a.value !== "none") {
        var s = i && _a(i) ? i.number : 0;
        t.push({ counter: a.value, reset: s });
      }
    }
    return t;
  }
}, o6 = {
  name: "duration",
  initialValue: "0s",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    return A.filter(Wi).map(function(t) {
      return Xy.parse(e, t);
    });
  }
}, u6 = {
  name: "quotes",
  initialValue: "none",
  prefix: !0,
  type: 1,
  parse: function(e, A) {
    if (A.length === 0)
      return null;
    var t = A[0];
    if (t.type === 20 && t.value === "none")
      return null;
    var r = [], n = A.filter(HR);
    if (n.length % 2 !== 0)
      return null;
    for (var a = 0; a < n.length; a += 2) {
      var i = n[a].value, s = n[a + 1].value;
      r.push({ open: i, close: s });
    }
    return r;
  }
}, kg = function(e, A, t) {
  if (!e)
    return "";
  var r = e[Math.min(A, e.length - 1)];
  return r ? t ? r.open : r.close : "";
}, l6 = {
  name: "box-shadow",
  initialValue: "none",
  type: 1,
  prefix: !1,
  parse: function(e, A) {
    return A.length === 1 && kf(A[0], "none") ? [] : Wt(A).map(function(t) {
      for (var r = {
        color: 255,
        offsetX: FA,
        offsetY: FA,
        blur: FA,
        spread: FA,
        inset: !1
      }, n = 0, a = 0; a < t.length; a++) {
        var i = t[a];
        kf(i, "inset") ? r.inset = !0 : kr(i) ? (n === 0 ? r.offsetX = i : n === 1 ? r.offsetY = i : n === 2 ? r.blur = i : r.spread = i, n++) : r.color = Or.parse(e, i);
      }
      return r;
    });
  }
}, c6 = {
  name: "paint-order",
  initialValue: "normal",
  prefix: !1,
  type: 1,
  parse: function(e, A) {
    var t = [
      0,
      1,
      2
      /* MARKERS */
    ], r = [];
    return A.filter(Ke).forEach(function(n) {
      switch (n.value) {
        case "stroke":
          r.push(
            1
            /* STROKE */
          );
          break;
        case "fill":
          r.push(
            0
            /* FILL */
          );
          break;
        case "markers":
          r.push(
            2
            /* MARKERS */
          );
          break;
      }
    }), t.forEach(function(n) {
      r.indexOf(n) === -1 && r.push(n);
    }), r;
  }
}, f6 = {
  name: "-webkit-text-stroke-color",
  initialValue: "currentcolor",
  prefix: !1,
  type: 3,
  format: "color"
}, d6 = {
  name: "-webkit-text-stroke-width",
  initialValue: "0",
  type: 0,
  prefix: !1,
  parse: function(e, A) {
    return Wi(A) ? A.number : 0;
  }
}, h6 = (
  /** @class */
  function() {
    function e(A, t) {
      var r, n;
      this.animationDuration = ie(A, o6, t.animationDuration), this.backgroundClip = ie(A, RR, t.backgroundClip), this.backgroundColor = ie(A, NR, t.backgroundColor), this.backgroundImage = ie(A, zR, t.backgroundImage), this.backgroundOrigin = ie(A, XR, t.backgroundOrigin), this.backgroundPosition = ie(A, qR, t.backgroundPosition), this.backgroundRepeat = ie(A, JR, t.backgroundRepeat), this.backgroundSize = ie(A, eN, t.backgroundSize), this.borderTopColor = ie(A, tN, t.borderTopColor), this.borderRightColor = ie(A, rN, t.borderRightColor), this.borderBottomColor = ie(A, nN, t.borderBottomColor), this.borderLeftColor = ie(A, aN, t.borderLeftColor), this.borderTopLeftRadius = ie(A, iN, t.borderTopLeftRadius), this.borderTopRightRadius = ie(A, sN, t.borderTopRightRadius), this.borderBottomRightRadius = ie(A, oN, t.borderBottomRightRadius), this.borderBottomLeftRadius = ie(A, uN, t.borderBottomLeftRadius), this.borderTopStyle = ie(A, lN, t.borderTopStyle), this.borderRightStyle = ie(A, cN, t.borderRightStyle), this.borderBottomStyle = ie(A, fN, t.borderBottomStyle), this.borderLeftStyle = ie(A, dN, t.borderLeftStyle), this.borderTopWidth = ie(A, hN, t.borderTopWidth), this.borderRightWidth = ie(A, pN, t.borderRightWidth), this.borderBottomWidth = ie(A, gN, t.borderBottomWidth), this.borderLeftWidth = ie(A, BN, t.borderLeftWidth), this.boxShadow = ie(A, l6, t.boxShadow), this.color = ie(A, vN, t.color), this.direction = ie(A, mN, t.direction), this.display = ie(A, wN, t.display), this.float = ie(A, xN, t.cssFloat), this.fontFamily = ie(A, e6, t.fontFamily), this.fontSize = ie(A, A6, t.fontSize), this.fontStyle = ie(A, n6, t.fontStyle), this.fontVariant = ie(A, r6, t.fontVariant), this.fontWeight = ie(A, t6, t.fontWeight), this.letterSpacing = ie(A, CN, t.letterSpacing), this.lineBreak = ie(A, EN, t.lineBreak), this.lineHeight = ie(A, FN, t.lineHeight), this.listStyleImage = ie(A, bN, t.listStyleImage), this.listStylePosition = ie(A, SN, t.listStylePosition), this.listStyleType = ie(A, Pf, t.listStyleType), this.marginTop = ie(A, UN, t.marginTop), this.marginRight = ie(A, _N, t.marginRight), this.marginBottom = ie(A, QN, t.marginBottom), this.marginLeft = ie(A, IN, t.marginLeft), this.opacity = ie(A, qN, t.opacity);
      var a = ie(A, DN, t.overflow);
      this.overflowX = a[0], this.overflowY = a[a.length > 1 ? 1 : 0], this.overflowWrap = ie(A, TN, t.overflowWrap), this.paddingTop = ie(A, ON, t.paddingTop), this.paddingRight = ie(A, HN, t.paddingRight), this.paddingBottom = ie(A, LN, t.paddingBottom), this.paddingLeft = ie(A, MN, t.paddingLeft), this.paintOrder = ie(A, c6, t.paintOrder), this.position = ie(A, NN, t.position), this.textAlign = ie(A, RN, t.textAlign), this.textDecorationColor = ie(A, JN, (r = t.textDecorationColor) !== null && r !== void 0 ? r : t.color), this.textDecorationLine = ie(A, ZN, (n = t.textDecorationLine) !== null && n !== void 0 ? n : t.textDecoration), this.textShadow = ie(A, kN, t.textShadow), this.textTransform = ie(A, PN, t.textTransform), this.transform = ie(A, KN, t.transform), this.transformOrigin = ie(A, WN, t.transformOrigin), this.visibility = ie(A, YN, t.visibility), this.webkitTextStrokeColor = ie(A, f6, t.webkitTextStrokeColor), this.webkitTextStrokeWidth = ie(A, d6, t.webkitTextStrokeWidth), this.wordBreak = ie(A, zN, t.wordBreak), this.zIndex = ie(A, XN, t.zIndex);
    }
    return e.prototype.isVisible = function() {
      return this.display > 0 && this.opacity > 0 && this.visibility === 0;
    }, e.prototype.isTransparent = function() {
      return Hr(this.backgroundColor);
    }, e.prototype.isTransformed = function() {
      return this.transform !== null;
    }, e.prototype.isPositioned = function() {
      return this.position !== 0;
    }, e.prototype.isPositionedWithZIndex = function() {
      return this.isPositioned() && !this.zIndex.auto;
    }, e.prototype.isFloating = function() {
      return this.float !== 0;
    }, e.prototype.isInlineLevel = function() {
      return BA(
        this.display,
        4
        /* INLINE */
      ) || BA(
        this.display,
        33554432
        /* INLINE_BLOCK */
      ) || BA(
        this.display,
        268435456
        /* INLINE_FLEX */
      ) || BA(
        this.display,
        536870912
        /* INLINE_GRID */
      ) || BA(
        this.display,
        67108864
        /* INLINE_LIST_ITEM */
      ) || BA(
        this.display,
        134217728
        /* INLINE_TABLE */
      );
    }, e;
  }()
), p6 = (
  /** @class */
  function() {
    function e(A, t) {
      this.content = ie(A, a6, t.content), this.quotes = ie(A, u6, t.quotes);
    }
    return e;
  }()
), Pg = (
  /** @class */
  function() {
    function e(A, t) {
      this.counterIncrement = ie(A, i6, t.counterIncrement), this.counterReset = ie(A, s6, t.counterReset);
    }
    return e;
  }()
), ie = function(e, A, t) {
  var r = new Iy(), n = t !== null && typeof t < "u" ? t.toString() : A.initialValue;
  r.write(n);
  var a = new Dy(r.read());
  switch (A.type) {
    case 2:
      var i = a.parseComponentValue();
      return A.parse(e, Ke(i) ? i.value : A.initialValue);
    case 0:
      return A.parse(e, a.parseComponentValue());
    case 1:
      return A.parse(e, a.parseComponentValues());
    case 4:
      return a.parseComponentValue();
    case 3:
      switch (A.format) {
        case "angle":
          return ku.parse(e, a.parseComponentValue());
        case "color":
          return Or.parse(e, a.parseComponentValue());
        case "image":
          return Dd.parse(e, a.parseComponentValue());
        case "length":
          var s = a.parseComponentValue();
          return kr(s) ? s : FA;
        case "length-percentage":
          var o = a.parseComponentValue();
          return hA(o) ? o : FA;
        case "time":
          return Xy.parse(e, a.parseComponentValue());
      }
      break;
  }
}, g6 = "data-html2canvas-debug", B6 = function(e) {
  var A = e.getAttribute(g6);
  switch (A) {
    case "all":
      return 1;
    case "clone":
      return 2;
    case "parse":
      return 3;
    case "render":
      return 4;
    default:
      return 0;
  }
}, Kf = function(e, A) {
  var t = B6(e);
  return t === 1 || A === t;
}, Yt = (
  /** @class */
  function() {
    function e(A, t) {
      if (this.context = A, this.textNodes = [], this.elements = [], this.flags = 0, Kf(
        t,
        3
        /* PARSE */
      ))
        debugger;
      this.styles = new h6(A, window.getComputedStyle(t, null)), Gf(t) && (this.styles.animationDuration.some(function(r) {
        return r > 0;
      }) && (t.style.animationDuration = "0s"), this.styles.transform !== null && (t.style.transform = "none")), this.bounds = Ru(this.context, t), Kf(
        t,
        4
        /* RENDER */
      ) && (this.flags |= 16);
    }
    return e;
  }()
), v6 = "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", Kg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ei = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Us = 0; Us < Kg.length; Us++)
  ei[Kg.charCodeAt(Us)] = Us;
var m6 = function(e) {
  var A = e.length * 0.75, t = e.length, r, n = 0, a, i, s, o;
  e[e.length - 1] === "=" && (A--, e[e.length - 2] === "=" && A--);
  var u = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && typeof Uint8Array.prototype.slice < "u" ? new ArrayBuffer(A) : new Array(A), l = Array.isArray(u) ? u : new Uint8Array(u);
  for (r = 0; r < t; r += 4)
    a = ei[e.charCodeAt(r)], i = ei[e.charCodeAt(r + 1)], s = ei[e.charCodeAt(r + 2)], o = ei[e.charCodeAt(r + 3)], l[n++] = a << 2 | i >> 4, l[n++] = (i & 15) << 4 | s >> 2, l[n++] = (s & 3) << 6 | o & 63;
  return u;
}, w6 = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 2)
    t.push(e[r + 1] << 8 | e[r]);
  return t;
}, y6 = function(e) {
  for (var A = e.length, t = [], r = 0; r < A; r += 4)
    t.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
  return t;
}, mn = 5, Td = 6 + 5, Cc = 2, x6 = Td - mn, qy = 65536 >> mn, C6 = 1 << mn, Ec = C6 - 1, E6 = 1024 >> mn, F6 = qy + E6, b6 = F6, S6 = 32, U6 = b6 + S6, _6 = 65536 >> Td, Q6 = 1 << x6, I6 = Q6 - 1, $g = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint16Array(Array.prototype.slice.call(e, A, t));
}, D6 = function(e, A, t) {
  return e.slice ? e.slice(A, t) : new Uint32Array(Array.prototype.slice.call(e, A, t));
}, T6 = function(e, A) {
  var t = m6(e), r = Array.isArray(t) ? y6(t) : new Uint32Array(t), n = Array.isArray(t) ? w6(t) : new Uint16Array(t), a = 24, i = $g(n, a / 2, r[4] / 2), s = r[5] === 2 ? $g(n, (a + r[4]) / 2) : D6(r, Math.ceil((a + r[4]) / 4));
  return new O6(r[0], r[1], r[2], r[3], i, s);
}, O6 = (
  /** @class */
  function() {
    function e(A, t, r, n, a, i) {
      this.initialValue = A, this.errorValue = t, this.highStart = r, this.highValueIndex = n, this.index = a, this.data = i;
    }
    return e.prototype.get = function(A) {
      var t;
      if (A >= 0) {
        if (A < 55296 || A > 56319 && A <= 65535)
          return t = this.index[A >> mn], t = (t << Cc) + (A & Ec), this.data[t];
        if (A <= 65535)
          return t = this.index[qy + (A - 55296 >> mn)], t = (t << Cc) + (A & Ec), this.data[t];
        if (A < this.highStart)
          return t = U6 - _6 + (A >> Td), t = this.index[t], t += A >> mn & I6, t = this.index[t], t = (t << Cc) + (A & Ec), this.data[t];
        if (A <= 1114111)
          return this.data[this.highValueIndex];
      }
      return this.errorValue;
    }, e;
  }()
), jg = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", H6 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var _s = 0; _s < jg.length; _s++)
  H6[jg.charCodeAt(_s)] = _s;
var L6 = 1, Fc = 2, bc = 3, Gg = 4, Vg = 5, M6 = 7, Wg = 8, Sc = 9, Uc = 10, Yg = 11, zg = 12, Xg = 13, qg = 14, _c = 15, R6 = function(e) {
  for (var A = [], t = 0, r = e.length; t < r; ) {
    var n = e.charCodeAt(t++);
    if (n >= 55296 && n <= 56319 && t < r) {
      var a = e.charCodeAt(t++);
      (a & 64512) === 56320 ? A.push(((n & 1023) << 10) + (a & 1023) + 65536) : (A.push(n), t--);
    } else
      A.push(n);
  }
  return A;
}, N6 = function() {
  for (var e = [], A = 0; A < arguments.length; A++)
    e[A] = arguments[A];
  if (String.fromCodePoint)
    return String.fromCodePoint.apply(String, e);
  var t = e.length;
  if (!t)
    return "";
  for (var r = [], n = -1, a = ""; ++n < t; ) {
    var i = e[n];
    i <= 65535 ? r.push(i) : (i -= 65536, r.push((i >> 10) + 55296, i % 1024 + 56320)), (n + 1 === t || r.length > 16384) && (a += String.fromCharCode.apply(String, r), r.length = 0);
  }
  return a;
}, k6 = T6(v6), At = "×", Qc = "÷", P6 = function(e) {
  return k6.get(e);
}, K6 = function(e, A, t) {
  var r = t - 2, n = A[r], a = A[t - 1], i = A[t];
  if (a === Fc && i === bc)
    return At;
  if (a === Fc || a === bc || a === Gg || i === Fc || i === bc || i === Gg)
    return Qc;
  if (a === Wg && [Wg, Sc, Yg, zg].indexOf(i) !== -1 || (a === Yg || a === Sc) && (i === Sc || i === Uc) || (a === zg || a === Uc) && i === Uc || i === Xg || i === Vg || i === M6 || a === L6)
    return At;
  if (a === Xg && i === qg) {
    for (; n === Vg; )
      n = A[--r];
    if (n === qg)
      return At;
  }
  if (a === _c && i === _c) {
    for (var s = 0; n === _c; )
      s++, n = A[--r];
    if (s % 2 === 0)
      return At;
  }
  return Qc;
}, $6 = function(e) {
  var A = R6(e), t = A.length, r = 0, n = 0, a = A.map(P6);
  return {
    next: function() {
      if (r >= t)
        return { done: !0, value: null };
      for (var i = At; r < t && (i = K6(A, a, ++r)) === At; )
        ;
      if (i !== At || r === t) {
        var s = N6.apply(null, A.slice(n, r));
        return n = r, { value: s, done: !1 };
      }
      return { done: !0, value: null };
    }
  };
}, j6 = function(e) {
  for (var A = $6(e), t = [], r; !(r = A.next()).done; )
    r.value && t.push(r.value.slice());
  return t;
}, G6 = function(e) {
  var A = 123;
  if (e.createRange) {
    var t = e.createRange();
    if (t.getBoundingClientRect) {
      var r = e.createElement("boundtest");
      r.style.height = A + "px", r.style.display = "block", e.body.appendChild(r), t.selectNode(r);
      var n = t.getBoundingClientRect(), a = Math.round(n.height);
      if (e.body.removeChild(r), a === A)
        return !0;
    }
  }
  return !1;
}, V6 = function(e) {
  var A = e.createElement("boundtest");
  A.style.width = "50px", A.style.display = "block", A.style.fontSize = "12px", A.style.letterSpacing = "0px", A.style.wordSpacing = "0px", e.body.appendChild(A);
  var t = e.createRange();
  A.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
  var r = A.firstChild, n = Nu(r.data).map(function(o) {
    return uA(o);
  }), a = 0, i = {}, s = n.every(function(o, u) {
    t.setStart(r, a), t.setEnd(r, a + o.length);
    var l = t.getBoundingClientRect();
    a += o.length;
    var c = l.x > i.x || l.y > i.y;
    return i = l, u === 0 ? !0 : c;
  });
  return e.body.removeChild(A), s;
}, W6 = function() {
  return typeof new Image().crossOrigin < "u";
}, Y6 = function() {
  return typeof new XMLHttpRequest().responseType == "string";
}, z6 = function(e) {
  var A = new Image(), t = e.createElement("canvas"), r = t.getContext("2d");
  if (!r)
    return !1;
  A.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
  try {
    r.drawImage(A, 0, 0), t.toDataURL();
  } catch {
    return !1;
  }
  return !0;
}, Jg = function(e) {
  return e[0] === 0 && e[1] === 255 && e[2] === 0 && e[3] === 255;
}, X6 = function(e) {
  var A = e.createElement("canvas"), t = 100;
  A.width = t, A.height = t;
  var r = A.getContext("2d");
  if (!r)
    return Promise.reject(!1);
  r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, t, t);
  var n = new Image(), a = A.toDataURL();
  n.src = a;
  var i = $f(t, t, 0, 0, n);
  return r.fillStyle = "red", r.fillRect(0, 0, t, t), Zg(i).then(function(s) {
    r.drawImage(s, 0, 0);
    var o = r.getImageData(0, 0, t, t).data;
    r.fillStyle = "red", r.fillRect(0, 0, t, t);
    var u = e.createElement("div");
    return u.style.backgroundImage = "url(" + a + ")", u.style.height = t + "px", Jg(o) ? Zg($f(t, t, 0, 0, u)) : Promise.reject(!1);
  }).then(function(s) {
    return r.drawImage(s, 0, 0), Jg(r.getImageData(0, 0, t, t).data);
  }).catch(function() {
    return !1;
  });
}, $f = function(e, A, t, r, n) {
  var a = "http://www.w3.org/2000/svg", i = document.createElementNS(a, "svg"), s = document.createElementNS(a, "foreignObject");
  return i.setAttributeNS(null, "width", e.toString()), i.setAttributeNS(null, "height", A.toString()), s.setAttributeNS(null, "width", "100%"), s.setAttributeNS(null, "height", "100%"), s.setAttributeNS(null, "x", t.toString()), s.setAttributeNS(null, "y", r.toString()), s.setAttributeNS(null, "externalResourcesRequired", "true"), i.appendChild(s), s.appendChild(n), i;
}, Zg = function(e) {
  return new Promise(function(A, t) {
    var r = new Image();
    r.onload = function() {
      return A(r);
    }, r.onerror = t, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
  });
}, CA = {
  get SUPPORT_RANGE_BOUNDS() {
    var e = G6(document);
    return Object.defineProperty(CA, "SUPPORT_RANGE_BOUNDS", { value: e }), e;
  },
  get SUPPORT_WORD_BREAKING() {
    var e = CA.SUPPORT_RANGE_BOUNDS && V6(document);
    return Object.defineProperty(CA, "SUPPORT_WORD_BREAKING", { value: e }), e;
  },
  get SUPPORT_SVG_DRAWING() {
    var e = z6(document);
    return Object.defineProperty(CA, "SUPPORT_SVG_DRAWING", { value: e }), e;
  },
  get SUPPORT_FOREIGNOBJECT_DRAWING() {
    var e = typeof Array.from == "function" && typeof window.fetch == "function" ? X6(document) : Promise.resolve(!1);
    return Object.defineProperty(CA, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: e }), e;
  },
  get SUPPORT_CORS_IMAGES() {
    var e = W6();
    return Object.defineProperty(CA, "SUPPORT_CORS_IMAGES", { value: e }), e;
  },
  get SUPPORT_RESPONSE_TYPE() {
    var e = Y6();
    return Object.defineProperty(CA, "SUPPORT_RESPONSE_TYPE", { value: e }), e;
  },
  get SUPPORT_CORS_XHR() {
    var e = "withCredentials" in new XMLHttpRequest();
    return Object.defineProperty(CA, "SUPPORT_CORS_XHR", { value: e }), e;
  },
  get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
    var e = !!(typeof Intl < "u" && Intl.Segmenter);
    return Object.defineProperty(CA, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: e }), e;
  }
}, fi = (
  /** @class */
  function() {
    function e(A, t) {
      this.text = A, this.bounds = t;
    }
    return e;
  }()
), q6 = function(e, A, t, r) {
  var n = ek(A, t), a = [], i = 0;
  return n.forEach(function(s) {
    if (t.textDecorationLine.length || s.trim().length > 0)
      if (CA.SUPPORT_RANGE_BOUNDS) {
        var o = eB(r, i, s.length).getClientRects();
        if (o.length > 1) {
          var u = Od(s), l = 0;
          u.forEach(function(f) {
            a.push(new fi(f, fr.fromDOMRectList(e, eB(r, l + i, f.length).getClientRects()))), l += f.length;
          });
        } else
          a.push(new fi(s, fr.fromDOMRectList(e, o)));
      } else {
        var c = r.splitText(s.length);
        a.push(new fi(s, J6(e, r))), r = c;
      }
    else
      CA.SUPPORT_RANGE_BOUNDS || (r = r.splitText(s.length));
    i += s.length;
  }), a;
}, J6 = function(e, A) {
  var t = A.ownerDocument;
  if (t) {
    var r = t.createElement("html2canvaswrapper");
    r.appendChild(A.cloneNode(!0));
    var n = A.parentNode;
    if (n) {
      n.replaceChild(r, A);
      var a = Ru(e, r);
      return r.firstChild && n.replaceChild(r.firstChild, r), a;
    }
  }
  return fr.EMPTY;
}, eB = function(e, A, t) {
  var r = e.ownerDocument;
  if (!r)
    throw new Error("Node has no owner document");
  var n = r.createRange();
  return n.setStart(e, A), n.setEnd(e, A + t), n;
}, Od = function(e) {
  if (CA.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var A = new Intl.Segmenter(void 0, { granularity: "grapheme" });
    return Array.from(A.segment(e)).map(function(t) {
      return t.segment;
    });
  }
  return j6(e);
}, Z6 = function(e, A) {
  if (CA.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
    var t = new Intl.Segmenter(void 0, {
      granularity: "word"
    });
    return Array.from(t.segment(e)).map(function(r) {
      return r.segment;
    });
  }
  return tk(e, A);
}, ek = function(e, A) {
  return A.letterSpacing !== 0 ? Od(e) : Z6(e, A);
}, Ak = [32, 160, 4961, 65792, 65793, 4153, 4241], tk = function(e, A) {
  for (var t = _3(e, {
    lineBreak: A.lineBreak,
    wordBreak: A.overflowWrap === "break-word" ? "break-word" : A.wordBreak
  }), r = [], n, a = function() {
    if (n.value) {
      var i = n.value.slice(), s = Nu(i), o = "";
      s.forEach(function(u) {
        Ak.indexOf(u) === -1 ? o += uA(u) : (o.length && r.push(o), r.push(uA(u)), o = "");
      }), o.length && r.push(o);
    }
  }; !(n = t.next()).done; )
    a();
  return r;
}, rk = (
  /** @class */
  function() {
    function e(A, t, r) {
      this.text = nk(t.data, r.textTransform), this.textBounds = q6(A, this.text, r, t);
    }
    return e;
  }()
), nk = function(e, A) {
  switch (A) {
    case 1:
      return e.toLowerCase();
    case 3:
      return e.replace(ak, ik);
    case 2:
      return e.toUpperCase();
    default:
      return e;
  }
}, ak = /(^|\s|:|-|\(|\))([a-z])/g, ik = function(e, A, t) {
  return e.length > 0 ? A + t.toUpperCase() : e;
}, Jy = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.src = r.currentSrc || r.src, n.intrinsicWidth = r.naturalWidth, n.intrinsicHeight = r.naturalHeight, n.context.cache.addImage(n.src), n;
    }
    return A;
  }(Yt)
), Zy = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.canvas = r, n.intrinsicWidth = r.width, n.intrinsicHeight = r.height, n;
    }
    return A;
  }(Yt)
), ex = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this, a = new XMLSerializer(), i = Ru(t, r);
      return r.setAttribute("width", i.width + "px"), r.setAttribute("height", i.height + "px"), n.svg = "data:image/svg+xml," + encodeURIComponent(a.serializeToString(r)), n.intrinsicWidth = r.width.baseVal.value, n.intrinsicHeight = r.height.baseVal.value, n.context.cache.addImage(n.svg), n;
    }
    return A;
  }(Yt)
), Ax = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.value = r.value, n;
    }
    return A;
  }(Yt)
), jf = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.start = r.start, n.reversed = typeof r.reversed == "boolean" && r.reversed === !0, n;
    }
    return A;
  }(Yt)
), sk = [
  {
    type: 15,
    flags: 0,
    unit: "px",
    number: 3
  }
], ok = [
  {
    type: 16,
    flags: 0,
    number: 50
  }
], uk = function(e) {
  return e.width > e.height ? new fr(e.left + (e.width - e.height) / 2, e.top, e.height, e.height) : e.width < e.height ? new fr(e.left, e.top + (e.height - e.width) / 2, e.width, e.width) : e;
}, lk = function(e) {
  var A = e.type === ck ? new Array(e.value.length + 1).join("•") : e.value;
  return A.length === 0 ? e.placeholder || "" : A;
}, _o = "checkbox", Qo = "radio", ck = "password", AB = 707406591, Hd = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      switch (n.type = r.type.toLowerCase(), n.checked = r.checked, n.value = lk(r), (n.type === _o || n.type === Qo) && (n.styles.backgroundColor = 3739148031, n.styles.borderTopColor = n.styles.borderRightColor = n.styles.borderBottomColor = n.styles.borderLeftColor = 2779096575, n.styles.borderTopWidth = n.styles.borderRightWidth = n.styles.borderBottomWidth = n.styles.borderLeftWidth = 1, n.styles.borderTopStyle = n.styles.borderRightStyle = n.styles.borderBottomStyle = n.styles.borderLeftStyle = 1, n.styles.backgroundClip = [
        0
        /* BORDER_BOX */
      ], n.styles.backgroundOrigin = [
        0
        /* BORDER_BOX */
      ], n.bounds = uk(n.bounds)), n.type) {
        case _o:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = sk;
          break;
        case Qo:
          n.styles.borderTopRightRadius = n.styles.borderTopLeftRadius = n.styles.borderBottomRightRadius = n.styles.borderBottomLeftRadius = ok;
          break;
      }
      return n;
    }
    return A;
  }(Yt)
), tx = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this, a = r.options[r.selectedIndex || 0];
      return n.value = a && a.text || "", n;
    }
    return A;
  }(Yt)
), rx = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.value = r.value, n;
    }
    return A;
  }(Yt)
), nx = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      n.src = r.src, n.width = parseInt(r.width, 10) || 0, n.height = parseInt(r.height, 10) || 0, n.backgroundColor = n.styles.backgroundColor;
      try {
        if (r.contentWindow && r.contentWindow.document && r.contentWindow.document.documentElement) {
          n.tree = ix(t, r.contentWindow.document.documentElement);
          var a = r.contentWindow.document.documentElement ? li(t, getComputedStyle(r.contentWindow.document.documentElement).backgroundColor) : lr.TRANSPARENT, i = r.contentWindow.document.body ? li(t, getComputedStyle(r.contentWindow.document.body).backgroundColor) : lr.TRANSPARENT;
          n.backgroundColor = Hr(a) ? Hr(i) ? n.styles.backgroundColor : i : a;
        }
      } catch {
      }
      return n;
    }
    return A;
  }(Yt)
), fk = ["OL", "UL", "MENU"], to = function(e, A, t, r) {
  for (var n = A.firstChild, a = void 0; n; n = a)
    if (a = n.nextSibling, sx(n) && n.data.trim().length > 0)
      t.textNodes.push(new rk(e, n, t.styles));
    else if (aa(n))
      if (cx(n) && n.assignedNodes)
        n.assignedNodes().forEach(function(s) {
          return to(e, s, t, r);
        });
      else {
        var i = ax(e, n);
        i.styles.isVisible() && (dk(n, i, r) ? i.flags |= 4 : hk(i.styles) && (i.flags |= 2), fk.indexOf(n.tagName) !== -1 && (i.flags |= 8), t.elements.push(i), n.slot, n.shadowRoot ? to(e, n.shadowRoot, i, r) : !Io(n) && !ox(n) && !Do(n) && to(e, n, i, r));
      }
}, ax = function(e, A) {
  return Vf(A) ? new Jy(e, A) : ux(A) ? new Zy(e, A) : ox(A) ? new ex(e, A) : pk(A) ? new Ax(e, A) : gk(A) ? new jf(e, A) : Bk(A) ? new Hd(e, A) : Do(A) ? new tx(e, A) : Io(A) ? new rx(e, A) : lx(A) ? new nx(e, A) : new Yt(e, A);
}, ix = function(e, A) {
  var t = ax(e, A);
  return t.flags |= 4, to(e, A, t, t), t;
}, dk = function(e, A, t) {
  return A.styles.isPositionedWithZIndex() || A.styles.opacity < 1 || A.styles.isTransformed() || Ld(e) && t.styles.isTransparent();
}, hk = function(e) {
  return e.isPositioned() || e.isFloating();
}, sx = function(e) {
  return e.nodeType === Node.TEXT_NODE;
}, aa = function(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}, Gf = function(e) {
  return aa(e) && typeof e.style < "u" && !ro(e);
}, ro = function(e) {
  return typeof e.className == "object";
}, pk = function(e) {
  return e.tagName === "LI";
}, gk = function(e) {
  return e.tagName === "OL";
}, Bk = function(e) {
  return e.tagName === "INPUT";
}, vk = function(e) {
  return e.tagName === "HTML";
}, ox = function(e) {
  return e.tagName === "svg";
}, Ld = function(e) {
  return e.tagName === "BODY";
}, ux = function(e) {
  return e.tagName === "CANVAS";
}, tB = function(e) {
  return e.tagName === "VIDEO";
}, Vf = function(e) {
  return e.tagName === "IMG";
}, lx = function(e) {
  return e.tagName === "IFRAME";
}, rB = function(e) {
  return e.tagName === "STYLE";
}, mk = function(e) {
  return e.tagName === "SCRIPT";
}, Io = function(e) {
  return e.tagName === "TEXTAREA";
}, Do = function(e) {
  return e.tagName === "SELECT";
}, cx = function(e) {
  return e.tagName === "SLOT";
}, nB = function(e) {
  return e.tagName.indexOf("-") > 0;
}, wk = (
  /** @class */
  function() {
    function e() {
      this.counters = {};
    }
    return e.prototype.getCounterValue = function(A) {
      var t = this.counters[A];
      return t && t.length ? t[t.length - 1] : 1;
    }, e.prototype.getCounterValues = function(A) {
      var t = this.counters[A];
      return t || [];
    }, e.prototype.pop = function(A) {
      var t = this;
      A.forEach(function(r) {
        return t.counters[r].pop();
      });
    }, e.prototype.parse = function(A) {
      var t = this, r = A.counterIncrement, n = A.counterReset, a = !0;
      r !== null && r.forEach(function(s) {
        var o = t.counters[s.counter];
        o && s.increment !== 0 && (a = !1, o.length || o.push(1), o[Math.max(0, o.length - 1)] += s.increment);
      });
      var i = [];
      return a && n.forEach(function(s) {
        var o = t.counters[s.counter];
        i.push(s.counter), o || (o = t.counters[s.counter] = []), o.push(s.reset);
      }), i;
    }, e;
  }()
), aB = {
  integers: [1e3, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
  values: ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"]
}, iB = {
  integers: [
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "Ք",
    "Փ",
    "Ւ",
    "Ց",
    "Ր",
    "Տ",
    "Վ",
    "Ս",
    "Ռ",
    "Ջ",
    "Պ",
    "Չ",
    "Ո",
    "Շ",
    "Ն",
    "Յ",
    "Մ",
    "Ճ",
    "Ղ",
    "Ձ",
    "Հ",
    "Կ",
    "Ծ",
    "Խ",
    "Լ",
    "Ի",
    "Ժ",
    "Թ",
    "Ը",
    "Է",
    "Զ",
    "Ե",
    "Դ",
    "Գ",
    "Բ",
    "Ա"
  ]
}, yk = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    19,
    18,
    17,
    16,
    15,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "י׳",
    "ט׳",
    "ח׳",
    "ז׳",
    "ו׳",
    "ה׳",
    "ד׳",
    "ג׳",
    "ב׳",
    "א׳",
    "ת",
    "ש",
    "ר",
    "ק",
    "צ",
    "פ",
    "ע",
    "ס",
    "נ",
    "מ",
    "ל",
    "כ",
    "יט",
    "יח",
    "יז",
    "טז",
    "טו",
    "י",
    "ט",
    "ח",
    "ז",
    "ו",
    "ה",
    "ד",
    "ג",
    "ב",
    "א"
  ]
}, xk = {
  integers: [
    1e4,
    9e3,
    8e3,
    7e3,
    6e3,
    5e3,
    4e3,
    3e3,
    2e3,
    1e3,
    900,
    800,
    700,
    600,
    500,
    400,
    300,
    200,
    100,
    90,
    80,
    70,
    60,
    50,
    40,
    30,
    20,
    10,
    9,
    8,
    7,
    6,
    5,
    4,
    3,
    2,
    1
  ],
  values: [
    "ჵ",
    "ჰ",
    "ჯ",
    "ჴ",
    "ხ",
    "ჭ",
    "წ",
    "ძ",
    "ც",
    "ჩ",
    "შ",
    "ყ",
    "ღ",
    "ქ",
    "ფ",
    "ჳ",
    "ტ",
    "ს",
    "რ",
    "ჟ",
    "პ",
    "ო",
    "ჲ",
    "ნ",
    "მ",
    "ლ",
    "კ",
    "ი",
    "თ",
    "ჱ",
    "ზ",
    "ვ",
    "ე",
    "დ",
    "გ",
    "ბ",
    "ა"
  ]
}, jn = function(e, A, t, r, n, a) {
  return e < A || e > t ? bi(e, n, a.length > 0) : r.integers.reduce(function(i, s, o) {
    for (; e >= s; )
      e -= s, i += r.values[o];
    return i;
  }, "") + a;
}, fx = function(e, A, t, r) {
  var n = "";
  do
    t || e--, n = r(e) + n, e /= A;
  while (e * A >= A);
  return n;
}, oA = function(e, A, t, r, n) {
  var a = t - A + 1;
  return (e < 0 ? "-" : "") + (fx(Math.abs(e), a, r, function(i) {
    return uA(Math.floor(i % a) + A);
  }) + n);
}, Jr = function(e, A, t) {
  t === void 0 && (t = ". ");
  var r = A.length;
  return fx(Math.abs(e), r, !1, function(n) {
    return A[Math.floor(n % r)];
  }) + t;
}, Zn = 1, Er = 2, Fr = 4, Ai = 8, Zt = function(e, A, t, r, n, a) {
  if (e < -9999 || e > 9999)
    return bi(e, 4, n.length > 0);
  var i = Math.abs(e), s = n;
  if (i === 0)
    return A[0] + s;
  for (var o = 0; i > 0 && o <= 4; o++) {
    var u = i % 10;
    u === 0 && BA(a, Zn) && s !== "" ? s = A[u] + s : u > 1 || u === 1 && o === 0 || u === 1 && o === 1 && BA(a, Er) || u === 1 && o === 1 && BA(a, Fr) && e > 100 || u === 1 && o > 1 && BA(a, Ai) ? s = A[u] + (o > 0 ? t[o - 1] : "") + s : u === 1 && o > 0 && (s = t[o - 1] + s), i = Math.floor(i / 10);
  }
  return (e < 0 ? r : "") + s;
}, sB = "十百千萬", oB = "拾佰仟萬", uB = "マイナス", Ic = "마이너스", bi = function(e, A, t) {
  var r = t ? ". " : "", n = t ? "、" : "", a = t ? ", " : "", i = t ? " " : "";
  switch (A) {
    case 0:
      return "•" + i;
    case 1:
      return "◦" + i;
    case 2:
      return "◾" + i;
    case 5:
      var s = oA(e, 48, 57, !0, r);
      return s.length < 4 ? "0" + s : s;
    case 4:
      return Jr(e, "〇一二三四五六七八九", n);
    case 6:
      return jn(e, 1, 3999, aB, 3, r).toLowerCase();
    case 7:
      return jn(e, 1, 3999, aB, 3, r);
    case 8:
      return oA(e, 945, 969, !1, r);
    case 9:
      return oA(e, 97, 122, !1, r);
    case 10:
      return oA(e, 65, 90, !1, r);
    case 11:
      return oA(e, 1632, 1641, !0, r);
    case 12:
    case 49:
      return jn(e, 1, 9999, iB, 3, r);
    case 35:
      return jn(e, 1, 9999, iB, 3, r).toLowerCase();
    case 13:
      return oA(e, 2534, 2543, !0, r);
    case 14:
    case 30:
      return oA(e, 6112, 6121, !0, r);
    case 15:
      return Jr(e, "子丑寅卯辰巳午未申酉戌亥", n);
    case 16:
      return Jr(e, "甲乙丙丁戊己庚辛壬癸", n);
    case 17:
    case 48:
      return Zt(e, "零一二三四五六七八九", sB, "負", n, Er | Fr | Ai);
    case 47:
      return Zt(e, "零壹貳參肆伍陸柒捌玖", oB, "負", n, Zn | Er | Fr | Ai);
    case 42:
      return Zt(e, "零一二三四五六七八九", sB, "负", n, Er | Fr | Ai);
    case 41:
      return Zt(e, "零壹贰叁肆伍陆柒捌玖", oB, "负", n, Zn | Er | Fr | Ai);
    case 26:
      return Zt(e, "〇一二三四五六七八九", "十百千万", uB, n, 0);
    case 25:
      return Zt(e, "零壱弐参四伍六七八九", "拾百千万", uB, n, Zn | Er | Fr);
    case 31:
      return Zt(e, "영일이삼사오육칠팔구", "십백천만", Ic, a, Zn | Er | Fr);
    case 33:
      return Zt(e, "零一二三四五六七八九", "十百千萬", Ic, a, 0);
    case 32:
      return Zt(e, "零壹貳參四五六七八九", "拾百千", Ic, a, Zn | Er | Fr);
    case 18:
      return oA(e, 2406, 2415, !0, r);
    case 20:
      return jn(e, 1, 19999, xk, 3, r);
    case 21:
      return oA(e, 2790, 2799, !0, r);
    case 22:
      return oA(e, 2662, 2671, !0, r);
    case 22:
      return jn(e, 1, 10999, yk, 3, r);
    case 23:
      return Jr(e, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
    case 24:
      return Jr(e, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
    case 27:
      return oA(e, 3302, 3311, !0, r);
    case 28:
      return Jr(e, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", n);
    case 29:
      return Jr(e, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", n);
    case 34:
      return oA(e, 3792, 3801, !0, r);
    case 37:
      return oA(e, 6160, 6169, !0, r);
    case 38:
      return oA(e, 4160, 4169, !0, r);
    case 39:
      return oA(e, 2918, 2927, !0, r);
    case 40:
      return oA(e, 1776, 1785, !0, r);
    case 43:
      return oA(e, 3046, 3055, !0, r);
    case 44:
      return oA(e, 3174, 3183, !0, r);
    case 45:
      return oA(e, 3664, 3673, !0, r);
    case 46:
      return oA(e, 3872, 3881, !0, r);
    case 3:
    default:
      return oA(e, 48, 57, !0, r);
  }
}, dx = "data-html2canvas-ignore", lB = (
  /** @class */
  function() {
    function e(A, t, r) {
      if (this.context = A, this.options = r, this.scrolledElements = [], this.referenceElement = t, this.counters = new wk(), this.quoteDepth = 0, !t.ownerDocument)
        throw new Error("Cloned element does not have an owner document");
      this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
    }
    return e.prototype.toIFrame = function(A, t) {
      var r = this, n = Ck(A, t);
      if (!n.contentWindow)
        return Promise.reject("Unable to find iframe window");
      var a = A.defaultView.pageXOffset, i = A.defaultView.pageYOffset, s = n.contentWindow, o = s.document, u = bk(n).then(function() {
        return LA(r, void 0, void 0, function() {
          var l, c;
          return SA(this, function(f) {
            switch (f.label) {
              case 0:
                return this.scrolledElements.forEach(Qk), s && (s.scrollTo(t.left, t.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (s.scrollY !== t.top || s.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(s.scrollX - t.left, s.scrollY - t.top, 0, 0))), l = this.options.onclone, c = this.clonedReferenceElement, typeof c > "u" ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : o.fonts && o.fonts.ready ? [4, o.fonts.ready] : [3, 2];
              case 1:
                f.sent(), f.label = 2;
              case 2:
                return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, Fk(o)] : [3, 4];
              case 3:
                f.sent(), f.label = 4;
              case 4:
                return typeof l == "function" ? [2, Promise.resolve().then(function() {
                  return l(o, c);
                }).then(function() {
                  return n;
                })] : [2, n];
            }
          });
        });
      });
      return o.open(), o.write(Uk(document.doctype) + "<html></html>"), _k(this.referenceElement.ownerDocument, a, i), o.replaceChild(o.adoptNode(this.documentElement), o.documentElement), o.close(), u;
    }, e.prototype.createElementClone = function(A) {
      if (Kf(
        A,
        2
        /* CLONE */
      ))
        debugger;
      if (ux(A))
        return this.createCanvasClone(A);
      if (tB(A))
        return this.createVideoClone(A);
      if (rB(A))
        return this.createStyleClone(A);
      var t = A.cloneNode(!1);
      return Vf(t) && (Vf(A) && A.currentSrc && A.currentSrc !== A.src && (t.src = A.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), nB(t) ? this.createCustomElementClone(t) : t;
    }, e.prototype.createCustomElementClone = function(A) {
      var t = document.createElement("html2canvascustomelement");
      return Dc(A.style, t), t;
    }, e.prototype.createStyleClone = function(A) {
      try {
        var t = A.sheet;
        if (t && t.cssRules) {
          var r = [].slice.call(t.cssRules, 0).reduce(function(a, i) {
            return i && typeof i.cssText == "string" ? a + i.cssText : a;
          }, ""), n = A.cloneNode(!1);
          return n.textContent = r, n;
        }
      } catch (a) {
        if (this.context.logger.error("Unable to access cssRules property", a), a.name !== "SecurityError")
          throw a;
      }
      return A.cloneNode(!1);
    }, e.prototype.createCanvasClone = function(A) {
      var t;
      if (this.options.inlineImages && A.ownerDocument) {
        var r = A.ownerDocument.createElement("img");
        try {
          return r.src = A.toDataURL(), r;
        } catch {
          this.context.logger.info("Unable to inline canvas contents, canvas is tainted", A);
        }
      }
      var n = A.cloneNode(!1);
      try {
        n.width = A.width, n.height = A.height;
        var a = A.getContext("2d"), i = n.getContext("2d");
        if (i)
          if (!this.options.allowTaint && a)
            i.putImageData(a.getImageData(0, 0, A.width, A.height), 0, 0);
          else {
            var s = (t = A.getContext("webgl2")) !== null && t !== void 0 ? t : A.getContext("webgl");
            if (s) {
              var o = s.getContextAttributes();
              (o == null ? void 0 : o.preserveDrawingBuffer) === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", A);
            }
            i.drawImage(A, 0, 0);
          }
        return n;
      } catch {
        this.context.logger.info("Unable to clone canvas as it is tainted", A);
      }
      return n;
    }, e.prototype.createVideoClone = function(A) {
      var t = A.ownerDocument.createElement("canvas");
      t.width = A.offsetWidth, t.height = A.offsetHeight;
      var r = t.getContext("2d");
      try {
        return r && (r.drawImage(A, 0, 0, t.width, t.height), this.options.allowTaint || r.getImageData(0, 0, t.width, t.height)), t;
      } catch {
        this.context.logger.info("Unable to clone video as it is tainted", A);
      }
      var n = A.ownerDocument.createElement("canvas");
      return n.width = A.offsetWidth, n.height = A.offsetHeight, n;
    }, e.prototype.appendChildNode = function(A, t, r) {
      (!aa(t) || !mk(t) && !t.hasAttribute(dx) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(t))) && (!this.options.copyStyles || !aa(t) || !rB(t)) && A.appendChild(this.cloneNode(t, r));
    }, e.prototype.cloneChildNodes = function(A, t, r) {
      for (var n = this, a = A.shadowRoot ? A.shadowRoot.firstChild : A.firstChild; a; a = a.nextSibling)
        if (aa(a) && cx(a) && typeof a.assignedNodes == "function") {
          var i = a.assignedNodes();
          i.length && i.forEach(function(s) {
            return n.appendChildNode(t, s, r);
          });
        } else
          this.appendChildNode(t, a, r);
    }, e.prototype.cloneNode = function(A, t) {
      if (sx(A))
        return document.createTextNode(A.data);
      if (!A.ownerDocument)
        return A.cloneNode(!1);
      var r = A.ownerDocument.defaultView;
      if (r && aa(A) && (Gf(A) || ro(A))) {
        var n = this.createElementClone(A);
        n.style.transitionProperty = "none";
        var a = r.getComputedStyle(A), i = r.getComputedStyle(A, ":before"), s = r.getComputedStyle(A, ":after");
        this.referenceElement === A && Gf(n) && (this.clonedReferenceElement = n), Ld(n) && Tk(n);
        var o = this.counters.parse(new Pg(this.context, a)), u = this.resolvePseudoContent(A, n, i, di.BEFORE);
        nB(A) && (t = !0), tB(A) || this.cloneChildNodes(A, n, t), u && n.insertBefore(u, n.firstChild);
        var l = this.resolvePseudoContent(A, n, s, di.AFTER);
        return l && n.appendChild(l), this.counters.pop(o), (a && (this.options.copyStyles || ro(A)) && !lx(A) || t) && Dc(a, n), (A.scrollTop !== 0 || A.scrollLeft !== 0) && this.scrolledElements.push([n, A.scrollLeft, A.scrollTop]), (Io(A) || Do(A)) && (Io(n) || Do(n)) && (n.value = A.value), n;
      }
      return A.cloneNode(!1);
    }, e.prototype.resolvePseudoContent = function(A, t, r, n) {
      var a = this;
      if (r) {
        var i = r.content, s = t.ownerDocument;
        if (!(!s || !i || i === "none" || i === "-moz-alt-content" || r.display === "none")) {
          this.counters.parse(new Pg(this.context, r));
          var o = new p6(this.context, r), u = s.createElement("html2canvaspseudoelement");
          Dc(r, u), o.content.forEach(function(c) {
            if (c.type === 0)
              u.appendChild(s.createTextNode(c.value));
            else if (c.type === 22) {
              var f = s.createElement("img");
              f.src = c.value, f.style.opacity = "1", u.appendChild(f);
            } else if (c.type === 18) {
              if (c.name === "attr") {
                var d = c.values.filter(Ke);
                d.length && u.appendChild(s.createTextNode(A.getAttribute(d[0].value) || ""));
              } else if (c.name === "counter") {
                var h = c.values.filter(pa), p = h[0], v = h[1];
                if (p && Ke(p)) {
                  var y = a.counters.getCounterValue(p.value), g = v && Ke(v) ? Pf.parse(a.context, v.value) : 3;
                  u.appendChild(s.createTextNode(bi(y, g, !1)));
                }
              } else if (c.name === "counters") {
                var B = c.values.filter(pa), p = B[0], w = B[1], v = B[2];
                if (p && Ke(p)) {
                  var m = a.counters.getCounterValues(p.value), x = v && Ke(v) ? Pf.parse(a.context, v.value) : 3, C = w && w.type === 0 ? w.value : "", E = m.map(function(b) {
                    return bi(b, x, !1);
                  }).join(C);
                  u.appendChild(s.createTextNode(E));
                }
              }
            } else if (c.type === 20)
              switch (c.value) {
                case "open-quote":
                  u.appendChild(s.createTextNode(kg(o.quotes, a.quoteDepth++, !0)));
                  break;
                case "close-quote":
                  u.appendChild(s.createTextNode(kg(o.quotes, --a.quoteDepth, !1)));
                  break;
                default:
                  u.appendChild(s.createTextNode(c.value));
              }
          }), u.className = Wf + " " + Yf;
          var l = n === di.BEFORE ? " " + Wf : " " + Yf;
          return ro(t) ? t.className.baseValue += l : t.className += l, u;
        }
      }
    }, e.destroy = function(A) {
      return A.parentNode ? (A.parentNode.removeChild(A), !0) : !1;
    }, e;
  }()
), di;
(function(e) {
  e[e.BEFORE = 0] = "BEFORE", e[e.AFTER = 1] = "AFTER";
})(di || (di = {}));
var Ck = function(e, A) {
  var t = e.createElement("iframe");
  return t.className = "html2canvas-container", t.style.visibility = "hidden", t.style.position = "fixed", t.style.left = "-10000px", t.style.top = "0px", t.style.border = "0", t.width = A.width.toString(), t.height = A.height.toString(), t.scrolling = "no", t.setAttribute(dx, "true"), e.body.appendChild(t), t;
}, Ek = function(e) {
  return new Promise(function(A) {
    if (e.complete) {
      A();
      return;
    }
    if (!e.src) {
      A();
      return;
    }
    e.onload = A, e.onerror = A;
  });
}, Fk = function(e) {
  return Promise.all([].slice.call(e.images, 0).map(Ek));
}, bk = function(e) {
  return new Promise(function(A, t) {
    var r = e.contentWindow;
    if (!r)
      return t("No window assigned for iframe");
    var n = r.document;
    r.onload = e.onload = function() {
      r.onload = e.onload = null;
      var a = setInterval(function() {
        n.body.childNodes.length > 0 && n.readyState === "complete" && (clearInterval(a), A(e));
      }, 50);
    };
  });
}, Sk = [
  "all",
  "d",
  "content"
  // Safari shows pseudoelements if content is set
], Dc = function(e, A) {
  for (var t = e.length - 1; t >= 0; t--) {
    var r = e.item(t);
    Sk.indexOf(r) === -1 && A.style.setProperty(r, e.getPropertyValue(r));
  }
  return A;
}, Uk = function(e) {
  var A = "";
  return e && (A += "<!DOCTYPE ", e.name && (A += e.name), e.internalSubset && (A += e.internalSubset), e.publicId && (A += '"' + e.publicId + '"'), e.systemId && (A += '"' + e.systemId + '"'), A += ">"), A;
}, _k = function(e, A, t) {
  e && e.defaultView && (A !== e.defaultView.pageXOffset || t !== e.defaultView.pageYOffset) && e.defaultView.scrollTo(A, t);
}, Qk = function(e) {
  var A = e[0], t = e[1], r = e[2];
  A.scrollLeft = t, A.scrollTop = r;
}, Ik = ":before", Dk = ":after", Wf = "___html2canvas___pseudoelement_before", Yf = "___html2canvas___pseudoelement_after", cB = `{
    content: "" !important;
    display: none !important;
}`, Tk = function(e) {
  Ok(e, "." + Wf + Ik + cB + `
         .` + Yf + Dk + cB);
}, Ok = function(e, A) {
  var t = e.ownerDocument;
  if (t) {
    var r = t.createElement("style");
    r.textContent = A, e.appendChild(r);
  }
}, hx = (
  /** @class */
  function() {
    function e() {
    }
    return e.getOrigin = function(A) {
      var t = e._link;
      return t ? (t.href = A, t.href = t.href, t.protocol + t.hostname + t.port) : "about:blank";
    }, e.isSameOrigin = function(A) {
      return e.getOrigin(A) === e._origin;
    }, e.setContext = function(A) {
      e._link = A.document.createElement("a"), e._origin = e.getOrigin(A.location.href);
    }, e._origin = "about:blank", e;
  }()
), Hk = (
  /** @class */
  function() {
    function e(A, t) {
      this.context = A, this._options = t, this._cache = {};
    }
    return e.prototype.addImage = function(A) {
      var t = Promise.resolve();
      return this.has(A) || (Oc(A) || Nk(A)) && (this._cache[A] = this.loadImage(A)).catch(function() {
      }), t;
    }, e.prototype.match = function(A) {
      return this._cache[A];
    }, e.prototype.loadImage = function(A) {
      return LA(this, void 0, void 0, function() {
        var t, r, n, a, i = this;
        return SA(this, function(s) {
          switch (s.label) {
            case 0:
              return t = hx.isSameOrigin(A), r = !Tc(A) && this._options.useCORS === !0 && CA.SUPPORT_CORS_IMAGES && !t, n = !Tc(A) && !t && !Oc(A) && typeof this._options.proxy == "string" && CA.SUPPORT_CORS_XHR && !r, !t && this._options.allowTaint === !1 && !Tc(A) && !Oc(A) && !n && !r ? [
                2
                /*return*/
              ] : (a = A, n ? [4, this.proxy(a)] : [3, 2]);
            case 1:
              a = s.sent(), s.label = 2;
            case 2:
              return this.context.logger.debug("Added image " + A.substring(0, 256)), [4, new Promise(function(o, u) {
                var l = new Image();
                l.onload = function() {
                  return o(l);
                }, l.onerror = u, (kk(a) || r) && (l.crossOrigin = "anonymous"), l.src = a, l.complete === !0 && setTimeout(function() {
                  return o(l);
                }, 500), i._options.imageTimeout > 0 && setTimeout(function() {
                  return u("Timed out (" + i._options.imageTimeout + "ms) loading image");
                }, i._options.imageTimeout);
              })];
            case 3:
              return [2, s.sent()];
          }
        });
      });
    }, e.prototype.has = function(A) {
      return typeof this._cache[A] < "u";
    }, e.prototype.keys = function() {
      return Promise.resolve(Object.keys(this._cache));
    }, e.prototype.proxy = function(A) {
      var t = this, r = this._options.proxy;
      if (!r)
        throw new Error("No proxy defined");
      var n = A.substring(0, 256);
      return new Promise(function(a, i) {
        var s = CA.SUPPORT_RESPONSE_TYPE ? "blob" : "text", o = new XMLHttpRequest();
        o.onload = function() {
          if (o.status === 200)
            if (s === "text")
              a(o.response);
            else {
              var c = new FileReader();
              c.addEventListener("load", function() {
                return a(c.result);
              }, !1), c.addEventListener("error", function(f) {
                return i(f);
              }, !1), c.readAsDataURL(o.response);
            }
          else
            i("Failed to proxy resource " + n + " with status code " + o.status);
        }, o.onerror = i;
        var u = r.indexOf("?") > -1 ? "&" : "?";
        if (o.open("GET", "" + r + u + "url=" + encodeURIComponent(A) + "&responseType=" + s), s !== "text" && o instanceof XMLHttpRequest && (o.responseType = s), t._options.imageTimeout) {
          var l = t._options.imageTimeout;
          o.timeout = l, o.ontimeout = function() {
            return i("Timed out (" + l + "ms) proxying " + n);
          };
        }
        o.send();
      });
    }, e;
  }()
), Lk = /^data:image\/svg\+xml/i, Mk = /^data:image\/.*;base64,/i, Rk = /^data:image\/.*/i, Nk = function(e) {
  return CA.SUPPORT_SVG_DRAWING || !Pk(e);
}, Tc = function(e) {
  return Rk.test(e);
}, kk = function(e) {
  return Mk.test(e);
}, Oc = function(e) {
  return e.substr(0, 4) === "blob";
}, Pk = function(e) {
  return e.substr(-3).toLowerCase() === "svg" || Lk.test(e);
}, Ae = (
  /** @class */
  function() {
    function e(A, t) {
      this.type = 0, this.x = A, this.y = t;
    }
    return e.prototype.add = function(A, t) {
      return new e(this.x + A, this.y + t);
    }, e;
  }()
), Gn = function(e, A, t) {
  return new Ae(e.x + (A.x - e.x) * t, e.y + (A.y - e.y) * t);
}, Qs = (
  /** @class */
  function() {
    function e(A, t, r, n) {
      this.type = 1, this.start = A, this.startControl = t, this.endControl = r, this.end = n;
    }
    return e.prototype.subdivide = function(A, t) {
      var r = Gn(this.start, this.startControl, A), n = Gn(this.startControl, this.endControl, A), a = Gn(this.endControl, this.end, A), i = Gn(r, n, A), s = Gn(n, a, A), o = Gn(i, s, A);
      return t ? new e(this.start, r, i, o) : new e(o, s, a, this.end);
    }, e.prototype.add = function(A, t) {
      return new e(this.start.add(A, t), this.startControl.add(A, t), this.endControl.add(A, t), this.end.add(A, t));
    }, e.prototype.reverse = function() {
      return new e(this.end, this.endControl, this.startControl, this.start);
    }, e;
  }()
), rt = function(e) {
  return e.type === 1;
}, Kk = (
  /** @class */
  function() {
    function e(A) {
      var t = A.styles, r = A.bounds, n = Za(t.borderTopLeftRadius, r.width, r.height), a = n[0], i = n[1], s = Za(t.borderTopRightRadius, r.width, r.height), o = s[0], u = s[1], l = Za(t.borderBottomRightRadius, r.width, r.height), c = l[0], f = l[1], d = Za(t.borderBottomLeftRadius, r.width, r.height), h = d[0], p = d[1], v = [];
      v.push((a + o) / r.width), v.push((h + c) / r.width), v.push((i + p) / r.height), v.push((u + f) / r.height);
      var y = Math.max.apply(Math, v);
      y > 1 && (a /= y, i /= y, o /= y, u /= y, c /= y, f /= y, h /= y, p /= y);
      var g = r.width - o, B = r.height - f, w = r.width - c, m = r.height - p, x = t.borderTopWidth, C = t.borderRightWidth, E = t.borderBottomWidth, T = t.borderLeftWidth, S = Ye(t.paddingTop, A.bounds.width), b = Ye(t.paddingRight, A.bounds.width), N = Ye(t.paddingBottom, A.bounds.width), O = Ye(t.paddingLeft, A.bounds.width);
      this.topLeftBorderDoubleOuterBox = a > 0 || i > 0 ? AA(r.left + T / 3, r.top + x / 3, a - T / 3, i - x / 3, Me.TOP_LEFT) : new Ae(r.left + T / 3, r.top + x / 3), this.topRightBorderDoubleOuterBox = a > 0 || i > 0 ? AA(r.left + g, r.top + x / 3, o - C / 3, u - x / 3, Me.TOP_RIGHT) : new Ae(r.left + r.width - C / 3, r.top + x / 3), this.bottomRightBorderDoubleOuterBox = c > 0 || f > 0 ? AA(r.left + w, r.top + B, c - C / 3, f - E / 3, Me.BOTTOM_RIGHT) : new Ae(r.left + r.width - C / 3, r.top + r.height - E / 3), this.bottomLeftBorderDoubleOuterBox = h > 0 || p > 0 ? AA(r.left + T / 3, r.top + m, h - T / 3, p - E / 3, Me.BOTTOM_LEFT) : new Ae(r.left + T / 3, r.top + r.height - E / 3), this.topLeftBorderDoubleInnerBox = a > 0 || i > 0 ? AA(r.left + T * 2 / 3, r.top + x * 2 / 3, a - T * 2 / 3, i - x * 2 / 3, Me.TOP_LEFT) : new Ae(r.left + T * 2 / 3, r.top + x * 2 / 3), this.topRightBorderDoubleInnerBox = a > 0 || i > 0 ? AA(r.left + g, r.top + x * 2 / 3, o - C * 2 / 3, u - x * 2 / 3, Me.TOP_RIGHT) : new Ae(r.left + r.width - C * 2 / 3, r.top + x * 2 / 3), this.bottomRightBorderDoubleInnerBox = c > 0 || f > 0 ? AA(r.left + w, r.top + B, c - C * 2 / 3, f - E * 2 / 3, Me.BOTTOM_RIGHT) : new Ae(r.left + r.width - C * 2 / 3, r.top + r.height - E * 2 / 3), this.bottomLeftBorderDoubleInnerBox = h > 0 || p > 0 ? AA(r.left + T * 2 / 3, r.top + m, h - T * 2 / 3, p - E * 2 / 3, Me.BOTTOM_LEFT) : new Ae(r.left + T * 2 / 3, r.top + r.height - E * 2 / 3), this.topLeftBorderStroke = a > 0 || i > 0 ? AA(r.left + T / 2, r.top + x / 2, a - T / 2, i - x / 2, Me.TOP_LEFT) : new Ae(r.left + T / 2, r.top + x / 2), this.topRightBorderStroke = a > 0 || i > 0 ? AA(r.left + g, r.top + x / 2, o - C / 2, u - x / 2, Me.TOP_RIGHT) : new Ae(r.left + r.width - C / 2, r.top + x / 2), this.bottomRightBorderStroke = c > 0 || f > 0 ? AA(r.left + w, r.top + B, c - C / 2, f - E / 2, Me.BOTTOM_RIGHT) : new Ae(r.left + r.width - C / 2, r.top + r.height - E / 2), this.bottomLeftBorderStroke = h > 0 || p > 0 ? AA(r.left + T / 2, r.top + m, h - T / 2, p - E / 2, Me.BOTTOM_LEFT) : new Ae(r.left + T / 2, r.top + r.height - E / 2), this.topLeftBorderBox = a > 0 || i > 0 ? AA(r.left, r.top, a, i, Me.TOP_LEFT) : new Ae(r.left, r.top), this.topRightBorderBox = o > 0 || u > 0 ? AA(r.left + g, r.top, o, u, Me.TOP_RIGHT) : new Ae(r.left + r.width, r.top), this.bottomRightBorderBox = c > 0 || f > 0 ? AA(r.left + w, r.top + B, c, f, Me.BOTTOM_RIGHT) : new Ae(r.left + r.width, r.top + r.height), this.bottomLeftBorderBox = h > 0 || p > 0 ? AA(r.left, r.top + m, h, p, Me.BOTTOM_LEFT) : new Ae(r.left, r.top + r.height), this.topLeftPaddingBox = a > 0 || i > 0 ? AA(r.left + T, r.top + x, Math.max(0, a - T), Math.max(0, i - x), Me.TOP_LEFT) : new Ae(r.left + T, r.top + x), this.topRightPaddingBox = o > 0 || u > 0 ? AA(r.left + Math.min(g, r.width - C), r.top + x, g > r.width + C ? 0 : Math.max(0, o - C), Math.max(0, u - x), Me.TOP_RIGHT) : new Ae(r.left + r.width - C, r.top + x), this.bottomRightPaddingBox = c > 0 || f > 0 ? AA(r.left + Math.min(w, r.width - T), r.top + Math.min(B, r.height - E), Math.max(0, c - C), Math.max(0, f - E), Me.BOTTOM_RIGHT) : new Ae(r.left + r.width - C, r.top + r.height - E), this.bottomLeftPaddingBox = h > 0 || p > 0 ? AA(r.left + T, r.top + Math.min(m, r.height - E), Math.max(0, h - T), Math.max(0, p - E), Me.BOTTOM_LEFT) : new Ae(r.left + T, r.top + r.height - E), this.topLeftContentBox = a > 0 || i > 0 ? AA(r.left + T + O, r.top + x + S, Math.max(0, a - (T + O)), Math.max(0, i - (x + S)), Me.TOP_LEFT) : new Ae(r.left + T + O, r.top + x + S), this.topRightContentBox = o > 0 || u > 0 ? AA(r.left + Math.min(g, r.width + T + O), r.top + x + S, g > r.width + T + O ? 0 : o - T + O, u - (x + S), Me.TOP_RIGHT) : new Ae(r.left + r.width - (C + b), r.top + x + S), this.bottomRightContentBox = c > 0 || f > 0 ? AA(r.left + Math.min(w, r.width - (T + O)), r.top + Math.min(B, r.height + x + S), Math.max(0, c - (C + b)), f - (E + N), Me.BOTTOM_RIGHT) : new Ae(r.left + r.width - (C + b), r.top + r.height - (E + N)), this.bottomLeftContentBox = h > 0 || p > 0 ? AA(r.left + T + O, r.top + m, Math.max(0, h - (T + O)), p - (E + N), Me.BOTTOM_LEFT) : new Ae(r.left + T + O, r.top + r.height - (E + N));
    }
    return e;
  }()
), Me;
(function(e) {
  e[e.TOP_LEFT = 0] = "TOP_LEFT", e[e.TOP_RIGHT = 1] = "TOP_RIGHT", e[e.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", e[e.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
})(Me || (Me = {}));
var AA = function(e, A, t, r, n) {
  var a = 4 * ((Math.sqrt(2) - 1) / 3), i = t * a, s = r * a, o = e + t, u = A + r;
  switch (n) {
    case Me.TOP_LEFT:
      return new Qs(new Ae(e, u), new Ae(e, u - s), new Ae(o - i, A), new Ae(o, A));
    case Me.TOP_RIGHT:
      return new Qs(new Ae(e, A), new Ae(e + i, A), new Ae(o, u - s), new Ae(o, u));
    case Me.BOTTOM_RIGHT:
      return new Qs(new Ae(o, A), new Ae(o, A + s), new Ae(e + i, u), new Ae(e, u));
    case Me.BOTTOM_LEFT:
    default:
      return new Qs(new Ae(o, u), new Ae(o - i, u), new Ae(e, A + s), new Ae(e, A));
  }
}, To = function(e) {
  return [e.topLeftBorderBox, e.topRightBorderBox, e.bottomRightBorderBox, e.bottomLeftBorderBox];
}, $k = function(e) {
  return [
    e.topLeftContentBox,
    e.topRightContentBox,
    e.bottomRightContentBox,
    e.bottomLeftContentBox
  ];
}, Oo = function(e) {
  return [
    e.topLeftPaddingBox,
    e.topRightPaddingBox,
    e.bottomRightPaddingBox,
    e.bottomLeftPaddingBox
  ];
}, jk = (
  /** @class */
  function() {
    function e(A, t, r) {
      this.offsetX = A, this.offsetY = t, this.matrix = r, this.type = 0, this.target = 6;
    }
    return e;
  }()
), Is = (
  /** @class */
  function() {
    function e(A, t) {
      this.path = A, this.target = t, this.type = 1;
    }
    return e;
  }()
), Gk = (
  /** @class */
  function() {
    function e(A) {
      this.opacity = A, this.type = 2, this.target = 6;
    }
    return e;
  }()
), Vk = function(e) {
  return e.type === 0;
}, px = function(e) {
  return e.type === 1;
}, Wk = function(e) {
  return e.type === 2;
}, fB = function(e, A) {
  return e.length === A.length ? e.some(function(t, r) {
    return t === A[r];
  }) : !1;
}, Yk = function(e, A, t, r, n) {
  return e.map(function(a, i) {
    switch (i) {
      case 0:
        return a.add(A, t);
      case 1:
        return a.add(A + r, t);
      case 2:
        return a.add(A + r, t + n);
      case 3:
        return a.add(A, t + n);
    }
    return a;
  });
}, gx = (
  /** @class */
  function() {
    function e(A) {
      this.element = A, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
    }
    return e;
  }()
), Bx = (
  /** @class */
  function() {
    function e(A, t) {
      if (this.container = A, this.parent = t, this.effects = [], this.curves = new Kk(this.container), this.container.styles.opacity < 1 && this.effects.push(new Gk(this.container.styles.opacity)), this.container.styles.transform !== null) {
        var r = this.container.bounds.left + this.container.styles.transformOrigin[0].number, n = this.container.bounds.top + this.container.styles.transformOrigin[1].number, a = this.container.styles.transform;
        this.effects.push(new jk(r, n, a));
      }
      if (this.container.styles.overflowX !== 0) {
        var i = To(this.curves), s = Oo(this.curves);
        fB(i, s) ? this.effects.push(new Is(
          i,
          6
          /* CONTENT */
        )) : (this.effects.push(new Is(
          i,
          2
          /* BACKGROUND_BORDERS */
        )), this.effects.push(new Is(
          s,
          4
          /* CONTENT */
        )));
      }
    }
    return e.prototype.getEffects = function(A) {
      for (var t = [
        2,
        3
        /* FIXED */
      ].indexOf(this.container.styles.position) === -1, r = this.parent, n = this.effects.slice(0); r; ) {
        var a = r.effects.filter(function(o) {
          return !px(o);
        });
        if (t || r.container.styles.position !== 0 || !r.parent) {
          if (n.unshift.apply(n, a), t = [
            2,
            3
            /* FIXED */
          ].indexOf(r.container.styles.position) === -1, r.container.styles.overflowX !== 0) {
            var i = To(r.curves), s = Oo(r.curves);
            fB(i, s) || n.unshift(new Is(
              s,
              6
              /* CONTENT */
            ));
          }
        } else
          n.unshift.apply(n, a);
        r = r.parent;
      }
      return n.filter(function(o) {
        return BA(o.target, A);
      });
    }, e;
  }()
), zf = function(e, A, t, r) {
  e.container.elements.forEach(function(n) {
    var a = BA(
      n.flags,
      4
      /* CREATES_REAL_STACKING_CONTEXT */
    ), i = BA(
      n.flags,
      2
      /* CREATES_STACKING_CONTEXT */
    ), s = new Bx(n, e);
    BA(
      n.styles.display,
      2048
      /* LIST_ITEM */
    ) && r.push(s);
    var o = BA(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) ? [] : r;
    if (a || i) {
      var u = a || n.styles.isPositioned() ? t : A, l = new gx(s);
      if (n.styles.isPositioned() || n.styles.opacity < 1 || n.styles.isTransformed()) {
        var c = n.styles.zIndex.order;
        if (c < 0) {
          var f = 0;
          u.negativeZIndex.some(function(h, p) {
            return c > h.element.container.styles.zIndex.order ? (f = p, !1) : f > 0;
          }), u.negativeZIndex.splice(f, 0, l);
        } else if (c > 0) {
          var d = 0;
          u.positiveZIndex.some(function(h, p) {
            return c >= h.element.container.styles.zIndex.order ? (d = p + 1, !1) : d > 0;
          }), u.positiveZIndex.splice(d, 0, l);
        } else
          u.zeroOrAutoZIndexOrTransformedOrOpacity.push(l);
      } else
        n.styles.isFloating() ? u.nonPositionedFloats.push(l) : u.nonPositionedInlineLevel.push(l);
      zf(s, l, a ? l : t, o);
    } else
      n.styles.isInlineLevel() ? A.inlineLevel.push(s) : A.nonInlineLevel.push(s), zf(s, A, t, o);
    BA(
      n.flags,
      8
      /* IS_LIST_OWNER */
    ) && vx(n, o);
  });
}, vx = function(e, A) {
  for (var t = e instanceof jf ? e.start : 1, r = e instanceof jf ? e.reversed : !1, n = 0; n < A.length; n++) {
    var a = A[n];
    a.container instanceof Ax && typeof a.container.value == "number" && a.container.value !== 0 && (t = a.container.value), a.listValue = bi(t, a.container.styles.listStyleType, !0), t += r ? -1 : 1;
  }
}, zk = function(e) {
  var A = new Bx(e, null), t = new gx(A), r = [];
  return zf(A, t, t, r), vx(A.container, r), t;
}, dB = function(e, A) {
  switch (A) {
    case 0:
      return it(e.topLeftBorderBox, e.topLeftPaddingBox, e.topRightBorderBox, e.topRightPaddingBox);
    case 1:
      return it(e.topRightBorderBox, e.topRightPaddingBox, e.bottomRightBorderBox, e.bottomRightPaddingBox);
    case 2:
      return it(e.bottomRightBorderBox, e.bottomRightPaddingBox, e.bottomLeftBorderBox, e.bottomLeftPaddingBox);
    case 3:
    default:
      return it(e.bottomLeftBorderBox, e.bottomLeftPaddingBox, e.topLeftBorderBox, e.topLeftPaddingBox);
  }
}, Xk = function(e, A) {
  switch (A) {
    case 0:
      return it(e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox, e.topRightBorderBox, e.topRightBorderDoubleOuterBox);
    case 1:
      return it(e.topRightBorderBox, e.topRightBorderDoubleOuterBox, e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox);
    case 2:
      return it(e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox, e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox);
    case 3:
    default:
      return it(e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox, e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox);
  }
}, qk = function(e, A) {
  switch (A) {
    case 0:
      return it(e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox, e.topRightBorderDoubleInnerBox, e.topRightPaddingBox);
    case 1:
      return it(e.topRightBorderDoubleInnerBox, e.topRightPaddingBox, e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox);
    case 2:
      return it(e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox, e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox);
    case 3:
    default:
      return it(e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox, e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox);
  }
}, Jk = function(e, A) {
  switch (A) {
    case 0:
      return Ds(e.topLeftBorderStroke, e.topRightBorderStroke);
    case 1:
      return Ds(e.topRightBorderStroke, e.bottomRightBorderStroke);
    case 2:
      return Ds(e.bottomRightBorderStroke, e.bottomLeftBorderStroke);
    case 3:
    default:
      return Ds(e.bottomLeftBorderStroke, e.topLeftBorderStroke);
  }
}, Ds = function(e, A) {
  var t = [];
  return rt(e) ? t.push(e.subdivide(0.5, !1)) : t.push(e), rt(A) ? t.push(A.subdivide(0.5, !0)) : t.push(A), t;
}, it = function(e, A, t, r) {
  var n = [];
  return rt(e) ? n.push(e.subdivide(0.5, !1)) : n.push(e), rt(t) ? n.push(t.subdivide(0.5, !0)) : n.push(t), rt(r) ? n.push(r.subdivide(0.5, !0).reverse()) : n.push(r), rt(A) ? n.push(A.subdivide(0.5, !1).reverse()) : n.push(A), n;
}, mx = function(e) {
  var A = e.bounds, t = e.styles;
  return A.add(t.borderLeftWidth, t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth), -(t.borderTopWidth + t.borderBottomWidth));
}, Ho = function(e) {
  var A = e.styles, t = e.bounds, r = Ye(A.paddingLeft, t.width), n = Ye(A.paddingRight, t.width), a = Ye(A.paddingTop, t.width), i = Ye(A.paddingBottom, t.width);
  return t.add(r + A.borderLeftWidth, a + A.borderTopWidth, -(A.borderRightWidth + A.borderLeftWidth + r + n), -(A.borderTopWidth + A.borderBottomWidth + a + i));
}, Zk = function(e, A) {
  return e === 0 ? A.bounds : e === 2 ? Ho(A) : mx(A);
}, eP = function(e, A) {
  return e === 0 ? A.bounds : e === 2 ? Ho(A) : mx(A);
}, Hc = function(e, A, t) {
  var r = Zk(ea(e.styles.backgroundOrigin, A), e), n = eP(ea(e.styles.backgroundClip, A), e), a = AP(ea(e.styles.backgroundSize, A), t, r), i = a[0], s = a[1], o = Za(ea(e.styles.backgroundPosition, A), r.width - i, r.height - s), u = tP(ea(e.styles.backgroundRepeat, A), o, a, r, n), l = Math.round(r.left + o[0]), c = Math.round(r.top + o[1]);
  return [u, l, c, i, s];
}, Vn = function(e) {
  return Ke(e) && e.value === ca.AUTO;
}, Ts = function(e) {
  return typeof e == "number";
}, AP = function(e, A, t) {
  var r = A[0], n = A[1], a = A[2], i = e[0], s = e[1];
  if (!i)
    return [0, 0];
  if (hA(i) && s && hA(s))
    return [Ye(i, t.width), Ye(s, t.height)];
  var o = Ts(a);
  if (Ke(i) && (i.value === ca.CONTAIN || i.value === ca.COVER)) {
    if (Ts(a)) {
      var u = t.width / t.height;
      return u < a != (i.value === ca.COVER) ? [t.width, t.width / a] : [t.height * a, t.height];
    }
    return [t.width, t.height];
  }
  var l = Ts(r), c = Ts(n), f = l || c;
  if (Vn(i) && (!s || Vn(s))) {
    if (l && c)
      return [r, n];
    if (!o && !f)
      return [t.width, t.height];
    if (f && o) {
      var d = l ? r : n * a, h = c ? n : r / a;
      return [d, h];
    }
    var p = l ? r : t.width, v = c ? n : t.height;
    return [p, v];
  }
  if (o) {
    var y = 0, g = 0;
    return hA(i) ? y = Ye(i, t.width) : hA(s) && (g = Ye(s, t.height)), Vn(i) ? y = g * a : (!s || Vn(s)) && (g = y / a), [y, g];
  }
  var B = null, w = null;
  if (hA(i) ? B = Ye(i, t.width) : s && hA(s) && (w = Ye(s, t.height)), B !== null && (!s || Vn(s)) && (w = l && c ? B / r * n : t.height), w !== null && Vn(i) && (B = l && c ? w / n * r : t.width), B !== null && w !== null)
    return [B, w];
  throw new Error("Unable to calculate background-size for element");
}, ea = function(e, A) {
  var t = e[A];
  return typeof t > "u" ? e[0] : t;
}, tP = function(e, A, t, r, n) {
  var a = A[0], i = A[1], s = t[0], o = t[1];
  switch (e) {
    case 2:
      return [
        new Ae(Math.round(r.left), Math.round(r.top + i)),
        new Ae(Math.round(r.left + r.width), Math.round(r.top + i)),
        new Ae(Math.round(r.left + r.width), Math.round(o + r.top + i)),
        new Ae(Math.round(r.left), Math.round(o + r.top + i))
      ];
    case 3:
      return [
        new Ae(Math.round(r.left + a), Math.round(r.top)),
        new Ae(Math.round(r.left + a + s), Math.round(r.top)),
        new Ae(Math.round(r.left + a + s), Math.round(r.height + r.top)),
        new Ae(Math.round(r.left + a), Math.round(r.height + r.top))
      ];
    case 1:
      return [
        new Ae(Math.round(r.left + a), Math.round(r.top + i)),
        new Ae(Math.round(r.left + a + s), Math.round(r.top + i)),
        new Ae(Math.round(r.left + a + s), Math.round(r.top + i + o)),
        new Ae(Math.round(r.left + a), Math.round(r.top + i + o))
      ];
    default:
      return [
        new Ae(Math.round(n.left), Math.round(n.top)),
        new Ae(Math.round(n.left + n.width), Math.round(n.top)),
        new Ae(Math.round(n.left + n.width), Math.round(n.height + n.top)),
        new Ae(Math.round(n.left), Math.round(n.height + n.top))
      ];
  }
}, rP = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", hB = "Hidden Text", nP = (
  /** @class */
  function() {
    function e(A) {
      this._data = {}, this._document = A;
    }
    return e.prototype.parseMetrics = function(A, t) {
      var r = this._document.createElement("div"), n = this._document.createElement("img"), a = this._document.createElement("span"), i = this._document.body;
      r.style.visibility = "hidden", r.style.fontFamily = A, r.style.fontSize = t, r.style.margin = "0", r.style.padding = "0", r.style.whiteSpace = "nowrap", i.appendChild(r), n.src = rP, n.width = 1, n.height = 1, n.style.margin = "0", n.style.padding = "0", n.style.verticalAlign = "baseline", a.style.fontFamily = A, a.style.fontSize = t, a.style.margin = "0", a.style.padding = "0", a.appendChild(this._document.createTextNode(hB)), r.appendChild(a), r.appendChild(n);
      var s = n.offsetTop - a.offsetTop + 2;
      r.removeChild(a), r.appendChild(this._document.createTextNode(hB)), r.style.lineHeight = "normal", n.style.verticalAlign = "super";
      var o = n.offsetTop - r.offsetTop + 2;
      return i.removeChild(r), { baseline: s, middle: o };
    }, e.prototype.getMetrics = function(A, t) {
      var r = A + " " + t;
      return typeof this._data[r] > "u" && (this._data[r] = this.parseMetrics(A, t)), this._data[r];
    }, e;
  }()
), wx = (
  /** @class */
  function() {
    function e(A, t) {
      this.context = A, this.options = t;
    }
    return e;
  }()
), aP = 1e4, iP = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n._activeEffects = [], n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), r.canvas || (n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px"), n.fontMetrics = new nP(document), n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.ctx.textBaseline = "bottom", n._activeEffects = [], n.context.logger.debug("Canvas renderer initialized (" + r.width + "x" + r.height + ") with scale " + r.scale), n;
    }
    return A.prototype.applyEffects = function(t) {
      for (var r = this; this._activeEffects.length; )
        this.popEffect();
      t.forEach(function(n) {
        return r.applyEffect(n);
      });
    }, A.prototype.applyEffect = function(t) {
      this.ctx.save(), Wk(t) && (this.ctx.globalAlpha = t.opacity), Vk(t) && (this.ctx.translate(t.offsetX, t.offsetY), this.ctx.transform(t.matrix[0], t.matrix[1], t.matrix[2], t.matrix[3], t.matrix[4], t.matrix[5]), this.ctx.translate(-t.offsetX, -t.offsetY)), px(t) && (this.path(t.path), this.ctx.clip()), this._activeEffects.push(t);
    }, A.prototype.popEffect = function() {
      this._activeEffects.pop(), this.ctx.restore();
    }, A.prototype.renderStack = function(t) {
      return LA(this, void 0, void 0, function() {
        var r;
        return SA(this, function(n) {
          switch (n.label) {
            case 0:
              return r = t.element.container.styles, r.isVisible() ? [4, this.renderStackContent(t)] : [3, 2];
            case 1:
              n.sent(), n.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNode = function(t) {
      return LA(this, void 0, void 0, function() {
        return SA(this, function(r) {
          switch (r.label) {
            case 0:
              if (BA(
                t.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return t.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(t)] : [3, 3];
            case 1:
              return r.sent(), [4, this.renderNodeContent(t)];
            case 2:
              r.sent(), r.label = 3;
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderTextWithLetterSpacing = function(t, r, n) {
      var a = this;
      if (r === 0)
        this.ctx.fillText(t.text, t.bounds.left, t.bounds.top + n);
      else {
        var i = Od(t.text);
        i.reduce(function(s, o) {
          return a.ctx.fillText(o, s, t.bounds.top + n), s + a.ctx.measureText(o).width;
        }, t.bounds.left);
      }
    }, A.prototype.createFontStyle = function(t) {
      var r = t.fontVariant.filter(function(i) {
        return i === "normal" || i === "small-caps";
      }).join(""), n = cP(t.fontFamily).join(", "), a = Wi(t.fontSize) ? "" + t.fontSize.number + t.fontSize.unit : t.fontSize.number + "px";
      return [
        [t.fontStyle, r, t.fontWeight, a, n].join(" "),
        n,
        a
      ];
    }, A.prototype.renderTextNode = function(t, r) {
      return LA(this, void 0, void 0, function() {
        var n, a, i, s, o, u, l, c, f = this;
        return SA(this, function(d) {
          return n = this.createFontStyle(r), a = n[0], i = n[1], s = n[2], this.ctx.font = a, this.ctx.direction = r.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", o = this.fontMetrics.getMetrics(i, s), u = o.baseline, l = o.middle, c = r.paintOrder, t.textBounds.forEach(function(h) {
            c.forEach(function(p) {
              switch (p) {
                case 0:
                  f.ctx.fillStyle = mA(r.color), f.renderTextWithLetterSpacing(h, r.letterSpacing, u);
                  var v = r.textShadow;
                  v.length && h.text.trim().length && (v.slice(0).reverse().forEach(function(y) {
                    f.ctx.shadowColor = mA(y.color), f.ctx.shadowOffsetX = y.offsetX.number * f.options.scale, f.ctx.shadowOffsetY = y.offsetY.number * f.options.scale, f.ctx.shadowBlur = y.blur.number, f.renderTextWithLetterSpacing(h, r.letterSpacing, u);
                  }), f.ctx.shadowColor = "", f.ctx.shadowOffsetX = 0, f.ctx.shadowOffsetY = 0, f.ctx.shadowBlur = 0), r.textDecorationLine.length && (f.ctx.fillStyle = mA(r.textDecorationColor || r.color), r.textDecorationLine.forEach(function(y) {
                    switch (y) {
                      case 1:
                        f.ctx.fillRect(h.bounds.left, Math.round(h.bounds.top + u), h.bounds.width, 1);
                        break;
                      case 2:
                        f.ctx.fillRect(h.bounds.left, Math.round(h.bounds.top), h.bounds.width, 1);
                        break;
                      case 3:
                        f.ctx.fillRect(h.bounds.left, Math.ceil(h.bounds.top + l), h.bounds.width, 1);
                        break;
                    }
                  }));
                  break;
                case 1:
                  r.webkitTextStrokeWidth && h.text.trim().length && (f.ctx.strokeStyle = mA(r.webkitTextStrokeColor), f.ctx.lineWidth = r.webkitTextStrokeWidth, f.ctx.lineJoin = window.chrome ? "miter" : "round", f.ctx.strokeText(h.text, h.bounds.left, h.bounds.top + u)), f.ctx.strokeStyle = "", f.ctx.lineWidth = 0, f.ctx.lineJoin = "miter";
                  break;
              }
            });
          }), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderReplacedElement = function(t, r, n) {
      if (n && t.intrinsicWidth > 0 && t.intrinsicHeight > 0) {
        var a = Ho(t), i = Oo(r);
        this.path(i), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, t.intrinsicWidth, t.intrinsicHeight, a.left, a.top, a.width, a.height), this.ctx.restore();
      }
    }, A.prototype.renderNodeContent = function(t) {
      return LA(this, void 0, void 0, function() {
        var r, n, a, i, s, o, g, g, u, l, c, f, w, d, h, m, p, v, y, g, B, w, m;
        return SA(this, function(x) {
          switch (x.label) {
            case 0:
              this.applyEffects(t.getEffects(
                4
                /* CONTENT */
              )), r = t.container, n = t.curves, a = r.styles, i = 0, s = r.textNodes, x.label = 1;
            case 1:
              return i < s.length ? (o = s[i], [4, this.renderTextNode(o, a)]) : [3, 4];
            case 2:
              x.sent(), x.label = 3;
            case 3:
              return i++, [3, 1];
            case 4:
              if (!(r instanceof Jy))
                return [3, 8];
              x.label = 5;
            case 5:
              return x.trys.push([5, 7, , 8]), [4, this.context.cache.match(r.src)];
            case 6:
              return g = x.sent(), this.renderReplacedElement(r, n, g), [3, 8];
            case 7:
              return x.sent(), this.context.logger.error("Error loading image " + r.src), [3, 8];
            case 8:
              if (r instanceof Zy && this.renderReplacedElement(r, n, r.canvas), !(r instanceof ex))
                return [3, 12];
              x.label = 9;
            case 9:
              return x.trys.push([9, 11, , 12]), [4, this.context.cache.match(r.svg)];
            case 10:
              return g = x.sent(), this.renderReplacedElement(r, n, g), [3, 12];
            case 11:
              return x.sent(), this.context.logger.error("Error loading svg " + r.svg.substring(0, 255)), [3, 12];
            case 12:
              return r instanceof nx && r.tree ? (u = new A(this.context, {
                scale: this.options.scale,
                backgroundColor: r.backgroundColor,
                x: 0,
                y: 0,
                width: r.width,
                height: r.height
              }), [4, u.render(r.tree)]) : [3, 14];
            case 13:
              l = x.sent(), r.width && r.height && this.ctx.drawImage(l, 0, 0, r.width, r.height, r.bounds.left, r.bounds.top, r.bounds.width, r.bounds.height), x.label = 14;
            case 14:
              if (r instanceof Hd && (c = Math.min(r.bounds.width, r.bounds.height), r.type === _o ? r.checked && (this.ctx.save(), this.path([
                new Ae(r.bounds.left + c * 0.39363, r.bounds.top + c * 0.79),
                new Ae(r.bounds.left + c * 0.16, r.bounds.top + c * 0.5549),
                new Ae(r.bounds.left + c * 0.27347, r.bounds.top + c * 0.44071),
                new Ae(r.bounds.left + c * 0.39694, r.bounds.top + c * 0.5649),
                new Ae(r.bounds.left + c * 0.72983, r.bounds.top + c * 0.23),
                new Ae(r.bounds.left + c * 0.84, r.bounds.top + c * 0.34085),
                new Ae(r.bounds.left + c * 0.39363, r.bounds.top + c * 0.79)
              ]), this.ctx.fillStyle = mA(AB), this.ctx.fill(), this.ctx.restore()) : r.type === Qo && r.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(r.bounds.left + c / 2, r.bounds.top + c / 2, c / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = mA(AB), this.ctx.fill(), this.ctx.restore())), sP(r) && r.value.length) {
                switch (f = this.createFontStyle(a), w = f[0], d = f[1], h = this.fontMetrics.getMetrics(w, d).baseline, this.ctx.font = w, this.ctx.fillStyle = mA(a.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = uP(r.styles.textAlign), m = Ho(r), p = 0, r.styles.textAlign) {
                  case 1:
                    p += m.width / 2;
                    break;
                  case 2:
                    p += m.width;
                    break;
                }
                v = m.add(p, 0, 0, -m.height / 2 + 1), this.ctx.save(), this.path([
                  new Ae(m.left, m.top),
                  new Ae(m.left + m.width, m.top),
                  new Ae(m.left + m.width, m.top + m.height),
                  new Ae(m.left, m.top + m.height)
                ]), this.ctx.clip(), this.renderTextWithLetterSpacing(new fi(r.value, v), a.letterSpacing, h), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
              }
              if (!BA(
                r.styles.display,
                2048
                /* LIST_ITEM */
              ))
                return [3, 20];
              if (r.styles.listStyleImage === null)
                return [3, 19];
              if (y = r.styles.listStyleImage, y.type !== 0)
                return [3, 18];
              g = void 0, B = y.url, x.label = 15;
            case 15:
              return x.trys.push([15, 17, , 18]), [4, this.context.cache.match(B)];
            case 16:
              return g = x.sent(), this.ctx.drawImage(g, r.bounds.left - (g.width + 10), r.bounds.top), [3, 18];
            case 17:
              return x.sent(), this.context.logger.error("Error loading list-style-image " + B), [3, 18];
            case 18:
              return [3, 20];
            case 19:
              t.listValue && r.styles.listStyleType !== -1 && (w = this.createFontStyle(a)[0], this.ctx.font = w, this.ctx.fillStyle = mA(a.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", m = new fr(r.bounds.left, r.bounds.top + Ye(r.styles.paddingTop, r.bounds.width), r.bounds.width, Rg(a.lineHeight, a.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new fi(t.listValue, m), a.letterSpacing, Rg(a.lineHeight, a.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), x.label = 20;
            case 20:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderStackContent = function(t) {
      return LA(this, void 0, void 0, function() {
        var r, n, y, a, i, y, s, o, y, u, l, y, c, f, y, d, h, y, p, v, y;
        return SA(this, function(g) {
          switch (g.label) {
            case 0:
              if (BA(
                t.element.container.flags,
                16
                /* DEBUG_RENDER */
              ))
                debugger;
              return [4, this.renderNodeBackgroundAndBorders(t.element)];
            case 1:
              g.sent(), r = 0, n = t.negativeZIndex, g.label = 2;
            case 2:
              return r < n.length ? (y = n[r], [4, this.renderStack(y)]) : [3, 5];
            case 3:
              g.sent(), g.label = 4;
            case 4:
              return r++, [3, 2];
            case 5:
              return [4, this.renderNodeContent(t.element)];
            case 6:
              g.sent(), a = 0, i = t.nonInlineLevel, g.label = 7;
            case 7:
              return a < i.length ? (y = i[a], [4, this.renderNode(y)]) : [3, 10];
            case 8:
              g.sent(), g.label = 9;
            case 9:
              return a++, [3, 7];
            case 10:
              s = 0, o = t.nonPositionedFloats, g.label = 11;
            case 11:
              return s < o.length ? (y = o[s], [4, this.renderStack(y)]) : [3, 14];
            case 12:
              g.sent(), g.label = 13;
            case 13:
              return s++, [3, 11];
            case 14:
              u = 0, l = t.nonPositionedInlineLevel, g.label = 15;
            case 15:
              return u < l.length ? (y = l[u], [4, this.renderStack(y)]) : [3, 18];
            case 16:
              g.sent(), g.label = 17;
            case 17:
              return u++, [3, 15];
            case 18:
              c = 0, f = t.inlineLevel, g.label = 19;
            case 19:
              return c < f.length ? (y = f[c], [4, this.renderNode(y)]) : [3, 22];
            case 20:
              g.sent(), g.label = 21;
            case 21:
              return c++, [3, 19];
            case 22:
              d = 0, h = t.zeroOrAutoZIndexOrTransformedOrOpacity, g.label = 23;
            case 23:
              return d < h.length ? (y = h[d], [4, this.renderStack(y)]) : [3, 26];
            case 24:
              g.sent(), g.label = 25;
            case 25:
              return d++, [3, 23];
            case 26:
              p = 0, v = t.positiveZIndex, g.label = 27;
            case 27:
              return p < v.length ? (y = v[p], [4, this.renderStack(y)]) : [3, 30];
            case 28:
              g.sent(), g.label = 29;
            case 29:
              return p++, [3, 27];
            case 30:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.mask = function(t) {
      this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(t.slice(0).reverse()), this.ctx.closePath();
    }, A.prototype.path = function(t) {
      this.ctx.beginPath(), this.formatPath(t), this.ctx.closePath();
    }, A.prototype.formatPath = function(t) {
      var r = this;
      t.forEach(function(n, a) {
        var i = rt(n) ? n.start : n;
        a === 0 ? r.ctx.moveTo(i.x, i.y) : r.ctx.lineTo(i.x, i.y), rt(n) && r.ctx.bezierCurveTo(n.startControl.x, n.startControl.y, n.endControl.x, n.endControl.y, n.end.x, n.end.y);
      });
    }, A.prototype.renderRepeat = function(t, r, n, a) {
      this.path(t), this.ctx.fillStyle = r, this.ctx.translate(n, a), this.ctx.fill(), this.ctx.translate(-n, -a);
    }, A.prototype.resizeImage = function(t, r, n) {
      var a;
      if (t.width === r && t.height === n)
        return t;
      var i = (a = this.canvas.ownerDocument) !== null && a !== void 0 ? a : document, s = i.createElement("canvas");
      s.width = Math.max(1, r), s.height = Math.max(1, n);
      var o = s.getContext("2d");
      return o.drawImage(t, 0, 0, t.width, t.height, 0, 0, r, n), s;
    }, A.prototype.renderBackgroundImage = function(t) {
      return LA(this, void 0, void 0, function() {
        var r, n, a, i, s, o;
        return SA(this, function(u) {
          switch (u.label) {
            case 0:
              r = t.styles.backgroundImage.length - 1, n = function(l) {
                var c, f, d, S, _, K, O, V, E, h, S, _, K, O, V, p, v, y, g, B, w, m, x, C, E, T, S, b, N, O, V, I, _, K, Y, X, R, U, H, D, Q, j;
                return SA(this, function(z) {
                  switch (z.label) {
                    case 0:
                      if (l.type !== 0)
                        return [3, 5];
                      c = void 0, f = l.url, z.label = 1;
                    case 1:
                      return z.trys.push([1, 3, , 4]), [4, a.context.cache.match(f)];
                    case 2:
                      return c = z.sent(), [3, 4];
                    case 3:
                      return z.sent(), a.context.logger.error("Error loading background-image " + f), [3, 4];
                    case 4:
                      return c && (d = Hc(t, r, [
                        c.width,
                        c.height,
                        c.width / c.height
                      ]), S = d[0], _ = d[1], K = d[2], O = d[3], V = d[4], E = a.ctx.createPattern(a.resizeImage(c, O, V), "repeat"), a.renderRepeat(S, E, _, K)), [3, 6];
                    case 5:
                      VR(l) ? (h = Hc(t, r, [null, null, null]), S = h[0], _ = h[1], K = h[2], O = h[3], V = h[4], p = PR(l.angle, O, V), v = p[0], y = p[1], g = p[2], B = p[3], w = p[4], m = document.createElement("canvas"), m.width = O, m.height = V, x = m.getContext("2d"), C = x.createLinearGradient(y, B, g, w), Lg(l.stops, v).forEach(function(re) {
                        return C.addColorStop(re.stop, mA(re.color));
                      }), x.fillStyle = C, x.fillRect(0, 0, O, V), O > 0 && V > 0 && (E = a.ctx.createPattern(m, "repeat"), a.renderRepeat(S, E, _, K))) : WR(l) && (T = Hc(t, r, [
                        null,
                        null,
                        null
                      ]), S = T[0], b = T[1], N = T[2], O = T[3], V = T[4], I = l.position.length === 0 ? [Id] : l.position, _ = Ye(I[0], O), K = Ye(I[I.length - 1], V), Y = KR(l, _, K, O, V), X = Y[0], R = Y[1], X > 0 && R > 0 && (U = a.ctx.createRadialGradient(b + _, N + K, 0, b + _, N + K, X), Lg(l.stops, X * 2).forEach(function(re) {
                        return U.addColorStop(re.stop, mA(re.color));
                      }), a.path(S), a.ctx.fillStyle = U, X !== R ? (H = t.bounds.left + 0.5 * t.bounds.width, D = t.bounds.top + 0.5 * t.bounds.height, Q = R / X, j = 1 / Q, a.ctx.save(), a.ctx.translate(H, D), a.ctx.transform(1, 0, 0, Q, 0, 0), a.ctx.translate(-H, -D), a.ctx.fillRect(b, j * (N - D) + D, O, V * j), a.ctx.restore()) : a.ctx.fill())), z.label = 6;
                    case 6:
                      return r--, [
                        2
                        /*return*/
                      ];
                  }
                });
              }, a = this, i = 0, s = t.styles.backgroundImage.slice(0).reverse(), u.label = 1;
            case 1:
              return i < s.length ? (o = s[i], [5, n(o)]) : [3, 4];
            case 2:
              u.sent(), u.label = 3;
            case 3:
              return i++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderSolidBorder = function(t, r, n) {
      return LA(this, void 0, void 0, function() {
        return SA(this, function(a) {
          return this.path(dB(n, r)), this.ctx.fillStyle = mA(t), this.ctx.fill(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.renderDoubleBorder = function(t, r, n, a) {
      return LA(this, void 0, void 0, function() {
        var i, s;
        return SA(this, function(o) {
          switch (o.label) {
            case 0:
              return r < 3 ? [4, this.renderSolidBorder(t, n, a)] : [3, 2];
            case 1:
              return o.sent(), [
                2
                /*return*/
              ];
            case 2:
              return i = Xk(a, n), this.path(i), this.ctx.fillStyle = mA(t), this.ctx.fill(), s = qk(a, n), this.path(s), this.ctx.fill(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderNodeBackgroundAndBorders = function(t) {
      return LA(this, void 0, void 0, function() {
        var r, n, a, i, s, o, u, l, c = this;
        return SA(this, function(f) {
          switch (f.label) {
            case 0:
              return this.applyEffects(t.getEffects(
                2
                /* BACKGROUND_BORDERS */
              )), r = t.container.styles, n = !Hr(r.backgroundColor) || r.backgroundImage.length, a = [
                { style: r.borderTopStyle, color: r.borderTopColor, width: r.borderTopWidth },
                { style: r.borderRightStyle, color: r.borderRightColor, width: r.borderRightWidth },
                { style: r.borderBottomStyle, color: r.borderBottomColor, width: r.borderBottomWidth },
                { style: r.borderLeftStyle, color: r.borderLeftColor, width: r.borderLeftWidth }
              ], i = oP(ea(r.backgroundClip, 0), t.curves), n || r.boxShadow.length ? (this.ctx.save(), this.path(i), this.ctx.clip(), Hr(r.backgroundColor) || (this.ctx.fillStyle = mA(r.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(t.container)]) : [3, 2];
            case 1:
              f.sent(), this.ctx.restore(), r.boxShadow.slice(0).reverse().forEach(function(d) {
                c.ctx.save();
                var h = To(t.curves), p = d.inset ? 0 : aP, v = Yk(h, -p + (d.inset ? 1 : -1) * d.spread.number, (d.inset ? 1 : -1) * d.spread.number, d.spread.number * (d.inset ? -2 : 2), d.spread.number * (d.inset ? -2 : 2));
                d.inset ? (c.path(h), c.ctx.clip(), c.mask(v)) : (c.mask(h), c.ctx.clip(), c.path(v)), c.ctx.shadowOffsetX = d.offsetX.number + p, c.ctx.shadowOffsetY = d.offsetY.number, c.ctx.shadowColor = mA(d.color), c.ctx.shadowBlur = d.blur.number, c.ctx.fillStyle = d.inset ? mA(d.color) : "rgba(0,0,0,1)", c.ctx.fill(), c.ctx.restore();
              }), f.label = 2;
            case 2:
              s = 0, o = 0, u = a, f.label = 3;
            case 3:
              return o < u.length ? (l = u[o], l.style !== 0 && !Hr(l.color) && l.width > 0 ? l.style !== 2 ? [3, 5] : [4, this.renderDashedDottedBorder(
                l.color,
                l.width,
                s,
                t.curves,
                2
                /* DASHED */
              )] : [3, 11]) : [3, 13];
            case 4:
              return f.sent(), [3, 11];
            case 5:
              return l.style !== 3 ? [3, 7] : [4, this.renderDashedDottedBorder(
                l.color,
                l.width,
                s,
                t.curves,
                3
                /* DOTTED */
              )];
            case 6:
              return f.sent(), [3, 11];
            case 7:
              return l.style !== 4 ? [3, 9] : [4, this.renderDoubleBorder(l.color, l.width, s, t.curves)];
            case 8:
              return f.sent(), [3, 11];
            case 9:
              return [4, this.renderSolidBorder(l.color, s, t.curves)];
            case 10:
              f.sent(), f.label = 11;
            case 11:
              s++, f.label = 12;
            case 12:
              return o++, [3, 3];
            case 13:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, A.prototype.renderDashedDottedBorder = function(t, r, n, a, i) {
      return LA(this, void 0, void 0, function() {
        var s, o, u, l, c, f, d, h, p, v, y, g, B, w, m, x, m, x;
        return SA(this, function(C) {
          return this.ctx.save(), s = Jk(a, n), o = dB(a, n), i === 2 && (this.path(o), this.ctx.clip()), rt(o[0]) ? (u = o[0].start.x, l = o[0].start.y) : (u = o[0].x, l = o[0].y), rt(o[1]) ? (c = o[1].end.x, f = o[1].end.y) : (c = o[1].x, f = o[1].y), n === 0 || n === 2 ? d = Math.abs(u - c) : d = Math.abs(l - f), this.ctx.beginPath(), i === 3 ? this.formatPath(s) : this.formatPath(o.slice(0, 2)), h = r < 3 ? r * 3 : r * 2, p = r < 3 ? r * 2 : r, i === 3 && (h = r, p = r), v = !0, d <= h * 2 ? v = !1 : d <= h * 2 + p ? (y = d / (2 * h + p), h *= y, p *= y) : (g = Math.floor((d + p) / (h + p)), B = (d - g * h) / (g - 1), w = (d - (g + 1) * h) / g, p = w <= 0 || Math.abs(p - B) < Math.abs(p - w) ? B : w), v && (i === 3 ? this.ctx.setLineDash([0, h + p]) : this.ctx.setLineDash([h, p])), i === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = r) : this.ctx.lineWidth = r * 2 + 1.1, this.ctx.strokeStyle = mA(t), this.ctx.stroke(), this.ctx.setLineDash([]), i === 2 && (rt(o[0]) && (m = o[3], x = o[0], this.ctx.beginPath(), this.formatPath([new Ae(m.end.x, m.end.y), new Ae(x.start.x, x.start.y)]), this.ctx.stroke()), rt(o[1]) && (m = o[1], x = o[2], this.ctx.beginPath(), this.formatPath([new Ae(m.end.x, m.end.y), new Ae(x.start.x, x.start.y)]), this.ctx.stroke())), this.ctx.restore(), [
            2
            /*return*/
          ];
        });
      });
    }, A.prototype.render = function(t) {
      return LA(this, void 0, void 0, function() {
        var r;
        return SA(this, function(n) {
          switch (n.label) {
            case 0:
              return this.options.backgroundColor && (this.ctx.fillStyle = mA(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), r = zk(t), [4, this.renderStack(r)];
            case 1:
              return n.sent(), this.applyEffects([]), [2, this.canvas];
          }
        });
      });
    }, A;
  }(wx)
), sP = function(e) {
  return e instanceof rx || e instanceof tx ? !0 : e instanceof Hd && e.type !== Qo && e.type !== _o;
}, oP = function(e, A) {
  switch (e) {
    case 0:
      return To(A);
    case 2:
      return $k(A);
    case 1:
    default:
      return Oo(A);
  }
}, uP = function(e) {
  switch (e) {
    case 1:
      return "center";
    case 2:
      return "right";
    case 0:
    default:
      return "left";
  }
}, lP = ["-apple-system", "system-ui"], cP = function(e) {
  return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? e.filter(function(A) {
    return lP.indexOf(A) === -1;
  }) : e;
}, fP = (
  /** @class */
  function(e) {
    Ct(A, e);
    function A(t, r) {
      var n = e.call(this, t, r) || this;
      return n.canvas = r.canvas ? r.canvas : document.createElement("canvas"), n.ctx = n.canvas.getContext("2d"), n.options = r, n.canvas.width = Math.floor(r.width * r.scale), n.canvas.height = Math.floor(r.height * r.scale), n.canvas.style.width = r.width + "px", n.canvas.style.height = r.height + "px", n.ctx.scale(n.options.scale, n.options.scale), n.ctx.translate(-r.x, -r.y), n.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + r.width + "x" + r.height + " at " + r.x + "," + r.y + ") with scale " + r.scale), n;
    }
    return A.prototype.render = function(t) {
      return LA(this, void 0, void 0, function() {
        var r, n;
        return SA(this, function(a) {
          switch (a.label) {
            case 0:
              return r = $f(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, t), [4, dP(r)];
            case 1:
              return n = a.sent(), this.options.backgroundColor && (this.ctx.fillStyle = mA(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
          }
        });
      });
    }, A;
  }(wx)
), dP = function(e) {
  return new Promise(function(A, t) {
    var r = new Image();
    r.onload = function() {
      A(r);
    }, r.onerror = t, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
  });
}, hP = (
  /** @class */
  function() {
    function e(A) {
      var t = A.id, r = A.enabled;
      this.id = t, this.enabled = r, this.start = Date.now();
    }
    return e.prototype.debug = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, cs([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.prototype.getTime = function() {
      return Date.now() - this.start;
    }, e.prototype.info = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, cs([this.id, this.getTime() + "ms"], A));
    }, e.prototype.warn = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, cs([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.prototype.error = function() {
      for (var A = [], t = 0; t < arguments.length; t++)
        A[t] = arguments[t];
      this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, cs([this.id, this.getTime() + "ms"], A)) : this.info.apply(this, A));
    }, e.instances = {}, e;
  }()
), pP = (
  /** @class */
  function() {
    function e(A, t) {
      var r;
      this.windowBounds = t, this.instanceName = "#" + e.instanceCount++, this.logger = new hP({ id: this.instanceName, enabled: A.logging }), this.cache = (r = A.cache) !== null && r !== void 0 ? r : new Hk(this, A);
    }
    return e.instanceCount = 1, e;
  }()
), gP = function(e, A) {
  return A === void 0 && (A = {}), BP(e, A);
};
typeof window < "u" && hx.setContext(window);
var BP = function(e, A) {
  return LA(void 0, void 0, void 0, function() {
    var t, r, n, a, i, s, o, u, l, c, f, d, h, p, v, y, g, B, w, m, C, x, C, E, T, S, b, N, O, V, I, _, K, Y, X, R, U, H, D, Q;
    return SA(this, function(j) {
      switch (j.label) {
        case 0:
          if (!e || typeof e != "object")
            return [2, Promise.reject("Invalid element provided as first argument")];
          if (t = e.ownerDocument, !t)
            throw new Error("Element is not attached to a Document");
          if (r = t.defaultView, !r)
            throw new Error("Document is not attached to a Window");
          return n = {
            allowTaint: (E = A.allowTaint) !== null && E !== void 0 ? E : !1,
            imageTimeout: (T = A.imageTimeout) !== null && T !== void 0 ? T : 15e3,
            proxy: A.proxy,
            useCORS: (S = A.useCORS) !== null && S !== void 0 ? S : !1
          }, a = Uf({ logging: (b = A.logging) !== null && b !== void 0 ? b : !0, cache: A.cache }, n), i = {
            windowWidth: (N = A.windowWidth) !== null && N !== void 0 ? N : r.innerWidth,
            windowHeight: (O = A.windowHeight) !== null && O !== void 0 ? O : r.innerHeight,
            scrollX: (V = A.scrollX) !== null && V !== void 0 ? V : r.pageXOffset,
            scrollY: (I = A.scrollY) !== null && I !== void 0 ? I : r.pageYOffset
          }, s = new fr(i.scrollX, i.scrollY, i.windowWidth, i.windowHeight), o = new pP(a, s), u = (_ = A.foreignObjectRendering) !== null && _ !== void 0 ? _ : !1, l = {
            allowTaint: (K = A.allowTaint) !== null && K !== void 0 ? K : !1,
            onclone: A.onclone,
            ignoreElements: A.ignoreElements,
            inlineImages: u,
            copyStyles: u
          }, o.logger.debug("Starting document clone with size " + s.width + "x" + s.height + " scrolled to " + -s.left + "," + -s.top), c = new lB(o, e, l), f = c.clonedReferenceElement, f ? [4, c.toIFrame(t, s)] : [2, Promise.reject("Unable to find element in cloned iframe")];
        case 1:
          return d = j.sent(), h = Ld(f) || vk(f) ? YM(f.ownerDocument) : Ru(o, f), p = h.width, v = h.height, y = h.left, g = h.top, B = vP(o, f, A.backgroundColor), w = {
            canvas: A.canvas,
            backgroundColor: B,
            scale: (X = (Y = A.scale) !== null && Y !== void 0 ? Y : r.devicePixelRatio) !== null && X !== void 0 ? X : 1,
            x: ((R = A.x) !== null && R !== void 0 ? R : 0) + y,
            y: ((U = A.y) !== null && U !== void 0 ? U : 0) + g,
            width: (H = A.width) !== null && H !== void 0 ? H : Math.ceil(p),
            height: (D = A.height) !== null && D !== void 0 ? D : Math.ceil(v)
          }, u ? (o.logger.debug("Document cloned, using foreign object rendering"), C = new fP(o, w), [4, C.render(f)]) : [3, 3];
        case 2:
          return m = j.sent(), [3, 5];
        case 3:
          return o.logger.debug("Document cloned, element located at " + y + "," + g + " with size " + p + "x" + v + " using computed rendering"), o.logger.debug("Starting DOM parsing"), x = ix(o, f), B === x.styles.backgroundColor && (x.styles.backgroundColor = lr.TRANSPARENT), o.logger.debug("Starting renderer for element at " + w.x + "," + w.y + " with size " + w.width + "x" + w.height), C = new iP(o, w), [4, C.render(x)];
        case 4:
          m = j.sent(), j.label = 5;
        case 5:
          return (!((Q = A.removeContainer) !== null && Q !== void 0) || Q) && (lB.destroy(d) || o.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), o.logger.debug("Finished rendering"), [2, m];
      }
    });
  });
}, vP = function(e, A, t) {
  var r = A.ownerDocument, n = r.documentElement ? li(e, getComputedStyle(r.documentElement).backgroundColor) : lr.TRANSPARENT, a = r.body ? li(e, getComputedStyle(r.body).backgroundColor) : lr.TRANSPARENT, i = typeof t == "string" ? li(e, t) : t === null ? lr.TRANSPARENT : 4294967295;
  return A === r.documentElement ? Hr(n) ? Hr(a) ? i : a : n : i;
};
const VAe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gP
}, Symbol.toStringTag, { value: "Module" })), mP = () => {
  const e = Pt(Tm);
  if (e === void 0)
    throw new Error("useChatConfig must be used within a ChatProvider");
  return {
    chatConfig: e.chatConfig,
    firebaseConfig: e.firebaseConfig,
    baseApiConfig: e.baseApiConfig
  };
};
var wP = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  function A(I) {
    return I && typeof I == "object" && "default" in I ? I.default : I;
  }
  var t = Rr, r = A(t), n = function() {
    return n = Object.assign || function(_) {
      for (var K, Y = 1, X = arguments.length; Y < X; Y++) {
        K = arguments[Y];
        for (var R in K)
          Object.prototype.hasOwnProperty.call(K, R) && (_[R] = K[R]);
      }
      return _;
    }, n.apply(this, arguments);
  };
  typeof SuppressedError == "function" && SuppressedError;
  var a = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof te < "u" ? te : typeof self < "u" ? self : {};
  function i(I) {
    return I && I.__esModule && Object.prototype.hasOwnProperty.call(I, "default") ? I.default : I;
  }
  function s(I, _) {
    return _ = { exports: {} }, I(_, _.exports), _.exports;
  }
  var o = s(function(I, _) {
    Object.defineProperty(_, "__esModule", { value: !0 }), _.BLOCKS = void 0, function(K) {
      K.DOCUMENT = "document", K.PARAGRAPH = "paragraph", K.HEADING_1 = "heading-1", K.HEADING_2 = "heading-2", K.HEADING_3 = "heading-3", K.HEADING_4 = "heading-4", K.HEADING_5 = "heading-5", K.HEADING_6 = "heading-6", K.OL_LIST = "ordered-list", K.UL_LIST = "unordered-list", K.LIST_ITEM = "list-item", K.HR = "hr", K.QUOTE = "blockquote", K.EMBEDDED_ENTRY = "embedded-entry-block", K.EMBEDDED_ASSET = "embedded-asset-block", K.EMBEDDED_RESOURCE = "embedded-resource-block", K.TABLE = "table", K.TABLE_ROW = "table-row", K.TABLE_CELL = "table-cell", K.TABLE_HEADER_CELL = "table-header-cell";
    }(_.BLOCKS || (_.BLOCKS = {}));
  });
  i(o), o.BLOCKS;
  var u = s(function(I, _) {
    Object.defineProperty(_, "__esModule", { value: !0 }), _.INLINES = void 0, function(K) {
      K.HYPERLINK = "hyperlink", K.ENTRY_HYPERLINK = "entry-hyperlink", K.ASSET_HYPERLINK = "asset-hyperlink", K.RESOURCE_HYPERLINK = "resource-hyperlink", K.EMBEDDED_ENTRY = "embedded-entry-inline", K.EMBEDDED_RESOURCE = "embedded-resource-inline";
    }(_.INLINES || (_.INLINES = {}));
  });
  i(u), u.INLINES;
  var l = s(function(I, _) {
    Object.defineProperty(_, "__esModule", { value: !0 });
    var K;
    (function(Y) {
      Y.BOLD = "bold", Y.ITALIC = "italic", Y.UNDERLINE = "underline", Y.CODE = "code", Y.SUPERSCRIPT = "superscript", Y.SUBSCRIPT = "subscript";
    })(K || (K = {})), _.default = K;
  });
  i(l);
  var c = s(function(I, _) {
    var K = a && a.__spreadArray || function(U, H, D) {
      if (D || arguments.length === 2)
        for (var Q = 0, j = H.length, z; Q < j; Q++)
          (z || !(Q in H)) && (z || (z = Array.prototype.slice.call(H, 0, Q)), z[Q] = H[Q]);
      return U.concat(z || Array.prototype.slice.call(H));
    }, Y = a && a.__importDefault || function(U) {
      return U && U.__esModule ? U : { default: U };
    }, X;
    Object.defineProperty(_, "__esModule", { value: !0 }), _.V1_MARKS = _.V1_NODE_TYPES = _.TEXT_CONTAINERS = _.HEADINGS = _.CONTAINERS = _.VOID_BLOCKS = _.TABLE_BLOCKS = _.LIST_ITEM_BLOCKS = _.TOP_LEVEL_BLOCKS = void 0;
    var R = Y(l);
    _.TOP_LEVEL_BLOCKS = [
      o.BLOCKS.PARAGRAPH,
      o.BLOCKS.HEADING_1,
      o.BLOCKS.HEADING_2,
      o.BLOCKS.HEADING_3,
      o.BLOCKS.HEADING_4,
      o.BLOCKS.HEADING_5,
      o.BLOCKS.HEADING_6,
      o.BLOCKS.OL_LIST,
      o.BLOCKS.UL_LIST,
      o.BLOCKS.HR,
      o.BLOCKS.QUOTE,
      o.BLOCKS.EMBEDDED_ENTRY,
      o.BLOCKS.EMBEDDED_ASSET,
      o.BLOCKS.EMBEDDED_RESOURCE,
      o.BLOCKS.TABLE
    ], _.LIST_ITEM_BLOCKS = [
      o.BLOCKS.PARAGRAPH,
      o.BLOCKS.HEADING_1,
      o.BLOCKS.HEADING_2,
      o.BLOCKS.HEADING_3,
      o.BLOCKS.HEADING_4,
      o.BLOCKS.HEADING_5,
      o.BLOCKS.HEADING_6,
      o.BLOCKS.OL_LIST,
      o.BLOCKS.UL_LIST,
      o.BLOCKS.HR,
      o.BLOCKS.QUOTE,
      o.BLOCKS.EMBEDDED_ENTRY,
      o.BLOCKS.EMBEDDED_ASSET,
      o.BLOCKS.EMBEDDED_RESOURCE
    ], _.TABLE_BLOCKS = [
      o.BLOCKS.TABLE,
      o.BLOCKS.TABLE_ROW,
      o.BLOCKS.TABLE_CELL,
      o.BLOCKS.TABLE_HEADER_CELL
    ], _.VOID_BLOCKS = [
      o.BLOCKS.HR,
      o.BLOCKS.EMBEDDED_ENTRY,
      o.BLOCKS.EMBEDDED_ASSET,
      o.BLOCKS.EMBEDDED_RESOURCE
    ], _.CONTAINERS = (X = {}, X[o.BLOCKS.OL_LIST] = [o.BLOCKS.LIST_ITEM], X[o.BLOCKS.UL_LIST] = [o.BLOCKS.LIST_ITEM], X[o.BLOCKS.LIST_ITEM] = _.LIST_ITEM_BLOCKS, X[o.BLOCKS.QUOTE] = [o.BLOCKS.PARAGRAPH], X[o.BLOCKS.TABLE] = [o.BLOCKS.TABLE_ROW], X[o.BLOCKS.TABLE_ROW] = [o.BLOCKS.TABLE_CELL, o.BLOCKS.TABLE_HEADER_CELL], X[o.BLOCKS.TABLE_CELL] = [o.BLOCKS.PARAGRAPH], X[o.BLOCKS.TABLE_HEADER_CELL] = [o.BLOCKS.PARAGRAPH], X), _.HEADINGS = [
      o.BLOCKS.HEADING_1,
      o.BLOCKS.HEADING_2,
      o.BLOCKS.HEADING_3,
      o.BLOCKS.HEADING_4,
      o.BLOCKS.HEADING_5,
      o.BLOCKS.HEADING_6
    ], _.TEXT_CONTAINERS = K([o.BLOCKS.PARAGRAPH], _.HEADINGS, !0), _.V1_NODE_TYPES = [
      o.BLOCKS.DOCUMENT,
      o.BLOCKS.PARAGRAPH,
      o.BLOCKS.HEADING_1,
      o.BLOCKS.HEADING_2,
      o.BLOCKS.HEADING_3,
      o.BLOCKS.HEADING_4,
      o.BLOCKS.HEADING_5,
      o.BLOCKS.HEADING_6,
      o.BLOCKS.OL_LIST,
      o.BLOCKS.UL_LIST,
      o.BLOCKS.LIST_ITEM,
      o.BLOCKS.HR,
      o.BLOCKS.QUOTE,
      o.BLOCKS.EMBEDDED_ENTRY,
      o.BLOCKS.EMBEDDED_ASSET,
      u.INLINES.HYPERLINK,
      u.INLINES.ENTRY_HYPERLINK,
      u.INLINES.ASSET_HYPERLINK,
      u.INLINES.EMBEDDED_ENTRY,
      "text"
    ], _.V1_MARKS = [R.default.BOLD, R.default.CODE, R.default.ITALIC, R.default.UNDERLINE];
  });
  i(c), c.V1_MARKS, c.V1_NODE_TYPES, c.TEXT_CONTAINERS, c.HEADINGS, c.CONTAINERS, c.VOID_BLOCKS, c.TABLE_BLOCKS, c.LIST_ITEM_BLOCKS, c.TOP_LEVEL_BLOCKS;
  var f = s(function(I, _) {
    Object.defineProperty(_, "__esModule", { value: !0 });
  });
  i(f);
  var d = s(function(I, _) {
    Object.defineProperty(_, "__esModule", { value: !0 });
  });
  i(d);
  var h = s(function(I, _) {
    Object.defineProperty(_, "__esModule", { value: !0 });
    var K = {
      nodeType: o.BLOCKS.DOCUMENT,
      data: {},
      content: [
        {
          nodeType: o.BLOCKS.PARAGRAPH,
          data: {},
          content: [
            {
              nodeType: "text",
              value: "",
              marks: [],
              data: {}
            }
          ]
        }
      ]
    };
    _.default = K;
  });
  i(h);
  var p = s(function(I, _) {
    Object.defineProperty(_, "__esModule", { value: !0 }), _.isText = _.isBlock = _.isInline = void 0;
    function K(U, H) {
      for (var D = 0, Q = Object.keys(U); D < Q.length; D++) {
        var j = Q[D];
        if (H === U[j])
          return !0;
      }
      return !1;
    }
    function Y(U) {
      return K(u.INLINES, U.nodeType);
    }
    _.isInline = Y;
    function X(U) {
      return K(o.BLOCKS, U.nodeType);
    }
    _.isBlock = X;
    function R(U) {
      return U.nodeType === "text";
    }
    _.isText = R;
  });
  i(p), p.isText, p.isBlock, p.isInline;
  var v = s(function(I, _) {
    var K = a && a.__createBinding || (Object.create ? function(D, Q, j, z) {
      z === void 0 && (z = j);
      var re = Object.getOwnPropertyDescriptor(Q, j);
      (!re || ("get" in re ? !Q.__esModule : re.writable || re.configurable)) && (re = { enumerable: !0, get: function() {
        return Q[j];
      } }), Object.defineProperty(D, z, re);
    } : function(D, Q, j, z) {
      z === void 0 && (z = j), D[z] = Q[j];
    }), Y = a && a.__setModuleDefault || (Object.create ? function(D, Q) {
      Object.defineProperty(D, "default", { enumerable: !0, value: Q });
    } : function(D, Q) {
      D.default = Q;
    }), X = a && a.__exportStar || function(D, Q) {
      for (var j in D)
        j !== "default" && !Object.prototype.hasOwnProperty.call(Q, j) && K(Q, D, j);
    }, R = a && a.__importStar || function(D) {
      if (D && D.__esModule)
        return D;
      var Q = {};
      if (D != null)
        for (var j in D)
          j !== "default" && Object.prototype.hasOwnProperty.call(D, j) && K(Q, D, j);
      return Y(Q, D), Q;
    }, U = a && a.__importDefault || function(D) {
      return D && D.__esModule ? D : { default: D };
    };
    Object.defineProperty(_, "__esModule", { value: !0 }), _.helpers = _.EMPTY_DOCUMENT = _.MARKS = _.INLINES = _.BLOCKS = void 0, Object.defineProperty(_, "BLOCKS", { enumerable: !0, get: function() {
      return o.BLOCKS;
    } }), Object.defineProperty(_, "INLINES", { enumerable: !0, get: function() {
      return u.INLINES;
    } }), Object.defineProperty(_, "MARKS", { enumerable: !0, get: function() {
      return U(l).default;
    } }), X(c, _), X(f, _), X(d, _), Object.defineProperty(_, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
      return U(h).default;
    } });
    var H = R(p);
    _.helpers = H;
  });
  i(v);
  var y = v.helpers;
  v.EMPTY_DOCUMENT;
  var g = v.MARKS, B = v.INLINES, w = v.BLOCKS;
  function m(I, _) {
    return t.isValidElement(I) && I.key === null ? t.cloneElement(I, { key: _ }) : I;
  }
  function x(I, _) {
    return I.map(function(K, Y) {
      return m(C(K, _), Y);
    });
  }
  function C(I, _) {
    var K = _.renderNode, Y = _.renderMark, X = _.renderText, R = _.preserveWhitespace;
    if (y.isText(I)) {
      var U = X ? X(I.value) : I.value;
      if (R) {
        U = U.replace(/ {2,}/g, function(j) {
          return "&nbsp;".repeat(j.length);
        });
        var H = U.split(`
`), D = [];
        H.forEach(function(j, z) {
          D.push(j), z !== H.length - 1 && D.push(r.createElement("br", null));
        }), U = D;
      }
      return I.marks.reduce(function(j, z) {
        return Y[z.type] ? Y[z.type](j) : j;
      }, U);
    } else {
      var Q = x(I.content, _);
      return !I.nodeType || !K[I.nodeType] ? r.createElement(r.Fragment, null, Q) : K[I.nodeType](I, Q);
    }
  }
  var E, T, S = (E = {}, E[w.DOCUMENT] = function(I, _) {
    return _;
  }, E[w.PARAGRAPH] = function(I, _) {
    return r.createElement("p", null, _);
  }, E[w.HEADING_1] = function(I, _) {
    return r.createElement("h1", null, _);
  }, E[w.HEADING_2] = function(I, _) {
    return r.createElement("h2", null, _);
  }, E[w.HEADING_3] = function(I, _) {
    return r.createElement("h3", null, _);
  }, E[w.HEADING_4] = function(I, _) {
    return r.createElement("h4", null, _);
  }, E[w.HEADING_5] = function(I, _) {
    return r.createElement("h5", null, _);
  }, E[w.HEADING_6] = function(I, _) {
    return r.createElement("h6", null, _);
  }, E[w.EMBEDDED_ENTRY] = function(I, _) {
    return r.createElement("div", null, _);
  }, E[w.EMBEDDED_RESOURCE] = function(I, _) {
    return r.createElement("div", null, _);
  }, E[w.UL_LIST] = function(I, _) {
    return r.createElement("ul", null, _);
  }, E[w.OL_LIST] = function(I, _) {
    return r.createElement("ol", null, _);
  }, E[w.LIST_ITEM] = function(I, _) {
    return r.createElement("li", null, _);
  }, E[w.QUOTE] = function(I, _) {
    return r.createElement("blockquote", null, _);
  }, E[w.HR] = function() {
    return r.createElement("hr", null);
  }, E[w.TABLE] = function(I, _) {
    return r.createElement(
      "table",
      null,
      r.createElement("tbody", null, _)
    );
  }, E[w.TABLE_ROW] = function(I, _) {
    return r.createElement("tr", null, _);
  }, E[w.TABLE_HEADER_CELL] = function(I, _) {
    return r.createElement("th", null, _);
  }, E[w.TABLE_CELL] = function(I, _) {
    return r.createElement("td", null, _);
  }, E[B.ASSET_HYPERLINK] = function(I) {
    return N(B.ASSET_HYPERLINK, I);
  }, E[B.ENTRY_HYPERLINK] = function(I) {
    return N(B.ENTRY_HYPERLINK, I);
  }, E[B.RESOURCE_HYPERLINK] = function(I) {
    return O(B.RESOURCE_HYPERLINK, I);
  }, E[B.EMBEDDED_ENTRY] = function(I) {
    return N(B.EMBEDDED_ENTRY, I);
  }, E[B.EMBEDDED_RESOURCE] = function(I, _) {
    return O(B.EMBEDDED_RESOURCE, I);
  }, E[B.HYPERLINK] = function(I, _) {
    return r.createElement("a", { href: I.data.uri }, _);
  }, E), b = (T = {}, T[g.BOLD] = function(I) {
    return r.createElement("b", null, I);
  }, T[g.ITALIC] = function(I) {
    return r.createElement("i", null, I);
  }, T[g.UNDERLINE] = function(I) {
    return r.createElement("u", null, I);
  }, T[g.CODE] = function(I) {
    return r.createElement("code", null, I);
  }, T[g.SUPERSCRIPT] = function(I) {
    return r.createElement("sup", null, I);
  }, T[g.SUBSCRIPT] = function(I) {
    return r.createElement("sub", null, I);
  }, T);
  function N(I, _) {
    return r.createElement(
      "span",
      { key: _.data.target.sys.id },
      "type: ",
      _.nodeType,
      " id: ",
      _.data.target.sys.id
    );
  }
  function O(I, _) {
    return r.createElement(
      "span",
      { key: _.data.target.sys.urn },
      "type: ",
      _.nodeType,
      " urn: ",
      _.data.target.sys.urn
    );
  }
  function V(I, _) {
    return _ === void 0 && (_ = {}), I ? C(I, {
      renderNode: n(n({}, S), _.renderNode),
      renderMark: n(n({}, b), _.renderMark),
      renderText: _.renderText,
      preserveWhitespace: _.preserveWhitespace
    }) : null;
  }
  e.documentToReactComponents = V;
})(wP);
var yP = {}, Yi = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.BLOCKS = void 0, function(A) {
    A.DOCUMENT = "document", A.PARAGRAPH = "paragraph", A.HEADING_1 = "heading-1", A.HEADING_2 = "heading-2", A.HEADING_3 = "heading-3", A.HEADING_4 = "heading-4", A.HEADING_5 = "heading-5", A.HEADING_6 = "heading-6", A.OL_LIST = "ordered-list", A.UL_LIST = "unordered-list", A.LIST_ITEM = "list-item", A.HR = "hr", A.QUOTE = "blockquote", A.EMBEDDED_ENTRY = "embedded-entry-block", A.EMBEDDED_ASSET = "embedded-asset-block", A.EMBEDDED_RESOURCE = "embedded-resource-block", A.TABLE = "table", A.TABLE_ROW = "table-row", A.TABLE_CELL = "table-cell", A.TABLE_HEADER_CELL = "table-header-cell";
  }(e.BLOCKS || (e.BLOCKS = {}));
})(Yi);
var Yu = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.INLINES = void 0, function(A) {
    A.HYPERLINK = "hyperlink", A.ENTRY_HYPERLINK = "entry-hyperlink", A.ASSET_HYPERLINK = "asset-hyperlink", A.RESOURCE_HYPERLINK = "resource-hyperlink", A.EMBEDDED_ENTRY = "embedded-entry-inline", A.EMBEDDED_RESOURCE = "embedded-resource-inline";
  }(e.INLINES || (e.INLINES = {}));
})(Yu);
var zu = {};
Object.defineProperty(zu, "__esModule", { value: !0 });
var Xf;
(function(e) {
  e.BOLD = "bold", e.ITALIC = "italic", e.UNDERLINE = "underline", e.CODE = "code", e.SUPERSCRIPT = "superscript", e.SUBSCRIPT = "subscript";
})(Xf || (Xf = {}));
zu.default = Xf;
var yx = {};
(function(e) {
  var A = te && te.__spreadArray || function(s, o, u) {
    if (u || arguments.length === 2)
      for (var l = 0, c = o.length, f; l < c; l++)
        (f || !(l in o)) && (f || (f = Array.prototype.slice.call(o, 0, l)), f[l] = o[l]);
    return s.concat(f || Array.prototype.slice.call(o));
  }, t = te && te.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  }, r;
  Object.defineProperty(e, "__esModule", { value: !0 }), e.V1_MARKS = e.V1_NODE_TYPES = e.TEXT_CONTAINERS = e.HEADINGS = e.CONTAINERS = e.VOID_BLOCKS = e.TABLE_BLOCKS = e.LIST_ITEM_BLOCKS = e.TOP_LEVEL_BLOCKS = void 0;
  var n = Yi, a = Yu, i = t(zu);
  e.TOP_LEVEL_BLOCKS = [
    n.BLOCKS.PARAGRAPH,
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6,
    n.BLOCKS.OL_LIST,
    n.BLOCKS.UL_LIST,
    n.BLOCKS.HR,
    n.BLOCKS.QUOTE,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    n.BLOCKS.EMBEDDED_RESOURCE,
    n.BLOCKS.TABLE
  ], e.LIST_ITEM_BLOCKS = [
    n.BLOCKS.PARAGRAPH,
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6,
    n.BLOCKS.OL_LIST,
    n.BLOCKS.UL_LIST,
    n.BLOCKS.HR,
    n.BLOCKS.QUOTE,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    n.BLOCKS.EMBEDDED_RESOURCE
  ], e.TABLE_BLOCKS = [
    n.BLOCKS.TABLE,
    n.BLOCKS.TABLE_ROW,
    n.BLOCKS.TABLE_CELL,
    n.BLOCKS.TABLE_HEADER_CELL
  ], e.VOID_BLOCKS = [
    n.BLOCKS.HR,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    n.BLOCKS.EMBEDDED_RESOURCE
  ], e.CONTAINERS = (r = {}, r[n.BLOCKS.OL_LIST] = [n.BLOCKS.LIST_ITEM], r[n.BLOCKS.UL_LIST] = [n.BLOCKS.LIST_ITEM], r[n.BLOCKS.LIST_ITEM] = e.LIST_ITEM_BLOCKS, r[n.BLOCKS.QUOTE] = [n.BLOCKS.PARAGRAPH], r[n.BLOCKS.TABLE] = [n.BLOCKS.TABLE_ROW], r[n.BLOCKS.TABLE_ROW] = [n.BLOCKS.TABLE_CELL, n.BLOCKS.TABLE_HEADER_CELL], r[n.BLOCKS.TABLE_CELL] = [n.BLOCKS.PARAGRAPH], r[n.BLOCKS.TABLE_HEADER_CELL] = [n.BLOCKS.PARAGRAPH], r), e.HEADINGS = [
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6
  ], e.TEXT_CONTAINERS = A([n.BLOCKS.PARAGRAPH], e.HEADINGS, !0), e.V1_NODE_TYPES = [
    n.BLOCKS.DOCUMENT,
    n.BLOCKS.PARAGRAPH,
    n.BLOCKS.HEADING_1,
    n.BLOCKS.HEADING_2,
    n.BLOCKS.HEADING_3,
    n.BLOCKS.HEADING_4,
    n.BLOCKS.HEADING_5,
    n.BLOCKS.HEADING_6,
    n.BLOCKS.OL_LIST,
    n.BLOCKS.UL_LIST,
    n.BLOCKS.LIST_ITEM,
    n.BLOCKS.HR,
    n.BLOCKS.QUOTE,
    n.BLOCKS.EMBEDDED_ENTRY,
    n.BLOCKS.EMBEDDED_ASSET,
    a.INLINES.HYPERLINK,
    a.INLINES.ENTRY_HYPERLINK,
    a.INLINES.ASSET_HYPERLINK,
    a.INLINES.EMBEDDED_ENTRY,
    "text"
  ], e.V1_MARKS = [i.default.BOLD, i.default.CODE, i.default.ITALIC, i.default.UNDERLINE];
})(yx);
var xx = {};
Object.defineProperty(xx, "__esModule", { value: !0 });
var Cx = {};
Object.defineProperty(Cx, "__esModule", { value: !0 });
var Md = {};
Object.defineProperty(Md, "__esModule", { value: !0 });
var pB = Yi, xP = {
  nodeType: pB.BLOCKS.DOCUMENT,
  data: {},
  content: [
    {
      nodeType: pB.BLOCKS.PARAGRAPH,
      data: {},
      content: [
        {
          nodeType: "text",
          value: "",
          marks: [],
          data: {}
        }
      ]
    }
  ]
};
Md.default = xP;
var Lr = {};
Object.defineProperty(Lr, "__esModule", { value: !0 });
Lr.isText = Lr.isBlock = Lr.isInline = void 0;
var CP = Yi, EP = Yu;
function Ex(e, A) {
  for (var t = 0, r = Object.keys(e); t < r.length; t++) {
    var n = r[t];
    if (A === e[n])
      return !0;
  }
  return !1;
}
function FP(e) {
  return Ex(EP.INLINES, e.nodeType);
}
Lr.isInline = FP;
function bP(e) {
  return Ex(CP.BLOCKS, e.nodeType);
}
Lr.isBlock = bP;
function SP(e) {
  return e.nodeType === "text";
}
Lr.isText = SP;
(function(e) {
  var A = te && te.__createBinding || (Object.create ? function(c, f, d, h) {
    h === void 0 && (h = d);
    var p = Object.getOwnPropertyDescriptor(f, d);
    (!p || ("get" in p ? !f.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return f[d];
    } }), Object.defineProperty(c, h, p);
  } : function(c, f, d, h) {
    h === void 0 && (h = d), c[h] = f[d];
  }), t = te && te.__setModuleDefault || (Object.create ? function(c, f) {
    Object.defineProperty(c, "default", { enumerable: !0, value: f });
  } : function(c, f) {
    c.default = f;
  }), r = te && te.__exportStar || function(c, f) {
    for (var d in c)
      d !== "default" && !Object.prototype.hasOwnProperty.call(f, d) && A(f, c, d);
  }, n = te && te.__importStar || function(c) {
    if (c && c.__esModule)
      return c;
    var f = {};
    if (c != null)
      for (var d in c)
        d !== "default" && Object.prototype.hasOwnProperty.call(c, d) && A(f, c, d);
    return t(f, c), f;
  }, a = te && te.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.helpers = e.EMPTY_DOCUMENT = e.MARKS = e.INLINES = e.BLOCKS = void 0;
  var i = Yi;
  Object.defineProperty(e, "BLOCKS", { enumerable: !0, get: function() {
    return i.BLOCKS;
  } });
  var s = Yu;
  Object.defineProperty(e, "INLINES", { enumerable: !0, get: function() {
    return s.INLINES;
  } });
  var o = zu;
  Object.defineProperty(e, "MARKS", { enumerable: !0, get: function() {
    return a(o).default;
  } }), r(yx, e), r(xx, e), r(Cx, e);
  var u = Md;
  Object.defineProperty(e, "EMPTY_DOCUMENT", { enumerable: !0, get: function() {
    return a(u).default;
  } });
  var l = n(Lr);
  e.helpers = l;
})(yP);
const Os = (e) => nU.find(
  (A) => A.locale === e || A.name === e || A.code === e
) ?? {
  code: "EN",
  locale: "en-US",
  name: "English"
}, UP = (e, A) => {
  try {
    return decodeURIComponent(escape(e));
  } catch {
    return A;
  }
}, _P = ({
  onSelect: e = (r) => {
    console.log("Selected language", r);
  },
  boxProps: A,
  linkProps: t
}) => {
  const { data: r } = yt(), { languages: n, languagesAvailable: a, theme: i } = r, { components: s } = i, { languageSelector: o } = s, [u, l] = Ue({
    ...(a || n)[0]
  }), {
    updateActiveLanguage: c,
    language: f,
    isTranslationsLoading: d
  } = fu(), h = o && o.link && o.link.color || "black", [p] = Im("al", "");
  return Re(() => {
    l(Os(p) ?? Os(f));
  }, []), Re(() => {
    l(Os(f));
  }, [f]), /* @__PURE__ */ F.jsx(
    nm,
    {
      alignItems: "center",
      maxW: "180px",
      id: "myasurion-language-selector",
      gap: 0,
      spacing: 0,
      ...A,
      children: (a || n) && (a || n).map((v, y) => /* @__PURE__ */ F.jsx(
        ta,
        {
          maxW: "40px",
          borderRight: y < (a || n).length - 1 ? "1px solid #fff" : "none",
          children: /* @__PURE__ */ F.jsx(zv, { isLoaded: !d, children: /* @__PURE__ */ F.jsx(
            Sn,
            {
              fontSize: "md",
              fontWeight: 400,
              color: h,
              variant: "link",
              w: "25px",
              h: "20px",
              textAlign: "center",
              textDecoration: u.code === v.code ? "underline" : "none",
              _hover: {
                color: h,
                textDecoration: "underline"
              },
              _selected: {
                color: h
              },
              onClick: () => {
                l({ ...v, index: y }), e({ ...v, index: y }), c(
                  Os(v.code).locale ?? "en-US"
                );
              },
              ...t,
              children: v != null && v.displayCode ? UP(v.displayCode, v.code) : v.code
            }
          ) })
        },
        `lang-${v.code}-${y}`
      ))
    }
  );
}, Rd = ({ children: e }) => /* @__PURE__ */ F.jsx(Xv, { above: "md", children: e }), qf = ({ children: e }) => /* @__PURE__ */ F.jsx(Xv, { below: "md", children: e }), gB = ({ onToggle: e }) => {
  const { data: A } = yt(), { theme: t } = A, { components: r } = t, { languageSelector: n } = r, { headerIsOpen: a } = sm(), i = n && n.link && n.link.color || "#000";
  return /* @__PURE__ */ F.jsx(F.Fragment, { children: /* @__PURE__ */ F.jsx(
    Sn,
    {
      id: "myasurion-menubutton",
      as: co,
      minW: "24px",
      w: "26px",
      p: 0,
      "aria-label": "profile",
      icon: a ? /* @__PURE__ */ F.jsx($v, { fill: i ?? "#000", color: i ?? "#000" }) : /* @__PURE__ */ F.jsx(lF, { fill: i ?? "#000" }),
      variant: "outline",
      border: "none",
      bg: "none",
      _hover: {
        bg: "none"
      },
      _selected: {
        bg: "none"
      },
      _active: {
        bg: "none"
      },
      onClick: () => e()
    }
  ) });
}, QP = (e) => {
  const { data: A } = yt(), { theme: t } = A, { colors: r } = t, { primary: n } = r;
  return /* @__PURE__ */ F.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...e, children: [
    /* @__PURE__ */ F.jsx(
      "path",
      {
        fill: n || "#8223D2",
        d: "M7 22h11c1.103 0 2-.897 2-2V4c0-1.102-.897-2-2-2H7c-1.103 0-2 .898-2 2v3h2V4h11v16H7v-3H5v3c0 1.103.897 2 2 2Z"
      }
    ),
    /* @__PURE__ */ F.jsx(
      "path",
      {
        fill: n || "#8223D2",
        d: "m10.293 8.708 1.414-1.416 4.707 4.699-4.706 4.715-1.416-1.412L12.582 13H4v-2h8.59l-2.297-2.292Z"
      }
    )
  ] });
}, IP = ({
  label: e,
  iconSrc: A,
  onSignOut: t,
  ...r
}) => {
  const [, n] = _0({}), [, a] = Q0({}), { data: i } = yt(), { theme: s } = i, { colors: o } = s, { accent: u } = o;
  return /* @__PURE__ */ F.jsxs(
    Sn,
    {
      id: "myasurion-signout-link",
      w: "full",
      minW: "287px",
      p: "12px 20px",
      colorScheme: "primary",
      color: u,
      textDecoration: "underline",
      variant: "link",
      onClick: () => {
        localStorage.clear(), sessionStorage.clear(), n({}), a({}), t && t();
      },
      ...r,
      children: [
        /* @__PURE__ */ F.jsx(Rd, { children: /* @__PURE__ */ F.jsx(ye, { mr: "8px", children: /* @__PURE__ */ F.jsx(QP, {}) }) }),
        e || /* @__PURE__ */ F.jsx(QA, { text: "Sign out", translationKey: "Global/Signout" })
      ]
    }
  );
}, DP = ({
  firstname: e,
  lastname: A,
  accountType: t = "main account",
  signOutProps: r,
  serviceRequestButtonProps: n,
  ...a
}) => {
  const { data: i } = yt(), { urls: s, mainMenu: o } = i, { theme: u } = i, { serviceRequestBtn: l } = (u == null ? void 0 : u.components) || {};
  return /* @__PURE__ */ F.jsxs(
    ye,
    {
      id: "myasurion-menu-display",
      zIndex: 999998,
      pos: "fixed",
      top: 0,
      left: 0,
      bg: "#fff",
      w: "full",
      h: "100dvh",
      m: 0,
      p: 0,
      border: "none",
      ...a,
      children: [
        /* @__PURE__ */ F.jsxs(
          pn,
          {
            gap: 0,
            spacing: 0,
            w: "full",
            alignItems: "baseline",
            id: "myasurion-menu-display-stack",
            children: [
              /* @__PURE__ */ F.jsx(ye, { w: "full", px: "16px", py: "24px", borderBottom: "1px solid #F0F0F5", children: /* @__PURE__ */ F.jsxs(Cn, { gap: 6, children: [
                /* @__PURE__ */ F.jsx(ye, { children: /* @__PURE__ */ F.jsx(cF, { firstname: e, lastname: A }) }),
                /* @__PURE__ */ F.jsx(ye, { children: /* @__PURE__ */ F.jsxs(pn, { alignItems: "baseline", children: [
                  /* @__PURE__ */ F.jsx(
                    EA,
                    {
                      fontSize: "xs",
                      fontWeight: 900,
                      lineHeight: "136%",
                      textTransform: "uppercase",
                      children: t
                    }
                  ),
                  /* @__PURE__ */ F.jsx(
                    Gs,
                    {
                      textTransform: "capitalize",
                      fontSize: "2xl",
                      lineHeight: "132%",
                      href: `${hl((s == null ? void 0 : s.profile) || "")}`,
                      _hover: { textDecoration: "none", cursor: "pointer" },
                      children: `${e} ${A}`
                    }
                  )
                ] }) }),
                /* @__PURE__ */ F.jsx(ef, {}),
                /* @__PURE__ */ F.jsx(ye, { children: /* @__PURE__ */ F.jsx(
                  Gs,
                  {
                    href: `${hl((s == null ? void 0 : s.profile) || "")}`,
                    _hover: { textDecoration: "none", cursor: "pointer" },
                    children: /* @__PURE__ */ F.jsx(Eh, { w: "24px", h: "24px", color: "#000" })
                  }
                ) })
              ] }) }),
              o && o.map((c, f) => {
                const d = hl(c.url);
                return /* @__PURE__ */ F.jsx(ye, { w: "full", px: "16px", py: "24px", children: /* @__PURE__ */ F.jsx(Cn, { children: /* @__PURE__ */ F.jsx(
                  Gs,
                  {
                    fontSize: "2xl",
                    fontWeight: 300,
                    lineHeight: "132%",
                    href: d,
                    w: "100%",
                    _hover: { textDecoration: "none", cursor: "pointer" },
                    children: /* @__PURE__ */ F.jsxs(Gv, { direction: "row", gap: 0, children: [
                      /* @__PURE__ */ F.jsx(ye, { children: c.name }),
                      /* @__PURE__ */ F.jsx(ef, {}),
                      /* @__PURE__ */ F.jsx(ye, { children: /* @__PURE__ */ F.jsx(
                        Eh,
                        {
                          w: "24px",
                          h: "24px",
                          color: "#000"
                        }
                      ) })
                    ] })
                  }
                ) }) }, `menu-${c.code}-${f}`);
              })
            ]
          }
        ),
        /* @__PURE__ */ F.jsx(
          ye,
          {
            id: "header-signout-section",
            position: "fixed",
            bottom: 0,
            w: "full",
            bg: "#FFFFFF",
            boxShadow: " 0px -4px 8px 0px rgba(0, 0, 0, 0.04)",
            children: /* @__PURE__ */ F.jsxs(pn, { alignItems: "baseline", w: "full", gap: 6, p: "24px 16px", children: [
              n && n.enabled && /* @__PURE__ */ F.jsx(
                Sn,
                {
                  ...l,
                  ...n == null ? void 0 : n.styleProps,
                  onClick: () => {
                    n != null && n.onClick && n.onClick();
                  },
                  children: (n == null ? void 0 : n.label) || "File a service request"
                }
              ),
              /* @__PURE__ */ F.jsx(
                IP,
                {
                  label: (r == null ? void 0 : r.label) && r.label,
                  onSignOut: () => {
                    r != null && r.onSignOut && r.onSignOut();
                  },
                  margin: "0 auto",
                  ...r == null ? void 0 : r.styleProps
                }
              )
            ] })
          }
        )
      ]
    }
  );
}, TP = (e) => {
  var A, t;
  return /* @__PURE__ */ F.jsxs(ye, { position: "relative", p: "4px", children: [
    /* @__PURE__ */ F.jsxs(
      UE,
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        ...e,
        children: [
          /* @__PURE__ */ F.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0 12.279V15H18V12.279L17.316 12.052C15.931 11.589 15 10.298 15 8.838V6C15 2.691 12.309 0 9 0C5.691 0 3 2.691 3 6V8.838C3 10.298 2.069 11.589 0.684 12.052L0 12.279ZM14.966 13H3.035C4.255 11.998 5 10.486 5 8.838V6C5 3.794 6.794 2 9 2C11.206 2 13 3.794 13 6V8.838C13 10.486 13.745 11.998 14.966 13Z",
              fill: ((A = e == null ? void 0 : e.fill) == null ? void 0 : A.toString()) ?? "black"
            }
          ),
          /* @__PURE__ */ F.jsx(
            "path",
            {
              d: "M8.9997 18C7.5237 18 6.24769 17.19 5.55469 16H12.4447C11.7517 17.19 10.4757 18 8.9997 18Z",
              fill: ((t = e == null ? void 0 : e.fill) == null ? void 0 : t.toString()) ?? "black"
            }
          )
        ]
      }
    ),
    (e == null ? void 0 : e.promptcount) > 0 && /* @__PURE__ */ F.jsx(
      Vs,
      {
        position: "absolute",
        top: "0",
        right: "0",
        minBlockSize: "14px",
        minInlineSize: "14px",
        minW: "14px",
        minH: "14px",
        padding: e.promptcount > 100 ? "4px" : "unset",
        verticalAlign: "middle",
        background: "#DB1B1B",
        children: /* @__PURE__ */ F.jsx(
          EA,
          {
            fontWeight: 700,
            size: e.promptcount > 100 ? "7px" : "8px",
            lineHeight: "normal",
            fontSize: e.promptcount > 100 ? "7px" : "8px",
            textAlign: "center",
            color: "white",
            children: e.promptcount
          }
        )
      }
    )
  ] });
}, OP = ({
  onToggle: e,
  isLoading: A,
  promptCount: t
}) => {
  const { data: r } = yt(), { theme: n } = r, { components: a } = n, { languageSelector: i } = a, s = i && i.link && i.link.color || "#fff";
  return /* @__PURE__ */ F.jsx(F.Fragment, { children: /* @__PURE__ */ F.jsx(
    Sn,
    {
      id: "myasurion-menubutton",
      as: co,
      minW: "24px",
      w: "26px",
      p: 0,
      "aria-label": "profile",
      icon: /* @__PURE__ */ F.jsx(zv, { isLoaded: !A, p: A ? "2px" : "0", children: /* @__PURE__ */ F.jsx(
        TP,
        {
          fill: s ?? "#fff",
          promptcount: t ?? 0
        }
      ) }),
      variant: "outline",
      border: "none",
      bg: "none",
      _hover: {
        bg: "none"
      },
      _selected: {
        bg: "none"
      },
      _active: {
        bg: "none"
      },
      onClick: () => e(),
      h: "min-content"
    }
  ) });
};
function Lo(e) {
  "@babel/helpers - typeof";
  return Lo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
    return typeof A;
  } : function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, Lo(e);
}
function kA(e, A) {
  if (A.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + A.length + " present");
}
function HP(e) {
  return kA(1, arguments), e instanceof Date || Lo(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function zt(e) {
  kA(1, arguments);
  var A = Object.prototype.toString.call(e);
  return e instanceof Date || Lo(e) === "object" && A === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || A === "[object Number]" ? new Date(e) : ((typeof e == "string" || A === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function LP(e) {
  if (kA(1, arguments), !HP(e) && typeof e != "number")
    return !1;
  var A = zt(e);
  return !isNaN(Number(A));
}
function Fn(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var A = Number(e);
  return isNaN(A) ? A : A < 0 ? Math.ceil(A) : Math.floor(A);
}
function MP(e, A) {
  kA(2, arguments);
  var t = zt(e).getTime(), r = Fn(A);
  return new Date(t + r);
}
function RP(e, A) {
  kA(2, arguments);
  var t = Fn(A);
  return MP(e, -t);
}
var NP = 864e5;
function kP(e) {
  kA(1, arguments);
  var A = zt(e), t = A.getTime();
  A.setUTCMonth(0, 1), A.setUTCHours(0, 0, 0, 0);
  var r = A.getTime(), n = t - r;
  return Math.floor(n / NP) + 1;
}
function Mo(e) {
  kA(1, arguments);
  var A = 1, t = zt(e), r = t.getUTCDay(), n = (r < A ? 7 : 0) + r - A;
  return t.setUTCDate(t.getUTCDate() - n), t.setUTCHours(0, 0, 0, 0), t;
}
function Fx(e) {
  kA(1, arguments);
  var A = zt(e), t = A.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var n = Mo(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var i = Mo(a);
  return A.getTime() >= n.getTime() ? t + 1 : A.getTime() >= i.getTime() ? t : t - 1;
}
function PP(e) {
  kA(1, arguments);
  var A = Fx(e), t = /* @__PURE__ */ new Date(0);
  t.setUTCFullYear(A, 0, 4), t.setUTCHours(0, 0, 0, 0);
  var r = Mo(t);
  return r;
}
var KP = 6048e5;
function $P(e) {
  kA(1, arguments);
  var A = zt(e), t = Mo(A).getTime() - PP(A).getTime();
  return Math.round(t / KP) + 1;
}
var jP = {};
function Xu() {
  return jP;
}
function Ro(e, A) {
  var t, r, n, a, i, s, o, u;
  kA(1, arguments);
  var l = Xu(), c = Fn((t = (r = (n = (a = A == null ? void 0 : A.weekStartsOn) !== null && a !== void 0 ? a : A == null || (i = A.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && n !== void 0 ? n : l.weekStartsOn) !== null && r !== void 0 ? r : (o = l.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && t !== void 0 ? t : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = zt(e), d = f.getUTCDay(), h = (d < c ? 7 : 0) + d - c;
  return f.setUTCDate(f.getUTCDate() - h), f.setUTCHours(0, 0, 0, 0), f;
}
function bx(e, A) {
  var t, r, n, a, i, s, o, u;
  kA(1, arguments);
  var l = zt(e), c = l.getUTCFullYear(), f = Xu(), d = Fn((t = (r = (n = (a = A == null ? void 0 : A.firstWeekContainsDate) !== null && a !== void 0 ? a : A == null || (i = A.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (o = f.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && t !== void 0 ? t : 1);
  if (!(d >= 1 && d <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(c + 1, 0, d), h.setUTCHours(0, 0, 0, 0);
  var p = Ro(h, A), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(c, 0, d), v.setUTCHours(0, 0, 0, 0);
  var y = Ro(v, A);
  return l.getTime() >= p.getTime() ? c + 1 : l.getTime() >= y.getTime() ? c : c - 1;
}
function GP(e, A) {
  var t, r, n, a, i, s, o, u;
  kA(1, arguments);
  var l = Xu(), c = Fn((t = (r = (n = (a = A == null ? void 0 : A.firstWeekContainsDate) !== null && a !== void 0 ? a : A == null || (i = A.locale) === null || i === void 0 || (s = i.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && n !== void 0 ? n : l.firstWeekContainsDate) !== null && r !== void 0 ? r : (o = l.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && t !== void 0 ? t : 1), f = bx(e, A), d = /* @__PURE__ */ new Date(0);
  d.setUTCFullYear(f, 0, c), d.setUTCHours(0, 0, 0, 0);
  var h = Ro(d, A);
  return h;
}
var VP = 6048e5;
function WP(e, A) {
  kA(1, arguments);
  var t = zt(e), r = Ro(t, A).getTime() - GP(t, A).getTime();
  return Math.round(r / VP) + 1;
}
function Pe(e, A) {
  for (var t = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < A; )
    r = "0" + r;
  return t + r;
}
var YP = {
  // Year
  y: function(A, t) {
    var r = A.getUTCFullYear(), n = r > 0 ? r : 1 - r;
    return Pe(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M: function(A, t) {
    var r = A.getUTCMonth();
    return t === "M" ? String(r + 1) : Pe(r + 1, 2);
  },
  // Day of the month
  d: function(A, t) {
    return Pe(A.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(A, t) {
    var r = A.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(A, t) {
    return Pe(A.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(A, t) {
    return Pe(A.getUTCHours(), t.length);
  },
  // Minute
  m: function(A, t) {
    return Pe(A.getUTCMinutes(), t.length);
  },
  // Second
  s: function(A, t) {
    return Pe(A.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(A, t) {
    var r = t.length, n = A.getUTCMilliseconds(), a = Math.floor(n * Math.pow(10, r - 3));
    return Pe(a, t.length);
  }
};
const yr = YP;
var Wn = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, zP = {
  // Era
  G: function(A, t, r) {
    var n = A.getUTCFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(n, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(n, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(A, t, r) {
    if (t === "yo") {
      var n = A.getUTCFullYear(), a = n > 0 ? n : 1 - n;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return yr.y(A, t);
  },
  // Local week-numbering year
  Y: function(A, t, r, n) {
    var a = bx(A, n), i = a > 0 ? a : 1 - a;
    if (t === "YY") {
      var s = i % 100;
      return Pe(s, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, {
      unit: "year"
    }) : Pe(i, t.length);
  },
  // ISO week-numbering year
  R: function(A, t) {
    var r = Fx(A);
    return Pe(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(A, t) {
    var r = A.getUTCFullYear();
    return Pe(r, t.length);
  },
  // Quarter
  Q: function(A, t, r) {
    var n = Math.ceil((A.getUTCMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return Pe(n, 2);
      case "Qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(A, t, r) {
    var n = Math.ceil((A.getUTCMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return Pe(n, 2);
      case "qo":
        return r.ordinalNumber(n, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(A, t, r) {
    var n = A.getUTCMonth();
    switch (t) {
      case "M":
      case "MM":
        return yr.M(A, t);
      case "Mo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(A, t, r) {
    var n = A.getUTCMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return Pe(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(A, t, r, n) {
    var a = WP(A, n);
    return t === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : Pe(a, t.length);
  },
  // ISO week of year
  I: function(A, t, r) {
    var n = $P(A);
    return t === "Io" ? r.ordinalNumber(n, {
      unit: "week"
    }) : Pe(n, t.length);
  },
  // Day of the month
  d: function(A, t, r) {
    return t === "do" ? r.ordinalNumber(A.getUTCDate(), {
      unit: "date"
    }) : yr.d(A, t);
  },
  // Day of year
  D: function(A, t, r) {
    var n = kP(A);
    return t === "Do" ? r.ordinalNumber(n, {
      unit: "dayOfYear"
    }) : Pe(n, t.length);
  },
  // Day of week
  E: function(A, t, r) {
    var n = A.getUTCDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(A, t, r, n) {
    var a = A.getUTCDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(i);
      case "ee":
        return Pe(i, 2);
      case "eo":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(A, t, r, n) {
    var a = A.getUTCDay(), i = (a - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(i);
      case "cc":
        return Pe(i, t.length);
      case "co":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(A, t, r) {
    var n = A.getUTCDay(), a = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(a);
      case "ii":
        return Pe(a, t.length);
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(A, t, r) {
    var n = A.getUTCHours(), a = n / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(A, t, r) {
    var n = A.getUTCHours(), a;
    switch (n === 12 ? a = Wn.noon : n === 0 ? a = Wn.midnight : a = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(A, t, r) {
    var n = A.getUTCHours(), a;
    switch (n >= 17 ? a = Wn.evening : n >= 12 ? a = Wn.afternoon : n >= 4 ? a = Wn.morning : a = Wn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(A, t, r) {
    if (t === "ho") {
      var n = A.getUTCHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, {
        unit: "hour"
      });
    }
    return yr.h(A, t);
  },
  // Hour [0-23]
  H: function(A, t, r) {
    return t === "Ho" ? r.ordinalNumber(A.getUTCHours(), {
      unit: "hour"
    }) : yr.H(A, t);
  },
  // Hour [0-11]
  K: function(A, t, r) {
    var n = A.getUTCHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, {
      unit: "hour"
    }) : Pe(n, t.length);
  },
  // Hour [1-24]
  k: function(A, t, r) {
    var n = A.getUTCHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, {
      unit: "hour"
    }) : Pe(n, t.length);
  },
  // Minute
  m: function(A, t, r) {
    return t === "mo" ? r.ordinalNumber(A.getUTCMinutes(), {
      unit: "minute"
    }) : yr.m(A, t);
  },
  // Second
  s: function(A, t, r) {
    return t === "so" ? r.ordinalNumber(A.getUTCSeconds(), {
      unit: "second"
    }) : yr.s(A, t);
  },
  // Fraction of second
  S: function(A, t) {
    return yr.S(A, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(A, t, r, n) {
    var a = n._originalDate || A, i = a.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (t) {
      case "X":
        return vB(i);
      case "XXXX":
      case "XX":
        return tn(i);
      case "XXXXX":
      case "XXX":
      default:
        return tn(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(A, t, r, n) {
    var a = n._originalDate || A, i = a.getTimezoneOffset();
    switch (t) {
      case "x":
        return vB(i);
      case "xxxx":
      case "xx":
        return tn(i);
      case "xxxxx":
      case "xxx":
      default:
        return tn(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(A, t, r, n) {
    var a = n._originalDate || A, i = a.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + BB(i, ":");
      case "OOOO":
      default:
        return "GMT" + tn(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(A, t, r, n) {
    var a = n._originalDate || A, i = a.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + BB(i, ":");
      case "zzzz":
      default:
        return "GMT" + tn(i, ":");
    }
  },
  // Seconds timestamp
  t: function(A, t, r, n) {
    var a = n._originalDate || A, i = Math.floor(a.getTime() / 1e3);
    return Pe(i, t.length);
  },
  // Milliseconds timestamp
  T: function(A, t, r, n) {
    var a = n._originalDate || A, i = a.getTime();
    return Pe(i, t.length);
  }
};
function BB(e, A) {
  var t = e > 0 ? "-" : "+", r = Math.abs(e), n = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return t + String(n);
  var i = A || "";
  return t + String(n) + i + Pe(a, 2);
}
function vB(e, A) {
  if (e % 60 === 0) {
    var t = e > 0 ? "-" : "+";
    return t + Pe(Math.abs(e) / 60, 2);
  }
  return tn(e, A);
}
function tn(e, A) {
  var t = A || "", r = e > 0 ? "-" : "+", n = Math.abs(e), a = Pe(Math.floor(n / 60), 2), i = Pe(n % 60, 2);
  return r + a + t + i;
}
const XP = zP;
var mB = function(A, t) {
  switch (A) {
    case "P":
      return t.date({
        width: "short"
      });
    case "PP":
      return t.date({
        width: "medium"
      });
    case "PPP":
      return t.date({
        width: "long"
      });
    case "PPPP":
    default:
      return t.date({
        width: "full"
      });
  }
}, Sx = function(A, t) {
  switch (A) {
    case "p":
      return t.time({
        width: "short"
      });
    case "pp":
      return t.time({
        width: "medium"
      });
    case "ppp":
      return t.time({
        width: "long"
      });
    case "pppp":
    default:
      return t.time({
        width: "full"
      });
  }
}, qP = function(A, t) {
  var r = A.match(/(P+)(p+)?/) || [], n = r[1], a = r[2];
  if (!a)
    return mB(A, t);
  var i;
  switch (n) {
    case "P":
      i = t.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = t.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = t.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = t.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", mB(n, t)).replace("{{time}}", Sx(a, t));
}, JP = {
  p: Sx,
  P: qP
};
const ZP = JP;
function e5(e) {
  var A = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return A.setUTCFullYear(e.getFullYear()), e.getTime() - A.getTime();
}
var A5 = ["D", "DD"], t5 = ["YY", "YYYY"];
function r5(e) {
  return A5.indexOf(e) !== -1;
}
function n5(e) {
  return t5.indexOf(e) !== -1;
}
function wB(e, A, t) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(A, "`) for formatting years to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(A, "`) for formatting years to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(A, "`) for formatting days of the month to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(A, "`) for formatting days of the month to the input `").concat(t, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var a5 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, i5 = function(A, t, r) {
  var n, a = a5[A];
  return typeof a == "string" ? n = a : t === 1 ? n = a.one : n = a.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
const s5 = i5;
function Lc(e) {
  return function() {
    var A = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = A.width ? String(A.width) : e.defaultWidth, r = e.formats[t] || e.formats[e.defaultWidth];
    return r;
  };
}
var o5 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, u5 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, l5 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, c5 = {
  date: Lc({
    formats: o5,
    defaultWidth: "full"
  }),
  time: Lc({
    formats: u5,
    defaultWidth: "full"
  }),
  dateTime: Lc({
    formats: l5,
    defaultWidth: "full"
  })
};
const f5 = c5;
var d5 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, h5 = function(A, t, r, n) {
  return d5[A];
};
const p5 = h5;
function $a(e) {
  return function(A, t) {
    var r = t != null && t.context ? String(t.context) : "standalone", n;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, i = t != null && t.width ? String(t.width) : a;
      n = e.formattingValues[i] || e.formattingValues[a];
    } else {
      var s = e.defaultWidth, o = t != null && t.width ? String(t.width) : e.defaultWidth;
      n = e.values[o] || e.values[s];
    }
    var u = e.argumentCallback ? e.argumentCallback(A) : A;
    return n[u];
  };
}
var g5 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, B5 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, v5 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, m5 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, w5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, y5 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, x5 = function(A, t) {
  var r = Number(A), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, C5 = {
  ordinalNumber: x5,
  era: $a({
    values: g5,
    defaultWidth: "wide"
  }),
  quarter: $a({
    values: B5,
    defaultWidth: "wide",
    argumentCallback: function(A) {
      return A - 1;
    }
  }),
  month: $a({
    values: v5,
    defaultWidth: "wide"
  }),
  day: $a({
    values: m5,
    defaultWidth: "wide"
  }),
  dayPeriod: $a({
    values: w5,
    defaultWidth: "wide",
    formattingValues: y5,
    defaultFormattingWidth: "wide"
  })
};
const E5 = C5;
function ja(e) {
  return function(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.width, n = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = A.match(n);
    if (!a)
      return null;
    var i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], o = Array.isArray(s) ? b5(s, function(c) {
      return c.test(i);
    }) : F5(s, function(c) {
      return c.test(i);
    }), u;
    u = e.valueCallback ? e.valueCallback(o) : o, u = t.valueCallback ? t.valueCallback(u) : u;
    var l = A.slice(i.length);
    return {
      value: u,
      rest: l
    };
  };
}
function F5(e, A) {
  for (var t in e)
    if (e.hasOwnProperty(t) && A(e[t]))
      return t;
}
function b5(e, A) {
  for (var t = 0; t < e.length; t++)
    if (A(e[t]))
      return t;
}
function S5(e) {
  return function(A) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = A.match(e.matchPattern);
    if (!r)
      return null;
    var n = r[0], a = A.match(e.parsePattern);
    if (!a)
      return null;
    var i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    var s = A.slice(n.length);
    return {
      value: i,
      rest: s
    };
  };
}
var U5 = /^(\d+)(th|st|nd|rd)?/i, _5 = /\d+/i, Q5 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, I5 = {
  any: [/^b/i, /^(a|c)/i]
}, D5 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, T5 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, O5 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, H5 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, L5 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, M5 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, R5 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, N5 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, k5 = {
  ordinalNumber: S5({
    matchPattern: U5,
    parsePattern: _5,
    valueCallback: function(A) {
      return parseInt(A, 10);
    }
  }),
  era: ja({
    matchPatterns: Q5,
    defaultMatchWidth: "wide",
    parsePatterns: I5,
    defaultParseWidth: "any"
  }),
  quarter: ja({
    matchPatterns: D5,
    defaultMatchWidth: "wide",
    parsePatterns: T5,
    defaultParseWidth: "any",
    valueCallback: function(A) {
      return A + 1;
    }
  }),
  month: ja({
    matchPatterns: O5,
    defaultMatchWidth: "wide",
    parsePatterns: H5,
    defaultParseWidth: "any"
  }),
  day: ja({
    matchPatterns: L5,
    defaultMatchWidth: "wide",
    parsePatterns: M5,
    defaultParseWidth: "any"
  }),
  dayPeriod: ja({
    matchPatterns: R5,
    defaultMatchWidth: "any",
    parsePatterns: N5,
    defaultParseWidth: "any"
  })
};
const P5 = k5;
var K5 = {
  code: "en-US",
  formatDistance: s5,
  formatLong: f5,
  formatRelative: p5,
  localize: E5,
  match: P5,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const $5 = K5;
var j5 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, G5 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, V5 = /^'([^]*?)'?$/, W5 = /''/g, Y5 = /[a-zA-Z]/;
function z5(e, A, t) {
  var r, n, a, i, s, o, u, l, c, f, d, h, p, v, y, g, B, w;
  kA(2, arguments);
  var m = String(A), x = Xu(), C = (r = (n = t == null ? void 0 : t.locale) !== null && n !== void 0 ? n : x.locale) !== null && r !== void 0 ? r : $5, E = Fn((a = (i = (s = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (u = t.locale) === null || u === void 0 || (l = u.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && s !== void 0 ? s : x.firstWeekContainsDate) !== null && i !== void 0 ? i : (c = x.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(E >= 1 && E <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = Fn((d = (h = (p = (v = t == null ? void 0 : t.weekStartsOn) !== null && v !== void 0 ? v : t == null || (y = t.locale) === null || y === void 0 || (g = y.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && p !== void 0 ? p : x.weekStartsOn) !== null && h !== void 0 ? h : (B = x.locale) === null || B === void 0 || (w = B.options) === null || w === void 0 ? void 0 : w.weekStartsOn) !== null && d !== void 0 ? d : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!C.localize)
    throw new RangeError("locale must contain localize property");
  if (!C.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var S = zt(e);
  if (!LP(S))
    throw new RangeError("Invalid time value");
  var b = e5(S), N = RP(S, b), O = {
    firstWeekContainsDate: E,
    weekStartsOn: T,
    locale: C,
    _originalDate: S
  }, V = m.match(G5).map(function(I) {
    var _ = I[0];
    if (_ === "p" || _ === "P") {
      var K = ZP[_];
      return K(I, C.formatLong);
    }
    return I;
  }).join("").match(j5).map(function(I) {
    if (I === "''")
      return "'";
    var _ = I[0];
    if (_ === "'")
      return X5(I);
    var K = XP[_];
    if (K)
      return !(t != null && t.useAdditionalWeekYearTokens) && n5(I) && wB(I, A, String(e)), !(t != null && t.useAdditionalDayOfYearTokens) && r5(I) && wB(I, A, String(e)), K(N, I, C.localize, O);
    if (_.match(Y5))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + _ + "`");
    return I;
  }).join("");
  return V;
}
function X5(e) {
  var A = e.match(V5);
  return A ? A[1].replace(W5, "'") : e;
}
const q5 = ({
  notificationsCount: e,
  notifications: A,
  ...t
}) => {
  var s;
  const { data: r } = yt(), { theme: n } = r, { colors: a } = n, { language: i } = fu();
  return /* @__PURE__ */ F.jsx(
    ye,
    {
      id: "myasurion-notifications-display",
      zIndex: 999998,
      pos: "fixed",
      top: 0,
      left: 0,
      bg: "#fff",
      w: "full",
      h: "100dvh",
      m: 0,
      p: 0,
      border: "none",
      color: "black",
      overflowY: "auto",
      ...t,
      children: /* @__PURE__ */ F.jsxs(
        pn,
        {
          gap: 0,
          spacing: 0,
          w: "full",
          alignItems: "baseline",
          id: "myasurion-notifications-display-stack",
          maxW: { base: "initial", lg: "768px", xl: "992px", "2xl": "1280px" },
          mx: "auto",
          pt: { md: 8 },
          children: [
            /* @__PURE__ */ F.jsx(ye, { w: "full", px: "16px", py: "16px", children: /* @__PURE__ */ F.jsxs(Cn, { gap: 6, children: [
              /* @__PURE__ */ F.jsx(ye, { children: /* @__PURE__ */ F.jsxs(pn, { alignItems: "baseline", gap: 1, children: [
                /* @__PURE__ */ F.jsx(
                  EA,
                  {
                    fontSize: "2xl",
                    fontWeight: 400,
                    lineHeight: "132%",
                    fontStyle: "normal",
                    children: /* @__PURE__ */ F.jsx(
                      QA,
                      {
                        translationKey: "Global/Notifications",
                        text: "notifications"
                      }
                    )
                  }
                ),
                A && Array.isArray(A) && /* @__PURE__ */ F.jsxs(
                  EA,
                  {
                    fontSize: "md",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "124%",
                    color: "#6E767D",
                    children: [
                      i === "th-TH" ? "ล่าสุดวันที่" : "Last",
                      " ",
                      new Date(
                        (s = A[0]) == null ? void 0 : s.NotificationDate
                      ).toLocaleString("en-US", {
                        month: "short",
                        day: "numeric",
                        year: "numeric"
                      })
                    ]
                  }
                )
              ] }) }),
              /* @__PURE__ */ F.jsx(ef, {})
            ] }) }),
            A && Array.isArray(A) && (A == null ? void 0 : A.map((o, u) => /* @__PURE__ */ F.jsx(ye, { w: "full", px: "16px", children: /* @__PURE__ */ F.jsxs(
              _t,
              {
                alignSelf: "stretch",
                padding: "12px 0px 20px",
                direction: "column",
                borderBottom: "1px solid #D5D6DA",
                gap: "8px",
                children: [
                  /* @__PURE__ */ F.jsx(
                    EA,
                    {
                      fontSize: "18px",
                      fontWeight: 700,
                      lineHeight: "132%",
                      color: (o == null ? void 0 : o.IsResolved) === "N" ? a.primary : "black",
                      children: i === "th-TH" ? (o == null ? void 0 : o.ServiceRequestEventDescTl) ?? (o == null ? void 0 : o.ServiceRequestEventDesc) : o == null ? void 0 : o.ServiceRequestEventDesc
                    }
                  ),
                  /* @__PURE__ */ F.jsx(
                    EA,
                    {
                      fontSize: "md",
                      fontWeight: (o == null ? void 0 : o.IsResolved) === "N" ? 700 : 400,
                      lineHeight: "124%",
                      fontStyle: "normal",
                      children: i === "th-TH" ? o == null ? void 0 : o.NotificationBodyTL : o == null ? void 0 : o.NotificationBody
                    }
                  ),
                  /* @__PURE__ */ F.jsx(
                    EA,
                    {
                      fontSize: "sm",
                      fontStyle: "normal",
                      lineHeight: "136%",
                      fontWeight: 400,
                      color: "#6E767D",
                      children: z5(new Date(o == null ? void 0 : o.EventDate), "d MMMM yyyy h:mm aaa")
                    }
                  )
                ]
              }
            ) }, `notifs-${o == null ? void 0 : o.AgreementId}-${u}`))),
            (!A || !Array.isArray(A) || (A == null ? void 0 : A.length) === 0) && /* @__PURE__ */ F.jsx(ye, { w: "full", px: "16px", children: /* @__PURE__ */ F.jsx(
              _t,
              {
                alignSelf: "stretch",
                padding: "12px 0px 20px",
                direction: "column",
                gap: "8px",
                children: /* @__PURE__ */ F.jsx(
                  EA,
                  {
                    fontSize: "18px",
                    fontWeight: 700,
                    lineHeight: "132%",
                    color: a.primary,
                    children: "No Pending Notifications"
                  }
                )
              }
            ) })
          ]
        }
      )
    }
  );
}, J5 = ({
  account: e,
  children: A,
  headerMenu: t,
  authenticated: r,
  showBack: n,
  showBackText: a,
  onToggleMenu: i,
  onToggleNotifications: s,
  onClickBack: o,
  languageSelectorProps: u,
  signOutProps: l,
  serviceRequestButtonProps: c,
  ...f
}) => {
  var H;
  const [d, h] = gU(), [p, v] = Ue(void 0), { data: y } = yt(), { theme: g } = y, { header: B, favicon: w } = g, { updateHeaderIsOpen: m, headerIsOpen: x, updateNoficationsIsOpen: C, notificationsIsOpen: E } = sm(), T = vF("notifications"), { notifications: S, isNotificationsLoading: b, promptCount: N } = K1(), { chatConfig: O, firebaseConfig: V } = mP(), I = {
    spaceIdRef: O == null ? void 0 : O.contentful.space,
    accessTokenRef: O == null ? void 0 : O.contentful.token,
    environmentRef: O == null ? void 0 : O.contentful.env,
    firebaseConfig: V
  }, { imageUrl: _, isLoading: K } = BU(
    B.logoSlug,
    I == null ? void 0 : I.spaceIdRef,
    I == null ? void 0 : I.accessTokenRef,
    I == null ? void 0 : I.environmentRef,
    I == null ? void 0 : I.firebaseConfig
  ), Y = _e(
    (D) => {
      m(D !== void 0 ? D : (Q) => (i && i(!Q), !Q)), C(!1), window.scrollTo(0, 0);
    },
    [x]
  ), X = _e(
    (D) => {
      C(D !== void 0 ? D : (Q) => (s && s(!Q), !Q)), m(!1), window.scrollTo(0, 0);
    },
    [E]
  ), R = _e(() => {
    C(!1), window.location.href = "/profile";
  }, []), U = _e((D) => {
    u != null && u.onSelect && (u == null || u.onSelect(D));
  }, []);
  return w && ((H = document.getElementById("favicon")) == null || H.setAttribute("href", w)), Re(() => {
    K || v(_ ?? void 0);
  }, [K, _]), Re(() => {
    x || E ? d() : h();
  }, [x, E]), /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
    /* @__PURE__ */ F.jsx(
      ta,
      {
        id: "myasurion-header",
        pos: "fixed",
        h: "56px",
        top: 0,
        left: 0,
        w: "full",
        p: "10px 16px",
        bg: B.bg || "white",
        zIndex: 999999,
        boxShadow: "0px 4px 8px 0px #00000014, 0px 1px 0px 0px #00000029 inset",
        ...f,
        children: n ? /* @__PURE__ */ F.jsx(ta, { alignItems: "end", w: "full", p: "8px 16px 4px 16px", children: /* @__PURE__ */ F.jsx(
          Sn,
          {
            variant: "link",
            colorScheme: "black",
            onClick: () => {
              o && o();
            },
            leftIcon: /* @__PURE__ */ F.jsx(_E, {}),
            children: /* @__PURE__ */ F.jsx(EA, { children: a || "Back" })
          }
        ) }) : /* @__PURE__ */ F.jsxs(ta, { alignItems: "end", w: "full", children: [
          A && A,
          !A && /* @__PURE__ */ F.jsxs(Cn, { h: "36px", justifyContent: "space-between", children: [
            /* @__PURE__ */ F.jsx(ta, { children: /* @__PURE__ */ F.jsx(
              Gs,
              {
                href: JE(),
                _hover: { textDecoration: "none", cursor: "pointer" },
                children: K ? /* @__PURE__ */ F.jsx(b0, {}) : /* @__PURE__ */ F.jsx(
                  Xo,
                  {
                    src: p ?? B.logo,
                    alt: "header logo",
                    maxH: "36px"
                  }
                )
              }
            ) }),
            /* @__PURE__ */ F.jsxs(Cn, { gap: 4, children: [
              /* @__PURE__ */ F.jsx(
                _P,
                {
                  boxProps: u == null ? void 0 : u.boxProps,
                  linkProps: u == null ? void 0 : u.linkProps,
                  onSelect: U
                }
              ),
              r && t ? t : /* @__PURE__ */ F.jsx(F.Fragment, {}),
              r && T && /* @__PURE__ */ F.jsx(
                OP,
                {
                  onToggle: X,
                  isLoading: b,
                  promptCount: N
                }
              ),
              r && !t ? /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
                /* @__PURE__ */ F.jsx(qf, { children: /* @__PURE__ */ F.jsx(gB, { onToggle: Y }) }),
                /* @__PURE__ */ F.jsx(Rd, { children: /* @__PURE__ */ F.jsx(gB, { onToggle: R }) })
              ] }) : /* @__PURE__ */ F.jsx(F.Fragment, {})
            ] })
          ] })
        ] })
      }
    ),
    x && /* @__PURE__ */ F.jsx(
      DP,
      {
        pt: "50px",
        firstname: (e == null ? void 0 : e.firstName) || "",
        lastname: (e == null ? void 0 : e.lastName) || "",
        signOutProps: {
          label: (l == null ? void 0 : l.label) && l.label,
          onSignOut: () => {
            Y(!1), l != null && l.onSignOut && (l == null || l.onSignOut());
          }
        },
        serviceRequestButtonProps: {
          enabled: c && c.enabled || !1,
          label: (c == null ? void 0 : c.label) && c.label,
          onClick: () => {
            Y(!1), c != null && c.onClick && (c == null || c.onClick());
          }
        }
      }
    ),
    T && E && /* @__PURE__ */ F.jsx(
      q5,
      {
        pt: "50px",
        notifications: S,
        isLoading: b
      }
    )
  ] });
}, Z5 = "/images/carriers/asurion/expert-group.png", Tt = {
  title: "Need help?",
  heading: "Hey 👋 I’m Anna, your Tech specialist.",
  subheading: "Our team is here to help!",
  searchTitle: "You might be searching for this...",
  keywords: ["Like for Like", "Service request fee", "Storage Capacity", "Wipe my Phone"]
}, WAe = ({
  title: e = Tt.title,
  heading: A,
  subheading: t,
  searchTitle: r,
  keywords: n = Tt.keywords,
  images: a,
  doAnimate: i = !1,
  expertGroupImage: s,
  ...o
}) => /* @__PURE__ */ F.jsx(
  ye,
  {
    id: "myasurion-customer-support-footer",
    w: "100%",
    h: { base: "409", md: "190px" },
    m: "0",
    minW: "320px",
    p: 0,
    bg: "#F0F0F5",
    zIndex: 15,
    ...o,
    children: /* @__PURE__ */ F.jsxs(
      ye,
      {
        id: "footer-container",
        display: "flex",
        flexFlow: "column nowrap",
        alignItems: "flex-start",
        w: "100%",
        children: [
          /* @__PURE__ */ F.jsx(
            tK,
            {
              title: e,
              heading: A,
              subheading: t,
              searchTitle: r,
              keywords: n,
              images: a,
              doAnimate: i,
              expertGroupImage: s,
              ...o
            }
          ),
          /* @__PURE__ */ F.jsx(
            AK,
            {
              title: e,
              heading: A,
              subheading: t,
              searchTitle: r,
              keywords: n,
              images: a,
              doAnimate: i,
              expertGroupImage: s,
              ...o
            }
          )
        ]
      }
    )
  }
), eK = RE`
    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
    50% {opacity: 1.0;}
    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
`, AK = ({
  heading: e,
  subheading: A,
  images: t,
  onSendQuestion: r
}) => {
  const [n, a] = Ue(""), [i] = am("al", ""), s = "CustomerSupportFooter", o = "Global", u = (c) => {
    c.code === "Enter" && n.trim().length > 0 && (r == null || r(n), a(""));
  }, l = () => {
    n && (r == null || r(n), a(""));
  };
  return /* @__PURE__ */ F.jsx(Rd, { children: /* @__PURE__ */ F.jsx(Wv, { w: "full", children: /* @__PURE__ */ F.jsxs(
    Cn,
    {
      h: "full",
      maxW: "800px",
      w: "full",
      justifyContent: "center",
      gap: "20px",
      mt: "47px",
      children: [
        /* @__PURE__ */ F.jsx(ye, { w: "96px", h: "96px", display: "flex", alignItems: "center", children: t == null ? void 0 : t.map((c, f) => c.view === "desktop" ? /* @__PURE__ */ F.jsx(
          Xo,
          {
            src: c.url,
            alt: "expert img",
            w: "96px",
            h: "96px"
          },
          `img-desktop-footer-${f}`
        ) : /* @__PURE__ */ F.jsx(F.Fragment, {})) }),
        /* @__PURE__ */ F.jsxs(ye, { w: "300px", children: [
          /* @__PURE__ */ F.jsx(EA, { fontWeight: 400, fontSize: "2xl", color: "black", m: 0, children: /* @__PURE__ */ F.jsx(
            QA,
            {
              text: e || Tt.heading,
              translationKey: `${o}/${s}_heading`
            }
          ) }),
          /* @__PURE__ */ F.jsx(EA, { fontWeight: 700, fontSize: "lg", color: "black", m: 0, children: /* @__PURE__ */ F.jsx(
            QA,
            {
              text: A || Tt.subheading,
              translationKey: `${o}/${s}_subheading`
            }
          ) })
        ] }),
        /* @__PURE__ */ F.jsx(ye, { w: "430px", children: /* @__PURE__ */ F.jsxs(S0, { children: [
          /* @__PURE__ */ F.jsx(
            zo,
            {
              placeholder: (
                // hardcode this for now hopefully just now
                i === "zh-Hant-TW" ? "我想知道…" : i === "th-TH" ? "พิมพ์ข้อความ" : "I need help with..."
              ),
              outline: "2px solid transparent",
              w: "100%",
              h: "56px",
              "outline-offset": "2px",
              pos: "relative",
              appearance: "none",
              backgroundColor: "#fff",
              border: "1px solid #000",
              color: "rgb(26, 32, 44)",
              cursor: "text",
              boxSizing: "border-box",
              padding: "0 40px 0 16px",
              borderRadius: "6px",
              fontSize: "16px",
              value: n,
              onChange: ({ target: c }) => a(c.value),
              onKeyDown: u
            }
          ),
          /* @__PURE__ */ F.jsx(qv, { cursor: "pointer", w: "40px", h: "40px", zIndex: "2", children: /* @__PURE__ */ F.jsx(
            jv,
            {
              stroke: "black",
              fill: "black",
              color: "black",
              onClick: l
            }
          ) })
        ] }) })
      ]
    }
  ) }) });
}, tK = ({
  title: e = Tt.title,
  heading: A,
  subheading: t,
  searchTitle: r,
  keywords: n = Tt.keywords,
  images: a,
  doAnimate: i = !1,
  expertGroupImage: s,
  onSendQuestion: o,
  onClickKeyword: u
}) => {
  const [l, c] = Ue(""), f = wF("portal", "stnFooterKeywords"), d = "CustomerSupportFooter", h = "Global", { language: p } = fu(), v = (B) => {
    B.code === "Enter" && l.trim().length > 0 && (o == null || o(l), c(""));
  }, y = () => {
    l && (o == null || o(l), c(""));
  }, g = qo();
  return /* @__PURE__ */ F.jsx(qf, { children: /* @__PURE__ */ F.jsxs(
    _t,
    {
      id: "experts-chat-container",
      padding: "24px 16px",
      flexFlow: "column nowrap",
      alignItems: "flex-start",
      gap: "8px",
      alignSelf: "stretch",
      background: "#F0F0F5",
      children: [
        /* @__PURE__ */ F.jsx(
          _t,
          {
            id: "footer-title",
            alignItems: "flex-start",
            gap: "8px",
            alignSelf: "stretch",
            height: "32px",
            children: /* @__PURE__ */ F.jsx(Jv, { as: "h2", fontSize: "2xl", fontWeight: "normal", lineHeight: "8", m: 0, children: /* @__PURE__ */ F.jsx(EA, { color: "black", m: 0, children: /* @__PURE__ */ F.jsx(
              QA,
              {
                text: e || Tt.title || "Need help?",
                translationKey: `${h}/${d}_title`
              }
            ) }) })
          }
        ),
        /* @__PURE__ */ F.jsxs(
          _t,
          {
            id: "footer-expert-search",
            flexFlow: "column nowrap",
            alignItems: "center",
            gap: "16px",
            alignSelf: "stretch",
            children: [
              /* @__PURE__ */ F.jsxs(
                ye,
                {
                  id: "footer-expert-search-expert-container",
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  gap: "8px",
                  alignSelf: "stretch",
                  children: [
                    /* @__PURE__ */ F.jsx(
                      ye,
                      {
                        id: "expert-images",
                        display: "flex",
                        flexFlow: "column nowrap",
                        alignItems: "center",
                        alignSelf: "stretch",
                        children: /* @__PURE__ */ F.jsx(
                          ye,
                          {
                            id: "expert-images-content",
                            display: "flex",
                            padding: "0px 16px",
                            flexFlow: "column nowrap",
                            alignItems: "flex-start",
                            gap: "16px",
                            children: /* @__PURE__ */ F.jsx(qf, { children: /* @__PURE__ */ F.jsx(ye, { id: "expert-images-group", children: /* @__PURE__ */ F.jsx(
                              _t,
                              {
                                flexFlow: "row nowrap",
                                position: "relative",
                                gap: "42px",
                                alignItems: "center",
                                justifyContent: "center",
                                height: "96px",
                                children: a && !s ? a.map((B) => {
                                  if (B.view === "mobile")
                                    return /* @__PURE__ */ F.jsx(
                                      rK,
                                      {
                                        img: B.url,
                                        position: B.position,
                                        doAnimate: i
                                      },
                                      B.position
                                    );
                                }) : /* @__PURE__ */ F.jsx(
                                  Xo,
                                  {
                                    src: s ?? `${g === "repair" ? "/portal" : ""}${Z5}`,
                                    alt: "expert group"
                                  }
                                )
                              }
                            ) }) })
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ F.jsxs(_t, { flexFlow: "column", children: [
                      /* @__PURE__ */ F.jsx(
                        EA,
                        {
                          align: "center",
                          fontWeight: "light",
                          fontSize: "lg",
                          color: "black",
                          m: 0,
                          children: /* @__PURE__ */ F.jsx(
                            QA,
                            {
                              text: A || Tt.heading,
                              translationKey: `${h}/${d}_heading`
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ F.jsx(
                        EA,
                        {
                          align: "center",
                          fontWeight: "bold",
                          fontSize: "lg",
                          color: "black",
                          m: 0,
                          children: /* @__PURE__ */ F.jsx(
                            QA,
                            {
                              text: t || Tt.subheading,
                              translationKey: `${h}/${d}_subheading`
                            }
                          )
                        }
                      )
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ F.jsxs(S0, { children: [
                /* @__PURE__ */ F.jsx(
                  zo,
                  {
                    placeholder: (
                      // hardcode this for now hopefully just now
                      p === "zh-Hant-TW" ? "我想知道…" : p === "th-TH" ? "พิมพ์ข้อความ" : "I need help with..."
                    ),
                    outline: "2px solid transparent",
                    w: "100%",
                    "outline-offset": "2px",
                    pos: "relative",
                    appearance: "none",
                    backgroundColor: "#fff",
                    borderColor: "inherit",
                    border: "2px solid #A5AAAF",
                    color: "rgb(26, 32, 44)",
                    cursor: "text",
                    boxSizing: "border-box",
                    padding: "0 40px 0 16px",
                    height: "40px",
                    borderRadius: "6px",
                    fontSize: "16px",
                    value: l,
                    onChange: ({ target: B }) => c(B.value),
                    onKeyDown: v
                  }
                ),
                /* @__PURE__ */ F.jsx(qv, { w: "40px", h: "40px", zIndex: "2", cursor: "pointer", children: /* @__PURE__ */ F.jsx(
                  jv,
                  {
                    stroke: "black",
                    fill: "black",
                    color: "black",
                    onClick: y
                  }
                ) })
              ] }),
              !f && /* @__PURE__ */ F.jsxs(
                ye,
                {
                  display: "flex",
                  flexFlow: "column nowrap",
                  alignItems: "center",
                  gap: "8px",
                  alignSelf: "stretch",
                  children: [
                    /* @__PURE__ */ F.jsx(_t, { id: "keywords-title", alignItems: "flex-start", alignSelf: "stretch", children: /* @__PURE__ */ F.jsx(
                      EA,
                      {
                        color: "#111111",
                        fontSize: "md",
                        fontWeight: "bold",
                        lineHeight: "124%",
                        children: /* @__PURE__ */ F.jsx(
                          QA,
                          {
                            text: r || Tt.searchTitle,
                            translationKey: `${h}/${d}_searchTitle`
                          }
                        )
                      }
                    ) }),
                    /* @__PURE__ */ F.jsx(_t, { id: "keywords", flexFlow: "row wrap", gap: "16px", children: n.map((B) => /* @__PURE__ */ F.jsx(
                      EA,
                      {
                        fontSize: "md",
                        fontWeight: "normal",
                        textDecorationLine: "underline",
                        lineHeight: "124%",
                        textAlign: "center",
                        cursor: "pointer",
                        m: 0,
                        color: "#000",
                        onClick: () => u == null ? void 0 : u(B),
                        children: /* @__PURE__ */ F.jsx(
                          QA,
                          {
                            text: B,
                            translationKey: `${h}/${d}_keyword-${B}`
                          }
                        )
                      },
                      B
                    )) })
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  ) });
}, rK = ({
  img: e,
  position: A,
  doAnimate: t
}) => /* @__PURE__ */ F.jsx(
  _t,
  {
    width: A === "middle" ? "96px" : "64px",
    height: A === "middle" ? "96px" : "64px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: "0",
    position: A === "middle" ? "absolute" : "initial",
    zIndex: A === "middle" ? 2 : 1,
    borderRadius: "50%",
    children: /* @__PURE__ */ F.jsxs(ye, { pos: "relative", children: [
      A === "middle" && /* @__PURE__ */ F.jsxs(F.Fragment, { children: [
        t && /* @__PURE__ */ F.jsx(
          ye,
          {
            border: "3px solid #008662",
            h: "25px",
            w: "25px",
            pos: "absolute",
            borderRadius: "30px",
            left: "8px",
            top: "0px",
            opacity: "0.0",
            animation: `${eK} 1s ease-out infinite`,
            as: oF.div,
            zIndex: "2"
          }
        ),
        /* @__PURE__ */ F.jsx(
          Vs,
          {
            backgroundColor: "#008662",
            pos: "absolute",
            size: "15px",
            top: "5px",
            left: "13px",
            zIndex: "2"
          }
        )
      ] }),
      /* @__PURE__ */ F.jsxs(Vs, { size: A === "middle" ? "96px" : "64px", pos: "relative", children: [
        /* @__PURE__ */ F.jsx(
          Xo,
          {
            src: e,
            alt: "expert img",
            borderRadius: "64px",
            width: A === "middle" ? "96px" : "64px",
            height: A === "middle" ? "96px" : "64px",
            flexShrink: "0"
          }
        ),
        A === "middle" && /* @__PURE__ */ F.jsx(
          Vs,
          {
            size: "88px",
            pos: "absolute",
            "aria-roledescription": "circular border for middle expert",
            border: "4px solid white",
            zIndex: "1"
          }
        )
      ] })
    ] })
  }
);
var Ux = { exports: {} }, cA = Ux.exports = {}, Qt, It;
function Jf() {
  throw new Error("setTimeout has not been defined");
}
function Zf() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Qt = setTimeout : Qt = Jf;
  } catch {
    Qt = Jf;
  }
  try {
    typeof clearTimeout == "function" ? It = clearTimeout : It = Zf;
  } catch {
    It = Zf;
  }
})();
function _x(e) {
  if (Qt === setTimeout)
    return setTimeout(e, 0);
  if ((Qt === Jf || !Qt) && setTimeout)
    return Qt = setTimeout, setTimeout(e, 0);
  try {
    return Qt(e, 0);
  } catch {
    try {
      return Qt.call(null, e, 0);
    } catch {
      return Qt.call(this, e, 0);
    }
  }
}
function nK(e) {
  if (It === clearTimeout)
    return clearTimeout(e);
  if ((It === Zf || !It) && clearTimeout)
    return It = clearTimeout, clearTimeout(e);
  try {
    return It(e);
  } catch {
    try {
      return It.call(null, e);
    } catch {
      return It.call(this, e);
    }
  }
}
var ar = [], fa = !1, dn, no = -1;
function aK() {
  !fa || !dn || (fa = !1, dn.length ? ar = dn.concat(ar) : no = -1, ar.length && Qx());
}
function Qx() {
  if (!fa) {
    var e = _x(aK);
    fa = !0;
    for (var A = ar.length; A; ) {
      for (dn = ar, ar = []; ++no < A; )
        dn && dn[no].run();
      no = -1, A = ar.length;
    }
    dn = null, fa = !1, nK(e);
  }
}
cA.nextTick = function(e) {
  var A = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var t = 1; t < arguments.length; t++)
      A[t - 1] = arguments[t];
  ar.push(new Ix(e, A)), ar.length === 1 && !fa && _x(Qx);
};
function Ix(e, A) {
  this.fun = e, this.array = A;
}
Ix.prototype.run = function() {
  this.fun.apply(null, this.array);
};
cA.title = "browser";
cA.browser = !0;
cA.env = {};
cA.argv = [];
cA.version = "";
cA.versions = {};
function pr() {
}
cA.on = pr;
cA.addListener = pr;
cA.once = pr;
cA.off = pr;
cA.removeListener = pr;
cA.removeAllListeners = pr;
cA.emit = pr;
cA.prependListener = pr;
cA.prependOnceListener = pr;
cA.listeners = function(e) {
  return [];
};
cA.binding = function(e) {
  throw new Error("process.binding is not supported");
};
cA.cwd = function() {
  return "/";
};
cA.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
cA.umask = function() {
  return 0;
};
var iK = Ux.exports;
const YAe = async (e, A, t) => {
  var r;
  try {
    const n = +/* @__PURE__ */ new Date(), a = au.SHA256(n.toString()).toString(), i = await e.get(
      `/content/strings?moduleId=${t}&language=${A}`,
      {
        headers: {
          Authorization: Mm(
            {
              httpPath: "/api/v1/content/strings",
              method: "GET",
              token: a
            },
            ((r = iK.env) == null ? void 0 : r.hmacKey) ?? {}.VITE_MYASURION_API_AUTH_HMAC_KEY
          ),
          token: a,
          t: n
        }
      }
    ), { data: s } = i;
    return s;
  } catch (n) {
    return console.log(n), null;
  }
}, zAe = async (e, A, t, r, n) => {
  try {
    const a = +/* @__PURE__ */ new Date(), i = await e.put(
      "/content/strings",
      JSON.stringify({
        entryId: t,
        value: r,
        language: n
      }),
      {
        method: "PUT",
        headers: {
          authorization: A.authorization,
          token: A.token,
          t: a
        }
      }
    ), { data: s } = i;
    return s;
  } catch (a) {
    throw console.log(a), a;
  }
}, sK = async (e, A, t, r, n, a) => {
  try {
    const i = +/* @__PURE__ */ new Date();
    if (!A.authorization && !A.token)
      throw "No headers to create";
    const s = await e.post(
      "/content/strings",
      JSON.stringify({
        moduleId: a || module,
        sectionId: n,
        pathId: t,
        value: r,
        usage: "static",
        autoPublish: "true"
      }),
      {
        method: "POST",
        headers: {
          authorization: A.authorization,
          token: A.token,
          t: i
        }
      }
    ), { data: o } = s;
    return console.log("create..."), o;
  } catch (i) {
    console.log(i);
  }
}, Dx = Kt({
  translationComponents: [],
  registerComponent: () => {
  },
  unregisterComponent: () => {
  }
}), XAe = ({ children: e }) => {
  const [A, t] = Ue([]), { translationAPI: r } = nc(), { entries: n } = nc(), a = async (o, u, l) => {
    var c;
    try {
      if (!r.api)
        throw "No api found for translation";
      if (!n)
        throw "No entries for translation";
      const f = n;
      if (!f || f.length === 0)
        throw "No fetched string data found";
      const d = (c = f.find((h) => h.id === l.section)) == null ? void 0 : c.text.findIndex((h) => h.path === l.path);
      (d === void 0 || d && d < 0) && sK(
        r.api,
        { authorization: r.authorization, token: r.token },
        l.path,
        u,
        l.section,
        l.module
      ), t((h) => {
        let p = 0;
        const v = h.find((g, B) => (p = B, g.meta.path === l.path));
        if (v) {
          const g = [...h];
          return g[p] = { ...v, text: u, s: "active" }, g;
        }
        const y = h.reduce((g, B) => B.i > g ? B.i : g, 0);
        return [
          ...h,
          {
            FC: o,
            text: u,
            meta: l,
            i: y !== void 0 ? y + 1 : 0,
            s: "active"
          }
        ];
      });
    } catch (f) {
      console.log(f);
    }
  }, { localeLanguage: i } = nc(), s = (o, u) => {
    t(
      (l) => l.map((c) => c.meta.path === u ? { ...c, s: "inactive" } : c)
    );
  };
  return Re(() => {
    t((o) => o);
  }, [i]), /* @__PURE__ */ F.jsx(
    Dx.Provider,
    {
      value: { translationComponents: A, registerComponent: a, unregisterComponent: s },
      children: e
    }
  );
}, qAe = () => Pt(Dx);
var Tx = { exports: {} }, oK = [
  {
    value: "#B0171F",
    name: "indian red"
  },
  {
    value: "#DC143C",
    css: !0,
    name: "crimson"
  },
  {
    value: "#FFB6C1",
    css: !0,
    name: "lightpink"
  },
  {
    value: "#FFAEB9",
    name: "lightpink 1"
  },
  {
    value: "#EEA2AD",
    name: "lightpink 2"
  },
  {
    value: "#CD8C95",
    name: "lightpink 3"
  },
  {
    value: "#8B5F65",
    name: "lightpink 4"
  },
  {
    value: "#FFC0CB",
    css: !0,
    name: "pink"
  },
  {
    value: "#FFB5C5",
    name: "pink 1"
  },
  {
    value: "#EEA9B8",
    name: "pink 2"
  },
  {
    value: "#CD919E",
    name: "pink 3"
  },
  {
    value: "#8B636C",
    name: "pink 4"
  },
  {
    value: "#DB7093",
    css: !0,
    name: "palevioletred"
  },
  {
    value: "#FF82AB",
    name: "palevioletred 1"
  },
  {
    value: "#EE799F",
    name: "palevioletred 2"
  },
  {
    value: "#CD6889",
    name: "palevioletred 3"
  },
  {
    value: "#8B475D",
    name: "palevioletred 4"
  },
  {
    value: "#FFF0F5",
    name: "lavenderblush 1"
  },
  {
    value: "#FFF0F5",
    css: !0,
    name: "lavenderblush"
  },
  {
    value: "#EEE0E5",
    name: "lavenderblush 2"
  },
  {
    value: "#CDC1C5",
    name: "lavenderblush 3"
  },
  {
    value: "#8B8386",
    name: "lavenderblush 4"
  },
  {
    value: "#FF3E96",
    name: "violetred 1"
  },
  {
    value: "#EE3A8C",
    name: "violetred 2"
  },
  {
    value: "#CD3278",
    name: "violetred 3"
  },
  {
    value: "#8B2252",
    name: "violetred 4"
  },
  {
    value: "#FF69B4",
    css: !0,
    name: "hotpink"
  },
  {
    value: "#FF6EB4",
    name: "hotpink 1"
  },
  {
    value: "#EE6AA7",
    name: "hotpink 2"
  },
  {
    value: "#CD6090",
    name: "hotpink 3"
  },
  {
    value: "#8B3A62",
    name: "hotpink 4"
  },
  {
    value: "#872657",
    name: "raspberry"
  },
  {
    value: "#FF1493",
    name: "deeppink 1"
  },
  {
    value: "#FF1493",
    css: !0,
    name: "deeppink"
  },
  {
    value: "#EE1289",
    name: "deeppink 2"
  },
  {
    value: "#CD1076",
    name: "deeppink 3"
  },
  {
    value: "#8B0A50",
    name: "deeppink 4"
  },
  {
    value: "#FF34B3",
    name: "maroon 1"
  },
  {
    value: "#EE30A7",
    name: "maroon 2"
  },
  {
    value: "#CD2990",
    name: "maroon 3"
  },
  {
    value: "#8B1C62",
    name: "maroon 4"
  },
  {
    value: "#C71585",
    css: !0,
    name: "mediumvioletred"
  },
  {
    value: "#D02090",
    name: "violetred"
  },
  {
    value: "#DA70D6",
    css: !0,
    name: "orchid"
  },
  {
    value: "#FF83FA",
    name: "orchid 1"
  },
  {
    value: "#EE7AE9",
    name: "orchid 2"
  },
  {
    value: "#CD69C9",
    name: "orchid 3"
  },
  {
    value: "#8B4789",
    name: "orchid 4"
  },
  {
    value: "#D8BFD8",
    css: !0,
    name: "thistle"
  },
  {
    value: "#FFE1FF",
    name: "thistle 1"
  },
  {
    value: "#EED2EE",
    name: "thistle 2"
  },
  {
    value: "#CDB5CD",
    name: "thistle 3"
  },
  {
    value: "#8B7B8B",
    name: "thistle 4"
  },
  {
    value: "#FFBBFF",
    name: "plum 1"
  },
  {
    value: "#EEAEEE",
    name: "plum 2"
  },
  {
    value: "#CD96CD",
    name: "plum 3"
  },
  {
    value: "#8B668B",
    name: "plum 4"
  },
  {
    value: "#DDA0DD",
    css: !0,
    name: "plum"
  },
  {
    value: "#EE82EE",
    css: !0,
    name: "violet"
  },
  {
    value: "#FF00FF",
    vga: !0,
    name: "magenta"
  },
  {
    value: "#FF00FF",
    vga: !0,
    css: !0,
    name: "fuchsia"
  },
  {
    value: "#EE00EE",
    name: "magenta 2"
  },
  {
    value: "#CD00CD",
    name: "magenta 3"
  },
  {
    value: "#8B008B",
    name: "magenta 4"
  },
  {
    value: "#8B008B",
    css: !0,
    name: "darkmagenta"
  },
  {
    value: "#800080",
    vga: !0,
    css: !0,
    name: "purple"
  },
  {
    value: "#BA55D3",
    css: !0,
    name: "mediumorchid"
  },
  {
    value: "#E066FF",
    name: "mediumorchid 1"
  },
  {
    value: "#D15FEE",
    name: "mediumorchid 2"
  },
  {
    value: "#B452CD",
    name: "mediumorchid 3"
  },
  {
    value: "#7A378B",
    name: "mediumorchid 4"
  },
  {
    value: "#9400D3",
    css: !0,
    name: "darkviolet"
  },
  {
    value: "#9932CC",
    css: !0,
    name: "darkorchid"
  },
  {
    value: "#BF3EFF",
    name: "darkorchid 1"
  },
  {
    value: "#B23AEE",
    name: "darkorchid 2"
  },
  {
    value: "#9A32CD",
    name: "darkorchid 3"
  },
  {
    value: "#68228B",
    name: "darkorchid 4"
  },
  {
    value: "#4B0082",
    css: !0,
    name: "indigo"
  },
  {
    value: "#8A2BE2",
    css: !0,
    name: "blueviolet"
  },
  {
    value: "#9B30FF",
    name: "purple 1"
  },
  {
    value: "#912CEE",
    name: "purple 2"
  },
  {
    value: "#7D26CD",
    name: "purple 3"
  },
  {
    value: "#551A8B",
    name: "purple 4"
  },
  {
    value: "#9370DB",
    css: !0,
    name: "mediumpurple"
  },
  {
    value: "#AB82FF",
    name: "mediumpurple 1"
  },
  {
    value: "#9F79EE",
    name: "mediumpurple 2"
  },
  {
    value: "#8968CD",
    name: "mediumpurple 3"
  },
  {
    value: "#5D478B",
    name: "mediumpurple 4"
  },
  {
    value: "#483D8B",
    css: !0,
    name: "darkslateblue"
  },
  {
    value: "#8470FF",
    name: "lightslateblue"
  },
  {
    value: "#7B68EE",
    css: !0,
    name: "mediumslateblue"
  },
  {
    value: "#6A5ACD",
    css: !0,
    name: "slateblue"
  },
  {
    value: "#836FFF",
    name: "slateblue 1"
  },
  {
    value: "#7A67EE",
    name: "slateblue 2"
  },
  {
    value: "#6959CD",
    name: "slateblue 3"
  },
  {
    value: "#473C8B",
    name: "slateblue 4"
  },
  {
    value: "#F8F8FF",
    css: !0,
    name: "ghostwhite"
  },
  {
    value: "#E6E6FA",
    css: !0,
    name: "lavender"
  },
  {
    value: "#0000FF",
    vga: !0,
    css: !0,
    name: "blue"
  },
  {
    value: "#0000EE",
    name: "blue 2"
  },
  {
    value: "#0000CD",
    name: "blue 3"
  },
  {
    value: "#0000CD",
    css: !0,
    name: "mediumblue"
  },
  {
    value: "#00008B",
    name: "blue 4"
  },
  {
    value: "#00008B",
    css: !0,
    name: "darkblue"
  },
  {
    value: "#000080",
    vga: !0,
    css: !0,
    name: "navy"
  },
  {
    value: "#191970",
    css: !0,
    name: "midnightblue"
  },
  {
    value: "#3D59AB",
    name: "cobalt"
  },
  {
    value: "#4169E1",
    css: !0,
    name: "royalblue"
  },
  {
    value: "#4876FF",
    name: "royalblue 1"
  },
  {
    value: "#436EEE",
    name: "royalblue 2"
  },
  {
    value: "#3A5FCD",
    name: "royalblue 3"
  },
  {
    value: "#27408B",
    name: "royalblue 4"
  },
  {
    value: "#6495ED",
    css: !0,
    name: "cornflowerblue"
  },
  {
    value: "#B0C4DE",
    css: !0,
    name: "lightsteelblue"
  },
  {
    value: "#CAE1FF",
    name: "lightsteelblue 1"
  },
  {
    value: "#BCD2EE",
    name: "lightsteelblue 2"
  },
  {
    value: "#A2B5CD",
    name: "lightsteelblue 3"
  },
  {
    value: "#6E7B8B",
    name: "lightsteelblue 4"
  },
  {
    value: "#778899",
    css: !0,
    name: "lightslategray"
  },
  {
    value: "#708090",
    css: !0,
    name: "slategray"
  },
  {
    value: "#C6E2FF",
    name: "slategray 1"
  },
  {
    value: "#B9D3EE",
    name: "slategray 2"
  },
  {
    value: "#9FB6CD",
    name: "slategray 3"
  },
  {
    value: "#6C7B8B",
    name: "slategray 4"
  },
  {
    value: "#1E90FF",
    name: "dodgerblue 1"
  },
  {
    value: "#1E90FF",
    css: !0,
    name: "dodgerblue"
  },
  {
    value: "#1C86EE",
    name: "dodgerblue 2"
  },
  {
    value: "#1874CD",
    name: "dodgerblue 3"
  },
  {
    value: "#104E8B",
    name: "dodgerblue 4"
  },
  {
    value: "#F0F8FF",
    css: !0,
    name: "aliceblue"
  },
  {
    value: "#4682B4",
    css: !0,
    name: "steelblue"
  },
  {
    value: "#63B8FF",
    name: "steelblue 1"
  },
  {
    value: "#5CACEE",
    name: "steelblue 2"
  },
  {
    value: "#4F94CD",
    name: "steelblue 3"
  },
  {
    value: "#36648B",
    name: "steelblue 4"
  },
  {
    value: "#87CEFA",
    css: !0,
    name: "lightskyblue"
  },
  {
    value: "#B0E2FF",
    name: "lightskyblue 1"
  },
  {
    value: "#A4D3EE",
    name: "lightskyblue 2"
  },
  {
    value: "#8DB6CD",
    name: "lightskyblue 3"
  },
  {
    value: "#607B8B",
    name: "lightskyblue 4"
  },
  {
    value: "#87CEFF",
    name: "skyblue 1"
  },
  {
    value: "#7EC0EE",
    name: "skyblue 2"
  },
  {
    value: "#6CA6CD",
    name: "skyblue 3"
  },
  {
    value: "#4A708B",
    name: "skyblue 4"
  },
  {
    value: "#87CEEB",
    css: !0,
    name: "skyblue"
  },
  {
    value: "#00BFFF",
    name: "deepskyblue 1"
  },
  {
    value: "#00BFFF",
    css: !0,
    name: "deepskyblue"
  },
  {
    value: "#00B2EE",
    name: "deepskyblue 2"
  },
  {
    value: "#009ACD",
    name: "deepskyblue 3"
  },
  {
    value: "#00688B",
    name: "deepskyblue 4"
  },
  {
    value: "#33A1C9",
    name: "peacock"
  },
  {
    value: "#ADD8E6",
    css: !0,
    name: "lightblue"
  },
  {
    value: "#BFEFFF",
    name: "lightblue 1"
  },
  {
    value: "#B2DFEE",
    name: "lightblue 2"
  },
  {
    value: "#9AC0CD",
    name: "lightblue 3"
  },
  {
    value: "#68838B",
    name: "lightblue 4"
  },
  {
    value: "#B0E0E6",
    css: !0,
    name: "powderblue"
  },
  {
    value: "#98F5FF",
    name: "cadetblue 1"
  },
  {
    value: "#8EE5EE",
    name: "cadetblue 2"
  },
  {
    value: "#7AC5CD",
    name: "cadetblue 3"
  },
  {
    value: "#53868B",
    name: "cadetblue 4"
  },
  {
    value: "#00F5FF",
    name: "turquoise 1"
  },
  {
    value: "#00E5EE",
    name: "turquoise 2"
  },
  {
    value: "#00C5CD",
    name: "turquoise 3"
  },
  {
    value: "#00868B",
    name: "turquoise 4"
  },
  {
    value: "#5F9EA0",
    css: !0,
    name: "cadetblue"
  },
  {
    value: "#00CED1",
    css: !0,
    name: "darkturquoise"
  },
  {
    value: "#F0FFFF",
    name: "azure 1"
  },
  {
    value: "#F0FFFF",
    css: !0,
    name: "azure"
  },
  {
    value: "#E0EEEE",
    name: "azure 2"
  },
  {
    value: "#C1CDCD",
    name: "azure 3"
  },
  {
    value: "#838B8B",
    name: "azure 4"
  },
  {
    value: "#E0FFFF",
    name: "lightcyan 1"
  },
  {
    value: "#E0FFFF",
    css: !0,
    name: "lightcyan"
  },
  {
    value: "#D1EEEE",
    name: "lightcyan 2"
  },
  {
    value: "#B4CDCD",
    name: "lightcyan 3"
  },
  {
    value: "#7A8B8B",
    name: "lightcyan 4"
  },
  {
    value: "#BBFFFF",
    name: "paleturquoise 1"
  },
  {
    value: "#AEEEEE",
    name: "paleturquoise 2"
  },
  {
    value: "#AEEEEE",
    css: !0,
    name: "paleturquoise"
  },
  {
    value: "#96CDCD",
    name: "paleturquoise 3"
  },
  {
    value: "#668B8B",
    name: "paleturquoise 4"
  },
  {
    value: "#2F4F4F",
    css: !0,
    name: "darkslategray"
  },
  {
    value: "#97FFFF",
    name: "darkslategray 1"
  },
  {
    value: "#8DEEEE",
    name: "darkslategray 2"
  },
  {
    value: "#79CDCD",
    name: "darkslategray 3"
  },
  {
    value: "#528B8B",
    name: "darkslategray 4"
  },
  {
    value: "#00FFFF",
    name: "cyan"
  },
  {
    value: "#00FFFF",
    css: !0,
    name: "aqua"
  },
  {
    value: "#00EEEE",
    name: "cyan 2"
  },
  {
    value: "#00CDCD",
    name: "cyan 3"
  },
  {
    value: "#008B8B",
    name: "cyan 4"
  },
  {
    value: "#008B8B",
    css: !0,
    name: "darkcyan"
  },
  {
    value: "#008080",
    vga: !0,
    css: !0,
    name: "teal"
  },
  {
    value: "#48D1CC",
    css: !0,
    name: "mediumturquoise"
  },
  {
    value: "#20B2AA",
    css: !0,
    name: "lightseagreen"
  },
  {
    value: "#03A89E",
    name: "manganeseblue"
  },
  {
    value: "#40E0D0",
    css: !0,
    name: "turquoise"
  },
  {
    value: "#808A87",
    name: "coldgrey"
  },
  {
    value: "#00C78C",
    name: "turquoiseblue"
  },
  {
    value: "#7FFFD4",
    name: "aquamarine 1"
  },
  {
    value: "#7FFFD4",
    css: !0,
    name: "aquamarine"
  },
  {
    value: "#76EEC6",
    name: "aquamarine 2"
  },
  {
    value: "#66CDAA",
    name: "aquamarine 3"
  },
  {
    value: "#66CDAA",
    css: !0,
    name: "mediumaquamarine"
  },
  {
    value: "#458B74",
    name: "aquamarine 4"
  },
  {
    value: "#00FA9A",
    css: !0,
    name: "mediumspringgreen"
  },
  {
    value: "#F5FFFA",
    css: !0,
    name: "mintcream"
  },
  {
    value: "#00FF7F",
    css: !0,
    name: "springgreen"
  },
  {
    value: "#00EE76",
    name: "springgreen 1"
  },
  {
    value: "#00CD66",
    name: "springgreen 2"
  },
  {
    value: "#008B45",
    name: "springgreen 3"
  },
  {
    value: "#3CB371",
    css: !0,
    name: "mediumseagreen"
  },
  {
    value: "#54FF9F",
    name: "seagreen 1"
  },
  {
    value: "#4EEE94",
    name: "seagreen 2"
  },
  {
    value: "#43CD80",
    name: "seagreen 3"
  },
  {
    value: "#2E8B57",
    name: "seagreen 4"
  },
  {
    value: "#2E8B57",
    css: !0,
    name: "seagreen"
  },
  {
    value: "#00C957",
    name: "emeraldgreen"
  },
  {
    value: "#BDFCC9",
    name: "mint"
  },
  {
    value: "#3D9140",
    name: "cobaltgreen"
  },
  {
    value: "#F0FFF0",
    name: "honeydew 1"
  },
  {
    value: "#F0FFF0",
    css: !0,
    name: "honeydew"
  },
  {
    value: "#E0EEE0",
    name: "honeydew 2"
  },
  {
    value: "#C1CDC1",
    name: "honeydew 3"
  },
  {
    value: "#838B83",
    name: "honeydew 4"
  },
  {
    value: "#8FBC8F",
    css: !0,
    name: "darkseagreen"
  },
  {
    value: "#C1FFC1",
    name: "darkseagreen 1"
  },
  {
    value: "#B4EEB4",
    name: "darkseagreen 2"
  },
  {
    value: "#9BCD9B",
    name: "darkseagreen 3"
  },
  {
    value: "#698B69",
    name: "darkseagreen 4"
  },
  {
    value: "#98FB98",
    css: !0,
    name: "palegreen"
  },
  {
    value: "#9AFF9A",
    name: "palegreen 1"
  },
  {
    value: "#90EE90",
    name: "palegreen 2"
  },
  {
    value: "#90EE90",
    css: !0,
    name: "lightgreen"
  },
  {
    value: "#7CCD7C",
    name: "palegreen 3"
  },
  {
    value: "#548B54",
    name: "palegreen 4"
  },
  {
    value: "#32CD32",
    css: !0,
    name: "limegreen"
  },
  {
    value: "#228B22",
    css: !0,
    name: "forestgreen"
  },
  {
    value: "#00FF00",
    vga: !0,
    name: "green 1"
  },
  {
    value: "#00FF00",
    vga: !0,
    css: !0,
    name: "lime"
  },
  {
    value: "#00EE00",
    name: "green 2"
  },
  {
    value: "#00CD00",
    name: "green 3"
  },
  {
    value: "#008B00",
    name: "green 4"
  },
  {
    value: "#008000",
    vga: !0,
    css: !0,
    name: "green"
  },
  {
    value: "#006400",
    css: !0,
    name: "darkgreen"
  },
  {
    value: "#308014",
    name: "sapgreen"
  },
  {
    value: "#7CFC00",
    css: !0,
    name: "lawngreen"
  },
  {
    value: "#7FFF00",
    name: "chartreuse 1"
  },
  {
    value: "#7FFF00",
    css: !0,
    name: "chartreuse"
  },
  {
    value: "#76EE00",
    name: "chartreuse 2"
  },
  {
    value: "#66CD00",
    name: "chartreuse 3"
  },
  {
    value: "#458B00",
    name: "chartreuse 4"
  },
  {
    value: "#ADFF2F",
    css: !0,
    name: "greenyellow"
  },
  {
    value: "#CAFF70",
    name: "darkolivegreen 1"
  },
  {
    value: "#BCEE68",
    name: "darkolivegreen 2"
  },
  {
    value: "#A2CD5A",
    name: "darkolivegreen 3"
  },
  {
    value: "#6E8B3D",
    name: "darkolivegreen 4"
  },
  {
    value: "#556B2F",
    css: !0,
    name: "darkolivegreen"
  },
  {
    value: "#6B8E23",
    css: !0,
    name: "olivedrab"
  },
  {
    value: "#C0FF3E",
    name: "olivedrab 1"
  },
  {
    value: "#B3EE3A",
    name: "olivedrab 2"
  },
  {
    value: "#9ACD32",
    name: "olivedrab 3"
  },
  {
    value: "#9ACD32",
    css: !0,
    name: "yellowgreen"
  },
  {
    value: "#698B22",
    name: "olivedrab 4"
  },
  {
    value: "#FFFFF0",
    name: "ivory 1"
  },
  {
    value: "#FFFFF0",
    css: !0,
    name: "ivory"
  },
  {
    value: "#EEEEE0",
    name: "ivory 2"
  },
  {
    value: "#CDCDC1",
    name: "ivory 3"
  },
  {
    value: "#8B8B83",
    name: "ivory 4"
  },
  {
    value: "#F5F5DC",
    css: !0,
    name: "beige"
  },
  {
    value: "#FFFFE0",
    name: "lightyellow 1"
  },
  {
    value: "#FFFFE0",
    css: !0,
    name: "lightyellow"
  },
  {
    value: "#EEEED1",
    name: "lightyellow 2"
  },
  {
    value: "#CDCDB4",
    name: "lightyellow 3"
  },
  {
    value: "#8B8B7A",
    name: "lightyellow 4"
  },
  {
    value: "#FAFAD2",
    css: !0,
    name: "lightgoldenrodyellow"
  },
  {
    value: "#FFFF00",
    vga: !0,
    name: "yellow 1"
  },
  {
    value: "#FFFF00",
    vga: !0,
    css: !0,
    name: "yellow"
  },
  {
    value: "#EEEE00",
    name: "yellow 2"
  },
  {
    value: "#CDCD00",
    name: "yellow 3"
  },
  {
    value: "#8B8B00",
    name: "yellow 4"
  },
  {
    value: "#808069",
    name: "warmgrey"
  },
  {
    value: "#808000",
    vga: !0,
    css: !0,
    name: "olive"
  },
  {
    value: "#BDB76B",
    css: !0,
    name: "darkkhaki"
  },
  {
    value: "#FFF68F",
    name: "khaki 1"
  },
  {
    value: "#EEE685",
    name: "khaki 2"
  },
  {
    value: "#CDC673",
    name: "khaki 3"
  },
  {
    value: "#8B864E",
    name: "khaki 4"
  },
  {
    value: "#F0E68C",
    css: !0,
    name: "khaki"
  },
  {
    value: "#EEE8AA",
    css: !0,
    name: "palegoldenrod"
  },
  {
    value: "#FFFACD",
    name: "lemonchiffon 1"
  },
  {
    value: "#FFFACD",
    css: !0,
    name: "lemonchiffon"
  },
  {
    value: "#EEE9BF",
    name: "lemonchiffon 2"
  },
  {
    value: "#CDC9A5",
    name: "lemonchiffon 3"
  },
  {
    value: "#8B8970",
    name: "lemonchiffon 4"
  },
  {
    value: "#FFEC8B",
    name: "lightgoldenrod 1"
  },
  {
    value: "#EEDC82",
    name: "lightgoldenrod 2"
  },
  {
    value: "#CDBE70",
    name: "lightgoldenrod 3"
  },
  {
    value: "#8B814C",
    name: "lightgoldenrod 4"
  },
  {
    value: "#E3CF57",
    name: "banana"
  },
  {
    value: "#FFD700",
    name: "gold 1"
  },
  {
    value: "#FFD700",
    css: !0,
    name: "gold"
  },
  {
    value: "#EEC900",
    name: "gold 2"
  },
  {
    value: "#CDAD00",
    name: "gold 3"
  },
  {
    value: "#8B7500",
    name: "gold 4"
  },
  {
    value: "#FFF8DC",
    name: "cornsilk 1"
  },
  {
    value: "#FFF8DC",
    css: !0,
    name: "cornsilk"
  },
  {
    value: "#EEE8CD",
    name: "cornsilk 2"
  },
  {
    value: "#CDC8B1",
    name: "cornsilk 3"
  },
  {
    value: "#8B8878",
    name: "cornsilk 4"
  },
  {
    value: "#DAA520",
    css: !0,
    name: "goldenrod"
  },
  {
    value: "#FFC125",
    name: "goldenrod 1"
  },
  {
    value: "#EEB422",
    name: "goldenrod 2"
  },
  {
    value: "#CD9B1D",
    name: "goldenrod 3"
  },
  {
    value: "#8B6914",
    name: "goldenrod 4"
  },
  {
    value: "#B8860B",
    css: !0,
    name: "darkgoldenrod"
  },
  {
    value: "#FFB90F",
    name: "darkgoldenrod 1"
  },
  {
    value: "#EEAD0E",
    name: "darkgoldenrod 2"
  },
  {
    value: "#CD950C",
    name: "darkgoldenrod 3"
  },
  {
    value: "#8B6508",
    name: "darkgoldenrod 4"
  },
  {
    value: "#FFA500",
    name: "orange 1"
  },
  {
    value: "#FF8000",
    css: !0,
    name: "orange"
  },
  {
    value: "#EE9A00",
    name: "orange 2"
  },
  {
    value: "#CD8500",
    name: "orange 3"
  },
  {
    value: "#8B5A00",
    name: "orange 4"
  },
  {
    value: "#FFFAF0",
    css: !0,
    name: "floralwhite"
  },
  {
    value: "#FDF5E6",
    css: !0,
    name: "oldlace"
  },
  {
    value: "#F5DEB3",
    css: !0,
    name: "wheat"
  },
  {
    value: "#FFE7BA",
    name: "wheat 1"
  },
  {
    value: "#EED8AE",
    name: "wheat 2"
  },
  {
    value: "#CDBA96",
    name: "wheat 3"
  },
  {
    value: "#8B7E66",
    name: "wheat 4"
  },
  {
    value: "#FFE4B5",
    css: !0,
    name: "moccasin"
  },
  {
    value: "#FFEFD5",
    css: !0,
    name: "papayawhip"
  },
  {
    value: "#FFEBCD",
    css: !0,
    name: "blanchedalmond"
  },
  {
    value: "#FFDEAD",
    name: "navajowhite 1"
  },
  {
    value: "#FFDEAD",
    css: !0,
    name: "navajowhite"
  },
  {
    value: "#EECFA1",
    name: "navajowhite 2"
  },
  {
    value: "#CDB38B",
    name: "navajowhite 3"
  },
  {
    value: "#8B795E",
    name: "navajowhite 4"
  },
  {
    value: "#FCE6C9",
    name: "eggshell"
  },
  {
    value: "#D2B48C",
    css: !0,
    name: "tan"
  },
  {
    value: "#9C661F",
    name: "brick"
  },
  {
    value: "#FF9912",
    name: "cadmiumyellow"
  },
  {
    value: "#FAEBD7",
    css: !0,
    name: "antiquewhite"
  },
  {
    value: "#FFEFDB",
    name: "antiquewhite 1"
  },
  {
    value: "#EEDFCC",
    name: "antiquewhite 2"
  },
  {
    value: "#CDC0B0",
    name: "antiquewhite 3"
  },
  {
    value: "#8B8378",
    name: "antiquewhite 4"
  },
  {
    value: "#DEB887",
    css: !0,
    name: "burlywood"
  },
  {
    value: "#FFD39B",
    name: "burlywood 1"
  },
  {
    value: "#EEC591",
    name: "burlywood 2"
  },
  {
    value: "#CDAA7D",
    name: "burlywood 3"
  },
  {
    value: "#8B7355",
    name: "burlywood 4"
  },
  {
    value: "#FFE4C4",
    name: "bisque 1"
  },
  {
    value: "#FFE4C4",
    css: !0,
    name: "bisque"
  },
  {
    value: "#EED5B7",
    name: "bisque 2"
  },
  {
    value: "#CDB79E",
    name: "bisque 3"
  },
  {
    value: "#8B7D6B",
    name: "bisque 4"
  },
  {
    value: "#E3A869",
    name: "melon"
  },
  {
    value: "#ED9121",
    name: "carrot"
  },
  {
    value: "#FF8C00",
    css: !0,
    name: "darkorange"
  },
  {
    value: "#FF7F00",
    name: "darkorange 1"
  },
  {
    value: "#EE7600",
    name: "darkorange 2"
  },
  {
    value: "#CD6600",
    name: "darkorange 3"
  },
  {
    value: "#8B4500",
    name: "darkorange 4"
  },
  {
    value: "#FFA54F",
    name: "tan 1"
  },
  {
    value: "#EE9A49",
    name: "tan 2"
  },
  {
    value: "#CD853F",
    name: "tan 3"
  },
  {
    value: "#CD853F",
    css: !0,
    name: "peru"
  },
  {
    value: "#8B5A2B",
    name: "tan 4"
  },
  {
    value: "#FAF0E6",
    css: !0,
    name: "linen"
  },
  {
    value: "#FFDAB9",
    name: "peachpuff 1"
  },
  {
    value: "#FFDAB9",
    css: !0,
    name: "peachpuff"
  },
  {
    value: "#EECBAD",
    name: "peachpuff 2"
  },
  {
    value: "#CDAF95",
    name: "peachpuff 3"
  },
  {
    value: "#8B7765",
    name: "peachpuff 4"
  },
  {
    value: "#FFF5EE",
    name: "seashell 1"
  },
  {
    value: "#FFF5EE",
    css: !0,
    name: "seashell"
  },
  {
    value: "#EEE5DE",
    name: "seashell 2"
  },
  {
    value: "#CDC5BF",
    name: "seashell 3"
  },
  {
    value: "#8B8682",
    name: "seashell 4"
  },
  {
    value: "#F4A460",
    css: !0,
    name: "sandybrown"
  },
  {
    value: "#C76114",
    name: "rawsienna"
  },
  {
    value: "#D2691E",
    css: !0,
    name: "chocolate"
  },
  {
    value: "#FF7F24",
    name: "chocolate 1"
  },
  {
    value: "#EE7621",
    name: "chocolate 2"
  },
  {
    value: "#CD661D",
    name: "chocolate 3"
  },
  {
    value: "#8B4513",
    name: "chocolate 4"
  },
  {
    value: "#8B4513",
    css: !0,
    name: "saddlebrown"
  },
  {
    value: "#292421",
    name: "ivoryblack"
  },
  {
    value: "#FF7D40",
    name: "flesh"
  },
  {
    value: "#FF6103",
    name: "cadmiumorange"
  },
  {
    value: "#8A360F",
    name: "burntsienna"
  },
  {
    value: "#A0522D",
    css: !0,
    name: "sienna"
  },
  {
    value: "#FF8247",
    name: "sienna 1"
  },
  {
    value: "#EE7942",
    name: "sienna 2"
  },
  {
    value: "#CD6839",
    name: "sienna 3"
  },
  {
    value: "#8B4726",
    name: "sienna 4"
  },
  {
    value: "#FFA07A",
    name: "lightsalmon 1"
  },
  {
    value: "#FFA07A",
    css: !0,
    name: "lightsalmon"
  },
  {
    value: "#EE9572",
    name: "lightsalmon 2"
  },
  {
    value: "#CD8162",
    name: "lightsalmon 3"
  },
  {
    value: "#8B5742",
    name: "lightsalmon 4"
  },
  {
    value: "#FF7F50",
    css: !0,
    name: "coral"
  },
  {
    value: "#FF4500",
    name: "orangered 1"
  },
  {
    value: "#FF4500",
    css: !0,
    name: "orangered"
  },
  {
    value: "#EE4000",
    name: "orangered 2"
  },
  {
    value: "#CD3700",
    name: "orangered 3"
  },
  {
    value: "#8B2500",
    name: "orangered 4"
  },
  {
    value: "#5E2612",
    name: "sepia"
  },
  {
    value: "#E9967A",
    css: !0,
    name: "darksalmon"
  },
  {
    value: "#FF8C69",
    name: "salmon 1"
  },
  {
    value: "#EE8262",
    name: "salmon 2"
  },
  {
    value: "#CD7054",
    name: "salmon 3"
  },
  {
    value: "#8B4C39",
    name: "salmon 4"
  },
  {
    value: "#FF7256",
    name: "coral 1"
  },
  {
    value: "#EE6A50",
    name: "coral 2"
  },
  {
    value: "#CD5B45",
    name: "coral 3"
  },
  {
    value: "#8B3E2F",
    name: "coral 4"
  },
  {
    value: "#8A3324",
    name: "burntumber"
  },
  {
    value: "#FF6347",
    name: "tomato 1"
  },
  {
    value: "#FF6347",
    css: !0,
    name: "tomato"
  },
  {
    value: "#EE5C42",
    name: "tomato 2"
  },
  {
    value: "#CD4F39",
    name: "tomato 3"
  },
  {
    value: "#8B3626",
    name: "tomato 4"
  },
  {
    value: "#FA8072",
    css: !0,
    name: "salmon"
  },
  {
    value: "#FFE4E1",
    name: "mistyrose 1"
  },
  {
    value: "#FFE4E1",
    css: !0,
    name: "mistyrose"
  },
  {
    value: "#EED5D2",
    name: "mistyrose 2"
  },
  {
    value: "#CDB7B5",
    name: "mistyrose 3"
  },
  {
    value: "#8B7D7B",
    name: "mistyrose 4"
  },
  {
    value: "#FFFAFA",
    name: "snow 1"
  },
  {
    value: "#FFFAFA",
    css: !0,
    name: "snow"
  },
  {
    value: "#EEE9E9",
    name: "snow 2"
  },
  {
    value: "#CDC9C9",
    name: "snow 3"
  },
  {
    value: "#8B8989",
    name: "snow 4"
  },
  {
    value: "#BC8F8F",
    css: !0,
    name: "rosybrown"
  },
  {
    value: "#FFC1C1",
    name: "rosybrown 1"
  },
  {
    value: "#EEB4B4",
    name: "rosybrown 2"
  },
  {
    value: "#CD9B9B",
    name: "rosybrown 3"
  },
  {
    value: "#8B6969",
    name: "rosybrown 4"
  },
  {
    value: "#F08080",
    css: !0,
    name: "lightcoral"
  },
  {
    value: "#CD5C5C",
    css: !0,
    name: "indianred"
  },
  {
    value: "#FF6A6A",
    name: "indianred 1"
  },
  {
    value: "#EE6363",
    name: "indianred 2"
  },
  {
    value: "#8B3A3A",
    name: "indianred 4"
  },
  {
    value: "#CD5555",
    name: "indianred 3"
  },
  {
    value: "#A52A2A",
    css: !0,
    name: "brown"
  },
  {
    value: "#FF4040",
    name: "brown 1"
  },
  {
    value: "#EE3B3B",
    name: "brown 2"
  },
  {
    value: "#CD3333",
    name: "brown 3"
  },
  {
    value: "#8B2323",
    name: "brown 4"
  },
  {
    value: "#B22222",
    css: !0,
    name: "firebrick"
  },
  {
    value: "#FF3030",
    name: "firebrick 1"
  },
  {
    value: "#EE2C2C",
    name: "firebrick 2"
  },
  {
    value: "#CD2626",
    name: "firebrick 3"
  },
  {
    value: "#8B1A1A",
    name: "firebrick 4"
  },
  {
    value: "#FF0000",
    vga: !0,
    name: "red 1"
  },
  {
    value: "#FF0000",
    vga: !0,
    css: !0,
    name: "red"
  },
  {
    value: "#EE0000",
    name: "red 2"
  },
  {
    value: "#CD0000",
    name: "red 3"
  },
  {
    value: "#8B0000",
    name: "red 4"
  },
  {
    value: "#8B0000",
    css: !0,
    name: "darkred"
  },
  {
    value: "#800000",
    vga: !0,
    css: !0,
    name: "maroon"
  },
  {
    value: "#8E388E",
    name: "sgi beet"
  },
  {
    value: "#7171C6",
    name: "sgi slateblue"
  },
  {
    value: "#7D9EC0",
    name: "sgi lightblue"
  },
  {
    value: "#388E8E",
    name: "sgi teal"
  },
  {
    value: "#71C671",
    name: "sgi chartreuse"
  },
  {
    value: "#8E8E38",
    name: "sgi olivedrab"
  },
  {
    value: "#C5C1AA",
    name: "sgi brightgray"
  },
  {
    value: "#C67171",
    name: "sgi salmon"
  },
  {
    value: "#555555",
    name: "sgi darkgray"
  },
  {
    value: "#1E1E1E",
    name: "sgi gray 12"
  },
  {
    value: "#282828",
    name: "sgi gray 16"
  },
  {
    value: "#515151",
    name: "sgi gray 32"
  },
  {
    value: "#5B5B5B",
    name: "sgi gray 36"
  },
  {
    value: "#848484",
    name: "sgi gray 52"
  },
  {
    value: "#8E8E8E",
    name: "sgi gray 56"
  },
  {
    value: "#AAAAAA",
    name: "sgi lightgray"
  },
  {
    value: "#B7B7B7",
    name: "sgi gray 72"
  },
  {
    value: "#C1C1C1",
    name: "sgi gray 76"
  },
  {
    value: "#EAEAEA",
    name: "sgi gray 92"
  },
  {
    value: "#F4F4F4",
    name: "sgi gray 96"
  },
  {
    value: "#FFFFFF",
    vga: !0,
    css: !0,
    name: "white"
  },
  {
    value: "#F5F5F5",
    name: "white smoke"
  },
  {
    value: "#F5F5F5",
    name: "gray 96"
  },
  {
    value: "#DCDCDC",
    css: !0,
    name: "gainsboro"
  },
  {
    value: "#D3D3D3",
    css: !0,
    name: "lightgrey"
  },
  {
    value: "#C0C0C0",
    vga: !0,
    css: !0,
    name: "silver"
  },
  {
    value: "#A9A9A9",
    css: !0,
    name: "darkgray"
  },
  {
    value: "#808080",
    vga: !0,
    css: !0,
    name: "gray"
  },
  {
    value: "#696969",
    css: !0,
    name: "dimgray"
  },
  {
    value: "#696969",
    name: "gray 42"
  },
  {
    value: "#000000",
    vga: !0,
    css: !0,
    name: "black"
  },
  {
    value: "#FCFCFC",
    name: "gray 99"
  },
  {
    value: "#FAFAFA",
    name: "gray 98"
  },
  {
    value: "#F7F7F7",
    name: "gray 97"
  },
  {
    value: "#F2F2F2",
    name: "gray 95"
  },
  {
    value: "#F0F0F0",
    name: "gray 94"
  },
  {
    value: "#EDEDED",
    name: "gray 93"
  },
  {
    value: "#EBEBEB",
    name: "gray 92"
  },
  {
    value: "#E8E8E8",
    name: "gray 91"
  },
  {
    value: "#E5E5E5",
    name: "gray 90"
  },
  {
    value: "#E3E3E3",
    name: "gray 89"
  },
  {
    value: "#E0E0E0",
    name: "gray 88"
  },
  {
    value: "#DEDEDE",
    name: "gray 87"
  },
  {
    value: "#DBDBDB",
    name: "gray 86"
  },
  {
    value: "#D9D9D9",
    name: "gray 85"
  },
  {
    value: "#D6D6D6",
    name: "gray 84"
  },
  {
    value: "#D4D4D4",
    name: "gray 83"
  },
  {
    value: "#D1D1D1",
    name: "gray 82"
  },
  {
    value: "#CFCFCF",
    name: "gray 81"
  },
  {
    value: "#CCCCCC",
    name: "gray 80"
  },
  {
    value: "#C9C9C9",
    name: "gray 79"
  },
  {
    value: "#C7C7C7",
    name: "gray 78"
  },
  {
    value: "#C4C4C4",
    name: "gray 77"
  },
  {
    value: "#C2C2C2",
    name: "gray 76"
  },
  {
    value: "#BFBFBF",
    name: "gray 75"
  },
  {
    value: "#BDBDBD",
    name: "gray 74"
  },
  {
    value: "#BABABA",
    name: "gray 73"
  },
  {
    value: "#B8B8B8",
    name: "gray 72"
  },
  {
    value: "#B5B5B5",
    name: "gray 71"
  },
  {
    value: "#B3B3B3",
    name: "gray 70"
  },
  {
    value: "#B0B0B0",
    name: "gray 69"
  },
  {
    value: "#ADADAD",
    name: "gray 68"
  },
  {
    value: "#ABABAB",
    name: "gray 67"
  },
  {
    value: "#A8A8A8",
    name: "gray 66"
  },
  {
    value: "#A6A6A6",
    name: "gray 65"
  },
  {
    value: "#A3A3A3",
    name: "gray 64"
  },
  {
    value: "#A1A1A1",
    name: "gray 63"
  },
  {
    value: "#9E9E9E",
    name: "gray 62"
  },
  {
    value: "#9C9C9C",
    name: "gray 61"
  },
  {
    value: "#999999",
    name: "gray 60"
  },
  {
    value: "#969696",
    name: "gray 59"
  },
  {
    value: "#949494",
    name: "gray 58"
  },
  {
    value: "#919191",
    name: "gray 57"
  },
  {
    value: "#8F8F8F",
    name: "gray 56"
  },
  {
    value: "#8C8C8C",
    name: "gray 55"
  },
  {
    value: "#8A8A8A",
    name: "gray 54"
  },
  {
    value: "#878787",
    name: "gray 53"
  },
  {
    value: "#858585",
    name: "gray 52"
  },
  {
    value: "#828282",
    name: "gray 51"
  },
  {
    value: "#7F7F7F",
    name: "gray 50"
  },
  {
    value: "#7D7D7D",
    name: "gray 49"
  },
  {
    value: "#7A7A7A",
    name: "gray 48"
  },
  {
    value: "#787878",
    name: "gray 47"
  },
  {
    value: "#757575",
    name: "gray 46"
  },
  {
    value: "#737373",
    name: "gray 45"
  },
  {
    value: "#707070",
    name: "gray 44"
  },
  {
    value: "#6E6E6E",
    name: "gray 43"
  },
  {
    value: "#666666",
    name: "gray 40"
  },
  {
    value: "#636363",
    name: "gray 39"
  },
  {
    value: "#616161",
    name: "gray 38"
  },
  {
    value: "#5E5E5E",
    name: "gray 37"
  },
  {
    value: "#5C5C5C",
    name: "gray 36"
  },
  {
    value: "#595959",
    name: "gray 35"
  },
  {
    value: "#575757",
    name: "gray 34"
  },
  {
    value: "#545454",
    name: "gray 33"
  },
  {
    value: "#525252",
    name: "gray 32"
  },
  {
    value: "#4F4F4F",
    name: "gray 31"
  },
  {
    value: "#4D4D4D",
    name: "gray 30"
  },
  {
    value: "#4A4A4A",
    name: "gray 29"
  },
  {
    value: "#474747",
    name: "gray 28"
  },
  {
    value: "#454545",
    name: "gray 27"
  },
  {
    value: "#424242",
    name: "gray 26"
  },
  {
    value: "#404040",
    name: "gray 25"
  },
  {
    value: "#3D3D3D",
    name: "gray 24"
  },
  {
    value: "#3B3B3B",
    name: "gray 23"
  },
  {
    value: "#383838",
    name: "gray 22"
  },
  {
    value: "#363636",
    name: "gray 21"
  },
  {
    value: "#333333",
    name: "gray 20"
  },
  {
    value: "#303030",
    name: "gray 19"
  },
  {
    value: "#2E2E2E",
    name: "gray 18"
  },
  {
    value: "#2B2B2B",
    name: "gray 17"
  },
  {
    value: "#292929",
    name: "gray 16"
  },
  {
    value: "#262626",
    name: "gray 15"
  },
  {
    value: "#242424",
    name: "gray 14"
  },
  {
    value: "#212121",
    name: "gray 13"
  },
  {
    value: "#1F1F1F",
    name: "gray 12"
  },
  {
    value: "#1C1C1C",
    name: "gray 11"
  },
  {
    value: "#1A1A1A",
    name: "gray 10"
  },
  {
    value: "#171717",
    name: "gray 9"
  },
  {
    value: "#141414",
    name: "gray 8"
  },
  {
    value: "#121212",
    name: "gray 7"
  },
  {
    value: "#0F0F0F",
    name: "gray 6"
  },
  {
    value: "#0D0D0D",
    name: "gray 5"
  },
  {
    value: "#0A0A0A",
    name: "gray 4"
  },
  {
    value: "#080808",
    name: "gray 3"
  },
  {
    value: "#050505",
    name: "gray 2"
  },
  {
    value: "#030303",
    name: "gray 1"
  },
  {
    value: "#F5F5F5",
    css: !0,
    name: "whitesmoke"
  }
];
(function(e) {
  var A = oK, t = A.filter(function(n) {
    return !!n.css;
  }), r = A.filter(function(n) {
    return !!n.vga;
  });
  e.exports = function(n) {
    var a = e.exports.get(n);
    return a && a.value;
  }, e.exports.get = function(n) {
    return n = n || "", n = n.trim().toLowerCase(), A.filter(function(a) {
      return a.name.toLowerCase() === n;
    }).pop();
  }, e.exports.all = e.exports.get.all = function() {
    return A;
  }, e.exports.get.css = function(n) {
    return n ? (n = n || "", n = n.trim().toLowerCase(), t.filter(function(a) {
      return a.name.toLowerCase() === n;
    }).pop()) : t;
  }, e.exports.get.vga = function(n) {
    return n ? (n = n || "", n = n.trim().toLowerCase(), r.filter(function(a) {
      return a.name.toLowerCase() === n;
    }).pop()) : r;
  };
})(Tx);
var uK = Tx.exports;
const JAe = /* @__PURE__ */ wt(uK);
var lK = {}, qu = {}, Nd = {}, Mc = {}, Hs = { exports: {} }, e0 = { exports: {} }, He = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yB;
function cK() {
  if (yB)
    return He;
  yB = 1;
  var e = typeof Symbol == "function" && Symbol.for, A = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, o = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function B(m) {
    if (typeof m == "object" && m !== null) {
      var x = m.$$typeof;
      switch (x) {
        case A:
          switch (m = m.type, m) {
            case o:
            case u:
            case r:
            case a:
            case n:
            case c:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case s:
                case l:
                case h:
                case d:
                case i:
                  return m;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  function w(m) {
    return B(m) === u;
  }
  return He.AsyncMode = o, He.ConcurrentMode = u, He.ContextConsumer = s, He.ContextProvider = i, He.Element = A, He.ForwardRef = l, He.Fragment = r, He.Lazy = h, He.Memo = d, He.Portal = t, He.Profiler = a, He.StrictMode = n, He.Suspense = c, He.isAsyncMode = function(m) {
    return w(m) || B(m) === o;
  }, He.isConcurrentMode = w, He.isContextConsumer = function(m) {
    return B(m) === s;
  }, He.isContextProvider = function(m) {
    return B(m) === i;
  }, He.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === A;
  }, He.isForwardRef = function(m) {
    return B(m) === l;
  }, He.isFragment = function(m) {
    return B(m) === r;
  }, He.isLazy = function(m) {
    return B(m) === h;
  }, He.isMemo = function(m) {
    return B(m) === d;
  }, He.isPortal = function(m) {
    return B(m) === t;
  }, He.isProfiler = function(m) {
    return B(m) === a;
  }, He.isStrictMode = function(m) {
    return B(m) === n;
  }, He.isSuspense = function(m) {
    return B(m) === c;
  }, He.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === r || m === u || m === a || m === n || m === c || m === f || typeof m == "object" && m !== null && (m.$$typeof === h || m.$$typeof === d || m.$$typeof === i || m.$$typeof === s || m.$$typeof === l || m.$$typeof === v || m.$$typeof === y || m.$$typeof === g || m.$$typeof === p);
  }, He.typeOf = B, He;
}
var Le = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xB;
function fK() {
  return xB || (xB = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, A = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, o = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, d = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function B(k) {
      return typeof k == "string" || typeof k == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      k === r || k === u || k === a || k === n || k === c || k === f || typeof k == "object" && k !== null && (k.$$typeof === h || k.$$typeof === d || k.$$typeof === i || k.$$typeof === s || k.$$typeof === l || k.$$typeof === v || k.$$typeof === y || k.$$typeof === g || k.$$typeof === p);
    }
    function w(k) {
      if (typeof k == "object" && k !== null) {
        var $ = k.$$typeof;
        switch ($) {
          case A:
            var ee = k.type;
            switch (ee) {
              case o:
              case u:
              case r:
              case a:
              case n:
              case c:
                return ee;
              default:
                var he = ee && ee.$$typeof;
                switch (he) {
                  case s:
                  case l:
                  case h:
                  case d:
                  case i:
                    return he;
                  default:
                    return $;
                }
            }
          case t:
            return $;
        }
      }
    }
    var m = o, x = u, C = s, E = i, T = A, S = l, b = r, N = h, O = d, V = t, I = a, _ = n, K = c, Y = !1;
    function X(k) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(k) || w(k) === o;
    }
    function R(k) {
      return w(k) === u;
    }
    function U(k) {
      return w(k) === s;
    }
    function H(k) {
      return w(k) === i;
    }
    function D(k) {
      return typeof k == "object" && k !== null && k.$$typeof === A;
    }
    function Q(k) {
      return w(k) === l;
    }
    function j(k) {
      return w(k) === r;
    }
    function z(k) {
      return w(k) === h;
    }
    function re(k) {
      return w(k) === d;
    }
    function Z(k) {
      return w(k) === t;
    }
    function ve(k) {
      return w(k) === a;
    }
    function L(k) {
      return w(k) === n;
    }
    function M(k) {
      return w(k) === c;
    }
    Le.AsyncMode = m, Le.ConcurrentMode = x, Le.ContextConsumer = C, Le.ContextProvider = E, Le.Element = T, Le.ForwardRef = S, Le.Fragment = b, Le.Lazy = N, Le.Memo = O, Le.Portal = V, Le.Profiler = I, Le.StrictMode = _, Le.Suspense = K, Le.isAsyncMode = X, Le.isConcurrentMode = R, Le.isContextConsumer = U, Le.isContextProvider = H, Le.isElement = D, Le.isForwardRef = Q, Le.isFragment = j, Le.isLazy = z, Le.isMemo = re, Le.isPortal = Z, Le.isProfiler = ve, Le.isStrictMode = L, Le.isSuspense = M, Le.isValidElementType = B, Le.typeOf = w;
  }()), Le;
}
process.env.NODE_ENV === "production" ? e0.exports = cK() : e0.exports = fK();
var kd = e0.exports;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Rc, CB;
function dK() {
  if (CB)
    return Rc;
  CB = 1;
  var e = Object.getOwnPropertySymbols, A = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var o = Object.getOwnPropertyNames(i).map(function(l) {
        return i[l];
      });
      if (o.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        u[l] = l;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Rc = n() ? Object.assign : function(a, i) {
    for (var s, o = r(a), u, l = 1; l < arguments.length; l++) {
      s = Object(arguments[l]);
      for (var c in s)
        A.call(s, c) && (o[c] = s[c]);
      if (e) {
        u = e(s);
        for (var f = 0; f < u.length; f++)
          t.call(s, u[f]) && (o[u[f]] = s[u[f]]);
      }
    }
    return o;
  }, Rc;
}
var Nc, EB;
function Pd() {
  if (EB)
    return Nc;
  EB = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Nc = e, Nc;
}
var kc, FB;
function Ox() {
  return FB || (FB = 1, kc = Function.call.bind(Object.prototype.hasOwnProperty)), kc;
}
var Pc, bB;
function hK() {
  if (bB)
    return Pc;
  bB = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var A = Pd(), t = {}, r = Ox();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function n(a, i, s, o, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in a)
        if (r(a, l)) {
          var c;
          try {
            if (typeof a[l] != "function") {
              var f = Error(
                (o || "React class") + ": " + s + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            c = a[l](i, l, o, s, null, A);
          } catch (h) {
            c = h;
          }
          if (c && !(c instanceof Error) && e(
            (o || "React class") + ": type specification of " + s + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in t)) {
            t[c.message] = !0;
            var d = u ? u() : "";
            e(
              "Failed " + s + " type: " + c.message + (d ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, Pc = n, Pc;
}
var Kc, SB;
function pK() {
  if (SB)
    return Kc;
  SB = 1;
  var e = kd, A = dK(), t = Pd(), r = Ox(), n = hK(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var o = "Warning: " + s;
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Kc = function(s, o) {
    var u = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function c(R) {
      var U = R && (u && R[u] || R[l]);
      if (typeof U == "function")
        return U;
    }
    var f = "<<anonymous>>", d = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: g(),
      arrayOf: B,
      element: w(),
      elementType: m(),
      instanceOf: x,
      node: S(),
      objectOf: E,
      oneOf: C,
      oneOfType: T,
      shape: N,
      exact: O
    };
    function h(R, U) {
      return R === U ? R !== 0 || 1 / R === 1 / U : R !== R && U !== U;
    }
    function p(R, U) {
      this.message = R, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function v(R) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, H = 0;
      function D(j, z, re, Z, ve, L, M) {
        if (Z = Z || f, L = L || re, M !== t) {
          if (o) {
            var k = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw k.name = "Invariant Violation", k;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var $ = Z + ":" + re;
            !U[$] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + L + "` prop on `" + Z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[$] = !0, H++);
          }
        }
        return z[re] == null ? j ? z[re] === null ? new p("The " + ve + " `" + L + "` is marked as required " + ("in `" + Z + "`, but its value is `null`.")) : new p("The " + ve + " `" + L + "` is marked as required in " + ("`" + Z + "`, but its value is `undefined`.")) : null : R(z, re, Z, ve, L);
      }
      var Q = D.bind(null, !1);
      return Q.isRequired = D.bind(null, !0), Q;
    }
    function y(R) {
      function U(H, D, Q, j, z, re) {
        var Z = H[D], ve = _(Z);
        if (ve !== R) {
          var L = K(Z);
          return new p(
            "Invalid " + j + " `" + z + "` of type " + ("`" + L + "` supplied to `" + Q + "`, expected ") + ("`" + R + "`."),
            { expectedType: R }
          );
        }
        return null;
      }
      return v(U);
    }
    function g() {
      return v(i);
    }
    function B(R) {
      function U(H, D, Q, j, z) {
        if (typeof R != "function")
          return new p("Property `" + z + "` of component `" + Q + "` has invalid PropType notation inside arrayOf.");
        var re = H[D];
        if (!Array.isArray(re)) {
          var Z = _(re);
          return new p("Invalid " + j + " `" + z + "` of type " + ("`" + Z + "` supplied to `" + Q + "`, expected an array."));
        }
        for (var ve = 0; ve < re.length; ve++) {
          var L = R(re, ve, Q, j, z + "[" + ve + "]", t);
          if (L instanceof Error)
            return L;
        }
        return null;
      }
      return v(U);
    }
    function w() {
      function R(U, H, D, Q, j) {
        var z = U[H];
        if (!s(z)) {
          var re = _(z);
          return new p("Invalid " + Q + " `" + j + "` of type " + ("`" + re + "` supplied to `" + D + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(R);
    }
    function m() {
      function R(U, H, D, Q, j) {
        var z = U[H];
        if (!e.isValidElementType(z)) {
          var re = _(z);
          return new p("Invalid " + Q + " `" + j + "` of type " + ("`" + re + "` supplied to `" + D + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(R);
    }
    function x(R) {
      function U(H, D, Q, j, z) {
        if (!(H[D] instanceof R)) {
          var re = R.name || f, Z = X(H[D]);
          return new p("Invalid " + j + " `" + z + "` of type " + ("`" + Z + "` supplied to `" + Q + "`, expected ") + ("instance of `" + re + "`."));
        }
        return null;
      }
      return v(U);
    }
    function C(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function U(H, D, Q, j, z) {
        for (var re = H[D], Z = 0; Z < R.length; Z++)
          if (h(re, R[Z]))
            return null;
        var ve = JSON.stringify(R, function(M, k) {
          var $ = K(k);
          return $ === "symbol" ? String(k) : k;
        });
        return new p("Invalid " + j + " `" + z + "` of value `" + String(re) + "` " + ("supplied to `" + Q + "`, expected one of " + ve + "."));
      }
      return v(U);
    }
    function E(R) {
      function U(H, D, Q, j, z) {
        if (typeof R != "function")
          return new p("Property `" + z + "` of component `" + Q + "` has invalid PropType notation inside objectOf.");
        var re = H[D], Z = _(re);
        if (Z !== "object")
          return new p("Invalid " + j + " `" + z + "` of type " + ("`" + Z + "` supplied to `" + Q + "`, expected an object."));
        for (var ve in re)
          if (r(re, ve)) {
            var L = R(re, ve, Q, j, z + "." + ve, t);
            if (L instanceof Error)
              return L;
          }
        return null;
      }
      return v(U);
    }
    function T(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var U = 0; U < R.length; U++) {
        var H = R[U];
        if (typeof H != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Y(H) + " at index " + U + "."
          ), i;
      }
      function D(Q, j, z, re, Z) {
        for (var ve = [], L = 0; L < R.length; L++) {
          var M = R[L], k = M(Q, j, z, re, Z, t);
          if (k == null)
            return null;
          k.data && r(k.data, "expectedType") && ve.push(k.data.expectedType);
        }
        var $ = ve.length > 0 ? ", expected one of type [" + ve.join(", ") + "]" : "";
        return new p("Invalid " + re + " `" + Z + "` supplied to " + ("`" + z + "`" + $ + "."));
      }
      return v(D);
    }
    function S() {
      function R(U, H, D, Q, j) {
        return V(U[H]) ? null : new p("Invalid " + Q + " `" + j + "` supplied to " + ("`" + D + "`, expected a ReactNode."));
      }
      return v(R);
    }
    function b(R, U, H, D, Q) {
      return new p(
        (R || "React class") + ": " + U + " type `" + H + "." + D + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Q + "`."
      );
    }
    function N(R) {
      function U(H, D, Q, j, z) {
        var re = H[D], Z = _(re);
        if (Z !== "object")
          return new p("Invalid " + j + " `" + z + "` of type `" + Z + "` " + ("supplied to `" + Q + "`, expected `object`."));
        for (var ve in R) {
          var L = R[ve];
          if (typeof L != "function")
            return b(Q, j, z, ve, K(L));
          var M = L(re, ve, Q, j, z + "." + ve, t);
          if (M)
            return M;
        }
        return null;
      }
      return v(U);
    }
    function O(R) {
      function U(H, D, Q, j, z) {
        var re = H[D], Z = _(re);
        if (Z !== "object")
          return new p("Invalid " + j + " `" + z + "` of type `" + Z + "` " + ("supplied to `" + Q + "`, expected `object`."));
        var ve = A({}, H[D], R);
        for (var L in ve) {
          var M = R[L];
          if (r(R, L) && typeof M != "function")
            return b(Q, j, z, L, K(M));
          if (!M)
            return new p(
              "Invalid " + j + " `" + z + "` key `" + L + "` supplied to `" + Q + "`.\nBad object: " + JSON.stringify(H[D], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(R), null, "  ")
            );
          var k = M(re, L, Q, j, z + "." + L, t);
          if (k)
            return k;
        }
        return null;
      }
      return v(U);
    }
    function V(R) {
      switch (typeof R) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !R;
        case "object":
          if (Array.isArray(R))
            return R.every(V);
          if (R === null || s(R))
            return !0;
          var U = c(R);
          if (U) {
            var H = U.call(R), D;
            if (U !== R.entries) {
              for (; !(D = H.next()).done; )
                if (!V(D.value))
                  return !1;
            } else
              for (; !(D = H.next()).done; ) {
                var Q = D.value;
                if (Q && !V(Q[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function I(R, U) {
      return R === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function _(R) {
      var U = typeof R;
      return Array.isArray(R) ? "array" : R instanceof RegExp ? "object" : I(U, R) ? "symbol" : U;
    }
    function K(R) {
      if (typeof R > "u" || R === null)
        return "" + R;
      var U = _(R);
      if (U === "object") {
        if (R instanceof Date)
          return "date";
        if (R instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function Y(R) {
      var U = K(R);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function X(R) {
      return !R.constructor || !R.constructor.name ? f : R.constructor.name;
    }
    return d.checkPropTypes = n, d.resetWarningCache = n.resetWarningCache, d.PropTypes = d, d;
  }, Kc;
}
var $c, UB;
function gK() {
  if (UB)
    return $c;
  UB = 1;
  var e = Pd();
  function A() {
  }
  function t() {
  }
  return t.resetWarningCache = A, $c = function() {
    function r(i, s, o, u, l, c) {
      if (c !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: t,
      resetWarningCache: A
    };
    return a.PropTypes = a, a;
  }, $c;
}
var _B;
function BK() {
  if (_B)
    return Hs.exports;
  if (_B = 1, process.env.NODE_ENV !== "production") {
    var e = kd, A = !0;
    Hs.exports = pK()(e.isElement, A);
  } else
    Hs.exports = gK()();
  return Hs.exports;
}
var QB;
function vK() {
  return QB || (QB = 1, function(e) {
    (function(A, t) {
      t(e, Rr, BK());
    })(te, function(A, t, r) {
      Object.defineProperty(A, "__esModule", {
        value: !0
      }), A.setHasSupportToCaptureOption = h;
      var n = i(t), a = i(r);
      function i(g) {
        return g && g.__esModule ? g : {
          default: g
        };
      }
      var s = Object.assign || function(g) {
        for (var B = 1; B < arguments.length; B++) {
          var w = arguments[B];
          for (var m in w)
            Object.prototype.hasOwnProperty.call(w, m) && (g[m] = w[m]);
        }
        return g;
      };
      function o(g, B) {
        var w = {};
        for (var m in g)
          B.indexOf(m) >= 0 || Object.prototype.hasOwnProperty.call(g, m) && (w[m] = g[m]);
        return w;
      }
      function u(g, B) {
        if (!(g instanceof B))
          throw new TypeError("Cannot call a class as a function");
      }
      var l = function() {
        function g(B, w) {
          for (var m = 0; m < w.length; m++) {
            var x = w[m];
            x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(B, x.key, x);
          }
        }
        return function(B, w, m) {
          return w && g(B.prototype, w), m && g(B, m), B;
        };
      }();
      function c(g, B) {
        if (!g)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return B && (typeof B == "object" || typeof B == "function") ? B : g;
      }
      function f(g, B) {
        if (typeof B != "function" && B !== null)
          throw new TypeError("Super expression must either be null or a function, not " + typeof B);
        g.prototype = Object.create(B && B.prototype, {
          constructor: {
            value: g,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), B && (Object.setPrototypeOf ? Object.setPrototypeOf(g, B) : g.__proto__ = B);
      }
      var d = !1;
      function h(g) {
        d = g;
      }
      try {
        addEventListener("test", null, Object.defineProperty({}, "capture", { get: function() {
          h(!0);
        } }));
      } catch {
      }
      function p() {
        var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { capture: !0 };
        return d ? g : g.capture;
      }
      function v(g) {
        if ("touches" in g) {
          var B = g.touches[0], w = B.pageX, m = B.pageY;
          return { x: w, y: m };
        }
        var x = g.screenX, C = g.screenY;
        return { x, y: C };
      }
      var y = function(g) {
        f(B, g);
        function B() {
          var w;
          u(this, B);
          for (var m = arguments.length, x = Array(m), C = 0; C < m; C++)
            x[C] = arguments[C];
          var E = c(this, (w = B.__proto__ || Object.getPrototypeOf(B)).call.apply(w, [this].concat(x)));
          return E._handleSwipeStart = E._handleSwipeStart.bind(E), E._handleSwipeMove = E._handleSwipeMove.bind(E), E._handleSwipeEnd = E._handleSwipeEnd.bind(E), E._onMouseDown = E._onMouseDown.bind(E), E._onMouseMove = E._onMouseMove.bind(E), E._onMouseUp = E._onMouseUp.bind(E), E._setSwiperRef = E._setSwiperRef.bind(E), E;
        }
        return l(B, [{
          key: "componentDidMount",
          value: function() {
            this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, p({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "componentWillUnmount",
          value: function() {
            this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, p({
              capture: !0,
              passive: !1
            }));
          }
        }, {
          key: "_onMouseDown",
          value: function(m) {
            this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(m));
          }
        }, {
          key: "_onMouseMove",
          value: function(m) {
            this.mouseDown && this._handleSwipeMove(m);
          }
        }, {
          key: "_onMouseUp",
          value: function(m) {
            this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(m);
          }
        }, {
          key: "_handleSwipeStart",
          value: function(m) {
            var x = v(m), C = x.x, E = x.y;
            this.moveStart = { x: C, y: E }, this.props.onSwipeStart(m);
          }
        }, {
          key: "_handleSwipeMove",
          value: function(m) {
            if (this.moveStart) {
              var x = v(m), C = x.x, E = x.y, T = C - this.moveStart.x, S = E - this.moveStart.y;
              this.moving = !0;
              var b = this.props.onSwipeMove({
                x: T,
                y: S
              }, m);
              b && m.cancelable && m.preventDefault(), this.movePosition = { deltaX: T, deltaY: S };
            }
          }
        }, {
          key: "_handleSwipeEnd",
          value: function(m) {
            this.props.onSwipeEnd(m);
            var x = this.props.tolerance;
            this.moving && this.movePosition && (this.movePosition.deltaX < -x ? this.props.onSwipeLeft(1, m) : this.movePosition.deltaX > x && this.props.onSwipeRight(1, m), this.movePosition.deltaY < -x ? this.props.onSwipeUp(1, m) : this.movePosition.deltaY > x && this.props.onSwipeDown(1, m)), this.moveStart = null, this.moving = !1, this.movePosition = null;
          }
        }, {
          key: "_setSwiperRef",
          value: function(m) {
            this.swiper = m, this.props.innerRef(m);
          }
        }, {
          key: "render",
          value: function() {
            var m = this.props;
            m.tagName;
            var x = m.className, C = m.style, E = m.children;
            m.allowMouseEvents, m.onSwipeUp, m.onSwipeDown, m.onSwipeLeft, m.onSwipeRight, m.onSwipeStart, m.onSwipeMove, m.onSwipeEnd, m.innerRef, m.tolerance;
            var T = o(m, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]);
            return n.default.createElement(
              this.props.tagName,
              s({
                ref: this._setSwiperRef,
                onMouseDown: this._onMouseDown,
                onTouchStart: this._handleSwipeStart,
                onTouchEnd: this._handleSwipeEnd,
                className: x,
                style: C
              }, T),
              E
            );
          }
        }]), B;
      }(t.Component);
      y.displayName = "ReactSwipe", y.propTypes = {
        tagName: a.default.string,
        className: a.default.string,
        style: a.default.object,
        children: a.default.node,
        allowMouseEvents: a.default.bool,
        onSwipeUp: a.default.func,
        onSwipeDown: a.default.func,
        onSwipeLeft: a.default.func,
        onSwipeRight: a.default.func,
        onSwipeStart: a.default.func,
        onSwipeMove: a.default.func,
        onSwipeEnd: a.default.func,
        innerRef: a.default.func,
        tolerance: a.default.number.isRequired
      }, y.defaultProps = {
        tagName: "div",
        allowMouseEvents: !1,
        onSwipeUp: function() {
        },
        onSwipeDown: function() {
        },
        onSwipeLeft: function() {
        },
        onSwipeRight: function() {
        },
        onSwipeStart: function() {
        },
        onSwipeMove: function() {
        },
        onSwipeEnd: function() {
        },
        innerRef: function() {
        },
        tolerance: 0
      }, A.default = y;
    });
  }(Mc)), Mc;
}
(function(e) {
  (function(A, t) {
    t(e, vK());
  })(te, function(A, t) {
    Object.defineProperty(A, "__esModule", {
      value: !0
    });
    var r = n(t);
    function n(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    A.default = r.default;
  });
})(Nd);
var zi = {}, Hx = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var A = {}.hasOwnProperty;
    function t() {
      for (var r = [], n = 0; n < arguments.length; n++) {
        var a = arguments[n];
        if (a) {
          var i = typeof a;
          if (i === "string" || i === "number")
            r.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var s = t.apply(null, a);
              s && r.push(s);
            }
          } else if (i === "object") {
            if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]")) {
              r.push(a.toString());
              continue;
            }
            for (var o in a)
              A.call(a, o) && a[o] && r.push(o);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(Hx);
var mK = Hx.exports;
Object.defineProperty(zi, "__esModule", {
  value: !0
});
zi.default = void 0;
var xr = wK(mK);
function wK(e) {
  return e && e.__esModule ? e : { default: e };
}
function yK(e, A, t) {
  return A in e ? Object.defineProperty(e, A, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[A] = t, e;
}
var xK = {
  ROOT: function(A) {
    return (0, xr.default)(yK({
      "carousel-root": !0
    }, A || "", !!A));
  },
  CAROUSEL: function(A) {
    return (0, xr.default)({
      carousel: !0,
      "carousel-slider": A
    });
  },
  WRAPPER: function(A, t) {
    return (0, xr.default)({
      "thumbs-wrapper": !A,
      "slider-wrapper": A,
      "axis-horizontal": t === "horizontal",
      "axis-vertical": t !== "horizontal"
    });
  },
  SLIDER: function(A, t) {
    return (0, xr.default)({
      thumbs: !A,
      slider: A,
      animated: !t
    });
  },
  ITEM: function(A, t, r) {
    return (0, xr.default)({
      thumb: !A,
      slide: A,
      selected: t,
      previous: r
    });
  },
  ARROW_PREV: function(A) {
    return (0, xr.default)({
      "control-arrow control-prev": !0,
      "control-disabled": A
    });
  },
  ARROW_NEXT: function(A) {
    return (0, xr.default)({
      "control-arrow control-next": !0,
      "control-disabled": A
    });
  },
  DOT: function(A) {
    return (0, xr.default)({
      dot: !0,
      selected: A
    });
  }
};
zi.default = xK;
var Xi = {}, Ju = {};
Object.defineProperty(Ju, "__esModule", {
  value: !0
});
Ju.outerWidth = void 0;
var CK = function(A) {
  var t = A.offsetWidth, r = getComputedStyle(A);
  return t += parseInt(r.marginLeft) + parseInt(r.marginRight), t;
};
Ju.outerWidth = CK;
var Qa = {};
Object.defineProperty(Qa, "__esModule", {
  value: !0
});
Qa.default = void 0;
var EK = function(A, t, r) {
  var n = A === 0 ? A : A + t, a = r === "horizontal" ? [n, 0, 0] : [0, n, 0], i = "translate3d", s = "(" + a.join(",") + ")";
  return i + s;
};
Qa.default = EK;
var qi = {};
Object.defineProperty(qi, "__esModule", {
  value: !0
});
qi.default = void 0;
var FK = function() {
  return window;
};
qi.default = FK;
Object.defineProperty(Xi, "__esModule", {
  value: !0
});
Xi.default = void 0;
var ct = UK(Rr), Zr = Zu(zi), bK = Ju, IB = Zu(Qa), SK = Zu(Nd), Ls = Zu(qi);
function Zu(e) {
  return e && e.__esModule ? e : { default: e };
}
function Lx() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return Lx = function() {
    return e;
  }, e;
}
function UK(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || hi(e) !== "object" && typeof e != "function")
    return { default: e };
  var A = Lx();
  if (A && A.has(e))
    return A.get(e);
  var t = {}, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      var a = r ? Object.getOwnPropertyDescriptor(e, n) : null;
      a && (a.get || a.set) ? Object.defineProperty(t, n, a) : t[n] = e[n];
    }
  return t.default = e, A && A.set(e, t), t;
}
function hi(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? hi = function(t) {
    return typeof t;
  } : hi = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hi(e);
}
function A0() {
  return A0 = Object.assign || function(e) {
    for (var A = 1; A < arguments.length; A++) {
      var t = arguments[A];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, A0.apply(this, arguments);
}
function _K(e, A) {
  if (!(e instanceof A))
    throw new TypeError("Cannot call a class as a function");
}
function DB(e, A) {
  for (var t = 0; t < A.length; t++) {
    var r = A[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function QK(e, A, t) {
  return A && DB(e.prototype, A), t && DB(e, t), e;
}
function IK(e, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(A && A.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), A && t0(e, A);
}
function t0(e, A) {
  return t0 = Object.setPrototypeOf || function(r, n) {
    return r.__proto__ = n, r;
  }, t0(e, A);
}
function DK(e) {
  var A = OK();
  return function() {
    var r = No(e), n;
    if (A) {
      var a = No(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return TK(this, n);
  };
}
function TK(e, A) {
  return A && (hi(A) === "object" || typeof A == "function") ? A : HA(e);
}
function HA(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function OK() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function No(e) {
  return No = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, No(e);
}
function bA(e, A, t) {
  return A in e ? Object.defineProperty(e, A, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[A] = t, e;
}
var HK = function(A) {
  return A.hasOwnProperty("key");
}, Kd = /* @__PURE__ */ function(e) {
  IK(t, e);
  var A = DK(t);
  function t(r) {
    var n;
    return _K(this, t), n = A.call(this, r), bA(HA(n), "itemsWrapperRef", void 0), bA(HA(n), "itemsListRef", void 0), bA(HA(n), "thumbsRef", void 0), bA(HA(n), "setItemsWrapperRef", function(a) {
      n.itemsWrapperRef = a;
    }), bA(HA(n), "setItemsListRef", function(a) {
      n.itemsListRef = a;
    }), bA(HA(n), "setThumbsRef", function(a, i) {
      n.thumbsRef || (n.thumbsRef = []), n.thumbsRef[i] = a;
    }), bA(HA(n), "updateSizes", function() {
      if (!(!n.props.children || !n.itemsWrapperRef || !n.thumbsRef)) {
        var a = ct.Children.count(n.props.children), i = n.itemsWrapperRef.clientWidth, s = n.props.thumbWidth ? n.props.thumbWidth : (0, bK.outerWidth)(n.thumbsRef[0]), o = Math.floor(i / s), u = o < a, l = u ? a - o : 0;
        n.setState(function(c, f) {
          return {
            itemSize: s,
            visibleItems: o,
            firstItem: u ? n.getFirstItem(f.selectedItem) : 0,
            lastPosition: l,
            showArrows: u
          };
        });
      }
    }), bA(HA(n), "handleClickItem", function(a, i, s) {
      if (!HK(s) || s.key === "Enter") {
        var o = n.props.onSelectItem;
        typeof o == "function" && o(a, i);
      }
    }), bA(HA(n), "onSwipeStart", function() {
      n.setState({
        swiping: !0
      });
    }), bA(HA(n), "onSwipeEnd", function() {
      n.setState({
        swiping: !1
      });
    }), bA(HA(n), "onSwipeMove", function(a) {
      var i = a.x;
      if (!n.state.itemSize || !n.itemsWrapperRef || !n.state.visibleItems)
        return !1;
      var s = 0, o = ct.Children.count(n.props.children), u = -(n.state.firstItem * 100) / n.state.visibleItems, l = Math.max(o - n.state.visibleItems, 0), c = -l * 100 / n.state.visibleItems;
      u === s && i > 0 && (i = 0), u === c && i < 0 && (i = 0);
      var f = n.itemsWrapperRef.clientWidth, d = u + 100 / (f / i);
      return n.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(h) {
        n.itemsListRef.style[h] = (0, IB.default)(d, "%", n.props.axis);
      }), !0;
    }), bA(HA(n), "slideRight", function(a) {
      n.moveTo(n.state.firstItem - (typeof a == "number" ? a : 1));
    }), bA(HA(n), "slideLeft", function(a) {
      n.moveTo(n.state.firstItem + (typeof a == "number" ? a : 1));
    }), bA(HA(n), "moveTo", function(a) {
      a = a < 0 ? 0 : a, a = a >= n.state.lastPosition ? n.state.lastPosition : a, n.setState({
        firstItem: a
      });
    }), n.state = {
      selectedItem: r.selectedItem,
      swiping: !1,
      showArrows: !1,
      firstItem: 0,
      visibleItems: 0,
      lastPosition: 0
    }, n;
  }
  return QK(t, [{
    key: "componentDidMount",
    value: function() {
      this.setupThumbs();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      this.props.selectedItem !== this.state.selectedItem && this.setState({
        selectedItem: this.props.selectedItem,
        firstItem: this.getFirstItem(this.props.selectedItem)
      }), this.props.children !== n.children && this.updateSizes();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyThumbs();
    }
  }, {
    key: "setupThumbs",
    value: function() {
      (0, Ls.default)().addEventListener("resize", this.updateSizes), (0, Ls.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
    }
  }, {
    key: "destroyThumbs",
    value: function() {
      (0, Ls.default)().removeEventListener("resize", this.updateSizes), (0, Ls.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
    }
  }, {
    key: "getFirstItem",
    value: function(n) {
      var a = n;
      return n >= this.state.lastPosition && (a = this.state.lastPosition), n < this.state.firstItem + this.state.visibleItems && (a = this.state.firstItem), n < this.state.firstItem && (a = n), a;
    }
  }, {
    key: "renderItems",
    value: function() {
      var n = this;
      return this.props.children.map(function(a, i) {
        var s = Zr.default.ITEM(!1, i === n.state.selectedItem), o = {
          key: i,
          ref: function(l) {
            return n.setThumbsRef(l, i);
          },
          className: s,
          onClick: n.handleClickItem.bind(n, i, n.props.children[i]),
          onKeyDown: n.handleClickItem.bind(n, i, n.props.children[i]),
          "aria-label": "".concat(n.props.labels.item, " ").concat(i + 1),
          style: {
            width: n.props.thumbWidth
          }
        };
        return /* @__PURE__ */ ct.default.createElement("li", A0({}, o, {
          role: "button",
          tabIndex: 0
        }), a);
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this;
      if (!this.props.children)
        return null;
      var a = ct.Children.count(this.props.children) > 1, i = this.state.showArrows && this.state.firstItem > 0, s = this.state.showArrows && this.state.firstItem < this.state.lastPosition, o = {}, u = -this.state.firstItem * (this.state.itemSize || 0), l = (0, IB.default)(u, "px", this.props.axis), c = this.props.transitionTime + "ms";
      return o = {
        WebkitTransform: l,
        MozTransform: l,
        MsTransform: l,
        OTransform: l,
        transform: l,
        msTransform: l,
        WebkitTransitionDuration: c,
        MozTransitionDuration: c,
        MsTransitionDuration: c,
        OTransitionDuration: c,
        transitionDuration: c,
        msTransitionDuration: c
      }, /* @__PURE__ */ ct.default.createElement("div", {
        className: Zr.default.CAROUSEL(!1)
      }, /* @__PURE__ */ ct.default.createElement("div", {
        className: Zr.default.WRAPPER(!1),
        ref: this.setItemsWrapperRef
      }, /* @__PURE__ */ ct.default.createElement("button", {
        type: "button",
        className: Zr.default.ARROW_PREV(!i),
        onClick: function() {
          return n.slideRight();
        },
        "aria-label": this.props.labels.leftArrow
      }), a ? /* @__PURE__ */ ct.default.createElement(SK.default, {
        tagName: "ul",
        className: Zr.default.SLIDER(!1, this.state.swiping),
        onSwipeLeft: this.slideLeft,
        onSwipeRight: this.slideRight,
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: o,
        innerRef: this.setItemsListRef,
        allowMouseEvents: this.props.emulateTouch
      }, this.renderItems()) : /* @__PURE__ */ ct.default.createElement("ul", {
        className: Zr.default.SLIDER(!1, this.state.swiping),
        ref: function(d) {
          return n.setItemsListRef(d);
        },
        style: o
      }, this.renderItems()), /* @__PURE__ */ ct.default.createElement("button", {
        type: "button",
        className: Zr.default.ARROW_NEXT(!s),
        onClick: function() {
          return n.slideLeft();
        },
        "aria-label": this.props.labels.rightArrow
      })));
    }
  }]), t;
}(ct.Component);
Xi.default = Kd;
bA(Kd, "displayName", "Thumbs");
bA(Kd, "defaultProps", {
  axis: "horizontal",
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  selectedItem: 0,
  thumbWidth: 80,
  transitionTime: 350
});
var el = {};
Object.defineProperty(el, "__esModule", {
  value: !0
});
el.default = void 0;
var LK = function() {
  return document;
};
el.default = LK;
var zA = {};
Object.defineProperty(zA, "__esModule", {
  value: !0
});
zA.setPosition = zA.getPosition = zA.isKeyboardEvent = zA.defaultStatusFormatter = zA.noop = void 0;
var MK = Rr, RK = NK(Qa);
function NK(e) {
  return e && e.__esModule ? e : { default: e };
}
var kK = function() {
};
zA.noop = kK;
var PK = function(A, t) {
  return "".concat(A, " of ").concat(t);
};
zA.defaultStatusFormatter = PK;
var KK = function(A) {
  return A ? A.hasOwnProperty("key") : !1;
};
zA.isKeyboardEvent = KK;
var $K = function(A, t) {
  if (t.infiniteLoop && ++A, A === 0)
    return 0;
  var r = MK.Children.count(t.children);
  if (t.centerMode && t.axis === "horizontal") {
    var n = -A * t.centerSlidePercentage, a = r - 1;
    return A && (A !== a || t.infiniteLoop) ? n += (100 - t.centerSlidePercentage) / 2 : A === a && (n += 100 - t.centerSlidePercentage), n;
  }
  return -A * 100;
};
zA.getPosition = $K;
var jK = function(A, t) {
  var r = {};
  return ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function(n) {
    r[n] = (0, RK.default)(A, "%", t);
  }), r;
};
zA.setPosition = jK;
var Lt = {};
Object.defineProperty(Lt, "__esModule", {
  value: !0
});
Lt.fadeAnimationHandler = Lt.slideStopSwipingHandler = Lt.slideSwipeAnimationHandler = Lt.slideAnimationHandler = void 0;
var Mx = Rr, GK = VK(Qa), Mt = zA;
function VK(e) {
  return e && e.__esModule ? e : { default: e };
}
function TB(e, A) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    A && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function on(e) {
  for (var A = 1; A < arguments.length; A++) {
    var t = arguments[A] != null ? arguments[A] : {};
    A % 2 ? TB(Object(t), !0).forEach(function(r) {
      WK(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TB(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function WK(e, A, t) {
  return A in e ? Object.defineProperty(e, A, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[A] = t, e;
}
var YK = function(A, t) {
  var r = {}, n = t.selectedItem, a = n, i = Mx.Children.count(A.children) - 1, s = A.infiniteLoop && (n < 0 || n > i);
  if (s)
    return a < 0 ? A.centerMode && A.centerSlidePercentage && A.axis === "horizontal" ? r.itemListStyle = (0, Mt.setPosition)(-(i + 2) * A.centerSlidePercentage - (100 - A.centerSlidePercentage) / 2, A.axis) : r.itemListStyle = (0, Mt.setPosition)(-(i + 2) * 100, A.axis) : a > i && (r.itemListStyle = (0, Mt.setPosition)(0, A.axis)), r;
  var o = (0, Mt.getPosition)(n, A), u = (0, GK.default)(o, "%", A.axis), l = A.transitionTime + "ms";
  return r.itemListStyle = {
    WebkitTransform: u,
    msTransform: u,
    OTransform: u,
    transform: u
  }, t.swiping || (r.itemListStyle = on(on({}, r.itemListStyle), {}, {
    WebkitTransitionDuration: l,
    MozTransitionDuration: l,
    OTransitionDuration: l,
    transitionDuration: l,
    msTransitionDuration: l
  })), r;
};
Lt.slideAnimationHandler = YK;
var zK = function(A, t, r, n) {
  var a = {}, i = t.axis === "horizontal", s = Mx.Children.count(t.children), o = 0, u = (0, Mt.getPosition)(r.selectedItem, t), l = t.infiniteLoop ? (0, Mt.getPosition)(s - 1, t) - 100 : (0, Mt.getPosition)(s - 1, t), c = i ? A.x : A.y, f = c;
  u === o && c > 0 && (f = 0), u === l && c < 0 && (f = 0);
  var d = u + 100 / (r.itemSize / f), h = Math.abs(c) > t.swipeScrollTolerance;
  return t.infiniteLoop && h && (r.selectedItem === 0 && d > -100 ? d -= s * 100 : r.selectedItem === s - 1 && d < -s * 100 && (d += s * 100)), (!t.preventMovementUntilSwipeScrollTolerance || h || r.swipeMovementStarted) && (r.swipeMovementStarted || n({
    swipeMovementStarted: !0
  }), a.itemListStyle = (0, Mt.setPosition)(d, t.axis)), h && !r.cancelClick && n({
    cancelClick: !0
  }), a;
};
Lt.slideSwipeAnimationHandler = zK;
var XK = function(A, t) {
  var r = (0, Mt.getPosition)(t.selectedItem, A), n = (0, Mt.setPosition)(r, A.axis);
  return {
    itemListStyle: n
  };
};
Lt.slideStopSwipingHandler = XK;
var qK = function(A, t) {
  var r = A.transitionTime + "ms", n = "ease-in-out", a = {
    position: "absolute",
    display: "block",
    zIndex: -2,
    minHeight: "100%",
    opacity: 0,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transitionTimingFunction: n,
    msTransitionTimingFunction: n,
    MozTransitionTimingFunction: n,
    WebkitTransitionTimingFunction: n,
    OTransitionTimingFunction: n
  };
  return t.swiping || (a = on(on({}, a), {}, {
    WebkitTransitionDuration: r,
    MozTransitionDuration: r,
    OTransitionDuration: r,
    transitionDuration: r,
    msTransitionDuration: r
  })), {
    slideStyle: a,
    selectedStyle: on(on({}, a), {}, {
      opacity: 1,
      position: "relative"
    }),
    prevStyle: on({}, a)
  };
};
Lt.fadeAnimationHandler = qK;
Object.defineProperty(qu, "__esModule", {
  value: !0
});
qu.default = void 0;
var Ne = e$(Rr), JK = Ji(Nd), tr = Ji(zi), ZK = Ji(Xi), Ms = Ji(el), Rs = Ji(qi), ti = zA, ko = Lt;
function Ji(e) {
  return e && e.__esModule ? e : { default: e };
}
function Rx() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return Rx = function() {
    return e;
  }, e;
}
function e$(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || pi(e) !== "object" && typeof e != "function")
    return { default: e };
  var A = Rx();
  if (A && A.has(e))
    return A.get(e);
  var t = {}, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      var a = r ? Object.getOwnPropertyDescriptor(e, n) : null;
      a && (a.get || a.set) ? Object.defineProperty(t, n, a) : t[n] = e[n];
    }
  return t.default = e, A && A.set(e, t), t;
}
function pi(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? pi = function(t) {
    return typeof t;
  } : pi = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pi(e);
}
function r0() {
  return r0 = Object.assign || function(e) {
    for (var A = 1; A < arguments.length; A++) {
      var t = arguments[A];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, r0.apply(this, arguments);
}
function OB(e, A) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    A && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ft(e) {
  for (var A = 1; A < arguments.length; A++) {
    var t = arguments[A] != null ? arguments[A] : {};
    A % 2 ? OB(Object(t), !0).forEach(function(r) {
      me(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : OB(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function A$(e, A) {
  if (!(e instanceof A))
    throw new TypeError("Cannot call a class as a function");
}
function HB(e, A) {
  for (var t = 0; t < A.length; t++) {
    var r = A[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function t$(e, A, t) {
  return A && HB(e.prototype, A), t && HB(e, t), e;
}
function r$(e, A) {
  if (typeof A != "function" && A !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(A && A.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), A && n0(e, A);
}
function n0(e, A) {
  return n0 = Object.setPrototypeOf || function(r, n) {
    return r.__proto__ = n, r;
  }, n0(e, A);
}
function n$(e) {
  var A = i$();
  return function() {
    var r = Po(e), n;
    if (A) {
      var a = Po(this).constructor;
      n = Reflect.construct(r, arguments, a);
    } else
      n = r.apply(this, arguments);
    return a$(this, n);
  };
}
function a$(e, A) {
  return A && (pi(A) === "object" || typeof A == "function") ? A : we(e);
}
function we(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function i$() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Po(e) {
  return Po = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Po(e);
}
function me(e, A, t) {
  return A in e ? Object.defineProperty(e, A, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[A] = t, e;
}
var $d = /* @__PURE__ */ function(e) {
  r$(t, e);
  var A = n$(t);
  function t(r) {
    var n;
    A$(this, t), n = A.call(this, r), me(we(n), "thumbsRef", void 0), me(we(n), "carouselWrapperRef", void 0), me(we(n), "listRef", void 0), me(we(n), "itemsRef", void 0), me(we(n), "timer", void 0), me(we(n), "animationHandler", void 0), me(we(n), "setThumbsRef", function(i) {
      n.thumbsRef = i;
    }), me(we(n), "setCarouselWrapperRef", function(i) {
      n.carouselWrapperRef = i;
    }), me(we(n), "setListRef", function(i) {
      n.listRef = i;
    }), me(we(n), "setItemsRef", function(i, s) {
      n.itemsRef || (n.itemsRef = []), n.itemsRef[s] = i;
    }), me(we(n), "autoPlay", function() {
      Ne.Children.count(n.props.children) <= 1 || (n.clearAutoPlay(), n.props.autoPlay && (n.timer = setTimeout(function() {
        n.increment();
      }, n.props.interval)));
    }), me(we(n), "clearAutoPlay", function() {
      n.timer && clearTimeout(n.timer);
    }), me(we(n), "resetAutoPlay", function() {
      n.clearAutoPlay(), n.autoPlay();
    }), me(we(n), "stopOnHover", function() {
      n.setState({
        isMouseEntered: !0
      }, n.clearAutoPlay);
    }), me(we(n), "startOnLeave", function() {
      n.setState({
        isMouseEntered: !1
      }, n.autoPlay);
    }), me(we(n), "isFocusWithinTheCarousel", function() {
      return n.carouselWrapperRef ? !!((0, Ms.default)().activeElement === n.carouselWrapperRef || n.carouselWrapperRef.contains((0, Ms.default)().activeElement)) : !1;
    }), me(we(n), "navigateWithKeyboard", function(i) {
      if (n.isFocusWithinTheCarousel()) {
        var s = n.props.axis, o = s === "horizontal", u = {
          ArrowUp: 38,
          ArrowRight: 39,
          ArrowDown: 40,
          ArrowLeft: 37
        }, l = o ? u.ArrowRight : u.ArrowDown, c = o ? u.ArrowLeft : u.ArrowUp;
        l === i.keyCode ? n.increment() : c === i.keyCode && n.decrement();
      }
    }), me(we(n), "updateSizes", function() {
      if (!(!n.state.initialized || !n.itemsRef || n.itemsRef.length === 0)) {
        var i = n.props.axis === "horizontal", s = n.itemsRef[0];
        if (s) {
          var o = i ? s.clientWidth : s.clientHeight;
          n.setState({
            itemSize: o
          }), n.thumbsRef && n.thumbsRef.updateSizes();
        }
      }
    }), me(we(n), "setMountState", function() {
      n.setState({
        hasMount: !0
      }), n.updateSizes();
    }), me(we(n), "handleClickItem", function(i, s) {
      if (Ne.Children.count(n.props.children) !== 0) {
        if (n.state.cancelClick) {
          n.setState({
            cancelClick: !1
          });
          return;
        }
        n.props.onClickItem(i, s), i !== n.state.selectedItem && n.setState({
          selectedItem: i
        });
      }
    }), me(we(n), "handleOnChange", function(i, s) {
      Ne.Children.count(n.props.children) <= 1 || n.props.onChange(i, s);
    }), me(we(n), "handleClickThumb", function(i, s) {
      n.props.onClickThumb(i, s), n.moveTo(i);
    }), me(we(n), "onSwipeStart", function(i) {
      n.setState({
        swiping: !0
      }), n.props.onSwipeStart(i);
    }), me(we(n), "onSwipeEnd", function(i) {
      n.setState({
        swiping: !1,
        cancelClick: !1,
        swipeMovementStarted: !1
      }), n.props.onSwipeEnd(i), n.clearAutoPlay(), n.state.autoPlay && n.autoPlay();
    }), me(we(n), "onSwipeMove", function(i, s) {
      n.props.onSwipeMove(s);
      var o = n.props.swipeAnimationHandler(i, n.props, n.state, n.setState.bind(we(n)));
      return n.setState(ft({}, o)), !!Object.keys(o).length;
    }), me(we(n), "decrement", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      n.moveTo(n.state.selectedItem - (typeof i == "number" ? i : 1));
    }), me(we(n), "increment", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
      n.moveTo(n.state.selectedItem + (typeof i == "number" ? i : 1));
    }), me(we(n), "moveTo", function(i) {
      if (typeof i == "number") {
        var s = Ne.Children.count(n.props.children) - 1;
        i < 0 && (i = n.props.infiniteLoop ? s : 0), i > s && (i = n.props.infiniteLoop ? 0 : s), n.selectItem({
          // if it's not a slider, we don't need to set position here
          selectedItem: i
        }), n.state.autoPlay && n.state.isMouseEntered === !1 && n.resetAutoPlay();
      }
    }), me(we(n), "onClickNext", function() {
      n.increment(1);
    }), me(we(n), "onClickPrev", function() {
      n.decrement(1);
    }), me(we(n), "onSwipeForward", function() {
      n.increment(1), n.props.emulateTouch && n.setState({
        cancelClick: !0
      });
    }), me(we(n), "onSwipeBackwards", function() {
      n.decrement(1), n.props.emulateTouch && n.setState({
        cancelClick: !0
      });
    }), me(we(n), "changeItem", function(i) {
      return function(s) {
        (!(0, ti.isKeyboardEvent)(s) || s.key === "Enter") && n.moveTo(i);
      };
    }), me(we(n), "selectItem", function(i) {
      n.setState(ft({
        previousItem: n.state.selectedItem
      }, i), function() {
        n.setState(n.animationHandler(n.props, n.state));
      }), n.handleOnChange(i.selectedItem, Ne.Children.toArray(n.props.children)[i.selectedItem]);
    }), me(we(n), "getInitialImage", function() {
      var i = n.props.selectedItem, s = n.itemsRef && n.itemsRef[i], o = s && s.getElementsByTagName("img") || [];
      return o[0];
    }), me(we(n), "getVariableItemHeight", function(i) {
      var s = n.itemsRef && n.itemsRef[i];
      if (n.state.hasMount && s && s.children.length) {
        var o = s.children[0].getElementsByTagName("img") || [];
        if (o.length > 0) {
          var u = o[0];
          if (!u.complete) {
            var l = function d() {
              n.forceUpdate(), u.removeEventListener("load", d);
            };
            u.addEventListener("load", l);
          }
        }
        var c = o[0] || s.children[0], f = c.clientHeight;
        return f > 0 ? f : null;
      }
      return null;
    });
    var a = {
      initialized: !1,
      previousItem: r.selectedItem,
      selectedItem: r.selectedItem,
      hasMount: !1,
      isMouseEntered: !1,
      autoPlay: r.autoPlay,
      swiping: !1,
      swipeMovementStarted: !1,
      cancelClick: !1,
      itemSize: 1,
      itemListStyle: {},
      slideStyle: {},
      selectedStyle: {},
      prevStyle: {}
    };
    return n.animationHandler = typeof r.animationHandler == "function" && r.animationHandler || r.animationHandler === "fade" && ko.fadeAnimationHandler || ko.slideAnimationHandler, n.state = ft(ft({}, a), n.animationHandler(r, a)), n;
  }
  return t$(t, [{
    key: "componentDidMount",
    value: function() {
      this.props.children && this.setupCarousel();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, a) {
      !n.children && this.props.children && !this.state.initialized && this.setupCarousel(), !n.autoFocus && this.props.autoFocus && this.forceFocus(), a.swiping && !this.state.swiping && this.setState(ft({}, this.props.stopSwipingHandler(this.props, this.state))), (n.selectedItem !== this.props.selectedItem || n.centerMode !== this.props.centerMode) && (this.updateSizes(), this.moveTo(this.props.selectedItem)), n.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
        autoPlay: this.props.autoPlay
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.destroyCarousel();
    }
  }, {
    key: "setupCarousel",
    value: function() {
      var n = this;
      this.bindEvents(), this.state.autoPlay && Ne.Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.props.autoFocus && this.forceFocus(), this.setState({
        initialized: !0
      }, function() {
        var a = n.getInitialImage();
        a && !a.complete ? a.addEventListener("load", n.setMountState) : n.setMountState();
      });
    }
  }, {
    key: "destroyCarousel",
    value: function() {
      this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
    }
  }, {
    key: "setupAutoPlay",
    value: function() {
      this.autoPlay();
      var n = this.carouselWrapperRef;
      this.props.stopOnHover && n && (n.addEventListener("mouseenter", this.stopOnHover), n.addEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "destroyAutoPlay",
    value: function() {
      this.clearAutoPlay();
      var n = this.carouselWrapperRef;
      this.props.stopOnHover && n && (n.removeEventListener("mouseenter", this.stopOnHover), n.removeEventListener("mouseleave", this.startOnLeave));
    }
  }, {
    key: "bindEvents",
    value: function() {
      (0, Rs.default)().addEventListener("resize", this.updateSizes), (0, Rs.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && (0, Ms.default)().addEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "unbindEvents",
    value: function() {
      (0, Rs.default)().removeEventListener("resize", this.updateSizes), (0, Rs.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
      var n = this.getInitialImage();
      n && n.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && (0, Ms.default)().removeEventListener("keydown", this.navigateWithKeyboard);
    }
  }, {
    key: "forceFocus",
    value: function() {
      var n;
      (n = this.carouselWrapperRef) === null || n === void 0 || n.focus();
    }
  }, {
    key: "renderItems",
    value: function(n) {
      var a = this;
      return this.props.children ? Ne.Children.map(this.props.children, function(i, s) {
        var o = s === a.state.selectedItem, u = s === a.state.previousItem, l = o && a.state.selectedStyle || u && a.state.prevStyle || a.state.slideStyle || {};
        a.props.centerMode && a.props.axis === "horizontal" && (l = ft(ft({}, l), {}, {
          minWidth: a.props.centerSlidePercentage + "%"
        })), a.state.swiping && a.state.swipeMovementStarted && (l = ft(ft({}, l), {}, {
          pointerEvents: "none"
        }));
        var c = {
          ref: function(d) {
            return a.setItemsRef(d, s);
          },
          key: "itemKey" + s + (n ? "clone" : ""),
          className: tr.default.ITEM(!0, s === a.state.selectedItem, s === a.state.previousItem),
          onClick: a.handleClickItem.bind(a, s, i),
          style: l
        };
        return /* @__PURE__ */ Ne.default.createElement("li", c, a.props.renderItem(i, {
          isSelected: s === a.state.selectedItem,
          isPrevious: s === a.state.previousItem
        }));
      }) : [];
    }
  }, {
    key: "renderControls",
    value: function() {
      var n = this, a = this.props, i = a.showIndicators, s = a.labels, o = a.renderIndicator, u = a.children;
      return i ? /* @__PURE__ */ Ne.default.createElement("ul", {
        className: "control-dots"
      }, Ne.Children.map(u, function(l, c) {
        return o && o(n.changeItem(c), c === n.state.selectedItem, c, s.item);
      })) : null;
    }
  }, {
    key: "renderStatus",
    value: function() {
      return this.props.showStatus ? /* @__PURE__ */ Ne.default.createElement("p", {
        className: "carousel-status"
      }, this.props.statusFormatter(this.state.selectedItem + 1, Ne.Children.count(this.props.children))) : null;
    }
  }, {
    key: "renderThumbs",
    value: function() {
      return !this.props.showThumbs || !this.props.children || Ne.Children.count(this.props.children) === 0 ? null : /* @__PURE__ */ Ne.default.createElement(ZK.default, {
        ref: this.setThumbsRef,
        onSelectItem: this.handleClickThumb,
        selectedItem: this.state.selectedItem,
        transitionTime: this.props.transitionTime,
        thumbWidth: this.props.thumbWidth,
        labels: this.props.labels,
        emulateTouch: this.props.emulateTouch
      }, this.props.renderThumbs(this.props.children));
    }
  }, {
    key: "render",
    value: function() {
      var n = this;
      if (!this.props.children || Ne.Children.count(this.props.children) === 0)
        return null;
      var a = this.props.swipeable && Ne.Children.count(this.props.children) > 1, i = this.props.axis === "horizontal", s = this.props.showArrows && Ne.Children.count(this.props.children) > 1, o = s && (this.state.selectedItem > 0 || this.props.infiniteLoop) || !1, u = s && (this.state.selectedItem < Ne.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || !1, l = this.renderItems(!0), c = l.shift(), f = l.pop(), d = {
        className: tr.default.SLIDER(!0, this.state.swiping),
        onSwipeMove: this.onSwipeMove,
        onSwipeStart: this.onSwipeStart,
        onSwipeEnd: this.onSwipeEnd,
        style: this.state.itemListStyle,
        tolerance: this.props.swipeScrollTolerance
      }, h = {};
      if (i) {
        if (d.onSwipeLeft = this.onSwipeForward, d.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
          var p = this.getVariableItemHeight(this.state.selectedItem);
          h.height = p || "auto";
        }
      } else
        d.onSwipeUp = this.props.verticalSwipe === "natural" ? this.onSwipeBackwards : this.onSwipeForward, d.onSwipeDown = this.props.verticalSwipe === "natural" ? this.onSwipeForward : this.onSwipeBackwards, d.style = ft(ft({}, d.style), {}, {
          height: this.state.itemSize
        }), h.height = this.state.itemSize;
      return /* @__PURE__ */ Ne.default.createElement("div", {
        "aria-label": this.props.ariaLabel,
        className: tr.default.ROOT(this.props.className),
        ref: this.setCarouselWrapperRef,
        tabIndex: this.props.useKeyboardArrows ? 0 : void 0
      }, /* @__PURE__ */ Ne.default.createElement("div", {
        className: tr.default.CAROUSEL(!0),
        style: {
          width: this.props.width
        }
      }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, o, this.props.labels.leftArrow), /* @__PURE__ */ Ne.default.createElement("div", {
        className: tr.default.WRAPPER(!0, this.props.axis),
        style: h
      }, a ? /* @__PURE__ */ Ne.default.createElement(JK.default, r0({
        tagName: "ul",
        innerRef: this.setListRef
      }, d, {
        allowMouseEvents: this.props.emulateTouch
      }), this.props.infiniteLoop && f, this.renderItems(), this.props.infiniteLoop && c) : /* @__PURE__ */ Ne.default.createElement("ul", {
        className: tr.default.SLIDER(!0, this.state.swiping),
        ref: function(y) {
          return n.setListRef(y);
        },
        style: this.state.itemListStyle || {}
      }, this.props.infiniteLoop && f, this.renderItems(), this.props.infiniteLoop && c)), this.props.renderArrowNext(this.onClickNext, u, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
    }
  }]), t;
}(Ne.default.Component);
qu.default = $d;
me($d, "displayName", "Carousel");
me($d, "defaultProps", {
  ariaLabel: void 0,
  axis: "horizontal",
  centerSlidePercentage: 80,
  interval: 3e3,
  labels: {
    leftArrow: "previous slide / item",
    rightArrow: "next slide / item",
    item: "slide item"
  },
  onClickItem: ti.noop,
  onClickThumb: ti.noop,
  onChange: ti.noop,
  onSwipeStart: function() {
  },
  onSwipeEnd: function() {
  },
  onSwipeMove: function() {
    return !1;
  },
  preventMovementUntilSwipeScrollTolerance: !1,
  renderArrowPrev: function(A, t, r) {
    return /* @__PURE__ */ Ne.default.createElement("button", {
      type: "button",
      "aria-label": r,
      className: tr.default.ARROW_PREV(!t),
      onClick: A
    });
  },
  renderArrowNext: function(A, t, r) {
    return /* @__PURE__ */ Ne.default.createElement("button", {
      type: "button",
      "aria-label": r,
      className: tr.default.ARROW_NEXT(!t),
      onClick: A
    });
  },
  renderIndicator: function(A, t, r, n) {
    return /* @__PURE__ */ Ne.default.createElement("li", {
      className: tr.default.DOT(t),
      onClick: A,
      onKeyDown: A,
      value: r,
      key: r,
      role: "button",
      tabIndex: 0,
      "aria-label": "".concat(n, " ").concat(r + 1)
    });
  },
  renderItem: function(A) {
    return A;
  },
  renderThumbs: function(A) {
    var t = Ne.Children.map(A, function(r) {
      var n = r;
      if (r.type !== "img" && (n = Ne.Children.toArray(r.props.children).find(function(a) {
        return a.type === "img";
      })), !!n)
        return n;
    });
    return t.filter(function(r) {
      return r;
    }).length === 0 ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : t;
  },
  statusFormatter: ti.defaultStatusFormatter,
  selectedItem: 0,
  showArrows: !0,
  showIndicators: !0,
  showStatus: !0,
  showThumbs: !0,
  stopOnHover: !0,
  swipeScrollTolerance: 5,
  swipeable: !0,
  transitionTime: 350,
  verticalSwipe: "standard",
  width: "100%",
  animationHandler: "slide",
  swipeAnimationHandler: ko.slideSwipeAnimationHandler,
  stopSwipingHandler: ko.slideStopSwipingHandler
});
var s$ = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "Carousel", {
    enumerable: !0,
    get: function() {
      return A.default;
    }
  }), Object.defineProperty(e, "CarouselProps", {
    enumerable: !0,
    get: function() {
      return t.CarouselProps;
    }
  }), Object.defineProperty(e, "Thumbs", {
    enumerable: !0,
    get: function() {
      return r.default;
    }
  });
  var A = n(qu), t = s$, r = n(Xi);
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
})(lK);
const o$ = /constructor/i.test(window.HTMLElement) || function(e) {
  return e.toString() === "[object SafariRemoteNotification]";
}(
  !window.safari || window.safari.pushNotification
), Nx = !!document.documentMode, u$ = !Nx && !!window.StyleMedia, kx = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime), l$ = kx && navigator.userAgent.indexOf("Edg") != -1, c$ = {
  isSafari: o$,
  isIE: Nx,
  isEdge: u$,
  isChrome: kx,
  isEdgeChromium: l$
}, f$ = () => {
  let e = window.navigator.userAgent, A = window.navigator.platform || navigator.userAgentData.platform, t = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"], r = ["Win32", "Win64", "Windows", "WinCE"], n = ["iPhone", "iPad", "iPod"], a = "";
  return t.indexOf(A) !== -1 ? a = "MACOS" : n.indexOf(A) !== -1 ? a = "IOS" : r.indexOf(A) !== -1 ? a = "WINDOWS" : /Android/.test(e) ? a = "ANDROID" : !a && /Linux/.test(A) && (a = "LINUX"), a;
}, ZAe = () => {
  const e = f$();
  return console.log("OS:", e), ["MACOS"].includes(e) && !c$.isSafari ? "video/webm" : ["MACOS", "IOS"].includes(e) ? "video/mp4" : "video/webm";
};
(function() {
  typeof window > "u" || (navigator.mediaDevices === void 0 && (navigator.mediaDevices = {}), navigator.mediaDevices.getUserMedia === void 0 && (navigator.mediaDevices.getUserMedia = function(A) {
    const t = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
    return t ? new Promise(function(r, n) {
      t.call(navigator, A, r, n);
    }) : (console.log("getUserMedia is not implemented in this browser"), Promise.reject(new Error("getUserMedia is not implemented in this browser")));
  }));
})();
function ete() {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var oe = function() {
  return oe = Object.assign || function(A) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (A[a] = t[a]);
    }
    return A;
  }, oe.apply(this, arguments);
};
function jd(e, A) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && A.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)
      A.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (t[r[n]] = e[r[n]]);
  return t;
}
function aA(e) {
  var A = typeof Symbol == "function" && Symbol.iterator, t = A && e[A], r = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(A ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function ke(e, A) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var r = t.call(e), n, a = [], i;
  try {
    for (; (A === void 0 || A-- > 0) && !(n = r.next()).done; )
      a.push(n.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      n && !n.done && (t = r.return) && t.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return a;
}
function nA(e, A, t) {
  if (t || arguments.length === 2)
    for (var r = 0, n = A.length, a; r < n; r++)
      (a || !(r in A)) && (a || (a = Array.prototype.slice.call(A, 0, r)), a[r] = A[r]);
  return e.concat(a || Array.prototype.slice.call(A));
}
var je;
(function(e) {
  e.Start = "xstate.start", e.Stop = "xstate.stop", e.Raise = "xstate.raise", e.Send = "xstate.send", e.Cancel = "xstate.cancel", e.NullEvent = "", e.Assign = "xstate.assign", e.After = "xstate.after", e.DoneState = "done.state", e.DoneInvoke = "done.invoke", e.Log = "xstate.log", e.Init = "xstate.init", e.Invoke = "xstate.invoke", e.ErrorExecution = "error.execution", e.ErrorCommunication = "error.communication", e.ErrorPlatform = "error.platform", e.ErrorCustom = "xstate.error", e.Update = "xstate.update", e.Pure = "xstate.pure", e.Choose = "xstate.choose";
})(je || (je = {}));
var Ko;
(function(e) {
  e.Parent = "#_parent", e.Internal = "#_internal";
})(Ko || (Ko = {}));
var LB = je.Start, Px = je.Stop, Al = je.Raise, Gd = je.Send, d$ = je.Cancel, h$ = je.NullEvent, Vd = je.Assign;
je.After;
je.DoneState;
var p$ = je.Log, g$ = je.Init, a0 = je.Invoke;
je.ErrorExecution;
var Ate = je.ErrorPlatform, tte = je.ErrorCustom, B$ = je.Update, v$ = je.Choose, m$ = je.Pure, Kx = ".", MB = {}, i0 = "xstate.guard", w$ = "", nt = process.env.NODE_ENV === "production", Ns;
function Wd(e, A, t) {
  t === void 0 && (t = Kx);
  var r = gi(e, t), n = gi(A, t);
  return Te(n) ? Te(r) ? n === r : !1 : Te(r) ? r in n : Object.keys(r).every(function(a) {
    return a in n ? Wd(r[a], n[a]) : !1;
  });
}
function $x(e) {
  try {
    return Te(e) || typeof e == "number" ? "".concat(e) : e.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function s0(e, A) {
  try {
    return Zi(e) ? e : e.toString().split(A);
  } catch {
    throw new Error("'".concat(e, "' is not a valid state path."));
  }
}
function y$(e) {
  return typeof e == "object" && "value" in e && "context" in e && "event" in e && "_event" in e;
}
function gi(e, A) {
  if (y$(e))
    return e.value;
  if (Zi(e))
    return $o(e);
  if (typeof e != "string")
    return e;
  var t = s0(e, A);
  return $o(t);
}
function $o(e) {
  if (e.length === 1)
    return e[0];
  for (var A = {}, t = A, r = 0; r < e.length - 1; r++)
    r === e.length - 2 ? t[e[r]] = e[r + 1] : (t[e[r]] = {}, t = t[e[r]]);
  return A;
}
function ri(e, A) {
  for (var t = {}, r = Object.keys(e), n = 0; n < r.length; n++) {
    var a = r[n];
    t[a] = A(e[a], a, e, n);
  }
  return t;
}
function RB(e, A, t) {
  var r, n, a = {};
  try {
    for (var i = aA(Object.keys(e)), s = i.next(); !s.done; s = i.next()) {
      var o = s.value, u = e[o];
      t(u) && (a[o] = A(u, o, e));
    }
  } catch (l) {
    r = {
      error: l
    };
  } finally {
    try {
      s && !s.done && (n = i.return) && n.call(i);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return a;
}
var x$ = function(e) {
  return function(A) {
    var t, r, n = A;
    try {
      for (var a = aA(e), i = a.next(); !i.done; i = a.next()) {
        var s = i.value;
        n = n[s];
      }
    } catch (o) {
      t = {
        error: o
      };
    } finally {
      try {
        i && !i.done && (r = a.return) && r.call(a);
      } finally {
        if (t)
          throw t.error;
      }
    }
    return n;
  };
};
function C$(e, A) {
  return function(t) {
    var r, n, a = t;
    try {
      for (var i = aA(e), s = i.next(); !s.done; s = i.next()) {
        var o = s.value;
        a = a[A][o];
      }
    } catch (u) {
      r = {
        error: u
      };
    } finally {
      try {
        s && !s.done && (n = i.return) && n.call(i);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return a;
  };
}
function ao(e) {
  if (!e)
    return [[]];
  if (Te(e))
    return [[e]];
  var A = sA(Object.keys(e).map(function(t) {
    var r = e[t];
    return typeof r != "string" && (!r || !Object.keys(r).length) ? [[t]] : ao(e[t]).map(function(n) {
      return [t].concat(n);
    });
  }));
  return A;
}
function sA(e) {
  var A;
  return (A = []).concat.apply(A, nA([], ke(e), !1));
}
function jx(e) {
  return Zi(e) ? e : [e];
}
function pt(e) {
  return e === void 0 ? [] : jx(e);
}
function Gx(e, A, t) {
  var r, n;
  if (Je(e))
    return e(A, t.data);
  var a = {};
  try {
    for (var i = aA(Object.keys(e)), s = i.next(); !s.done; s = i.next()) {
      var o = s.value, u = e[o];
      Je(u) ? a[o] = u(A, t.data) : a[o] = u;
    }
  } catch (l) {
    r = {
      error: l
    };
  } finally {
    try {
      s && !s.done && (n = i.return) && n.call(i);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return a;
}
function E$(e) {
  return /^(done|error)\./.test(e);
}
function rte(e) {
  return !!(e instanceof Promise || e !== null && (Je(e) || typeof e == "object") && Je(e.then));
}
function nte(e) {
  return e !== null && typeof e == "object" && "transition" in e && typeof e.transition == "function";
}
function F$(e, A) {
  var t, r, n = ke([[], []], 2), a = n[0], i = n[1];
  try {
    for (var s = aA(e), o = s.next(); !o.done; o = s.next()) {
      var u = o.value;
      A(u) ? a.push(u) : i.push(u);
    }
  } catch (l) {
    t = {
      error: l
    };
  } finally {
    try {
      o && !o.done && (r = s.return) && r.call(s);
    } finally {
      if (t)
        throw t.error;
    }
  }
  return [a, i];
}
function Vx(e, A) {
  return ri(e.states, function(t, r) {
    if (t) {
      var n = (Te(A) ? void 0 : A[r]) || (t ? t.current : void 0);
      if (n)
        return {
          current: n,
          states: Vx(t, n)
        };
    }
  });
}
function b$(e, A) {
  return {
    current: A,
    states: Vx(e, A)
  };
}
function NB(e, A, t, r) {
  nt || ir(!!e, "Attempting to update undefined context");
  var n = e && t.reduce(function(a, i) {
    var s, o, u = i.assignment, l = {
      state: r,
      action: i,
      _event: A
    }, c = {};
    if (Je(u))
      c = u(a, A.data, l);
    else
      try {
        for (var f = aA(Object.keys(u)), d = f.next(); !d.done; d = f.next()) {
          var h = d.value, p = u[h];
          c[h] = Je(p) ? p(a, A.data, l) : p;
        }
      } catch (v) {
        s = {
          error: v
        };
      } finally {
        try {
          d && !d.done && (o = f.return) && o.call(f);
        } finally {
          if (s)
            throw s.error;
        }
      }
    return Object.assign({}, a, c);
  }, e);
  return n;
}
var ir = function() {
};
nt || (ir = function(e, A) {
  var t = e instanceof Error ? e : void 0;
  if (!(!t && e) && console !== void 0) {
    var r = ["Warning: ".concat(A)];
    t && r.push(t), console.warn.apply(console, r);
  }
});
function Zi(e) {
  return Array.isArray(e);
}
function Je(e) {
  return typeof e == "function";
}
function Te(e) {
  return typeof e == "string";
}
function Wx(e, A) {
  if (e)
    return Te(e) ? {
      type: i0,
      name: e,
      predicate: A ? A[e] : void 0
    } : Je(e) ? {
      type: i0,
      name: e.name,
      predicate: e
    } : e;
}
function ate(e) {
  try {
    return "subscribe" in e && Je(e.subscribe);
  } catch {
    return !1;
  }
}
var Yd = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
Ns = {}, Ns[Yd] = function() {
  return this;
}, Ns[Symbol.observable] = function() {
  return this;
};
function Si(e) {
  return !!e && "__xstatenode" in e;
}
function ite(e) {
  return !!e && typeof e.send == "function";
}
function zd(e, A) {
  return Te(e) || typeof e == "number" ? oe({
    type: e
  }, A) : e;
}
function Ui(e, A) {
  if (!Te(e) && "$$type" in e && e.$$type === "scxml")
    return e;
  var t = zd(e);
  return oe({
    name: t.type,
    data: t,
    $$type: "scxml",
    type: "external"
  }, A);
}
function Yn(e, A) {
  var t = jx(A).map(function(r) {
    return typeof r > "u" || typeof r == "string" || Si(r) ? {
      target: r,
      event: e
    } : oe(oe({}, r), {
      event: e
    });
  });
  return t;
}
function S$(e) {
  if (!(e === void 0 || e === w$))
    return pt(e);
}
function ste(e, A, t) {
  if (!nt) {
    var r = e.stack ? " Stacktrace was '".concat(e.stack, "'") : "";
    if (e === A)
      console.error("Missing onError handler for invocation '".concat(t, "', error was '").concat(e, "'.").concat(r));
    else {
      var n = A.stack ? " Stacktrace was '".concat(A.stack, "'") : "";
      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(t, "'. ") + "Original error: '".concat(e, "'. ").concat(r, " Current error is '").concat(A, "'.").concat(n));
    }
  }
}
function Yx(e, A, t, r, n) {
  var a = e.options.guards, i = {
    state: n,
    cond: A,
    _event: r
  };
  if (A.type === i0)
    return ((a == null ? void 0 : a[A.name]) || A.predicate)(t, r.data, i);
  var s = a == null ? void 0 : a[A.type];
  if (!s)
    throw new Error("Guard '".concat(A.type, "' is not implemented on machine '").concat(e.id, "'."));
  return s(t, r.data, i);
}
function U$(e) {
  return typeof e == "string" ? {
    type: e
  } : e;
}
function ote(e, A, t) {
  var r = function() {
  }, n = typeof e == "object", a = n ? e : null;
  return {
    next: ((n ? e.next : e) || r).bind(a),
    error: ((n ? e.error : A) || r).bind(a),
    complete: ((n ? e.complete : t) || r).bind(a)
  };
}
function ks(e, A) {
  return "".concat(e, ":invocation[").concat(A, "]");
}
function kB(e) {
  return (e.type === Al || e.type === Gd && e.to === Ko.Internal) && typeof e.delay != "number";
}
var o0 = /* @__PURE__ */ Ui({
  type: g$
});
function PB(e, A) {
  return A && A[e] || void 0;
}
function _i(e, A) {
  var t;
  if (Te(e) || typeof e == "number") {
    var r = PB(e, A);
    Je(r) ? t = {
      type: e,
      exec: r
    } : r ? t = r : t = {
      type: e,
      exec: void 0
    };
  } else if (Je(e))
    t = {
      // Convert action to string if unnamed
      type: e.name || e.toString(),
      exec: e
    };
  else {
    var r = PB(e.type, A);
    if (Je(r))
      t = oe(oe({}, e), {
        exec: r
      });
    else if (r) {
      var n = r.type || e.type;
      t = oe(oe(oe({}, r), e), {
        type: n
      });
    } else
      t = e;
  }
  return t;
}
var un = function(e, A) {
  if (!e)
    return [];
  var t = Zi(e) ? e : [e];
  return t.map(function(r) {
    return _i(r, A);
  });
};
function Xd(e) {
  var A = _i(e);
  return oe(oe({
    id: Te(e) ? e : A.id
  }, A), {
    type: A.type
  });
}
function _$(e, A) {
  return {
    type: Al,
    event: typeof e == "function" ? e : zd(e),
    delay: A ? A.delay : void 0,
    id: A == null ? void 0 : A.id
  };
}
function Q$(e, A, t, r) {
  var n = {
    _event: t
  }, a = Ui(Je(e.event) ? e.event(A, t.data, n) : e.event), i;
  if (Te(e.delay)) {
    var s = r && r[e.delay];
    i = Je(s) ? s(A, t.data, n) : s;
  } else
    i = Je(e.delay) ? e.delay(A, t.data, n) : e.delay;
  return oe(oe({}, e), {
    type: Al,
    _event: a,
    delay: i
  });
}
function I$(e, A) {
  return {
    to: A ? A.to : void 0,
    type: Gd,
    event: Je(e) ? e : zd(e),
    delay: A ? A.delay : void 0,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: A && A.id !== void 0 ? A.id : Je(e) ? e.name : $x(e)
  };
}
function D$(e, A, t, r) {
  var n = {
    _event: t
  }, a = Ui(Je(e.event) ? e.event(A, t.data, n) : e.event), i;
  if (Te(e.delay)) {
    var s = r && r[e.delay];
    i = Je(s) ? s(A, t.data, n) : s;
  } else
    i = Je(e.delay) ? e.delay(A, t.data, n) : e.delay;
  var o = Je(e.to) ? e.to(A, t.data, n) : e.to;
  return oe(oe({}, e), {
    to: o,
    _event: a,
    event: a.data,
    delay: i
  });
}
var T$ = function(e, A, t) {
  return oe(oe({}, e), {
    value: Te(e.expr) ? e.expr : e.expr(A, t.data, {
      _event: t
    })
  });
}, O$ = function(e) {
  return {
    type: d$,
    sendId: e
  };
};
function H$(e) {
  var A = Xd(e);
  return {
    type: je.Start,
    activity: A,
    exec: void 0
  };
}
function L$(e) {
  var A = Je(e) ? e : Xd(e);
  return {
    type: je.Stop,
    activity: A,
    exec: void 0
  };
}
function M$(e, A, t) {
  var r = Je(e.activity) ? e.activity(A, t.data) : e.activity, n = typeof r == "string" ? {
    id: r
  } : r, a = {
    type: je.Stop,
    activity: n
  };
  return a;
}
var R$ = function(e) {
  return {
    type: Vd,
    assignment: e
  };
};
function N$(e, A) {
  var t = A ? "#".concat(A) : "";
  return "".concat(je.After, "(").concat(e, ")").concat(t);
}
function Ps(e, A) {
  var t = "".concat(je.DoneState, ".").concat(e), r = {
    type: t,
    data: A
  };
  return r.toString = function() {
    return t;
  }, r;
}
function k$(e, A) {
  var t = "".concat(je.DoneInvoke, ".").concat(e), r = {
    type: t,
    data: A
  };
  return r.toString = function() {
    return t;
  }, r;
}
function P$(e, A) {
  var t = "".concat(je.ErrorPlatform, ".").concat(e), r = {
    type: t,
    data: A
  };
  return r.toString = function() {
    return t;
  }, r;
}
var K$ = function(e) {
  var A, t, r = [];
  try {
    for (var n = aA(e), a = n.next(); !a.done; a = n.next())
      for (var i = a.value, s = 0; s < i.actions.length; ) {
        if (i.actions[s].type === Vd) {
          r.push(i.actions[s]), i.actions.splice(s, 1);
          continue;
        }
        s++;
      }
  } catch (o) {
    A = {
      error: o
    };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (A)
        throw A.error;
    }
  }
  return r;
};
function u0(e, A, t, r, n, a, i) {
  i === void 0 && (i = !1);
  var s = i ? [] : K$(n), o = s.length ? NB(t, r, s, A) : t, u = i ? [t] : void 0, l = [];
  function c(h, p) {
    var v;
    switch (p.type) {
      case Al: {
        var y = Q$(p, o, r, e.options.delays);
        return a && typeof y.delay == "number" && a(y, o, r), y;
      }
      case Gd:
        var g = D$(p, o, r, e.options.delays);
        if (!nt) {
          var B = p.delay;
          ir(
            !Te(B) || typeof g.delay == "number",
            // tslint:disable-next-line:max-line-length
            "No delay reference for delay expression '".concat(B, "' was found on machine '").concat(e.id, "'")
          );
        }
        return a && g.to !== Ko.Internal && (h === "entry" ? l.push(g) : a(g, o, r)), g;
      case p$: {
        var w = T$(p, o, r);
        return a == null || a(w, o, r), w;
      }
      case v$: {
        var m = p, x = (v = m.conds.find(function(K) {
          var Y = Wx(K.cond, e.options.guards);
          return !Y || Yx(e, Y, o, r, a ? void 0 : A);
        })) === null || v === void 0 ? void 0 : v.actions;
        if (!x)
          return [];
        var C = ke(u0(e, A, o, r, [{
          type: h,
          actions: un(pt(x), e.options.actions)
        }], a, i), 2), E = C[0], T = C[1];
        return o = T, u == null || u.push(o), E;
      }
      case m$: {
        var x = p.get(o, r.data);
        if (!x)
          return [];
        var S = ke(u0(e, A, o, r, [{
          type: h,
          actions: un(pt(x), e.options.actions)
        }], a, i), 2), b = S[0], N = S[1];
        return o = N, u == null || u.push(o), b;
      }
      case Px: {
        var w = M$(p, o, r);
        return a == null || a(w, t, r), w;
      }
      case Vd: {
        o = NB(o, r, [p], a ? void 0 : A), u == null || u.push(o);
        break;
      }
      default:
        var O = _i(p, e.options.actions), V = O.exec;
        if (a)
          a(O, o, r);
        else if (V && u) {
          var I = u.length - 1, _ = oe(oe({}, O), {
            exec: function(K) {
              for (var Y = [], X = 1; X < arguments.length; X++)
                Y[X - 1] = arguments[X];
              V.apply(void 0, nA([u[I]], ke(Y), !1));
            }
          });
          O = _;
        }
        return O;
    }
  }
  function f(h) {
    var p, v, y = [];
    try {
      for (var g = aA(h.actions), B = g.next(); !B.done; B = g.next()) {
        var w = B.value, m = c(h.type, w);
        m && (y = y.concat(m));
      }
    } catch (x) {
      p = {
        error: x
      };
    } finally {
      try {
        B && !B.done && (v = g.return) && v.call(g);
      } finally {
        if (p)
          throw p.error;
      }
    }
    return l.forEach(function(x) {
      a(x, o, r);
    }), l.length = 0, y;
  }
  var d = sA(n.map(f));
  return [d, o];
}
var KB = [], $$ = function(e, A) {
  KB.push(e);
  var t = A(e);
  return KB.pop(), t;
};
function zx(e) {
  var A;
  return A = {
    id: e,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: e
      };
    }
  }, A[Yd] = function() {
    return this;
  }, A;
}
function j$(e, A, t, r) {
  var n, a = U$(e.src), i = (n = A == null ? void 0 : A.options.services) === null || n === void 0 ? void 0 : n[a.type], s = e.data ? Gx(e.data, t, r) : void 0, o = i ? G$(i, e.id, s) : zx(e.id);
  return o.meta = e, o;
}
function G$(e, A, t) {
  var r = zx(A);
  if (r.deferred = !0, Si(e)) {
    var n = r.state = $$(void 0, function() {
      return (t ? e.withContext(t) : e).initialState;
    });
    r.getSnapshot = function() {
      return n;
    };
  }
  return r;
}
function V$(e) {
  try {
    return typeof e.send == "function";
  } catch {
    return !1;
  }
}
function ute(e) {
  return V$(e) && "id" in e;
}
function lte(e) {
  var A;
  return oe((A = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, A[Yd] = function() {
    return this;
  }, A), e);
}
var jo = function(e) {
  return e.type === "atomic" || e.type === "final";
};
function Xx(e) {
  return Object.keys(e.states).map(function(A) {
    return e.states[A];
  });
}
function Qi(e) {
  return Xx(e).filter(function(A) {
    return A.type !== "history";
  });
}
function qx(e) {
  var A = [e];
  return jo(e) ? A : A.concat(sA(Qi(e).map(qx)));
}
function ni(e, A) {
  var t, r, n, a, i, s, o, u, l = new Set(e), c = l0(l), f = new Set(A);
  try {
    for (var d = aA(f), h = d.next(); !h.done; h = d.next())
      for (var p = h.value, v = p.parent; v && !f.has(v); )
        f.add(v), v = v.parent;
  } catch (T) {
    t = {
      error: T
    };
  } finally {
    try {
      h && !h.done && (r = d.return) && r.call(d);
    } finally {
      if (t)
        throw t.error;
    }
  }
  var y = l0(f);
  try {
    for (var g = aA(f), B = g.next(); !B.done; B = g.next()) {
      var p = B.value;
      if (p.type === "compound" && (!y.get(p) || !y.get(p).length))
        c.get(p) ? c.get(p).forEach(function(S) {
          return f.add(S);
        }) : p.initialStateNodes.forEach(function(S) {
          return f.add(S);
        });
      else if (p.type === "parallel")
        try {
          for (var w = (i = void 0, aA(Qi(p))), m = w.next(); !m.done; m = w.next()) {
            var x = m.value;
            f.has(x) || (f.add(x), c.get(x) ? c.get(x).forEach(function(S) {
              return f.add(S);
            }) : x.initialStateNodes.forEach(function(S) {
              return f.add(S);
            }));
          }
        } catch (S) {
          i = {
            error: S
          };
        } finally {
          try {
            m && !m.done && (s = w.return) && s.call(w);
          } finally {
            if (i)
              throw i.error;
          }
        }
    }
  } catch (T) {
    n = {
      error: T
    };
  } finally {
    try {
      B && !B.done && (a = g.return) && a.call(g);
    } finally {
      if (n)
        throw n.error;
    }
  }
  try {
    for (var C = aA(f), E = C.next(); !E.done; E = C.next())
      for (var p = E.value, v = p.parent; v && !f.has(v); )
        f.add(v), v = v.parent;
  } catch (T) {
    o = {
      error: T
    };
  } finally {
    try {
      E && !E.done && (u = C.return) && u.call(C);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return f;
}
function Jx(e, A) {
  var t = A.get(e);
  if (!t)
    return {};
  if (e.type === "compound") {
    var r = t[0];
    if (r) {
      if (jo(r))
        return r.key;
    } else
      return {};
  }
  var n = {};
  return t.forEach(function(a) {
    n[a.key] = Jx(a, A);
  }), n;
}
function l0(e) {
  var A, t, r = /* @__PURE__ */ new Map();
  try {
    for (var n = aA(e), a = n.next(); !a.done; a = n.next()) {
      var i = a.value;
      r.has(i) || r.set(i, []), i.parent && (r.has(i.parent) || r.set(i.parent, []), r.get(i.parent).push(i));
    }
  } catch (s) {
    A = {
      error: s
    };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (A)
        throw A.error;
    }
  }
  return r;
}
function W$(e, A) {
  var t = ni([e], A);
  return Jx(e, l0(t));
}
function ai(e, A) {
  return Array.isArray(e) ? e.some(function(t) {
    return t === A;
  }) : e instanceof Set ? e.has(A) : !1;
}
function Y$(e) {
  return nA([], ke(new Set(sA(nA([], ke(e.map(function(A) {
    return A.ownEvents;
  })), !1)))), !1);
}
function io(e, A) {
  return A.type === "compound" ? Qi(A).some(function(t) {
    return t.type === "final" && ai(e, t);
  }) : A.type === "parallel" ? Qi(A).every(function(t) {
    return io(e, t);
  }) : !1;
}
function z$(e) {
  return e === void 0 && (e = []), e.reduce(function(A, t) {
    return t.meta !== void 0 && (A[t.id] = t.meta), A;
  }, {});
}
function $B(e) {
  return new Set(sA(e.map(function(A) {
    return A.tags;
  })));
}
function Zx(e, A) {
  if (e === A)
    return !0;
  if (e === void 0 || A === void 0)
    return !1;
  if (Te(e) || Te(A))
    return e === A;
  var t = Object.keys(e), r = Object.keys(A);
  return t.length === r.length && t.every(function(n) {
    return Zx(e[n], A[n]);
  });
}
function cte(e) {
  return typeof e != "object" || e === null ? !1 : "value" in e && "_event" in e;
}
function fte(e, A) {
  var t = e.exec, r = oe(oe({}, e), {
    exec: t !== void 0 ? function() {
      return t(A.context, A.event, {
        action: e,
        state: A,
        _event: A._event
      });
    } : void 0
  });
  return r;
}
var Cr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(A) {
      var t = this, r;
      this.actions = [], this.activities = MB, this.meta = {}, this.events = [], this.value = A.value, this.context = A.context, this._event = A._event, this._sessionid = A._sessionid, this.event = this._event.data, this.historyValue = A.historyValue, this.history = A.history, this.actions = A.actions || [], this.activities = A.activities || MB, this.meta = z$(A.configuration), this.events = A.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = A.configuration, this.transitions = A.transitions, this.children = A.children, this.done = !!A.done, this.tags = (r = Array.isArray(A.tags) ? new Set(A.tags) : A.tags) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set(), this.machine = A.machine, Object.defineProperty(this, "nextEvents", {
        get: function() {
          return Y$(t.configuration);
        }
      });
    }
    return e.from = function(A, t) {
      if (A instanceof e)
        return A.context !== t ? new e({
          value: A.value,
          context: t,
          _event: A._event,
          _sessionid: null,
          historyValue: A.historyValue,
          history: A.history,
          actions: [],
          activities: A.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        }) : A;
      var r = o0;
      return new e({
        value: A,
        context: t,
        _event: r,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        meta: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, e.create = function(A) {
      return new e(A);
    }, e.inert = function(A, t) {
      if (A instanceof e) {
        if (!A.actions.length)
          return A;
        var r = o0;
        return new e({
          value: A.value,
          context: t,
          _event: r,
          _sessionid: null,
          historyValue: A.historyValue,
          history: A.history,
          activities: A.activities,
          configuration: A.configuration,
          transitions: [],
          children: {}
        });
      }
      return e.from(A, t);
    }, e.prototype.toStrings = function(A, t) {
      var r = this;
      if (A === void 0 && (A = this.value), t === void 0 && (t = "."), Te(A))
        return [A];
      var n = Object.keys(A);
      return n.concat.apply(n, nA([], ke(n.map(function(a) {
        return r.toStrings(A[a], t).map(function(i) {
          return a + t + i;
        });
      })), !1));
    }, e.prototype.toJSON = function() {
      var A = this;
      A.configuration, A.transitions;
      var t = A.tags;
      A.machine;
      var r = jd(A, ["configuration", "transitions", "tags", "machine"]);
      return oe(oe({}, r), {
        tags: Array.from(t)
      });
    }, e.prototype.matches = function(A) {
      return Wd(A, this.value);
    }, e.prototype.hasTag = function(A) {
      return this.tags.has(A);
    }, e.prototype.can = function(A) {
      var t;
      nt && ir(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
      var r = (t = this.machine) === null || t === void 0 ? void 0 : t.getTransitionData(this, A);
      return !!(r != null && r.transitions.length) && // Check that at least one transition is not forbidden
      r.transitions.some(function(n) {
        return n.target !== void 0 || n.actions.length;
      });
    }, e;
  }()
);
function X$(e) {
  if (typeof e == "string") {
    var A = {
      type: e
    };
    return A.toString = function() {
      return e;
    }, A;
  }
  return e;
}
function Ks(e) {
  return oe(oe({
    type: a0
  }, e), {
    toJSON: function() {
      e.onDone, e.onError;
      var A = jd(e, ["onDone", "onError"]);
      return oe(oe({}, A), {
        type: a0,
        src: X$(e.src)
      });
    }
  });
}
var Aa = "", c0 = "#", Ga = "*", zn = {}, Xn = function(e) {
  return e[0] === c0;
}, q$ = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
}, J$ = function(e, A, t) {
  var r = t.slice(0, -1).some(function(a) {
    return !("cond" in a) && !("in" in a) && (Te(a.target) || Si(a.target));
  }), n = A === Aa ? "the transient event" : "event '".concat(A, "'");
  ir(!r, "One or more transitions for ".concat(n, " on state '").concat(e.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
}, Z$ = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(A, t, r, n) {
      r === void 0 && (r = "context" in A ? A.context : void 0);
      var a = this, i;
      this.config = A, this._context = r, this.order = -1, this.__xstatenode = !0, this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign(q$(), t), this.parent = n == null ? void 0 : n.parent, this.key = this.config.key || (n == null ? void 0 : n.key) || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : Kx), this.id = this.config.id || nA([this.machine.key], ke(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (i = this.config.schema) !== null && i !== void 0 ? i : {}, this.description = this.config.description, nt || ir(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead.")), this.initial = this.config.initial, this.states = this.config.states ? ri(this.config.states, function(u, l) {
        var c, f = new e(u, {}, void 0, {
          parent: a,
          key: l
        });
        return Object.assign(a.idMap, oe((c = {}, c[f.id] = f, c), f.idMap)), f;
      }) : zn;
      var s = 0;
      function o(u) {
        var l, c;
        u.order = s++;
        try {
          for (var f = aA(Xx(u)), d = f.next(); !d.done; d = f.next()) {
            var h = d.value;
            o(h);
          }
        } catch (p) {
          l = {
            error: p
          };
        } finally {
          try {
            d && !d.done && (c = f.return) && c.call(f);
          } finally {
            if (l)
              throw l.error;
          }
        }
      }
      o(this), this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(u) {
        var l = u.event;
        return l === Aa;
      }) : Aa in this.config.on : !1), this.strict = !!this.config.strict, this.onEntry = pt(this.config.entry || this.config.onEntry).map(function(u) {
        return _i(u);
      }), this.onExit = pt(this.config.exit || this.config.onExit).map(function(u) {
        return _i(u);
      }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = pt(this.config.invoke).map(function(u, l) {
        var c, f;
        if (Si(u)) {
          var d = ks(a.id, l);
          return a.machine.options.services = oe((c = {}, c[d] = u, c), a.machine.options.services), Ks({
            src: d,
            id: d
          });
        } else if (Te(u.src)) {
          var d = u.id || ks(a.id, l);
          return Ks(oe(oe({}, u), {
            id: d,
            src: u.src
          }));
        } else if (Si(u.src) || Je(u.src)) {
          var d = u.id || ks(a.id, l);
          return a.machine.options.services = oe((f = {}, f[d] = u.src, f), a.machine.options.services), Ks(oe(oe({
            id: d
          }, u), {
            src: d
          }));
        } else {
          var h = u.src;
          return Ks(oe(oe({
            id: ks(a.id, l)
          }, u), {
            src: h
          }));
        }
      }), this.activities = pt(this.config.activities).concat(this.invoke).map(function(u) {
        return Xd(u);
      }), this.transition = this.transition.bind(this), this.tags = pt(this.config.tags);
    }
    return e.prototype._init = function() {
      this.__cache.transitions || qx(this).forEach(function(A) {
        return A.on;
      });
    }, e.prototype.withConfig = function(A, t) {
      var r = this.options, n = r.actions, a = r.activities, i = r.guards, s = r.services, o = r.delays;
      return new e(this.config, {
        actions: oe(oe({}, n), A.actions),
        activities: oe(oe({}, a), A.activities),
        guards: oe(oe({}, i), A.guards),
        services: oe(oe({}, s), A.services),
        delays: oe(oe({}, o), A.delays)
      }, t ?? this.context);
    }, e.prototype.withContext = function(A) {
      return new e(this.config, this.options, A);
    }, Object.defineProperty(e.prototype, "context", {
      get: function() {
        return Je(this._context) ? this._context() : this._context;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: ri(this.states, function(A) {
            return A.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toJSON = function() {
      return this.definition;
    }, Object.defineProperty(e.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on)
          return this.__cache.on;
        var A = this.transitions;
        return this.__cache.on = A.reduce(function(t, r) {
          return t[r.eventType] = t[r.eventType] || [], t[r.eventType].push(r), t;
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getCandidates = function(A) {
      if (this.__cache.candidates[A])
        return this.__cache.candidates[A];
      var t = A === Aa, r = this.transitions.filter(function(n) {
        var a = n.eventType === A;
        return t ? a : a || n.eventType === Ga;
      });
      return this.__cache.candidates[A] = r, r;
    }, e.prototype.getDelayedTransitions = function() {
      var A = this, t = this.config.after;
      if (!t)
        return [];
      var r = function(a, i) {
        var s = Je(a) ? "".concat(A.id, ":delay[").concat(i, "]") : a, o = N$(s, A.id);
        return A.onEntry.push(I$(o, {
          delay: a
        })), A.onExit.push(O$(o)), o;
      }, n = Zi(t) ? t.map(function(a, i) {
        var s = r(a.delay, i);
        return oe(oe({}, a), {
          event: s
        });
      }) : sA(Object.keys(t).map(function(a, i) {
        var s = t[a], o = Te(s) ? {
          target: s
        } : s, u = isNaN(+a) ? a : +a, l = r(u, i);
        return pt(o).map(function(c) {
          return oe(oe({}, c), {
            event: l,
            delay: u
          });
        });
      }));
      return n.map(function(a) {
        var i = a.delay;
        return oe(oe({}, A.formatTransition(a)), {
          delay: i
        });
      });
    }, e.prototype.getStateNodes = function(A) {
      var t, r = this;
      if (!A)
        return [];
      var n = A instanceof Cr ? A.value : gi(A, this.delimiter);
      if (Te(n)) {
        var a = this.getStateNode(n).initial;
        return a !== void 0 ? this.getStateNodes((t = {}, t[n] = a, t)) : [this, this.states[n]];
      }
      var i = Object.keys(n), s = [this];
      return s.push.apply(s, nA([], ke(sA(i.map(function(o) {
        return r.getStateNode(o).getStateNodes(n[o]);
      }))), !1)), s;
    }, e.prototype.handles = function(A) {
      var t = $x(A);
      return this.events.includes(t);
    }, e.prototype.resolveState = function(A) {
      var t = A instanceof Cr ? A : Cr.create(A), r = Array.from(ni([], this.getStateNodes(t.value)));
      return new Cr(oe(oe({}, t), {
        value: this.resolve(t.value),
        configuration: r,
        done: io(r, this),
        tags: $B(r),
        machine: this.machine
      }));
    }, e.prototype.transitionLeafNode = function(A, t, r) {
      var n = this.getStateNode(A), a = n.next(t, r);
      return !a || !a.transitions.length ? this.next(t, r) : a;
    }, e.prototype.transitionCompoundNode = function(A, t, r) {
      var n = Object.keys(A), a = this.getStateNode(n[0]), i = a._transition(A[n[0]], t, r);
      return !i || !i.transitions.length ? this.next(t, r) : i;
    }, e.prototype.transitionParallelNode = function(A, t, r) {
      var n, a, i = {};
      try {
        for (var s = aA(Object.keys(A)), o = s.next(); !o.done; o = s.next()) {
          var u = o.value, l = A[u];
          if (l) {
            var c = this.getStateNode(u), f = c._transition(l, t, r);
            f && (i[u] = f);
          }
        }
      } catch (y) {
        n = {
          error: y
        };
      } finally {
        try {
          o && !o.done && (a = s.return) && a.call(s);
        } finally {
          if (n)
            throw n.error;
        }
      }
      var d = Object.keys(i).map(function(y) {
        return i[y];
      }), h = sA(d.map(function(y) {
        return y.transitions;
      })), p = d.some(function(y) {
        return y.transitions.length > 0;
      });
      if (!p)
        return this.next(t, r);
      var v = sA(Object.keys(i).map(function(y) {
        return i[y].configuration;
      }));
      return {
        transitions: h,
        exitSet: sA(d.map(function(y) {
          return y.exitSet;
        })),
        configuration: v,
        source: t,
        actions: sA(Object.keys(i).map(function(y) {
          return i[y].actions;
        }))
      };
    }, e.prototype._transition = function(A, t, r) {
      return Te(A) ? this.transitionLeafNode(A, t, r) : Object.keys(A).length === 1 ? this.transitionCompoundNode(A, t, r) : this.transitionParallelNode(A, t, r);
    }, e.prototype.getTransitionData = function(A, t) {
      return this._transition(A.value, A, Ui(t));
    }, e.prototype.next = function(A, t) {
      var r, n, a = this, i = t.name, s = [], o = [], u;
      try {
        for (var l = aA(this.getCandidates(i)), c = l.next(); !c.done; c = l.next()) {
          var f = c.value, d = f.cond, h = f.in, p = A.context, v = h ? Te(h) && Xn(h) ? (
            // Check if in state by ID
            A.matches(gi(this.getStateNodeById(h).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            Wd(gi(h, this.delimiter), x$(this.path.slice(0, -2))(A.value))
          ) : !0, y = !1;
          try {
            y = !d || Yx(this.machine, d, p, t, A);
          } catch (w) {
            throw new Error("Unable to evaluate guard '".concat(d.name || d.type, "' in transition for event '").concat(i, "' in state node '").concat(this.id, `':
`).concat(w.message));
          }
          if (y && v) {
            f.target !== void 0 && (o = f.target), s.push.apply(s, nA([], ke(f.actions), !1)), u = f;
            break;
          }
        }
      } catch (w) {
        r = {
          error: w
        };
      } finally {
        try {
          c && !c.done && (n = l.return) && n.call(l);
        } finally {
          if (r)
            throw r.error;
        }
      }
      if (u) {
        if (!o.length)
          return {
            transitions: [u],
            exitSet: [],
            configuration: A.value ? [this] : [],
            source: A,
            actions: s
          };
        var g = sA(o.map(function(w) {
          return a.getRelativeStateNodes(w, A.historyValue);
        })), B = !!u.internal;
        return {
          transitions: [u],
          exitSet: B ? [] : sA(o.map(function(w) {
            return a.getPotentiallyReenteringNodes(w);
          })),
          configuration: g,
          source: A,
          actions: s
        };
      }
    }, e.prototype.getPotentiallyReenteringNodes = function(A) {
      if (this.order < A.order)
        return [this];
      for (var t = [], r = this, n = A; r && r !== n; )
        t.push(r), r = r.parent;
      return r !== n ? [] : (t.push(n), t);
    }, e.prototype.getActions = function(A, t, r, n, a, i, s) {
      var o, u, l, c, f = this, d = i ? ni([], this.getStateNodes(i.value)) : [], h = /* @__PURE__ */ new Set();
      try {
        for (var p = aA(Array.from(A).sort(function(b, N) {
          return b.order - N.order;
        })), v = p.next(); !v.done; v = p.next()) {
          var y = v.value;
          (!ai(d, y) || ai(r.exitSet, y) || y.parent && h.has(y.parent)) && h.add(y);
        }
      } catch (b) {
        o = {
          error: b
        };
      } finally {
        try {
          v && !v.done && (u = p.return) && u.call(p);
        } finally {
          if (o)
            throw o.error;
        }
      }
      try {
        for (var g = aA(d), B = g.next(); !B.done; B = g.next()) {
          var y = B.value;
          (!ai(A, y) || ai(r.exitSet, y.parent)) && r.exitSet.push(y);
        }
      } catch (b) {
        l = {
          error: b
        };
      } finally {
        try {
          B && !B.done && (c = g.return) && c.call(g);
        } finally {
          if (l)
            throw l.error;
        }
      }
      r.exitSet.sort(function(b, N) {
        return N.order - b.order;
      });
      var w = Array.from(h).sort(function(b, N) {
        return b.order - N.order;
      }), m = new Set(r.exitSet), x = sA(w.map(function(b) {
        var N = [];
        if (b.type !== "final")
          return N;
        var O = b.parent;
        if (!O.parent)
          return N;
        N.push(
          Ps(b.id, b.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          Ps(O.id, b.doneData ? Gx(b.doneData, n, a) : void 0)
        );
        var V = O.parent;
        return V.type === "parallel" && Qi(V).every(function(I) {
          return io(r.configuration, I);
        }) && N.push(Ps(V.id)), N;
      })), C = w.map(function(b) {
        var N = b.onEntry, O = b.activities.map(function(V) {
          return H$(V);
        });
        return {
          type: "entry",
          actions: un(s ? nA(nA([], ke(N), !1), ke(O), !1) : nA(nA([], ke(O), !1), ke(N), !1), f.machine.options.actions)
        };
      }).concat({
        type: "state_done",
        actions: x.map(function(b) {
          return _$(b);
        })
      }), E = Array.from(m).map(function(b) {
        return {
          type: "exit",
          actions: un(nA(nA([], ke(b.onExit), !1), ke(b.activities.map(function(N) {
            return L$(N);
          })), !1), f.machine.options.actions)
        };
      }), T = E.concat({
        type: "transition",
        actions: un(r.actions, this.machine.options.actions)
      }).concat(C);
      if (t) {
        var S = un(sA(nA([], ke(A), !1).sort(function(b, N) {
          return N.order - b.order;
        }).map(function(b) {
          return b.onExit;
        })), this.machine.options.actions).filter(function(b) {
          return !kB(b);
        });
        return T.concat({
          type: "stop",
          actions: S
        });
      }
      return T;
    }, e.prototype.transition = function(A, t, r, n) {
      A === void 0 && (A = this.initialState);
      var a = Ui(t), i;
      if (A instanceof Cr)
        i = r === void 0 ? A : this.resolveState(Cr.from(A, r));
      else {
        var s = Te(A) ? this.resolve($o(this.getResolvedPath(A))) : this.resolve(A), o = r ?? this.machine.context;
        i = this.resolveState(Cr.from(s, o));
      }
      if (!nt && a.name === Ga)
        throw new Error("An event cannot have the wildcard type ('".concat(Ga, "')"));
      if (this.strict && !this.events.includes(a.name) && !E$(a.name))
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(a.name, "'"));
      var u = this._transition(i.value, i, a) || {
        transitions: [],
        configuration: [],
        exitSet: [],
        source: i,
        actions: []
      }, l = ni([], this.getStateNodes(i.value)), c = u.configuration.length ? ni(l, u.configuration) : l;
      return u.configuration = nA([], ke(c), !1), this.resolveTransition(u, i, i.context, n, a);
    }, e.prototype.resolveRaisedTransition = function(A, t, r, n) {
      var a, i = A.actions;
      return A = this.transition(A, t, void 0, n), A._event = r, A.event = r.data, (a = A.actions).unshift.apply(a, nA([], ke(i), !1)), A;
    }, e.prototype.resolveTransition = function(A, t, r, n, a) {
      var i, s, o, u, l = this;
      a === void 0 && (a = o0);
      var c = A.configuration, f = !t || A.transitions.length > 0, d = f ? A.configuration : t ? t.configuration : [], h = io(d, this), p = f ? W$(this.machine, c) : void 0, v = t ? t.historyValue ? t.historyValue : A.source ? this.machine.historyValue(t.value) : void 0 : void 0, y = this.getActions(new Set(d), h, A, r, a, t, n), g = t ? oe({}, t.activities) : {};
      try {
        for (var B = aA(y), w = B.next(); !w.done; w = B.next()) {
          var m = w.value;
          try {
            for (var x = (o = void 0, aA(m.actions)), C = x.next(); !C.done; C = x.next()) {
              var E = C.value;
              E.type === LB ? g[E.activity.id || E.activity.type] = E : E.type === Px && (g[E.activity.id || E.activity.type] = !1);
            }
          } catch (Q) {
            o = {
              error: Q
            };
          } finally {
            try {
              C && !C.done && (u = x.return) && u.call(x);
            } finally {
              if (o)
                throw o.error;
            }
          }
        }
      } catch (Q) {
        i = {
          error: Q
        };
      } finally {
        try {
          w && !w.done && (s = B.return) && s.call(B);
        } finally {
          if (i)
            throw i.error;
        }
      }
      var T = ke(u0(this, t, r, a, y, n, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), S = T[0], b = T[1], N = ke(F$(S, kB), 2), O = N[0], V = N[1], I = S.filter(function(Q) {
        var j;
        return Q.type === LB && ((j = Q.activity) === null || j === void 0 ? void 0 : j.type) === a0;
      }), _ = I.reduce(function(Q, j) {
        return Q[j.activity.id] = j$(j.activity, l.machine, b, a), Q;
      }, t ? oe({}, t.children) : {}), K = new Cr({
        value: p || t.value,
        context: b,
        _event: a,
        // Persist _sessionid between states
        _sessionid: t ? t._sessionid : null,
        historyValue: p ? v ? b$(v, p) : void 0 : t ? t.historyValue : void 0,
        history: !p || A.source ? t : void 0,
        actions: p ? V : [],
        activities: p ? g : t ? t.activities : {},
        events: [],
        configuration: d,
        transitions: A.transitions,
        children: _,
        done: h,
        tags: $B(d),
        machine: this
      }), Y = r !== b;
      K.changed = a.name === B$ || Y;
      var X = K.history;
      X && delete X.history;
      var R = !h && (this._transient || c.some(function(Q) {
        return Q._transient;
      }));
      if (!f && (!R || a.name === Aa))
        return K;
      var U = K;
      if (!h)
        for (R && (U = this.resolveRaisedTransition(U, {
          type: h$
        }, a, n)); O.length; ) {
          var H = O.shift();
          U = this.resolveRaisedTransition(U, H._event, a, n);
        }
      var D = U.changed || (X ? !!U.actions.length || Y || typeof X.value != typeof U.value || !Zx(U.value, X.value) : void 0);
      return U.changed = D, U.history = X, U;
    }, e.prototype.getStateNode = function(A) {
      if (Xn(A))
        return this.machine.getStateNodeById(A);
      if (!this.states)
        throw new Error("Unable to retrieve child state '".concat(A, "' from '").concat(this.id, "'; no child states exist."));
      var t = this.states[A];
      if (!t)
        throw new Error("Child state '".concat(A, "' does not exist on '").concat(this.id, "'"));
      return t;
    }, e.prototype.getStateNodeById = function(A) {
      var t = Xn(A) ? A.slice(c0.length) : A;
      if (t === this.id)
        return this;
      var r = this.machine.idMap[t];
      if (!r)
        throw new Error("Child state node '#".concat(t, "' does not exist on machine '").concat(this.id, "'"));
      return r;
    }, e.prototype.getStateNodeByPath = function(A) {
      if (typeof A == "string" && Xn(A))
        try {
          return this.getStateNodeById(A.slice(1));
        } catch {
        }
      for (var t = s0(A, this.delimiter).slice(), r = this; t.length; ) {
        var n = t.shift();
        if (!n.length)
          break;
        r = r.getStateNode(n);
      }
      return r;
    }, e.prototype.resolve = function(A) {
      var t, r = this;
      if (!A)
        return this.initialStateValue || zn;
      switch (this.type) {
        case "parallel":
          return ri(this.initialStateValue, function(a, i) {
            return a ? r.getStateNode(i).resolve(A[i] || a) : zn;
          });
        case "compound":
          if (Te(A)) {
            var n = this.getStateNode(A);
            return n.type === "parallel" || n.type === "compound" ? (t = {}, t[A] = n.initialStateValue, t) : A;
          }
          return Object.keys(A).length ? ri(A, function(a, i) {
            return a ? r.getStateNode(i).resolve(a) : zn;
          }) : this.initialStateValue || {};
        default:
          return A || zn;
      }
    }, e.prototype.getResolvedPath = function(A) {
      if (Xn(A)) {
        var t = this.machine.idMap[A.slice(c0.length)];
        if (!t)
          throw new Error("Unable to find state node '".concat(A, "'"));
        return t.path;
      }
      return s0(A, this.delimiter);
    }, Object.defineProperty(e.prototype, "initialStateValue", {
      get: function() {
        var A;
        if (this.__cache.initialStateValue)
          return this.__cache.initialStateValue;
        var t;
        if (this.type === "parallel")
          t = RB(this.states, function(r) {
            return r.initialStateValue || zn;
          }, function(r) {
            return r.type !== "history";
          });
        else if (this.initial !== void 0) {
          if (!this.states[this.initial])
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          t = jo(this.states[this.initial]) ? this.initial : (A = {}, A[this.initial] = this.states[this.initial].initialStateValue, A);
        } else
          t = {};
        return this.__cache.initialStateValue = t, this.__cache.initialStateValue;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getInitialState = function(A, t) {
      this._init();
      var r = this.getStateNodes(A);
      return this.resolveTransition({
        configuration: r,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, t ?? this.machine.context, void 0);
    }, Object.defineProperty(e.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var A = this.initialStateValue;
        if (!A)
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(A);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var A;
        if (this.type === "history") {
          var t = this.config;
          Te(t.target) ? A = Xn(t.target) ? $o(this.machine.getStateNodeById(t.target).path.slice(this.path.length - 1)) : t.target : A = t.target;
        }
        return A;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getRelativeStateNodes = function(A, t, r) {
      return r === void 0 && (r = !0), r ? A.type === "history" ? A.resolveHistory(t) : A.initialStateNodes : [A];
    }, Object.defineProperty(e.prototype, "initialStateNodes", {
      get: function() {
        var A = this;
        if (jo(this))
          return [this];
        if (this.type === "compound" && !this.initial)
          return nt || ir(!1, "Compound state node '".concat(this.id, "' has no initial state.")), [this];
        var t = ao(this.initialStateValue);
        return sA(t.map(function(r) {
          return A.getFromRelativePath(r);
        }));
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getFromRelativePath = function(A) {
      if (!A.length)
        return [this];
      var t = ke(A), r = t[0], n = t.slice(1);
      if (!this.states)
        throw new Error("Cannot retrieve subPath '".concat(r, "' from node with no states"));
      var a = this.getStateNode(r);
      if (a.type === "history")
        return a.resolveHistory();
      if (!this.states[r])
        throw new Error("Child state '".concat(r, "' does not exist on '").concat(this.id, "'"));
      return this.states[r].getFromRelativePath(n);
    }, e.prototype.historyValue = function(A) {
      if (Object.keys(this.states).length)
        return {
          current: A || this.initialStateValue,
          states: RB(this.states, function(t, r) {
            if (!A)
              return t.historyValue();
            var n = Te(A) ? void 0 : A[r];
            return t.historyValue(n || t.initialStateValue);
          }, function(t) {
            return !t.history;
          })
        };
    }, e.prototype.resolveHistory = function(A) {
      var t = this;
      if (this.type !== "history")
        return [this];
      var r = this.parent;
      if (!A) {
        var n = this.target;
        return n ? sA(ao(n).map(function(i) {
          return r.getFromRelativePath(i);
        })) : r.initialStateNodes;
      }
      var a = C$(r.path, "states")(A).current;
      return Te(a) ? [r.getStateNode(a)] : sA(ao(a).map(function(i) {
        return t.history === "deep" ? r.getFromRelativePath(i) : [r.states[i[0]]];
      }));
    }, Object.defineProperty(e.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var A = this, t = sA(Object.keys(this.states).map(function(r) {
          return A.states[r].stateIds;
        }));
        return [this.id].concat(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var A, t, r, n;
        if (this.__cache.events)
          return this.__cache.events;
        var a = this.states, i = new Set(this.ownEvents);
        if (a)
          try {
            for (var s = aA(Object.keys(a)), o = s.next(); !o.done; o = s.next()) {
              var u = o.value, l = a[u];
              if (l.states)
                try {
                  for (var c = (r = void 0, aA(l.events)), f = c.next(); !f.done; f = c.next()) {
                    var d = f.value;
                    i.add("".concat(d));
                  }
                } catch (h) {
                  r = {
                    error: h
                  };
                } finally {
                  try {
                    f && !f.done && (n = c.return) && n.call(c);
                  } finally {
                    if (r)
                      throw r.error;
                  }
                }
            }
          } catch (h) {
            A = {
              error: h
            };
          } finally {
            try {
              o && !o.done && (t = s.return) && t.call(s);
            } finally {
              if (A)
                throw A.error;
            }
          }
        return this.__cache.events = Array.from(i);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var A = new Set(this.transitions.filter(function(t) {
          return !(!t.target && !t.actions.length && t.internal);
        }).map(function(t) {
          return t.eventType;
        }));
        return Array.from(A);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolveTarget = function(A) {
      var t = this;
      if (A !== void 0)
        return A.map(function(r) {
          if (!Te(r))
            return r;
          var n = r[0] === t.delimiter;
          if (n && !t.parent)
            return t.getStateNodeByPath(r.slice(1));
          var a = n ? t.key + r : r;
          if (t.parent)
            try {
              var i = t.parent.getStateNodeByPath(a);
              return i;
            } catch (s) {
              throw new Error("Invalid transition definition for state node '".concat(t.id, `':
`).concat(s.message));
            }
          else
            return t.getStateNodeByPath(a);
        });
    }, e.prototype.formatTransition = function(A) {
      var t = this, r = S$(A.target), n = "internal" in A ? A.internal : r ? r.some(function(o) {
        return Te(o) && o[0] === t.delimiter;
      }) : !0, a = this.machine.options.guards, i = this.resolveTarget(r), s = oe(oe({}, A), {
        actions: un(pt(A.actions)),
        cond: Wx(A.cond, a),
        target: i,
        source: this,
        internal: n,
        eventType: A.event,
        toJSON: function() {
          return oe(oe({}, s), {
            target: s.target ? s.target.map(function(o) {
              return "#".concat(o.id);
            }) : void 0,
            source: "#".concat(t.id)
          });
        }
      });
      return s;
    }, e.prototype.formatTransitions = function() {
      var A, t, r = this, n;
      if (!this.config.on)
        n = [];
      else if (Array.isArray(this.config.on))
        n = this.config.on;
      else {
        var a = this.config.on, i = Ga, s = a[i], o = s === void 0 ? [] : s, u = jd(a, [typeof i == "symbol" ? i : i + ""]);
        n = sA(Object.keys(u).map(function(g) {
          !nt && g === Aa && ir(!1, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(r.id, '".'));
          var B = Yn(g, u[g]);
          return nt || J$(r, g, B), B;
        }).concat(Yn(Ga, o)));
      }
      var l = this.config.always ? Yn("", this.config.always) : [], c = this.config.onDone ? Yn(String(Ps(this.id)), this.config.onDone) : [];
      nt || ir(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
      var f = sA(this.invoke.map(function(g) {
        var B = [];
        return g.onDone && B.push.apply(B, nA([], ke(Yn(String(k$(g.id)), g.onDone)), !1)), g.onError && B.push.apply(B, nA([], ke(Yn(String(P$(g.id)), g.onError)), !1)), B;
      })), d = this.after, h = sA(nA(nA(nA(nA([], ke(c), !1), ke(f), !1), ke(n), !1), ke(l), !1).map(function(g) {
        return pt(g).map(function(B) {
          return r.formatTransition(B);
        });
      }));
      try {
        for (var p = aA(d), v = p.next(); !v.done; v = p.next()) {
          var y = v.value;
          h.push(y);
        }
      } catch (g) {
        A = {
          error: g
        };
      } finally {
        try {
          v && !v.done && (t = p.return) && t.call(p);
        } finally {
          if (A)
            throw A.error;
        }
      }
      return h;
    }, e;
  }()
), jB = !1;
function e9(e, A) {
  return !nt && !("predictableActionArguments" in e) && !jB && (jB = !0, console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html")), new Z$(e, A);
}
var St = R$, A9 = td, t9 = rw, r9 = 1, n9 = 2;
function a9(e, A, t, r) {
  var n = t.length, a = n, i = !r;
  if (e == null)
    return !a;
  for (e = Object(e); n--; ) {
    var s = t[n];
    if (i && s[2] ? s[1] !== e[s[0]] : !(s[0] in e))
      return !1;
  }
  for (; ++n < a; ) {
    s = t[n];
    var o = s[0], u = e[o], l = s[1];
    if (i && s[2]) {
      if (u === void 0 && !(o in e))
        return !1;
    } else {
      var c = new A9();
      if (r)
        var f = r(u, l, o, e, A, c);
      if (!(f === void 0 ? t9(l, u, r9 | n9, r, c) : f))
        return !1;
    }
  }
  return !0;
}
var i9 = a9, s9 = jr;
function o9(e) {
  return e === e && !s9(e);
}
var eC = o9, u9 = eC, l9 = Ri;
function c9(e) {
  for (var A = l9(e), t = A.length; t--; ) {
    var r = A[t], n = e[r];
    A[t] = [r, n, u9(n)];
  }
  return A;
}
var f9 = c9;
function d9(e, A) {
  return function(t) {
    return t == null ? !1 : t[e] === A && (A !== void 0 || e in Object(t));
  };
}
var AC = d9, h9 = i9, p9 = f9, g9 = AC;
function B9(e) {
  var A = p9(e);
  return A.length == 1 && A[0][2] ? g9(A[0][0], A[0][1]) : function(t) {
    return t === e || h9(t, e, A);
  };
}
var v9 = B9;
function m9(e, A) {
  return e != null && A in Object(e);
}
var w9 = m9, y9 = yu, x9 = q0, C9 = ot, E9 = ad, F9 = J0, b9 = ki;
function S9(e, A, t) {
  A = y9(A, e);
  for (var r = -1, n = A.length, a = !1; ++r < n; ) {
    var i = b9(A[r]);
    if (!(a = e != null && t(e, i)))
      break;
    e = e[i];
  }
  return a || ++r != n ? a : (n = e == null ? 0 : e.length, !!n && F9(n) && E9(i, n) && (C9(e) || x9(e)));
}
var U9 = S9, _9 = w9, Q9 = U9;
function I9(e, A) {
  return e != null && Q9(e, A, _9);
}
var D9 = I9, T9 = rw, O9 = cT, H9 = D9, L9 = id, M9 = eC, R9 = AC, N9 = ki, k9 = 1, P9 = 2;
function K9(e, A) {
  return L9(e) && M9(A) ? R9(N9(e), A) : function(t) {
    var r = O9(t, e);
    return r === void 0 && r === A ? H9(t, e) : T9(A, r, k9 | P9);
  };
}
var $9 = K9;
function j9(e) {
  return e;
}
var es = j9;
function G9(e) {
  return function(A) {
    return A == null ? void 0 : A[e];
  };
}
var V9 = G9, W9 = xu;
function Y9(e) {
  return function(A) {
    return W9(A, e);
  };
}
var z9 = Y9, X9 = V9, q9 = z9, J9 = id, Z9 = ki;
function e7(e) {
  return J9(e) ? X9(Z9(e)) : q9(e);
}
var A7 = e7, t7 = v9, r7 = $9, n7 = es, a7 = ot, i7 = A7;
function s7(e) {
  return typeof e == "function" ? e : e == null ? n7 : typeof e == "object" ? a7(e) ? r7(e[0], e[1]) : t7(e) : i7(e);
}
var tC = s7, o7 = /\s/;
function u7(e) {
  for (var A = e.length; A-- && o7.test(e.charAt(A)); )
    ;
  return A;
}
var l7 = u7, c7 = l7, f7 = /^\s+/;
function d7(e) {
  return e && e.slice(0, c7(e) + 1).replace(f7, "");
}
var h7 = d7, p7 = h7, GB = jr, g7 = Ni, VB = 0 / 0, B7 = /^[-+]0x[0-9a-f]+$/i, v7 = /^0b[01]+$/i, m7 = /^0o[0-7]+$/i, w7 = parseInt;
function y7(e) {
  if (typeof e == "number")
    return e;
  if (g7(e))
    return VB;
  if (GB(e)) {
    var A = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = GB(A) ? A + "" : A;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = p7(e);
  var t = v7.test(e);
  return t || m7.test(e) ? w7(e.slice(2), t ? 2 : 8) : B7.test(e) ? VB : +e;
}
var x7 = y7;
function C7(e) {
  return function(A, t, r) {
    for (var n = -1, a = Object(A), i = r(A), s = i.length; s--; ) {
      var o = i[e ? s : ++n];
      if (t(a[o], o, a) === !1)
        break;
    }
    return A;
  };
}
var E7 = C7, F7 = E7, b7 = F7(), S7 = b7, U7 = S7, _7 = Ri;
function Q7(e, A) {
  return e && U7(e, A, _7);
}
var I7 = Q7, D7 = Mi;
function T7(e, A) {
  return function(t, r) {
    if (t == null)
      return t;
    if (!D7(t))
      return e(t, r);
    for (var n = t.length, a = A ? n : -1, i = Object(t); (A ? a-- : ++a < n) && r(i[a], a, i) !== !1; )
      ;
    return t;
  };
}
var O7 = T7, H7 = I7, L7 = O7, M7 = L7(H7), R7 = M7, N7 = R7, k7 = Mi;
function P7(e, A) {
  var t = -1, r = k7(e) ? Array(e.length) : [];
  return N7(e, function(n, a, i) {
    r[++t] = A(n, a, i);
  }), r;
}
var rC = P7;
function K7(e, A) {
  var t = e.length;
  for (e.sort(A); t--; )
    e[t] = e[t].value;
  return e;
}
var $7 = K7, WB = Ni;
function j7(e, A) {
  if (e !== A) {
    var t = e !== void 0, r = e === null, n = e === e, a = WB(e), i = A !== void 0, s = A === null, o = A === A, u = WB(A);
    if (!s && !u && !a && e > A || a && i && o && !s && !u || r && i && o || !t && o || !n)
      return 1;
    if (!r && !a && !u && e < A || u && t && n && !r && !a || s && t && n || !i && n || !o)
      return -1;
  }
  return 0;
}
var G7 = j7, V7 = G7;
function W7(e, A, t) {
  for (var r = -1, n = e.criteria, a = A.criteria, i = n.length, s = t.length; ++r < i; ) {
    var o = V7(n[r], a[r]);
    if (o) {
      if (r >= s)
        return o;
      var u = t[r];
      return o * (u == "desc" ? -1 : 1);
    }
  }
  return e.index - A.index;
}
var Y7 = W7, jc = wu, z7 = xu, X7 = tC, q7 = rC, J7 = $7, Z7 = hu, ej = Y7, Aj = es, tj = ot;
function rj(e, A, t) {
  A.length ? A = jc(A, function(a) {
    return tj(a) ? function(i) {
      return z7(i, a.length === 1 ? a[0] : a);
    } : a;
  }) : A = [Aj];
  var r = -1;
  A = jc(A, Z7(X7));
  var n = q7(e, function(a, i, s) {
    var o = jc(A, function(u) {
      return u(a);
    });
    return { criteria: o, index: ++r, value: a };
  });
  return J7(n, function(a, i) {
    return ej(a, i, t);
  });
}
var nj = rj;
function aj(e, A, t) {
  switch (t.length) {
    case 0:
      return e.call(A);
    case 1:
      return e.call(A, t[0]);
    case 2:
      return e.call(A, t[0], t[1]);
    case 3:
      return e.call(A, t[0], t[1], t[2]);
  }
  return e.apply(A, t);
}
var ij = aj, sj = ij, YB = Math.max;
function oj(e, A, t) {
  return A = YB(A === void 0 ? e.length - 1 : A, 0), function() {
    for (var r = arguments, n = -1, a = YB(r.length - A, 0), i = Array(a); ++n < a; )
      i[n] = r[A + n];
    n = -1;
    for (var s = Array(A + 1); ++n < A; )
      s[n] = r[n];
    return s[A] = t(i), sj(e, this, s);
  };
}
var nC = oj;
function uj(e) {
  return function() {
    return e;
  };
}
var lj = uj, cj = Qn, fj = function() {
  try {
    var e = cj(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), aC = fj, dj = lj, zB = aC, hj = es, pj = zB ? function(e, A) {
  return zB(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: dj(A),
    writable: !0
  });
} : hj, gj = pj, Bj = 800, vj = 16, mj = Date.now;
function wj(e) {
  var A = 0, t = 0;
  return function() {
    var r = mj(), n = vj - (r - t);
    if (t = r, n > 0) {
      if (++A >= Bj)
        return arguments[0];
    } else
      A = 0;
    return e.apply(void 0, arguments);
  };
}
var yj = wj, xj = gj, Cj = yj, Ej = Cj(xj), iC = Ej, Fj = es, bj = nC, Sj = iC;
function Uj(e, A) {
  return Sj(bj(e, A, Fj), e + "");
}
var sC = Uj, _j = pu, Qj = Mi, Ij = ad, Dj = jr;
function Tj(e, A, t) {
  if (!Dj(t))
    return !1;
  var r = typeof A;
  return (r == "number" ? Qj(t) && Ij(A, t.length) : r == "string" && A in t) ? _j(t[A], e) : !1;
}
var Oj = Tj, Hj = ow, Lj = nj, Mj = sC, XB = Oj, Rj = Mj(function(e, A) {
  if (e == null)
    return [];
  var t = A.length;
  return t > 1 && XB(e, A[0], A[1]) ? A = [] : t > 2 && XB(A[0], A[1], A[2]) && (A = [A[0]]), Lj(e, Hj(A, 1), []);
}), Nj = Rj;
const dte = /* @__PURE__ */ wt(Nj), hte = e9(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QDsAOsB0BLCAbMAxAGICiAKgMIASA2gAwC6ioqA9rFgC5avLMgAPRAEYAbMIwBmaZICssuqIBMADnGyAnABoQATxFKA7BgAshpUroLZS4So0BfBzrSYAZmE4BjABZZkUADKAK4ATgBuYLoEELxg2MjhrADW8a4YHt5+ASERUQj+SV4Ahty89AwV-GwcZXxIgogmoipSdLZKspImJnQmGmI6+gjCPaYaExqSwhoqsqJ0hpJOLugZnr7+QWGR0WChoayhGKi4pW5HALYY6ZmbOTv5hawldRVVDTVcPPWgQgjNVqSdrCTrdXr9QZ6RAqEwYQwKOh0OSiQx0YR0WYrEDpWBgfBeTiBLxHQiBEgAGRIFDIAH1AhQAPIAJRIHxY7G+vH4-zUEjkJlsshMNgmnSGIhMElEMtEwsFJkkSimSiczhxrAgcH4rmqnLqPMQAFpRBKECaMEirdbraNsekcPg9bUfoaAUozaDjBpzJYNIqlNJhHZ7Ws7tltnlhhyXdyGv8jJIMBoWoZRBpZMJJCplRnPX0MKJs2purNRWnQ5hYI9dABVZDFcLFLBnABGTs++td8cQRe9Zg0qlR2dUkjNKgkYhlaLT4lhshUlYweIJRJJoTAzq5v0aCFRomT-pUwPasjRUs9gowU9RMx69hUiyXK7AhOZYGKsDjMe3boxkg0UwxBnVQrDBS8lGvWVDDvEwHzVBwgA */
    id: "nps",
    predictableActionArguments: !0,
    tsTypes: {},
    schema: {
      context: {},
      events: {},
      services: {}
    },
    on: {
      SET_SURVEY_ID: {
        actions: ["setSurveyId"]
      },
      SET_CLIENT_ID: {
        actions: ["setClientId"]
      },
      SET_MDN: {
        actions: ["setMdn"]
      },
      SET_SCORE_QUESTION_ID: {
        actions: ["setScoreQuestionId"]
      }
    },
    context: {
      surveyId: "",
      clientId: "",
      mdn: "",
      reasons: {
        PROMOTER: {
          questionId: "",
          description: "",
          reasons: []
        },
        PASSIVE: {
          questionId: "",
          description: "",
          reasons: []
        },
        DETRACTOR: {
          questionId: "",
          description: "",
          reasons: []
        }
      },
      scoreQuestionId: "",
      score: null,
      customerCategory: null,
      selectedReasons: [],
      surveyResult: null,
      errors: null
    },
    initial: "idle",
    states: {
      idle: {
        on: {
          FETCH: { target: "fetchingSurvey" }
        }
      },
      fetchingSurvey: {
        tags: ["loading"],
        invoke: {
          src: "getSurvey",
          onDone: { target: "selectScore", actions: ["setReasonsPerCategory"] },
          onError: {
            target: "surveyUnavailable"
          }
        }
      },
      surveyUnavailable: {
        type: "final"
      },
      selectScore: {
        on: {
          SET_SCORE: {
            actions: ["setScore", "setCustomerCategory"]
          },
          SUBMIT_SCORE: {
            target: "selectReason"
          }
        }
      },
      selectReason: {
        on: {
          UPDATE_REASONS: {
            actions: ["setReasons"]
          },
          SUBMIT_NPS: "submittingSurvey"
        }
      },
      submittingSurvey: {
        tags: ["loading"],
        invoke: {
          src: "submitSurvey",
          onDone: {
            target: "surveySubmitted",
            actions: "setSurveyResult"
          },
          onError: {
            target: "selectReason",
            actions: "setError"
          }
        }
      },
      surveySubmitted: {
        type: "final"
      }
    }
  },
  {
    actions: {
      setSurveyId: St({
        surveyId: (e, A) => A.id
      }),
      setClientId: St({
        clientId: (e, A) => A.id
      }),
      setMdn: St({
        mdn: (e, A) => A.mdn
      }),
      setScoreQuestionId: St({
        scoreQuestionId: (e, A) => A.id
      }),
      setReasonsPerCategory: St({
        reasons: (e, A) => A.data
      }),
      setCustomerCategory: St({
        customerCategory: (e, { score: A }) => A > 8 ? "PROMOTER" : A > 6 ? "PASSIVE" : A !== null ? "DETRACTOR" : null
      }),
      setScore: St({
        score: (e, A) => A.score
      }),
      setReasons: St({
        selectedReasons: (e, A) => A.selectedReasons
      }),
      setSurveyResult: St({
        surveyResult: (e, A) => A.data
      }),
      setError: St({
        errors: (e, A) => A.data.message || A.data.response.data || "Unknown error occured"
      })
    }
  }
);
var oC = { exports: {} };
(function(e, A) {
  (function(t, r) {
    r();
  })(te, function() {
    function t(u, l) {
      return typeof l > "u" ? l = { autoBom: !1 } : typeof l != "object" && (console.warn("Deprecated: Expected third argument to be a object"), l = { autoBom: !l }), l.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(u.type) ? new Blob(["\uFEFF", u], { type: u.type }) : u;
    }
    function r(u, l, c) {
      var f = new XMLHttpRequest();
      f.open("GET", u), f.responseType = "blob", f.onload = function() {
        o(f.response, l, c);
      }, f.onerror = function() {
        console.error("could not download file");
      }, f.send();
    }
    function n(u) {
      var l = new XMLHttpRequest();
      l.open("HEAD", u, !1);
      try {
        l.send();
      } catch {
      }
      return 200 <= l.status && 299 >= l.status;
    }
    function a(u) {
      try {
        u.dispatchEvent(new MouseEvent("click"));
      } catch {
        var l = document.createEvent("MouseEvents");
        l.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), u.dispatchEvent(l);
      }
    }
    var i = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof te == "object" && te.global === te ? te : void 0, s = i.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), o = i.saveAs || (typeof window != "object" || window !== i ? function() {
    } : "download" in HTMLAnchorElement.prototype && !s ? function(u, l, c) {
      var f = i.URL || i.webkitURL, d = document.createElement("a");
      l = l || u.name || "download", d.download = l, d.rel = "noopener", typeof u == "string" ? (d.href = u, d.origin === location.origin ? a(d) : n(d.href) ? r(u, l, c) : a(d, d.target = "_blank")) : (d.href = f.createObjectURL(u), setTimeout(function() {
        f.revokeObjectURL(d.href);
      }, 4e4), setTimeout(function() {
        a(d);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(u, l, c) {
      if (l = l || u.name || "download", typeof u != "string")
        navigator.msSaveOrOpenBlob(t(u, c), l);
      else if (n(u))
        r(u, l, c);
      else {
        var f = document.createElement("a");
        f.href = u, f.target = "_blank", setTimeout(function() {
          a(f);
        });
      }
    } : function(u, l, c, f) {
      if (f = f || open("", "_blank"), f && (f.document.title = f.document.body.innerText = "downloading..."), typeof u == "string")
        return r(u, l, c);
      var d = u.type === "application/octet-stream", h = /constructor/i.test(i.HTMLElement) || i.safari, p = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((p || d && h || s) && typeof FileReader < "u") {
        var v = new FileReader();
        v.onloadend = function() {
          var B = v.result;
          B = p ? B : B.replace(/^data:[^;]*;/, "data:attachment/file;"), f ? f.location.href = B : location = B, f = null;
        }, v.readAsDataURL(u);
      } else {
        var y = i.URL || i.webkitURL, g = y.createObjectURL(u);
        f ? f.location = g : location.href = g, f = null, setTimeout(function() {
          y.revokeObjectURL(g);
        }, 4e4);
      }
    });
    i.saveAs = o.saveAs = o, e.exports = o;
  });
})(oC);
var pte = oC.exports;
const f0 = ({ children: e }) => /* @__PURE__ */ F.jsx(F.Fragment, { children: e ?? /* @__PURE__ */ F.jsxs(Fh, { children: [
  /* @__PURE__ */ F.jsx(Rn, { children: /* @__PURE__ */ F.jsx(ye, { fontSize: "md", children: /* @__PURE__ */ F.jsx(
    QA,
    {
      text: "At least 10 characters long",
      translationKey: "ChangePassword/password-requirements-rule-1"
    }
  ) }) }),
  /* @__PURE__ */ F.jsxs(Rn, { children: [
    /* @__PURE__ */ F.jsx(ye, { fontSize: "md", children: /* @__PURE__ */ F.jsx(
      QA,
      {
        text: "Must contain a combination of 4 out of 4 of the following attributes:",
        translationKey: "ChangePassword/password-requirements-rule-header"
      }
    ) }),
    /* @__PURE__ */ F.jsxs(Fh, { children: [
      /* @__PURE__ */ F.jsx(Rn, { children: /* @__PURE__ */ F.jsx(ye, { fontSize: "md", children: /* @__PURE__ */ F.jsx(
        QA,
        {
          text: "At least one uppercase letter (A-Z)",
          translationKey: "ChangePassword/password-requirements-rule-2"
        }
      ) }) }),
      /* @__PURE__ */ F.jsx(Rn, { children: /* @__PURE__ */ F.jsx(ye, { fontSize: "md", children: /* @__PURE__ */ F.jsx(
        QA,
        {
          text: "At least one lowercase letter (a-z)",
          translationKey: "ChangePassword/password-requirements-rule-3"
        }
      ) }) }),
      /* @__PURE__ */ F.jsx(Rn, { children: /* @__PURE__ */ F.jsx(ye, { fontSize: "md", children: /* @__PURE__ */ F.jsx(
        QA,
        {
          text: "At least one special character (!@#$%&*)",
          translationKey: "ChangePassword/password-requirements-rule-4"
        }
      ) }) }),
      /* @__PURE__ */ F.jsx(Rn, { children: /* @__PURE__ */ F.jsx(ye, { fontSize: "md", children: /* @__PURE__ */ F.jsx(
        QA,
        {
          text: "At least one numeric character (0-9)",
          translationKey: "ChangePassword/password-requirements-rule-5"
        }
      ) }) })
    ] })
  ] })
] }) });
var kj = function(A) {
  return Pj(A) && !Kj(A);
};
function Pj(e) {
  return !!e && typeof e == "object";
}
function Kj(e) {
  var A = Object.prototype.toString.call(e);
  return A === "[object RegExp]" || A === "[object Date]" || Gj(e);
}
var $j = typeof Symbol == "function" && Symbol.for, jj = $j ? Symbol.for("react.element") : 60103;
function Gj(e) {
  return e.$$typeof === jj;
}
function Vj(e) {
  return Array.isArray(e) ? [] : {};
}
function Go(e, A) {
  return A.clone !== !1 && A.isMergeableObject(e) ? Ii(Vj(e), e, A) : e;
}
function Wj(e, A, t) {
  return e.concat(A).map(function(r) {
    return Go(r, t);
  });
}
function Yj(e, A, t) {
  var r = {};
  return t.isMergeableObject(e) && Object.keys(e).forEach(function(n) {
    r[n] = Go(e[n], t);
  }), Object.keys(A).forEach(function(n) {
    !t.isMergeableObject(A[n]) || !e[n] ? r[n] = Go(A[n], t) : r[n] = Ii(e[n], A[n], t);
  }), r;
}
function Ii(e, A, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || Wj, t.isMergeableObject = t.isMergeableObject || kj;
  var r = Array.isArray(A), n = Array.isArray(e), a = r === n;
  return a ? r ? t.arrayMerge(e, A, t) : Yj(e, A, t) : Go(A, t);
}
Ii.all = function(A, t) {
  if (!Array.isArray(A))
    throw new Error("first argument should be an array");
  return A.reduce(function(r, n) {
    return Ii(r, n, t);
  }, {});
};
var d0 = Ii, zj = typeof global == "object" && global && global.Object === Object && global;
const uC = zj;
var Xj = typeof self == "object" && self && self.Object === Object && self, qj = uC || Xj || Function("return this")();
const Xt = qj;
var Jj = Xt.Symbol;
const Pr = Jj;
var lC = Object.prototype, Zj = lC.hasOwnProperty, eG = lC.toString, Va = Pr ? Pr.toStringTag : void 0;
function AG(e) {
  var A = Zj.call(e, Va), t = e[Va];
  try {
    e[Va] = void 0;
    var r = !0;
  } catch {
  }
  var n = eG.call(e);
  return r && (A ? e[Va] = t : delete e[Va]), n;
}
var tG = Object.prototype, rG = tG.toString;
function nG(e) {
  return rG.call(e);
}
var aG = "[object Null]", iG = "[object Undefined]", qB = Pr ? Pr.toStringTag : void 0;
function Dn(e) {
  return e == null ? e === void 0 ? iG : aG : qB && qB in Object(e) ? AG(e) : nG(e);
}
function cC(e, A) {
  return function(t) {
    return e(A(t));
  };
}
var sG = cC(Object.getPrototypeOf, Object);
const qd = sG;
function Tn(e) {
  return e != null && typeof e == "object";
}
var oG = "[object Object]", uG = Function.prototype, lG = Object.prototype, fC = uG.toString, cG = lG.hasOwnProperty, fG = fC.call(Object);
function JB(e) {
  if (!Tn(e) || Dn(e) != oG)
    return !1;
  var A = qd(e);
  if (A === null)
    return !0;
  var t = cG.call(A, "constructor") && A.constructor;
  return typeof t == "function" && t instanceof t && fC.call(t) == fG;
}
var ZB = Array.isArray, ev = Object.keys, dG = Object.prototype.hasOwnProperty, hG = typeof Element < "u";
function h0(e, A) {
  if (e === A)
    return !0;
  if (e && A && typeof e == "object" && typeof A == "object") {
    var t = ZB(e), r = ZB(A), n, a, i;
    if (t && r) {
      if (a = e.length, a != A.length)
        return !1;
      for (n = a; n-- !== 0; )
        if (!h0(e[n], A[n]))
          return !1;
      return !0;
    }
    if (t != r)
      return !1;
    var s = e instanceof Date, o = A instanceof Date;
    if (s != o)
      return !1;
    if (s && o)
      return e.getTime() == A.getTime();
    var u = e instanceof RegExp, l = A instanceof RegExp;
    if (u != l)
      return !1;
    if (u && l)
      return e.toString() == A.toString();
    var c = ev(e);
    if (a = c.length, a !== ev(A).length)
      return !1;
    for (n = a; n-- !== 0; )
      if (!dG.call(A, c[n]))
        return !1;
    if (hG && e instanceof Element && A instanceof Element)
      return e === A;
    for (n = a; n-- !== 0; )
      if (i = c[n], !(i === "_owner" && e.$$typeof) && !h0(e[i], A[i]))
        return !1;
    return !0;
  }
  return e !== e && A !== A;
}
var pG = function(A, t) {
  try {
    return h0(A, t);
  } catch (r) {
    if (r.message && r.message.match(/stack|recursion/i) || r.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", r.name, r.message), !1;
    throw r;
  }
};
const rn = /* @__PURE__ */ wt(pG);
var gG = process.env.NODE_ENV === "production";
function UA(e, A) {
  if (!gG) {
    if (e)
      return;
    var t = "Warning: " + A;
    typeof console < "u" && console.warn(t);
    try {
      throw Error(t);
    } catch {
    }
  }
}
function BG() {
  this.__data__ = [], this.size = 0;
}
function dC(e, A) {
  return e === A || e !== e && A !== A;
}
function tl(e, A) {
  for (var t = e.length; t--; )
    if (dC(e[t][0], A))
      return t;
  return -1;
}
var vG = Array.prototype, mG = vG.splice;
function wG(e) {
  var A = this.__data__, t = tl(A, e);
  if (t < 0)
    return !1;
  var r = A.length - 1;
  return t == r ? A.pop() : mG.call(A, t, 1), --this.size, !0;
}
function yG(e) {
  var A = this.__data__, t = tl(A, e);
  return t < 0 ? void 0 : A[t][1];
}
function xG(e) {
  return tl(this.__data__, e) > -1;
}
function CG(e, A) {
  var t = this.__data__, r = tl(t, e);
  return r < 0 ? (++this.size, t.push([e, A])) : t[r][1] = A, this;
}
function gr(e) {
  var A = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++A < t; ) {
    var r = e[A];
    this.set(r[0], r[1]);
  }
}
gr.prototype.clear = BG;
gr.prototype.delete = wG;
gr.prototype.get = yG;
gr.prototype.has = xG;
gr.prototype.set = CG;
function EG() {
  this.__data__ = new gr(), this.size = 0;
}
function FG(e) {
  var A = this.__data__, t = A.delete(e);
  return this.size = A.size, t;
}
function bG(e) {
  return this.__data__.get(e);
}
function SG(e) {
  return this.__data__.has(e);
}
function As(e) {
  var A = typeof e;
  return e != null && (A == "object" || A == "function");
}
var UG = "[object AsyncFunction]", _G = "[object Function]", QG = "[object GeneratorFunction]", IG = "[object Proxy]";
function hC(e) {
  if (!As(e))
    return !1;
  var A = Dn(e);
  return A == _G || A == QG || A == UG || A == IG;
}
var DG = Xt["__core-js_shared__"];
const Gc = DG;
var Av = function() {
  var e = /[^.]+$/.exec(Gc && Gc.keys && Gc.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function TG(e) {
  return !!Av && Av in e;
}
var OG = Function.prototype, HG = OG.toString;
function On(e) {
  if (e != null) {
    try {
      return HG.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var LG = /[\\^$.*+?()[\]{}|]/g, MG = /^\[object .+?Constructor\]$/, RG = Function.prototype, NG = Object.prototype, kG = RG.toString, PG = NG.hasOwnProperty, KG = RegExp(
  "^" + kG.call(PG).replace(LG, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function $G(e) {
  if (!As(e) || TG(e))
    return !1;
  var A = hC(e) ? KG : MG;
  return A.test(On(e));
}
function jG(e, A) {
  return e == null ? void 0 : e[A];
}
function Hn(e, A) {
  var t = jG(e, A);
  return $G(t) ? t : void 0;
}
var GG = Hn(Xt, "Map");
const Di = GG;
var VG = Hn(Object, "create");
const Ti = VG;
function WG() {
  this.__data__ = Ti ? Ti(null) : {}, this.size = 0;
}
function YG(e) {
  var A = this.has(e) && delete this.__data__[e];
  return this.size -= A ? 1 : 0, A;
}
var zG = "__lodash_hash_undefined__", XG = Object.prototype, qG = XG.hasOwnProperty;
function JG(e) {
  var A = this.__data__;
  if (Ti) {
    var t = A[e];
    return t === zG ? void 0 : t;
  }
  return qG.call(A, e) ? A[e] : void 0;
}
var ZG = Object.prototype, eV = ZG.hasOwnProperty;
function AV(e) {
  var A = this.__data__;
  return Ti ? A[e] !== void 0 : eV.call(A, e);
}
var tV = "__lodash_hash_undefined__";
function rV(e, A) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Ti && A === void 0 ? tV : A, this;
}
function bn(e) {
  var A = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++A < t; ) {
    var r = e[A];
    this.set(r[0], r[1]);
  }
}
bn.prototype.clear = WG;
bn.prototype.delete = YG;
bn.prototype.get = JG;
bn.prototype.has = AV;
bn.prototype.set = rV;
function nV() {
  this.size = 0, this.__data__ = {
    hash: new bn(),
    map: new (Di || gr)(),
    string: new bn()
  };
}
function aV(e) {
  var A = typeof e;
  return A == "string" || A == "number" || A == "symbol" || A == "boolean" ? e !== "__proto__" : e === null;
}
function rl(e, A) {
  var t = e.__data__;
  return aV(A) ? t[typeof A == "string" ? "string" : "hash"] : t.map;
}
function iV(e) {
  var A = rl(this, e).delete(e);
  return this.size -= A ? 1 : 0, A;
}
function sV(e) {
  return rl(this, e).get(e);
}
function oV(e) {
  return rl(this, e).has(e);
}
function uV(e, A) {
  var t = rl(this, e), r = t.size;
  return t.set(e, A), this.size += t.size == r ? 0 : 1, this;
}
function Wr(e) {
  var A = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++A < t; ) {
    var r = e[A];
    this.set(r[0], r[1]);
  }
}
Wr.prototype.clear = nV;
Wr.prototype.delete = iV;
Wr.prototype.get = sV;
Wr.prototype.has = oV;
Wr.prototype.set = uV;
var lV = 200;
function cV(e, A) {
  var t = this.__data__;
  if (t instanceof gr) {
    var r = t.__data__;
    if (!Di || r.length < lV - 1)
      return r.push([e, A]), this.size = ++t.size, this;
    t = this.__data__ = new Wr(r);
  }
  return t.set(e, A), this.size = t.size, this;
}
function Ia(e) {
  var A = this.__data__ = new gr(e);
  this.size = A.size;
}
Ia.prototype.clear = EG;
Ia.prototype.delete = FG;
Ia.prototype.get = bG;
Ia.prototype.has = SG;
Ia.prototype.set = cV;
function fV(e, A) {
  for (var t = -1, r = e == null ? 0 : e.length; ++t < r && A(e[t], t, e) !== !1; )
    ;
  return e;
}
var dV = function() {
  try {
    var e = Hn(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}();
const tv = dV;
function pC(e, A, t) {
  A == "__proto__" && tv ? tv(e, A, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[A] = t;
}
var hV = Object.prototype, pV = hV.hasOwnProperty;
function gC(e, A, t) {
  var r = e[A];
  (!(pV.call(e, A) && dC(r, t)) || t === void 0 && !(A in e)) && pC(e, A, t);
}
function nl(e, A, t, r) {
  var n = !t;
  t || (t = {});
  for (var a = -1, i = A.length; ++a < i; ) {
    var s = A[a], o = r ? r(t[s], e[s], s, t, e) : void 0;
    o === void 0 && (o = e[s]), n ? pC(t, s, o) : gC(t, s, o);
  }
  return t;
}
function gV(e, A) {
  for (var t = -1, r = Array(e); ++t < e; )
    r[t] = A(t);
  return r;
}
var BV = "[object Arguments]";
function rv(e) {
  return Tn(e) && Dn(e) == BV;
}
var BC = Object.prototype, vV = BC.hasOwnProperty, mV = BC.propertyIsEnumerable, wV = rv(function() {
  return arguments;
}()) ? rv : function(e) {
  return Tn(e) && vV.call(e, "callee") && !mV.call(e, "callee");
};
const yV = wV;
var xV = Array.isArray;
const ts = xV;
function CV() {
  return !1;
}
var vC = typeof exports == "object" && exports && !exports.nodeType && exports, nv = vC && typeof module == "object" && module && !module.nodeType && module, EV = nv && nv.exports === vC, av = EV ? Xt.Buffer : void 0, FV = av ? av.isBuffer : void 0, bV = FV || CV;
const mC = bV;
var SV = 9007199254740991, UV = /^(?:0|[1-9]\d*)$/;
function _V(e, A) {
  var t = typeof e;
  return A = A ?? SV, !!A && (t == "number" || t != "symbol" && UV.test(e)) && e > -1 && e % 1 == 0 && e < A;
}
var QV = 9007199254740991;
function wC(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= QV;
}
var IV = "[object Arguments]", DV = "[object Array]", TV = "[object Boolean]", OV = "[object Date]", HV = "[object Error]", LV = "[object Function]", MV = "[object Map]", RV = "[object Number]", NV = "[object Object]", kV = "[object RegExp]", PV = "[object Set]", KV = "[object String]", $V = "[object WeakMap]", jV = "[object ArrayBuffer]", GV = "[object DataView]", VV = "[object Float32Array]", WV = "[object Float64Array]", YV = "[object Int8Array]", zV = "[object Int16Array]", XV = "[object Int32Array]", qV = "[object Uint8Array]", JV = "[object Uint8ClampedArray]", ZV = "[object Uint16Array]", eW = "[object Uint32Array]", Xe = {};
Xe[VV] = Xe[WV] = Xe[YV] = Xe[zV] = Xe[XV] = Xe[qV] = Xe[JV] = Xe[ZV] = Xe[eW] = !0;
Xe[IV] = Xe[DV] = Xe[jV] = Xe[TV] = Xe[GV] = Xe[OV] = Xe[HV] = Xe[LV] = Xe[MV] = Xe[RV] = Xe[NV] = Xe[kV] = Xe[PV] = Xe[KV] = Xe[$V] = !1;
function AW(e) {
  return Tn(e) && wC(e.length) && !!Xe[Dn(e)];
}
function Jd(e) {
  return function(A) {
    return e(A);
  };
}
var yC = typeof exports == "object" && exports && !exports.nodeType && exports, Bi = yC && typeof module == "object" && module && !module.nodeType && module, tW = Bi && Bi.exports === yC, Vc = tW && uC.process, rW = function() {
  try {
    var e = Bi && Bi.require && Bi.require("util").types;
    return e || Vc && Vc.binding && Vc.binding("util");
  } catch {
  }
}();
const ga = rW;
var iv = ga && ga.isTypedArray, nW = iv ? Jd(iv) : AW;
const aW = nW;
var iW = Object.prototype, sW = iW.hasOwnProperty;
function xC(e, A) {
  var t = ts(e), r = !t && yV(e), n = !t && !r && mC(e), a = !t && !r && !n && aW(e), i = t || r || n || a, s = i ? gV(e.length, String) : [], o = s.length;
  for (var u in e)
    (A || sW.call(e, u)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    _V(u, o))) && s.push(u);
  return s;
}
var oW = Object.prototype;
function Zd(e) {
  var A = e && e.constructor, t = typeof A == "function" && A.prototype || oW;
  return e === t;
}
var uW = cC(Object.keys, Object);
const lW = uW;
var cW = Object.prototype, fW = cW.hasOwnProperty;
function dW(e) {
  if (!Zd(e))
    return lW(e);
  var A = [];
  for (var t in Object(e))
    fW.call(e, t) && t != "constructor" && A.push(t);
  return A;
}
function CC(e) {
  return e != null && wC(e.length) && !hC(e);
}
function eh(e) {
  return CC(e) ? xC(e) : dW(e);
}
function hW(e, A) {
  return e && nl(A, eh(A), e);
}
function pW(e) {
  var A = [];
  if (e != null)
    for (var t in Object(e))
      A.push(t);
  return A;
}
var gW = Object.prototype, BW = gW.hasOwnProperty;
function vW(e) {
  if (!As(e))
    return pW(e);
  var A = Zd(e), t = [];
  for (var r in e)
    r == "constructor" && (A || !BW.call(e, r)) || t.push(r);
  return t;
}
function Ah(e) {
  return CC(e) ? xC(e, !0) : vW(e);
}
function mW(e, A) {
  return e && nl(A, Ah(A), e);
}
var EC = typeof exports == "object" && exports && !exports.nodeType && exports, sv = EC && typeof module == "object" && module && !module.nodeType && module, wW = sv && sv.exports === EC, ov = wW ? Xt.Buffer : void 0, uv = ov ? ov.allocUnsafe : void 0;
function yW(e, A) {
  if (A)
    return e.slice();
  var t = e.length, r = uv ? uv(t) : new e.constructor(t);
  return e.copy(r), r;
}
function FC(e, A) {
  var t = -1, r = e.length;
  for (A || (A = Array(r)); ++t < r; )
    A[t] = e[t];
  return A;
}
function xW(e, A) {
  for (var t = -1, r = e == null ? 0 : e.length, n = 0, a = []; ++t < r; ) {
    var i = e[t];
    A(i, t, e) && (a[n++] = i);
  }
  return a;
}
function bC() {
  return [];
}
var CW = Object.prototype, EW = CW.propertyIsEnumerable, lv = Object.getOwnPropertySymbols, FW = lv ? function(e) {
  return e == null ? [] : (e = Object(e), xW(lv(e), function(A) {
    return EW.call(e, A);
  }));
} : bC;
const th = FW;
function bW(e, A) {
  return nl(e, th(e), A);
}
function SC(e, A) {
  for (var t = -1, r = A.length, n = e.length; ++t < r; )
    e[n + t] = A[t];
  return e;
}
var SW = Object.getOwnPropertySymbols, UW = SW ? function(e) {
  for (var A = []; e; )
    SC(A, th(e)), e = qd(e);
  return A;
} : bC;
const UC = UW;
function _W(e, A) {
  return nl(e, UC(e), A);
}
function _C(e, A, t) {
  var r = A(e);
  return ts(e) ? r : SC(r, t(e));
}
function QW(e) {
  return _C(e, eh, th);
}
function IW(e) {
  return _C(e, Ah, UC);
}
var DW = Hn(Xt, "DataView");
const p0 = DW;
var TW = Hn(Xt, "Promise");
const g0 = TW;
var OW = Hn(Xt, "Set");
const B0 = OW;
var HW = Hn(Xt, "WeakMap");
const v0 = HW;
var cv = "[object Map]", LW = "[object Object]", fv = "[object Promise]", dv = "[object Set]", hv = "[object WeakMap]", pv = "[object DataView]", MW = On(p0), RW = On(Di), NW = On(g0), kW = On(B0), PW = On(v0), nn = Dn;
(p0 && nn(new p0(new ArrayBuffer(1))) != pv || Di && nn(new Di()) != cv || g0 && nn(g0.resolve()) != fv || B0 && nn(new B0()) != dv || v0 && nn(new v0()) != hv) && (nn = function(e) {
  var A = Dn(e), t = A == LW ? e.constructor : void 0, r = t ? On(t) : "";
  if (r)
    switch (r) {
      case MW:
        return pv;
      case RW:
        return cv;
      case NW:
        return fv;
      case kW:
        return dv;
      case PW:
        return hv;
    }
  return A;
});
const rh = nn;
var KW = Object.prototype, $W = KW.hasOwnProperty;
function jW(e) {
  var A = e.length, t = new e.constructor(A);
  return A && typeof e[0] == "string" && $W.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var GW = Xt.Uint8Array;
const gv = GW;
function nh(e) {
  var A = new e.constructor(e.byteLength);
  return new gv(A).set(new gv(e)), A;
}
function VW(e, A) {
  var t = A ? nh(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var WW = /\w*$/;
function YW(e) {
  var A = new e.constructor(e.source, WW.exec(e));
  return A.lastIndex = e.lastIndex, A;
}
var Bv = Pr ? Pr.prototype : void 0, vv = Bv ? Bv.valueOf : void 0;
function zW(e) {
  return vv ? Object(vv.call(e)) : {};
}
function XW(e, A) {
  var t = A ? nh(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var qW = "[object Boolean]", JW = "[object Date]", ZW = "[object Map]", eY = "[object Number]", AY = "[object RegExp]", tY = "[object Set]", rY = "[object String]", nY = "[object Symbol]", aY = "[object ArrayBuffer]", iY = "[object DataView]", sY = "[object Float32Array]", oY = "[object Float64Array]", uY = "[object Int8Array]", lY = "[object Int16Array]", cY = "[object Int32Array]", fY = "[object Uint8Array]", dY = "[object Uint8ClampedArray]", hY = "[object Uint16Array]", pY = "[object Uint32Array]";
function gY(e, A, t) {
  var r = e.constructor;
  switch (A) {
    case aY:
      return nh(e);
    case qW:
    case JW:
      return new r(+e);
    case iY:
      return VW(e, t);
    case sY:
    case oY:
    case uY:
    case lY:
    case cY:
    case fY:
    case dY:
    case hY:
    case pY:
      return XW(e, t);
    case ZW:
      return new r();
    case eY:
    case rY:
      return new r(e);
    case AY:
      return YW(e);
    case tY:
      return new r();
    case nY:
      return zW(e);
  }
}
var mv = Object.create, BY = function() {
  function e() {
  }
  return function(A) {
    if (!As(A))
      return {};
    if (mv)
      return mv(A);
    e.prototype = A;
    var t = new e();
    return e.prototype = void 0, t;
  };
}();
const vY = BY;
function mY(e) {
  return typeof e.constructor == "function" && !Zd(e) ? vY(qd(e)) : {};
}
var wY = "[object Map]";
function yY(e) {
  return Tn(e) && rh(e) == wY;
}
var wv = ga && ga.isMap, xY = wv ? Jd(wv) : yY;
const CY = xY;
var EY = "[object Set]";
function FY(e) {
  return Tn(e) && rh(e) == EY;
}
var yv = ga && ga.isSet, bY = yv ? Jd(yv) : FY;
const SY = bY;
var UY = 1, _Y = 2, QY = 4, QC = "[object Arguments]", IY = "[object Array]", DY = "[object Boolean]", TY = "[object Date]", OY = "[object Error]", IC = "[object Function]", HY = "[object GeneratorFunction]", LY = "[object Map]", MY = "[object Number]", DC = "[object Object]", RY = "[object RegExp]", NY = "[object Set]", kY = "[object String]", PY = "[object Symbol]", KY = "[object WeakMap]", $Y = "[object ArrayBuffer]", jY = "[object DataView]", GY = "[object Float32Array]", VY = "[object Float64Array]", WY = "[object Int8Array]", YY = "[object Int16Array]", zY = "[object Int32Array]", XY = "[object Uint8Array]", qY = "[object Uint8ClampedArray]", JY = "[object Uint16Array]", ZY = "[object Uint32Array]", Ve = {};
Ve[QC] = Ve[IY] = Ve[$Y] = Ve[jY] = Ve[DY] = Ve[TY] = Ve[GY] = Ve[VY] = Ve[WY] = Ve[YY] = Ve[zY] = Ve[LY] = Ve[MY] = Ve[DC] = Ve[RY] = Ve[NY] = Ve[kY] = Ve[PY] = Ve[XY] = Ve[qY] = Ve[JY] = Ve[ZY] = !0;
Ve[OY] = Ve[IC] = Ve[KY] = !1;
function so(e, A, t, r, n, a) {
  var i, s = A & UY, o = A & _Y, u = A & QY;
  if (t && (i = n ? t(e, r, n, a) : t(e)), i !== void 0)
    return i;
  if (!As(e))
    return e;
  var l = ts(e);
  if (l) {
    if (i = jW(e), !s)
      return FC(e, i);
  } else {
    var c = rh(e), f = c == IC || c == HY;
    if (mC(e))
      return yW(e, s);
    if (c == DC || c == QC || f && !n) {
      if (i = o || f ? {} : mY(e), !s)
        return o ? _W(e, mW(i, e)) : bW(e, hW(i, e));
    } else {
      if (!Ve[c])
        return n ? e : {};
      i = gY(e, c, s);
    }
  }
  a || (a = new Ia());
  var d = a.get(e);
  if (d)
    return d;
  a.set(e, i), SY(e) ? e.forEach(function(v) {
    i.add(so(v, A, t, v, e, a));
  }) : CY(e) && e.forEach(function(v, y) {
    i.set(y, so(v, A, t, y, e, a));
  });
  var h = u ? o ? IW : QW : o ? Ah : eh, p = l ? void 0 : h(e);
  return fV(p || e, function(v, y) {
    p && (y = v, v = e[y]), gC(i, y, so(v, A, t, y, e, a));
  }), i;
}
var ez = 4;
function xv(e) {
  return so(e, ez);
}
function TC(e, A) {
  for (var t = -1, r = e == null ? 0 : e.length, n = Array(r); ++t < r; )
    n[t] = A(e[t], t, e);
  return n;
}
var Az = "[object Symbol]";
function ah(e) {
  return typeof e == "symbol" || Tn(e) && Dn(e) == Az;
}
var tz = "Expected a function";
function ih(e, A) {
  if (typeof e != "function" || A != null && typeof A != "function")
    throw new TypeError(tz);
  var t = function() {
    var r = arguments, n = A ? A.apply(this, r) : r[0], a = t.cache;
    if (a.has(n))
      return a.get(n);
    var i = e.apply(this, r);
    return t.cache = a.set(n, i) || a, i;
  };
  return t.cache = new (ih.Cache || Wr)(), t;
}
ih.Cache = Wr;
var rz = 500;
function nz(e) {
  var A = ih(e, function(r) {
    return t.size === rz && t.clear(), r;
  }), t = A.cache;
  return A;
}
var az = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, iz = /\\(\\)?/g, sz = nz(function(e) {
  var A = [];
  return e.charCodeAt(0) === 46 && A.push(""), e.replace(az, function(t, r, n, a) {
    A.push(n ? a.replace(iz, "$1") : r || t);
  }), A;
});
const oz = sz;
var uz = 1 / 0;
function lz(e) {
  if (typeof e == "string" || ah(e))
    return e;
  var A = e + "";
  return A == "0" && 1 / e == -uz ? "-0" : A;
}
var cz = 1 / 0, Cv = Pr ? Pr.prototype : void 0, Ev = Cv ? Cv.toString : void 0;
function OC(e) {
  if (typeof e == "string")
    return e;
  if (ts(e))
    return TC(e, OC) + "";
  if (ah(e))
    return Ev ? Ev.call(e) : "";
  var A = e + "";
  return A == "0" && 1 / e == -cz ? "-0" : A;
}
function fz(e) {
  return e == null ? "" : OC(e);
}
function HC(e) {
  return ts(e) ? TC(e, lz) : ah(e) ? [e] : FC(oz(fz(e)));
}
var LC = kd, dz = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, hz = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, MC = {};
MC[LC.ForwardRef] = dz;
MC[LC.Memo] = hz;
function qe() {
  return qe = Object.assign || function(e) {
    for (var A = 1; A < arguments.length; A++) {
      var t = arguments[A];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, qe.apply(this, arguments);
}
function ia(e, A) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), n, a;
  for (a = 0; a < r.length; a++)
    n = r[a], !(A.indexOf(n) >= 0) && (t[n] = e[n]);
  return t;
}
var al = /* @__PURE__ */ Kt(void 0);
al.displayName = "FormikContext";
var pz = al.Provider;
al.Consumer;
function sh() {
  var e = Pt(al);
  return e || (process.env.NODE_ENV !== "production" ? UA(!1, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : UA(!1)), e;
}
var MA = function(A) {
  return typeof A == "function";
}, il = function(A) {
  return A !== null && typeof A == "object";
}, gz = function(A) {
  return String(Math.floor(Number(A))) === A;
}, Wc = function(A) {
  return Object.prototype.toString.call(A) === "[object String]";
}, RC = function(A) {
  return F0.count(A) === 0;
}, Yc = function(A) {
  return il(A) && MA(A.then);
};
function Bz(e) {
  if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function WA(e, A, t, r) {
  r === void 0 && (r = 0);
  for (var n = HC(A); e && r < n.length; )
    e = e[n[r++]];
  return r !== n.length && !e || e === void 0 ? t : e;
}
function wn(e, A, t) {
  for (var r = xv(e), n = r, a = 0, i = HC(A); a < i.length - 1; a++) {
    var s = i[a], o = WA(e, i.slice(0, a + 1));
    if (o && (il(o) || Array.isArray(o)))
      n = n[s] = xv(o);
    else {
      var u = i[a + 1];
      n = n[s] = gz(u) && Number(u) >= 0 ? [] : {};
    }
  }
  return (a === 0 ? e : n)[i[a]] === t ? e : (t === void 0 ? delete n[i[a]] : n[i[a]] = t, a === 0 && t === void 0 && delete r[i[a]], r);
}
function NC(e, A, t, r) {
  t === void 0 && (t = /* @__PURE__ */ new WeakMap()), r === void 0 && (r = {});
  for (var n = 0, a = Object.keys(e); n < a.length; n++) {
    var i = a[n], s = e[i];
    il(s) ? t.get(s) || (t.set(s, !0), r[i] = Array.isArray(s) ? [] : {}, NC(s, A, t, r[i])) : r[i] = A;
  }
  return r;
}
function vz(e, A) {
  switch (A.type) {
    case "SET_VALUES":
      return qe({}, e, {
        values: A.payload
      });
    case "SET_TOUCHED":
      return qe({}, e, {
        touched: A.payload
      });
    case "SET_ERRORS":
      return rn(e.errors, A.payload) ? e : qe({}, e, {
        errors: A.payload
      });
    case "SET_STATUS":
      return qe({}, e, {
        status: A.payload
      });
    case "SET_ISSUBMITTING":
      return qe({}, e, {
        isSubmitting: A.payload
      });
    case "SET_ISVALIDATING":
      return qe({}, e, {
        isValidating: A.payload
      });
    case "SET_FIELD_VALUE":
      return qe({}, e, {
        values: wn(e.values, A.payload.field, A.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return qe({}, e, {
        touched: wn(e.touched, A.payload.field, A.payload.value)
      });
    case "SET_FIELD_ERROR":
      return qe({}, e, {
        errors: wn(e.errors, A.payload.field, A.payload.value)
      });
    case "RESET_FORM":
      return qe({}, e, A.payload);
    case "SET_FORMIK_STATE":
      return A.payload(e);
    case "SUBMIT_ATTEMPT":
      return qe({}, e, {
        touched: NC(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return qe({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return qe({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var en = {}, $s = {};
function mz(e) {
  var A = e.validateOnChange, t = A === void 0 ? !0 : A, r = e.validateOnBlur, n = r === void 0 ? !0 : r, a = e.validateOnMount, i = a === void 0 ? !1 : a, s = e.isInitialValid, o = e.enableReinitialize, u = o === void 0 ? !1 : o, l = e.onSubmit, c = ia(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), f = qe({
    validateOnChange: t,
    validateOnBlur: n,
    validateOnMount: i,
    onSubmit: l
  }, c), d = Ut(f.initialValues), h = Ut(f.initialErrors || en), p = Ut(f.initialTouched || $s), v = Ut(f.initialStatus), y = Ut(!1), g = Ut({});
  process.env.NODE_ENV !== "production" && Re(function() {
    typeof s > "u" || (process.env.NODE_ENV !== "production" ? UA(!1, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : UA(!1));
  }, []), Re(function() {
    return y.current = !0, function() {
      y.current = !1;
    };
  }, []);
  var B = Ue(0), w = B[1], m = Ut({
    values: f.initialValues,
    errors: f.initialErrors || en,
    touched: f.initialTouched || $s,
    status: f.initialStatus,
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), x = m.current, C = _e(function(P) {
    var J = m.current;
    m.current = vz(J, P), J !== m.current && w(function(ne) {
      return ne + 1;
    });
  }, []), E = _e(function(P, J) {
    return new Promise(function(ne, ue) {
      var ge = f.validate(P, J);
      ge == null ? ne(en) : Yc(ge) ? ge.then(function(Ce) {
        ne(Ce || en);
      }, function(Ce) {
        process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", Ce), ue(Ce);
      }) : ne(ge);
    });
  }, [f.validate]), T = _e(function(P, J) {
    var ne = f.validationSchema, ue = MA(ne) ? ne(J) : ne, ge = J && ue.validateAt ? ue.validateAt(J, P) : xz(P, ue);
    return new Promise(function(Ce, fA) {
      ge.then(function() {
        Ce(en);
      }, function(jA) {
        jA.name === "ValidationError" ? Ce(yz(jA)) : (process.env.NODE_ENV !== "production" && console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", jA), fA(jA));
      });
    });
  }, [f.validationSchema]), S = _e(function(P, J) {
    return new Promise(function(ne) {
      return ne(g.current[P].validate(J));
    });
  }, []), b = _e(function(P) {
    var J = Object.keys(g.current).filter(function(ue) {
      return MA(g.current[ue].validate);
    }), ne = J.length > 0 ? J.map(function(ue) {
      return S(ue, WA(P, ue));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(ne).then(function(ue) {
      return ue.reduce(function(ge, Ce, fA) {
        return Ce === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || Ce && (ge = wn(ge, J[fA], Ce)), ge;
      }, {});
    });
  }, [S]), N = _e(function(P) {
    return Promise.all([b(P), f.validationSchema ? T(P) : {}, f.validate ? E(P) : {}]).then(function(J) {
      var ne = J[0], ue = J[1], ge = J[2], Ce = d0.all([ne, ue, ge], {
        arrayMerge: Cz
      });
      return Ce;
    });
  }, [f.validate, f.validationSchema, b, E, T]), O = ZA(function(P) {
    return P === void 0 && (P = x.values), C({
      type: "SET_ISVALIDATING",
      payload: !0
    }), N(P).then(function(J) {
      return y.current && (C({
        type: "SET_ISVALIDATING",
        payload: !1
      }), C({
        type: "SET_ERRORS",
        payload: J
      })), J;
    });
  });
  Re(function() {
    i && y.current === !0 && rn(d.current, f.initialValues) && O(d.current);
  }, [i, O]);
  var V = _e(function(P) {
    var J = P && P.values ? P.values : d.current, ne = P && P.errors ? P.errors : h.current ? h.current : f.initialErrors || {}, ue = P && P.touched ? P.touched : p.current ? p.current : f.initialTouched || {}, ge = P && P.status ? P.status : v.current ? v.current : f.initialStatus;
    d.current = J, h.current = ne, p.current = ue, v.current = ge;
    var Ce = function() {
      C({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!P && !!P.isSubmitting,
          errors: ne,
          touched: ue,
          status: ge,
          values: J,
          isValidating: !!P && !!P.isValidating,
          submitCount: P && P.submitCount && typeof P.submitCount == "number" ? P.submitCount : 0
        }
      });
    };
    if (f.onReset) {
      var fA = f.onReset(x.values, $);
      Yc(fA) ? fA.then(Ce) : Ce();
    } else
      Ce();
  }, [f.initialErrors, f.initialStatus, f.initialTouched, f.onReset]);
  Re(function() {
    y.current === !0 && !rn(d.current, f.initialValues) && u && (d.current = f.initialValues, V(), i && O(d.current));
  }, [u, f.initialValues, V, i, O]), Re(function() {
    u && y.current === !0 && !rn(h.current, f.initialErrors) && (h.current = f.initialErrors || en, C({
      type: "SET_ERRORS",
      payload: f.initialErrors || en
    }));
  }, [u, f.initialErrors]), Re(function() {
    u && y.current === !0 && !rn(p.current, f.initialTouched) && (p.current = f.initialTouched || $s, C({
      type: "SET_TOUCHED",
      payload: f.initialTouched || $s
    }));
  }, [u, f.initialTouched]), Re(function() {
    u && y.current === !0 && !rn(v.current, f.initialStatus) && (v.current = f.initialStatus, C({
      type: "SET_STATUS",
      payload: f.initialStatus
    }));
  }, [u, f.initialStatus, f.initialTouched]);
  var I = ZA(function(P) {
    if (g.current[P] && MA(g.current[P].validate)) {
      var J = WA(x.values, P), ne = g.current[P].validate(J);
      return Yc(ne) ? (C({
        type: "SET_ISVALIDATING",
        payload: !0
      }), ne.then(function(ue) {
        return ue;
      }).then(function(ue) {
        C({
          type: "SET_FIELD_ERROR",
          payload: {
            field: P,
            value: ue
          }
        }), C({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (C({
        type: "SET_FIELD_ERROR",
        payload: {
          field: P,
          value: ne
        }
      }), Promise.resolve(ne));
    } else if (f.validationSchema)
      return C({
        type: "SET_ISVALIDATING",
        payload: !0
      }), T(x.values, P).then(function(ue) {
        return ue;
      }).then(function(ue) {
        C({
          type: "SET_FIELD_ERROR",
          payload: {
            field: P,
            value: WA(ue, P)
          }
        }), C({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), _ = _e(function(P, J) {
    var ne = J.validate;
    g.current[P] = {
      validate: ne
    };
  }, []), K = _e(function(P) {
    delete g.current[P];
  }, []), Y = ZA(function(P, J) {
    C({
      type: "SET_TOUCHED",
      payload: P
    });
    var ne = J === void 0 ? n : J;
    return ne ? O(x.values) : Promise.resolve();
  }), X = _e(function(P) {
    C({
      type: "SET_ERRORS",
      payload: P
    });
  }, []), R = ZA(function(P, J) {
    var ne = MA(P) ? P(x.values) : P;
    C({
      type: "SET_VALUES",
      payload: ne
    });
    var ue = J === void 0 ? t : J;
    return ue ? O(ne) : Promise.resolve();
  }), U = _e(function(P, J) {
    C({
      type: "SET_FIELD_ERROR",
      payload: {
        field: P,
        value: J
      }
    });
  }, []), H = ZA(function(P, J, ne) {
    C({
      type: "SET_FIELD_VALUE",
      payload: {
        field: P,
        value: J
      }
    });
    var ue = ne === void 0 ? t : ne;
    return ue ? O(wn(x.values, P, J)) : Promise.resolve();
  }), D = _e(function(P, J) {
    var ne = J, ue = P, ge;
    if (!Wc(P)) {
      P.persist && P.persist();
      var Ce = P.target ? P.target : P.currentTarget, fA = Ce.type, jA = Ce.name, Mn = Ce.id, Et = Ce.value, zr = Ce.checked, ll = Ce.outerHTML, Da = Ce.options, ns = Ce.multiple;
      ne = J || jA || Mn, !ne && process.env.NODE_ENV !== "production" && Fv({
        htmlContent: ll,
        documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
        handlerName: "handleChange"
      }), ue = /number|range/.test(fA) ? (ge = parseFloat(Et), isNaN(ge) ? "" : ge) : /checkbox/.test(fA) ? Fz(WA(x.values, ne), zr, Et) : Da && ns ? Ez(Da) : Et;
    }
    ne && H(ne, ue);
  }, [H, x.values]), Q = ZA(function(P) {
    if (Wc(P))
      return function(J) {
        return D(J, P);
      };
    D(P);
  }), j = ZA(function(P, J, ne) {
    J === void 0 && (J = !0), C({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: P,
        value: J
      }
    });
    var ue = ne === void 0 ? n : ne;
    return ue ? O(x.values) : Promise.resolve();
  }), z = _e(function(P, J) {
    P.persist && P.persist();
    var ne = P.target, ue = ne.name, ge = ne.id, Ce = ne.outerHTML, fA = J || ue || ge;
    !fA && process.env.NODE_ENV !== "production" && Fv({
      htmlContent: Ce,
      documentationAnchorLink: "handleblur-e-any--void",
      handlerName: "handleBlur"
    }), j(fA, !0);
  }, [j]), re = ZA(function(P) {
    if (Wc(P))
      return function(J) {
        return z(J, P);
      };
    z(P);
  }), Z = _e(function(P) {
    MA(P) ? C({
      type: "SET_FORMIK_STATE",
      payload: P
    }) : C({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return P;
      }
    });
  }, []), ve = _e(function(P) {
    C({
      type: "SET_STATUS",
      payload: P
    });
  }, []), L = _e(function(P) {
    C({
      type: "SET_ISSUBMITTING",
      payload: P
    });
  }, []), M = ZA(function() {
    return C({
      type: "SUBMIT_ATTEMPT"
    }), O().then(function(P) {
      var J = P instanceof Error, ne = !J && Object.keys(P).length === 0;
      if (ne) {
        var ue;
        try {
          if (ue = ee(), ue === void 0)
            return;
        } catch (ge) {
          throw ge;
        }
        return Promise.resolve(ue).then(function(ge) {
          return y.current && C({
            type: "SUBMIT_SUCCESS"
          }), ge;
        }).catch(function(ge) {
          if (y.current)
            throw C({
              type: "SUBMIT_FAILURE"
            }), ge;
        });
      } else if (y.current && (C({
        type: "SUBMIT_FAILURE"
      }), J))
        throw P;
    });
  }), k = ZA(function(P) {
    if (P && P.preventDefault && MA(P.preventDefault) && P.preventDefault(), P && P.stopPropagation && MA(P.stopPropagation) && P.stopPropagation(), process.env.NODE_ENV !== "production" && typeof document < "u") {
      var J = Bz();
      J !== null && J instanceof HTMLButtonElement && (J.attributes && J.attributes.getNamedItem("type") || (process.env.NODE_ENV !== "production" ? UA(!1, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : UA(!1)));
    }
    M().catch(function(ne) {
      console.warn("Warning: An unhandled error was caught from submitForm()", ne);
    });
  }), $ = {
    resetForm: V,
    validateForm: O,
    validateField: I,
    setErrors: X,
    setFieldError: U,
    setFieldTouched: j,
    setFieldValue: H,
    setStatus: ve,
    setSubmitting: L,
    setTouched: Y,
    setValues: R,
    setFormikState: Z,
    submitForm: M
  }, ee = ZA(function() {
    return l(x.values, $);
  }), he = ZA(function(P) {
    P && P.preventDefault && MA(P.preventDefault) && P.preventDefault(), P && P.stopPropagation && MA(P.stopPropagation) && P.stopPropagation(), V();
  }), pe = _e(function(P) {
    return {
      value: WA(x.values, P),
      error: WA(x.errors, P),
      touched: !!WA(x.touched, P),
      initialValue: WA(d.current, P),
      initialTouched: !!WA(p.current, P),
      initialError: WA(h.current, P)
    };
  }, [x.errors, x.touched, x.values]), fe = _e(function(P) {
    return {
      setValue: function(ne, ue) {
        return H(P, ne, ue);
      },
      setTouched: function(ne, ue) {
        return j(P, ne, ue);
      },
      setError: function(ne) {
        return U(P, ne);
      }
    };
  }, [H, j, U]), Ge = _e(function(P) {
    var J = il(P), ne = J ? P.name : P, ue = WA(x.values, ne), ge = {
      name: ne,
      value: ue,
      onChange: Q,
      onBlur: re
    };
    if (J) {
      var Ce = P.type, fA = P.value, jA = P.as, Mn = P.multiple;
      Ce === "checkbox" ? fA === void 0 ? ge.checked = !!ue : (ge.checked = !!(Array.isArray(ue) && ~ue.indexOf(fA)), ge.value = fA) : Ce === "radio" ? (ge.checked = ue === fA, ge.value = fA) : jA === "select" && Mn && (ge.value = ge.value || [], ge.multiple = !0);
    }
    return ge;
  }, [re, Q, x.values]), gA = xn(function() {
    return !rn(d.current, x.values);
  }, [d.current, x.values]), JA = xn(function() {
    return typeof s < "u" ? gA ? x.errors && Object.keys(x.errors).length === 0 : s !== !1 && MA(s) ? s(f) : s : x.errors && Object.keys(x.errors).length === 0;
  }, [s, gA, x.errors, f]), rA = qe({}, x, {
    initialValues: d.current,
    initialErrors: h.current,
    initialTouched: p.current,
    initialStatus: v.current,
    handleBlur: re,
    handleChange: Q,
    handleReset: he,
    handleSubmit: k,
    resetForm: V,
    setErrors: X,
    setFormikState: Z,
    setFieldTouched: j,
    setFieldValue: H,
    setFieldError: U,
    setStatus: ve,
    setSubmitting: L,
    setTouched: Y,
    setValues: R,
    submitForm: M,
    validateForm: O,
    validateField: I,
    isValid: JA,
    dirty: gA,
    unregisterField: K,
    registerField: _,
    getFieldProps: Ge,
    getFieldMeta: pe,
    getFieldHelpers: fe,
    validateOnBlur: n,
    validateOnChange: t,
    validateOnMount: i
  });
  return rA;
}
function wz(e) {
  var A = mz(e), t = e.component, r = e.children, n = e.render, a = e.innerRef;
  return EE(a, function() {
    return A;
  }), process.env.NODE_ENV !== "production" && Re(function() {
    e.render && (process.env.NODE_ENV !== "production" ? UA(!1, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : UA(!1));
  }, []), ln(pz, {
    value: A
  }, t ? ln(t, A) : n ? n(A) : r ? MA(r) ? r(A) : RC(r) ? null : F0.only(r) : null);
}
function Fv(e) {
  var A = e.htmlContent, t = e.documentationAnchorLink, r = e.handlerName;
  console.warn("Warning: Formik called `" + r + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + A + `
    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#` + t + `
  `);
}
function yz(e) {
  var A = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return wn(A, e.path, e.message);
    for (var n = e.inner, t = Array.isArray(n), r = 0, n = t ? n : n[Symbol.iterator](); ; ) {
      var a;
      if (t) {
        if (r >= n.length)
          break;
        a = n[r++];
      } else {
        if (r = n.next(), r.done)
          break;
        a = r.value;
      }
      var i = a;
      WA(A, i.path) || (A = wn(A, i.path, i.message));
    }
  }
  return A;
}
function xz(e, A, t, r) {
  t === void 0 && (t = !1);
  var n = m0(e);
  return A[t ? "validateSync" : "validate"](n, {
    abortEarly: !1,
    context: r || n
  });
}
function m0(e) {
  var A = Array.isArray(e) ? [] : {};
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      var r = String(t);
      Array.isArray(e[r]) === !0 ? A[r] = e[r].map(function(n) {
        return Array.isArray(n) === !0 || JB(n) ? m0(n) : n !== "" ? n : void 0;
      }) : JB(e[r]) ? A[r] = m0(e[r]) : A[r] = e[r] !== "" ? e[r] : void 0;
    }
  return A;
}
function Cz(e, A, t) {
  var r = e.slice();
  return A.forEach(function(a, i) {
    if (typeof r[i] > "u") {
      var s = t.clone !== !1, o = s && t.isMergeableObject(a);
      r[i] = o ? d0(Array.isArray(a) ? [] : {}, a, t) : a;
    } else
      t.isMergeableObject(a) ? r[i] = d0(e[i], a, t) : e.indexOf(a) === -1 && r.push(a);
  }), r;
}
function Ez(e) {
  return Array.from(e).filter(function(A) {
    return A.selected;
  }).map(function(A) {
    return A.value;
  });
}
function Fz(e, A, t) {
  if (typeof e == "boolean")
    return !!A;
  var r = [], n = !1, a = -1;
  if (Array.isArray(e))
    r = e, a = e.indexOf(t), n = a >= 0;
  else if (!t || t == "true" || t == "false")
    return !!A;
  return A && t && !n ? r.concat(t) : n ? r.slice(0, a).concat(r.slice(a + 1)) : r;
}
var bz = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? FE : Re;
function ZA(e) {
  var A = Ut(e);
  return bz(function() {
    A.current = e;
  }), _e(function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return A.current.apply(void 0, r);
  }, []);
}
function zc(e) {
  var A = e.validate, t = e.name, r = e.render, n = e.children, a = e.as, i = e.component, s = e.className, o = ia(e, ["validate", "name", "render", "children", "as", "component", "className"]), u = sh(), l = ia(u, ["validate", "validationSchema"]);
  process.env.NODE_ENV !== "production" && Re(function() {
    r && (process.env.NODE_ENV !== "production" ? UA(!1, '<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name="' + t + '" render={({field, form}) => ...} /> with <Field name="' + t + '">{({field, form, meta}) => ...}</Field>') : UA(!1)), a && n && MA(n) && (process.env.NODE_ENV !== "production" ? UA(!1, "You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.") : UA(!1)), i && n && MA(n) && (process.env.NODE_ENV !== "production" ? UA(!1, "You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.") : UA(!1)), r && n && !RC(n) && (process.env.NODE_ENV !== "production" ? UA(!1, "You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored") : UA(!1));
  }, []);
  var c = l.registerField, f = l.unregisterField;
  Re(function() {
    return c(t, {
      validate: A
    }), function() {
      f(t);
    };
  }, [c, f, t, A]);
  var d = l.getFieldProps(qe({
    name: t
  }, o)), h = l.getFieldMeta(t), p = {
    field: d,
    form: l
  };
  if (r)
    return r(qe({}, p, {
      meta: h
    }));
  if (MA(n))
    return n(qe({}, p, {
      meta: h
    }));
  if (i) {
    if (typeof i == "string") {
      var v = o.innerRef, y = ia(o, ["innerRef"]);
      return ln(i, qe({
        ref: v
      }, d, y, {
        className: s
      }), n);
    }
    return ln(i, qe({
      field: d,
      form: l
    }, o, {
      className: s
    }), n);
  }
  var g = a || "input";
  if (typeof g == "string") {
    var B = o.innerRef, w = ia(o, ["innerRef"]);
    return ln(g, qe({
      ref: B
    }, d, w, {
      className: s
    }), n);
  }
  return ln(g, qe({}, d, o, {
    className: s
  }), n);
}
var kC = /* @__PURE__ */ CE(function(e, A) {
  var t = e.action, r = ia(e, ["action"]), n = t ?? "#", a = sh(), i = a.handleReset, s = a.handleSubmit;
  return ln("form", qe({
    onSubmit: s,
    ref: A,
    onReset: i,
    action: n
  }, r));
});
kC.displayName = "Form";
var Sz = "Expected a function";
function Uz(e, A, t) {
  if (typeof e != "function")
    throw new TypeError(Sz);
  return setTimeout(function() {
    e.apply(void 0, t);
  }, A);
}
var _z = Uz, Qz = _z, Iz = sC, Dz = x7, Tz = Iz(function(e, A, t) {
  return Qz(e, Dz(A) || 0, t);
}), Oz = Tz;
const Hz = /* @__PURE__ */ wt(Oz);
var Lz = iw, Mz = 0;
function Rz(e) {
  var A = ++Mz;
  return Lz(e) + A;
}
var Nz = Rz;
const kz = /* @__PURE__ */ wt(Nz), { useEffect: Pz } = Zc, Kz = ({ onChange: e = M0 }) => {
  const { values: A, errors: t } = sh();
  return Pz(() => {
    e == null || e(A, t);
  }, [A, t]), null;
}, $z = NE(kC), jz = ({
  id: e,
  submitLabel: A = "Submit",
  onChange: t = M0,
  hasDefaultControls: r = !0,
  sx: n,
  children: a
}) => {
  const [i] = Dm(a, {
    buttons: Af
  });
  return /* @__PURE__ */ F.jsxs(
    $z,
    {
      id: e,
      display: "flex",
      flexDirection: "column",
      h: "full",
      justifyContent: "space-between",
      sx: n,
      children: [
        Rr.Children.toArray(a).filter(
          (s) => {
            var o;
            return Rr.isValidElement(s) && s.type !== ((o = i.buttons) == null ? void 0 : o.type);
          }
        ),
        /* @__PURE__ */ F.jsx(Kz, { onChange: t }),
        r && (i.buttons ?? /* @__PURE__ */ F.jsx(Af, { type: "submit", w: "full", children: A }))
      ]
    }
  );
}, Gz = Object.assign(jz, {
  Button: Af
});
var Vz = wu, Wz = tC, Yz = rC, zz = ot;
function Xz(e, A) {
  var t = zz(e) ? Vz : Yz;
  return t(e, Wz(A));
}
var qz = Xz;
const Jz = /* @__PURE__ */ wt(qz);
function Zz(e, A) {
  for (var t = -1, r = e == null ? 0 : e.length; ++t < r && A(e[t], t, e) !== !1; )
    ;
  return e;
}
var eX = Zz, bv = aC;
function AX(e, A, t) {
  A == "__proto__" && bv ? bv(e, A, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[A] = t;
}
var PC = AX, tX = PC, rX = pu, nX = Object.prototype, aX = nX.hasOwnProperty;
function iX(e, A, t) {
  var r = e[A];
  (!(aX.call(e, A) && rX(r, t)) || t === void 0 && !(A in e)) && tX(e, A, t);
}
var KC = iX, sX = KC, oX = PC;
function uX(e, A, t, r) {
  var n = !t;
  t || (t = {});
  for (var a = -1, i = A.length; ++a < i; ) {
    var s = A[a], o = r ? r(t[s], e[s], s, t, e) : void 0;
    o === void 0 && (o = e[s]), n ? oX(t, s, o) : sX(t, s, o);
  }
  return t;
}
var rs = uX, lX = rs, cX = Ri;
function fX(e, A) {
  return e && lX(A, cX(A), e);
}
var dX = fX;
function hX(e) {
  var A = [];
  if (e != null)
    for (var t in Object(e))
      A.push(t);
  return A;
}
var pX = hX, gX = jr, BX = z0, vX = pX, mX = Object.prototype, wX = mX.hasOwnProperty;
function yX(e) {
  if (!gX(e))
    return vX(e);
  var A = BX(e), t = [];
  for (var r in e)
    r == "constructor" && (A || !wX.call(e, r)) || t.push(r);
  return t;
}
var xX = yX, CX = ew, EX = xX, FX = Mi;
function bX(e) {
  return FX(e) ? CX(e, !0) : EX(e);
}
var oh = bX, SX = rs, UX = oh;
function _X(e, A) {
  return e && SX(A, UX(A), e);
}
var QX = _X, Vo = { exports: {} };
Vo.exports;
(function(e, A) {
  var t = jt, r = A && !A.nodeType && A, n = r && !0 && e && !e.nodeType && e, a = n && n.exports === r, i = a ? t.Buffer : void 0, s = i ? i.allocUnsafe : void 0;
  function o(u, l) {
    if (l)
      return u.slice();
    var c = u.length, f = s ? s(c) : new u.constructor(c);
    return u.copy(f), f;
  }
  e.exports = o;
})(Vo, Vo.exports);
var IX = Vo.exports;
function DX(e, A) {
  var t = -1, r = e.length;
  for (A || (A = Array(r)); ++t < r; )
    A[t] = e[t];
  return A;
}
var TX = DX, OX = rs, HX = nd;
function LX(e, A) {
  return OX(e, HX(e), A);
}
var MX = LX, RX = Km, NX = RX(Object.getPrototypeOf, Object), uh = NX, kX = rd, PX = uh, KX = nd, $X = Zm, jX = Object.getOwnPropertySymbols, GX = jX ? function(e) {
  for (var A = []; e; )
    kX(A, KX(e)), e = PX(e);
  return A;
} : $X, $C = GX, VX = rs, WX = $C;
function YX(e, A) {
  return VX(e, WX(e), A);
}
var zX = YX, XX = Jm, qX = $C, JX = oh;
function ZX(e) {
  return XX(e, JX, qX);
}
var jC = ZX, eq = Object.prototype, Aq = eq.hasOwnProperty;
function tq(e) {
  var A = e.length, t = new e.constructor(A);
  return A && typeof e[0] == "string" && Aq.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var rq = tq, Sv = qm;
function nq(e) {
  var A = new e.constructor(e.byteLength);
  return new Sv(A).set(new Sv(e)), A;
}
var lh = nq, aq = lh;
function iq(e, A) {
  var t = A ? aq(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var sq = iq, oq = /\w*$/;
function uq(e) {
  var A = new e.constructor(e.source, oq.exec(e));
  return A.lastIndex = e.lastIndex, A;
}
var lq = uq, Uv = ma, _v = Uv ? Uv.prototype : void 0, Qv = _v ? _v.valueOf : void 0;
function cq(e) {
  return Qv ? Object(Qv.call(e)) : {};
}
var fq = cq, dq = lh;
function hq(e, A) {
  var t = A ? dq(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var pq = hq, gq = lh, Bq = sq, vq = lq, mq = fq, wq = pq, yq = "[object Boolean]", xq = "[object Date]", Cq = "[object Map]", Eq = "[object Number]", Fq = "[object RegExp]", bq = "[object Set]", Sq = "[object String]", Uq = "[object Symbol]", _q = "[object ArrayBuffer]", Qq = "[object DataView]", Iq = "[object Float32Array]", Dq = "[object Float64Array]", Tq = "[object Int8Array]", Oq = "[object Int16Array]", Hq = "[object Int32Array]", Lq = "[object Uint8Array]", Mq = "[object Uint8ClampedArray]", Rq = "[object Uint16Array]", Nq = "[object Uint32Array]";
function kq(e, A, t) {
  var r = e.constructor;
  switch (A) {
    case _q:
      return gq(e);
    case yq:
    case xq:
      return new r(+e);
    case Qq:
      return Bq(e, t);
    case Iq:
    case Dq:
    case Tq:
    case Oq:
    case Hq:
    case Lq:
    case Mq:
    case Rq:
    case Nq:
      return wq(e, t);
    case Cq:
      return new r();
    case Eq:
    case Sq:
      return new r(e);
    case Fq:
      return vq(e);
    case bq:
      return new r();
    case Uq:
      return mq(e);
  }
}
var Pq = kq, Kq = jr, Iv = Object.create, $q = function() {
  function e() {
  }
  return function(A) {
    if (!Kq(A))
      return {};
    if (Iv)
      return Iv(A);
    e.prototype = A;
    var t = new e();
    return e.prototype = void 0, t;
  };
}(), jq = $q, Gq = jq, Vq = uh, Wq = z0;
function Yq(e) {
  return typeof e.constructor == "function" && !Wq(e) ? Gq(Vq(e)) : {};
}
var zq = Yq, Xq = du, qq = Gr, Jq = "[object Map]";
function Zq(e) {
  return qq(e) && Xq(e) == Jq;
}
var eJ = Zq, AJ = eJ, tJ = hu, Dv = ed, Tv = Dv && Dv.isMap, rJ = Tv ? tJ(Tv) : AJ, nJ = rJ, aJ = du, iJ = Gr, sJ = "[object Set]";
function oJ(e) {
  return iJ(e) && aJ(e) == sJ;
}
var uJ = oJ, lJ = uJ, cJ = hu, Ov = ed, Hv = Ov && Ov.isSet, fJ = Hv ? cJ(Hv) : lJ, dJ = fJ, hJ = td, pJ = eX, gJ = KC, BJ = dX, vJ = QX, mJ = IX, wJ = TX, yJ = MX, xJ = zX, CJ = Aw, EJ = jC, FJ = du, bJ = rq, SJ = Pq, UJ = zq, _J = ot, QJ = Z0, IJ = nJ, DJ = jr, TJ = dJ, OJ = Ri, HJ = oh, LJ = 1, MJ = 2, RJ = 4, GC = "[object Arguments]", NJ = "[object Array]", kJ = "[object Boolean]", PJ = "[object Date]", KJ = "[object Error]", VC = "[object Function]", $J = "[object GeneratorFunction]", jJ = "[object Map]", GJ = "[object Number]", WC = "[object Object]", VJ = "[object RegExp]", WJ = "[object Set]", YJ = "[object String]", zJ = "[object Symbol]", XJ = "[object WeakMap]", qJ = "[object ArrayBuffer]", JJ = "[object DataView]", ZJ = "[object Float32Array]", eZ = "[object Float64Array]", AZ = "[object Int8Array]", tZ = "[object Int16Array]", rZ = "[object Int32Array]", nZ = "[object Uint8Array]", aZ = "[object Uint8ClampedArray]", iZ = "[object Uint16Array]", sZ = "[object Uint32Array]", We = {};
We[GC] = We[NJ] = We[qJ] = We[JJ] = We[kJ] = We[PJ] = We[ZJ] = We[eZ] = We[AZ] = We[tZ] = We[rZ] = We[jJ] = We[GJ] = We[WC] = We[VJ] = We[WJ] = We[YJ] = We[zJ] = We[nZ] = We[aZ] = We[iZ] = We[sZ] = !0;
We[KJ] = We[VC] = We[XJ] = !1;
function oo(e, A, t, r, n, a) {
  var i, s = A & LJ, o = A & MJ, u = A & RJ;
  if (t && (i = n ? t(e, r, n, a) : t(e)), i !== void 0)
    return i;
  if (!DJ(e))
    return e;
  var l = _J(e);
  if (l) {
    if (i = bJ(e), !s)
      return wJ(e, i);
  } else {
    var c = FJ(e), f = c == VC || c == $J;
    if (QJ(e))
      return mJ(e, s);
    if (c == WC || c == GC || f && !n) {
      if (i = o || f ? {} : UJ(e), !s)
        return o ? xJ(e, vJ(i, e)) : yJ(e, BJ(i, e));
    } else {
      if (!We[c])
        return n ? e : {};
      i = SJ(e, c, s);
    }
  }
  a || (a = new hJ());
  var d = a.get(e);
  if (d)
    return d;
  a.set(e, i), TJ(e) ? e.forEach(function(v) {
    i.add(oo(v, A, t, v, e, a));
  }) : IJ(e) && e.forEach(function(v, y) {
    i.set(y, oo(v, A, t, y, e, a));
  });
  var h = u ? o ? EJ : CJ : o ? HJ : OJ, p = l ? void 0 : h(e);
  return pJ(p || e, function(v, y) {
    p && (y = v, v = e[y]), gJ(i, y, oo(v, A, t, y, e, a));
  }), i;
}
var oZ = oo;
function uZ(e) {
  var A = e == null ? 0 : e.length;
  return A ? e[A - 1] : void 0;
}
var lZ = uZ;
function cZ(e, A, t) {
  var r = -1, n = e.length;
  A < 0 && (A = -A > n ? 0 : n + A), t = t > n ? n : t, t < 0 && (t += n), n = A > t ? 0 : t - A >>> 0, A >>>= 0;
  for (var a = Array(n); ++r < n; )
    a[r] = e[r + A];
  return a;
}
var fZ = cZ, dZ = xu, hZ = fZ;
function pZ(e, A) {
  return A.length < 2 ? e : dZ(e, hZ(A, 0, -1));
}
var gZ = pZ, BZ = yu, vZ = lZ, mZ = gZ, wZ = ki;
function yZ(e, A) {
  return A = BZ(A, e), e = mZ(e, A), e == null || delete e[wZ(vZ(A))];
}
var xZ = yZ, CZ = wa, EZ = uh, FZ = Gr, bZ = "[object Object]", SZ = Function.prototype, UZ = Object.prototype, YC = SZ.toString, _Z = UZ.hasOwnProperty, QZ = YC.call(Object);
function IZ(e) {
  if (!FZ(e) || CZ(e) != bZ)
    return !1;
  var A = EZ(e);
  if (A === null)
    return !0;
  var t = _Z.call(A, "constructor") && A.constructor;
  return typeof t == "function" && t instanceof t && YC.call(t) == QZ;
}
var DZ = IZ, TZ = DZ;
function OZ(e) {
  return TZ(e) ? void 0 : e;
}
var HZ = OZ, LZ = wT, MZ = nC, RZ = iC;
function NZ(e) {
  return RZ(MZ(e, void 0, LZ), e + "");
}
var kZ = NZ, PZ = wu, KZ = oZ, $Z = xZ, jZ = yu, GZ = rs, VZ = HZ, WZ = kZ, YZ = jC, zZ = 1, XZ = 2, qZ = 4, JZ = WZ(function(e, A) {
  var t = {};
  if (e == null)
    return t;
  var r = !1;
  A = PZ(A, function(a) {
    return a = jZ(a, e), r || (r = a.length > 1), a;
  }), GZ(e, YZ(e), t), r && (t = KZ(t, zZ | XZ | qZ, VZ));
  for (var n = A.length; n--; )
    $Z(t, A[n]);
  return t;
}), ZZ = JZ;
const eee = /* @__PURE__ */ wt(ZZ);
function Aee(e, A) {
  for (var t, r = -1, n = e.length; ++r < n; ) {
    var a = A(e[r]);
    a !== void 0 && (t = t === void 0 ? a : t + a);
  }
  return t;
}
var tee = Aee, ree = tee, nee = es;
function aee(e) {
  return e && e.length ? ree(e, nee) : 0;
}
var iee = aee;
const see = /* @__PURE__ */ wt(iee);
function Ln(e) {
  this._maxSize = e, this.clear();
}
Ln.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Ln.prototype.get = function(e) {
  return this._values[e];
};
Ln.prototype.set = function(e, A) {
  return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = A;
};
var oee = /[^.^\]^[]+|(?=\[\]|\.\.)/g, zC = /^\d+$/, uee = /^\d/, lee = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, cee = /^\s*(['"]?)(.*?)(\1)\s*$/, ch = 512, Lv = new Ln(ch), Mv = new Ln(ch), Rv = new Ln(ch), yn = {
  Cache: Ln,
  split: w0,
  normalizePath: Xc,
  setter: function(e) {
    var A = Xc(e);
    return Mv.get(e) || Mv.set(e, function(r, n) {
      for (var a = 0, i = A.length, s = r; a < i - 1; ) {
        var o = A[a];
        if (o === "__proto__" || o === "constructor" || o === "prototype")
          return r;
        s = s[A[a++]];
      }
      s[A[a]] = n;
    });
  },
  getter: function(e, A) {
    var t = Xc(e);
    return Rv.get(e) || Rv.set(e, function(n) {
      for (var a = 0, i = t.length; a < i; )
        if (n != null || !A)
          n = n[t[a++]];
        else
          return;
      return n;
    });
  },
  join: function(e) {
    return e.reduce(function(A, t) {
      return A + (fh(t) || zC.test(t) ? "[" + t + "]" : (A ? "." : "") + t);
    }, "");
  },
  forEach: function(e, A, t) {
    fee(Array.isArray(e) ? e : w0(e), A, t);
  }
};
function Xc(e) {
  return Lv.get(e) || Lv.set(
    e,
    w0(e).map(function(A) {
      return A.replace(cee, "$2");
    })
  );
}
function w0(e) {
  return e.match(oee) || [""];
}
function fee(e, A, t) {
  var r = e.length, n, a, i, s;
  for (a = 0; a < r; a++)
    n = e[a], n && (pee(n) && (n = '"' + n + '"'), s = fh(n), i = !s && /^\d+$/.test(n), A.call(t, n, s, i, a, e));
}
function fh(e) {
  return typeof e == "string" && e && ["'", '"'].indexOf(e.charAt(0)) !== -1;
}
function dee(e) {
  return e.match(uee) && !e.match(zC);
}
function hee(e) {
  return lee.test(e);
}
function pee(e) {
  return !fh(e) && (dee(e) || hee(e));
}
const gee = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, sl = (e) => e.match(gee) || [], ol = (e) => e[0].toUpperCase() + e.slice(1), dh = (e, A) => sl(e).join(A).toLowerCase(), XC = (e) => sl(e).reduce(
  (A, t) => `${A}${A ? t[0].toUpperCase() + t.slice(1).toLowerCase() : t.toLowerCase()}`,
  ""
), Bee = (e) => ol(XC(e)), vee = (e) => dh(e, "_"), mee = (e) => dh(e, "-"), wee = (e) => ol(dh(e, " ")), yee = (e) => sl(e).map(ol).join(" ");
var qc = {
  words: sl,
  upperFirst: ol,
  camelCase: XC,
  pascalCase: Bee,
  snakeCase: vee,
  kebabCase: mee,
  sentenceCase: wee,
  titleCase: yee
}, hh = { exports: {} };
hh.exports = function(e) {
  return qC(xee(e), e);
};
hh.exports.array = qC;
function qC(e, A) {
  var t = e.length, r = new Array(t), n = {}, a = t, i = Cee(A), s = Eee(e);
  for (A.forEach(function(u) {
    if (!s.has(u[0]) || !s.has(u[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); a--; )
    n[a] || o(e[a], a, /* @__PURE__ */ new Set());
  return r;
  function o(u, l, c) {
    if (c.has(u)) {
      var f;
      try {
        f = ", node was:" + JSON.stringify(u);
      } catch {
        f = "";
      }
      throw new Error("Cyclic dependency" + f);
    }
    if (!s.has(u))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(u));
    if (!n[l]) {
      n[l] = !0;
      var d = i.get(u) || /* @__PURE__ */ new Set();
      if (d = Array.from(d), l = d.length) {
        c.add(u);
        do {
          var h = d[--l];
          o(h, s.get(h), c);
        } while (l);
        c.delete(u);
      }
      r[--t] = u;
    }
  }
}
function xee(e) {
  for (var A = /* @__PURE__ */ new Set(), t = 0, r = e.length; t < r; t++) {
    var n = e[t];
    A.add(n[0]), A.add(n[1]);
  }
  return Array.from(A);
}
function Cee(e) {
  for (var A = /* @__PURE__ */ new Map(), t = 0, r = e.length; t < r; t++) {
    var n = e[t];
    A.has(n[0]) || A.set(n[0], /* @__PURE__ */ new Set()), A.has(n[1]) || A.set(n[1], /* @__PURE__ */ new Set()), A.get(n[0]).add(n[1]);
  }
  return A;
}
function Eee(e) {
  for (var A = /* @__PURE__ */ new Map(), t = 0, r = e.length; t < r; t++)
    A.set(e[t], t);
  return A;
}
var Fee = hh.exports;
const bee = /* @__PURE__ */ wt(Fee), See = Object.prototype.toString, Uee = Error.prototype.toString, _ee = RegExp.prototype.toString, Qee = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", Iee = /^Symbol\((.*)\)(.*)$/;
function Dee(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function Nv(e, A = !1) {
  if (e == null || e === !0 || e === !1)
    return "" + e;
  const t = typeof e;
  if (t === "number")
    return Dee(e);
  if (t === "string")
    return A ? `"${e}"` : e;
  if (t === "function")
    return "[Function " + (e.name || "anonymous") + "]";
  if (t === "symbol")
    return Qee.call(e).replace(Iee, "Symbol($1)");
  const r = See.call(e).slice(8, -1);
  return r === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : r === "Error" || e instanceof Error ? "[" + Uee.call(e) + "]" : r === "RegExp" ? _ee.call(e) : null;
}
function Mr(e, A) {
  let t = Nv(e, A);
  return t !== null ? t : JSON.stringify(e, function(r, n) {
    let a = Nv(this[r], A);
    return a !== null ? a : n;
  }, 2);
}
function JC(e) {
  return e == null ? [] : [].concat(e);
}
let ZC, Tee = /\$\{\s*(\w+)\s*\}/g;
ZC = Symbol.toStringTag;
class $A extends Error {
  static formatError(A, t) {
    const r = t.label || t.path || "this";
    return r !== t.path && (t = Object.assign({}, t, {
      path: r
    })), typeof A == "string" ? A.replace(Tee, (n, a) => Mr(t[a])) : typeof A == "function" ? A(t) : A;
  }
  static isError(A) {
    return A && A.name === "ValidationError";
  }
  constructor(A, t, r, n, a) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this[ZC] = "Error", this.name = "ValidationError", this.value = t, this.path = r, this.type = n, this.errors = [], this.inner = [], JC(A).forEach((i) => {
      if ($A.isError(i)) {
        this.errors.push(...i.errors);
        const s = i.inner.length ? i.inner : [i];
        this.inner.push(...s);
      } else
        this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], !a && Error.captureStackTrace && Error.captureStackTrace(this, $A);
  }
}
let Dt = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: A,
    value: t,
    originalValue: r
  }) => {
    const n = r != null && r !== t ? ` (cast from the value \`${Mr(r, !0)}\`).` : ".";
    return A !== "mixed" ? `${e} must be a \`${A}\` type, but the final value was: \`${Mr(t, !0)}\`` + n : `${e} must match the configured type. The validated value was: \`${Mr(t, !0)}\`` + n;
  }
}, ht = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, Oee = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, y0 = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, Hee = {
  isValue: "${path} field must be ${value}"
}, x0 = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, Lee = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, Mee = {
  notType: (e) => {
    const {
      path: A,
      value: t,
      spec: r
    } = e, n = r.types.length;
    if (Array.isArray(t)) {
      if (t.length < n)
        return `${A} tuple value has too few items, expected a length of ${n} but got ${t.length} for value: \`${Mr(t, !0)}\``;
      if (t.length > n)
        return `${A} tuple value has too many items, expected a length of ${n} but got ${t.length} for value: \`${Mr(t, !0)}\``;
    }
    return $A.formatError(Dt.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Dt,
  string: ht,
  number: Oee,
  date: y0,
  object: x0,
  array: Lee,
  boolean: Hee,
  tuple: Mee
});
const ph = (e) => e && e.__isYupSchema__;
class Wo {
  static fromOptions(A, t) {
    if (!t.then && !t.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: r,
      then: n,
      otherwise: a
    } = t, i = typeof r == "function" ? r : (...s) => s.every((o) => o === r);
    return new Wo(A, (s, o) => {
      var u;
      let l = i(...s) ? n : a;
      return (u = l == null ? void 0 : l(o)) != null ? u : o;
    });
  }
  constructor(A, t) {
    this.fn = void 0, this.refs = A, this.refs = A, this.fn = t;
  }
  resolve(A, t) {
    let r = this.refs.map((a) => (
      // TODO: ? operator here?
      a.getValue(t == null ? void 0 : t.value, t == null ? void 0 : t.parent, t == null ? void 0 : t.context)
    )), n = this.fn(r, A, t);
    if (n === void 0 || // @ts-ignore this can be base
    n === A)
      return A;
    if (!ph(n))
      throw new TypeError("conditions must return a schema object");
    return n.resolve(t);
  }
}
const js = {
  context: "$",
  value: "."
};
function Ree(e, A) {
  return new Yr(e, A);
}
class Yr {
  constructor(A, t = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof A != "string")
      throw new TypeError("ref must be a string, got: " + A);
    if (this.key = A.trim(), A === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === js.context, this.isValue = this.key[0] === js.value, this.isSibling = !this.isContext && !this.isValue;
    let r = this.isContext ? js.context : this.isValue ? js.value : "";
    this.path = this.key.slice(r.length), this.getter = this.path && yn.getter(this.path, !0), this.map = t.map;
  }
  getValue(A, t, r) {
    let n = this.isContext ? r : this.isValue ? A : t;
    return this.getter && (n = this.getter(n || {})), this.map && (n = this.map(n)), n;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(A, t) {
    return this.getValue(A, t == null ? void 0 : t.parent, t == null ? void 0 : t.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(A) {
    return A && A.__isYupRef;
  }
}
Yr.prototype.__isYupRef = !0;
const hn = (e) => e == null;
function qn(e) {
  function A({
    value: t,
    path: r = "",
    options: n,
    originalValue: a,
    schema: i
  }, s, o) {
    const {
      name: u,
      test: l,
      params: c,
      message: f,
      skipAbsent: d
    } = e;
    let {
      parent: h,
      context: p,
      abortEarly: v = i.spec.abortEarly,
      disableStackTrace: y = i.spec.disableStackTrace
    } = n;
    function g(b) {
      return Yr.isRef(b) ? b.getValue(t, h, p) : b;
    }
    function B(b = {}) {
      var N;
      const O = Object.assign({
        value: t,
        originalValue: a,
        label: i.spec.label,
        path: b.path || r,
        spec: i.spec
      }, c, b.params);
      for (const I of Object.keys(O))
        O[I] = g(O[I]);
      const V = new $A($A.formatError(b.message || f, O), t, O.path, b.type || u, (N = b.disableStackTrace) != null ? N : y);
      return V.params = O, V;
    }
    const w = v ? s : o;
    let m = {
      path: r,
      parent: h,
      type: u,
      from: n.from,
      createError: B,
      resolve: g,
      options: n,
      originalValue: a,
      schema: i
    };
    const x = (b) => {
      $A.isError(b) ? w(b) : b ? o(null) : w(B());
    }, C = (b) => {
      $A.isError(b) ? w(b) : s(b);
    };
    if (d && hn(t))
      return x(!0);
    let T;
    try {
      var S;
      if (T = l.call(m, t, m), typeof ((S = T) == null ? void 0 : S.then) == "function") {
        if (n.sync)
          throw new Error(`Validation test of type: "${m.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(T).then(x, C);
      }
    } catch (b) {
      C(b);
      return;
    }
    x(T);
  }
  return A.OPTIONS = e, A;
}
function Nee(e, A, t, r = t) {
  let n, a, i;
  return A ? (yn.forEach(A, (s, o, u) => {
    let l = o ? s.slice(1, s.length - 1) : s;
    e = e.resolve({
      context: r,
      parent: n,
      value: t
    });
    let c = e.type === "tuple", f = u ? parseInt(l, 10) : 0;
    if (e.innerType || c) {
      if (c && !u)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${i}" must contain an index to the tuple element, e.g. "${i}[0]"`);
      if (t && f >= t.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${A}. because there is no value at that index. `);
      n = t, t = t && t[f], e = c ? e.spec.types[f] : e.innerType;
    }
    if (!u) {
      if (!e.fields || !e.fields[l])
        throw new Error(`The schema does not contain the path: ${A}. (failed at: ${i} which is a type: "${e.type}")`);
      n = t, t = t && t[l], e = e.fields[l];
    }
    a = l, i = o ? "[" + s + "]" : "." + s;
  }), {
    schema: e,
    parent: n,
    parentPath: a
  }) : {
    parent: n,
    parentPath: A,
    schema: e
  };
}
class Yo extends Set {
  describe() {
    const A = [];
    for (const t of this.values())
      A.push(Yr.isRef(t) ? t.describe() : t);
    return A;
  }
  resolveAll(A) {
    let t = [];
    for (const r of this.values())
      t.push(A(r));
    return t;
  }
  clone() {
    return new Yo(this.values());
  }
  merge(A, t) {
    const r = this.clone();
    return A.forEach((n) => r.add(n)), t.forEach((n) => r.delete(n)), r;
  }
}
function sa(e, A = /* @__PURE__ */ new Map()) {
  if (ph(e) || !e || typeof e != "object")
    return e;
  if (A.has(e))
    return A.get(e);
  let t;
  if (e instanceof Date)
    t = new Date(e.getTime()), A.set(e, t);
  else if (e instanceof RegExp)
    t = new RegExp(e), A.set(e, t);
  else if (Array.isArray(e)) {
    t = new Array(e.length), A.set(e, t);
    for (let r = 0; r < e.length; r++)
      t[r] = sa(e[r], A);
  } else if (e instanceof Map) {
    t = /* @__PURE__ */ new Map(), A.set(e, t);
    for (const [r, n] of e.entries())
      t.set(r, sa(n, A));
  } else if (e instanceof Set) {
    t = /* @__PURE__ */ new Set(), A.set(e, t);
    for (const r of e)
      t.add(sa(r, A));
  } else if (e instanceof Object) {
    t = {}, A.set(e, t);
    for (const [r, n] of Object.entries(e))
      t[r] = sa(n, A);
  } else
    throw Error(`Unable to clone ${e}`);
  return t;
}
class kt {
  constructor(A) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new Yo(), this._blacklist = new Yo(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Dt.notType);
    }), this.type = A.type, this._typeCheck = A.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, A == null ? void 0 : A.spec), this.withMutation((t) => {
      t.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(A) {
    if (this._mutate)
      return A && Object.assign(this.spec, A), this;
    const t = Object.create(Object.getPrototypeOf(this));
    return t.type = this.type, t._typeCheck = this._typeCheck, t._whitelist = this._whitelist.clone(), t._blacklist = this._blacklist.clone(), t.internalTests = Object.assign({}, this.internalTests), t.exclusiveTests = Object.assign({}, this.exclusiveTests), t.deps = [...this.deps], t.conditions = [...this.conditions], t.tests = [...this.tests], t.transforms = [...this.transforms], t.spec = sa(Object.assign({}, this.spec, A)), t;
  }
  label(A) {
    let t = this.clone();
    return t.spec.label = A, t;
  }
  meta(...A) {
    if (A.length === 0)
      return this.spec.meta;
    let t = this.clone();
    return t.spec.meta = Object.assign(t.spec.meta || {}, A[0]), t;
  }
  withMutation(A) {
    let t = this._mutate;
    this._mutate = !0;
    let r = A(this);
    return this._mutate = t, r;
  }
  concat(A) {
    if (!A || A === this)
      return this;
    if (A.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${A.type}`);
    let t = this, r = A.clone();
    const n = Object.assign({}, t.spec, r.spec);
    return r.spec = n, r.internalTests = Object.assign({}, t.internalTests, r.internalTests), r._whitelist = t._whitelist.merge(A._whitelist, A._blacklist), r._blacklist = t._blacklist.merge(A._blacklist, A._whitelist), r.tests = t.tests, r.exclusiveTests = t.exclusiveTests, r.withMutation((a) => {
      A.tests.forEach((i) => {
        a.test(i.OPTIONS);
      });
    }), r.transforms = [...t.transforms, ...r.transforms], r;
  }
  isType(A) {
    return A == null ? !!(this.spec.nullable && A === null || this.spec.optional && A === void 0) : this._typeCheck(A);
  }
  resolve(A) {
    let t = this;
    if (t.conditions.length) {
      let r = t.conditions;
      t = t.clone(), t.conditions = [], t = r.reduce((n, a) => a.resolve(n, A), t), t = t.resolve(A);
    }
    return t;
  }
  resolveOptions(A) {
    var t, r, n, a;
    return Object.assign({}, A, {
      from: A.from || [],
      strict: (t = A.strict) != null ? t : this.spec.strict,
      abortEarly: (r = A.abortEarly) != null ? r : this.spec.abortEarly,
      recursive: (n = A.recursive) != null ? n : this.spec.recursive,
      disableStackTrace: (a = A.disableStackTrace) != null ? a : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(A, t = {}) {
    let r = this.resolve(Object.assign({
      value: A
    }, t)), n = t.assert === "ignore-optionality", a = r._cast(A, t);
    if (t.assert !== !1 && !r.isType(a)) {
      if (n && hn(a))
        return a;
      let i = Mr(A), s = Mr(a);
      throw new TypeError(`The value of ${t.path || "field"} could not be cast to a value that satisfies the schema type: "${r.type}". 

attempted value: ${i} 
` + (s !== i ? `result of cast: ${s}` : ""));
    }
    return a;
  }
  _cast(A, t) {
    let r = A === void 0 ? A : this.transforms.reduce((n, a) => a.call(this, n, A, this), A);
    return r === void 0 && (r = this.getDefault(t)), r;
  }
  _validate(A, t = {}, r, n) {
    let {
      path: a,
      originalValue: i = A,
      strict: s = this.spec.strict
    } = t, o = A;
    s || (o = this._cast(o, Object.assign({
      assert: !1
    }, t)));
    let u = [];
    for (let l of Object.values(this.internalTests))
      l && u.push(l);
    this.runTests({
      path: a,
      value: o,
      originalValue: i,
      options: t,
      tests: u
    }, r, (l) => {
      if (l.length)
        return n(l, o);
      this.runTests({
        path: a,
        value: o,
        originalValue: i,
        options: t,
        tests: this.tests
      }, r, n);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(A, t, r) {
    let n = !1, {
      tests: a,
      value: i,
      originalValue: s,
      path: o,
      options: u
    } = A, l = (p) => {
      n || (n = !0, t(p, i));
    }, c = (p) => {
      n || (n = !0, r(p, i));
    }, f = a.length, d = [];
    if (!f)
      return c([]);
    let h = {
      value: i,
      originalValue: s,
      path: o,
      options: u,
      schema: this
    };
    for (let p = 0; p < a.length; p++) {
      const v = a[p];
      v(h, l, function(g) {
        g && (Array.isArray(g) ? d.push(...g) : d.push(g)), --f <= 0 && c(d);
      });
    }
  }
  asNestedTest({
    key: A,
    index: t,
    parent: r,
    parentPath: n,
    originalParent: a,
    options: i
  }) {
    const s = A ?? t;
    if (s == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const o = typeof s == "number";
    let u = r[s];
    const l = Object.assign({}, i, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: r,
      value: u,
      originalValue: a[s],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [o ? "index" : "key"]: s,
      path: o || s.includes(".") ? `${n || ""}[${u ? s : `"${s}"`}]` : (n ? `${n}.` : "") + A
    });
    return (c, f, d) => this.resolve(l)._validate(u, l, f, d);
  }
  validate(A, t) {
    var r;
    let n = this.resolve(Object.assign({}, t, {
      value: A
    })), a = (r = t == null ? void 0 : t.disableStackTrace) != null ? r : n.spec.disableStackTrace;
    return new Promise((i, s) => n._validate(A, t, (o, u) => {
      $A.isError(o) && (o.value = u), s(o);
    }, (o, u) => {
      o.length ? s(new $A(o, u, void 0, void 0, a)) : i(u);
    }));
  }
  validateSync(A, t) {
    var r;
    let n = this.resolve(Object.assign({}, t, {
      value: A
    })), a, i = (r = t == null ? void 0 : t.disableStackTrace) != null ? r : n.spec.disableStackTrace;
    return n._validate(A, Object.assign({}, t, {
      sync: !0
    }), (s, o) => {
      throw $A.isError(s) && (s.value = o), s;
    }, (s, o) => {
      if (s.length)
        throw new $A(s, A, void 0, void 0, i);
      a = o;
    }), a;
  }
  isValid(A, t) {
    return this.validate(A, t).then(() => !0, (r) => {
      if ($A.isError(r))
        return !1;
      throw r;
    });
  }
  isValidSync(A, t) {
    try {
      return this.validateSync(A, t), !0;
    } catch (r) {
      if ($A.isError(r))
        return !1;
      throw r;
    }
  }
  _getDefault(A) {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this, A) : sa(t);
  }
  getDefault(A) {
    return this.resolve(A || {})._getDefault(A);
  }
  default(A) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: A
    });
  }
  strict(A = !0) {
    return this.clone({
      strict: A
    });
  }
  nullability(A, t) {
    const r = this.clone({
      nullable: A
    });
    return r.internalTests.nullable = qn({
      message: t,
      name: "nullable",
      test(n) {
        return n === null ? this.schema.spec.nullable : !0;
      }
    }), r;
  }
  optionality(A, t) {
    const r = this.clone({
      optional: A
    });
    return r.internalTests.optionality = qn({
      message: t,
      name: "optionality",
      test(n) {
        return n === void 0 ? this.schema.spec.optional : !0;
      }
    }), r;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(A = Dt.defined) {
    return this.optionality(!1, A);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(A = Dt.notNull) {
    return this.nullability(!1, A);
  }
  required(A = Dt.required) {
    return this.clone().withMutation((t) => t.nonNullable(A).defined(A));
  }
  notRequired() {
    return this.clone().withMutation((A) => A.nullable().optional());
  }
  transform(A) {
    let t = this.clone();
    return t.transforms.push(A), t;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...A) {
    let t;
    if (A.length === 1 ? typeof A[0] == "function" ? t = {
      test: A[0]
    } : t = A[0] : A.length === 2 ? t = {
      name: A[0],
      test: A[1]
    } : t = {
      name: A[0],
      message: A[1],
      test: A[2]
    }, t.message === void 0 && (t.message = Dt.default), typeof t.test != "function")
      throw new TypeError("`test` is a required parameters");
    let r = this.clone(), n = qn(t), a = t.exclusive || t.name && r.exclusiveTests[t.name] === !0;
    if (t.exclusive && !t.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return t.name && (r.exclusiveTests[t.name] = !!t.exclusive), r.tests = r.tests.filter((i) => !(i.OPTIONS.name === t.name && (a || i.OPTIONS.test === n.OPTIONS.test))), r.tests.push(n), r;
  }
  when(A, t) {
    !Array.isArray(A) && typeof A != "string" && (t = A, A = ".");
    let r = this.clone(), n = JC(A).map((a) => new Yr(a));
    return n.forEach((a) => {
      a.isSibling && r.deps.push(a.key);
    }), r.conditions.push(typeof t == "function" ? new Wo(n, t) : Wo.fromOptions(n, t)), r;
  }
  typeError(A) {
    let t = this.clone();
    return t.internalTests.typeError = qn({
      message: A,
      name: "typeError",
      skipAbsent: !0,
      test(r) {
        return this.schema._typeCheck(r) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), t;
  }
  oneOf(A, t = Dt.oneOf) {
    let r = this.clone();
    return A.forEach((n) => {
      r._whitelist.add(n), r._blacklist.delete(n);
    }), r.internalTests.whiteList = qn({
      message: t,
      name: "oneOf",
      skipAbsent: !0,
      test(n) {
        let a = this.schema._whitelist, i = a.resolveAll(this.resolve);
        return i.includes(n) ? !0 : this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: i
          }
        });
      }
    }), r;
  }
  notOneOf(A, t = Dt.notOneOf) {
    let r = this.clone();
    return A.forEach((n) => {
      r._blacklist.add(n), r._whitelist.delete(n);
    }), r.internalTests.blacklist = qn({
      message: t,
      name: "notOneOf",
      test(n) {
        let a = this.schema._blacklist, i = a.resolveAll(this.resolve);
        return i.includes(n) ? this.createError({
          params: {
            values: Array.from(a).join(", "),
            resolved: i
          }
        }) : !0;
      }
    }), r;
  }
  strip(A = !0) {
    let t = this.clone();
    return t.spec.strip = A, t;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(A) {
    const t = (A ? this.resolve(A) : this).clone(), {
      label: r,
      meta: n,
      optional: a,
      nullable: i
    } = t.spec;
    return {
      meta: n,
      label: r,
      optional: a,
      nullable: i,
      default: t.getDefault(A),
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((o) => ({
        name: o.OPTIONS.name,
        params: o.OPTIONS.params
      })).filter((o, u, l) => l.findIndex((c) => c.name === o.name) === u)
    };
  }
}
kt.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"])
  kt.prototype[`${e}At`] = function(A, t, r = {}) {
    const {
      parent: n,
      parentPath: a,
      schema: i
    } = Nee(this, A, t, r.context);
    return i[e](n && n[a], Object.assign({}, r, {
      parent: n,
      path: A
    }));
  };
for (const e of ["equals", "is"])
  kt.prototype[e] = kt.prototype.oneOf;
for (const e of ["not", "nope"])
  kt.prototype[e] = kt.prototype.notOneOf;
let kee = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), Pee = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), Kee = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, $ee = (e) => hn(e) || e === e.trim(), jee = {}.toString();
function uo() {
  return new eE();
}
class eE extends kt {
  constructor() {
    super({
      type: "string",
      check(A) {
        return A instanceof String && (A = A.valueOf()), typeof A == "string";
      }
    }), this.withMutation(() => {
      this.transform((A, t, r) => {
        if (!r.spec.coerce || r.isType(A) || Array.isArray(A))
          return A;
        const n = A != null && A.toString ? A.toString() : A;
        return n === jee ? A : n;
      });
    });
  }
  required(A) {
    return super.required(A).withMutation((t) => t.test({
      message: A || Dt.required,
      name: "required",
      skipAbsent: !0,
      test: (r) => !!r.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((A) => (A.tests = A.tests.filter((t) => t.OPTIONS.name !== "required"), A));
  }
  length(A, t = ht.length) {
    return this.test({
      message: t,
      name: "length",
      exclusive: !0,
      params: {
        length: A
      },
      skipAbsent: !0,
      test(r) {
        return r.length === this.resolve(A);
      }
    });
  }
  min(A, t = ht.min) {
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: A
      },
      skipAbsent: !0,
      test(r) {
        return r.length >= this.resolve(A);
      }
    });
  }
  max(A, t = ht.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: t,
      params: {
        max: A
      },
      skipAbsent: !0,
      test(r) {
        return r.length <= this.resolve(A);
      }
    });
  }
  matches(A, t) {
    let r = !1, n, a;
    return t && (typeof t == "object" ? {
      excludeEmptyString: r = !1,
      message: n,
      name: a
    } = t : n = t), this.test({
      name: a || "matches",
      message: n || ht.matches,
      params: {
        regex: A
      },
      skipAbsent: !0,
      test: (i) => i === "" && r || i.search(A) !== -1
    });
  }
  email(A = ht.email) {
    return this.matches(kee, {
      name: "email",
      message: A,
      excludeEmptyString: !0
    });
  }
  url(A = ht.url) {
    return this.matches(Pee, {
      name: "url",
      message: A,
      excludeEmptyString: !0
    });
  }
  uuid(A = ht.uuid) {
    return this.matches(Kee, {
      name: "uuid",
      message: A,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((A) => A === null ? "" : A);
  }
  trim(A = ht.trim) {
    return this.transform((t) => t != null ? t.trim() : t).test({
      message: A,
      name: "trim",
      test: $ee
    });
  }
  lowercase(A = ht.lowercase) {
    return this.transform((t) => hn(t) ? t : t.toLowerCase()).test({
      message: A,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => hn(t) || t === t.toLowerCase()
    });
  }
  uppercase(A = ht.uppercase) {
    return this.transform((t) => hn(t) ? t : t.toUpperCase()).test({
      message: A,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (t) => hn(t) || t === t.toUpperCase()
    });
  }
}
uo.prototype = eE.prototype;
const Gee = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function er(e, A = 0) {
  return Number(e) || A;
}
function Vee(e) {
  const A = Gee.exec(e);
  if (!A)
    return Date.parse ? Date.parse(e) : Number.NaN;
  const t = {
    year: er(A[1]),
    month: er(A[2], 1) - 1,
    day: er(A[3], 1),
    hour: er(A[4]),
    minute: er(A[5]),
    second: er(A[6]),
    millisecond: A[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      er(A[7].substring(0, 3))
    ) : 0,
    z: A[8] || void 0,
    plusMinus: A[9] || void 0,
    hourOffset: er(A[10]),
    minuteOffset: er(A[11])
  };
  if (t.z === void 0 && t.plusMinus === void 0)
    return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
  let r = 0;
  return t.z !== "Z" && t.plusMinus !== void 0 && (r = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (r = 0 - r)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + r, t.second, t.millisecond);
}
let Wee = /* @__PURE__ */ new Date(""), Yee = (e) => Object.prototype.toString.call(e) === "[object Date]";
class ul extends kt {
  constructor() {
    super({
      type: "date",
      check(A) {
        return Yee(A) && !isNaN(A.getTime());
      }
    }), this.withMutation(() => {
      this.transform((A, t, r) => !r.spec.coerce || r.isType(A) || A === null ? A : (A = Vee(A), isNaN(A) ? ul.INVALID_DATE : new Date(A)));
    });
  }
  prepareParam(A, t) {
    let r;
    if (Yr.isRef(A))
      r = A;
    else {
      let n = this.cast(A);
      if (!this._typeCheck(n))
        throw new TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);
      r = n;
    }
    return r;
  }
  min(A, t = y0.min) {
    let r = this.prepareParam(A, "min");
    return this.test({
      message: t,
      name: "min",
      exclusive: !0,
      params: {
        min: A
      },
      skipAbsent: !0,
      test(n) {
        return n >= this.resolve(r);
      }
    });
  }
  max(A, t = y0.max) {
    let r = this.prepareParam(A, "max");
    return this.test({
      message: t,
      name: "max",
      exclusive: !0,
      params: {
        max: A
      },
      skipAbsent: !0,
      test(n) {
        return n <= this.resolve(r);
      }
    });
  }
}
ul.INVALID_DATE = Wee;
ul.prototype;
function zee(e, A = []) {
  let t = [], r = /* @__PURE__ */ new Set(), n = new Set(A.map(([i, s]) => `${i}-${s}`));
  function a(i, s) {
    let o = yn.split(i)[0];
    r.add(o), n.has(`${s}-${o}`) || t.push([s, o]);
  }
  for (const i of Object.keys(e)) {
    let s = e[i];
    r.add(i), Yr.isRef(s) && s.isSibling ? a(s.path, i) : ph(s) && "deps" in s && s.deps.forEach((o) => a(o, i));
  }
  return bee.array(Array.from(r), t).reverse();
}
function kv(e, A) {
  let t = 1 / 0;
  return e.some((r, n) => {
    var a;
    if ((a = A.path) != null && a.includes(r))
      return t = n, !0;
  }), t;
}
function AE(e) {
  return (A, t) => kv(e, A) - kv(e, t);
}
const Xee = (e, A, t) => {
  if (typeof e != "string")
    return e;
  let r = e;
  try {
    r = JSON.parse(e);
  } catch {
  }
  return t.isType(r) ? r : e;
};
function lo(e) {
  if ("fields" in e) {
    const A = {};
    for (const [t, r] of Object.entries(e.fields))
      A[t] = lo(r);
    return e.setFields(A);
  }
  if (e.type === "array") {
    const A = e.optional();
    return A.innerType && (A.innerType = lo(A.innerType)), A;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(lo)
  }) : "optional" in e ? e.optional() : e;
}
const qee = (e, A) => {
  const t = [...yn.normalizePath(A)];
  if (t.length === 1)
    return t[0] in e;
  let r = t.pop(), n = yn.getter(yn.join(t), !0)(e);
  return !!(n && r in n);
};
let Pv = (e) => Object.prototype.toString.call(e) === "[object Object]";
function Jee(e, A) {
  let t = Object.keys(e.fields);
  return Object.keys(A).filter((r) => t.indexOf(r) === -1);
}
const Zee = AE([]);
function gh(e) {
  return new tE(e);
}
class tE extends kt {
  constructor(A) {
    super({
      type: "object",
      check(t) {
        return Pv(t) || typeof t == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Zee, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      A && this.shape(A);
    });
  }
  _cast(A, t = {}) {
    var r;
    let n = super._cast(A, t);
    if (n === void 0)
      return this.getDefault(t);
    if (!this._typeCheck(n))
      return n;
    let a = this.fields, i = (r = t.stripUnknown) != null ? r : this.spec.noUnknown, s = [].concat(this._nodes, Object.keys(n).filter((c) => !this._nodes.includes(c))), o = {}, u = Object.assign({}, t, {
      parent: o,
      __validating: t.__validating || !1
    }), l = !1;
    for (const c of s) {
      let f = a[c], d = c in n;
      if (f) {
        let h, p = n[c];
        u.path = (t.path ? `${t.path}.` : "") + c, f = f.resolve({
          value: p,
          context: t.context,
          parent: o
        });
        let v = f instanceof kt ? f.spec : void 0, y = v == null ? void 0 : v.strict;
        if (v != null && v.strip) {
          l = l || c in n;
          continue;
        }
        h = !t.__validating || !y ? (
          // TODO: use _cast, this is double resolving
          f.cast(n[c], u)
        ) : n[c], h !== void 0 && (o[c] = h);
      } else
        d && !i && (o[c] = n[c]);
      (d !== c in o || o[c] !== n[c]) && (l = !0);
    }
    return l ? o : n;
  }
  _validate(A, t = {}, r, n) {
    let {
      from: a = [],
      originalValue: i = A,
      recursive: s = this.spec.recursive
    } = t;
    t.from = [{
      schema: this,
      value: i
    }, ...a], t.__validating = !0, t.originalValue = i, super._validate(A, t, r, (o, u) => {
      if (!s || !Pv(u)) {
        n(o, u);
        return;
      }
      i = i || u;
      let l = [];
      for (let c of this._nodes) {
        let f = this.fields[c];
        !f || Yr.isRef(f) || l.push(f.asNestedTest({
          options: t,
          key: c,
          parent: u,
          parentPath: t.path,
          originalParent: i
        }));
      }
      this.runTests({
        tests: l,
        value: u,
        originalValue: i,
        options: t
      }, r, (c) => {
        n(c.sort(this._sortErrors).concat(o), u);
      });
    });
  }
  clone(A) {
    const t = super.clone(A);
    return t.fields = Object.assign({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
  }
  concat(A) {
    let t = super.concat(A), r = t.fields;
    for (let [n, a] of Object.entries(this.fields)) {
      const i = r[n];
      r[n] = i === void 0 ? a : i;
    }
    return t.withMutation((n) => (
      // XXX: excludes here is wrong
      n.setFields(r, [...this._excludedEdges, ...A._excludedEdges])
    ));
  }
  _getDefault(A) {
    if ("default" in this.spec)
      return super._getDefault(A);
    if (!this._nodes.length)
      return;
    let t = {};
    return this._nodes.forEach((r) => {
      var n;
      const a = this.fields[r];
      let i = A;
      (n = i) != null && n.value && (i = Object.assign({}, i, {
        parent: i.value,
        value: i.value[r]
      })), t[r] = a && "getDefault" in a ? a.getDefault(i) : void 0;
    }), t;
  }
  setFields(A, t) {
    let r = this.clone();
    return r.fields = A, r._nodes = zee(A, t), r._sortErrors = AE(Object.keys(A)), t && (r._excludedEdges = t), r;
  }
  shape(A, t = []) {
    return this.clone().withMutation((r) => {
      let n = r._excludedEdges;
      return t.length && (Array.isArray(t[0]) || (t = [t]), n = [...r._excludedEdges, ...t]), r.setFields(Object.assign(r.fields, A), n);
    });
  }
  partial() {
    const A = {};
    for (const [t, r] of Object.entries(this.fields))
      A[t] = "optional" in r && r.optional instanceof Function ? r.optional() : r;
    return this.setFields(A);
  }
  deepPartial() {
    return lo(this);
  }
  pick(A) {
    const t = {};
    for (const r of A)
      this.fields[r] && (t[r] = this.fields[r]);
    return this.setFields(t, this._excludedEdges.filter(([r, n]) => A.includes(r) && A.includes(n)));
  }
  omit(A) {
    const t = [];
    for (const r of Object.keys(this.fields))
      A.includes(r) || t.push(r);
    return this.pick(t);
  }
  from(A, t, r) {
    let n = yn.getter(A, !0);
    return this.transform((a) => {
      if (!a)
        return a;
      let i = a;
      return qee(a, A) && (i = Object.assign({}, a), r || delete i[A], i[t] = n(a)), i;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(Xee);
  }
  noUnknown(A = !0, t = x0.noUnknown) {
    typeof A != "boolean" && (t = A, A = !0);
    let r = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: t,
      test(n) {
        if (n == null)
          return !0;
        const a = Jee(this.schema, n);
        return !A || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return r.spec.noUnknown = A, r;
  }
  unknown(A = !0, t = x0.noUnknown) {
    return this.noUnknown(!A, t);
  }
  transformKeys(A) {
    return this.transform((t) => {
      if (!t)
        return t;
      const r = {};
      for (const n of Object.keys(t))
        r[A(n)] = t[n];
      return r;
    });
  }
  camelCase() {
    return this.transformKeys(qc.camelCase);
  }
  snakeCase() {
    return this.transformKeys(qc.snakeCase);
  }
  constantCase() {
    return this.transformKeys((A) => qc.snakeCase(A).toUpperCase());
  }
  describe(A) {
    const t = (A ? this.resolve(A) : this).clone(), r = super.describe(A);
    r.fields = {};
    for (const [a, i] of Object.entries(t.fields)) {
      var n;
      let s = A;
      (n = s) != null && n.value && (s = Object.assign({}, s, {
        parent: s.value,
        value: s.value[a]
      })), r.fields[a] = i.describe(s);
    }
    return r;
  }
}
gh.prototype = tE.prototype;
const rE = {
  oldPassword: uo().required("Please kindly use the password you have registered"),
  newPassword: uo().required("No password provided").min(10, "The password entered is not long enough").test({
    name: "has-cap",
    exclusive: !0,
    message: "Password must have an uppercase letter",
    test: (e) => /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]/.test(e)
  }).test({
    name: "has-lower",
    exclusive: !0,
    message: "The password does not have a lowercase letter",
    test: (e) => /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]/.test(e)
  }).test({
    name: "has-integer",
    exclusive: !0,
    message: "The password does not have integer",
    test: (e) => /^(?=.*\d+)[A-Za-z\d!@#$%&*]/.test(e)
  }).test({
    name: "has-special",
    exclusive: !0,
    message: "Password should have (and be limited to) these special characters: !@#$%&*",
    test: (e) => see(Jz([
      /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*\d+)[A-Za-z\d!@#$%&*]{10,}$/,
      /^(?=.*[!@#$%&*]+)^[A-Za-z\d!@#$%&*]{10,}$/
    ], (r) => r.test(e))) === 4
  }),
  // .test({
  //     name: 'is-valid-pattern',
  //     exclusive: true,
  //     message:
  //         'Password must contain at least one uppercase letter, one lowercase letter, one numeric character and one special character',
  //     test: (value: string) => {
  //         const patterns = [
  //             /^(?=.*[a-z]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*[A-Z]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*\d+)[A-Za-z\d!@#$%&*]{10,}$/,
  //             /^(?=.*[!@#$%&*]+)[A-Za-z\d!@#$%&*]{10,}$/,
  //         ];
  //         const matched = sum(map(patterns, (pattern) => pattern.test(value)));
  //         return matched >= 3;
  //     },
  // }),
  confirmNewPassword: uo().when("newPassword", (e, A) => e ? A.required("Confirm Password is required") : A).oneOf([Ree("newPassword"), ""], "Your passwords do not match")
}, Kv = gh(rE), eAe = gh(eee(rE, "oldPassword"));
var AAe = /* @__PURE__ */ ((e) => (e.CHANGE = "change", e.RESET = "reset", e.NEW = "new", e))(AAe || {});
const tAe = {
  new: eAe,
  change: Kv,
  reset: Kv
}, Jc = ({ placeholder: e, border: A, ...t }) => {
  const [r, n] = Ue(), a = Ut(null), i = () => n(!0), s = () => n(!1);
  return Nr("focus", i, a), Nr("blur", s, a), /* @__PURE__ */ F.jsxs(ye, { position: "relative", children: [
    r && /* @__PURE__ */ F.jsx(
      ye,
      {
        pos: "absolute",
        top: "2px",
        left: "10px",
        fontSize: "sm",
        fontWeight: 400,
        color: "gray.500",
        children: e
      }
    ),
    /* @__PURE__ */ F.jsx(S0, { children: /* @__PURE__ */ F.jsx(
      zo,
      {
        type: "password",
        p: r ? "8px 12px" : "12px",
        minH: "56px",
        border: A || void 0,
        placeholder: r ? "" : e,
        ref: a,
        onFocus: i,
        onBlur: s,
        ...t
      }
    ) })
  ] });
}, rAe = ({
  title: e,
  isLoading: A = !1,
  mode: t = "new",
  apiErrors: r = {},
  initialValues: n = {
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: ""
  },
  initialErrors: a = {},
  schema: i,
  onSubmit: s = bh,
  onChange: o = bh,
  hashingFn: u = ZE,
  hashingFnParams: l = [""],
  formId: c = kz("form-password-reset-"),
  sx: f,
  children: d
}) => {
  const [h] = Dm(d, {
    helperText: f0
  });
  i = i ?? tAe[t];
  const p = (g) => g.preventDefault(), [v, y] = Ue(!1);
  return /* @__PURE__ */ F.jsx(
    wz,
    {
      initialValues: n,
      enableReinitialize: !0,
      initialErrors: a,
      validationSchema: i,
      onSubmit: (g) => {
        y(!0), Hz(() => {
          const B = u.apply(null, [
            g.oldPassword ?? "",
            ...l
          ]), w = u.apply(null, [
            g.newPassword ?? "",
            ...l
          ]);
          s({
            ...g,
            oldPassword: B,
            newPassword: w
          }), y(!1);
        }, 1e3);
      },
      children: ({ isValid: g, dirty: B }) => /* @__PURE__ */ F.jsx(Gz, { id: c, onChange: o, sx: f, hasDefaultControls: !1, children: /* @__PURE__ */ F.jsxs(pn, { w: "full", h: "full", justifyContent: "space-between", children: [
        /* @__PURE__ */ F.jsxs(pn, { gap: 4, w: "full", children: [
          /* @__PURE__ */ F.jsx(
            Jv,
            {
              w: "full",
              letterSpacing: -0.352,
              fontWeight: "light",
              lineHeight: "shorter",
              fontSize: "2rem",
              children: e || "Change password"
            }
          ),
          t === "change" && /* @__PURE__ */ F.jsx(zc, { name: "oldPassword", children: ({ field: w, form: m }) => /* @__PURE__ */ F.jsxs(
            fl,
            {
              isInvalid: m.errors.oldPassword && m.touched.oldPassword || r && r.oldPassword && r.oldPassword.length > 0,
              children: [
                /* @__PURE__ */ F.jsx(
                  Jc,
                  {
                    placeholder: "Current password",
                    isDisabled: A || v,
                    onPaste: p,
                    ...w
                  }
                ),
                /* @__PURE__ */ F.jsx(dl, { children: m.errors.oldPassword || r.oldPassword })
              ]
            }
          ) }),
          /* @__PURE__ */ F.jsx(ye, { fontWeight: "light", lineHeight: "shorter", fontSize: "xl", children: /* @__PURE__ */ F.jsx(
            QA,
            {
              text: "Your password must meet the following requirements:",
              translationKey: "ChangePassword/password-requirements-header"
            }
          ) }),
          h.helperText ?? /* @__PURE__ */ F.jsx(f0, {}),
          /* @__PURE__ */ F.jsx(zc, { name: "newPassword", children: ({ field: w, form: m }) => /* @__PURE__ */ F.jsxs(
            fl,
            {
              isInvalid: m.errors.newPassword && m.touched.newPassword || r && r.newPassword && r.newPassword.length > 0,
              children: [
                /* @__PURE__ */ F.jsx(
                  Jc,
                  {
                    placeholder: "New password",
                    isDisabled: A || v,
                    border: g && B ? "2px solid green" : "1px solid black",
                    onPaste: p,
                    ...w
                  }
                ),
                /* @__PURE__ */ F.jsx(dl, { children: m.errors.newPassword || r.newPassword })
              ]
            }
          ) }),
          /* @__PURE__ */ F.jsx(zc, { name: "confirmNewPassword", children: ({ field: w, form: m }) => /* @__PURE__ */ F.jsxs(
            fl,
            {
              isInvalid: m.errors.confirmNewPassword && m.touched.confirmNewPassword || r && r.confirmNewPassword && r.confirmNewPassword.length > 0,
              children: [
                /* @__PURE__ */ F.jsx(
                  Jc,
                  {
                    placeholder: "Confirm New password",
                    isDisabled: A || v,
                    border: g && B ? "2px solid green" : "1px solid black",
                    isValid: g,
                    onPaste: p,
                    ...w
                  }
                ),
                /* @__PURE__ */ F.jsx(dl, { children: m.errors.confirmNewPassword || r.confirmNewPassword })
              ]
            }
          ) })
        ] }),
        /* @__PURE__ */ F.jsx(
          Sn,
          {
            w: "full",
            type: "submit",
            isLoading: A || v,
            isDisabled: !B || !g,
            bgColor: { base: "primary.500", md: "black" },
            children: "Proceed"
          }
        )
      ] }) })
    }
  );
}, gte = Object.assign(rAe, { HelperText: f0 });
export {
  cte as $,
  yt as A,
  mP as B,
  WAe as C,
  Rd as D,
  GS as E,
  Fp as F,
  JAe as G,
  J5 as H,
  hF as I,
  rm as J,
  lU as K,
  _P as L,
  gB as M,
  cU as N,
  z5 as O,
  gte as P,
  nt as Q,
  lte as R,
  IP as S,
  pU as T,
  ote as U,
  aA as V,
  o0 as W,
  Gx as X,
  k$ as Y,
  $$ as Z,
  oe as _,
  nc as a,
  jAe as a$,
  Cr as a0,
  Je as a1,
  Ui as a2,
  sA as a3,
  nA as a4,
  ke as a5,
  un as a6,
  u0 as a7,
  kB as a8,
  ir as a9,
  fte as aA,
  tC as aB,
  Mi as aC,
  Ri as aD,
  x7 as aE,
  hte as aF,
  ii as aG,
  dte as aH,
  ete as aI,
  ZAe as aJ,
  lK as aK,
  pte as aL,
  Uh as aM,
  SAe as aN,
  PAe as aO,
  DAe as aP,
  OAe as aQ,
  HAe as aR,
  LAe as aS,
  MAe as aT,
  RAe as aU,
  kAe as aV,
  NAe as aW,
  ae as aX,
  gP as aY,
  KAe as aZ,
  $Ae as a_,
  Ate as aa,
  G$ as ab,
  rte as ac,
  ute as ad,
  ate as ae,
  Si as af,
  nte as ag,
  B$ as ah,
  P$ as ai,
  ste as aj,
  Yd as ak,
  Zi as al,
  zd as am,
  Ko as an,
  Te as ao,
  ite as ap,
  tte as aq,
  PB as ar,
  p$ as as,
  Px as at,
  LB as au,
  je as av,
  U$ as aw,
  d$ as ax,
  Gd as ay,
  Al as az,
  XAe as b,
  GAe as b0,
  yP as b1,
  wP as b2,
  KC as b3,
  yu as b4,
  ad as b5,
  jr as b6,
  ki as b7,
  VAe as b8,
  wr as b9,
  Qe as ba,
  zAe as c,
  DP as d,
  qf as e,
  YAe as f,
  UAe as g,
  QA as h,
  IAe as i,
  eAe as j,
  Kv as k,
  AAe as l,
  eU as m,
  vF as n,
  sm as o,
  wF as p,
  _Ae as q,
  K1 as r,
  Im as s,
  Dm as t,
  qAe as u,
  fu as v,
  gU as w,
  BU as x,
  QAe as y,
  sU as z
};
